import _regeneratorRuntime from "/var/lib/jenkins/goworkspace/src/github.com/researchnow/samplify-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import React, { Component, PureComponent, Children, cloneElement, createElement } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, ThemeProvider } from 'styled-components';
import { ErrorSplash, icons, Button, Spinner, Toggle, TextInputLine, Tooltip, Upload, TextInput, Select, ButtonGroup, GroupedButton, Checkbox, ModalHeader, ModalBody, ModalFooter, ModalCancel, Alert, Modal, Radio, Slider, defaultTheme } from 'samplify-design';
import ReactDOM, { findDOMNode } from 'react-dom';
import { components } from 'react-select';
import 'samplify-design/bundle.css';
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace(n) {
  return n && n.default || n;
}

var _global = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var hasOwnProperty = {}.hasOwnProperty;

var _has = function _has(it, key) {
  return hasOwnProperty.call(it, key);
};

var _fails = function _fails(exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
}; // Thank's IE8 for his funny defineProperty


var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

var _core = createCommonjsModule(function (module) {
  var core = module.exports = {
    version: '2.6.3'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});

var _core_1 = _core.version;

var _isObject = function _isObject(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function _anObject(it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var document$1 = _global.document; // typeof document.createElement is 'object' in old IE

var is = _isObject(document$1) && _isObject(document$1.createElement);

var _domCreate = function _domCreate(it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // 7.1.1 ToPrimitive(input [, PreferredType])
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string


var _toPrimitive = function _toPrimitive(it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;
var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);

  P = _toPrimitive(P, true);

  _anObject(Attributes);

  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var _objectDp = {
  f: f
};

var _propertyDesc = function _propertyDesc(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var id = 0;
var px = Math.random();

var _uid = function _uid(key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _redefine = createCommonjsModule(function (module) {
  var SRC = _uid('src');

  var TO_STRING = 'toString';
  var $toString = Function[TO_STRING];
  var TPL = ('' + $toString).split(TO_STRING);

  _core.inspectSource = function (it) {
    return $toString.call(it);
  };

  (module.exports = function (O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

    if (O === _global) {
      O[key] = val;
    } else if (!safe) {
      delete O[key];

      _hide(O, key, val);
    } else if (O[key]) {
      O[key] = val;
    } else {
      _hide(O, key, val);
    } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

  })(Function.prototype, TO_STRING, function toString() {
    return typeof this == 'function' && this[SRC] || $toString.call(this);
  });
});

var _aFunction = function _aFunction(it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
}; // optional / simple context binding


var _ctx = function _ctx(fn, that, length) {
  _aFunction(fn);

  if (that === undefined) return fn;

  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;

  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

    out = (own ? target : source)[key]; // bind timers to global for call from export context

    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out; // extend global

    if (target) _redefine(target, key, out, type & $export.U); // export

    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};

_global.core = _core; // type bitmap

$export.F = 1; // forced

$export.G = 2; // global

$export.S = 4; // static

$export.P = 8; // proto

$export.B = 16; // bind

$export.W = 32; // wrap

$export.U = 64; // safe

$export.R = 128; // real proto method for `library`

var _export = $export;

var _meta = createCommonjsModule(function (module) {
  var META = _uid('meta');

  var setDesc = _objectDp.f;
  var id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !_fails(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
});

var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;
var _library = false;

var _shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core.version,
    mode: 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var _wks = createCommonjsModule(function (module) {
  var store = _shared('wks');

  var Symbol = _global.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function _setToStringTag(it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

var f$1 = _wks;
var _wksExt = {
  f: f$1
};
var defineProperty = _objectDp.f;

var _wksDefine = function _wksDefine(name) {
  var $Symbol = _core.Symbol || (_core.Symbol = _library ? {} : _global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
    value: _wksExt.f(name)
  });
};

var toString = {}.toString;

var _cof = function _cof(it) {
  return toString.call(it).slice(8, -1);
}; // fallback for non-array-like ES3 and non-enumerable old V8 strings
// eslint-disable-next-line no-prototype-builtins


var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
}; // 7.2.1 RequireObjectCoercible(argument)


var _defined = function _defined(it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
}; // to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function _toIobject(it) {
  return _iobject(_defined(it));
}; // 7.1.4 ToInteger


var ceil = Math.ceil;
var floor = Math.floor;

var _toInteger = function _toInteger(it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
}; // 7.1.15 ToLength


var min = Math.min;

var _toLength = function _toLength(it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

var _toAbsoluteIndex = function _toAbsoluteIndex(index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
}; // false -> Array#indexOf
// true  -> Array#includes


var _arrayIncludes = function _arrayIncludes(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);

    var length = _toLength(O.length);

    var index = _toAbsoluteIndex(fromIndex, length);

    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }
    return !IS_INCLUDES && -1;
  };
};

var shared = _shared('keys');

var _sharedKey = function _sharedKey(key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);

var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function _objectKeysInternal(object, names) {
  var O = _toIobject(object);

  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    if (key != IE_PROTO) _has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }

  return result;
}; // IE 8- don't enum bug keys


var _enumBugKeys = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(','); // 19.1.2.14 / 15.2.3.14 Object.keys(O)


var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$2 = Object.getOwnPropertySymbols;
var _objectGops = {
  f: f$2
};
var f$3 = {}.propertyIsEnumerable;
var _objectPie = {
  f: f$3
}; // all enumerable object keys, includes symbols

var _enumKeys = function _enumKeys(it) {
  var result = _objectKeys(it);

  var getSymbols = _objectGops.f;

  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;

    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }

  return result;
}; // 7.2.2 IsArray(argument)


var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);

  var keys = _objectKeys(Properties);

  var length = keys.length;
  var i = 0;
  var P;

  while (length > i) {
    _objectDp.f(O, P = keys[i++], Properties[P]);
  }

  return O;
};

var document$2 = _global.document;

var _html = document$2 && document$2.documentElement; // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


var IE_PROTO$1 = _sharedKey('IE_PROTO');

var Empty = function Empty() {
  /* empty */
};

var PROTOTYPE$1 = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');

  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';

  _html.appendChild(iframe);

  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);

  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;

  while (i--) {
    delete _createDict[PROTOTYPE$1][_enumBugKeys[i]];
  }

  return _createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$1] = O;
  } else result = _createDict();

  return Properties === undefined ? result : _objectDps(result, Properties);
}; // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)


var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
  f: f$4
}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
  f: f$5
};
var gOPD = Object.getOwnPropertyDescriptor;
var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) {
    /* empty */
  }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};
var _objectGopd = {
  f: f$6
}; // ECMAScript 6 symbols shim

var META = _meta.KEY;
var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;

var _stringify = $JSON && $JSON.stringify;

var PROTOTYPE$2 = 'prototype';

var HIDDEN = _wks('_hidden');

var TO_PRIMITIVE = _wks('toPrimitive');

var isEnum = {}.propertyIsEnumerable;

var SymbolRegistry = _shared('symbol-registry');

var AllSymbols = _shared('symbols');

var OPSymbols = _shared('op-symbols');

var ObjectProto = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = _global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function get() {
      return dP$1(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
} : dP$1;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);

  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);

  _anObject(it);

  key = _toPrimitive(key, true);

  _anObject(D);

  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, {
        enumerable: _propertyDesc(0, false)
      });
    }

    return setSymbolDesc(it, key, D);
  }

  return dP$1(it, key, D);
};

var $defineProperties = function defineProperties(it, P) {
  _anObject(it);

  var keys = _enumKeys(P = _toIobject(P));

  var i = 0;
  var l = keys.length;
  var key;

  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }

  return it;
};

var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};

var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};

var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }

  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }

  return result;
}; // 19.4.1.1 Symbol([description])


if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');

    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);

    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };

    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, {
      configurable: true,
      set: $set
    });
    return wrap(tag);
  };

  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, {
  Symbol: $Symbol
});

for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  _wks(es6Symbols[j++]);
}

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) {
  _wksDefine(wellKnownSymbols[k++]);
}

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return _has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
}); // 24.3.2 JSON.stringify(value [, replacer [, space]])


$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols

  return _stringify([S]) != '[null]' || _stringify({
    a: S
  }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;

    while (arguments.length > i) {
      args.push(arguments[i++]);
    }

    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

    if (!_isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
}); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

_setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]


_setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]


_setToStringTag(_global.JSON, 'JSON', true); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


_export(_export.S, 'Object', {
  create: _objectCreate
}); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


_export(_export.S + _export.F * !_descriptors, 'Object', {
  defineProperty: _objectDp.f
}); // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)


_export(_export.S + _export.F * !_descriptors, 'Object', {
  defineProperties: _objectDps
}); // most Object methods by ES6 should accept primitives


var _objectSap = function _objectSap(KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);

  _export(_export.S + _export.F * _fails(function () {
    fn(1);
  }), 'Object', exp);
}; // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)


var $getOwnPropertyDescriptor$1 = _objectGopd.f;

_objectSap('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor$1(_toIobject(it), key);
  };
}); // 7.1.13 ToObject(argument)


var _toObject = function _toObject(it) {
  return Object(_defined(it));
}; // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');

var ObjectProto$1 = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];

  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? ObjectProto$1 : null;
}; // 19.1.2.9 Object.getPrototypeOf(O)


_objectSap('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return _objectGpo(_toObject(it));
  };
}); // 19.1.2.14 Object.keys(O)


_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
}); // 19.1.2.7 Object.getOwnPropertyNames(O)


_objectSap('getOwnPropertyNames', function () {
  return _objectGopnExt.f;
}); // 19.1.2.5 Object.freeze(O)


var meta = _meta.onFreeze;

_objectSap('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && _isObject(it) ? $freeze(meta(it)) : it;
  };
}); // 19.1.2.17 Object.seal(O)


var meta$1 = _meta.onFreeze;

_objectSap('seal', function ($seal) {
  return function seal(it) {
    return $seal && _isObject(it) ? $seal(meta$1(it)) : it;
  };
}); // 19.1.2.15 Object.preventExtensions(O)


var meta$2 = _meta.onFreeze;

_objectSap('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && _isObject(it) ? $preventExtensions(meta$2(it)) : it;
  };
}); // 19.1.2.12 Object.isFrozen(O)


_objectSap('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return _isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
}); // 19.1.2.13 Object.isSealed(O)


_objectSap('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return _isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
}); // 19.1.2.11 Object.isExtensible(O)


_objectSap('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return _isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
}); // 19.1.2.1 Object.assign(target, source, ...)


var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {}; // eslint-disable-next-line no-undef

  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = _toObject(target);

  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;

  while (aLen > index) {
    var S = _iobject(arguments[index++]);

    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }

  return T;
} : $assign; // 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', {
  assign: _objectAssign
}); // 7.2.9 SameValue(x, y)


var _sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
}; // 19.1.3.10 Object.is(value1, value2)


_export(_export.S, 'Object', {
  is: _sameValue
}); // Works with __proto__ only. Old v8 can't work with null proto objects.

/* eslint-disable no-proto */


var check = function check(O, proto) {
  _anObject(O);

  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};

var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }

    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
}; // 19.1.3.19 Object.setPrototypeOf(O, proto)

_export(_export.S, 'Object', {
  setPrototypeOf: _setProto.set
}); // getting tag from 19.1.3.6 Object.prototype.toString()


var TAG$1 = _wks('toStringTag'); // ES3 wrong here


var ARG = _cof(function () {
  return arguments;
}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {
    /* empty */
  }
};

var _classof = function _classof(it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T // builtinTag case
  : ARG ? _cof(O) // ES3 arguments fallback
  : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
}; // 19.1.3.6 Object.prototype.toString()


var test = {};
test[_wks('toStringTag')] = 'z';

if (test + '' != '[object z]') {
  _redefine(Object.prototype, 'toString', function toString() {
    return '[object ' + _classof(this) + ']';
  }, true);
} // fast apply, http://jsperf.lnkit.com/fast-apply/5


var _invoke = function _invoke(fn, args, that) {
  var un = that === undefined;

  switch (args.length) {
    case 0:
      return un ? fn() : fn.call(that);

    case 1:
      return un ? fn(args[0]) : fn.call(that, args[0]);

    case 2:
      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

    case 3:
      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

    case 4:
      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
  }

  return fn.apply(that, args);
};

var arraySlice = [].slice;
var factories = {};

var construct = function construct(F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) {
      n[i] = 'a[' + i + ']';
    } // eslint-disable-next-line no-new-func


    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  }

  return factories[len](F, args);
};

var _bind = Function.bind || function bind(that
/* , ...args */
) {
  var fn = _aFunction(this);

  var partArgs = arraySlice.call(arguments, 1);

  var bound = function bound()
  /* args... */
  {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : _invoke(fn, args, that);
  };

  if (_isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
}; // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)


_export(_export.P, 'Function', {
  bind: _bind
});

var dP$2 = _objectDp.f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name'; // 19.2.4.2 name

NAME in FProto || _descriptors && dP$2(FProto, NAME, {
  configurable: true,
  get: function get() {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

var HAS_INSTANCE = _wks('hasInstance');

var FunctionProto = Function.prototype; // 19.2.3.6 Function.prototype[@@hasInstance](V)

if (!(HAS_INSTANCE in FunctionProto)) _objectDp.f(FunctionProto, HAS_INSTANCE, {
  value: function value(O) {
    if (typeof this != 'function' || !_isObject(O)) return false;
    if (!_isObject(this.prototype)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

    while (O = _objectGpo(O)) {
      if (this.prototype === O) return true;
    }

    return false;
  }
});

var _stringWs = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

var space = '[' + _stringWs + ']';
var non = "\u200B\x85";
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function exporter(KEY, exec, ALIAS) {
  var exp = {};

  var FORCE = _fails(function () {
    return !!_stringWs[KEY]() || non[KEY]() != non;
  });

  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
  if (ALIAS) exp[ALIAS] = fn;

  _export(_export.P + _export.F * FORCE, 'String', exp);
}; // 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim


var trim = exporter.trim = function (string, TYPE) {
  string = String(_defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

var _stringTrim = exporter;
var $parseInt = _global.parseInt;
var $trim = _stringTrim.trim;
var hex = /^[-+]?0[xX]/;

var _parseInt = $parseInt(_stringWs + '08') !== 8 || $parseInt(_stringWs + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
} : $parseInt; // 18.2.5 parseInt(string, radix)


_export(_export.G + _export.F * (parseInt != _parseInt), {
  parseInt: _parseInt
});

var $parseFloat = _global.parseFloat;
var $trim$1 = _stringTrim.trim;

var _parseFloat = 1 / $parseFloat(_stringWs + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim$1(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat; // 18.2.4 parseFloat(string)


_export(_export.G + _export.F * (parseFloat != _parseFloat), {
  parseFloat: _parseFloat
});

var setPrototypeOf = _setProto.set;

var _inheritIfRequired = function _inheritIfRequired(that, target, C) {
  var S = target.constructor;
  var P;

  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }

  return that;
};

var gOPN$2 = _objectGopn.f;
var gOPD$2 = _objectGopd.f;
var dP$3 = _objectDp.f;
var $trim$2 = _stringTrim.trim;
var NUMBER = 'Number';
var $Number = _global[NUMBER];
var Base = $Number;
var proto = $Number.prototype; // Opera ~12 has broken Object#toString

var BROKEN_COF = _cof(_objectCreate(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype; // 7.1.3 ToNumber(argument)

var toNumber = function toNumber(argument) {
  var it = _toPrimitive(argument, false);

  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim$2(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;

    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal /^0b[01]+$/i

        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        // fast equal /^0o[0-7]+$/i

        default:
          return +it;
      }

      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i); // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols

        if (code < 48 || code > maxCode) return NaN;
      }

      return parseInt(digits, radix);
    }
  }

  return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number // check on 1..constructor(foo) case
    && (BROKEN_COF ? _fails(function () {
      proto.valueOf.call(that);
    }) : _cof(that) != NUMBER) ? _inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };

  for (var keys = _descriptors ? gOPN$2(Base) : ( // ES3:
  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES6 (in case, if modules with ES6 Number statics required before):
  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j$1 = 0, key; keys.length > j$1; j$1++) {
    if (_has(Base, key = keys[j$1]) && !_has($Number, key)) {
      dP$3($Number, key, gOPD$2(Base, key));
    }
  }

  $Number.prototype = proto;
  proto.constructor = $Number;

  _redefine(_global, NUMBER, $Number);
}

var _aNumberValue = function _aNumberValue(it, msg) {
  if (typeof it != 'number' && _cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

var _stringRepeat = function repeat(count) {
  var str = String(_defined(this));
  var res = '';

  var n = _toInteger(count);

  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");

  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) res += str;
  }

  return res;
};

var $toFixed = 1.0.toFixed;
var floor$1 = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function multiply(n, c) {
  var i = -1;
  var c2 = c;

  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor$1(c2 / 1e7);
  }
};

var divide = function divide(n) {
  var i = 6;
  var c = 0;

  while (--i >= 0) {
    c += data[i];
    data[i] = floor$1(c / n);
    c = c % n * 1e7;
  }
};

var numToString = function numToString() {
  var i = 6;
  var s = '';

  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + _stringRepeat.call(ZERO, 7 - t.length) + t;
    }
  }

  return s;
};

var pow = function pow(x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function log(x) {
  var n = 0;
  var x2 = x;

  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }

  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  }

  return n;
};

_export(_export.P + _export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !_fails(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = _aNumberValue(this, ERROR);

    var f = _toInteger(fractionDigits);

    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR); // eslint-disable-next-line no-self-compare

    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);

    if (x < 0) {
      s = '-';
      x = -x;
    }

    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;

      if (e > 0) {
        multiply(0, z);
        j = f;

        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }

        multiply(pow(10, j, 1), 0);
        j = e - 1;

        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }

        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + _stringRepeat.call(ZERO, f);
      }
    }

    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + _stringRepeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    }

    return m;
  }
});

var $toPrecision = 1.0.toPrecision;

_export(_export.P + _export.F * (_fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !_fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = _aNumberValue(this, 'Number#toPrecision: incorrect invocation!');

    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
}); // 20.1.2.1 Number.EPSILON


_export(_export.S, 'Number', {
  EPSILON: Math.pow(2, -52)
}); // 20.1.2.2 Number.isFinite(number)


var _isFinite = _global.isFinite;

_export(_export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
}); // 20.1.2.3 Number.isInteger(number)


var floor$2 = Math.floor;

var _isInteger = function isInteger(it) {
  return !_isObject(it) && isFinite(it) && floor$2(it) === it;
}; // 20.1.2.3 Number.isInteger(number)


_export(_export.S, 'Number', {
  isInteger: _isInteger
}); // 20.1.2.4 Number.isNaN(number)


_export(_export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
}); // 20.1.2.5 Number.isSafeInteger(number)


var abs = Math.abs;

_export(_export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return _isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
}); // 20.1.2.6 Number.MAX_SAFE_INTEGER


_export(_export.S, 'Number', {
  MAX_SAFE_INTEGER: 0x1fffffffffffff
}); // 20.1.2.10 Number.MIN_SAFE_INTEGER


_export(_export.S, 'Number', {
  MIN_SAFE_INTEGER: -0x1fffffffffffff
}); // 20.1.2.12 Number.parseFloat(string)


_export(_export.S + _export.F * (Number.parseFloat != _parseFloat), 'Number', {
  parseFloat: _parseFloat
}); // 20.1.2.13 Number.parseInt(string, radix)


_export(_export.S + _export.F * (Number.parseInt != _parseInt), 'Number', {
  parseInt: _parseInt
}); // 20.2.2.20 Math.log1p(x)


var _mathLog1p = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
}; // 20.2.2.3 Math.acosh(x)


var sqrt = Math.sqrt;
var $acosh = Math.acosh;

_export(_export.S + _export.F * !($acosh // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
&& Math.floor($acosh(Number.MAX_VALUE)) == 710 // Tor Browser bug: Math.acosh(Infinity) -> NaN
&& $acosh(Infinity) == Infinity), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : _mathLog1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
}); // 20.2.2.5 Math.asinh(x)


var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
} // Tor Browser bug: Math.asinh(0) -> -0


_export(_export.S + _export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {
  asinh: asinh
}); // 20.2.2.7 Math.atanh(x)


var $atanh = Math.atanh; // Tor Browser bug: Math.atanh(-0) -> 0

_export(_export.S + _export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
}); // 20.2.2.28 Math.sign(x)


var _mathSign = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
}; // 20.2.2.9 Math.cbrt(x)


_export(_export.S, 'Math', {
  cbrt: function cbrt(x) {
    return _mathSign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
}); // 20.2.2.11 Math.clz32(x)


_export(_export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
}); // 20.2.2.12 Math.cosh(x)


var exp = Math.exp;

_export(_export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
}); // 20.2.2.14 Math.expm1(x)


var $expm1 = Math.expm1;

var _mathExpm1 = !$expm1 // Old FF bug
|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168 // Tor Browser bug
|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1; // 20.2.2.14 Math.expm1(x)


_export(_export.S + _export.F * (_mathExpm1 != Math.expm1), 'Math', {
  expm1: _mathExpm1
}); // 20.2.2.16 Math.fround(x)


var pow$1 = Math.pow;
var EPSILON = pow$1(2, -52);
var EPSILON32 = pow$1(2, -23);
var MAX32 = pow$1(2, 127) * (2 - EPSILON32);
var MIN32 = pow$1(2, -126);

var roundTiesToEven = function roundTiesToEven(n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

var _mathFround = Math.fround || function fround(x) {
  var $abs = Math.abs(x);

  var $sign = _mathSign(x);

  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs); // eslint-disable-next-line no-self-compare

  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
}; // 20.2.2.16 Math.fround(x)


_export(_export.S, 'Math', {
  fround: _mathFround
}); // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])


var abs$1 = Math.abs;

_export(_export.S, 'Math', {
  hypot: function hypot(value1, value2) {
    // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;

    while (i < aLen) {
      arg = abs$1(arguments[i++]);

      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }

    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
}); // 20.2.2.18 Math.imul(x, y)


var $imul = Math.imul; // some WebKit versions fails with big numbers, some has wrong arity

_export(_export.S + _export.F * _fails(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
}); // 20.2.2.21 Math.log10(x)


_export(_export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
}); // 20.2.2.20 Math.log1p(x)


_export(_export.S, 'Math', {
  log1p: _mathLog1p
}); // 20.2.2.22 Math.log2(x)


_export(_export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
}); // 20.2.2.28 Math.sign(x)


_export(_export.S, 'Math', {
  sign: _mathSign
}); // 20.2.2.30 Math.sinh(x)


var exp$1 = Math.exp; // V8 near Chromium 38 has a problem with very small numbers

_export(_export.S + _export.F * _fails(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1 ? (_mathExpm1(x) - _mathExpm1(-x)) / 2 : (exp$1(x - 1) - exp$1(-x - 1)) * (Math.E / 2);
  }
}); // 20.2.2.33 Math.tanh(x)


var exp$2 = Math.exp;

_export(_export.S, 'Math', {
  tanh: function tanh(x) {
    var a = _mathExpm1(x = +x);

    var b = _mathExpm1(-x);

    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp$2(x) + exp$2(-x));
  }
}); // 20.2.2.34 Math.trunc(x)


_export(_export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint; // length should be 1, old FF problem

_export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) {
    // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;

    while (aLen > i) {
      code = +arguments[i++];
      if (_toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
    }

    return res.join('');
  }
});

_export(_export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = _toIobject(callSite.raw);

    var len = _toLength(tpl.length);

    var aLen = arguments.length;
    var res = [];
    var i = 0;

    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    }

    return res.join('');
  }
}); // 21.1.3.25 String.prototype.trim()


_stringTrim('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
}); // true  -> String#at
// false -> String#codePointAt


var _stringAt = function _stringAt(TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));

    var i = _toInteger(pos);

    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _iterators = {};
var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

_hide(IteratorPrototype, _wks('iterator'), function () {
  return this;
});

var _iterCreate = function _iterCreate(Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, {
    next: _propertyDesc(1, next)
  });

  _setToStringTag(Constructor, NAME + ' Iterator');
};

var ITERATOR = _wks('iterator');

var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

var _iterDefine = function _iterDefine(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);

  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];

    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };

      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }

    return function entries() {
      return new Constructor(this, kind);
    };
  };

  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype; // Fix native

  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));

    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines


      if (typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  } // fix Array#{values, @@iterator}.name in V8 / FF


  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;

    $default = function values() {
      return $native.call(this);
    };
  } // Define iterator


  if (BUGGY || VALUES_BUG || !proto[ITERATOR]) {
    _hide(proto, ITERATOR, $default);
  } // Plug for library


  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;

  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }

  return methods;
};

var $at = _stringAt(true); // 21.1.3.27 String.prototype[@@iterator]()


_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target

  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

var $at$1 = _stringAt(false);

_export(_export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at$1(this, pos);
  }
}); // 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');

var _isRegexp = function _isRegexp(it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
}; // helper for String#{startsWith, endsWith, includes}


var _stringContext = function _stringContext(that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');

var _failsIsRegexp = function _failsIsRegexp(KEY) {
  var re = /./;

  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) {
      /* empty */
    }
  }

  return true;
};

var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString
  /* , endPosition = @length */
  ) {
    var that = _stringContext(this, searchString, ENDS_WITH);

    var endPosition = arguments.length > 1 ? arguments[1] : undefined;

    var len = _toLength(that.length);

    var end = endPosition === undefined ? len : Math.min(_toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
  }
});

var INCLUDES = 'includes';

_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
  includes: function includes(searchString
  /* , position = 0 */
  ) {
    return !!~_stringContext(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_export(_export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: _stringRepeat
});

var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString
  /* , position = 0 */
  ) {
    var that = _stringContext(this, searchString, STARTS_WITH);

    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));

    var search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
  }
});

var quot = /"/g; // B.2.3.2.1 CreateHTML(string, tag, attribute, value)

var createHTML = function createHTML(string, tag, attribute, value) {
  var S = String(_defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

var _stringHtml = function _stringHtml(NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);

  _export(_export.P + _export.F * _fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
}; // B.2.3.2 String.prototype.anchor(name)


_stringHtml('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
}); // B.2.3.3 String.prototype.big()


_stringHtml('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
}); // B.2.3.4 String.prototype.blink()


_stringHtml('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
}); // B.2.3.5 String.prototype.bold()


_stringHtml('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
}); // B.2.3.6 String.prototype.fixed()


_stringHtml('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
}); // B.2.3.7 String.prototype.fontcolor(color)


_stringHtml('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
}); // B.2.3.8 String.prototype.fontsize(size)


_stringHtml('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
}); // B.2.3.9 String.prototype.italics()


_stringHtml('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
}); // B.2.3.10 String.prototype.link(url)


_stringHtml('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
}); // B.2.3.11 String.prototype.small()


_stringHtml('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
}); // B.2.3.12 String.prototype.strike()


_stringHtml('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
}); // B.2.3.13 String.prototype.sub()


_stringHtml('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
}); // B.2.3.14 String.prototype.sup()


_stringHtml('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
}); // 20.3.3.1 / 15.9.4.4 Date.now()


_export(_export.S, 'Date', {
  now: function now() {
    return new Date().getTime();
  }
});

_export(_export.P + _export.F * _fails(function () {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
    toISOString: function toISOString() {
      return 1;
    }
  }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = _toObject(this);

    var pv = _toPrimitive(O);

    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
}); // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()


var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function lz(num) {
  return num > 9 ? num : '0' + num;
}; // PhantomJS / old WebKit has a broken implementations


var _dateToIsoString = _fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !_fails(function () {
  $toISOString.call(new Date(NaN));
}) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString; // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
// PhantomJS / old WebKit has a broken implementations


_export(_export.P + _export.F * (Date.prototype.toISOString !== _dateToIsoString), 'Date', {
  toISOString: _dateToIsoString
});

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime$1 = DateProto.getTime;

if (new Date(NaN) + '' != INVALID_DATE) {
  _redefine(DateProto, TO_STRING, function toString() {
    var value = getTime$1.call(this); // eslint-disable-next-line no-self-compare

    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

var NUMBER$1 = 'number';

var _dateToPrimitive = function _dateToPrimitive(hint) {
  if (hint !== 'string' && hint !== NUMBER$1 && hint !== 'default') throw TypeError('Incorrect hint');
  return _toPrimitive(_anObject(this), hint != NUMBER$1);
};

var TO_PRIMITIVE$1 = _wks('toPrimitive');

var proto$1 = Date.prototype;
if (!(TO_PRIMITIVE$1 in proto$1)) _hide(proto$1, TO_PRIMITIVE$1, _dateToPrimitive); // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)

_export(_export.S, 'Array', {
  isArray: _isArray
}); // call something on iterator step with safe closing on error


var _iterCall = function _iterCall(iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
}; // check on default Array iterator


var ITERATOR$1 = _wks('iterator');

var ArrayProto = Array.prototype;

var _isArrayIter = function _isArrayIter(it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

var _createProperty = function _createProperty(object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));else object[index] = value;
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2] || it['@@iterator'] || _iterators[_classof(it)];
};

var ITERATOR$3 = _wks('iterator');

var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$3]();

  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
} catch (e) {
  /* empty */
}

var _iterDetect = function _iterDetect(exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;

  try {
    var arr = [7];
    var iter = arr[ITERATOR$3]();

    iter.next = function () {
      return {
        done: safe = true
      };
    };

    arr[ITERATOR$3] = function () {
      return iter;
    };

    exec(arr);
  } catch (e) {
    /* empty */
  }

  return safe;
};

_export(_export.S + _export.F * !_iterDetect(function (iter) {}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike
  /* , mapfn = undefined, thisArg = undefined */
  ) {
    var O = _toObject(arrayLike);

    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);

      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }

    result.length = index;
    return result;
  }
}); // WebKit Array.of isn't generic


_export(_export.S + _export.F * _fails(function () {
  function F() {
    /* empty */
  }

  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of()
  /* ...args */
  {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);

    while (aLen > index) {
      _createProperty(result, index, arguments[index++]);
    }

    result.length = aLen;
    return result;
  }
});

var _strictMethod = function _strictMethod(method, arg) {
  return !!method && _fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () {
      /* empty */
    }, 1) : method.call(null);
  });
}; // 22.1.3.13 Array.prototype.join(separator)


var arrayJoin = [].join; // fallback for not array-like strings

_export(_export.P + _export.F * (_iobject != Object || !_strictMethod(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(_toIobject(this), separator === undefined ? ',' : separator);
  }
});

var arraySlice$1 = [].slice; // fallback for not array-like ES3 strings and DOM objects

_export(_export.P + _export.F * _fails(function () {
  if (_html) arraySlice$1.call(_html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = _toLength(this.length);

    var klass = _cof(this);

    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice$1.call(this, begin, end);

    var start = _toAbsoluteIndex(begin, len);

    var upTo = _toAbsoluteIndex(end, len);

    var size = _toLength(upTo - start);

    var cloned = new Array(size);
    var i = 0;

    for (; i < size; i++) {
      cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
    }

    return cloned;
  }
});

var $sort = [].sort;
var test$1 = [1, 2, 3];

_export(_export.P + _export.F * (_fails(function () {
  // IE8-
  test$1.sort(undefined);
}) || !_fails(function () {
  // V8 bug
  test$1.sort(null); // Old WebKit
}) || !_strictMethod($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined ? $sort.call(_toObject(this)) : $sort.call(_toObject(this), _aFunction(comparefn));
  }
});

var SPECIES = _wks('species');

var _arraySpeciesConstructor = function _arraySpeciesConstructor(original) {
  var C;

  if (_isArray(original)) {
    C = original.constructor; // cross-realm fallback

    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;

    if (_isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? Array : C;
}; // 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function _arraySpeciesCreate(original, length) {
  return new (_arraySpeciesConstructor(original))(length);
}; // 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex


var _arrayMethods = function _arrayMethods(TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);

    var self = _iobject(O);

    var f = _ctx(callbackfn, that, 3);

    var length = _toLength(self.length);

    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;

    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);

        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true;
              // some

              case 5:
                return val;
              // find

              case 6:
                return index;
              // findIndex

              case 2:
                result.push(val);
              // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var $forEach = _arrayMethods(0);

var STRICT = _strictMethod([].forEach, true);

_export(_export.P + _export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn
  /* , thisArg */
  ) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

var $map = _arrayMethods(1);

_export(_export.P + _export.F * !_strictMethod([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn
  /* , thisArg */
  ) {
    return $map(this, callbackfn, arguments[1]);
  }
});

var $filter = _arrayMethods(2);

_export(_export.P + _export.F * !_strictMethod([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn
  /* , thisArg */
  ) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

var $some = _arrayMethods(3);

_export(_export.P + _export.F * !_strictMethod([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn
  /* , thisArg */
  ) {
    return $some(this, callbackfn, arguments[1]);
  }
});

var $every = _arrayMethods(4);

_export(_export.P + _export.F * !_strictMethod([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn
  /* , thisArg */
  ) {
    return $every(this, callbackfn, arguments[1]);
  }
});

var _arrayReduce = function _arrayReduce(that, callbackfn, aLen, memo, isRight) {
  _aFunction(callbackfn);

  var O = _toObject(that);

  var self = _iobject(O);

  var length = _toLength(O.length);

  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }

    index += i;

    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }

  for (; isRight ? index >= 0 : length > index; index += i) {
    if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
  }

  return memo;
};

_export(_export.P + _export.F * !_strictMethod([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn
  /* , initialValue */
  ) {
    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

_export(_export.P + _export.F * !_strictMethod([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn
  /* , initialValue */
  ) {
    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

var $indexOf = _arrayIncludes(false);

var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO || !_strictMethod($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement
  /* , fromIndex = 0 */
  ) {
    return NEGATIVE_ZERO // convert -0 to +0
    ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
  }
});

var $native$1 = [].lastIndexOf;
var NEGATIVE_ZERO$1 = !!$native$1 && 1 / [1].lastIndexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO$1 || !_strictMethod($native$1)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement
  /* , fromIndex = @[*-1] */
  ) {
    // convert -0 to +0
    if (NEGATIVE_ZERO$1) return $native$1.apply(this, arguments) || 0;

    var O = _toIobject(this);

    var length = _toLength(O.length);

    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, _toInteger(arguments[1]));
    if (index < 0) index = length + index;

    for (; index >= 0; index--) {
      if (index in O) if (O[index] === searchElement) return index || 0;
    }

    return -1;
  }
});

var _arrayCopyWithin = [].copyWithin || function copyWithin(target
/* = 0 */
, start
/* = 0, end = @length */
) {
  var O = _toObject(this);

  var len = _toLength(O.length);

  var to = _toAbsoluteIndex(target, len);

  var from = _toAbsoluteIndex(start, len);

  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : _toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;

  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }

  while (count-- > 0) {
    if (from in O) O[to] = O[from];else delete O[to];
    to += inc;
    from += inc;
  }

  return O;
}; // 22.1.3.31 Array.prototype[@@unscopables]


var UNSCOPABLES = _wks('unscopables');

var ArrayProto$1 = Array.prototype;
if (ArrayProto$1[UNSCOPABLES] == undefined) _hide(ArrayProto$1, UNSCOPABLES, {});

var _addToUnscopables = function _addToUnscopables(key) {
  ArrayProto$1[UNSCOPABLES][key] = true;
}; // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)


_export(_export.P, 'Array', {
  copyWithin: _arrayCopyWithin
});

_addToUnscopables('copyWithin');

var _arrayFill = function fill(value
/* , start = 0, end = @length */
) {
  var O = _toObject(this);

  var length = _toLength(O.length);

  var aLen = arguments.length;

  var index = _toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);

  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : _toAbsoluteIndex(end, length);

  while (endPos > index) {
    O[index++] = value;
  }

  return O;
}; // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)


_export(_export.P, 'Array', {
  fill: _arrayFill
});

_addToUnscopables('fill'); // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)


var $find = _arrayMethods(5);

var KEY = 'find';
var forced = true; // Shouldn't skip holes

if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});

_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn
  /* , that = undefined */
  ) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables(KEY); // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)


var $find$1 = _arrayMethods(6);

var KEY$1 = 'findIndex';
var forced$1 = true; // Shouldn't skip holes

if (KEY$1 in []) Array(1)[KEY$1](function () {
  forced$1 = false;
});

_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn
  /* , that = undefined */
  ) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables(KEY$1);

var SPECIES$1 = _wks('species');

var _setSpecies = function _setSpecies(KEY) {
  var C = _global[KEY];
  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

_setSpecies('Array');

var _iterStep = function _iterStep(done, value) {
  return {
    value: value,
    done: !!done
  };
}; // 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()


var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target

  this._i = 0; // next index

  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;

  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }

  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)


_iterators.Arguments = _iterators.Array;

_addToUnscopables('keys');

_addToUnscopables('values');

_addToUnscopables('entries'); // 21.2.5.3 get RegExp.prototype.flags


var _flags = function _flags() {
  var that = _anObject(this);

  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var dP$4 = _objectDp.f;
var gOPN$3 = _objectGopn.f;
var $RegExp = _global.RegExp;
var Base$1 = $RegExp;
var proto$2 = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g; // "new" creates a new object, old webkit buggy here

var CORRECT_NEW = new $RegExp(re1) !== re1;

if (_descriptors && (!CORRECT_NEW || _fails(function () {
  re2[_wks('match')] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;

    var piRE = _isRegexp(p);

    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : _inheritIfRequired(CORRECT_NEW ? new Base$1(piRE && !fiU ? p.source : p, f) : Base$1((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? _flags.call(p) : f), tiRE ? this : proto$2, $RegExp);
  };

  var proxy = function proxy(key) {
    key in $RegExp || dP$4($RegExp, key, {
      configurable: true,
      get: function get() {
        return Base$1[key];
      },
      set: function set(it) {
        Base$1[key] = it;
      }
    });
  };

  for (var keys$1 = gOPN$3(Base$1), i = 0; keys$1.length > i;) {
    proxy(keys$1[i++]);
  }

  proto$2.constructor = $RegExp;
  $RegExp.prototype = proto$2;

  _redefine(_global, 'RegExp', $RegExp);
}

_setSpecies('RegExp');

var nativeExec = RegExp.prototype.exec; // This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.

var nativeReplace = String.prototype.replace;
var patchedExec = nativeExec;
var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
}(); // nonparticipating capturing group, copied from es5-shim's String#split patch.


var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', _flags.call(re));
    }

    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }

    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var _regexpExec = patchedExec;

_export({
  target: 'RegExp',
  proto: true,
  forced: _regexpExec !== /./.exec
}, {
  exec: _regexpExec
}); // 21.2.5.3 get RegExp.prototype.flags()


if (_descriptors && /./g.flags != 'g') _objectDp.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: _flags
});
var TO_STRING$1 = 'toString';
var $toString$1 = /./[TO_STRING$1];

var define = function define(fn) {
  _redefine(RegExp.prototype, TO_STRING$1, fn, true);
}; // 21.2.5.14 RegExp.prototype.toString()


if (_fails(function () {
  return $toString$1.call({
    source: 'a',
    flags: 'b'
  }) != '/a/b';
})) {
  define(function toString() {
    var R = _anObject(this);

    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
  }); // FF44- RegExp#toString has a wrong name
} else if ($toString$1.name != TO_STRING$1) {
  define(function toString() {
    return $toString$1.call(this);
  });
}

var at = _stringAt(true); // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex


var _advanceStringIndex = function _advanceStringIndex(S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

var builtinExec = RegExp.prototype.exec; // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec

var _regexpExecAbstract = function _regexpExecAbstract(R, S) {
  var exec = R.exec;

  if (typeof exec === 'function') {
    var result = exec.call(R, S);

    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }

    return result;
  }

  if (_classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }

  return builtinExec.call(R, S);
};

var SPECIES$2 = _wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;

  re.exec = function () {
    var result = [];
    result.groups = {
      a: '7'
    };
    return result;
  };

  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;

  re.exec = function () {
    return originalExec.apply(this, arguments);
  };

  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();

var _fixReWks = function _fixReWks(KEY, length, exec) {
  var SYMBOL = _wks(KEY);

  var DELEGATES_TO_SYMBOL = !_fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};

    O[SYMBOL] = function () {
      return 7;
    };

    return ''[KEY](O) != 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !_fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    re.exec = function () {
      execCalled = true;
      return null;
    };

    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};

      re.constructor[SPECIES$2] = function () {
        return re;
      };
    }

    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(_defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === _regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return {
            done: true,
            value: nativeRegExpMethod.call(regexp, str, arg2)
          };
        }

        return {
          done: true,
          value: nativeMethod.call(str, regexp, arg2)
        };
      }

      return {
        done: false
      };
    });
    var strfn = fns[0];
    var rxfn = fns[1];

    _redefine(String.prototype, KEY, strfn);

    _hide(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
    ? function (string, arg) {
      return rxfn.call(string, this, arg);
    } // 21.2.5.6 RegExp.prototype[@@match](string)
    // 21.2.5.9 RegExp.prototype[@@search](string)
    : function (string) {
      return rxfn.call(string, this);
    });
  }
}; // @@match logic


_fixReWks('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [// `String.prototype.match` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.match
  function match(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, // `RegExp.prototype[@@match]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
  function (regexp) {
    var res = maybeCallNative($match, regexp, this);
    if (res.done) return res.value;

    var rx = _anObject(regexp);

    var S = String(this);
    if (!rx.global) return _regexpExecAbstract(rx, S);
    var fullUnicode = rx.unicode;
    rx.lastIndex = 0;
    var A = [];
    var n = 0;
    var result;

    while ((result = _regexpExecAbstract(rx, S)) !== null) {
      var matchStr = String(result[0]);
      A[n] = matchStr;
      if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
      n++;
    }

    return n === 0 ? null : A;
  }];
});

var max$1 = Math.max;
var min$2 = Math.min;
var floor$3 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function maybeToString(it) {
  return it === undefined ? it : String(it);
}; // @@replace logic


_fixReWks('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [// `String.prototype.replace` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
  }, // `RegExp.prototype[@@replace]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
  function (regexp, replaceValue) {
    var res = maybeCallNative($replace, regexp, this, replaceValue);
    if (res.done) return res.value;

    var rx = _anObject(regexp);

    var S = String(this);
    var functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = String(replaceValue);
    var global = rx.global;

    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }

    var results = [];

    while (true) {
      var result = _regexpExecAbstract(rx, S);

      if (result === null) break;
      results.push(result);
      if (!global) break;
      var matchStr = String(result[0]);
      if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
    }

    var accumulatedResult = '';
    var nextSourcePosition = 0;

    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = String(result[0]);
      var position = max$1(min$2(_toInteger(result.index), S.length), 0);
      var captures = []; // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

      for (var j = 1; j < result.length; j++) {
        captures.push(maybeToString(result[j]));
      }

      var namedCaptures = result.groups;

      if (functionalReplace) {
        var replacerArgs = [matched].concat(captures, position, S);
        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
        var replacement = String(replaceValue.apply(undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }

      if (position >= nextSourcePosition) {
        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }

    return accumulatedResult + S.slice(nextSourcePosition);
  }]; // https://tc39.github.io/ecma262/#sec-getsubstitution

  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

    if (namedCaptures !== undefined) {
      namedCaptures = _toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }

    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;

      switch (ch.charAt(0)) {
        case '$':
          return '$';

        case '&':
          return matched;

        case '`':
          return str.slice(0, position);

        case "'":
          return str.slice(tailPos);

        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;

        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;

          if (n > m) {
            var f = floor$3(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }

          capture = captures[n - 1];
      }

      return capture === undefined ? '' : capture;
    });
  }
}); // @@search logic


_fixReWks('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [// `String.prototype.search` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.search
  function search(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, // `RegExp.prototype[@@search]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
  function (regexp) {
    var res = maybeCallNative($search, regexp, this);
    if (res.done) return res.value;

    var rx = _anObject(regexp);

    var S = String(this);
    var previousLastIndex = rx.lastIndex;
    if (!_sameValue(previousLastIndex, 0)) rx.lastIndex = 0;

    var result = _regexpExecAbstract(rx, S);

    if (!_sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
    return result === null ? -1 : result.index;
  }];
}); // 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$3 = _wks('species');

var _speciesConstructor = function _speciesConstructor(O, D) {
  var C = _anObject(O).constructor;

  var S;
  return C === undefined || (S = _anObject(C)[SPECIES$3]) == undefined ? D : _aFunction(S);
};

var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX$1 = 'lastIndex';
var MAX_UINT32 = 0xffffffff; // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError

var SUPPORTS_Y = !_fails(function () {}); // @@split logic

_fixReWks('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;

  if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return []; // If `separator` is not a regex, use native split

      if (!_isRegexp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0; // Make `global` and avoid `lastIndex` issues by working with a copy

      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;

      while (match = _regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX$1];

        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }

        if (separatorCopy[LAST_INDEX$1] === match.index) separatorCopy[LAST_INDEX$1]++; // Avoid an infinite loop
      }

      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));

      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    }; // Chakra, V8

  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function internalSplit(separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [// `String.prototype.split` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = defined(this);
    var splitter = separator == undefined ? undefined : separator[SPLIT];
    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
  }, // `RegExp.prototype[@@split]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (regexp, limit) {
    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
    if (res.done) return res.value;

    var rx = _anObject(regexp);

    var S = String(this);

    var C = _speciesConstructor(rx, RegExp);

    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g'); // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.

    var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return _regexpExecAbstract(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];

    while (q < S.length) {
      splitter.lastIndex = SUPPORTS_Y ? q : 0;

      var z = _regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));

      var e;

      if (z === null || (e = $min(_toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
        q = _advanceStringIndex(S, q, unicodeMatching);
      } else {
        A.push(S.slice(p, q));
        if (A.length === lim) return A;

        for (var i = 1; i <= z.length - 1; i++) {
          A.push(z[i]);
          if (A.length === lim) return A;
        }

        q = p = e;
      }
    }

    A.push(S.slice(p));
    return A;
  }];
});

var _anInstance = function _anInstance(it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }

  return it;
};

var _forOf = createCommonjsModule(function (module) {
  var BREAK = {};
  var RETURN = {};

  var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function () {
      return iterable;
    } : core_getIteratorMethod(iterable);

    var f = _ctx(fn, that, entries ? 2 : 1);

    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

    if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
      result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
      if (result === BREAK || result === RETURN) return result;
    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
      result = _iterCall(iterator, f, step.value, entries);
      if (result === BREAK || result === RETURN) return result;
    }
  };

  exports.BREAK = BREAK;
  exports.RETURN = RETURN;
});

var process$1 = _global.process;
var setTask = _global.setImmediate;
var clearTask = _global.clearImmediate;
var MessageChannel$1 = _global.MessageChannel;
var Dispatch = _global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function run() {
  var id = +this; // eslint-disable-next-line no-prototype-builtins

  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var listener = function listener(event) {
  run.call(event.data);
}; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;

    while (arguments.length > i) {
      args.push(arguments[i++]);
    }

    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };

    defer(counter);
    return counter;
  };

  clearTask = function clearImmediate(id) {
    delete queue[id];
  }; // Node.js 0.8-


  if (_cof(process$1) == 'process') {
    defer = function defer(id) {
      process$1.nextTick(_ctx(run, id, 1));
    }; // Sphere (JS game engine) Dispatch API

  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(_ctx(run, id, 1));
    }; // Browsers with MessageChannel, includes WebWorkers

  } else if (MessageChannel$1) {
    channel = new MessageChannel$1();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
    defer = function defer(id) {
      _global.postMessage(id + '', '*');
    };

    _global.addEventListener('message', listener, false); // IE8-

  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
    defer = function defer(id) {
      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
        _html.removeChild(this);

        run.call(id);
      };
    }; // Rest old browsers

  } else {
    defer = function defer(id) {
      setTimeout(_ctx(run, id, 1), 0);
    };
  }
}

var _task = {
  set: setTask,
  clear: clearTask
};
var macrotask = _task.set;
var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
var process$2 = _global.process;
var Promise$1 = _global.Promise;
var isNode = _cof(process$2) == 'process';

var _microtask = function _microtask() {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process$2.domain)) parent.exit();

    while (head) {
      fn = head.fn;
      head = head.next;

      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }

    last = undefined;
    if (parent) parent.enter();
  }; // Node.js


  if (isNode) {
    notify = function notify() {
      process$2.nextTick(flush);
    }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, {
      characterData: true
    }); // eslint-disable-line no-new

    notify = function notify() {
      node.data = toggle = !toggle;
    }; // environments with maybe non-completely correct, but existent Promise

  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);

    notify = function notify() {
      promise.then(flush);
    }; // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout

  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global, flush);
    };
  }

  return function (fn) {
    var task = {
      fn: fn,
      next: undefined
    };
    if (last) last.next = task;

    if (!head) {
      head = task;
      notify();
    }

    last = task;
  };
}; // 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction(resolve);
  this.reject = _aFunction(reject);
}

var f$7 = function f$7(C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
  f: f$7
};

var _perform = function _perform(exec) {
  try {
    return {
      e: false,
      v: exec()
    };
  } catch (e) {
    return {
      e: true,
      v: e
    };
  }
};

var navigator$1 = _global.navigator;

var _userAgent = navigator$1 && navigator$1.userAgent || '';

var _promiseResolve = function _promiseResolve(C, x) {
  _anObject(C);

  if (_isObject(x) && x.constructor === C) return x;

  var promiseCapability = _newPromiseCapability.f(C);

  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll = function _redefineAll(target, src, safe) {
  for (var key in src) {
    _redefine(target, key, src[key], safe);
  }

  return target;
};

var task = _task.set;

var microtask = _microtask();

var PROMISE = 'Promise';
var TypeError$1 = _global.TypeError;
var process$3 = _global.process;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global[PROMISE];
var isNode$1 = _classof(process$3) == 'process';

var empty = function empty() {
  /* empty */
};

var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;
var USE_NATIVE$1 = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);

    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
      exec(empty, empty);
    }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


    return (isNode$1 || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0 && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {
    /* empty */
  }
}(); // helpers

var isThenable = function isThenable(it) {
  var then;
  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;

    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;

      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }

          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // may throw

            if (domain) {
              domain.exit();
              exited = true;
            }
          }

          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };

    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach


    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};

var onUnhandled = function onUnhandled(promise) {
  task.call(_global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;

    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else if (handler = _global.onunhandledrejection) {
          handler({
            promise: promise,
            reason: value
          });
        } else if ((console = _global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    }

    promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};

var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};

var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(_global, function () {
    var handler;

    if (isNode$1) {
      process$3.emit('rejectionHandled', promise);
    } else if (handler = _global.onrejectionhandled) {
      handler({
        promise: promise,
        reason: promise._v
      });
    }
  });
};

var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap

  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};

var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap

  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");

    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = {
          _w: promise,
          _d: false
        }; // wrap

        try {
          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({
      _w: promise,
      _d: false
    }, e); // wrap
  }
}; // constructor polyfill


if (!USE_NATIVE$1) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance(this, $Promise, PROMISE, '_h');

    _aFunction(executor);

    Internal.call(this);

    try {
      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  }; // eslint-disable-next-line no-unused-vars


  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions

    this._a = undefined; // <- checked in isUnhandled reactions

    this._s = 0; // <- state

    this._d = false; // <- done

    this._v = undefined; // <- value

    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

    this._n = false; // <- notify
  };

  Internal.prototype = _redefineAll($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$3.domain : undefined;

      this._c.push(reaction);

      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });

  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx($resolve, promise, 1);
    this.reject = _ctx($reject, promise, 1);
  };

  _newPromiseCapability.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE$1, {
  Promise: $Promise
});

_setToStringTag($Promise, PROMISE);

_setSpecies(PROMISE);

Wrapper = _core[PROMISE]; // statics

_export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});

_export(_export.S + _export.F * (_library || !USE_NATIVE$1), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve(_library && this === Wrapper ? $Promise : this, x);
  }
});

_export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;

    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;

      _forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });

      --remaining || resolve(values);
    });

    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;

    var result = _perform(function () {
      _forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });

    if (result.e) reject(result.v);
    return capability.promise;
  }
});

var _validateCollection = function _validateCollection(it, TYPE) {
  if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

var dP$5 = _objectDp.f;
var fastKey = _meta.fastKey;
var SIZE = _descriptors ? '_s' : 'size';

var getEntry = function getEntry(that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index]; // frozen object case

  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

var _collectionStrong = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');

      that._t = NAME; // collection type

      that._i = _objectCreate(null); // index

      that._f = undefined; // first entry

      that._l = undefined; // last entry

      that[SIZE] = 0; // size

      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });

    _redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }

        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function _delete(key) {
        var that = _validateCollection(this, NAME);

        var entry = getEntry(that, key);

        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        }

        return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn
      /* , that = undefined */
      ) {
        _validateCollection(this, NAME);

        var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);

        var entry;

        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this); // revert to the last existing entry

          while (entry && entry.r) {
            entry = entry.p;
          }
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(_validateCollection(this, NAME), key);
      }
    });

    if (_descriptors) dP$5(C.prototype, 'size', {
      get: function get() {
        return _validateCollection(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var entry = getEntry(that, key);
    var prev, index; // change existing entry

    if (entry) {
      entry.v = value; // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true),
        // <- index
        k: key,
        // <- key
        v: value,
        // <- value
        p: prev = that._l,
        // <- previous entry
        n: undefined,
        // <- next entry
        r: false // <- removed

      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++; // add to index

      if (index !== 'F') that._i[index] = entry;
    }

    return that;
  },
  getEntry: getEntry,
  setStrong: function setStrong(C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    _iterDefine(C, NAME, function (iterated, kind) {
      this._t = _validateCollection(iterated, NAME); // target

      this._k = kind; // kind

      this._l = undefined; // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l; // revert to the last existing entry

      while (entry && entry.r) {
        entry = entry.p;
      } // get next entry


      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return _iterStep(1);
      } // return step by kind


      if (kind == 'keys') return _iterStep(0, entry.k);
      if (kind == 'values') return _iterStep(0, entry.v);
      return _iterStep(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2


    _setSpecies(NAME);
  }
};

var _collection = function _collection(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = _global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};

  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];

    _redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !_isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);
      return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);
      return this;
    });
  };

  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);

    _redefineAll(C.prototype, methods);

    _meta.NEED = true;
  } else {
    var instance = new C(); // early implementations not supports chaining

    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false

    var THROWS_ON_PRIMITIVES = _fails(function () {
      instance.has(1);
    }); // most early implementations doesn't supports iterables, most modern - not close it correctly


    var ACCEPT_ITERABLES = _iterDetect(function (iter) {
      new C(iter);
    }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same


    var BUGGY_ZERO = !IS_WEAK && _fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;

      while (index--) {
        $instance[ADDER](index, index);
      }

      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        _anInstance(target, C, NAME);

        var that = _inheritIfRequired(new Base(), target, C);

        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  _setToStringTag(C, NAME);

  O[NAME] = C;

  _export(_export.G + _export.W + _export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
  return C;
};

var MAP = 'Map'; // 23.1 Map Objects

var es6_map = _collection(MAP, function (get) {
  return function Map() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = _collectionStrong.getEntry(_validateCollection(this, MAP), key);

    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return _collectionStrong.def(_validateCollection(this, MAP), key === 0 ? 0 : key, value);
  }
}, _collectionStrong, true);

var SET = 'Set'; // 23.2 Set Objects

var es6_set = _collection(SET, function (get) {
  return function Set() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
  }
}, _collectionStrong);

var getWeak = _meta.getWeak;

var arrayFind = _arrayMethods(5);

var arrayFindIndex = _arrayMethods(6);

var id$1 = 0; // fallback for uncaught frozen keys

var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};

var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};
var _collectionWeak = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');

      that._t = NAME; // collection type

      that._i = id$1++; // collection id

      that._l = undefined; // leak store for uncaught frozen objects

      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });

    _redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function _delete(key) {
        if (!_isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME))['delete'](key);
        return data && _has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!_isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME)).has(key);
        return data && _has(data, this._i);
      }
    });

    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(_anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};
var es6_weakMap = createCommonjsModule(function (module) {
  var each = _arrayMethods(0);

  var WEAK_MAP = 'WeakMap';
  var getWeak = _meta.getWeak;
  var isExtensible = Object.isExtensible;
  var uncaughtFrozenStore = _collectionWeak.ufstore;
  var tmp = {};
  var InternalMap;

  var wrapper = function wrapper(get) {
    return function WeakMap() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  };

  var methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
      if (_isObject(key)) {
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(_validateCollection(this, WEAK_MAP)).get(key);
        return data ? data[this._i] : undefined;
      }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
      return _collectionWeak.def(_validateCollection(this, WEAK_MAP), key, value);
    }
  }; // 23.3 WeakMap Objects

  var $WeakMap = module.exports = _collection(WEAK_MAP, wrapper, methods, _collectionWeak, true, true); // IE11 WeakMap frozen keys fix


  if (_fails(function () {
    return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
  })) {
    InternalMap = _collectionWeak.getConstructor(wrapper, WEAK_MAP);

    _objectAssign(InternalMap.prototype, methods);

    _meta.NEED = true;
    each(['delete', 'has', 'get', 'set'], function (key) {
      var proto = $WeakMap.prototype;
      var method = proto[key];

      _redefine(proto, key, function (a, b) {
        // store frozen objects on internal weakmap shim
        if (_isObject(a) && !isExtensible(a)) {
          if (!this._f) this._f = new InternalMap();

          var result = this._f[key](a, b);

          return key == 'set' ? this : result; // store all the rest on native weakmap
        }

        return method.call(this, a, b);
      });
    });
  }
});
var WEAK_SET = 'WeakSet'; // 23.4 WeakSet Objects

_collection(WEAK_SET, function (get) {
  return function WeakSet() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return _collectionWeak.def(_validateCollection(this, WEAK_SET), value, true);
  }
}, _collectionWeak, false, true);

var TYPED = _uid('typed_array');

var VIEW = _uid('view');

var ABV = !!(_global.ArrayBuffer && _global.DataView);
var CONSTR = ABV;
var i$1 = 0;
var l = 9;
var Typed;
var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

while (i$1 < l) {
  if (Typed = _global[TypedArrayConstructors[i$1++]]) {
    _hide(Typed.prototype, TYPED, true);

    _hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

var _typed = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
}; // https://tc39.github.io/ecma262/#sec-toindex

var _toIndex = function _toIndex(it) {
  if (it === undefined) return 0;

  var number = _toInteger(it);

  var length = _toLength(number);

  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

var _typedBuffer = createCommonjsModule(function (module, exports) {
  var gOPN = _objectGopn.f;
  var dP = _objectDp.f;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var DATA_VIEW = 'DataView';
  var PROTOTYPE = 'prototype';
  var WRONG_LENGTH = 'Wrong length!';
  var WRONG_INDEX = 'Wrong index!';
  var $ArrayBuffer = _global[ARRAY_BUFFER];
  var $DataView = _global[DATA_VIEW];
  var Math = _global.Math;
  var RangeError = _global.RangeError; // eslint-disable-next-line no-shadow-restricted-names

  var Infinity = _global.Infinity;
  var BaseBuffer = $ArrayBuffer;
  var abs = Math.abs;
  var pow = Math.pow;
  var floor = Math.floor;
  var log = Math.log;
  var LN2 = Math.LN2;
  var BUFFER = 'buffer';
  var BYTE_LENGTH = 'byteLength';
  var BYTE_OFFSET = 'byteOffset';
  var $BUFFER = _descriptors ? '_b' : BUFFER;
  var $LENGTH = _descriptors ? '_l' : BYTE_LENGTH;
  var $OFFSET = _descriptors ? '_o' : BYTE_OFFSET; // IEEE754 conversions based on https://github.com/feross/ieee754

  function packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = abs(value); // eslint-disable-next-line no-self-compare

    if (value != value || value === Infinity) {
      // eslint-disable-next-line no-self-compare
      m = value != value ? 1 : 0;
      e = eMax;
    } else {
      e = floor(log(value) / LN2);

      if (value * (c = pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }

      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * pow(2, 1 - eBias);
      }

      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * pow(2, eBias - 1) * pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {
      ;
    }

    e = e << mLen | m;
    eLen += mLen;

    for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {
      ;
    }

    buffer[--i] |= s * 128;
    return buffer;
  }

  function unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;

    for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {
      ;
    }

    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;

    for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {
      ;
    }

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : s ? -Infinity : Infinity;
    } else {
      m = m + pow(2, mLen);
      e = e - eBias;
    }

    return (s ? -1 : 1) * m * pow(2, e - mLen);
  }

  function unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
  }

  function packI8(it) {
    return [it & 0xff];
  }

  function packI16(it) {
    return [it & 0xff, it >> 8 & 0xff];
  }

  function packI32(it) {
    return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
  }

  function packF64(it) {
    return packIEEE754(it, 52, 8);
  }

  function packF32(it) {
    return packIEEE754(it, 23, 4);
  }

  function addGetter(C, key, internal) {
    dP(C[PROTOTYPE], key, {
      get: function get() {
        return this[internal];
      }
    });
  }

  function get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;

    var intIndex = _toIndex(numIndex);

    if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
    var store = view[$BUFFER]._b;
    var start = intIndex + view[$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
  }

  function set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;

    var intIndex = _toIndex(numIndex);

    if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
    var store = view[$BUFFER]._b;
    var start = intIndex + view[$OFFSET];
    var pack = conversion(+value);

    for (var i = 0; i < bytes; i++) {
      store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
    }
  }

  if (!_typed.ABV) {
    $ArrayBuffer = function ArrayBuffer(length) {
      _anInstance(this, $ArrayBuffer, ARRAY_BUFFER);

      var byteLength = _toIndex(length);

      this._b = _arrayFill.call(new Array(byteLength), 0);
      this[$LENGTH] = byteLength;
    };

    $DataView = function DataView(buffer, byteOffset, byteLength) {
      _anInstance(this, $DataView, DATA_VIEW);

      _anInstance(buffer, $ArrayBuffer, DATA_VIEW);

      var bufferLength = buffer[$LENGTH];

      var offset = _toInteger(byteOffset);

      if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
      byteLength = byteLength === undefined ? bufferLength - offset : _toLength(byteLength);
      if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
      this[$BUFFER] = buffer;
      this[$OFFSET] = offset;
      this[$LENGTH] = byteLength;
    };

    if (_descriptors) {
      addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
      addGetter($DataView, BUFFER, '_b');
      addGetter($DataView, BYTE_LENGTH, '_l');
      addGetter($DataView, BYTE_OFFSET, '_o');
    }

    _redefineAll($DataView[PROTOTYPE], {
      getInt8: function getInt8(byteOffset) {
        return get(this, 1, byteOffset)[0] << 24 >> 24;
      },
      getUint8: function getUint8(byteOffset) {
        return get(this, 1, byteOffset)[0];
      },
      getInt16: function getInt16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments[1]);
        return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
      },
      getUint16: function getUint16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments[1]);
        return bytes[1] << 8 | bytes[0];
      },
      getInt32: function getInt32(byteOffset
      /* , littleEndian */
      ) {
        return unpackI32(get(this, 4, byteOffset, arguments[1]));
      },
      getUint32: function getUint32(byteOffset
      /* , littleEndian */
      ) {
        return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
      },
      getFloat32: function getFloat32(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
      },
      getFloat64: function getFloat64(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
      },
      setInt8: function setInt8(byteOffset, value) {
        set(this, 1, byteOffset, packI8, value);
      },
      setUint8: function setUint8(byteOffset, value) {
        set(this, 1, byteOffset, packI8, value);
      },
      setInt16: function setInt16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packI16, value, arguments[2]);
      },
      setUint16: function setUint16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packI16, value, arguments[2]);
      },
      setInt32: function setInt32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packI32, value, arguments[2]);
      },
      setUint32: function setUint32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packI32, value, arguments[2]);
      },
      setFloat32: function setFloat32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packF32, value, arguments[2]);
      },
      setFloat64: function setFloat64(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 8, byteOffset, packF64, value, arguments[2]);
      }
    });
  } else {
    if (!_fails(function () {
      $ArrayBuffer(1);
    }) || !_fails(function () {
      new $ArrayBuffer(-1); // eslint-disable-line no-new
    }) || _fails(function () {
      new $ArrayBuffer(); // eslint-disable-line no-new

      new $ArrayBuffer(1.5); // eslint-disable-line no-new

      new $ArrayBuffer(NaN); // eslint-disable-line no-new

      return $ArrayBuffer.name != ARRAY_BUFFER;
    })) {
      $ArrayBuffer = function ArrayBuffer(length) {
        _anInstance(this, $ArrayBuffer);

        return new BaseBuffer(_toIndex(length));
      };

      var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];

      for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
        if (!((key = keys[j++]) in $ArrayBuffer)) _hide($ArrayBuffer, key, BaseBuffer[key]);
      }

      ArrayBufferProto.constructor = $ArrayBuffer;
    } // iOS Safari 7.x bug


    var view = new $DataView(new $ArrayBuffer(2));
    var $setInt8 = $DataView[PROTOTYPE].setInt8;
    view.setInt8(0, 2147483648);
    view.setInt8(1, 2147483649);
    if (view.getInt8(0) || !view.getInt8(1)) _redefineAll($DataView[PROTOTYPE], {
      setInt8: function setInt8(byteOffset, value) {
        $setInt8.call(this, byteOffset, value << 24 >> 24);
      },
      setUint8: function setUint8(byteOffset, value) {
        $setInt8.call(this, byteOffset, value << 24 >> 24);
      }
    }, true);
  }

  _setToStringTag($ArrayBuffer, ARRAY_BUFFER);

  _setToStringTag($DataView, DATA_VIEW);

  _hide($DataView[PROTOTYPE], _typed.VIEW, true);

  exports[ARRAY_BUFFER] = $ArrayBuffer;
  exports[DATA_VIEW] = $DataView;
});

var ArrayBuffer$1 = _global.ArrayBuffer;
var $ArrayBuffer = _typedBuffer.ArrayBuffer;
var $DataView = _typedBuffer.DataView;
var $isView = _typed.ABV && ArrayBuffer$1.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW$1 = _typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

_export(_export.G + _export.W + _export.F * (ArrayBuffer$1 !== $ArrayBuffer), {
  ArrayBuffer: $ArrayBuffer
});

_export(_export.S + _export.F * !_typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || _isObject(it) && VIEW$1 in it;
  }
});

_export(_export.P + _export.U + _export.F * _fails(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(_anObject(this), start); // FF fix

    var len = _anObject(this).byteLength;

    var first = _toAbsoluteIndex(start, len);

    var fin = _toAbsoluteIndex(end === undefined ? len : end, len);

    var result = new (_speciesConstructor(this, $ArrayBuffer))(_toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;

    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    }

    return result;
  }
});

_setSpecies(ARRAY_BUFFER);

_export(_export.G + _export.W + _export.F * !_typed.ABV, {
  DataView: _typedBuffer.DataView
});

var _typedArray = createCommonjsModule(function (module) {
  if (_descriptors) {
    var global = _global;
    var fails = _fails;
    var $export = _export;
    var $typed = _typed;
    var $buffer = _typedBuffer;
    var ctx = _ctx;
    var anInstance = _anInstance;
    var propertyDesc = _propertyDesc;
    var hide = _hide;
    var redefineAll = _redefineAll;
    var toInteger = _toInteger;
    var toLength = _toLength;
    var toIndex = _toIndex;
    var toAbsoluteIndex = _toAbsoluteIndex;
    var toPrimitive = _toPrimitive;
    var has = _has;
    var classof = _classof;
    var isObject = _isObject;
    var toObject = _toObject;
    var isArrayIter = _isArrayIter;
    var create = _objectCreate;
    var getPrototypeOf = _objectGpo;
    var gOPN = _objectGopn.f;
    var getIterFn = core_getIteratorMethod;
    var uid = _uid;
    var wks = _wks;
    var createArrayMethod = _arrayMethods;
    var createArrayIncludes = _arrayIncludes;
    var speciesConstructor = _speciesConstructor;
    var ArrayIterators = es6_array_iterator;
    var Iterators = _iterators;
    var $iterDetect = _iterDetect;
    var setSpecies = _setSpecies;
    var arrayFill = _arrayFill;
    var arrayCopyWithin = _arrayCopyWithin;
    var $DP = _objectDp;
    var $GOPD = _objectGopd;
    var dP = $DP.f;
    var gOPD = $GOPD.f;
    var RangeError = global.RangeError;
    var TypeError = global.TypeError;
    var Uint8Array = global.Uint8Array;
    var ARRAY_BUFFER = 'ArrayBuffer';
    var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
    var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var PROTOTYPE = 'prototype';
    var ArrayProto = Array[PROTOTYPE];
    var $ArrayBuffer = $buffer.ArrayBuffer;
    var $DataView = $buffer.DataView;
    var arrayForEach = createArrayMethod(0);
    var arrayFilter = createArrayMethod(2);
    var arraySome = createArrayMethod(3);
    var arrayEvery = createArrayMethod(4);
    var arrayFind = createArrayMethod(5);
    var arrayFindIndex = createArrayMethod(6);
    var arrayIncludes = createArrayIncludes(true);
    var arrayIndexOf = createArrayIncludes(false);
    var arrayValues = ArrayIterators.values;
    var arrayKeys = ArrayIterators.keys;
    var arrayEntries = ArrayIterators.entries;
    var arrayLastIndexOf = ArrayProto.lastIndexOf;
    var arrayReduce = ArrayProto.reduce;
    var arrayReduceRight = ArrayProto.reduceRight;
    var arrayJoin = ArrayProto.join;
    var arraySort = ArrayProto.sort;
    var arraySlice = ArrayProto.slice;
    var arrayToString = ArrayProto.toString;
    var arrayToLocaleString = ArrayProto.toLocaleString;
    var ITERATOR = wks('iterator');
    var TAG = wks('toStringTag');
    var TYPED_CONSTRUCTOR = uid('typed_constructor');
    var DEF_CONSTRUCTOR = uid('def_constructor');
    var ALL_CONSTRUCTORS = $typed.CONSTR;
    var TYPED_ARRAY = $typed.TYPED;
    var VIEW = $typed.VIEW;
    var WRONG_LENGTH = 'Wrong length!';
    var $map = createArrayMethod(1, function (O, length) {
      return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
    });
    var LITTLE_ENDIAN = fails(function () {
      // eslint-disable-next-line no-undef
      return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
    });
    var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
      new Uint8Array(1).set({});
    });

    var toOffset = function toOffset(it, BYTES) {
      var offset = toInteger(it);
      if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
      return offset;
    };

    var validate = function validate(it) {
      if (isObject(it) && TYPED_ARRAY in it) return it;
      throw TypeError(it + ' is not a typed array!');
    };

    var allocate = function allocate(C, length) {
      if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
        throw TypeError('It is not a typed array constructor!');
      }

      return new C(length);
    };

    var speciesFromList = function speciesFromList(O, list) {
      return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
    };

    var fromList = function fromList(C, list) {
      var index = 0;
      var length = list.length;
      var result = allocate(C, length);

      while (length > index) {
        result[index] = list[index++];
      }

      return result;
    };

    var addGetter = function addGetter(it, key, internal) {
      dP(it, key, {
        get: function get() {
          return this._d[internal];
        }
      });
    };

    var $from = function from(source
    /* , mapfn, thisArg */
    ) {
      var O = toObject(source);
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var iterFn = getIterFn(O);
      var i, length, values, result, step, iterator;

      if (iterFn != undefined && !isArrayIter(iterFn)) {
        for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
          values.push(step.value);
        }

        O = values;
      }

      if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);

      for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
        result[i] = mapping ? mapfn(O[i], i) : O[i];
      }

      return result;
    };

    var $of = function of()
    /* ...items */
    {
      var index = 0;
      var length = arguments.length;
      var result = allocate(this, length);

      while (length > index) {
        result[index] = arguments[index++];
      }

      return result;
    }; // iOS Safari 6.x fails here


    var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
      arrayToLocaleString.call(new Uint8Array(1));
    });

    var $toLocaleString = function toLocaleString() {
      return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
    };

    var proto = {
      copyWithin: function copyWithin(target, start
      /* , end */
      ) {
        return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
      },
      every: function every(callbackfn
      /* , thisArg */
      ) {
        return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      fill: function fill(value
      /* , start, end */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayFill.apply(validate(this), arguments);
      },
      filter: function filter(callbackfn
      /* , thisArg */
      ) {
        return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
      },
      find: function find(predicate
      /* , thisArg */
      ) {
        return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
      },
      findIndex: function findIndex(predicate
      /* , thisArg */
      ) {
        return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
      },
      forEach: function forEach(callbackfn
      /* , thisArg */
      ) {
        arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      indexOf: function indexOf(searchElement
      /* , fromIndex */
      ) {
        return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
      },
      includes: function includes(searchElement
      /* , fromIndex */
      ) {
        return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
      },
      join: function join(separator) {
        // eslint-disable-line no-unused-vars
        return arrayJoin.apply(validate(this), arguments);
      },
      lastIndexOf: function lastIndexOf(searchElement
      /* , fromIndex */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayLastIndexOf.apply(validate(this), arguments);
      },
      map: function map(mapfn
      /* , thisArg */
      ) {
        return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      reduce: function reduce(callbackfn
      /* , initialValue */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayReduce.apply(validate(this), arguments);
      },
      reduceRight: function reduceRight(callbackfn
      /* , initialValue */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayReduceRight.apply(validate(this), arguments);
      },
      reverse: function reverse() {
        var that = this;
        var length = validate(that).length;
        var middle = Math.floor(length / 2);
        var index = 0;
        var value;

        while (index < middle) {
          value = that[index];
          that[index++] = that[--length];
          that[length] = value;
        }

        return that;
      },
      some: function some(callbackfn
      /* , thisArg */
      ) {
        return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      sort: function sort(comparefn) {
        return arraySort.call(validate(this), comparefn);
      },
      subarray: function subarray(begin, end) {
        var O = validate(this);
        var length = O.length;
        var $begin = toAbsoluteIndex(begin, length);
        return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
      }
    };

    var $slice = function slice(start, end) {
      return speciesFromList(this, arraySlice.call(validate(this), start, end));
    };

    var $set = function set(arrayLike
    /* , offset */
    ) {
      validate(this);
      var offset = toOffset(arguments[1], 1);
      var length = this.length;
      var src = toObject(arrayLike);
      var len = toLength(src.length);
      var index = 0;
      if (len + offset > length) throw RangeError(WRONG_LENGTH);

      while (index < len) {
        this[offset + index] = src[index++];
      }
    };

    var $iterators = {
      entries: function entries() {
        return arrayEntries.call(validate(this));
      },
      keys: function keys() {
        return arrayKeys.call(validate(this));
      },
      values: function values() {
        return arrayValues.call(validate(this));
      }
    };

    var isTAIndex = function isTAIndex(target, key) {
      return isObject(target) && target[TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };

    var $getDesc = function getOwnPropertyDescriptor(target, key) {
      return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
    };

    var $setDesc = function defineProperty(target, key, desc) {
      if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set') // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
        target[key] = desc.value;
        return target;
      }

      return dP(target, key, desc);
    };

    if (!ALL_CONSTRUCTORS) {
      $GOPD.f = $getDesc;
      $DP.f = $setDesc;
    }

    $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
      getOwnPropertyDescriptor: $getDesc,
      defineProperty: $setDesc
    });

    if (fails(function () {
      arrayToString.call({});
    })) {
      arrayToString = arrayToLocaleString = function toString() {
        return arrayJoin.call(this);
      };
    }

    var $TypedArrayPrototype$ = redefineAll({}, proto);
    redefineAll($TypedArrayPrototype$, $iterators);
    hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
    redefineAll($TypedArrayPrototype$, {
      slice: $slice,
      set: $set,
      constructor: function constructor() {
        /* noop */
      },
      toString: arrayToString,
      toLocaleString: $toLocaleString
    });
    addGetter($TypedArrayPrototype$, 'buffer', 'b');
    addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
    addGetter($TypedArrayPrototype$, 'byteLength', 'l');
    addGetter($TypedArrayPrototype$, 'length', 'e');
    dP($TypedArrayPrototype$, TAG, {
      get: function get() {
        return this[TYPED_ARRAY];
      }
    }); // eslint-disable-next-line max-statements

    module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
      CLAMPED = !!CLAMPED;
      var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
      var GETTER = 'get' + KEY;
      var SETTER = 'set' + KEY;
      var TypedArray = global[NAME];
      var Base = TypedArray || {};
      var TAC = TypedArray && getPrototypeOf(TypedArray);
      var FORCED = !TypedArray || !$typed.ABV;
      var O = {};
      var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];

      var getter = function getter(that, index) {
        var data = that._d;
        return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
      };

      var setter = function setter(that, index, value) {
        var data = that._d;
        if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
        data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
      };

      var addElement = function addElement(that, index) {
        dP(that, index, {
          get: function get() {
            return getter(this, index);
          },
          set: function set(value) {
            return setter(this, index, value);
          },
          enumerable: true
        });
      };

      if (FORCED) {
        TypedArray = wrapper(function (that, data, $offset, $length) {
          anInstance(that, TypedArray, NAME, '_d');
          var index = 0;
          var offset = 0;
          var buffer, byteLength, length, klass;

          if (!isObject(data)) {
            length = toIndex(data);
            byteLength = length * BYTES;
            buffer = new $ArrayBuffer(byteLength);
          } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
            buffer = data;
            offset = toOffset($offset, BYTES);
            var $len = data.byteLength;

            if ($length === undefined) {
              if ($len % BYTES) throw RangeError(WRONG_LENGTH);
              byteLength = $len - offset;
              if (byteLength < 0) throw RangeError(WRONG_LENGTH);
            } else {
              byteLength = toLength($length) * BYTES;
              if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
            }

            length = byteLength / BYTES;
          } else if (TYPED_ARRAY in data) {
            return fromList(TypedArray, data);
          } else {
            return $from.call(TypedArray, data);
          }

          hide(that, '_d', {
            b: buffer,
            o: offset,
            l: byteLength,
            e: length,
            v: new $DataView(buffer)
          });

          while (index < length) {
            addElement(that, index++);
          }
        });
        TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
        hide(TypedArrayPrototype, 'constructor', TypedArray);
      } else if (!fails(function () {
        TypedArray(1);
      }) || !fails(function () {
        new TypedArray(-1); // eslint-disable-line no-new
      }) || !$iterDetect(function (iter) {
        new TypedArray(); // eslint-disable-line no-new

        new TypedArray(null); // eslint-disable-line no-new

        new TypedArray(1.5); // eslint-disable-line no-new

        new TypedArray(iter); // eslint-disable-line no-new
      }, true)) {
        TypedArray = wrapper(function (that, data, $offset, $length) {
          anInstance(that, TypedArray, NAME);
          var klass; // `ws` module bug, temporarily remove validation length for Uint8Array
          // https://github.com/websockets/ws/pull/645

          if (!isObject(data)) return new Base(toIndex(data));

          if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
            return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
          }

          if (TYPED_ARRAY in data) return fromList(TypedArray, data);
          return $from.call(TypedArray, data);
        });
        arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
          if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
        });
        TypedArray[PROTOTYPE] = TypedArrayPrototype;
        TypedArrayPrototype.constructor = TypedArray;
      }

      var $nativeIterator = TypedArrayPrototype[ITERATOR];
      var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
      var $iterator = $iterators.values;
      hide(TypedArray, TYPED_CONSTRUCTOR, true);
      hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
      hide(TypedArrayPrototype, VIEW, true);
      hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

      if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
        dP(TypedArrayPrototype, TAG, {
          get: function get() {
            return NAME;
          }
        });
      }

      O[NAME] = TypedArray;
      $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
      $export($export.S, NAME, {
        BYTES_PER_ELEMENT: BYTES
      });
      $export($export.S + $export.F * fails(function () {
        Base.of.call(TypedArray, 1);
      }), NAME, {
        from: $from,
        of: $of
      });
      if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
      $export($export.P, NAME, proto);
      setSpecies(NAME);
      $export($export.P + $export.F * FORCED_SET, NAME, {
        set: $set
      });
      $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
      if (TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
      $export($export.P + $export.F * fails(function () {
        new TypedArray(1).slice();
      }), NAME, {
        slice: $slice
      });
      $export($export.P + $export.F * (fails(function () {
        return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
      }) || !fails(function () {
        TypedArrayPrototype.toLocaleString.call([1, 2]);
      })), NAME, {
        toLocaleString: $toLocaleString
      });
      Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
      if (!CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
    };
  } else module.exports = function () {
    /* empty */
  };
});

_typedArray('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

_typedArray('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

_typedArray('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)


var rApply = (_global.Reflect || {}).apply;
var fApply = Function.apply; // MS Edge argumentsList argument is optional

_export(_export.S + _export.F * !_fails(function () {
  rApply(function () {
    /* empty */
  });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = _aFunction(target);

    var L = _anObject(argumentsList);

    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
}); // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])


var rConstruct = (_global.Reflect || {}).construct; // MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it

var NEW_TARGET_BUG = _fails(function () {
  function F() {
    /* empty */
  }

  return !(rConstruct(function () {
    /* empty */
  }, [], F) instanceof F);
});

var ARGS_BUG = !_fails(function () {
  rConstruct(function () {
    /* empty */
  });
});

_export(_export.S + _export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args
  /* , newTarget */
  ) {
    _aFunction(Target);

    _anObject(args);

    var newTarget = arguments.length < 3 ? Target : _aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);

    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0:
          return new Target();

        case 1:
          return new Target(args[0]);

        case 2:
          return new Target(args[0], args[1]);

        case 3:
          return new Target(args[0], args[1], args[2]);

        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      } // w/o altered newTarget, lot of arguments case


      var $args = [null];
      $args.push.apply($args, args);
      return new (_bind.apply(Target, $args))();
    } // with altered newTarget, not support built-in constructors


    var proto = newTarget.prototype;

    var instance = _objectCreate(_isObject(proto) ? proto : Object.prototype);

    var result = Function.apply.call(Target, instance, args);
    return _isObject(result) ? result : instance;
  }
}); // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
// MS Edge has broken Reflect.defineProperty - throwing instead of returning false


_export(_export.S + _export.F * _fails(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(_objectDp.f({}, 1, {
    value: 1
  }), 1, {
    value: 2
  });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    _anObject(target);

    propertyKey = _toPrimitive(propertyKey, true);

    _anObject(attributes);

    try {
      _objectDp.f(target, propertyKey, attributes);

      return true;
    } catch (e) {
      return false;
    }
  }
}); // 26.1.4 Reflect.deleteProperty(target, propertyKey)


var gOPD$3 = _objectGopd.f;

_export(_export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD$3(_anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
}); // 26.1.5 Reflect.enumerate(target)


var Enumerate = function Enumerate(iterated) {
  this._t = _anObject(iterated); // target

  this._i = 0; // next index

  var keys = this._k = []; // keys

  var key;

  for (key in iterated) {
    keys.push(key);
  }
};

_iterCreate(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;

  do {
    if (that._i >= keys.length) return {
      value: undefined,
      done: true
    };
  } while (!((key = keys[that._i++]) in that._t));

  return {
    value: key,
    done: false
  };
});

_export(_export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
}); // 26.1.6 Reflect.get(target, propertyKey [, receiver])


function get(target, propertyKey
/* , receiver */
) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (_anObject(target) === receiver) return target[propertyKey];
  if (desc = _objectGopd.f(target, propertyKey)) return _has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
  if (_isObject(proto = _objectGpo(target))) return get(proto, propertyKey, receiver);
}

_export(_export.S, 'Reflect', {
  get: get
}); // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)


_export(_export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return _objectGopd.f(_anObject(target), propertyKey);
  }
}); // 26.1.8 Reflect.getPrototypeOf(target)


_export(_export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return _objectGpo(_anObject(target));
  }
}); // 26.1.9 Reflect.has(target, propertyKey)


_export(_export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
}); // 26.1.10 Reflect.isExtensible(target)


var $isExtensible = Object.isExtensible;

_export(_export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    _anObject(target);

    return $isExtensible ? $isExtensible(target) : true;
  }
}); // all object keys, includes non-enumerable and symbols


var Reflect$1 = _global.Reflect;

var _ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
  var keys = _objectGopn.f(_anObject(it));

  var getSymbols = _objectGops.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
}; // 26.1.11 Reflect.ownKeys(target)


_export(_export.S, 'Reflect', {
  ownKeys: _ownKeys
}); // 26.1.12 Reflect.preventExtensions(target)


var $preventExtensions = Object.preventExtensions;

_export(_export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    _anObject(target);

    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
}); // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])


function set(target, propertyKey, V
/* , receiver */
) {
  var receiver = arguments.length < 4 ? target : arguments[3];

  var ownDesc = _objectGopd.f(_anObject(target), propertyKey);

  var existingDescriptor, proto;

  if (!ownDesc) {
    if (_isObject(proto = _objectGpo(target))) {
      return set(proto, propertyKey, V, receiver);
    }

    ownDesc = _propertyDesc(0);
  }

  if (_has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !_isObject(receiver)) return false;

    if (existingDescriptor = _objectGopd.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;

      _objectDp.f(receiver, propertyKey, existingDescriptor);
    } else _objectDp.f(receiver, propertyKey, _propertyDesc(0, V));

    return true;
  }

  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

_export(_export.S, 'Reflect', {
  set: set
}); // 26.1.14 Reflect.setPrototypeOf(target, proto)


if (_setProto) _export(_export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    _setProto.check(target, proto);

    try {
      _setProto.set(target, proto);

      return true;
    } catch (e) {
      return false;
    }
  }
}); // https://github.com/tc39/Array.prototype.includes

var $includes = _arrayIncludes(true);

_export(_export.P, 'Array', {
  includes: function includes(el
  /* , fromIndex = 0 */
  ) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables('includes');

var includes = _core.Array.includes; // https://github.com/tc39/proposal-string-pad-start-end

var _stringPad = function _stringPad(that, maxLength, fillString, left) {
  var S = String(_defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);

  var intMaxLength = _toLength(maxLength);

  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;

  var stringFiller = _stringRepeat.call(fillStr, Math.ceil(fillLen / fillStr.length));

  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
}; // https://github.com/tc39/proposal-string-pad-start-end
// https://github.com/zloirock/core-js/issues/280


_export(_export.P + _export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(_userAgent), 'String', {
  padStart: function padStart(maxLength
  /* , fillString = ' ' */
  ) {
    return _stringPad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

var padStart = _core.String.padStart; // https://github.com/tc39/proposal-string-pad-start-end
// https://github.com/zloirock/core-js/issues/280

_export(_export.P + _export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(_userAgent), 'String', {
  padEnd: function padEnd(maxLength
  /* , fillString = ' ' */
  ) {
    return _stringPad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

var padEnd = _core.String.padEnd;

_wksDefine('asyncIterator');

var asyncIterator = _wksExt.f('asyncIterator'); // https://github.com/tc39/proposal-object-getownpropertydescriptors


_export(_export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = _toIobject(object);

    var getDesc = _objectGopd.f;

    var keys = _ownKeys(O);

    var result = {};
    var i = 0;
    var key, desc;

    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) _createProperty(result, key, desc);
    }

    return result;
  }
});

var getOwnPropertyDescriptors = _core.Object.getOwnPropertyDescriptors;
var isEnum$1 = _objectPie.f;

var _objectToArray = function _objectToArray(isEntries) {
  return function (it) {
    var O = _toIobject(it);

    var keys = _objectKeys(O);

    var length = keys.length;
    var i = 0;
    var result = [];
    var key;

    while (length > i) {
      if (isEnum$1.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }

    return result;
  };
}; // https://github.com/tc39/proposal-object-values-entries


var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var values = _core.Object.values; // https://github.com/tc39/proposal-object-values-entries

var $entries = _objectToArray(true);

_export(_export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

var entries = _core.Object.entries;

_export(_export.P + _export.R, 'Promise', {
  'finally': function _finally(onFinally) {
    var C = _speciesConstructor(this, _core.Promise || _global.Promise);

    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
});

var _finally = _core.Promise['finally']; // ie9- setTimeout & setInterval additional parameters fix

var slice = [].slice;
var MSIE = /MSIE .\./.test(_userAgent); // <- dirty ie9- check

var wrap$1 = function wrap$1(set) {
  return function (fn, time
  /* , ...args */
  ) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};

_export(_export.G + _export.B + _export.F * MSIE, {
  setTimeout: wrap$1(_global.setTimeout),
  setInterval: wrap$1(_global.setInterval)
});

_export(_export.G + _export.B, {
  setImmediate: _task.set,
  clearImmediate: _task.clear
});

var ITERATOR$4 = _wks('iterator');

var TO_STRING_TAG = _wks('toStringTag');

var ArrayValues = _iterators.Array;
var DOMIterables = {
  CSSRuleList: true,
  // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true,
  // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true,
  // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = _objectKeys(DOMIterables), i$2 = 0; i$2 < collections.length; i$2++) {
  var NAME$1 = collections[i$2];
  var explicit = DOMIterables[NAME$1];
  var Collection = _global[NAME$1];
  var proto$3 = Collection && Collection.prototype;
  var key$1;

  if (proto$3) {
    if (!proto$3[ITERATOR$4]) _hide(proto$3, ITERATOR$4, ArrayValues);
    if (!proto$3[TO_STRING_TAG]) _hide(proto$3, TO_STRING_TAG, NAME$1);
    _iterators[NAME$1] = ArrayValues;
    if (explicit) for (key$1 in es6_array_iterator) {
      if (!proto$3[key$1]) _redefine(proto$3, key$1, es6_array_iterator[key$1], true);
    }
  }
}

var runtime = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  !function (global) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var runtime = global.regeneratorRuntime;

    if (runtime) {
      {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      } // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.

      return;
    } // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.


    runtime = global.regeneratorRuntime = module.exports;

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    runtime.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    runtime.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    runtime.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    runtime.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          if (delegate.iterator.return) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    runtime.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    runtime.values = values;

    function doneResult() {
      return {
        value: undefined,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }

        return ContinueSentinel;
      }
    };
  }( // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  function () {
    return this || typeof self === "object" && self;
  }() || Function("return this")());
});

if (commonjsGlobal._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

commonjsGlobal._babelPolyfill = true;
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__$1 = process.env.NODE_ENV !== 'production';

var warning$1 = function warning$1() {};

if (__DEV__$1) {
  warning$1 = function warning$1(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

var warning_1$1 = warning$1;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var invariant_1 = invariant;

function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
} // About 1.5x faster than the two-arg version of Array#splice()


function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
} // This implementation is based heavily on node's url.parse


function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];
  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';
  var hasTrailingSlash = void 0;

  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;

  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }
  if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
  var result = fromParts.join('/');
  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
  return result;
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function valueEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();
    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
  return path;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolvePathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && valueEqual(a.state, b.state);
};

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    warning_1$1(prompt == null, 'A history supports only one prompt at a time');
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          warning_1$1(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */


var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
};
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */


var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */


var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */


var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  invariant_1(canUseDOM, 'Browser history needs a DOM');
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
    warning_1$1(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = createTransitionManager();

  var setState = function setState(nextState) {
    _extends$1(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  var createHref = function createHref(location) {
    return basename + createPath(location);
  };

  var push = function push(path, state) {
    warning_1$1(!((typeof path === 'undefined' ? 'undefined' : _typeof$1(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
        warning_1$1(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    warning_1$1(!((typeof path === 'undefined' ? 'undefined' : _typeof$1(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
        warning_1$1(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      addEventListener(window, PopStateEvent, handlePopState);
      if (needsHashChangeListener) addEventListener(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      removeEventListener(window, PopStateEvent, handlePopState);
      if (needsHashChangeListener) removeEventListener(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  invariant_1(canUseDOM, 'Hash history needs a DOM');
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());
    warning_1$1(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  };

  var transitionManager = createTransitionManager();

  var setState = function setState(nextState) {
    _extends$2(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }; // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  };

  var push = function push(path, state) {
    warning_1$1(state === undefined, 'Hash history cannot push state; it is ignored');
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
        warning_1$1(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    warning_1$1(state === undefined, 'Hash history cannot replace state; it is ignored');
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  };

  var go = function go(n) {
    warning_1$1(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      addEventListener(window, HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      removeEventListener(window, HashChangeEvent$1, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
};

var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};
/**
 * Creates a history object that stores locations in memory.
 */


var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  var setState = function setState(nextState) {
    _extends$3(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  var push = function push(path, state) {
    warning_1$1(!((typeof path === 'undefined' ? 'undefined' : _typeof$2(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    warning_1$1(!((typeof path === 'undefined' ? 'undefined' : _typeof$2(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */


var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends$4({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;
    invariant_1(children == null || React.Children.count(children) === 1, "A <Router> may have only one child element"); // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.

    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    warning_1(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;
    return children ? React.Children.only(children) : null;
  };

  return Router;
}(React.Component);

Router.propTypes = {
  history: PropTypes.object.isRequired,
  children: PropTypes.node
};
Router.contextTypes = {
  router: PropTypes.object
};
Router.childContextTypes = {
  router: PropTypes.object.isRequired
}; // Written in this round about way for babel-transform-imports

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses HTML5 history.
 */


var BrowserRouter = function (_React$Component) {
  _inherits$1(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck$1(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = createBrowserHistory(_this.props), _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    warning_1(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return React.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(React.Component);

BrowserRouter.propTypes = {
  basename: PropTypes.string,
  forceRefresh: PropTypes.bool,
  getUserConfirmation: PropTypes.func,
  keyLength: PropTypes.number,
  children: PropTypes.node
};

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$2(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses window.location.hash.
 */


var HashRouter = function (_React$Component) {
  _inherits$2(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck$2(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = createHashHistory(_this.props), _temp), _possibleConstructorReturn$2(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    warning_1(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return React.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(React.Component);

HashRouter.propTypes = {
  basename: PropTypes.string,
  getUserConfirmation: PropTypes.func,
  hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"]),
  children: PropTypes.node
};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$3(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = function (_React$Component) {
  _inherits$3(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck$3(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;

          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn$3(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars


    invariant_1(this.context.router, "You should not use <Link> outside a <Router>");
    invariant_1(to !== undefined, 'You must specify the "to" property');
    var history = this.context.router.history;
    var location = typeof to === "string" ? createLocation(to, null, null, history.location) : to;
    var href = history.createHref(location);
    return React.createElement("a", _extends$5({}, props, {
      onClick: this.handleClick,
      href: href,
      ref: innerRef
    }));
  };

  return Link;
}(React.Component);

Link.propTypes = {
  onClick: PropTypes.func,
  target: PropTypes.string,
  replace: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  innerRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: PropTypes.shape({
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
      replace: PropTypes.func.isRequired,
      createHref: PropTypes.func.isRequired
    }).isRequired
  }).isRequired
};

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$4(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that stores location in memory.
 */


var MemoryRouter = function (_React$Component) {
  _inherits$4(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck$4(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$4(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = createMemoryHistory(_this.props), _temp), _possibleConstructorReturn$4(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    warning_1(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return React.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(React.Component);

MemoryRouter.propTypes = {
  initialEntries: PropTypes.array,
  initialIndex: PropTypes.number,
  getUserConfirmation: PropTypes.func,
  keyLength: PropTypes.number,
  children: PropTypes.node
}; // Written in this round about way for babel-transform-imports

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};
/**
 * Expose `pathToRegexp`.
 */


var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */

var PATH_REGEXP = new RegExp([// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)', // Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */

function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length; // Ignore already escaped sequences.

    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7]; // Push the current path onto the tokens.

    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;
    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  } // Match any characters still remaining.


  if (index < str.length) {
    path += str.substr(index);
  } // If the path exists, push it onto the end.


  if (path) {
    tokens.push(path);
  }

  return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */


function compile(str, options) {
  return tokensToFunction(parse(str, options));
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */


function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */


function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}
/**
 * Expose a method for transforming tokens into the path function.
 */


function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length); // Compile all the patterns before compilation.

  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;
        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */


function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */


function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */


function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */


function flags(options) {
  return options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */


function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */


function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
  return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */


function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */


function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options =
    /** @type {!Object} */
    keys || options;
    keys = [];
  }

  options = options || {};
  var strict = options.strict;
  var end = options.end !== false;
  var route = ''; // Iterate over the tokens and create our regexp string.

  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';
      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter; // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".

  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */


function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options =
    /** @type {!Object} */
    keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path,
    /** @type {!Array} */
    keys);
  }

  if (isarray(path)) {
    return arrayToRegexp(
    /** @type {!Array} */
    path,
    /** @type {!Array} */
    keys, options);
  }

  return stringToRegexp(
  /** @type {string} */
  path,
  /** @type {!Array} */
  keys, options);
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
  if (cache[pattern]) return cache[pattern];
  var keys = [];
  var re = pathToRegexp_1(pattern, keys, options);
  var compiledPattern = {
    re: re,
    keys: keys
  };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */


var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];
  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
  if (path == null) return parent;

  var _compilePath = compilePath(path, {
    end: exact,
    strict: strict,
    sensitive: sensitive
  }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);
  if (!match) return null;
  var url = match[0],
      values = match.slice(1);
  var isExact = pathname === url;
  if (exact && !isExact) return null;
  return {
    path: path,
    // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url,
    // the matched portion of the URL
    isExact: isExact,
    // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$5(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isEmptyChildren = function isEmptyChildren(children) {
  return React.Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */


var Route = function (_React$Component) {
  _inherits$5(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck$5(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$5(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn$5(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends$6({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;
    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    invariant_1(router, "You should not use <Route> or withRouter() outside a <Router>");
    var route = router.route;
    var pathname = (location || route.location).pathname;
    return matchPath(pathname, {
      path: path,
      strict: strict,
      exact: exact,
      sensitive: sensitive
    }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    warning_1(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
    warning_1(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
    warning_1(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    warning_1(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    warning_1(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;
    var location = this.props.location || route.location;
    var props = {
      match: match,
      location: location,
      history: history,
      staticContext: staticContext
    };
    if (component) return match ? React.createElement(component, props) : null;
    if (render) return match ? render(props) : null;
    if (typeof children === "function") return children(props);
    if (children && !isEmptyChildren(children)) return React.Children.only(children);
    return null;
  };

  return Route;
}(React.Component);

Route.propTypes = {
  computedMatch: PropTypes.object,
  // private, from <Switch>
  path: PropTypes.string,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  sensitive: PropTypes.bool,
  component: PropTypes.func,
  render: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  location: PropTypes.object
};
Route.contextTypes = {
  router: PropTypes.shape({
    history: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  })
};
Route.childContextTypes = {
  router: PropTypes.object.isRequired
}; // Written in this round about way for babel-transform-imports

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof$3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties$1(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof$3(to)) === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return React.createElement(Route, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;
      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
      return React.createElement(Link, _extends$7({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends$7({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: Link.propTypes.to,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  location: PropTypes.object,
  activeClassName: PropTypes.string,
  className: PropTypes.string,
  activeStyle: PropTypes.object,
  style: PropTypes.object,
  isActive: PropTypes.func,
  "aria-current": PropTypes.oneOf(["page", "step", "location", "date", "time", "true"])
};
NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$6(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */


var Prompt = function (_React$Component) {
  _inherits$6(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck$6(this, Prompt);

    return _possibleConstructorReturn$6(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();
    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    invariant_1(this.context.router, "You should not use <Prompt> outside a <Router>");
    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(React.Component);

Prompt.propTypes = {
  when: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: PropTypes.shape({
    history: PropTypes.shape({
      block: PropTypes.func.isRequired
    }).isRequired
  }).isRequired
}; // Written in this round about way for babel-transform-imports

var patternCache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache$1[cacheKey] || (patternCache$1[cacheKey] = {});
  if (cache[pattern]) return cache[pattern];
  var compiledGenerator = pathToRegexp_1.compile(pattern);

  if (cacheCount$1 < cacheLimit$1) {
    cache[pattern] = compiledGenerator;
    cacheCount$1++;
  }

  return compiledGenerator;
};
/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */


var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }

  var generator = compileGenerator(pattern);
  return generator(params, {
    pretty: true
  });
};

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$7(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for updating the location programmatically
 * with a component.
 */


var Redirect = function (_React$Component) {
  _inherits$7(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck$7(this, Redirect);

    return _possibleConstructorReturn$7(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    invariant_1(this.context.router, "You should not use <Redirect> outside a <Router>");
    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = createLocation(prevProps.to);
    var nextTo = createLocation(this.props.to);

    if (locationsAreEqual(prevTo, nextTo)) {
      warning_1(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return generatePath(to, computedMatch.params);
      } else {
        return _extends$8({}, to, {
          pathname: generatePath(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;
    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(React.Component);

Redirect.propTypes = {
  computedMatch: PropTypes.object,
  // private, from <Switch>
  push: PropTypes.bool,
  from: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: PropTypes.shape({
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
      replace: PropTypes.func.isRequired
    }).isRequired,
    staticContext: PropTypes.object
  }).isRequired
}; // Written in this round about way for babel-transform-imports

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$8(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var addLeadingSlash$1 = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;
  return _extends$9({}, location, {
    pathname: addLeadingSlash$1(basename) + location.pathname
  });
};

var stripBasename$1 = function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash$1(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return _extends$9({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : createPath(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    invariant_1(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter = function (_React$Component) {
  _inherits$8(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck$8(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$8(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash$1(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;
      context.action = "PUSH";
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;
      context.action = "REPLACE";
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn$8(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    warning_1(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties$2(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename$1(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return React.createElement(Router, _extends$9({}, props, {
      history: history
    }));
  };

  return StaticRouter;
}(React.Component);

StaticRouter.propTypes = {
  basename: PropTypes.string,
  context: PropTypes.object.isRequired,
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: PropTypes.object.isRequired
}; // Written in this round about way for babel-transform-imports

function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$9(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */


var Switch = function (_React$Component) {
  _inherits$9(Switch, _React$Component);

  function Switch() {
    _classCallCheck$9(this, Switch);

    return _possibleConstructorReturn$9(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    invariant_1(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    warning_1(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    warning_1(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;
    var location = this.props.location || route.location;
    var match = void 0,
        child = void 0;
    React.Children.forEach(children, function (element) {
      if (match == null && React.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;
        var path = pathProp || from;
        child = element;
        match = matchPath(location.pathname, {
          path: path,
          exact: exact,
          strict: strict,
          sensitive: sensitive
        }, route.match);
      }
    });
    return match ? React.cloneElement(child, {
      location: location,
      computedMatch: match
    }) : null;
  };

  return Switch;
}(React.Component);

Switch.contextTypes = {
  router: PropTypes.shape({
    route: PropTypes.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object
}; // Written in this round about way for babel-transform-imports
// Written in this round about way for babel-transform-imports
// Written in this round about way for babel-transform-imports

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * A public higher-order component to access the imperative API
 */


var withRouter = function withRouter(Component$$1) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties$3(props, ["wrappedComponentRef"]);

    return React.createElement(Route, {
      children: function children(routeComponentProps) {
        return React.createElement(Component$$1, _extends$a({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component$$1.displayName || Component$$1.name) + ")";
  C.WrappedComponent = Component$$1;
  C.propTypes = {
    wrappedComponentRef: PropTypes.func
  };
  return hoistNonReactStatics_cjs(C, Component$$1);
}; // Written in this round about way for babel-transform-imports


function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ReactReduxContext = React.createContext(null);

var Provider =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Provider, _Component);

  function Provider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.state = {
      storeState: store.getState(),
      store: store
    };
    return _this;
  }

  var _proto = Provider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.subscribe();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this._isMounted = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      if (this.unsubscribe) this.unsubscribe();
      this.subscribe();
    }
  };

  _proto.subscribe = function subscribe() {
    var _this2 = this;

    var store = this.props.store;
    this.unsubscribe = store.subscribe(function () {
      var newStoreState = store.getState();

      if (!_this2._isMounted) {
        return;
      }

      _this2.setState(function (providerState) {
        // If the value is the same, skip the unnecessary state update.
        if (providerState.storeState === newStoreState) {
          return null;
        }

        return {
          storeState: newStoreState
        };
      });
    }); // Actions might have been dispatched between render and mount - handle those

    var postMountStoreState = store.getState();

    if (postMountStoreState !== this.state.storeState) {
      this.setState({
        storeState: postMountStoreState
      });
    }
  };

  _proto.render = function render() {
    var Context = this.props.context || ReactReduxContext;
    return React.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };

  return Provider;
}(Component);

Provider.propTypes = {
  store: PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired
  }),
  context: PropTypes.object,
  children: PropTypes.any
};

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.memo") : 60115,
      r = b ? Symbol.for("react.lazy") : 60116;

  function t(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case r:
        case q:
        case d:
          return u;
      }
    }
  }

  function v(a) {
    return t(a) === m;
  }

  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };

  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };

  exports.isConcurrentMode = v;

  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };

  exports.isContextProvider = function (a) {
    return t(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return t(a) === n;
  };

  exports.isFragment = function (a) {
    return t(a) === e;
  };

  exports.isLazy = function (a) {
    return t(a) === r;
  };

  exports.isMemo = function (a) {
    return t(a) === q;
  };

  exports.isPortal = function (a) {
    return t(a) === d;
  };

  exports.isProfiler = function (a) {
    return t(a) === g;
  };

  exports.isStrictMode = function (a) {
    return t(a) === f;
  };

  exports.isSuspense = function (a) {
    return t(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
      }
      /**
       * Forked from fbjs/warning:
       * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
       *
       * Only change is we use console.warn instead of console.error,
       * and do nothing when 'console' is not supported.
       * This really simplifies the code.
       * ---
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var lowPriorityWarning = function lowPriorityWarning() {};

      {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.warn(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        lowPriorityWarning = function lowPriorityWarning(condition, format) {
          if (format === undefined) {
            throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }
      var lowPriorityWarning$1 = lowPriorityWarning;

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_LAZY_TYPE:
            case REACT_MEMO_TYPE:
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.typeOf = typeOf;
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isValidElementType = isValidElementType;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
    })();
  }
});
unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var reactIs_1 = reactIs.isValidElementType;
var reactIs_2 = reactIs.isElement;
var reactIs_3 = reactIs.ForwardRef;
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS$1 = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS$1 = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
var defineProperty$2 = Object.defineProperty;
var getOwnPropertyNames$1 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype$1 = Object.prototype;

function hoistNonReactStatics$1(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype$1) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype$1) {
        hoistNonReactStatics$1(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames$1(sourceComponent);

    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }

    var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS$1;
    var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS$1;

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS$1[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$2(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs$1 = hoistNonReactStatics$1;

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  invariant_1(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
  invariant_1(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components,  create a custom React context with ' + "React.createContext(), and pass the context object to React-Redux's Provider and specific components" + ' like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  invariant_1(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production') {
      invariant_1(reactIs_1(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;
    var OuterBaseComponent = Component;
    var FinalWrappedComponent = WrappedComponent;

    if (pure) {
      OuterBaseComponent = PureComponent;
    }

    function makeDerivedPropsSelector() {
      var lastProps;
      var lastState;
      var lastDerivedProps;
      var lastStore;
      var sourceSelector;
      return function selectDerivedProps(state, props, store) {
        if (pure && lastProps === props && lastState === state) {
          return lastDerivedProps;
        }

        if (store !== lastStore) {
          lastStore = store;
          sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
        }

        lastProps = props;
        lastState = state;
        var nextProps = sourceSelector(state, props);

        if (lastDerivedProps === nextProps) {
          return lastDerivedProps;
        }

        lastDerivedProps = nextProps;
        return lastDerivedProps;
      };
    }

    function makeChildElementSelector() {
      var lastChildProps, lastForwardRef, lastChildElement;
      return function selectChildElement(childProps, forwardRef) {
        if (childProps !== lastChildProps || forwardRef !== lastForwardRef) {
          lastChildProps = childProps;
          lastForwardRef = forwardRef;
          lastChildElement = React.createElement(FinalWrappedComponent, _extends({}, childProps, {
            ref: forwardRef
          }));
        }

        return lastChildElement;
      };
    }

    var Connect =
    /*#__PURE__*/
    function (_OuterBaseComponent) {
      _inheritsLoose(Connect, _OuterBaseComponent);

      function Connect(props) {
        var _this;

        _this = _OuterBaseComponent.call(this, props) || this;
        invariant_1(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
        _this.selectDerivedProps = makeDerivedPropsSelector();
        _this.selectChildElement = makeChildElementSelector();
        _this.renderWrappedComponent = _this.renderWrappedComponent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        return _this;
      }

      var _proto = Connect.prototype;

      _proto.renderWrappedComponent = function renderWrappedComponent(value) {
        invariant_1(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
        var storeState = value.storeState,
            store = value.store;
        var wrapperProps = this.props;
        var forwardedRef;

        if (forwardRef) {
          wrapperProps = this.props.wrapperProps;
          forwardedRef = this.props.forwardedRef;
        }

        var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store);
        return this.selectChildElement(derivedProps, forwardedRef);
      };

      _proto.render = function render() {
        var ContextToUse = this.props.context || Context;
        return React.createElement(ContextToUse.Consumer, null, this.renderWrappedComponent);
      };

      return Connect;
    }(OuterBaseComponent);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return React.createElement(Connect, {
          wrapperProps: props,
          forwardedRef: ref
        });
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs$1(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs$1(Connect, WrappedComponent);
  };
}

var hasOwn = Object.prototype.hasOwnProperty;

function is$1(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is$1(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is$1(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;

  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      result = Symbol('observable');
      Symbol.observable = result;
    }
  } else {
    result = '@@observable';
  }

  return result;
}
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = symbolObservablePonyfill(root);
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */

var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */


function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[result] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[result] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning$2(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (process.env.NODE_ENV !== 'production') {
      if (typeof reducers[key] === 'undefined') {
        warning$2("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (process.env.NODE_ENV !== 'production') {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (process.env.NODE_ENV !== 'production') {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning$2(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */


function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */


function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */


function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning$2('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

var redux =
/*#__PURE__*/
Object.freeze({
  createStore: createStore,
  combineReducers: combineReducers,
  bindActionCreators: bindActionCreators,
  applyMiddleware: applyMiddleware,
  compose: compose,
  __DO_NOT_USE__ActionTypes: ActionTypes
});
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject$1(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning$3(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject$1(value)) {
    warning$3(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..


function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//


function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}

var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}

var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      warning$3("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.


function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */


function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}

var connect = createConnect();

var asyncToGenerator = function asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty$3 = function defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get$1 = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var _templateObject = taggedTemplateLiteral(["\n\tpadding-top: 100px;\n\tdisplay: block;\n\theight: auto;\n\twidth: 90%;\n\tmax-width: 800px;\n\tmargin: 0 auto;\n"], ["\n\tpadding-top: 100px;\n\tdisplay: block;\n\theight: auto;\n\twidth: 90%;\n\tmax-width: 800px;\n\tmargin: 0 auto;\n"]),
    _templateObject2 = taggedTemplateLiteral(["\n\ttext-align: center;\n\tfont-family: ", ";\n\tfont-weight: normal;\n\tfont-size: 18px;\n\tcolor: ", ";\n"], ["\n\ttext-align: center;\n\tfont-family: ", ";\n\tfont-weight: normal;\n\tfont-size: 18px;\n\tcolor: ", ";\n"]);

var StyledArt = styled(ErrorSplash)(_templateObject);
var Header = styled.h1(_templateObject2, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.neutralDark["1"];
});

var ErrorSplash$1 = function ErrorSplash$$1() {
  return React.createElement("div", null, React.createElement(StyledArt, null), React.createElement(Header, null, "Something went very wrong. Get out of here quick!"));
};

var AppErrorBoundary = function (_React$Component) {
  inherits(AppErrorBoundary, _React$Component);

  function AppErrorBoundary() {
    classCallCheck(this, AppErrorBoundary);
    return possibleConstructorReturn(this, (AppErrorBoundary.__proto__ || Object.getPrototypeOf(AppErrorBoundary)).apply(this, arguments));
  }

  createClass(AppErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.props.setError({
        type: "render",
        error: error,
        info: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          error = _props.error,
          children = _props.children;
      if (error === false) return React.Children.only(children);
      return React.createElement(ErrorSplash$1, null);
    }
  }]);
  return AppErrorBoundary;
}(React.Component); // 7.1.4 ToInteger


var ceil$1 = Math.ceil;
var floor$4 = Math.floor;

var _toInteger$1 = function _toInteger$1(it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor$4 : ceil$1)(it);
}; // 7.2.1 RequireObjectCoercible(argument)


var _defined$1 = function _defined$1(it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
}; // true  -> String#at
// false -> String#codePointAt


var _stringAt$1 = function _stringAt$1(TO_STRING) {
  return function (that, pos) {
    var s = String(_defined$1(that));

    var i = _toInteger$1(pos);

    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _library$1 = true;

var _global$1 = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core$1 = createCommonjsModule(function (module) {
  var core = module.exports = {
    version: '2.6.2'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});

var _core_1$1 = _core$1.version;

var _aFunction$1 = function _aFunction$1(it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
}; // optional / simple context binding


var _ctx$1 = function _ctx$1(fn, that, length) {
  _aFunction$1(fn);

  if (that === undefined) return fn;

  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var _isObject$1 = function _isObject$1(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject$1 = function _anObject$1(it) {
  if (!_isObject$1(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails$1 = function _fails$1(exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
}; // Thank's IE8 for his funny defineProperty


var _descriptors$1 = !_fails$1(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

var document$3 = _global$1.document; // typeof document.createElement is 'object' in old IE

var is$2 = _isObject$1(document$3) && _isObject$1(document$3.createElement);

var _domCreate$1 = function _domCreate$1(it) {
  return is$2 ? document$3.createElement(it) : {};
};

var _ie8DomDefine$1 = !_descriptors$1 && !_fails$1(function () {
  return Object.defineProperty(_domCreate$1('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // 7.1.1 ToPrimitive(input [, PreferredType])
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string


var _toPrimitive$1 = function _toPrimitive$1(it, S) {
  if (!_isObject$1(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP$6 = Object.defineProperty;
var f$8 = _descriptors$1 ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject$1(O);

  P = _toPrimitive$1(P, true);

  _anObject$1(Attributes);

  if (_ie8DomDefine$1) try {
    return dP$6(O, P, Attributes);
  } catch (e) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var _objectDp$1 = {
  f: f$8
};

var _propertyDesc$1 = function _propertyDesc$1(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide$1 = _descriptors$1 ? function (object, key, value) {
  return _objectDp$1.f(object, key, _propertyDesc$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;

var _has$1 = function _has$1(it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE$3 = 'prototype';

var $export$1 = function $export$1(type, name, source) {
  var IS_FORCED = type & $export$1.F;
  var IS_GLOBAL = type & $export$1.G;
  var IS_STATIC = type & $export$1.S;
  var IS_PROTO = type & $export$1.P;
  var IS_BIND = type & $export$1.B;
  var IS_WRAP = type & $export$1.W;
  var exports = IS_GLOBAL ? _core$1 : _core$1[name] || (_core$1[name] = {});
  var expProto = exports[PROTOTYPE$3];
  var target = IS_GLOBAL ? _global$1 : IS_STATIC ? _global$1[name] : (_global$1[name] || {})[PROTOTYPE$3];
  var key, own, out;
  if (IS_GLOBAL) source = name;

  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has$1(exports, key)) continue; // export native or passed

    out = own ? target[key] : source[key]; // prevent global pollution for namespaces

    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
    : IS_BIND && own ? _ctx$1(out, _global$1) // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();

            case 1:
              return new C(a);

            case 2:
              return new C(a, b);
          }

          return new C(a, b, c);
        }

        return C.apply(this, arguments);
      };

      F[PROTOTYPE$3] = C[PROTOTYPE$3];
      return F; // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? _ctx$1(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

      if (type & $export$1.R && expProto && !expProto[key]) _hide$1(expProto, key, out);
    }
  }
}; // type bitmap


$export$1.F = 1; // forced

$export$1.G = 2; // global

$export$1.S = 4; // static

$export$1.P = 8; // proto

$export$1.B = 16; // bind

$export$1.W = 32; // wrap

$export$1.U = 64; // safe

$export$1.R = 128; // real proto method for `library`

var _export$1 = $export$1;
var _redefine$1 = _hide$1;
var _iterators$1 = {};
var toString$2 = {}.toString;

var _cof$1 = function _cof$1(it) {
  return toString$2.call(it).slice(8, -1);
}; // fallback for non-array-like ES3 and non-enumerable old V8 strings
// eslint-disable-next-line no-prototype-builtins


var _iobject$1 = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof$1(it) == 'String' ? it.split('') : Object(it);
}; // to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject$1 = function _toIobject$1(it) {
  return _iobject$1(_defined$1(it));
}; // 7.1.15 ToLength


var min$3 = Math.min;

var _toLength$1 = function _toLength$1(it) {
  return it > 0 ? min$3(_toInteger$1(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max$2 = Math.max;
var min$4 = Math.min;

var _toAbsoluteIndex$1 = function _toAbsoluteIndex$1(index, length) {
  index = _toInteger$1(index);
  return index < 0 ? max$2(index + length, 0) : min$4(index, length);
}; // false -> Array#indexOf
// true  -> Array#includes


var _arrayIncludes$1 = function _arrayIncludes$1(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject$1($this);

    var length = _toLength$1(O.length);

    var index = _toAbsoluteIndex$1(fromIndex, length);

    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }
    return !IS_INCLUDES && -1;
  };
};

var _shared$1 = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global$1[SHARED] || (_global$1[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core$1.version,
    mode: _library$1 ? 'pure' : 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var id$2 = 0;
var px$1 = Math.random();

var _uid$1 = function _uid$1(key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$2 + px$1).toString(36));
};

var shared$1 = _shared$1('keys');

var _sharedKey$1 = function _sharedKey$1(key) {
  return shared$1[key] || (shared$1[key] = _uid$1(key));
};

var arrayIndexOf$1 = _arrayIncludes$1(false);

var IE_PROTO$3 = _sharedKey$1('IE_PROTO');

var _objectKeysInternal$1 = function _objectKeysInternal$1(object, names) {
  var O = _toIobject$1(object);

  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    if (key != IE_PROTO$3) _has$1(O, key) && result.push(key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (_has$1(O, key = names[i++])) {
      ~arrayIndexOf$1(result, key) || result.push(key);
    }
  }

  return result;
}; // IE 8- don't enum bug keys


var _enumBugKeys$1 = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(','); // 19.1.2.14 / 15.2.3.14 Object.keys(O)


var _objectKeys$1 = Object.keys || function keys(O) {
  return _objectKeysInternal$1(O, _enumBugKeys$1);
};

var _objectDps$1 = _descriptors$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject$1(O);

  var keys = _objectKeys$1(Properties);

  var length = keys.length;
  var i = 0;
  var P;

  while (length > i) {
    _objectDp$1.f(O, P = keys[i++], Properties[P]);
  }

  return O;
};

var document$4 = _global$1.document;

var _html$1 = document$4 && document$4.documentElement; // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


var IE_PROTO$4 = _sharedKey$1('IE_PROTO');

var Empty$1 = function Empty$1() {
  /* empty */
};

var PROTOTYPE$4 = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

var _createDict$ = function createDict$1() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate$1('iframe');

  var i = _enumBugKeys$1.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';

  _html$1.appendChild(iframe);

  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);

  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict$ = iframeDocument.F;

  while (i--) {
    delete _createDict$[PROTOTYPE$4][_enumBugKeys$1[i]];
  }

  return _createDict$();
};

var _objectCreate$1 = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    Empty$1[PROTOTYPE$4] = _anObject$1(O);
    result = new Empty$1();
    Empty$1[PROTOTYPE$4] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$4] = O;
  } else result = _createDict$();

  return Properties === undefined ? result : _objectDps$1(result, Properties);
};

var _wks$1 = createCommonjsModule(function (module) {
  var store = _shared$1('wks');

  var Symbol = _global$1.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid$1)('Symbol.' + name));
  };

  $exports.store = store;
});

var def$1 = _objectDp$1.f;

var TAG$2 = _wks$1('toStringTag');

var _setToStringTag$1 = function _setToStringTag$1(it, tag, stat) {
  if (it && !_has$1(it = stat ? it : it.prototype, TAG$2)) def$1(it, TAG$2, {
    configurable: true,
    value: tag
  });
};

var IteratorPrototype$1 = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

_hide$1(IteratorPrototype$1, _wks$1('iterator'), function () {
  return this;
});

var _iterCreate$1 = function _iterCreate$1(Constructor, NAME, next) {
  Constructor.prototype = _objectCreate$1(IteratorPrototype$1, {
    next: _propertyDesc$1(1, next)
  });

  _setToStringTag$1(Constructor, NAME + ' Iterator');
}; // 7.1.13 ToObject(argument)


var _toObject$1 = function _toObject$1(it) {
  return Object(_defined$1(it));
}; // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$5 = _sharedKey$1('IE_PROTO');

var ObjectProto$2 = Object.prototype;

var _objectGpo$1 = Object.getPrototypeOf || function (O) {
  O = _toObject$1(O);
  if (_has$1(O, IE_PROTO$5)) return O[IE_PROTO$5];

  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? ObjectProto$2 : null;
};

var ITERATOR$5 = _wks$1('iterator');

var BUGGY$1 = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

var FF_ITERATOR$1 = '@@iterator';
var KEYS$1 = 'keys';
var VALUES$1 = 'values';

var returnThis$1 = function returnThis$1() {
  return this;
};

var _iterDefine$1 = function _iterDefine$1(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate$1(Constructor, NAME, next);

  var getMethod = function getMethod(kind) {
    if (!BUGGY$1 && kind in proto) return proto[kind];

    switch (kind) {
      case KEYS$1:
        return function keys() {
          return new Constructor(this, kind);
        };

      case VALUES$1:
        return function values() {
          return new Constructor(this, kind);
        };
    }

    return function entries() {
      return new Constructor(this, kind);
    };
  };

  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES$1;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR$5] || proto[FF_ITERATOR$1] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype; // Fix native

  if ($anyNative) {
    IteratorPrototype = _objectGpo$1($anyNative.call(new Base()));

    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag$1(IteratorPrototype, TAG, true); // fix for some old engines


      if (!_library$1 && typeof IteratorPrototype[ITERATOR$5] != 'function') _hide$1(IteratorPrototype, ITERATOR$5, returnThis$1);
    }
  } // fix Array#{values, @@iterator}.name in V8 / FF


  if (DEF_VALUES && $native && $native.name !== VALUES$1) {
    VALUES_BUG = true;

    $default = function values() {
      return $native.call(this);
    };
  } // Define iterator


  if ((!_library$1 || FORCED) && (BUGGY$1 || VALUES_BUG || !proto[ITERATOR$5])) {
    _hide$1(proto, ITERATOR$5, $default);
  } // Plug for library


  _iterators$1[NAME] = $default;
  _iterators$1[TAG] = returnThis$1;

  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES$1),
      keys: IS_SET ? $default : getMethod(KEYS$1),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine$1(proto, key, methods[key]);
    } else _export$1(_export$1.P + _export$1.F * (BUGGY$1 || VALUES_BUG), NAME, methods);
  }

  return methods;
};

var $at$2 = _stringAt$1(true); // 21.1.3.27 String.prototype[@@iterator]()


_iterDefine$1(String, 'String', function (iterated) {
  this._t = String(iterated); // target

  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at$2(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

var _iterStep$1 = function _iterStep$1(done, value) {
  return {
    value: value,
    done: !!done
  };
}; // 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()


var es6_array_iterator$1 = _iterDefine$1(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject$1(iterated); // target

  this._i = 0; // next index

  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;

  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep$1(1);
  }

  if (kind == 'keys') return _iterStep$1(0, index);
  if (kind == 'values') return _iterStep$1(0, O[index]);
  return _iterStep$1(0, [index, O[index]]);
}, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)


_iterators$1.Arguments = _iterators$1.Array;

var TO_STRING_TAG$1 = _wks$1('toStringTag');

var DOMIterables$1 = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i$3 = 0; i$3 < DOMIterables$1.length; i$3++) {
  var NAME$2 = DOMIterables$1[i$3];
  var Collection$1 = _global$1[NAME$2];
  var proto$4 = Collection$1 && Collection$1.prototype;
  if (proto$4 && !proto$4[TO_STRING_TAG$1]) _hide$1(proto$4, TO_STRING_TAG$1, NAME$2);
  _iterators$1[NAME$2] = _iterators$1.Array;
}

var f$9 = _wks$1;
var _wksExt$1 = {
  f: f$9
};

var iterator = _wksExt$1.f('iterator');

var iterator$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": iterator,
    __esModule: true
  };
});
unwrapExports(iterator$1);

var _meta$1 = createCommonjsModule(function (module) {
  var META = _uid$1('meta');

  var setDesc = _objectDp$1.f;
  var id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !_fails$1(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!_isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!_has$1(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!_has$1(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !_has$1(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
});

var _meta_1$1 = _meta$1.KEY;
var _meta_2$1 = _meta$1.NEED;
var _meta_3$1 = _meta$1.fastKey;
var _meta_4$1 = _meta$1.getWeak;
var _meta_5$1 = _meta$1.onFreeze;
var defineProperty$4 = _objectDp$1.f;

var _wksDefine$1 = function _wksDefine$1(name) {
  var $Symbol = _core$1.Symbol || (_core$1.Symbol = {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$4($Symbol, name, {
    value: _wksExt$1.f(name)
  });
};

var f$a = Object.getOwnPropertySymbols;
var _objectGops$1 = {
  f: f$a
};
var f$b = {}.propertyIsEnumerable;
var _objectPie$1 = {
  f: f$b
}; // all enumerable object keys, includes symbols

var _enumKeys$1 = function _enumKeys$1(it) {
  var result = _objectKeys$1(it);

  var getSymbols = _objectGops$1.f;

  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie$1.f;
    var i = 0;
    var key;

    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }

  return result;
}; // 7.2.2 IsArray(argument)


var _isArray$1 = Array.isArray || function isArray(arg) {
  return _cof$1(arg) == 'Array';
}; // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)


var hiddenKeys$1 = _enumBugKeys$1.concat('length', 'prototype');

var f$c = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal$1(O, hiddenKeys$1);
};

var _objectGopn$1 = {
  f: f$c
}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN$4 = _objectGopn$1.f;
var toString$3 = {}.toString;
var windowNames$1 = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames$1 = function getWindowNames$1(it) {
  try {
    return gOPN$4(it);
  } catch (e) {
    return windowNames$1.slice();
  }
};

var f$d = function getOwnPropertyNames(it) {
  return windowNames$1 && toString$3.call(it) == '[object Window]' ? getWindowNames$1(it) : gOPN$4(_toIobject$1(it));
};

var _objectGopnExt$1 = {
  f: f$d
};
var gOPD$4 = Object.getOwnPropertyDescriptor;
var f$e = _descriptors$1 ? gOPD$4 : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject$1(O);
  P = _toPrimitive$1(P, true);
  if (_ie8DomDefine$1) try {
    return gOPD$4(O, P);
  } catch (e) {
    /* empty */
  }
  if (_has$1(O, P)) return _propertyDesc$1(!_objectPie$1.f.call(O, P), O[P]);
};
var _objectGopd$1 = {
  f: f$e
}; // ECMAScript 6 symbols shim

var META$1 = _meta$1.KEY;
var gOPD$5 = _objectGopd$1.f;
var dP$7 = _objectDp$1.f;
var gOPN$5 = _objectGopnExt$1.f;
var $Symbol$1 = _global$1.Symbol;
var $JSON$1 = _global$1.JSON;

var _stringify$1 = $JSON$1 && $JSON$1.stringify;

var PROTOTYPE$5 = 'prototype';

var HIDDEN$1 = _wks$1('_hidden');

var TO_PRIMITIVE$2 = _wks$1('toPrimitive');

var isEnum$2 = {}.propertyIsEnumerable;

var SymbolRegistry$1 = _shared$1('symbol-registry');

var AllSymbols$1 = _shared$1('symbols');

var OPSymbols$1 = _shared$1('op-symbols');

var ObjectProto$3 = Object[PROTOTYPE$5];
var USE_NATIVE$2 = typeof $Symbol$1 == 'function';
var QObject$1 = _global$1.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

var setter$1 = !QObject$1 || !QObject$1[PROTOTYPE$5] || !QObject$1[PROTOTYPE$5].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

var setSymbolDesc$1 = _descriptors$1 && _fails$1(function () {
  return _objectCreate$1(dP$7({}, 'a', {
    get: function get() {
      return dP$7(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$5(ObjectProto$3, key);
  if (protoDesc) delete ObjectProto$3[key];
  dP$7(it, key, D);
  if (protoDesc && it !== ObjectProto$3) dP$7(ObjectProto$3, key, protoDesc);
} : dP$7;

var wrap$2 = function wrap$2(tag) {
  var sym = AllSymbols$1[tag] = _objectCreate$1($Symbol$1[PROTOTYPE$5]);

  sym._k = tag;
  return sym;
};

var isSymbol$1 = USE_NATIVE$2 && typeof $Symbol$1.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol$1;
};

var $defineProperty$1 = function defineProperty(it, key, D) {
  if (it === ObjectProto$3) $defineProperty$1(OPSymbols$1, key, D);

  _anObject$1(it);

  key = _toPrimitive$1(key, true);

  _anObject$1(D);

  if (_has$1(AllSymbols$1, key)) {
    if (!D.enumerable) {
      if (!_has$1(it, HIDDEN$1)) dP$7(it, HIDDEN$1, _propertyDesc$1(1, {}));
      it[HIDDEN$1][key] = true;
    } else {
      if (_has$1(it, HIDDEN$1) && it[HIDDEN$1][key]) it[HIDDEN$1][key] = false;
      D = _objectCreate$1(D, {
        enumerable: _propertyDesc$1(0, false)
      });
    }

    return setSymbolDesc$1(it, key, D);
  }

  return dP$7(it, key, D);
};

var $defineProperties$1 = function defineProperties(it, P) {
  _anObject$1(it);

  var keys = _enumKeys$1(P = _toIobject$1(P));

  var i = 0;
  var l = keys.length;
  var key;

  while (l > i) {
    $defineProperty$1(it, key = keys[i++], P[key]);
  }

  return it;
};

var $create$1 = function create(it, P) {
  return P === undefined ? _objectCreate$1(it) : $defineProperties$1(_objectCreate$1(it), P);
};

var $propertyIsEnumerable$1 = function propertyIsEnumerable(key) {
  var E = isEnum$2.call(this, key = _toPrimitive$1(key, true));
  if (this === ObjectProto$3 && _has$1(AllSymbols$1, key) && !_has$1(OPSymbols$1, key)) return false;
  return E || !_has$1(this, key) || !_has$1(AllSymbols$1, key) || _has$1(this, HIDDEN$1) && this[HIDDEN$1][key] ? E : true;
};

var $getOwnPropertyDescriptor$2 = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject$1(it);
  key = _toPrimitive$1(key, true);
  if (it === ObjectProto$3 && _has$1(AllSymbols$1, key) && !_has$1(OPSymbols$1, key)) return;
  var D = gOPD$5(it, key);
  if (D && _has$1(AllSymbols$1, key) && !(_has$1(it, HIDDEN$1) && it[HIDDEN$1][key])) D.enumerable = true;
  return D;
};

var $getOwnPropertyNames$1 = function getOwnPropertyNames(it) {
  var names = gOPN$5(_toIobject$1(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (!_has$1(AllSymbols$1, key = names[i++]) && key != HIDDEN$1 && key != META$1) result.push(key);
  }

  return result;
};

var $getOwnPropertySymbols$1 = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$3;
  var names = gOPN$5(IS_OP ? OPSymbols$1 : _toIobject$1(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (_has$1(AllSymbols$1, key = names[i++]) && (IS_OP ? _has$1(ObjectProto$3, key) : true)) result.push(AllSymbols$1[key]);
  }

  return result;
}; // 19.4.1.1 Symbol([description])


if (!USE_NATIVE$2) {
  $Symbol$1 = function Symbol() {
    if (this instanceof $Symbol$1) throw TypeError('Symbol is not a constructor!');

    var tag = _uid$1(arguments.length > 0 ? arguments[0] : undefined);

    var $set = function $set(value) {
      if (this === ObjectProto$3) $set.call(OPSymbols$1, value);
      if (_has$1(this, HIDDEN$1) && _has$1(this[HIDDEN$1], tag)) this[HIDDEN$1][tag] = false;
      setSymbolDesc$1(this, tag, _propertyDesc$1(1, value));
    };

    if (_descriptors$1 && setter$1) setSymbolDesc$1(ObjectProto$3, tag, {
      configurable: true,
      set: $set
    });
    return wrap$2(tag);
  };

  _redefine$1($Symbol$1[PROTOTYPE$5], 'toString', function toString() {
    return this._k;
  });

  _objectGopd$1.f = $getOwnPropertyDescriptor$2;
  _objectDp$1.f = $defineProperty$1;
  _objectGopn$1.f = _objectGopnExt$1.f = $getOwnPropertyNames$1;
  _objectPie$1.f = $propertyIsEnumerable$1;
  _objectGops$1.f = $getOwnPropertySymbols$1;

  if (_descriptors$1 && !_library$1) {
    _redefine$1(ObjectProto$3, 'propertyIsEnumerable', $propertyIsEnumerable$1, true);
  }

  _wksExt$1.f = function (name) {
    return wrap$2(_wks$1(name));
  };
}

_export$1(_export$1.G + _export$1.W + _export$1.F * !USE_NATIVE$2, {
  Symbol: $Symbol$1
});

for (var es6Symbols$1 = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j$2 = 0; es6Symbols$1.length > j$2;) {
  _wks$1(es6Symbols$1[j$2++]);
}

for (var wellKnownSymbols$1 = _objectKeys$1(_wks$1.store), k$1 = 0; wellKnownSymbols$1.length > k$1;) {
  _wksDefine$1(wellKnownSymbols$1[k$1++]);
}

_export$1(_export$1.S + _export$1.F * !USE_NATIVE$2, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return _has$1(SymbolRegistry$1, key += '') ? SymbolRegistry$1[key] : SymbolRegistry$1[key] = $Symbol$1(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol$1(sym)) throw TypeError(sym + ' is not a symbol!');

    for (var key in SymbolRegistry$1) {
      if (SymbolRegistry$1[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter$1 = true;
  },
  useSimple: function useSimple() {
    setter$1 = false;
  }
});

_export$1(_export$1.S + _export$1.F * !USE_NATIVE$2, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create$1,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty$1,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties$1,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$2,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames$1,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols$1
}); // 24.3.2 JSON.stringify(value [, replacer [, space]])


$JSON$1 && _export$1(_export$1.S + _export$1.F * (!USE_NATIVE$2 || _fails$1(function () {
  var S = $Symbol$1(); // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols

  return _stringify$1([S]) != '[null]' || _stringify$1({
    a: S
  }) != '{}' || _stringify$1(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;

    while (arguments.length > i) {
      args.push(arguments[i++]);
    }

    $replacer = replacer = args[1];
    if (!_isObject$1(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined

    if (!_isArray$1(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol$1(value)) return value;
    };
    args[1] = replacer;
    return _stringify$1.apply($JSON$1, args);
  }
}); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

$Symbol$1[PROTOTYPE$5][TO_PRIMITIVE$2] || _hide$1($Symbol$1[PROTOTYPE$5], TO_PRIMITIVE$2, $Symbol$1[PROTOTYPE$5].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

_setToStringTag$1($Symbol$1, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]


_setToStringTag$1(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]


_setToStringTag$1(_global$1.JSON, 'JSON', true);

_wksDefine$1('asyncIterator');

_wksDefine$1('observable');

var symbol = _core$1.Symbol;
var symbol$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": symbol,
    __esModule: true
  };
});
unwrapExports(symbol$1);

var _typeof_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _iterator2 = _interopRequireDefault(iterator$1);

  var _symbol2 = _interopRequireDefault(symbol$1);

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
  };

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
});

unwrapExports(_typeof_1); // 19.1.2.1 Object.assign(target, source, ...)

var $assign$1 = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

var _objectAssign$1 = !$assign$1 || _fails$1(function () {
  var A = {};
  var B = {}; // eslint-disable-next-line no-undef

  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign$1({}, A)[S] != 7 || Object.keys($assign$1({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = _toObject$1(target);

  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops$1.f;
  var isEnum = _objectPie$1.f;

  while (aLen > index) {
    var S = _iobject$1(arguments[index++]);

    var keys = getSymbols ? _objectKeys$1(S).concat(getSymbols(S)) : _objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }

  return T;
} : $assign$1; // 19.1.3.1 Object.assign(target, source)


_export$1(_export$1.S + _export$1.F, 'Object', {
  assign: _objectAssign$1
});

var assign = _core$1.Object.assign;
var assign$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": assign,
    __esModule: true
  };
});
unwrapExports(assign$1);
var classCallCheck$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
});
unwrapExports(classCallCheck$1); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)

_export$1(_export$1.S + _export$1.F * !_descriptors$1, 'Object', {
  defineProperty: _objectDp$1.f
});

var $Object = _core$1.Object;

var defineProperty$5 = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$6 = createCommonjsModule(function (module) {
  module.exports = {
    "default": defineProperty$5,
    __esModule: true
  };
});
unwrapExports(defineProperty$6);
var createClass$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _defineProperty2 = _interopRequireDefault(defineProperty$6);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
});
unwrapExports(createClass$1);
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$1 = _freeGlobal || freeSelf || Function('return this')();
var _root = root$1;
/** Built-in value references. */

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$2.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);

  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;
/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;
/** Used for built-in method references. */

var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);

  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

var defineProperty$8 = function () {
  try {
    var func = _getNative(Object, 'defineProperty');

    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty$1 = defineProperty$8;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

var _createBaseFor = createBaseFor;
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */

var baseFor = _createBaseFor();

var _baseFor = baseFor;
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$3.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
var isArray_1 = isArray;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;
var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && _freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  module.exports = nodeUtil;
});
/* Node.js helper references. */


var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$4.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    _isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$5;
  return value === proto;
}

var _isPrototype = isPrototype;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$6.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys$2(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$2;
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */

function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf;
/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}

var _stackClear = stackClear;
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;
/* Built-in method references that are verified to be native. */

var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;
/* Built-in method references that are verified to be native. */

var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$7.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;
/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$8.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$8.call(data, key);
}

var _hashHas = hashHas;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);

  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof _ListCache) {
    var pairs = data.__data__;

    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new _MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);

  return this;
}

var _setCacheAdd = setCacheAdd;
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new _MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;
var _SetCache = SetCache;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

var _arraySome = arraySome;
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Assume cyclic values are equal.


  var stacked = stack.get(array);

  if (stacked && stack.get(other)) {
    return stacked == other;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new _SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!_arraySome(other, function (othValue, othIndex) {
        if (!_cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;
/** Built-in value references. */

var Uint8Array = _root.Uint8Array;
var _Uint8Array = Uint8Array;
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;
/** `Object#toString` result references. */

var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }

      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag$1:
      var convert = _mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG$1; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);

      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);

      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

  }

  return false;
}

var _equalByTag = equalByTag;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter;
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray() {
  return [];
}

var stubArray_1 = stubArray;
/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$2 = 1;
/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty$9.call(other, key))) {
      return false;
    }
  } // Assume cyclic values are equal.


  var stacked = stack.get(object);

  if (stacked && stack.get(other)) {
    return stacked == other;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;
/* Built-in method references that are verified to be native. */

var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;
/* Built-in method references that are verified to be native. */

var Promise$2 = _getNative(_root, 'Promise');

var _Promise = Promise$2;
/* Built-in method references that are verified to be native. */

var Set = _getNative(_root, 'Set');

var _Set = Set;
/* Built-in method references that are verified to be native. */

var WeakMap$1 = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap$1;
/** `Object#toString` result references. */

var mapTag$2 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */


var getTag = _baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2 || _Map && getTag(new _Map()) != mapTag$2 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$2 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;

        case mapCtorString:
          return mapTag$2;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$2;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var _getTag = getTag;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$3 = 1;
/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';
/** Used for built-in method references. */

var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$b.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);
  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;
  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack());
    return objIsArr || isTypedArray_1(object) ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack) : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$a.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$a.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new _Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new _Stack());
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */

function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike_1(value) && !isObjectLike_1(other)) {
    return value !== value && other !== other;
  }

  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */

function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }

  object = Object(object);

  while (index--) {
    var data = matchData[index];

    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }

  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack();

      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }

      if (!(result === undefined ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack) : result)) {
        return false;
      }
    }
  }

  return true;
}

var _baseIsMatch = baseIsMatch;
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */

function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */

function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, _isStrictComparable(value)];
  }

  return result;
}

var _getMatchData = getMatchData;
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }

    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

var _matchesStrictComparable = matchesStrictComparable;
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatches(source) {
  var matchData = _getMatchData(source);

  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }

  return function (object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;
/** `Object#toString` result references. */

var symbolTag$1 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$2(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1;
}

var isSymbol_1 = isSymbol$2;
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = _MapCache;
var memoize_1 = memoize;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize_1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;
/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = _memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
      result.push('');
    }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

var _stringToPath = stringToPath;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }

  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _baseToString = baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString$4(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString$4;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }

  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _toKey = toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = _castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get$2(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$2;
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */

function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);
  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result || ++index != length) {
    return result;
  }

  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) && (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */

function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;
/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }

  return function (object) {
    var objValue = get_1(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn_1(object, path) : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity(value) {
  return value;
}

var identity_1 = identity;
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyDeep(path) {
  return function (object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */

function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */

function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }

  if (value == null) {
    return identity_1;
  }

  if (typeof value == 'object') {
    return isArray_1(value) ? _baseMatchesProperty(value[0], value[1]) : _baseMatches(value);
  }

  return property_1(value);
}

var _baseIteratee = baseIteratee;
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */

function mapValues(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function (value, key, object) {
    _baseAssignValue(result, key, iteratee(value, key, object));
  });

  return result;
}

var mapValues_1 = mapValues; // most Object methods by ES6 should accept primitives

var _objectSap$1 = function _objectSap$1(KEY, exec) {
  var fn = (_core$1.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);

  _export$1(_export$1.S + _export$1.F * _fails$1(function () {
    fn(1);
  }), 'Object', exp);
}; // 19.1.2.14 Object.keys(O)


_objectSap$1('keys', function () {
  return function keys(it) {
    return _objectKeys$1(_toObject$1(it));
  };
});

var keys$3 = _core$1.Object.keys;
var keys$4 = createCommonjsModule(function (module) {
  module.exports = {
    "default": keys$3,
    __esModule: true
  };
});
unwrapExports(keys$4); // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $getOwnPropertyDescriptor$3 = _objectGopd$1.f;

_objectSap$1('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor$3(_toIobject$1(it), key);
  };
});

var $Object$1 = _core$1.Object;

var getOwnPropertyDescriptor$2 = function getOwnPropertyDescriptor(it, key) {
  return $Object$1.getOwnPropertyDescriptor(it, key);
};

var getOwnPropertyDescriptor$3 = createCommonjsModule(function (module) {
  module.exports = {
    "default": getOwnPropertyDescriptor$2,
    __esModule: true
  };
});
unwrapExports(getOwnPropertyDescriptor$3); // 19.1.2.9 Object.getPrototypeOf(O)

_objectSap$1('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return _objectGpo$1(_toObject$1(it));
  };
});

var getPrototypeOf$2 = _core$1.Object.getPrototypeOf;
var getPrototypeOf$3 = createCommonjsModule(function (module) {
  module.exports = {
    "default": getPrototypeOf$2,
    __esModule: true
  };
});
unwrapExports(getPrototypeOf$3);
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */

function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */

function forOwn(object, iteratee) {
  return object && _baseForOwn(object, _castFunction(iteratee));
}

var forOwn_1 = forOwn;
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }

  return -1;
}

var _baseFindIndex = baseFindIndex;
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN;
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }

  return -1;
}

var _strictIndexOf = strictIndexOf;
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseIndexOf(array, value, fromIndex) {
  return value === value ? _strictIndexOf(array, value, fromIndex) : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf;
/** `Object#toString` result references. */

var stringTag$2 = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */

function isString(value) {
  return typeof value == 'string' || !isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$2;
}

var isString_1 = isString;
/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */

var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol_1(value)) {
    return NAN;
  }

  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber$1;
/** Used as references for various `Number` constants. */

var INFINITY$2 = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */

function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }

  value = toNumber_1(value);

  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }

  return value === value ? value : 0;
}

var toFinite_1 = toFinite;
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */

function toInteger(value) {
  var result = toFinite_1(value),
      remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

var toInteger_1 = toInteger;
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */

function baseValues(object, props) {
  return _arrayMap(props, function (key) {
    return object[key];
  });
}

var _baseValues = baseValues;
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */

function values$1(object) {
  return object == null ? [] : _baseValues(object, keys_1(object));
}

var values_1 = values$1;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */

function includes$1(collection, value, fromIndex, guard) {
  collection = isArrayLike_1(collection) ? collection : values_1(collection);
  fromIndex = fromIndex && !guard ? toInteger_1(fromIndex) : 0;
  var length = collection.length;

  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }

  return isString_1(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && _baseIndexOf(collection, value, fromIndex) > -1;
}

var includes_1 = includes$1; // call something on iterator step with safe closing on error

var _iterCall$1 = function _iterCall$1(iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject$1(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject$1(ret.call(iterator));
    throw e;
  }
}; // check on default Array iterator


var ITERATOR$6 = _wks$1('iterator');

var ArrayProto$2 = Array.prototype;

var _isArrayIter$1 = function _isArrayIter$1(it) {
  return it !== undefined && (_iterators$1.Array === it || ArrayProto$2[ITERATOR$6] === it);
};

var _createProperty$1 = function _createProperty$1(object, index, value) {
  if (index in object) _objectDp$1.f(object, index, _propertyDesc$1(0, value));else object[index] = value;
}; // getting tag from 19.1.3.6 Object.prototype.toString()


var TAG$3 = _wks$1('toStringTag'); // ES3 wrong here


var ARG$1 = _cof$1(function () {
  return arguments;
}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

var tryGet$1 = function tryGet$1(it, key) {
  try {
    return it[key];
  } catch (e) {
    /* empty */
  }
};

var _classof$1 = function _classof$1(it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
  : typeof (T = tryGet$1(O = Object(it), TAG$3)) == 'string' ? T // builtinTag case
  : ARG$1 ? _cof$1(O) // ES3 arguments fallback
  : (B = _cof$1(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$7 = _wks$1('iterator');

var core_getIteratorMethod$1 = _core$1.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$7] || it['@@iterator'] || _iterators$1[_classof$1(it)];
};

var ITERATOR$8 = _wks$1('iterator');

var SAFE_CLOSING$1 = false;

try {
  var riter$1 = [7][ITERATOR$8]();

  riter$1['return'] = function () {
    SAFE_CLOSING$1 = true;
  };
} catch (e) {
  /* empty */
}

var _iterDetect$1 = function _iterDetect$1(exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING$1) return false;
  var safe = false;

  try {
    var arr = [7];
    var iter = arr[ITERATOR$8]();

    iter.next = function () {
      return {
        done: safe = true
      };
    };

    arr[ITERATOR$8] = function () {
      return iter;
    };

    exec(arr);
  } catch (e) {
    /* empty */
  }

  return safe;
};

_export$1(_export$1.S + _export$1.F * !_iterDetect$1(function (iter) {}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike
  /* , mapfn = undefined, thisArg = undefined */
  ) {
    var O = _toObject$1(arrayLike);

    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod$1(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx$1(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

    if (iterFn != undefined && !(C == Array && _isArrayIter$1(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty$1(result, index, mapping ? _iterCall$1(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength$1(O.length);

      for (result = new C(length); length > index; index++) {
        _createProperty$1(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }

    result.length = index;
    return result;
  }
});

var from_1 = _core$1.Array.from;
var from_1$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": from_1,
    __esModule: true
  };
});
unwrapExports(from_1$1);
var toConsumableArray$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _from2 = _interopRequireDefault(from_1$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  };
});
unwrapExports(toConsumableArray$1);

var _isPlaceholder = function _isPlaceholder(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
};
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


var _curry1 = function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
};

var _arity = function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };

    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };

    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };

    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };

    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };

    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };

    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };

    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };

    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };

    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };

    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };

    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
};
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


var _curry2 = function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;

      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
};
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */


var _curryN = function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;

    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;

      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }

      combined[combinedIdx] = result;

      if (!_isPlaceholder(result)) {
        left -= 1;
      }

      combinedIdx += 1;
    }

    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
  };
};
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value `R.__` may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
 * following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */


var curryN = _curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }

  return _arity(length, _curryN(length, [], fn));
});
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value `R.__` may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
 * following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */


var curry = _curry1(function curry(fn) {
  return curryN(fn.length, fn);
});
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */


var __ = {
  '@@functional/placeholder': true
};
var lib$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ops = exports.getBatchToken = undefined;

  var _toConsumableArray3 = _interopRequireDefault(toConsumableArray$1);

  var _assign2 = _interopRequireDefault(assign$1);

  var _defineProperty2 = _interopRequireDefault(defineProperty$6);

  var _symbol2 = _interopRequireDefault(symbol$1);

  var _typeof3 = _interopRequireDefault(_typeof_1);

  exports.canMutate = canMutate;
  exports.getImmutableOps = getImmutableOps;

  var _curry2 = _interopRequireDefault(curry);

  var _2 = _interopRequireDefault(__);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function forOwn(obj, fn) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        fn(obj[key], key);
      }
    }
  }

  function isArrayLike(value) {
    return value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && typeof value.length === 'number' && value.length >= 0 && value.length % 1 === 0;
  }

  var OWNER_ID_TAG = '@@_______immutableOpsOwnerID';

  function fastArrayCopy(arr) {
    var copied = new Array(arr.length);

    for (var i = 0; i < arr.length; i++) {
      copied[i] = arr[i];
    }

    return copied;
  }

  function canMutate(obj, ownerID) {
    if (!ownerID) return false;
    return obj[OWNER_ID_TAG] === ownerID;
  }

  var newOwnerID = typeof _symbol2.default === 'function' ? function () {
    return (0, _symbol2.default)('ownerID');
  } : function () {
    return {};
  };
  var getBatchToken = exports.getBatchToken = newOwnerID;

  function addOwnerID(obj, ownerID) {
    (0, _defineProperty2.default)(obj, OWNER_ID_TAG, {
      value: ownerID,
      configurable: true,
      enumerable: false
    });
    return obj;
  }

  function prepareNewObject(instance, ownerID) {
    if (ownerID) {
      addOwnerID(instance, ownerID);
    }

    return instance;
  }

  function forceArray(arg) {
    if (!(arg instanceof Array)) {
      return [arg];
    }

    return arg;
  }

  var PATH_SEPARATOR = '.';

  function normalizePath(pathArg) {
    if (typeof pathArg === 'string') {
      if (pathArg.indexOf(PATH_SEPARATOR) === -1) {
        return [pathArg];
      }

      return pathArg.split(PATH_SEPARATOR);
    }

    return pathArg;
  }

  function mutableSet(key, value, obj) {
    obj[key] = value;
    return obj;
  }

  function mutableSetIn(_pathArg, value, obj) {
    var originalPathArg = normalizePath(_pathArg);
    var pathLen = originalPathArg.length;
    var done = false;
    var idx = 0;
    var acc = obj;
    var curr = originalPathArg[idx];

    while (!done) {
      if (idx === pathLen - 1) {
        acc[curr] = value;
        done = true;
      } else {
        var currType = (0, _typeof3.default)(acc[curr]);

        if (currType === 'undefined') {
          var newObj = {};
          prepareNewObject(newObj, null);
          acc[curr] = newObj;
        } else if (currType !== 'object') {
          var pathRepr = originalPathArg[idx - 1] + '.' + curr;
          throw new Error('A non-object value was encountered when traversing setIn path at ' + pathRepr + '.');
        }

        acc = acc[curr];
        idx++;
        curr = originalPathArg[idx];
      }
    }

    return obj;
  }

  function valueInPath(_pathArg, obj) {
    var pathArg = normalizePath(_pathArg);
    var acc = obj;

    for (var i = 0; i < pathArg.length; i++) {
      var curr = pathArg[i];
      var currRef = acc[curr];

      if (i === pathArg.length - 1) {
        return currRef;
      }

      if ((typeof currRef === 'undefined' ? 'undefined' : (0, _typeof3.default)(currRef)) === 'object') {
        acc = currRef;
      } else {
        return undefined;
      }
    }
  }

  function immutableSetIn(ownerID, _pathArg, value, obj) {
    var pathArg = normalizePath(_pathArg);
    var currentValue = valueInPath(pathArg, obj);
    if (value === currentValue) return obj;
    var pathLen = pathArg.length;
    var acc = void 0;

    if (canMutate(obj, ownerID)) {
      acc = obj;
    } else {
      acc = (0, _assign2.default)(prepareNewObject({}, ownerID), obj);
    }

    var rootObj = acc;
    pathArg.forEach(function (curr, idx) {
      if (idx === pathLen - 1) {
        acc[curr] = value;
        return;
      }

      var currRef = acc[curr];
      var currType = typeof currRef === 'undefined' ? 'undefined' : (0, _typeof3.default)(currRef);

      if (currType === 'object') {
        if (canMutate(currRef, ownerID)) {
          acc = currRef;
        } else {
          var newObj = prepareNewObject({}, ownerID);
          acc[curr] = (0, _assign2.default)(newObj, currRef);
          acc = newObj;
        }

        return;
      }

      if (currType === 'undefined') {
        var _newObj = prepareNewObject({}, ownerID);

        acc[curr] = _newObj;
        acc = _newObj;
        return;
      }

      var pathRepr = pathArg[idx - 1] + '.' + curr;
      throw new Error('A non-object value was encountered when traversing setIn path at ' + pathRepr + '.');
    });
    return rootObj;
  }

  function mutableMerge(isDeep, _mergeObjs, baseObj) {
    var mergeObjs = forceArray(_mergeObjs);

    if (isDeep) {
      mergeObjs.forEach(function (mergeObj) {
        forOwn(mergeObj, function (value, key) {
          if (isDeep && baseObj.hasOwnProperty(key)) {
            var assignValue = void 0;

            if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
              assignValue = mutableMerge(isDeep, [value], baseObj[key]);
            } else {
              assignValue = value;
            }

            baseObj[key] = assignValue;
          } else {
            baseObj[key] = value;
          }
        });
      });
    } else {
      _assign2.default.apply(Object, [baseObj].concat((0, _toConsumableArray3.default)(mergeObjs)));
    }

    return baseObj;
  }

  var mutableShallowMerge = mutableMerge.bind(null, false);
  var mutableDeepMerge = mutableMerge.bind(null, true);

  function mutableOmit(_keys, obj) {
    var keys = forceArray(_keys);
    keys.forEach(function (key) {
      delete obj[key];
    });
    return obj;
  }

  function _shouldMergeKey(obj, other, key) {
    return obj[key] !== other[key];
  }

  function immutableMerge(isDeep, ownerID, _mergeObjs, obj) {
    if (canMutate(obj, ownerID)) return mutableMerge(isDeep, _mergeObjs, obj);
    var mergeObjs = forceArray(_mergeObjs);
    var hasChanges = false;
    var nextObject = obj;

    var willChange = function willChange() {
      if (!hasChanges) {
        hasChanges = true;
        nextObject = (0, _assign2.default)({}, obj);
        prepareNewObject(nextObject, ownerID);
      }
    };

    mergeObjs.forEach(function (mergeObj) {
      forOwn(mergeObj, function (mergeValue, key) {
        if (isDeep && obj.hasOwnProperty(key)) {
          var currentValue = nextObject[key];

          if ((typeof mergeValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(mergeValue)) === 'object' && !(mergeValue instanceof Array)) {
            if (_shouldMergeKey(nextObject, mergeObj, key)) {
              var recursiveMergeResult = immutableMerge(isDeep, ownerID, mergeValue, currentValue);

              if (recursiveMergeResult !== currentValue) {
                willChange();
                nextObject[key] = recursiveMergeResult;
              }
            }

            return true; // continue forOwn
          }
        }

        if (_shouldMergeKey(nextObject, mergeObj, key)) {
          willChange();
          nextObject[key] = mergeValue;
        }
      });
    });
    return nextObject;
  }

  var immutableDeepMerge = immutableMerge.bind(null, true);
  var immutableShallowMerge = immutableMerge.bind(null, false);

  function immutableArrSet(ownerID, index, value, arr) {
    if (canMutate(arr, ownerID)) return mutableSet(index, value, arr);
    if (arr[index] === value) return arr;
    var newArr = fastArrayCopy(arr);
    newArr[index] = value;
    prepareNewObject(newArr, ownerID);
    return newArr;
  }

  function immutableSet(ownerID, key, value, obj) {
    if (isArrayLike(obj)) return immutableArrSet(ownerID, key, value, obj);
    if (canMutate(obj, ownerID)) return mutableSet(key, value, obj);
    if (obj[key] === value) return obj;
    var newObj = (0, _assign2.default)({}, obj);
    prepareNewObject(newObj, ownerID);
    newObj[key] = value;
    return newObj;
  }

  function immutableOmit(ownerID, _keys, obj) {
    if (canMutate(obj, ownerID)) return mutableOmit(_keys, obj);
    var keys = forceArray(_keys);
    var keysInObj = keys.filter(function (key) {
      return obj.hasOwnProperty(key);
    }); // None of the keys were in the object, so we can return `obj`.

    if (keysInObj.length === 0) return obj;
    var newObj = (0, _assign2.default)({}, obj);
    keysInObj.forEach(function (key) {
      delete newObj[key];
    });
    prepareNewObject(newObj, ownerID);
    return newObj;
  }

  function mutableArrPush(_vals, arr) {
    var vals = forceArray(_vals);
    arr.push.apply(arr, (0, _toConsumableArray3.default)(vals));
    return arr;
  }

  function mutableArrFilter(func, arr) {
    var currIndex = 0;
    var originalIndex = 0;

    while (currIndex < arr.length) {
      var item = arr[currIndex];

      if (!func(item, originalIndex)) {
        arr.splice(currIndex, 1);
      } else {
        currIndex++;
      }

      originalIndex++;
    }

    return arr;
  }

  function mutableArrSplice(index, deleteCount, _vals, arr) {
    var vals = forceArray(_vals);
    arr.splice.apply(arr, [index, deleteCount].concat((0, _toConsumableArray3.default)(vals)));
    return arr;
  }

  function mutableArrInsert(index, _vals, arr) {
    return mutableArrSplice(index, 0, _vals, arr);
  }

  function immutableArrSplice(ownerID, index, deleteCount, _vals, arr) {
    if (canMutate(arr, ownerID)) return mutableArrSplice(index, deleteCount, _vals, arr);
    var vals = forceArray(_vals);
    var newArr = arr.slice();
    prepareNewObject(newArr, ownerID);
    newArr.splice.apply(newArr, [index, deleteCount].concat((0, _toConsumableArray3.default)(vals)));
    return newArr;
  }

  function immutableArrInsert(ownerID, index, _vals, arr) {
    if (canMutate(arr, ownerID)) return mutableArrInsert(index, _vals, arr);
    return immutableArrSplice(ownerID, index, 0, _vals, arr);
  }

  function immutableArrPush(ownerID, vals, arr) {
    return immutableArrInsert(ownerID, arr.length, vals, arr);
  }

  function immutableArrFilter(ownerID, func, arr) {
    if (canMutate(arr, ownerID)) return mutableArrFilter(func, arr);
    var newArr = arr.filter(func);
    if (newArr.length === arr.length) return arr;
    prepareNewObject(newArr, ownerID);
    return newArr;
  }

  var immutableOperations = {
    // object operations
    merge: immutableShallowMerge,
    deepMerge: immutableDeepMerge,
    omit: immutableOmit,
    setIn: immutableSetIn,
    // array operations
    insert: immutableArrInsert,
    push: immutableArrPush,
    filter: immutableArrFilter,
    splice: immutableArrSplice,
    // both
    set: immutableSet
  };
  var mutableOperations = {
    // object operations
    merge: mutableShallowMerge,
    deepMerge: mutableDeepMerge,
    omit: mutableOmit,
    setIn: mutableSetIn,
    // array operations
    insert: mutableArrInsert,
    push: mutableArrPush,
    filter: mutableArrFilter,
    splice: mutableArrSplice,
    // both
    set: mutableSet
  };

  function getImmutableOps() {
    var immutableOps = (0, _assign2.default)({}, immutableOperations);
    forOwn(immutableOps, function (value, key) {
      immutableOps[key] = (0, _curry2.default)(value.bind(null, null));
    });
    var mutableOps = (0, _assign2.default)({}, mutableOperations);
    forOwn(mutableOps, function (value, key) {
      mutableOps[key] = (0, _curry2.default)(value);
    });
    var batchOps = (0, _assign2.default)({}, immutableOperations);
    forOwn(batchOps, function (value, key) {
      batchOps[key] = (0, _curry2.default)(value);
    });

    function batched(_token, _fn) {
      var token = void 0;
      var fn = void 0;

      if (typeof _token === 'function') {
        fn = _token;
        token = getBatchToken();
      } else {
        token = _token;
        fn = _fn;
      }

      var immutableOpsBoundToToken = (0, _assign2.default)({}, immutableOperations);
      forOwn(immutableOpsBoundToToken, function (value, key) {
        immutableOpsBoundToToken[key] = (0, _curry2.default)(value.bind(null, token));
      });
      return fn(immutableOpsBoundToToken);
    }

    return (0, _assign2.default)(immutableOps, {
      mutable: mutableOps,
      batch: batchOps,
      batched: batched,
      __: _2.default,
      getBatchToken: getBatchToken
    });
  }

  var ops = exports.ops = getImmutableOps();
  exports.default = ops;
});
unwrapExports(lib$1);
var lib_1 = lib$1.ops;
var lib_2 = lib$1.getBatchToken;
var lib_3 = lib$1.canMutate;
var lib_4 = lib$1.getImmutableOps;
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && _baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes$2 = arrayIncludes;
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }

  return false;
}

var _arrayIncludesWith = arrayIncludesWith;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */

function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? _arrayIncludesWith : _arrayIncludes$2,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];

    if (othIndex && iteratee) {
      array = _arrayMap(array, _baseUnary(iteratee));
    }

    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new _SetCache(othIndex && array) : undefined;
  }

  array = arrays[0];
  var index = -1,
      seen = caches[0];

  outer: while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;

    if (!(seen ? _cacheHas(seen, computed) : includes(result, computed, comparator))) {
      othIndex = othLength;

      while (--othIndex) {
        var cache = caches[othIndex];

        if (!(cache ? _cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
          continue outer;
        }
      }

      if (seen) {
        seen.push(computed);
      }

      result.push(value);
    }
  }

  return result;
}

var _baseIntersection = baseIntersection;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

var _apply = apply;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$1 = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant(value) {
  return function () {
    return value;
  };
}

var constant_1 = constant;
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString = !_defineProperty$1 ? identity_1 : function (func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};
var _baseSetToString = baseSetToString;
/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */

function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */

function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */

function castArrayLikeObject(value) {
  return isArrayLikeObject_1(value) ? value : [];
}

var _castArrayLikeObject = castArrayLikeObject;
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */

var intersection = _baseRest(function (arrays) {
  var mapped = _arrayMap(arrays, _castArrayLikeObject);

  return mapped.length && mapped[0] === arrays[0] ? _baseIntersection(mapped) : [];
});

var intersection_1 = intersection;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE$1 = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */

function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes$2,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }

  if (iteratee) {
    values = _arrayMap(values, _baseUnary(iteratee));
  }

  if (comparator) {
    includes = _arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE$1) {
    includes = _cacheHas;
    isCommon = false;
    values = new _SetCache(values);
  }

  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);
    value = comparator || value !== 0 ? value : 0;

    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;

      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }

      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }

  return result;
}

var _baseDifference = baseDifference;
/** Built-in value references. */

var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */

function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */

function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;
  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];

    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }

  return result;
}

var _baseFlatten = baseFlatten;
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */

var difference = _baseRest(function (array, values) {
  return isArrayLikeObject_1(array) ? _baseDifference(array, _baseFlatten(values, 1, isArrayLikeObject_1, true)) : [];
});

var difference_1 = difference;
var utils = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.warnDeprecated = exports.getBatchToken = exports.arrayDiffActions = exports.includes = exports.ops = exports.objectShallowEquals = exports.reverseFieldErrorMessage = exports.normalizeEntity = exports.reverseFieldName = exports.m2mToFieldName = exports.m2mFromFieldName = exports.m2mName = exports.attachQuerySetMethods = undefined;

  var _keys2 = _interopRequireDefault(keys$4);

  var _defineProperty2 = _interopRequireDefault(defineProperty$6);

  var _getOwnPropertyDescriptor2 = _interopRequireDefault(getOwnPropertyDescriptor$3);

  var _getPrototypeOf2 = _interopRequireDefault(getPrototypeOf$3);

  var _forOwn2 = _interopRequireDefault(forOwn_1);

  var _includes2 = _interopRequireDefault(includes_1);

  var _immutableOps2 = _interopRequireDefault(lib$1);

  var _intersection2 = _interopRequireDefault(intersection_1);

  var _difference2 = _interopRequireDefault(difference_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function warnDeprecated(msg) {
    var logger = typeof console.warn === 'function' ? console.warn.bind(console) : console.log.bind(console);
    return logger(msg);
  }
  /**
   * @module utils
   */


  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  /**
   * Returns the branch name for a many-to-many relation.
   * The name is the combination of the model name and the field name the relation
   * was declared. The field name's first letter is capitalized.
   *
   * Example: model `Author` has a many-to-many relation to the model `Book`, defined
   * in the `Author` field `books`. The many-to-many branch name will be `AuthorBooks`.
   *
   * @private
   * @param  {string} declarationModelName - the name of the model the many-to-many relation was declared on
   * @param  {string} fieldName            - the field name where the many-to-many relation was declared on
   * @return {string} The branch name for the many-to-many relation.
   */


  function m2mName(declarationModelName, fieldName) {
    return declarationModelName + capitalize(fieldName);
  }
  /**
   * Returns the fieldname that saves a foreign key to the
   * model id where the many-to-many relation was declared.
   *
   * Example: `Author` => `fromAuthorId`
   *
   * @private
   * @param  {string} declarationModelName - the name of the model where the relation was declared
   * @return {string} the field name in the through model for `declarationModelName`'s foreign key.
   */


  function m2mFromFieldName(declarationModelName) {
    return 'from' + declarationModelName + 'Id';
  }
  /**
   * Returns the fieldname that saves a foreign key in a many-to-many through model to the
   * model where the many-to-many relation was declared.
   *
   * Example: `Book` => `toBookId`
   *
   * @private
   * @param  {string} otherModelName - the name of the model that was the target of the many-to-many
   *                                   declaration.
   * @return {string} the field name in the through model for `otherModelName`'s foreign key..
   */


  function m2mToFieldName(otherModelName) {
    return 'to' + otherModelName + 'Id';
  }

  function reverseFieldName(modelName) {
    return modelName.toLowerCase() + 'Set'; // eslint-disable-line prefer-template
  }

  function querySetDelegatorFactory(methodName) {
    return function querySetDelegator() {
      var _getQuerySet;

      return (_getQuerySet = this.getQuerySet())[methodName].apply(_getQuerySet, arguments);
    };
  }

  function querySetGetterDelegatorFactory(getterName) {
    return function querySetGetterDelegator() {
      var qs = this.getQuerySet();
      return qs[getterName];
    };
  }

  function forEachSuperClass(subClass, func) {
    var currClass = subClass;

    while (currClass !== Function.prototype) {
      func(currClass);
      currClass = (0, _getPrototypeOf2.default)(currClass);
    }
  }

  function attachQuerySetMethods(modelClass, querySetClass) {
    var leftToDefine = querySetClass.sharedMethods.slice(); // There is no way to get a property descriptor for the whole prototype chain;
    // only from an objects own properties. Therefore we traverse the whole prototype
    // chain for querySet.

    forEachSuperClass(querySetClass, function (cls) {
      for (var i = 0; i < leftToDefine.length; i++) {
        var defined = false;
        var methodName = leftToDefine[i];
        var descriptor = (0, _getOwnPropertyDescriptor2.default)(cls.prototype, methodName);

        if (typeof descriptor !== 'undefined') {
          if (typeof descriptor.get !== 'undefined') {
            descriptor.get = querySetGetterDelegatorFactory(methodName);
            (0, _defineProperty2.default)(modelClass, methodName, descriptor);
            defined = true;
          } else if (typeof descriptor.value === 'function') {
            modelClass[methodName] = querySetDelegatorFactory(methodName);
            defined = true;
          }
        }

        if (defined) {
          leftToDefine.splice(i--, 1);
        }
      }
    });
  }
  /**
   * Normalizes `entity` to an id, where `entity` can be an id
   * or a Model instance.
   *
   * @private
   * @param  {*} entity - either a Model instance or an id value
   * @return {*} the id value of `entity`
   */


  function normalizeEntity(entity) {
    if (entity !== null && typeof entity !== 'undefined' && typeof entity.getId === 'function') {
      return entity.getId();
    }

    return entity;
  }

  function reverseFieldErrorMessage(modelName, fieldName, toModelName, backwardsFieldName) {
    return ['Reverse field ' + backwardsFieldName + ' already defined', ' on model ' + toModelName + '. To fix, set a custom related', ' name on ' + modelName + '.' + fieldName + '.'].join('');
  }

  function objectShallowEquals(a, b) {
    var keysInA = 0; // eslint-disable-next-line consistent-return

    (0, _forOwn2.default)(a, function (value, key) {
      if (!b.hasOwnProperty(key) || b[key] !== value) {
        return false;
      }

      keysInA++;
    });
    return keysInA === (0, _keys2.default)(b).length;
  }

  function arrayDiffActions(sourceArr, targetArr) {
    var itemsInBoth = (0, _intersection2.default)(sourceArr, targetArr);
    var deleteItems = (0, _difference2.default)(sourceArr, itemsInBoth);
    var addItems = (0, _difference2.default)(targetArr, itemsInBoth);

    if (deleteItems.length || addItems.length) {
      return {
        delete: deleteItems,
        add: addItems
      };
    }

    return null;
  }

  var getBatchToken = _immutableOps2.default.getBatchToken;
  exports.attachQuerySetMethods = attachQuerySetMethods;
  exports.m2mName = m2mName;
  exports.m2mFromFieldName = m2mFromFieldName;
  exports.m2mToFieldName = m2mToFieldName;
  exports.reverseFieldName = reverseFieldName;
  exports.normalizeEntity = normalizeEntity;
  exports.reverseFieldErrorMessage = reverseFieldErrorMessage;
  exports.objectShallowEquals = objectShallowEquals;
  exports.ops = _immutableOps2.default;
  exports.includes = _includes2.default;
  exports.arrayDiffActions = arrayDiffActions;
  exports.getBatchToken = getBatchToken;
  exports.warnDeprecated = warnDeprecated;
});
unwrapExports(utils);
var utils_1 = utils.warnDeprecated;
var utils_2 = utils.getBatchToken;
var utils_3 = utils.arrayDiffActions;
var utils_4 = utils.includes;
var utils_5 = utils.ops;
var utils_6 = utils.objectShallowEquals;
var utils_7 = utils.reverseFieldErrorMessage;
var utils_8 = utils.normalizeEntity;
var utils_9 = utils.reverseFieldName;
var utils_10 = utils.m2mToFieldName;
var utils_11 = utils.m2mFromFieldName;
var utils_12 = utils.m2mName;
var utils_13 = utils.attachQuerySetMethods;
var constants = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var UPDATE = exports.UPDATE = 'REDUX_ORM_UPDATE';
  var DELETE = exports.DELETE = 'REDUX_ORM_DELETE';
  var CREATE = exports.CREATE = 'REDUX_ORM_CREATE';
  var FILTER = exports.FILTER = 'REDUX_ORM_FILTER';
  var EXCLUDE = exports.EXCLUDE = 'REDUX_ORM_EXCLUDE';
  var ORDER_BY = exports.ORDER_BY = 'REDUX_ORM_ORDER_BY';
  var SUCCESS = exports.SUCCESS = 'SUCCESS';
  var FAILURE = exports.FAILURE = 'FAILURE';
});
unwrapExports(constants);
var constants_1 = constants.UPDATE;
var constants_2 = constants.DELETE;
var constants_3 = constants.CREATE;
var constants_4 = constants.FILTER;
var constants_5 = constants.EXCLUDE;
var constants_6 = constants.ORDER_BY;
var constants_7 = constants.SUCCESS;
var constants_8 = constants.FAILURE;
var QuerySet_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof3 = _interopRequireDefault(_typeof_1);

  var _assign2 = _interopRequireDefault(assign$1);

  var _classCallCheck3 = _interopRequireDefault(classCallCheck$1);

  var _createClass3 = _interopRequireDefault(createClass$1);

  var _mapValues2 = _interopRequireDefault(mapValues_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * This class is used to build and make queries to the database
   * and operating the resulting set (such as updating attributes
   * or deleting the records).
   *
   * The queries are built lazily. For example:
   *
   * ```javascript
   * const qs = Book.all()
   *     .filter(book => book.releaseYear > 1999)
   *     .orderBy('name');
   * ```
   *
   * Doesn't execute a query. The query is executed only when
   * you need information from the query result, such as {@link QuerySet#count},
   * {@link QuerySet#toRefArray}. After the query is executed, the resulting
   * set is cached in the QuerySet instance.
   *
   * QuerySet instances also return copies, so chaining filters doesn't
   * mutate the previous instances.
   */


  var QuerySet = function () {
    /**
     * Creates a QuerySet. The constructor is mainly for internal use;
     * You should access QuerySet instances from {@link Model}.
     *
     * @param  {Model} modelClass - the model class of objects in this QuerySet.
     * @param  {any[]} clauses - query clauses needed to evaluate the set.
     * @param {Object} [opts] - additional options
     */
    function QuerySet(modelClass, clauses, opts) {
      (0, _classCallCheck3.default)(this, QuerySet);
      (0, _assign2.default)(this, {
        modelClass: modelClass,
        clauses: clauses || []
      });
      this._opts = opts;
    }

    QuerySet.addSharedMethod = function addSharedMethod(methodName) {
      this.sharedMethods = this.sharedMethods.concat(methodName);
    };

    QuerySet.prototype._new = function _new(clauses, userOpts) {
      var opts = (0, _assign2.default)({}, this._opts, userOpts);
      return new this.constructor(this.modelClass, clauses, opts);
    };

    QuerySet.prototype.toString = function toString() {
      var _this = this;

      this._evaluate();

      var contents = this.rows.map(function (id) {
        return _this.modelClass.withId(id).toString();
      }).join('\n    - ');
      return 'QuerySet contents: \n    - ' + contents;
    };
    /**
     * Returns an array of the plain objects represented by the QuerySet.
     * The plain objects are direct references to the store.
     *
     * @return {Object[]} references to the plain JS objects represented by
     *                    the QuerySet
     */


    QuerySet.prototype.toRefArray = function toRefArray() {
      this._evaluate();

      return this.rows;
    };
    /**
     * Returns an array of {@link Model} instances represented by the QuerySet.
     * @return {Model[]} model instances represented by the QuerySet
     */


    QuerySet.prototype.toModelArray = function toModelArray() {
      this._evaluate();

      var ModelClass = this.modelClass;
      return this.rows.map(function (props) {
        return new ModelClass(props);
      });
    };
    /**
     * Returns the number of {@link Model} instances represented by the QuerySet.
     *
     * @return {number} length of the QuerySet
     */


    QuerySet.prototype.count = function count() {
      this._evaluate();

      return this.rows.length;
    };
    /**
     * Checks if the {@link QuerySet} instance has any records matching the query
     * in the database.
     *
     * @return {Boolean} `true` if the {@link QuerySet} instance contains entities, else `false`.
     */


    QuerySet.prototype.exists = function exists() {
      return Boolean(this.count());
    };
    /**
     * Returns the {@link Model} instance at index `index` in the {@link QuerySet} instance if
     * `withRefs` flag is set to `false`, or a reference to the plain JavaScript
     * object in the model state if `true`.
     *
     * @param  {number} index - index of the model instance to get
     * @return {Model|undefined} a {@link Model} instance at index
     *                           `index` in the {@link QuerySet} instance,
     *                           or undefined if the index is out of bounds.
     */


    QuerySet.prototype.at = function at(index) {
      this._evaluate();

      if (index >= 0 && index < this.rows.length) {
        var ModelClass = this.modelClass;
        return new ModelClass(this.rows[index]);
      }

      return undefined;
    };
    /**
     * Returns the {@link Model} instance at index 0 in the {@link QuerySet} instance.
     * @return {Model}
     */


    QuerySet.prototype.first = function first() {
      return this.at(0);
    };
    /**
     * Returns the {@link Model} instance at index `QuerySet.count() - 1`
     * @return {Model}
     */


    QuerySet.prototype.last = function last() {
      this._evaluate();

      return this.at(this.rows.length - 1);
    };
    /**
     * Returns a new {@link QuerySet} instance with the same entities.
     * @return {QuerySet} a new QuerySet with the same entities.
     */


    QuerySet.prototype.all = function all() {
      return this._new(this.clauses);
    };
    /**
     * Returns a new {@link QuerySet} instance with entities that match properties in `lookupObj`.
     *
     * @param  {Object} lookupObj - the properties to match objects with.
     * @return {QuerySet} a new {@link QuerySet} instance with objects that passed the filter.
     */


    QuerySet.prototype.filter = function filter(lookupObj) {
      var normalizedLookupObj = (typeof lookupObj === 'undefined' ? 'undefined' : (0, _typeof3.default)(lookupObj)) === 'object' ? (0, _mapValues2.default)(lookupObj, utils.normalizeEntity) : lookupObj;
      var filterDescriptor = {
        type: constants.FILTER,
        payload: normalizedLookupObj
      };
      return this._new(this.clauses.concat(filterDescriptor));
    };
    /**
     * Returns a new {@link QuerySet} instance with entities that do not match
     * properties in `lookupObj`.
     *
     * @param  {Object} lookupObj - the properties to unmatch objects with.
     * @return {QuerySet} a new {@link QuerySet} instance with objects that passed the filter.
     */


    QuerySet.prototype.exclude = function exclude(lookupObj) {
      var normalizedLookupObj = (typeof lookupObj === 'undefined' ? 'undefined' : (0, _typeof3.default)(lookupObj)) === 'object' ? (0, _mapValues2.default)(lookupObj, utils.normalizeEntity) : lookupObj;
      var excludeDescriptor = {
        type: constants.EXCLUDE,
        payload: normalizedLookupObj
      };
      return this._new(this.clauses.concat(excludeDescriptor));
    };

    QuerySet.prototype._evaluate = function _evaluate() {
      if (!this._evaluated) {
        var session = this.modelClass.session;
        var querySpec = {
          table: this.modelClass.modelName,
          clauses: this.clauses
        };

        var _session$query = session.query(querySpec),
            rows = _session$query.rows;

        this.rows = rows;
        this._evaluated = true;
      }
    };
    /**
     * Returns a new {@link QuerySet} instance with entities ordered by `iteratees` in ascending
     * order, unless otherwise specified. Delegates to `lodash.orderBy`.
     *
     * @param  {string[]|Function[]} iteratees - an array where each item can be a string or a
     *                                           function. If a string is supplied, it should
     *                                           correspond to property on the entity that will
     *                                           determine the order. If a function is supplied,
     *                                           it should return the value to order by.
     * @param {Boolean[]} [orders] - the sort orders of `iteratees`. If unspecified, all iteratees
     *                               will be sorted in ascending order. `true` and `'asc'`
     *                               correspond to ascending order, and `false` and `'desc`
     *                               to descending order.
     * @return {QuerySet} a new {@link QuerySet} with objects ordered by `iteratees`.
     */


    QuerySet.prototype.orderBy = function orderBy(iteratees, orders) {
      var orderByDescriptor = {
        type: constants.ORDER_BY,
        payload: [iteratees, orders]
      };
      return this._new(this.clauses.concat(orderByDescriptor));
    };
    /**
     * Records an update specified with `mergeObj` to all the objects
     * in the {@link QuerySet} instance.
     *
     * @param  {Object} mergeObj - an object to merge with all the objects in this
     *                             queryset.
     * @return {undefined}
     */


    QuerySet.prototype.update = function update(mergeObj) {
      this.modelClass.session.applyUpdate({
        action: constants.UPDATE,
        query: {
          table: this.modelClass.modelName,
          clauses: this.clauses
        },
        payload: mergeObj
      });
      this._evaluated = false;
    };
    /**
     * Records a deletion of all the objects in this {@link QuerySet} instance.
     * @return {undefined}
     */


    QuerySet.prototype.delete = function _delete() {
      // eslint-disable-next-line no-underscore-dangle
      this.toModelArray().forEach(function (model) {
        return model._onDelete();
      });
      this.modelClass.session.applyUpdate({
        action: constants.DELETE,
        query: {
          table: this.modelClass.modelName,
          clauses: this.clauses
        }
      });
      this._evaluated = false;
    }; // DEPRECATED AND REMOVED METHODS


    QuerySet.prototype.map = function map() {
      throw new Error('QuerySet.prototype.map is removed. ' + 'Call .toModelArray() or .toRefArray() first to map.');
    };

    QuerySet.prototype.forEach = function forEach() {
      throw new Error('QuerySet.prototype.forEach is removed. ' + 'Call .toModelArray() or .toRefArray() first to iterate.');
    };

    (0, _createClass3.default)(QuerySet, [{
      key: 'withModels',
      get: function get() {
        throw new Error('QuerySet.prototype.withModels is removed. ' + 'Use .toModelArray() or predicate functions that ' + 'instantiate Models from refs, e.g. new Model(ref).');
      }
    }, {
      key: 'withRefs',
      get: function get() {
        (0, utils.warnDeprecated)('QuerySet.prototype.withRefs is deprecated. ' + 'Query building operates on refs only now.');
      }
    }]);
    return QuerySet;
  }();

  QuerySet.sharedMethods = ['count', 'at', 'all', 'last', 'first', 'exists', 'filter', 'exclude', 'orderBy', 'update', 'delete'];
  exports.default = QuerySet;
});
unwrapExports(QuerySet_1);
var defineProperty$9 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _defineProperty2 = _interopRequireDefault(defineProperty$6);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (obj, key, value) {
    if (key in obj) {
      (0, _defineProperty2.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };
});
unwrapExports(defineProperty$9);
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$1() {// No operation performed.
}

var noop_1 = noop$1;
/** Used as references for various `Number` constants. */

var INFINITY$3 = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */

var createSet = !(_Set && 1 / _setToArray(new _Set([, -0]))[1] == INFINITY$3) ? noop_1 : function (values) {
  return new _Set(values);
};
var _createSet = createSet;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE$2 = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */

function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes$2,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = _arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE$2) {
    var set = iteratee ? null : _createSet(array);

    if (set) {
      return _setToArray(set);
    }

    isCommon = false;
    includes = _cacheHas;
    seen = new _SetCache();
  } else {
    seen = iteratee ? [] : result;
  }

  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;

    if (isCommon && computed === computed) {
      var seenIndex = seen.length;

      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }

      if (iteratee) {
        seen.push(computed);
      }

      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }

      result.push(value);
    }
  }

  return result;
}

var _baseUniq = baseUniq;
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */

function uniq(array) {
  return array && array.length ? _baseUniq(array) : [];
}

var uniq_1 = uniq;
var possibleConstructorReturn$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _typeof3 = _interopRequireDefault(_typeof_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
  };
});
unwrapExports(possibleConstructorReturn$1); // Works with __proto__ only. Old v8 can't work with null proto objects.

/* eslint-disable no-proto */

var check$1 = function check$1(O, proto) {
  _anObject$1(O);

  if (!_isObject$1(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};

var _setProto$1 = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = _ctx$1(Function.call, _objectGopd$1.f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }

    return function setPrototypeOf(O, proto) {
      check$1(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check$1
}; // 19.1.3.19 Object.setPrototypeOf(O, proto)

_export$1(_export$1.S, 'Object', {
  setPrototypeOf: _setProto$1.set
});

var setPrototypeOf$1 = _core$1.Object.setPrototypeOf;
var setPrototypeOf$2 = createCommonjsModule(function (module) {
  module.exports = {
    "default": setPrototypeOf$1,
    __esModule: true
  };
});
unwrapExports(setPrototypeOf$2); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

_export$1(_export$1.S, 'Object', {
  create: _objectCreate$1
});

var $Object$2 = _core$1.Object;

var create = function create(P, D) {
  return $Object$2.create(P, D);
};

var create$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": create,
    __esModule: true
  };
});
unwrapExports(create$1);
var inherits$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf$2);

  var _create2 = _interopRequireDefault(create$1);

  var _typeof3 = _interopRequireDefault(_typeof_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  };
});
unwrapExports(inherits$1);
var Session_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(defineProperty$6);

  var _possibleConstructorReturn3 = _interopRequireDefault(possibleConstructorReturn$1);

  var _inherits3 = _interopRequireDefault(inherits$1);

  var _classCallCheck3 = _interopRequireDefault(classCallCheck$1);

  var _createClass3 = _interopRequireDefault(createClass$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Session = function () {
    /**
     * Creates a new Session.
     *
     * @param  {Database} db - a {@link Database} instance
     * @param  {Object} state - the database state
     * @param  {Boolean} [withMutations] - whether the session should mutate data
     * @param  {Object} [batchToken] - used by the backend to identify objects that can be
     *                                 mutated.
     */
    function Session(schema, db, state, withMutations, batchToken) {
      var _this2 = this;

      (0, _classCallCheck3.default)(this, Session);
      this.schema = schema;
      this.db = db;
      this.state = state || db.getEmptyState();
      this.initialState = this.state;
      this.withMutations = !!withMutations;
      this.batchToken = batchToken || (0, lib$1.getBatchToken)();
      this._accessedModels = {};
      this.modelData = {};
      this.models = schema.getModelClasses();
      this.sessionBoundModels = this.models.map(function (modelClass) {
        var sessionBoundModel = function (_modelClass) {
          (0, _inherits3.default)(SessionBoundModel, _modelClass);

          function SessionBoundModel() {
            (0, _classCallCheck3.default)(this, SessionBoundModel);
            return (0, _possibleConstructorReturn3.default)(this, _modelClass.apply(this, arguments));
          }

          return SessionBoundModel;
        }(modelClass);

        (0, _defineProperty2.default)(_this2, modelClass.modelName, {
          get: function get() {
            return sessionBoundModel;
          }
        });
        sessionBoundModel.connect(_this2);
        return sessionBoundModel;
      });
    }

    Session.prototype.markAccessed = function markAccessed(modelName) {
      this.getDataForModel(modelName).accessed = true;
    };

    Session.prototype.getDataForModel = function getDataForModel(modelName) {
      if (!this.modelData[modelName]) {
        this.modelData[modelName] = {};
      }

      return this.modelData[modelName];
    };
    /**
     * Applies update to a model state.
     *
     * @private
     * @param {Object} update - the update object. Must have keys
     *                          `type`, `payload`.
     */


    Session.prototype.applyUpdate = function applyUpdate(updateSpec) {
      var batchToken = this.batchToken,
          withMutations = this.withMutations;
      var tx = {
        batchToken: batchToken,
        withMutations: withMutations
      };
      var result = this.db.update(updateSpec, tx, this.state);
      var status = result.status,
          state = result.state;

      if (status === constants.SUCCESS) {
        this.state = state;
      } else {
        throw new Error('Applying update failed: ' + result.toString());
      }

      return result.payload;
    };

    Session.prototype.query = function query(querySpec) {
      var table = querySpec.table;
      this.markAccessed(table);
      return this.db.query(querySpec, this.state);
    }; // DEPRECATED AND REMOVED METHODS


    Session.prototype.getNextState = function getNextState() {
      (0, utils.warnDeprecated)('Session.prototype.getNextState function is deprecated. Access ' + 'the Session.prototype.state property instead.');
      return this.state;
    };

    Session.prototype.reduce = function reduce() {
      throw new Error('Session.prototype.reduce is removed. The Redux integration API ' + 'is now decoupled from ORM and Session - see the 0.9 migration guide ' + 'in the GitHub repo.');
    };

    (0, _createClass3.default)(Session, [{
      key: 'accessedModels',
      get: function get() {
        var _this3 = this;

        return this.sessionBoundModels.filter(function (model) {
          return !!_this3.getDataForModel(model.modelName).accessed;
        }).map(function (model) {
          return model.modelName;
        });
      }
    }]);
    return Session;
  }();

  exports.default = Session;
});
unwrapExports(Session_1);

var ITERATOR$9 = _wks$1('iterator');

var core_isIterable = _core$1.isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR$9] !== undefined || '@@iterator' in O // eslint-disable-next-line no-prototype-builtins
  || _iterators$1.hasOwnProperty(_classof$1(O));
};

var isIterable = core_isIterable;
var isIterable$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": isIterable,
    __esModule: true
  };
});
unwrapExports(isIterable$1);

var core_getIterator = _core$1.getIterator = function (it) {
  var iterFn = core_getIteratorMethod$1(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return _anObject$1(iterFn.call(it));
};

var getIterator = core_getIterator;
var getIterator$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": getIterator,
    __esModule: true
  };
});
unwrapExports(getIterator$1);
var slicedToArray$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _isIterable3 = _interopRequireDefault(isIterable$1);

  var _getIterator3 = _interopRequireDefault(getIterator$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if ((0, _isIterable3.default)(Object(arr))) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
});
unwrapExports(slicedToArray$1);
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */

function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function (value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

var _baseFindKey = baseFindKey;
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */

function findKey(object, predicate) {
  return _baseFindKey(object, _baseIteratee(predicate, 3), _baseForOwn);
}

var findKey_1 = findKey;
var descriptors = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.manyToManyDescriptor = exports.backwardManyToOneDescriptor = exports.backwardOneToOneDescriptor = exports.forwardOneToOneDescriptor = exports.forwardManyToOneDescriptor = exports.attrDescriptor = undefined;

  var _defineProperty3 = _interopRequireDefault(defineProperty$9);

  var _difference2 = _interopRequireDefault(difference_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function attrDescriptor(fieldName) {
    return {
      get: function get() {
        return this._fields[fieldName];
      },
      set: function set(value) {
        return this.set(fieldName, value);
      },
      enumerable: true,
      configurable: true
    };
  } // Forwards side a Foreign Key: returns one object.
  // Also works as forwardsOneToOneDescriptor.


  function forwardManyToOneDescriptor(fieldName, declaredToModelName) {
    return {
      get: function get() {
        var currentSession = this.getClass().session;
        var declaredToModel = currentSession[declaredToModelName];
        var toId = this._fields[fieldName];

        if (typeof toId !== 'undefined' && toId !== null) {
          return declaredToModel.withId(toId);
        }

        return undefined;
      },
      set: function set(value) {
        var currentSession = this.getClass().session;
        var declaredToModel = currentSession[declaredToModelName];
        var toId = void 0;

        if (value instanceof declaredToModel) {
          toId = value.getId();
        } else {
          toId = value;
        }

        this.update((0, _defineProperty3.default)({}, fieldName, toId));
      }
    };
  }

  var forwardOneToOneDescriptor = forwardManyToOneDescriptor;

  function backwardOneToOneDescriptor(declaredFieldName, declaredFromModelName) {
    return {
      get: function get() {
        var currentSession = this.getClass().session;
        var declaredFromModel = currentSession[declaredFromModelName];
        var thisId = this.getId();
        var found = void 0;

        try {
          found = declaredFromModel.get((0, _defineProperty3.default)({}, declaredFieldName, thisId));
        } catch (e) {
          return null;
        }

        return found;
      },
      set: function set() {
        throw new Error('Can\'t mutate a reverse one-to-one relation.');
      }
    };
  } // Reverse side of a Foreign Key: returns many objects.


  function backwardManyToOneDescriptor(declaredFieldName, declaredFromModelName) {
    return {
      get: function get() {
        var currentSession = this.getClass().session;
        var declaredFromModel = currentSession[declaredFromModelName];
        var thisId = this.getId();
        return declaredFromModel.filter((0, _defineProperty3.default)({}, declaredFieldName, thisId));
      },
      set: function set() {
        throw new Error('Can\'t mutate a reverse many-to-one relation.');
      }
    };
  } // Both sides of Many to Many, use the reverse flag.


  function manyToManyDescriptor(declaredFromModelName, declaredToModelName, throughModelName, throughFields, reverse) {
    return {
      get: function get() {
        var currentSession = this.getClass().session;
        var declaredFromModel = currentSession[declaredFromModelName];
        var declaredToModel = currentSession[declaredToModelName];
        var throughModel = currentSession[throughModelName];
        var thisId = this.getId();
        var fromFieldName = throughFields.from;
        var toFieldName = throughFields.to;
        var lookupObj = {};

        if (!reverse) {
          lookupObj[fromFieldName] = thisId;
        } else {
          lookupObj[toFieldName] = thisId;
        }

        var throughQs = throughModel.filter(lookupObj);
        var toIds = throughQs.toRefArray().map(function (obj) {
          return obj[reverse ? fromFieldName : toFieldName];
        });
        var qsFromModel = reverse ? declaredFromModel : declaredToModel;
        var qs = qsFromModel.filter(function (attrs) {
          return (0, utils.includes)(toIds, attrs[qsFromModel.idAttribute]);
        });

        qs.add = function add() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var idsToAdd = args.map(utils.normalizeEntity);
          var filterWithAttr = reverse ? fromFieldName : toFieldName;
          var existingQs = throughQs.filter(function (through) {
            return (0, utils.includes)(idsToAdd, through[filterWithAttr]);
          });

          if (existingQs.exists()) {
            var existingIds = existingQs.toRefArray().map(function (through) {
              return through[filterWithAttr];
            });
            var toAddModel = reverse ? declaredFromModel.modelName : declaredToModel.modelName;
            var addFromModel = reverse ? declaredToModel.modelName : declaredFromModel.modelName;
            throw new Error('Tried to add already existing ' + toAddModel + ' id(s) ' + existingIds + ' to the ' + addFromModel + ' instance with id ' + thisId);
          }

          if (reverse) {
            idsToAdd.forEach(function (id) {
              var _throughModel$create;

              throughModel.create((_throughModel$create = {}, (0, _defineProperty3.default)(_throughModel$create, fromFieldName, id), (0, _defineProperty3.default)(_throughModel$create, toFieldName, thisId), _throughModel$create));
            });
          } else {
            idsToAdd.forEach(function (id) {
              var _throughModel$create2;

              throughModel.create((_throughModel$create2 = {}, (0, _defineProperty3.default)(_throughModel$create2, fromFieldName, thisId), (0, _defineProperty3.default)(_throughModel$create2, toFieldName, id), _throughModel$create2));
            });
          }
        };

        qs.clear = function clear() {
          throughQs.delete();
        };

        qs.remove = function remove() {
          for (var _len2 = arguments.length, entities = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            entities[_key2] = arguments[_key2];
          }

          var idsToRemove = entities.map(utils.normalizeEntity);
          var attrInIdsToRemove = reverse ? fromFieldName : toFieldName;
          var entitiesToDelete = throughQs.filter(function (through) {
            return (0, utils.includes)(idsToRemove, through[attrInIdsToRemove]);
          });

          if (entitiesToDelete.count() !== idsToRemove.length) {
            // Tried deleting non-existing entities.
            var entitiesToDeleteIds = entitiesToDelete.toRefArray().map(function (through) {
              return through[attrInIdsToRemove];
            });
            var unexistingIds = (0, _difference2.default)(idsToRemove, entitiesToDeleteIds);
            var toDeleteModel = reverse ? declaredFromModel.modelName : declaredToModel.modelName;
            var deleteFromModel = reverse ? declaredToModel.modelName : declaredFromModel.modelName;
            throw new Error('Tried to delete non-existing ' + toDeleteModel + ' id(s) ' + unexistingIds + ' from the ' + deleteFromModel + ' instance with id ' + thisId);
          }

          entitiesToDelete.delete();
        };

        return qs;
      },
      set: function set() {
        throw new Error('Tried setting a M2M field. Please use the related QuerySet methods add and remove.');
      }
    };
  }

  exports.attrDescriptor = attrDescriptor;
  exports.forwardManyToOneDescriptor = forwardManyToOneDescriptor;
  exports.forwardOneToOneDescriptor = forwardOneToOneDescriptor;
  exports.backwardOneToOneDescriptor = backwardOneToOneDescriptor;
  exports.backwardManyToOneDescriptor = backwardManyToOneDescriptor;
  exports.manyToManyDescriptor = manyToManyDescriptor;
});
unwrapExports(descriptors);
var descriptors_1 = descriptors.manyToManyDescriptor;
var descriptors_2 = descriptors.backwardManyToOneDescriptor;
var descriptors_3 = descriptors.backwardOneToOneDescriptor;
var descriptors_4 = descriptors.forwardOneToOneDescriptor;
var descriptors_5 = descriptors.forwardManyToOneDescriptor;
var descriptors_6 = descriptors.attrDescriptor;
var fields = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.OneToOne = exports.ManyToMany = exports.ForeignKey = exports.Attribute = undefined;

  var _slicedToArray3 = _interopRequireDefault(slicedToArray$1);

  var _getOwnPropertyDescriptor2 = _interopRequireDefault(getOwnPropertyDescriptor$3);

  var _possibleConstructorReturn3 = _interopRequireDefault(possibleConstructorReturn$1);

  var _inherits3 = _interopRequireDefault(inherits$1);

  var _typeof3 = _interopRequireDefault(_typeof_1);

  var _defineProperty2 = _interopRequireDefault(defineProperty$6);

  var _classCallCheck3 = _interopRequireDefault(classCallCheck$1);

  exports.attr = attr;
  exports.fk = fk;
  exports.many = many;
  exports.oneToOne = oneToOne;

  var _findKey2 = _interopRequireDefault(findKey_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @module fields
   */


  var Attribute = exports.Attribute = function () {
    function Attribute(opts) {
      (0, _classCallCheck3.default)(this, Attribute);
      this.opts = opts || {};

      if (this.opts.hasOwnProperty('getDefault')) {
        this.getDefault = this.opts.getDefault;
      }
    }

    Attribute.prototype.install = function install(model, fieldName, orm) {
      (0, _defineProperty2.default)(model.prototype, fieldName, (0, descriptors.attrDescriptor)(fieldName));
    };

    return Attribute;
  }();

  var RelationalField = function () {
    function RelationalField() {
      (0, _classCallCheck3.default)(this, RelationalField);

      if (arguments.length === 1 && (0, _typeof3.default)(arguments.length <= 0 ? undefined : arguments[0]) === 'object') {
        var opts = arguments.length <= 0 ? undefined : arguments[0];
        this.toModelName = opts.to;
        this.relatedName = opts.relatedName;
        this.through = opts.through;
        this.throughFields = opts.throughFields;
      } else {
        this.toModelName = arguments.length <= 0 ? undefined : arguments[0];
        this.relatedName = arguments.length <= 1 ? undefined : arguments[1];
      }
    }

    RelationalField.prototype.getClass = function getClass() {
      return this.constructor;
    };

    return RelationalField;
  }();

  var ForeignKey = exports.ForeignKey = function (_RelationalField) {
    (0, _inherits3.default)(ForeignKey, _RelationalField);

    function ForeignKey() {
      (0, _classCallCheck3.default)(this, ForeignKey);
      return (0, _possibleConstructorReturn3.default)(this, _RelationalField.apply(this, arguments));
    }

    ForeignKey.prototype.install = function install(model, fieldName, orm) {
      var toModelName = this.toModelName;
      var toModel = toModelName === 'this' ? model : orm.get(toModelName); // Forwards.

      (0, _defineProperty2.default)(model.prototype, fieldName, (0, descriptors.forwardManyToOneDescriptor)(fieldName, toModel.modelName)); // Backwards.

      var backwardsFieldName = this.relatedName ? this.relatedName : (0, utils.reverseFieldName)(model.modelName);
      var backwardsDescriptor = (0, _getOwnPropertyDescriptor2.default)(toModel.prototype, backwardsFieldName);

      if (backwardsDescriptor) {
        var errorMsg = (0, utils.reverseFieldErrorMessage)(model.modelName, fieldName, toModel.modelName, backwardsFieldName);
        throw new Error(errorMsg);
      }

      (0, _defineProperty2.default)(toModel.prototype, backwardsFieldName, (0, descriptors.backwardManyToOneDescriptor)(fieldName, model.modelName));
      var ThisField = this.getClass();
      toModel.virtualFields[backwardsFieldName] = new ThisField(model.modelName, fieldName);
    };

    return ForeignKey;
  }(RelationalField);

  var ManyToMany = exports.ManyToMany = function (_RelationalField2) {
    (0, _inherits3.default)(ManyToMany, _RelationalField2);

    function ManyToMany() {
      (0, _classCallCheck3.default)(this, ManyToMany);
      return (0, _possibleConstructorReturn3.default)(this, _RelationalField2.apply(this, arguments));
    }

    ManyToMany.prototype.install = function install(model, fieldName, orm) {
      var toModelName = this.toModelName;
      var toModel = toModelName === 'this' ? model : orm.get(toModelName); // Forwards.

      var throughModelName = this.through || (0, utils.m2mName)(model.modelName, fieldName);
      var throughModel = orm.get(throughModelName);
      var throughFields = void 0;

      if (!this.throughFields) {
        var toFieldName = (0, _findKey2.default)(throughModel.fields, function (field) {
          return field instanceof ForeignKey && field.toModelName === toModel.modelName;
        });
        var fromFieldName = (0, _findKey2.default)(throughModel.fields, function (field) {
          return field instanceof ForeignKey && field.toModelName === model.modelName;
        });
        throughFields = {
          to: toFieldName,
          from: fromFieldName
        };
      } else {
        var _throughFields = (0, _slicedToArray3.default)(this.throughFields, 2),
            fieldAName = _throughFields[0],
            fieldBName = _throughFields[1];

        var fieldA = throughModel.fields[fieldAName];

        if (fieldA.toModelName === toModel.modelName) {
          throughFields = {
            to: fieldAName,
            from: fieldBName
          };
        } else {
          throughFields = {
            to: fieldBName,
            from: fieldAName
          };
        }
      }

      (0, _defineProperty2.default)(model.prototype, fieldName, (0, descriptors.manyToManyDescriptor)(model.modelName, toModel.modelName, throughModelName, throughFields, false));
      model.virtualFields[fieldName] = new ManyToMany({
        to: toModel.modelName,
        relatedName: fieldName,
        through: this.through,
        throughFields: throughFields
      }); // Backwards.

      var backwardsFieldName = this.relatedName ? this.relatedName : (0, utils.reverseFieldName)(model.modelName);
      var backwardsDescriptor = (0, _getOwnPropertyDescriptor2.default)(toModel.prototype, backwardsFieldName);

      if (backwardsDescriptor) {
        // Backwards field was already defined on toModel.
        var errorMsg = (0, utils.reverseFieldErrorMessage)(model.modelName, fieldName, toModel.modelName, backwardsFieldName);
        throw new Error(errorMsg);
      }

      (0, _defineProperty2.default)(toModel.prototype, backwardsFieldName, (0, descriptors.manyToManyDescriptor)(model.modelName, toModel.modelName, throughModelName, throughFields, true));
      toModel.virtualFields[backwardsFieldName] = new ManyToMany({
        to: model.modelName,
        relatedName: fieldName,
        through: throughModelName,
        throughFields: throughFields
      });
    };

    ManyToMany.prototype.getDefault = function getDefault() {
      return [];
    };

    return ManyToMany;
  }(RelationalField);

  var OneToOne = exports.OneToOne = function (_RelationalField3) {
    (0, _inherits3.default)(OneToOne, _RelationalField3);

    function OneToOne() {
      (0, _classCallCheck3.default)(this, OneToOne);
      return (0, _possibleConstructorReturn3.default)(this, _RelationalField3.apply(this, arguments));
    }

    OneToOne.prototype.install = function install(model, fieldName, orm) {
      var toModelName = this.toModelName;
      var toModel = toModelName === 'this' ? model : orm.get(toModelName); // Forwards.

      (0, _defineProperty2.default)(model.prototype, fieldName, (0, descriptors.forwardOneToOneDescriptor)(fieldName, toModel.modelName)); // Backwards.

      var backwardsFieldName = this.relatedName ? this.relatedName : model.modelName.toLowerCase();
      var backwardsDescriptor = (0, _getOwnPropertyDescriptor2.default)(toModel.prototype, backwardsFieldName);

      if (backwardsDescriptor) {
        var errorMsg = (0, utils.reverseFieldErrorMessage)(model.modelName, fieldName, toModel.modelName, backwardsFieldName);
        throw new Error(errorMsg);
      }

      (0, _defineProperty2.default)(toModel.prototype, backwardsFieldName, (0, descriptors.backwardOneToOneDescriptor)(fieldName, model.modelName));
      toModel.virtualFields[backwardsFieldName] = new OneToOne(model.modelName, fieldName);
    };

    return OneToOne;
  }(RelationalField);
  /**
   * Defines a value attribute on the model.
   * Though not required, it is recommended to define this for each non-foreign key you wish to use.
   * Getters and setters need to be defined on each Model
   * instantiation for undeclared data fields, which is slower.
   * You can use the optional `getDefault` parameter to fill in unpassed values
   * to {@link Model#create}, such as for generating ID's with UUID:
   *
   * ```javascript
   * import getUUID from 'your-uuid-package-of-choice';
   *
   * fields = {
   *   id: attr({ getDefault: () => getUUID() }),
   *   title: attr(),
   * }
   * ```
   *
   * @param  {Object} [opts]
   * @param {Function} [opts.getDefault] - if you give a function here, it's return
   *                                       value from calling with zero arguments will
   *                                       be used as the value when creating a new Model
   *                                       instance with {@link Model#create} if the field
   *                                       value is not passed.
   * @return {Attribute}
   */


  function attr(opts) {
    return new Attribute(opts);
  }
  /**
   * Defines a foreign key on a model, which points
   * to a single entity on another model.
   *
   * You can pass arguments as either a single object,
   * or two arguments.
   *
   * If you pass two arguments, the first one is the name
   * of the Model the foreign key is pointing to, and
   * the second one is an optional related name, which will
   * be used to access the Model the foreign key
   * is being defined from, from the target Model.
   *
   * If the related name is not passed, it will be set as
   * `${toModelName}Set`.
   *
   * If you pass an object to `fk`, it has to be in the form
   *
   * ```javascript
   * fields = {
   *   author: fk({ to: 'Author', relatedName: 'books' })
   * }
   * ```
   *
   * Which is equal to
   *
   * ```javascript
   * fields = {
   *   author: fk('Author', 'books'),
   * }
   * ```
   *
   * @param  {string|boolean} toModelNameOrObj - the `modelName` property of
   *                                           the Model that is the target of the
   *                                           foreign key, or an object with properties
   *                                           `to` and optionally `relatedName`.
   * @param {string} [relatedName] - if you didn't pass an object as the first argument,
   *                                 this is the property name that will be used to
   *                                 access a QuerySet the foreign key is defined from,
   *                                 from the target model.
   * @return {ForeignKey}
   */


  function fk() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new (Function.prototype.bind.apply(ForeignKey, [null].concat(args)))();
  }
  /**
   * Defines a many-to-many relationship between
   * this (source) and another (target) model.
   *
   * The relationship is modeled with an extra model called the through model.
   * The through model has foreign keys to both the source and target models.
   *
   * You can define your own through model if you want to associate more information
   * to the relationship. A custom through model must have at least two foreign keys,
   * one pointing to the source Model, and one pointing to the target Model.
   *
   * If you have more than one foreign key pointing to a source or target Model in the
   * through Model, you must pass the option `throughFields`, which is an array of two
   * strings, where the strings are the field names that identify the foreign keys to
   * be used for the many-to-many relationship. Redux-ORM will figure out which field name
   * points to which model by checking the through Model definition.
   *
   * Unlike `fk`, this function accepts only an object argument.
   *
   * ```javascript
   * class Authorship extends Model {}
   * Authorship.modelName = 'Authorship';
   * Authorship.fields = {
   *   author: fk('Author', 'authorships'),
   *   book: fk('Book', 'authorships'),
   * };
   *
   * class Author extends Model {}
   * Author.modelName = 'Author';
   * Author.fields = {
   *   books: many({
   *     to: 'Book',
   *     relatedName: 'authors',
   *     through: 'Authorship',
   *
   *     // this is optional, since Redux-ORM can figure
   *     // out the through fields itself as there aren't
   *     // multiple foreign keys pointing to the same models.
   *     throughFields: ['author', 'book'],
   *   })
   * };
   *
   * class Book extends Model {}
   * Book.modelName = 'Book';
   * ```
   *
   * You should only define the many-to-many relationship on one side. In the
   * above case of Authors to Books through Authorships, the relationship is
   * defined only on the Author model.
   *
   * @param  {Object} options - options
   * @param  {string} options.to - the `modelName` attribute of the target Model.
   * @param  {string} [options.through] - the `modelName` attribute of the through Model which
   *                                    must declare at least one foreign key to both source and
   *                                    target Models. If not supplied, Redux-Orm will autogenerate
   *                                    one.
   * @param  {string[]} [options.throughFields] - this must be supplied only when a custom through
   *                                            Model has more than one foreign key pointing to
   *                                            either the source or target mode. In this case
   *                                            Redux-ORM can't figure out the correct fields for
   *                                            you, you must provide them. The supplied array should
   *                                            have two elements that are the field names for the
   *                                            through fields you want to declare the many-to-many
   *                                            relationship with. The order doesn't matter;
   *                                            Redux-ORM will figure out which field points to
   *                                            the source Model and which to the target Model.
   * @param  {string} [options.relatedName] - the attribute used to access a QuerySet
   *                                          of source Models from target Model.
   * @return {ManyToMany}
   */


  function many() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return new (Function.prototype.bind.apply(ManyToMany, [null].concat(args)))();
  }
  /**
   * Defines a one-to-one relationship. In database terms, this is a foreign key with the
   * added restriction that only one entity can point to single target entity.
   *
   * The arguments are the same as with `fk`. If `relatedName` is not supplied,
   * the source model name in lowercase will be used. Note that with the one-to-one
   * relationship, the `relatedName` should be in singular, not plural.
   * @param  {string|boolean} toModelNameOrObj - the `modelName` property of
   *                                           the Model that is the target of the
   *                                           foreign key, or an object with properties
   *                                           `to` and optionally `relatedName`.
   * @param {string} [relatedName] - if you didn't pass an object as the first argument,
   *                                 this is the property name that will be used to
   *                                 access a Model the foreign key is defined from,
   *                                 from the target Model.
   * @return {OneToOne}
   */


  function oneToOne() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return new (Function.prototype.bind.apply(OneToOne, [null].concat(args)))();
  }
});
unwrapExports(fields);
var fields_1 = fields.OneToOne;
var fields_2 = fields.ManyToMany;
var fields_3 = fields.ForeignKey;
var fields_4 = fields.Attribute;
var fields_5 = fields.attr;
var fields_6 = fields.fk;
var fields_7 = fields.many;
var fields_8 = fields.oneToOne;
var Model_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _toConsumableArray3 = _interopRequireDefault(toConsumableArray$1);

  var _keys2 = _interopRequireDefault(keys$4);

  var _defineProperty3 = _interopRequireDefault(defineProperty$6);

  var _assign2 = _interopRequireDefault(assign$1);

  var _classCallCheck3 = _interopRequireDefault(classCallCheck$1);

  var _createClass3 = _interopRequireDefault(createClass$1);

  var _defineProperty5 = _interopRequireDefault(defineProperty$9);

  var _forOwn2 = _interopRequireDefault(forOwn_1);

  var _uniq2 = _interopRequireDefault(uniq_1);

  var _Session2 = _interopRequireDefault(Session_1);

  var _QuerySet2 = _interopRequireDefault(QuerySet_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // Generates a query specification
  // to get a single row from a table identified
  // by a primary key.


  function getByIdQuery(modelInstance) {
    var modelClass = modelInstance.getClass();
    return {
      table: modelClass.modelName,
      clauses: [{
        type: constants.FILTER,
        payload: (0, _defineProperty5.default)({}, modelClass.idAttribute, modelInstance.getId())
      }]
    };
  }
  /**
   * The heart of an ORM, the data model.
   *
   * The fields you specify to the Model will be used to generate
   * a schema to the database, related property accessors, and
   * possibly through models.
   *
   * In each {@link Session} you instantiate from an {@link ORM} instance,
   * you will receive a session-specific subclass of this Model. The methods
   * you define here will be available to you in sessions.
   *
   * An instance of {@link Model} represents a record in the database, though
   * it is possible to generate multiple instances from the same record in the database.
   *
   * To create data models in your schema, subclass {@link Model}. To define
   * information about the data model, override static class methods. Define instance
   * logic by defining prototype methods (without `static` keyword).
   */


  var Model = function () {
    /**
     * Creates a Model instance from it's properties.
     * Don't use this to create a new record; Use the static method {@link Model#create}.
     * @param  {Object} props - the properties to instantiate with
     */
    function Model(props) {
      (0, _classCallCheck3.default)(this, Model);

      this._initFields(props);
    }

    Model.prototype._initFields = function _initFields(props) {
      var _this = this;

      this._fields = (0, _assign2.default)({}, props);
      (0, _forOwn2.default)(props, function (fieldValue, fieldName) {
        // In this case, we got a prop that wasn't defined as a field.
        // Assuming it's an arbitrary data field, making an instance-specific
        // descriptor for it.
        // Using the in operator as the property could be defined anywhere
        // on the prototype chain.
        if (!(fieldName in _this)) {
          (0, _defineProperty3.default)(_this, fieldName, {
            get: function get() {
              return _this._fields[fieldName];
            },
            set: function set(value) {
              return _this.set(fieldName, value);
            },
            configurable: true,
            enumerable: true
          });
        }
      });
    };

    Model.toString = function toString() {
      return 'ModelClass: ' + this.modelName;
    };
    /**
     * Returns the options object passed to the database for the table that represents
     * this Model class.
     *
     * Returns an empty object by default, which means the database
     * will use default options. You can either override this function to return the options
     * you want to use, or assign the options object as a static property of the same name to the
     * Model class.
     *
     * @return {Object} the options object passed to the database for the table
     *                  representing this Model class.
     */


    Model.options = function options() {
      return {};
    };

    Model._getTableOpts = function _getTableOpts() {
      if (typeof this.backend === 'function') {
        (0, utils.warnDeprecated)('Model.backend is deprecated. Please rename to .options');
        return this.backend();
      } else if (this.backend) {
        (0, utils.warnDeprecated)('Model.backend is deprecated. Please rename to .options');
        return this.backend;
      } else if (typeof this.options === 'function') {
        return this.options();
      }

      return this.options;
    };

    Model.markAccessed = function markAccessed() {
      this.session.markAccessed(this);
    };
    /**
     * Returns the id attribute of this {@link Model}.
     *
     * @return {string} The id attribute of this {@link Model}.
     */

    /**
     * Connect the model class to a {@link Session}.
     *
     * @private
     * @param  {Session} session - The session to connect to.
     */


    Model.connect = function connect(session) {
      if (!(session instanceof _Session2.default)) {
        throw Error('A model can only connect to a Session instance.');
      }

      this._session = session;
    };
    /**
     * Get the current {@link Session} instance.
     *
     * @private
     * @return {Session} The current {@link Session} instance.
     */


    Model.getQuerySet = function getQuerySet() {
      var QuerySetClass = this.querySetClass;
      return new QuerySetClass(this);
    };

    Model.invalidateClassCache = function invalidateClassCache() {
      this.isSetUp = undefined;
      this.virtualFields = {};
    };
    /**
     * Returns a {@link QuerySet} containing all {@link Model} instances.
     * @return {QuerySet} a QuerySet containing all {@link Model} instances
     */


    Model.all = function all() {
      return this.getQuerySet();
    };
    /**
     * Update many-many relations for model.
     * @param relations
     */


    Model.prototype._refreshMany2Many = function _refreshMany2Many(relations) {
      var _this2 = this;

      var ThisModel = this.getClass();
      var fields$$1 = ThisModel.fields;
      var virtualFields = ThisModel.virtualFields;
      (0, _keys2.default)(relations).forEach(function (name) {
        var reverse = !fields$$1.hasOwnProperty(name);
        var field = virtualFields[name];
        var values = relations[name];
        var normalizedNewIds = values.map(utils.normalizeEntity);
        var uniqueIds = (0, _uniq2.default)(normalizedNewIds);

        if (normalizedNewIds.length !== uniqueIds.length) {
          throw new Error('Found duplicate id(s) when passing "' + normalizedNewIds + '" to ' + ThisModel.modelName + '.' + name + ' value');
        }

        var throughModelName = field.through || (0, utils.m2mName)(ThisModel.modelName, name);
        var ThroughModel = ThisModel.session[throughModelName];
        var fromField = void 0;
        var toField = void 0;

        if (!reverse) {
          var _field$throughFields = field.throughFields;
          fromField = _field$throughFields.from;
          toField = _field$throughFields.to;
        } else {
          var _field$throughFields2 = field.throughFields;
          toField = _field$throughFields2.from;
          fromField = _field$throughFields2.to;
        }

        var currentIds = ThroughModel.filter(function (through) {
          return through[fromField] === _this2[ThisModel.idAttribute];
        }).toRefArray().map(function (ref) {
          return ref[toField];
        });
        var diffActions = (0, utils.arrayDiffActions)(currentIds, normalizedNewIds);

        if (diffActions) {
          var idsToDelete = diffActions.delete;
          var idsToAdd = diffActions.add;

          if (idsToDelete.length > 0) {
            var _name;

            (_name = _this2[name]).remove.apply(_name, (0, _toConsumableArray3.default)(idsToDelete));
          }

          if (idsToAdd.length > 0) {
            var _name2;

            (_name2 = _this2[name]).add.apply(_name2, (0, _toConsumableArray3.default)(idsToAdd));
          }
        }
      });
    };
    /**
     * Creates a new record in the database, instantiates a {@link Model} and returns it.
     *
     * If you pass values for many-to-many fields, instances are created on the through
     * model as well.
     *
     * @param  {props} userProps - the new {@link Model}'s properties.
     * @return {Model} a new {@link Model} instance.
     */


    Model.create = function create(userProps) {
      var _this3 = this;

      var props = (0, _assign2.default)({}, userProps);
      var m2mRelations = {};
      var declaredFieldNames = (0, _keys2.default)(this.fields);
      var declaredVirtualFieldNames = (0, _keys2.default)(this.virtualFields);
      declaredFieldNames.forEach(function (key) {
        var field = _this3.fields[key];
        var valuePassed = userProps.hasOwnProperty(key);

        if (!(field instanceof fields.ManyToMany)) {
          if (valuePassed) {
            var value = userProps[key];
            props[key] = (0, utils.normalizeEntity)(value);
          } else if (field.getDefault) {
            props[key] = field.getDefault();
          }
        } else if (valuePassed) {
          // If a value is supplied for a ManyToMany field,
          // discard them from props and save for later processing.
          m2mRelations[key] = userProps[key];
          delete props[key];
        }
      }); // add backward many-many if required

      declaredVirtualFieldNames.forEach(function (key) {
        if (!m2mRelations.hasOwnProperty(key)) {
          var field = _this3.virtualFields[key];

          if (userProps.hasOwnProperty(key) && field instanceof fields.ManyToMany) {
            // If a value is supplied for a ManyToMany field,
            // discard them from props and save for later processing.
            m2mRelations[key] = userProps[key];
            delete props[key];
          }
        }
      });
      var newEntry = this.session.applyUpdate({
        action: constants.CREATE,
        table: this.modelName,
        payload: props
      });
      var ModelClass = this;
      var instance = new ModelClass(newEntry);

      instance._refreshMany2Many(m2mRelations); // eslint-disable-line no-underscore-dangle


      return instance;
    };
    /**
     * Creates a new or update existing record in the database, instantiates a {@link Model} and returns it.
     *
     * If you pass values for many-to-many fields, instances are created on the through
     * model as well.
     *
     * @param  {props} userProps - the required {@link Model}'s properties.
     * @return {Model} a {@link Model} instance.
     */


    Model.upsert = function upsert(userProps) {
      var idAttr = this.idAttribute;

      if (userProps.hasOwnProperty(idAttr) && this.hasId(userProps[idAttr])) {
        var model = this.withId(userProps[idAttr]);
        model.update(userProps);
        return model;
      }

      return this.create(userProps);
    };
    /**
     * Returns a {@link Model} instance for the object with id `id`.
     * This throws if the `id` doesn't exist. Use {@link Model#hasId}
     * to check for existence first if you're not certain.
     *
     * @param  {*} id - the `id` of the object to get
     * @throws If object with id `id` doesn't exist
     * @return {Model} {@link Model} instance with id `id`
     */


    Model.withId = function withId(id) {
      var ModelClass = this;

      var rows = this._findDatabaseRows((0, _defineProperty5.default)({}, ModelClass.idAttribute, id));

      if (rows.length === 0) {
        throw new Error(ModelClass.modelName + ' instance with id ' + id + ' not found');
      }

      return new ModelClass(rows[0]);
    };
    /**
     * Returns a boolean indicating if an entity with the id `id` exists
     * in the state.
     *
     * @param  {*}  id - a value corresponding to the id attribute of the {@link Model} class.
     * @return {Boolean} a boolean indicating if entity with `id` exists in the state
     */


    Model.hasId = function hasId(id) {
      var rows = this._findDatabaseRows((0, _defineProperty5.default)({}, this.idAttribute, id));

      return rows.length === 1;
    };

    Model._findDatabaseRows = function _findDatabaseRows(lookupObj) {
      var ModelClass = this;
      return ModelClass.session.query({
        table: ModelClass.modelName,
        clauses: [{
          type: constants.FILTER,
          payload: lookupObj
        }]
      }).rows;
    };
    /**
     * Gets the {@link Model} instance that matches properties in `lookupObj`.
     * Throws an error if {@link Model} is not found, or multiple records match
     * the properties.
     *
     * @param  {Object} lookupObj - the properties used to match a single entity.
     * @return {Model} a {@link Model} instance that matches `lookupObj` properties.
     */


    Model.get = function get(lookupObj) {
      var ModelClass = this;

      var rows = this._findDatabaseRows(lookupObj);

      if (rows.length === 0) {
        throw new Error('Model instance not found when calling get method');
      } else if (rows.length > 1) {
        throw new Error('Expected to find a single row in Model.get. Found ' + rows.length + '.');
      }

      return new ModelClass(rows[0]);
    };
    /**
     * Gets the {@link Model} class or subclass constructor (the class that
     * instantiated this instance).
     *
     * @return {Model} The {@link Model} class or subclass constructor used to instantiate
     *                 this instance.
     */


    Model.prototype.getClass = function getClass() {
      return this.constructor;
    };
    /**
     * Gets the id value of the current instance by looking up the id attribute.
     * @return {*} The id value of the current instance.
     */


    Model.prototype.getId = function getId() {
      return this._fields[this.getClass().idAttribute];
    };
    /**
     * Returns a reference to the plain JS object in the store.
     * Make sure to not mutate this.
     *
     * @return {Object} a reference to the plain JS object in the store
     */

    /**
     * Returns a string representation of the {@link Model} instance.
     *
     * @return {string} A string representation of this {@link Model} instance.
     */


    Model.prototype.toString = function toString() {
      var _this4 = this;

      var ThisModel = this.getClass();
      var className = ThisModel.modelName;
      var fieldNames = (0, _keys2.default)(ThisModel.fields);
      var fields$$1 = fieldNames.map(function (fieldName) {
        var field = ThisModel.fields[fieldName];

        if (field instanceof fields.ManyToMany) {
          var ids = _this4[fieldName].toModelArray().map(function (model) {
            return model.getId();
          });

          return fieldName + ': [' + ids.join(', ') + ']';
        }

        var val = _this4._fields[fieldName];
        return fieldName + ': ' + val;
      }).join(', ');
      return className + ': {' + fields$$1 + '}';
    };
    /**
     * Returns a boolean indicating if `otherModel` equals this {@link Model} instance.
     * Equality is determined by shallow comparing their attributes.
     *
     * @param  {Model} otherModel - a {@link Model} instance to compare
     * @return {Boolean} a boolean indicating if the {@link Model} instance's are equal.
     */


    Model.prototype.equals = function equals(otherModel) {
      // eslint-disable-next-line no-underscore-dangle
      return (0, utils.objectShallowEquals)(this._fields, otherModel._fields);
    };
    /**
     * Updates a property name to given value for this {@link Model} instance.
     * The values are immediately committed to the database.
     *
     * @param {string} propertyName - name of the property to set
     * @param {*} value - value assigned to the property
     * @return {undefined}
     */


    Model.prototype.set = function set(propertyName, value) {
      this.update((0, _defineProperty5.default)({}, propertyName, value));
    };
    /**
     * Assigns multiple fields and corresponding values to this {@link Model} instance.
     * The updates are immediately committed to the database.
     *
     * @param  {Object} userMergeObj - an object that will be merged with this instance.
     * @return {undefined}
     */


    Model.prototype.update = function update(userMergeObj) {
      var ThisModel = this.getClass();
      var mergeObj = (0, _assign2.default)({}, userMergeObj);
      var fields$$1 = ThisModel.fields;
      var virtualFields = ThisModel.virtualFields;
      var m2mRelations = {}; // If an array of entities or id's is supplied for a
      // many-to-many related field, clear the old relations
      // and add the new ones.

      for (var mergeKey in mergeObj) {
        // eslint-disable-line no-restricted-syntax, guard-for-in
        var isRealField = fields$$1.hasOwnProperty(mergeKey);

        if (isRealField) {
          var field = fields$$1[mergeKey];

          if (field instanceof fields.ForeignKey || field instanceof fields.OneToOne) {
            // update one-one/fk relations
            mergeObj[mergeKey] = (0, utils.normalizeEntity)(mergeObj[mergeKey]);
          } else if (field instanceof fields.ManyToMany) {
            // field is forward relation
            m2mRelations[mergeKey] = mergeObj[mergeKey];
            delete mergeObj[mergeKey];
          }
        } else if (virtualFields.hasOwnProperty(mergeKey)) {
          var _field = virtualFields[mergeKey];

          if (_field instanceof fields.ManyToMany) {
            // field is backward relation
            m2mRelations[mergeKey] = mergeObj[mergeKey];
            delete mergeObj[mergeKey];
          }
        }
      }

      this._initFields((0, _assign2.default)({}, this._fields, mergeObj));

      this._refreshMany2Many(m2mRelations); // eslint-disable-line no-underscore-dangle


      ThisModel.session.applyUpdate({
        action: constants.UPDATE,
        query: getByIdQuery(this),
        payload: mergeObj
      });
    };
    /**
     * Updates {@link Model} instance attributes to reflect the
     * database state in the current session.
     * @return {undefined}
     */


    Model.prototype.refreshFromState = function refreshFromState() {
      this._initFields(this.ref);
    };
    /**
     * Deletes the record for this {@link Model} instance.
     * You'll still be able to access fields and values on the instance.
     *
     * @return {undefined}
     */


    Model.prototype.delete = function _delete() {
      this._onDelete();

      this.getClass().session.applyUpdate({
        action: constants.DELETE,
        query: getByIdQuery(this)
      });
    };

    Model.prototype._onDelete = function _onDelete() {
      var virtualFields = this.getClass().virtualFields;

      for (var key in virtualFields) {
        // eslint-disable-line
        var field = virtualFields[key];

        if (field instanceof fields.ManyToMany) {
          // Delete any many-to-many rows the entity is included in.
          this[key].clear();
        } else if (field instanceof fields.ForeignKey) {
          var relatedQs = this[key];

          if (relatedQs.exists()) {
            relatedQs.update((0, _defineProperty5.default)({}, field.relatedName, null));
          }
        } else if (field instanceof fields.OneToOne) {
          // Set null to any foreign keys or one to ones pointed to
          // this instance.
          if (this[key] !== null) {
            this[key][field.relatedName] = null;
          }
        }
      }
    }; // DEPRECATED AND REMOVED METHODS


    Model.prototype.getNextState = function getNextState() {
      throw new Error('Model.prototype.getNextState is removed. See the 0.9 ' + 'migration guide on the GitHub repo.');
    };

    (0, _createClass3.default)(Model, [{
      key: 'ref',
      get: function get() {
        var ModelClass = this.getClass(); // eslint-disable-next-line no-underscore-dangle

        return ModelClass._findDatabaseRows((0, _defineProperty5.default)({}, ModelClass.idAttribute, this.getId()))[0];
      }
    }], [{
      key: '_sessionData',
      get: function get() {
        if (!this.session) return {};
        return this.session.getDataForModel(this.modelName);
      }
    }, {
      key: 'idAttribute',
      get: function get() {
        return this.session.db.describe(this.modelName).idAttribute;
      }
    }, {
      key: 'session',
      get: function get() {
        return this._session;
      }
    }, {
      key: 'query',
      get: function get() {
        return this.getQuerySet();
      }
    }]);
    return Model;
  }();

  Model.fields = {
    id: (0, fields.attr)()
  };
  Model.virtualFields = {};
  Model.querySetClass = _QuerySet2.default;
  exports.default = Model;
});
unwrapExports(Model_1);
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */

function createFind(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);

    if (!isArrayLike_1(collection)) {
      var iteratee = _baseIteratee(predicate, 3);

      collection = keys_1(collection);

      predicate = function predicate(key) {
        return iteratee(iterable[key], key, iterable);
      };
    }

    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$2 = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */

function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;

  if (!length) {
    return -1;
  }

  var index = fromIndex == null ? 0 : toInteger_1(fromIndex);

  if (index < 0) {
    index = nativeMax$2(length + index, 0);
  }

  return _baseFindIndex(array, _baseIteratee(predicate, 3), index);
}

var findIndex_1 = findIndex;
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */

var find = _createFind(findIndex_1);

var find_1 = find;
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }

    if (!isArrayLike_1(collection)) {
      return eachFunc(collection, iteratee);
    }

    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }

    return collection;
  };
}

var _createBaseEach = createBaseEach;
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */

var baseEach = _createBaseEach(_baseForOwn);

var _baseEach = baseEach;
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function baseFilter(collection, predicate) {
  var result = [];

  _baseEach(collection, function (value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });

  return result;
}

var _baseFilter = baseFilter;
/** Error message constants. */

var FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */

function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  return function () {
    var args = arguments;

    switch (args.length) {
      case 0:
        return !predicate.call(this);

      case 1:
        return !predicate.call(this, args[0]);

      case 2:
        return !predicate.call(this, args[0], args[1]);

      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }

    return !predicate.apply(this, args);
  };
}

var negate_1 = negate;
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */

function reject(collection, predicate) {
  var func = isArray_1(collection) ? _arrayFilter : _baseFilter;
  return func(collection, negate_1(_baseIteratee(predicate, 3)));
}

var reject_1 = reject;
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */

function filter(collection, predicate) {
  var func = isArray_1(collection) ? _arrayFilter : _baseFilter;
  return func(collection, _baseIteratee(predicate, 3));
}

var filter_1 = filter;
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike_1(collection) ? Array(collection.length) : [];

  _baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });

  return result;
}

var _baseMap = baseMap;
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy(array, comparer) {
  var length = array.length;
  array.sort(comparer);

  while (length--) {
    array[length] = array[length].value;
  }

  return array;
}

var _baseSortBy = baseSortBy;
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */

function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol_1(value);
    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol_1(other);

    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }

    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }

  return 0;
}

var _compareAscending = compareAscending;
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */

function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = _compareAscending(objCriteria[index], othCriteria[index]);

    if (result) {
      if (index >= ordersLength) {
        return result;
      }

      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


  return object.index - other.index;
}

var _compareMultiple = compareMultiple;
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */

function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = _arrayMap(iteratees.length ? iteratees : [identity_1], _baseUnary(_baseIteratee));

  var result = _baseMap(collection, function (value, key, collection) {
    var criteria = _arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });

    return {
      'criteria': criteria,
      'index': ++index,
      'value': value
    };
  });

  return _baseSortBy(result, function (object, other) {
    return _compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy;
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */

function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }

  if (!isArray_1(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }

  orders = guard ? undefined : orders;

  if (!isArray_1(orders)) {
    orders = orders == null ? [] : [orders];
  }

  return _baseOrderBy(collection, iteratees, orders);
}

var orderBy_1 = orderBy;
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */

function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }

  var type = typeof index;

  if (type == 'number' ? isArrayLike_1(object) && _isIndex(index, object.length) : type == 'string' && index in object) {
    return eq_1(object[index], value);
  }

  return false;
}

var _isIterateeCall = isIterateeCall;
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */

var sortBy = _baseRest(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }

  var length = iteratees.length;

  if (length > 1 && _isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && _isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }

  return _baseOrderBy(collection, _baseFlatten(iteratees, 1), []);
});

var sortBy_1 = sortBy;
var Table_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty3 = _interopRequireDefault(defineProperty$9);

  var _slicedToArray3 = _interopRequireDefault(slicedToArray$1);

  var _assign2 = _interopRequireDefault(assign$1);

  var _classCallCheck3 = _interopRequireDefault(classCallCheck$1);

  var _reject2 = _interopRequireDefault(reject_1);

  var _filter2 = _interopRequireDefault(filter_1);

  var _orderBy2 = _interopRequireDefault(orderBy_1);

  var _sortBy2 = _interopRequireDefault(sortBy_1);

  var _immutableOps2 = _interopRequireDefault(lib$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var DEFAULT_OPTS = {
    idAttribute: 'id',
    arrName: 'items',
    mapName: 'itemsById'
  }; // Input is the current max id and the new id passed to the create action.
  // Both may be undefined. The current max id in the case that this is the first Model
  // being created, and the new id if the id was not explicitly passed to the
  // database.
  //
  // Return value is the new max id and the id to use to create the new row.
  // If the id's are strings, the id must be passed explicitly every time.
  // In this case, the current max id will remain `NaN` due to `Math.max`, but that's fine.

  function idSequencer(_currMax, userPassedId) {
    var currMax = _currMax;
    var newMax = void 0;
    var newId = void 0;

    if (currMax === undefined) {
      currMax = -1;
    }

    if (userPassedId === undefined) {
      newMax = currMax + 1;
      newId = newMax;
    } else {
      newMax = Math.max(currMax + 1, userPassedId);
      newId = userPassedId;
    }

    return [newMax, // new max id
    newId];
  }
  /**
   * Handles the underlying data structure for a {@link Model} class.
   */


  var Table = function () {
    /**
     * Creates a new {@link Table} instance.
     * @param  {Object} userOpts - options to use.
     * @param  {string} [userOpts.idAttribute=id] - the id attribute of the entity.
     * @param  {string} [userOpts.arrName=items] - the state attribute where an array of
     *                                             entity id's are stored
     * @param  {string} [userOpts.mapName=itemsById] - the state attribute where the entity objects
     *                                                 are stored in a id to entity object
     *                                                 map.
     */
    function Table(userOpts) {
      (0, _classCallCheck3.default)(this, Table);
      (0, _assign2.default)(this, DEFAULT_OPTS, userOpts);
    }
    /**
     * Returns a reference to the object at index `id`
     * in state `branch`.
     *
     * @param  {Object} branch - the state
     * @param  {Number} id - the id of the object to get
     * @return {Object|undefined} A reference to the raw object in the state or
     *                            `undefined` if not found.
     */


    Table.prototype.accessId = function accessId(branch, id) {
      return branch[this.mapName][id];
    };

    Table.prototype.idExists = function idExists(branch, id) {
      return branch[this.mapName].hasOwnProperty(id);
    };

    Table.prototype.accessIdList = function accessIdList(branch) {
      return branch[this.arrName];
    };

    Table.prototype.accessList = function accessList(branch) {
      var _this = this;

      return branch[this.arrName].map(function (id) {
        return _this.accessId(branch, id);
      });
    };

    Table.prototype.getMaxId = function getMaxId(branch) {
      return this.getMeta(branch, 'maxId');
    };

    Table.prototype.setMaxId = function setMaxId(tx, branch, newMaxId) {
      return this.setMeta(tx, branch, 'maxId', newMaxId);
    };

    Table.prototype.nextId = function nextId(id) {
      return id + 1;
    };

    Table.prototype.query = function query(branch, clauses) {
      var _this2 = this;

      var optimizedClauses = (0, _sortBy2.default)(clauses, function (_ref) {
        var type = _ref.type,
            payload = _ref.payload;

        if (type === constants.FILTER && payload.hasOwnProperty(_this2.idAttribute)) {
          return 1;
        }

        if (type === constants.FILTER || type === constants.EXCLUDE) {
          return 2;
        }

        return 3;
      });
      return optimizedClauses.reduce(function (rows, _ref2, index) {
        var type = _ref2.type,
            payload = _ref2.payload;

        switch (type) {
          case constants.FILTER:
            {
              var idAttribute = _this2.idAttribute;
              var id = payload[idAttribute];

              if (index === 0 && payload.hasOwnProperty(idAttribute) && id !== null && id !== undefined) {
                // Payload specified a primary key; Since that is unique, we can directly
                // return that.
                return _this2.idExists(branch, id) ? [_this2.accessId(branch, id)] : [];
              }

              return (0, _filter2.default)(rows, payload);
            }

          case constants.EXCLUDE:
            {
              return (0, _reject2.default)(rows, payload);
            }

          case constants.ORDER_BY:
            {
              var _payload = (0, _slicedToArray3.default)(payload, 2),
                  iteratees = _payload[0],
                  orders = _payload[1];

              return (0, _orderBy2.default)(rows, iteratees, orders);
            }

          default:
            return rows;
        }
      }, this.accessList(branch));
    };
    /**
     * Returns the default state for the data structure.
     * @return {Object} The default state for this {@link Backend} instance's data structure
     */


    Table.prototype.getEmptyState = function getEmptyState() {
      var _ref3;

      return _ref3 = {}, (0, _defineProperty3.default)(_ref3, this.arrName, []), (0, _defineProperty3.default)(_ref3, this.mapName, {}), (0, _defineProperty3.default)(_ref3, 'meta', {}), _ref3;
    };

    Table.prototype.setMeta = function setMeta(tx, branch, key, value) {
      var batchToken = tx.batchToken,
          withMutations = tx.withMutations;

      if (withMutations) {
        var res = _immutableOps2.default.mutable.setIn(['meta', key], value, branch);

        return res;
      }

      return _immutableOps2.default.batch.setIn(batchToken, ['meta', key], value, branch);
    };

    Table.prototype.getMeta = function getMeta(branch, key) {
      return branch.meta[key];
    };
    /**
     * Returns the data structure including a new object `entry`
     * @param  {Object} tx - transaction info
     * @param  {Object} branch - the data structure state
     * @param  {Object} entry - the object to insert
     * @return {Object} an object with two keys: `state` and `created`.
     *                  `state` is the new table state and `created` is the
     *                  row that was created.
     */


    Table.prototype.insert = function insert(tx, branch, entry) {
      var _ops$batch$merge2;

      var batchToken = tx.batchToken,
          withMutations = tx.withMutations;
      var hasId = entry.hasOwnProperty(this.idAttribute);
      var workingState = branch; // This will not affect string id's.

      var _idSequencer = idSequencer(this.getMaxId(branch), entry[this.idAttribute]),
          _idSequencer2 = (0, _slicedToArray3.default)(_idSequencer, 2),
          newMaxId = _idSequencer2[0],
          id = _idSequencer2[1];

      workingState = this.setMaxId(tx, branch, newMaxId);
      var finalEntry = hasId ? entry : _immutableOps2.default.batch.set(batchToken, this.idAttribute, id, entry);

      if (withMutations) {
        _immutableOps2.default.mutable.push(id, workingState[this.arrName]);

        _immutableOps2.default.mutable.set(id, finalEntry, workingState[this.mapName]);

        return {
          state: workingState,
          created: finalEntry
        };
      }

      var nextState = _immutableOps2.default.batch.merge(batchToken, (_ops$batch$merge2 = {}, (0, _defineProperty3.default)(_ops$batch$merge2, this.arrName, _immutableOps2.default.batch.push(batchToken, id, workingState[this.arrName])), (0, _defineProperty3.default)(_ops$batch$merge2, this.mapName, _immutableOps2.default.batch.merge(batchToken, (0, _defineProperty3.default)({}, id, finalEntry), workingState[this.mapName])), _ops$batch$merge2), workingState);

      return {
        state: nextState,
        created: finalEntry
      };
    };
    /**
     * Returns the data structure with objects where `rows`
     * are merged with `mergeObj`.
     *
     * @param  {Object} tx - transaction info
     * @param  {Object} branch - the data structure state
     * @param  {Object[]} rows - rows to update
     * @param  {Object} mergeObj - The object to merge with each row.
     * @return {Object}
     */


    Table.prototype.update = function update(tx, branch, rows, mergeObj) {
      var _this3 = this;

      var batchToken = tx.batchToken,
          withMutations = tx.withMutations;
      var mapName = this.mapName;

      var mapFunction = function mapFunction(row) {
        var merge = withMutations ? _immutableOps2.default.mutable.merge : _immutableOps2.default.batch.merge(batchToken);
        return merge(mergeObj, row);
      };

      var set = withMutations ? _immutableOps2.default.mutable.set : _immutableOps2.default.batch.set(batchToken);
      var newMap = rows.reduce(function (map, row) {
        var result = mapFunction(row);
        return set(result[_this3.idAttribute], result, map);
      }, branch[mapName]);
      return _immutableOps2.default.batch.set(batchToken, mapName, newMap, branch);
    };
    /**
     * Returns the data structure without rows `rows`.
     * @param  {Object} tx - transaction info
     * @param  {Object} branch - the data structure state
     * @param  {Object[]} rows - rows to update
     * @return {Object} the data structure without ids in `idsToDelete`.
     */


    Table.prototype.delete = function _delete(tx, branch, rows) {
      var _this4 = this,
          _ops$batch$merge3;

      var batchToken = tx.batchToken,
          withMutations = tx.withMutations;
      var arrName = this.arrName,
          mapName = this.mapName;
      var arr = branch[arrName];
      var idsToDelete = rows.map(function (row) {
        return row[_this4.idAttribute];
      });

      if (withMutations) {
        idsToDelete.forEach(function (id) {
          var idx = arr.indexOf(id);

          if (idx !== -1) {
            _immutableOps2.default.mutable.splice(idx, 1, [], arr);
          }

          _immutableOps2.default.mutable.omit(id, branch[mapName]);
        });
        return branch;
      }

      return _immutableOps2.default.batch.merge(batchToken, (_ops$batch$merge3 = {}, (0, _defineProperty3.default)(_ops$batch$merge3, arrName, _immutableOps2.default.batch.filter(batchToken, function (id) {
        return !(0, utils.includes)(idsToDelete, id);
      }, branch[arrName])), (0, _defineProperty3.default)(_ops$batch$merge3, mapName, _immutableOps2.default.batch.omit(batchToken, idsToDelete, branch[mapName])), _ops$batch$merge3), branch);
    };

    return Table;
  }();

  exports.default = Table;
});
unwrapExports(Table_1);
var Database = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createDatabase = createDatabase;

  var _mapValues2 = _interopRequireDefault(mapValues_1);

  var _immutableOps2 = _interopRequireDefault(lib$1);

  var _Table2 = _interopRequireDefault(Table_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function replaceTableState(tableName, newTableState, tx, state) {
    var batchToken = tx.batchToken,
        withMutations = tx.withMutations;

    if (withMutations) {
      state[tableName] = newTableState;
      return state;
    }

    return _immutableOps2.default.batch.set(batchToken, tableName, newTableState, state);
  }

  function query(tables, querySpec, state) {
    var tableName = querySpec.table,
        clauses = querySpec.clauses;
    var table = tables[tableName];
    var rows = table.query(state[tableName], clauses);
    return {
      rows: rows
    };
  }

  function update(tables, updateSpec, tx, state) {
    var action = updateSpec.action,
        payload = updateSpec.payload;
    var tableName = void 0;
    var nextTableState = void 0;
    var resultPayload = void 0;

    if (action === constants.CREATE) {
      tableName = updateSpec.table;
      var table = tables[tableName];
      var currTableState = state[tableName];
      var result = table.insert(tx, currTableState, payload);
      nextTableState = result.state;
      resultPayload = result.created;
    } else {
      var querySpec = updateSpec.query;
      tableName = querySpec.table;

      var _query = query(tables, querySpec, state),
          rows = _query.rows;

      var _table = tables[tableName];
      var _currTableState = state[tableName];

      if (action === constants.UPDATE) {
        nextTableState = _table.update(tx, _currTableState, rows, payload);
      } else if (action === constants.DELETE) {
        nextTableState = _table.delete(tx, _currTableState, rows);
      } else {
        throw new Error('Database received unknown update type: ' + action);
      }
    }

    var nextDBState = replaceTableState(tableName, nextTableState, tx, state);
    return {
      status: constants.SUCCESS,
      state: nextDBState,
      payload: resultPayload
    };
  }

  function createDatabase(schemaSpec) {
    var tablesSpec = schemaSpec.tables;
    var tables = (0, _mapValues2.default)(tablesSpec, function (tableSpec) {
      return new _Table2.default(tableSpec);
    });

    var getEmptyState = function getEmptyState() {
      return (0, _mapValues2.default)(tables, function (table) {
        return table.getEmptyState();
      });
    };

    return {
      getEmptyState: getEmptyState,
      query: query.bind(null, tables),
      update: update.bind(null, tables),
      // Used to inspect the schema.
      describe: function describe(tableName) {
        return tables[tableName];
      }
    };
  }

  exports.default = createDatabase;
});
unwrapExports(Database);
var Database_1 = Database.createDatabase;
var db = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createDatabase = undefined;

  var _Database2 = _interopRequireDefault(Database);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.createDatabase = _Database2.default;
  exports.default = _Database2.default;
});
unwrapExports(db);
var db_1 = db.createDatabase;
var lib$2 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.defaultMemoize = defaultMemoize;
  exports.createSelectorCreator = createSelectorCreator;
  exports.createStructuredSelector = createStructuredSelector;

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function defaultEqualityCheck(a, b) {
    return a === b;
  }

  function defaultMemoize(func) {
    var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
    var lastArgs = null;
    var lastResult = null;
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
        return equalityCheck(value, lastArgs[index]);
      })) {
        lastResult = func.apply(undefined, args);
      }

      lastArgs = args;
      return lastResult;
    };
  }

  function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

    if (!dependencies.every(function (dep) {
      return typeof dep === 'function';
    })) {
      var dependencyTypes = dependencies.map(function (dep) {
        return typeof dep;
      }).join(', ');
      throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }

    return dependencies;
  }

  function createSelectorCreator(memoize) {
    for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      memoizeOptions[_key2 - 1] = arguments[_key2];
    }

    return function () {
      for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        funcs[_key3] = arguments[_key3];
      }

      var recomputations = 0;
      var resultFunc = funcs.pop();
      var dependencies = getDependencies(funcs);
      var memoizedResultFunc = memoize.apply(undefined, [function () {
        recomputations++;
        return resultFunc.apply(undefined, arguments);
      }].concat(memoizeOptions));

      var selector = function selector(state, props) {
        for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
          args[_key4 - 2] = arguments[_key4];
        }

        var params = dependencies.map(function (dependency) {
          return dependency.apply(undefined, [state, props].concat(args));
        });
        return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
      };

      selector.resultFunc = resultFunc;

      selector.recomputations = function () {
        return recomputations;
      };

      selector.resetRecomputations = function () {
        return recomputations = 0;
      };

      return selector;
    };
  }

  var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

  function createStructuredSelector(selectors) {
    var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

    if (typeof selectors !== 'object') {
      throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    }

    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function (key) {
      return selectors[key];
    }), function () {
      for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        values[_key5] = arguments[_key5];
      }

      return values.reduce(function (composition, value, index) {
        composition[objectKeys[index]] = value;
        return composition;
      }, {});
    });
  }
});
unwrapExports(lib$2);
var lib_1$1 = lib$2.defaultMemoize;
var lib_2$1 = lib$2.createSelectorCreator;
var lib_3$1 = lib$2.createStructuredSelector;
var lib_4$1 = lib$2.createSelector;
var memoize_1$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _toConsumableArray3 = _interopRequireDefault(toConsumableArray$1);

  exports.eqCheck = eqCheck;
  exports.memoize = memoize;

  var _values2 = _interopRequireDefault(values_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function eqCheck(a, b) {
    return a === b;
  }

  function shouldRun(invalidatorMap, state) {
    return (0, _values2.default)(invalidatorMap).some(function (invalidate) {
      return invalidate(state);
    });
  }
  /**
   * A memoizer to use with redux-orm
   * selectors. When the memoized function is first run,
   * the memoizer will remember the models that are accessed
   * during that function run.
   *
   * On subsequent runs, the memoizer will check if those
   * models' states have changed compared to the previous run.
   *
   * Memoization algorithm operates like this:
   *
   * 1. Has the selector been run before? If not, go to 5.
   *
   * 2. If the selector has other input selectors in addition to the
   *    ORM state selector, check their results for equality with the previous results.
   *    If they aren't equal, go to 5.
   *
   * 3. Is the ORM state referentially equal to the previous ORM state the selector
   *    was called with? If yes, return the previous result.
   *
   * 4. Check which Model's states the selector has accessed on previous runs.
   *    Check for equality with each of those states versus their states in the
   *    previous ORM state. If all of them are equal, return the previous result.
   *
   * 5. Run the selector. Check the Session object used by the selector for
   *    which Model's states were accessed, and merge them with the previously
   *    saved information about accessed models (if-else branching can change
   *    which models are accessed on different inputs). Save the ORM state and
   *    other arguments the selector was called with, overriding previously
   *    saved values. Save the selector result. Return the selector result.
   *
   * @private
   * @param  {Function} func - function to memoize
   * @param  {Function} equalityCheck - equality check function to use with normal
   *                                  selector args
   * @param  {ORM} orm - a redux-orm ORM instance
   * @return {Function} `func` memoized.
   */


  function memoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eqCheck;
    var orm = arguments[2];
    var lastOrmState = null;
    var lastResult = null;
    var lastArgs = null;
    var modelNameToInvalidatorMap = {};
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var dbState = args[0],
          otherArgs = args.slice(1);
      var dbIsEqual = lastOrmState === dbState || !shouldRun(modelNameToInvalidatorMap, dbState);
      var argsAreEqual = lastArgs && otherArgs.every(function (value, index) {
        return equalityCheck(value, lastArgs[index]);
      });

      if (dbIsEqual && argsAreEqual) {
        return lastResult;
      }

      var session = orm.session(dbState);
      var newArgs = [session].concat((0, _toConsumableArray3.default)(otherArgs));
      var result = func.apply(undefined, (0, _toConsumableArray3.default)(newArgs)); // If a selector has control flow branching, different
      // input arguments might result in a different set of
      // accessed models. On each run, we check if any new
      // models are accessed and add their invalidator functions.

      session.accessedModels.forEach(function (modelName) {
        if (!modelNameToInvalidatorMap.hasOwnProperty(modelName)) {
          modelNameToInvalidatorMap[modelName] = function (nextState) {
            return lastOrmState[modelName] !== nextState[modelName];
          };
        }
      });
      lastResult = result;
      lastOrmState = dbState;
      lastArgs = otherArgs;
      return lastResult;
    };
  }
});
unwrapExports(memoize_1$1);
var memoize_2 = memoize_1$1.eqCheck;
var memoize_3 = memoize_1$1.memoize;
var redux$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createReducer = undefined;
  exports.defaultUpdater = defaultUpdater;
  exports.createSelector = createSelector;

  function defaultUpdater(session, action) {
    session.sessionBoundModels.forEach(function (modelClass) {
      if (typeof modelClass.reducer === 'function') {
        // This calls this.applyUpdate to update this.state
        modelClass.reducer(action, modelClass, session);
      }
    });
  }

  var createReducer = exports.createReducer = function createReducer(orm) {
    var updater = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultUpdater;
    return function (state, action) {
      var session = orm.session(state || orm.getEmptyState());
      updater(session, action);
      return session.state;
    };
  };
  /**
   * Returns a memoized selector based on passed arguments.
   * This is similar to `reselect`'s `createSelector`,
   * except you can also pass a single function to be memoized.
   *
   * If you pass multiple functions, the format will be the
   * same as in `reselect`. The last argument is the selector
   * function and the previous are input selectors.
   *
   * When you use this method to create a selector, the returned selector
   * expects the whole `redux-orm` state branch as input. In the selector
   * function that you pass as the last argument, you will receive
   * `session` argument (a `Session` instance) followed by any
   * input arguments, like in `reselect`.
   *
   * This is an example selector:
   *
   * ```javascript
   * // orm is an instance of ORM
   * const bookSelector = createSelector(orm, session => {
   *     return session.Book.map(book => {
   *         return Object.assign({}, book.ref, {
   *             authors: book.authors.map(author => author.name),
   *             genres: book.genres.map(genre => genre.name),
   *         });
   *     });
   * });
   * ```
   *
   * redux-orm uses a special memoization function to avoid recomputations.
   * When a selector runs for the first time, it checks which Models' state
   * branches were accessed. On subsequent runs, the selector first checks
   * if those branches have changed -- if not, it just returns the previous
   * result. This way you can use the `PureRenderMixin` in your React
   * components for performance gains.
   *
   * @param {ORM} orm - the ORM instance
   * @param  {...Function} args - zero or more input selectors
   *                              and the selector function.
   * @return {Function} memoized selector
   */


  function createSelector(orm) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1) {
      return (0, memoize_1$1.memoize)(args[0], memoize_1$1.eqCheck, orm);
    }

    return (0, lib$2.createSelectorCreator)(memoize_1$1.memoize, memoize_1$1.eqCheck, orm).apply(undefined, args);
  }
});
unwrapExports(redux$1);
var redux_1 = redux$1.createReducer;
var redux_2 = redux$1.defaultUpdater;
var redux_3 = redux$1.createSelector;
var ORM_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ORM = undefined;

  var _defineProperty3 = _interopRequireDefault(defineProperty$9);

  var _possibleConstructorReturn3 = _interopRequireDefault(possibleConstructorReturn$1);

  var _inherits3 = _interopRequireDefault(inherits$1);

  var _assign2 = _interopRequireDefault(assign$1);

  var _classCallCheck3 = _interopRequireDefault(classCallCheck$1);

  exports.DeprecatedSchema = DeprecatedSchema;

  var _forOwn2 = _interopRequireDefault(forOwn_1);

  var _find2 = _interopRequireDefault(find_1);

  var _Session2 = _interopRequireDefault(Session_1);

  var _Model3 = _interopRequireDefault(Model_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ORM_DEFAULTS = {
    createDatabase: db.createDatabase
  };
  /**
   * ORM - the Object Relational Mapper.
   *
   * Use instances of this class to:
   *
   * - Register your {@link Model} classes using {@link ORM#register}
   * - Get the empty state for the underlying database with {@link ORM#getEmptyState}
   * - Start an immutable database session with {@link ORM#session}
   * - Start a mutating database session with {@link ORM#mutableSession}
   *
   * Internally, this class handles generating a schema specification from models
   * to the database.
   */

  var ORM = exports.ORM = function () {
    /**
     * Creates a new ORM instance.
     */
    function ORM(opts) {
      (0, _classCallCheck3.default)(this, ORM);

      var _Object$assign = (0, _assign2.default)({}, ORM_DEFAULTS, opts || {}),
          createDatabase = _Object$assign.createDatabase;

      this.createDatabase = createDatabase;
      this.registry = [];
      this.implicitThroughModels = [];
      this.installedFields = {};
    }
    /**
     * Registers a {@link Model} class to the ORM.
     *
     * If the model has declared any ManyToMany fields, their
     * through models will be generated and registered with
     * this call, unless a custom through model has been specified.
     *
     * @param  {...Model} model - a {@link Model} class to register
     * @return {undefined}
     */


    ORM.prototype.register = function register() {
      var _this = this;

      for (var _len = arguments.length, models = Array(_len), _key = 0; _key < _len; _key++) {
        models[_key] = arguments[_key];
      }

      models.forEach(function (model) {
        model.invalidateClassCache();

        _this.registerManyToManyModelsFor(model);

        _this.registry.push(model);
      });
    };

    ORM.prototype.registerManyToManyModelsFor = function registerManyToManyModelsFor(model) {
      var _this3 = this;

      var fields$$1 = model.fields;
      var thisModelName = model.modelName;
      (0, _forOwn2.default)(fields$$1, function (fieldInstance, fieldName) {
        if (fieldInstance instanceof fields.ManyToMany && !fieldInstance.through) {
          var _Through$fields;

          var toModelName = void 0;

          if (fieldInstance.toModelName === 'this') {
            toModelName = thisModelName;
          } else {
            toModelName = fieldInstance.toModelName;
          }

          var fromFieldName = (0, utils.m2mFromFieldName)(thisModelName);
          var toFieldName = (0, utils.m2mToFieldName)(toModelName);

          var Through = function (_Model) {
            (0, _inherits3.default)(ThroughModel, _Model);

            function ThroughModel() {
              (0, _classCallCheck3.default)(this, ThroughModel);
              return (0, _possibleConstructorReturn3.default)(this, _Model.apply(this, arguments));
            }

            return ThroughModel;
          }(_Model3.default);

          Through.modelName = (0, utils.m2mName)(thisModelName, fieldName);
          Through.fields = (_Through$fields = {
            id: (0, fields.attr)()
          }, (0, _defineProperty3.default)(_Through$fields, fromFieldName, new fields.ForeignKey(thisModelName)), (0, _defineProperty3.default)(_Through$fields, toFieldName, new fields.ForeignKey(toModelName)), _Through$fields);
          Through.invalidateClassCache();

          _this3.implicitThroughModels.push(Through);
        }
      });
    };
    /**
     * Gets a {@link Model} class by its name from the registry.
     * @param  {string} modelName - the name of the {@link Model} class to get
     * @throws If {@link Model} class is not found.
     * @return {Model} the {@link Model} class, if found
     */


    ORM.prototype.get = function get(modelName) {
      var found = (0, _find2.default)(this.registry.concat(this.implicitThroughModels), function (model) {
        return model.modelName === modelName;
      });

      if (typeof found === 'undefined') {
        throw new Error('Did not find model ' + modelName + ' from registry.');
      }

      return found;
    };

    ORM.prototype.getModelClasses = function getModelClasses() {
      this._setupModelPrototypes(this.registry);

      this._setupModelPrototypes(this.implicitThroughModels);

      return this.registry.concat(this.implicitThroughModels);
    };

    ORM.prototype._attachQuerySetMethods = function _attachQuerySetMethods(model) {
      var querySetClass = model.querySetClass;
      (0, utils.attachQuerySetMethods)(model, querySetClass);
    };

    ORM.prototype.isFieldInstalled = function isFieldInstalled(modelName, fieldName) {
      return this.installedFields.hasOwnProperty(modelName) ? !!this.installedFields[modelName][fieldName] : false;
    };

    ORM.prototype.setFieldInstalled = function setFieldInstalled(modelName, fieldName) {
      if (!this.installedFields.hasOwnProperty(modelName)) {
        this.installedFields[modelName] = {};
      }

      this.installedFields[modelName][fieldName] = true;
    };

    ORM.prototype._setupModelPrototypes = function _setupModelPrototypes(models) {
      var _this4 = this;

      models.forEach(function (model) {
        if (!model.isSetUp) {
          var fields$$1 = model.fields;
          (0, _forOwn2.default)(fields$$1, function (fieldInstance, fieldName) {
            if (!_this4.isFieldInstalled(model.modelName, fieldName)) {
              fieldInstance.install(model, fieldName, _this4);

              _this4.setFieldInstalled(model.modelName, fieldName);
            }
          });

          _this4._attachQuerySetMethods(model);

          model.isSetUp = true;
        }
      });
    };

    ORM.prototype.generateSchemaSpec = function generateSchemaSpec() {
      var models = this.getModelClasses();
      var tables = models.reduce(function (spec, modelClass) {
        var tableName = modelClass.modelName;

        var tableSpec = modelClass._getTableOpts(); // eslint-disable-line no-underscore-dangle


        spec[tableName] = (0, _assign2.default)({}, {
          fields: modelClass.fields
        }, tableSpec);
        return spec;
      }, {});
      return {
        tables: tables
      };
    };

    ORM.prototype.getDatabase = function getDatabase() {
      if (!this.db) {
        this.db = this.createDatabase(this.generateSchemaSpec());
      }

      return this.db;
    };
    /**
     * Returns the empty database state.
     * @return {Object} the empty state
     */


    ORM.prototype.getEmptyState = function getEmptyState() {
      return this.getDatabase().getEmptyState();
    };
    /**
     * Begins an immutable database session.
     *
     * @param  {Object} state  - the state the database manages
     * @return {Session} a new {@link Session} instance
     */


    ORM.prototype.session = function session(state) {
      return new _Session2.default(this, this.getDatabase(), state);
    };
    /**
     * Begins a mutable database session.
     *
     * @param  {Object} state  - the state the database manages
     * @return {Session} a new {@link Session} instance
     */


    ORM.prototype.mutableSession = function mutableSession(state) {
      return new _Session2.default(this, this.getDatabase(), state, true);
    }; // DEPRECATED AND REMOVED METHODS


    ORM.prototype.withMutations = function withMutations(state) {
      (0, utils.warnDeprecated)('ORM.prototype.withMutations is deprecated. ' + 'Use ORM.prototype.mutableSession instead.');
      return this.mutableSession(state);
    };

    ORM.prototype.from = function from(state) {
      (0, utils.warnDeprecated)('ORM.prototype.from function is deprecated. ' + 'Use ORM.prototype.session instead.');
      return this.session(state);
    };

    ORM.prototype.reducer = function reducer() {
      (0, utils.warnDeprecated)('ORM.prototype.reducer is deprecated. Access ' + 'the Session.prototype.state property instead.');
      return (0, redux$1.createReducer)(this);
    };

    ORM.prototype.createSelector = function createSelector() {
      (0, utils.warnDeprecated)('ORM.prototype.createSelector is deprecated. ' + 'Import `createSelector` from Redux-ORM instead.');

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return redux$1.createSelector.apply(undefined, [this].concat(args));
    };

    ORM.prototype.getDefaultState = function getDefaultState() {
      (0, utils.warnDeprecated)('ORM.prototype.getDefaultState is deprecated. Use ' + 'the ORM.prototype.getEmptyState instead.');
      return this.getEmptyState();
    };

    ORM.prototype.define = function define() {
      throw new Error('ORM.prototype.define is removed. Please define a Model class.');
    };

    return ORM;
  }();

  function DeprecatedSchema() {
    throw new Error('Schema has been renamed to ORM. Please import ORM instead of Schema ' + 'from Redux-ORM.');
  }

  exports.default = ORM;
});
unwrapExports(ORM_1);
var ORM_2 = ORM_1.ORM;
var ORM_3 = ORM_1.DeprecatedSchema;
var lib$3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createSelector = exports.createReducer = exports.oneToOne = exports.attr = exports.many = exports.fk = exports.OneToOne = exports.ManyToMany = exports.ForeignKey = exports.Session = exports.Backend = exports.Schema = exports.ORM = exports.Model = exports.QuerySet = exports.Attribute = undefined;

  var _QuerySet2 = _interopRequireDefault(QuerySet_1);

  var _Model2 = _interopRequireDefault(Model_1);

  var _Session2 = _interopRequireDefault(Session_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Schema = ORM_1.DeprecatedSchema;

  var Backend = function RemovedBackend() {
    throw new Error('Having a custom Backend instance is now unsupported. ' + 'Documentation for database customization is upcoming, for now ' + 'please look at the db folder in the source.');
  };

  exports.Attribute = fields.Attribute;
  exports.QuerySet = _QuerySet2.default;
  exports.Model = _Model2.default;
  exports.ORM = ORM_1.ORM;
  exports.Schema = Schema;
  exports.Backend = Backend;
  exports.Session = _Session2.default;
  exports.ForeignKey = fields.ForeignKey;
  exports.ManyToMany = fields.ManyToMany;
  exports.OneToOne = fields.OneToOne;
  exports.fk = fields.fk;
  exports.many = fields.many;
  exports.attr = fields.attr;
  exports.oneToOne = fields.oneToOne;
  exports.createReducer = redux$1.createReducer;
  exports.createSelector = redux$1.createSelector;
  exports.default = _Model2.default;
});
unwrapExports(lib$3);
var lib_1$2 = lib$3.createSelector;
var lib_2$2 = lib$3.createReducer;
var lib_3$2 = lib$3.oneToOne;
var lib_4$2 = lib$3.attr;
var lib_5 = lib$3.many;
var lib_6 = lib$3.fk;
var lib_7 = lib$3.OneToOne;
var lib_8 = lib$3.ManyToMany;
var lib_9 = lib$3.ForeignKey;
var lib_10 = lib$3.Session;
var lib_11 = lib$3.Backend;
var lib_12 = lib$3.Schema;
var lib_13 = lib$3.ORM;
var lib_14 = lib$3.Model;
var lib_15 = lib$3.QuerySet;
var lib_16 = lib$3.Attribute;

function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


  var length = prev.length;

  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
  var lastArgs = null;
  var lastResult = null; // we reference arguments instead of spreading them for performance reasons

  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      return memoizedResultFunc.apply(null, params);
    });
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;

    selector.recomputations = function () {
      return recomputations;
    };

    selector.resetRecomputations = function () {
      return recomputations = 0;
    };

    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);
var PAGE_CREATE_WITH_NEW_QUESTION = "PAGE_CREATE_WITH_NEW_QUESTION";
var PAGE_CREATE_WITH_EXISTING_QUESTION_UNSAFE = "PAGE_CREATE_WITH_EXISTING_QUESTION_UNSAFE";
var PAGE_DELETE = "PAGE_DELETE";
var PAGE_DUPLICATE = "PAGE_DUPLICATE";
var PAGE_SET_CONTENT = "PAGE_SET_CONTENT";
var PAGE_TOGGLE_RANDOM_SORT = "PAGE_TOGGLE_RANDOM_SORT";
var PAGE_TOGGLE_REVERSE_SORT = "PAGE_TOGGLE_REVERSE_SORT";
var PAGE_TOGGLE_ANCHOR = "PAGE_TOGGLE_ANCHOR";
var PAGE_MOVE = "PAGE_MOVE";
var PAGE_MOVE_UNSAFE = "PAGE_MOVE_UNSAFE";
var pageTypes = {
  PAGE_CREATE_WITH_NEW_QUESTION: PAGE_CREATE_WITH_NEW_QUESTION,
  PAGE_CREATE_WITH_EXISTING_QUESTION_UNSAFE: PAGE_CREATE_WITH_EXISTING_QUESTION_UNSAFE,
  PAGE_DUPLICATE: PAGE_DUPLICATE,
  PAGE_DELETE: PAGE_DELETE,
  PAGE_SET_CONTENT: PAGE_SET_CONTENT,
  PAGE_TOGGLE_RANDOM_SORT: PAGE_TOGGLE_RANDOM_SORT,
  PAGE_TOGGLE_REVERSE_SORT: PAGE_TOGGLE_REVERSE_SORT,
  PAGE_TOGGLE_ANCHOR: PAGE_TOGGLE_ANCHOR,
  PAGE_MOVE: PAGE_MOVE,
  PAGE_MOVE_UNSAFE: PAGE_MOVE_UNSAFE
};
var SURVEY_SET_TITLE = "SURVEY_SET_TITLE";
var SURVEY_SET_HASH = "SURVEY_SET_HASH";
var SURVEY_SET_PREVIEW_LINK = "SURVEY_SET_PREVIEW_LINK";
var surveyTypes = {
  SURVEY_SET_TITLE: SURVEY_SET_TITLE,
  SURVEY_SET_HASH: SURVEY_SET_HASH,
  SURVEY_SET_PREVIEW_LINK: SURVEY_SET_PREVIEW_LINK
};
var QUESTION_CREATE = "QUESTION_CREATE";
var QUESTION_DELETE = "QUESTION_DELETE";
var QUESTION_DUPLICATE = "QUESTION_DUPLICATE";
var QUESTION_MOVE_UNSAFE = "QUESTION_MOVE_UNSAFE";
var QUESTION_UPDATE_EDITOR = "QUESTION_UPDATE_EDITOR";
var QUESTION_SET_TYPE = "QUESTION_SET_TYPE";
var QUESTION_TOGGLE_RATING_TYPE = "QUESTION_TOGGLE_RATING_TYPE";
var QUESTION_TOGGLE_SLIDER_TYPE = "QUESTION_TOGGLE_SLIDER_TYPE";
var QUESTION_SET_CONTENT = "QUESTION_SET_CONTENT";
var QUESTION_RESET_CONTENT = "QUESTION_RESET_CONTENT";
var QUESTION_SET_DESCRIPTION = "QUESTION_SET_DESCRIPTION";
var QUESTION_TOGGLE_DESCRIPTION = "QUESTION_TOGGLE_DESCRIPTION";
var QUESTION_TOGGLE_MEDIA = "QUESTION_TOGGLE_MEDIA";
var QUESTION_TOGGLE_MEDIA_TYPE = "QUESTION_TOGGLE_MEDIA_TYPE";
var QUESTION_TOGGLE_RANDOM_SORT = "QUESTION_TOGGLE_RANDOM_SORT";
var QUESTION_TOGGLE_REVERSE_SORT = "QUESTION_TOGGLE_REVERSE_SORT";
var QUESTION_TOGGLE_ANSWER_IMAGES = "QUESTION_TOGGLE_ANSWER_IMAGES";
var QUESTION_TOGGLE_VISIBILITY = "QUESTION_SET_VISIBILITY";
var QUESTION_TOGGLE_REQUIRED = "QUESTION_TOGGLE_REQUIRED";
var QUESTION_TOGGLE_ANCHOR = "QUESTION_TOGGLE_ANCHOR";
var QUESTION_SET_MIN_ANSWERS = "QUESTION_SET_MIN_ANSWERS";
var QUESTION_SET_MAX_ANSWERS = "QUESTION_SET_MAX_ANSWERS";
var QUESTION_SET_STEPS = "QUESTION_SET_STEPS";
var QUESTION_SET_MIN_VALUE = "QUESTION_SET_MIN_VALUE";
var QUESTION_SET_MAX_VALUE = "QUESTION_SET_MAX_VALUE";
var QUESTION_SET_INCREMENT = "QUESTION_SET_INCREMENT";
var QUESTION_SET_VIDEO_URL = "QUESTION_SET_VIDEO_URL";
var QUESTION_TOGGLE_VALIDATES_SUM = "QUESTION_TOGGLE_VALIDATES_SUM";
var QUESTION_SET_TARGET_SUM = "QUESTION_SET_TARGET_SUM";
var QUESTION_IMAGE_REQUEST = "QUESTION_IMAGE_REQUEST";
var QUESTION_IMAGE_SUCCESS = "QUESTION_IMAGE_SUCCESS";
var QUESTION_IMAGE_ERROR = "QUESTION_IMAGE_ERROR";
var QUESTION_IMAGE_CLEAR = "QUESTION_IMAGE_CLEAR";
var QUESTION_SET_ROWS = "QUESTION_SET_ROWS";
var QUESTION_SET_COLUMNS = "QUESTION_SET_COLUMNS";
var QUESTION_SET_MIN_LENGTH = "QUESTION_SET_MIN_LENGTH";
var QUESTION_SET_MAX_LENGTH = "QUESTION_SET_MAX_LENGTH";
var QUESTION_RECONCILE_LENGTH = "QUESTION_RECONCILE_LENGTH";
var questionTypes = {
  QUESTION_CREATE: QUESTION_CREATE,
  QUESTION_DELETE: QUESTION_DELETE,
  QUESTION_DUPLICATE: QUESTION_DUPLICATE,
  QUESTION_MOVE_UNSAFE: QUESTION_MOVE_UNSAFE,
  QUESTION_UPDATE_EDITOR: QUESTION_UPDATE_EDITOR,
  QUESTION_SET_TYPE: QUESTION_SET_TYPE,
  QUESTION_SET_CONTENT: QUESTION_SET_CONTENT,
  QUESTION_RESET_CONTENT: QUESTION_RESET_CONTENT,
  QUESTION_SET_DESCRIPTION: QUESTION_SET_DESCRIPTION,
  QUESTION_TOGGLE_DESCRIPTION: QUESTION_TOGGLE_DESCRIPTION,
  QUESTION_TOGGLE_SLIDER_TYPE: QUESTION_TOGGLE_SLIDER_TYPE,
  QUESTION_TOGGLE_MEDIA: QUESTION_TOGGLE_MEDIA,
  QUESTION_TOGGLE_MEDIA_TYPE: QUESTION_TOGGLE_MEDIA_TYPE,
  QUESTION_TOGGLE_RANDOM_SORT: QUESTION_TOGGLE_RANDOM_SORT,
  QUESTION_TOGGLE_REVERSE_SORT: QUESTION_TOGGLE_REVERSE_SORT,
  QUESTION_TOGGLE_ANSWER_IMAGES: QUESTION_TOGGLE_ANSWER_IMAGES,
  QUESTION_TOGGLE_VISIBILITY: QUESTION_TOGGLE_VISIBILITY,
  QUESTION_TOGGLE_REQUIRED: QUESTION_TOGGLE_REQUIRED,
  QUESTION_TOGGLE_ANCHOR: QUESTION_TOGGLE_ANCHOR,
  QUESTION_TOGGLE_RATING_TYPE: QUESTION_TOGGLE_RATING_TYPE,
  QUESTION_SET_MIN_ANSWERS: QUESTION_SET_MIN_ANSWERS,
  QUESTION_SET_MAX_ANSWERS: QUESTION_SET_MAX_ANSWERS,
  QUESTION_SET_STEPS: QUESTION_SET_STEPS,
  QUESTION_SET_MIN_LENGTH: QUESTION_SET_MIN_LENGTH,
  QUESTION_SET_MAX_LENGTH: QUESTION_SET_MAX_LENGTH,
  QUESTION_SET_MIN_VALUE: QUESTION_SET_MIN_VALUE,
  QUESTION_SET_MAX_VALUE: QUESTION_SET_MAX_VALUE,
  QUESTION_SET_INCREMENT: QUESTION_SET_INCREMENT,
  QUESTION_SET_VIDEO_URL: QUESTION_SET_VIDEO_URL,
  QUESTION_TOGGLE_VALIDATES_SUM: QUESTION_TOGGLE_VALIDATES_SUM,
  QUESTION_SET_TARGET_SUM: QUESTION_SET_TARGET_SUM,
  QUESTION_IMAGE_REQUEST: QUESTION_IMAGE_REQUEST,
  QUESTION_IMAGE_SUCCESS: QUESTION_IMAGE_SUCCESS,
  QUESTION_IMAGE_ERROR: QUESTION_IMAGE_ERROR,
  QUESTION_IMAGE_CLEAR: QUESTION_IMAGE_CLEAR,
  QUESTION_SET_ROWS: QUESTION_SET_ROWS,
  QUESTION_SET_COLUMNS: QUESTION_SET_COLUMNS,
  QUESTION_RECONCILE_LENGTH: QUESTION_RECONCILE_LENGTH
};
var ANSWER_CONTENT_CREATE = "ANSWER_CONTENT_CREATE";
var ANSWER_CONTENT_DELETE = "ANSWER_CONTENT_DELETE";
var ANSWER_CONTENT_SET_CONTENT = "ANSWER_CONTENT_SET_CONTENT";
var ANSWER_CONTENT_RESET_CONTENT = "ANSWER_CONTENT_RESET_CONTENT";
var ANSWER_CONTENT_TOGGLE_ANCHOR = "ANSWER_CONTENT_TOGGLE_ANCHOR";
var ANSWER_CONTENT_MOVE = "ANSWER_CONTENT_MOVE";
var ANSWER_CONTENT_IMAGE_REQUEST = "ANSWER_CONTENT_IMAGE_REQUEST";
var ANSWER_CONTENT_IMAGE_SUCCESS = "ANSWER_CONTENT_IMAGE_SUCCESS";
var ANSWER_CONTENT_IMAGE_ERROR = "ANSWER_CONTENT_IMAGE_ERROR";
var answerContentTypes = {
  ANSWER_CONTENT_CREATE: ANSWER_CONTENT_CREATE,
  ANSWER_CONTENT_DELETE: ANSWER_CONTENT_DELETE,
  ANSWER_CONTENT_SET_CONTENT: ANSWER_CONTENT_SET_CONTENT,
  ANSWER_CONTENT_RESET_CONTENT: ANSWER_CONTENT_RESET_CONTENT,
  ANSWER_CONTENT_TOGGLE_ANCHOR: ANSWER_CONTENT_TOGGLE_ANCHOR,
  ANSWER_CONTENT_MOVE: ANSWER_CONTENT_MOVE,
  ANSWER_CONTENT_IMAGE_REQUEST: ANSWER_CONTENT_IMAGE_REQUEST,
  ANSWER_CONTENT_IMAGE_SUCCESS: ANSWER_CONTENT_IMAGE_SUCCESS,
  ANSWER_CONTENT_IMAGE_ERROR: ANSWER_CONTENT_IMAGE_ERROR
};
var pipeTypes = {
  PIPE_CREATE: "PIPE_CREATE",
  PIPE_DELETE: "PIPE_DELETE",
  PIPE_SET_PAGE: "PIPE_SET_PAGE",
  PIPE_SET_QUESTION: "PIPE_SET_QUESTION",
  PIPE_SET_PLACEHOLDER: "PIPE_SET_PLACEHOLDER",
  PIPE_TOGGLE_SELECTED: "PIPE_TOGGLE_SELECTED"
};
var LOGIC_CONDITION_CREATE = "LOGIC_CONDITION_CREATE";
var LOGIC_CONDITION_DELETE = "LOGIC_CONDITION_DELETE";
var LOGIC_CONDITION_SET_PAGE = "LOGIC_CONDITION_SET_PAGE";
var LOGIC_CONDITION_SET_QUESTION = "LOGIC_CONDITION_SET_QUESTION";
var LOGIC_CONDITION_SET_ANSWER = "LOGIC_CONDITION_SET_ANSWER";
var LOGIC_CONDITION_SET_SPECIAL_OPTION_VALUE = "LOGIC_CONDITION_SET_SPECIAL_OPTION_VALUE";
var LOGIC_CONDITION_SET_VALUE = "LOGIC_CONDITION_SET_VALUE";
var LOGIC_CONDITION_SET_OPERATOR = "LOGIC_CONDITION_SET_OPERATOR";
var LOGIC_CONDITION_SET_RESPONSE = "LOGIC_CONDITION_SET_RESPONSE";
var LOGIC_CONDITION_SET_GATE = "LOGIC_CONDITION_SET_GATE";
var LOGIC_CONDITION_SET_TARGET = "LOGIC_CONDITION_SET_TARGET";
var logicConditionTypes = {
  LOGIC_CONDITION_CREATE: LOGIC_CONDITION_CREATE,
  LOGIC_CONDITION_DELETE: LOGIC_CONDITION_DELETE,
  LOGIC_CONDITION_SET_PAGE: LOGIC_CONDITION_SET_PAGE,
  LOGIC_CONDITION_SET_QUESTION: LOGIC_CONDITION_SET_QUESTION,
  LOGIC_CONDITION_SET_ANSWER: LOGIC_CONDITION_SET_ANSWER,
  LOGIC_CONDITION_SET_SPECIAL_OPTION_VALUE: LOGIC_CONDITION_SET_SPECIAL_OPTION_VALUE,
  LOGIC_CONDITION_SET_VALUE: LOGIC_CONDITION_SET_VALUE,
  LOGIC_CONDITION_SET_OPERATOR: LOGIC_CONDITION_SET_OPERATOR,
  LOGIC_CONDITION_SET_RESPONSE: LOGIC_CONDITION_SET_RESPONSE,
  LOGIC_CONDITION_SET_GATE: LOGIC_CONDITION_SET_GATE,
  LOGIC_CONDITION_SET_TARGET: LOGIC_CONDITION_SET_TARGET
};
var DISPLAY_LOGIC_CREATE = "DISPLAY_LOGIC_CREATE";
var SKIP_LOGIC_CREATE = "SKIP_LOGIC_CREATE";
var SKIP_LOGIC_DELETE = "SKIP_LOGIC_DELETE";
var LOGIC_BRANCH_DELETE = "LOGIC_BRANCH_DELETE";
var LOGIC_BRANCH_SET_TARGET = "LOGIC_BRANCH_SET_TARGET";
var logicBranchTypes = {
  DISPLAY_LOGIC_CREATE: DISPLAY_LOGIC_CREATE,
  SKIP_LOGIC_CREATE: SKIP_LOGIC_CREATE,
  SKIP_LOGIC_DELETE: SKIP_LOGIC_DELETE,
  LOGIC_BRANCH_DELETE: LOGIC_BRANCH_DELETE,
  LOGIC_BRANCH_SET_TARGET: LOGIC_BRANCH_SET_TARGET
};
var SECTION_CREATE = "SECTION_CREATE";
var SECTION_DELETE = "SECTION_DELETE";
var SECTION_SET_CONTENT = "SECTION_SET_CONTENT";
var SECTION_SET_SORT_TYPE = "SECTION_SET_SORT_TYPE";
var SECTION_MERGE = "SECTION_MERGE";
var SECTION_MOVE_UNSAFE = "SECTION_MOVE_UNSAFE";
var sectionTypes = {
  SECTION_CREATE: SECTION_CREATE,
  SECTION_DELETE: SECTION_DELETE,
  SECTION_SET_CONTENT: SECTION_SET_CONTENT,
  SECTION_SET_SORT_TYPE: SECTION_SET_SORT_TYPE,
  SECTION_MERGE: SECTION_MERGE,
  SECTION_MOVE_UNSAFE: SECTION_MOVE_UNSAFE
};
var GROUP_CREATE = "GROUP_CREATE";
var GROUP_DELETE = "GROUP_DELETE";
var GROUP_SET_SORT_TYPE = "GROUP_SET_SORT_TYPE";
var GROUP_SET_CONTENT = "GROUP_SET_CONTENT";
var GROUP_MOVE_UNSAFE = "GROUP_MOVE_UNSAFE";
var groupTypes = {
  GROUP_CREATE: GROUP_CREATE,
  GROUP_DELETE: GROUP_DELETE,
  GROUP_SET_SORT_TYPE: GROUP_SET_SORT_TYPE,
  GROUP_SET_CONTENT: GROUP_SET_CONTENT,
  GROUP_MOVE_UNSAFE: GROUP_MOVE_UNSAFE
};
var SPECIAL_OPTION_CREATE = "SPECIAL_OPTION_CREATE";
var SPECIAL_OPTION_DELETE = "SPECIAL_OPTION_DELETE";
var SPECIAL_OPTION_SET_TEXT = "SPECIAL_OPTION_SET_TEXT";
var SPECIAL_OPTION_TOGGLE_OPEN_ANSWER = "SPECIAL_OPTION_TOGGLE_OPEN_ANSWER";
var SPECIAL_OPTION_TOGGLE_OPEN_ANSWER_REQUIRED = "SPECIAL_OPTION_TOGGLE_OPEN_ANSWER_REQUIRED";
var SPECIAL_OPTION_SET_OPEN_ANSWER_TEXT = "SPECIAL_OPTION_SET_OPEN_ANSWER_TEXT";
var specialOptionTypes = {
  SPECIAL_OPTION_CREATE: SPECIAL_OPTION_CREATE,
  SPECIAL_OPTION_DELETE: SPECIAL_OPTION_DELETE,
  SPECIAL_OPTION_SET_TEXT: SPECIAL_OPTION_SET_TEXT,
  SPECIAL_OPTION_TOGGLE_OPEN_ANSWER: SPECIAL_OPTION_TOGGLE_OPEN_ANSWER,
  SPECIAL_OPTION_TOGGLE_OPEN_ANSWER_REQUIRED: SPECIAL_OPTION_TOGGLE_OPEN_ANSWER_REQUIRED,
  SPECIAL_OPTION_SET_OPEN_ANSWER_TEXT: SPECIAL_OPTION_SET_OPEN_ANSWER_TEXT
};
var MODAL_SHOW = "MODAL_SHOW";
var MODAL_CLOSE = "MODAL_CLOSE";
var modalTypes = {
  MODAL_SHOW: MODAL_SHOW,
  MODAL_CLOSE: MODAL_CLOSE
};
var AUTOSAVE_REQUEST = "AUTOSAVE_REQUEST";
var AUTOSAVE_SUCCESS = "AUTOSAVE_SUCCESS";
var AUTOSAVE_ERROR = "AUTOSAVE_ERROR";
var autosaveTypes = {
  AUTOSAVE_REQUEST: AUTOSAVE_REQUEST,
  AUTOSAVE_SUCCESS: AUTOSAVE_SUCCESS,
  AUTOSAVE_ERROR: AUTOSAVE_ERROR
};
var INTERFACE_TOGGLE_EXPAND_QUESTIONS = "INTERFACE_TOGGLE_EXPAND_QUESTIONS";
var INTERFACE_SET_OUTLINE_HEADER = "INTERFACE_SET_OUTLINE_HEADER";
var INTERFACE_SET_ERROR = "INTERFACE_SET_ERROR";
var INTERFACE_TOGGLE_TEMPLATE = "INTERFACE_TOGGLE_TEMPLATE";
var INTERFACE_TOGGLE_READ_ONLY = "INTERFACE_TOGGLE_READ_ONLY";
var INTERFACE_TOGGLE_OUTLINE_OVERLAY = "INTERFACE_TOGGLE_OUTLINE_OVERLAY";
var interfaceTypes = {
  INTERFACE_TOGGLE_EXPAND_QUESTIONS: INTERFACE_TOGGLE_EXPAND_QUESTIONS,
  INTERFACE_SET_OUTLINE_HEADER: INTERFACE_SET_OUTLINE_HEADER,
  INTERFACE_SET_ERROR: INTERFACE_SET_ERROR,
  INTERFACE_TOGGLE_TEMPLATE: INTERFACE_TOGGLE_TEMPLATE,
  INTERFACE_TOGGLE_READ_ONLY: INTERFACE_TOGGLE_READ_ONLY,
  INTERFACE_TOGGLE_OUTLINE_OVERLAY: INTERFACE_TOGGLE_OUTLINE_OVERLAY
}; // These actions are 'batched' for action history purposes.
// https://github.com/omnidan/redux-undo#grouping-actions

var groupedTypes = [questionTypes.QUESTION_SET_DESCRIPTION, questionTypes.QUESTION_SET_STEPS, questionTypes.QUESTION_SET_MIN_LENGTH, questionTypes.QUESTION_SET_MAX_LENGTH, questionTypes.QUESTION_SET_TARGET_SUM, answerContentTypes.ANSWER_CONTENT_SET_CONTENT, specialOptionTypes.SPECIAL_OPTION_SET_TEXT, specialOptionTypes.SPECIAL_OPTION_SET_OPEN_ANSWER_TEXT, sectionTypes.SECTION_SET_CONTENT, groupTypes.GROUP_SET_CONTENT, pageTypes.PAGE_SET_CONTENT, questionTypes.QUESTION_UPDATE_EDITOR, surveyTypes.SURVEY_SET_TITLE]; // These actions are ignored by action history and the autosave saga.

var excludedTypes = [].concat(toConsumableArray(Object.keys(modalTypes)), toConsumableArray(Object.keys(autosaveTypes)), toConsumableArray(Object.keys(interfaceTypes)), [answerContentTypes.ANSWER_CONTENT_IMAGE_REQUEST, answerContentTypes.ANSWER_CONTENT_IMAGE_ERROR, questionTypes.QUESTION_IMAGE_REQUEST, questionTypes.QUESTION_IMAGE_ERROR, surveyTypes.SURVEY_SET_HASH, surveyTypes.SURVEY_SET_PREVIEW_LINK]);
var lib$4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(_x, _x2, _x3) {
    var _again = true;

    _function: while (_again) {
      var object = _x,
          property = _x2,
          receiver = _x3;
      _again = false;
      if (object === null) object = Function.prototype;
      var desc = Object.getOwnPropertyDescriptor(object, property);

      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);

        if (parent === null) {
          return undefined;
        } else {
          _x = parent;
          _x2 = property;
          _x3 = receiver;
          _again = true;
          desc = parent = undefined;
          continue _function;
        }
      } else if ('value' in desc) {
        return desc.value;
      } else {
        var getter = desc.get;

        if (getter === undefined) {
          return undefined;
        }

        return getter.call(receiver);
      }
    }
  };

  exports.getPropTypesMixin = getPropTypesMixin;

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
      throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _lodashForOwn2 = _interopRequireDefault(forOwn_1);

  function validateProp(validator, props, key, modelName) {
    var result = validator(props, key, modelName, 'prop');

    if (result instanceof Error) {
      throw result;
    }
  }

  function hasPropTypes(obj) {
    return typeof obj.propTypes === 'object';
  }

  function hasDefaultProps(obj) {
    return typeof obj.defaultProps === 'object';
  }

  function validateProps(props, propTypes, modelName) {
    (0, _lodashForOwn2['default'])(propTypes, function (validator, key) {
      validateProp(validator, props, key, modelName);
    });
  }

  function getPropTypesMixin(userOpts) {
    var opts = userOpts || {};
    var useValidation = undefined;

    if (opts.hasOwnProperty('validate')) {
      useValidation = opts.validate;
    } else if (process) {
      useValidation = process.env.NODE_ENV !== 'production';
    } else {
      useValidation = true;
    }

    var useDefaults = opts.hasOwnProperty('useDefaults') ? opts.useDefaults : true;
    return function (superclass) {
      return function (_superclass) {
        _inherits(_class, _superclass);

        function _class() {
          _classCallCheck(this, _class);

          _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).apply(this, arguments);
        }

        _createClass(_class, [{
          key: 'update',
          value: function update() {
            var modelClass = this.getClass();

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            if (useValidation && hasPropTypes(modelClass)) {
              (function () {
                var props = args[0];
                var propTypes = modelClass.propTypes;
                var modelName = modelClass.modelName; // Run validators for only the props passed in, not
                // all declared PropTypes.

                (0, _lodashForOwn2['default'])(props, function (val, key) {
                  if (propTypes.hasOwnProperty(key)) {
                    var validator = propTypes[key];
                    validateProp(validator, props, key, modelName + '.update');
                  }
                });
              })();
            }

            return _get(Object.getPrototypeOf(_class.prototype), 'update', this).apply(this, args);
          }
        }], [{
          key: 'create',
          value: function create() {
            var _get2;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            var props = args[0];
            var rest = args.slice(1);
            var defaults = useDefaults && hasDefaultProps(this) ? this.defaultProps : {};
            var propsWithDefaults = Object.assign({}, defaults, props);

            if (useValidation && hasPropTypes(this)) {
              validateProps(propsWithDefaults, this.propTypes, this.modelName + '.create');
            }

            return (_get2 = _get(Object.getPrototypeOf(_class), 'create', this)).call.apply(_get2, [this, propsWithDefaults].concat(_toConsumableArray(rest)));
          }
        }]);

        return _class;
      }(superclass);
    };
  }

  exports['default'] = getPropTypesMixin();
});
unwrapExports(lib$4);
var lib_1$3 = lib$4.getPropTypesMixin;

var Model$1 = function (_BaseModel) {
  inherits(Model$$1, _BaseModel);

  function Model$$1() {
    classCallCheck(this, Model$$1);
    return possibleConstructorReturn(this, (Model$$1.__proto__ || Object.getPrototypeOf(Model$$1)).apply(this, arguments));
  }

  createClass(Model$$1, [{
    key: "toggle",
    value: function toggle(field) {
      // $FlowFixMe (not sure how to deal with computed properties in Flow)
      this.set(field, !this[field]);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = this.ref,
          id = _ref.id,
          attrs = objectWithoutProperties(_ref, ["id"]);
      var newModel = this.constructor.create(_extends$c({}, attrs, newAttrs));
      return newModel;
    }
  }]);
  return Model$$1;
}(lib_14);

var mixin = lib_1$3({
  validate: false,
  useDefaults: true
});
var Model$2 = mixin(Model$1);

var AnswerContent = function (_BaseModel) {
  inherits(AnswerContent, _BaseModel);

  function AnswerContent() {
    classCallCheck(this, AnswerContent);
    return possibleConstructorReturn(this, (AnswerContent.__proto__ || Object.getPrototypeOf(AnswerContent)).apply(this, arguments));
  }

  createClass(AnswerContent, null, [{
    key: "reducer",
    // Question type model relations
    value: function reducer(action, AnswerContent, session) {
      switch (action.type) {
        case answerContentTypes.ANSWER_CONTENT_CREATE:
          {
            var _action$payload = action.payload,
                after = _action$payload.after,
                payloadAttrs = objectWithoutProperties(_action$payload, ["after"]);
            var previousModel = session.AnswerContent.withId(after).ref;
            var _id = previousModel.id,
                previousAttrs = objectWithoutProperties(previousModel, ["id"]);

            var _sequence = previousAttrs.sequence + 0.5;

            var _content = "Answer Choice " + (previousAttrs.sequence + 1);

            AnswerContent.create(_extends$c({}, previousAttrs, {
              sequence: _sequence,
              content: _content,
              lastNonEmptyContent: _content,
              imageFilename: false,
              imageUrl: false,
              anchor: false
            }, payloadAttrs));
            break;
          }

        case answerContentTypes.ANSWER_CONTENT_SET_CONTENT:
          {
            var _action$payload2 = action.payload,
                _id2 = _action$payload2.id,
                _content2 = _action$payload2.content;
            var model = AnswerContent.withId(_id2);
            model.set("content", _content2);
            if (_content2.trim() !== "") model.set("lastNonEmptyContent", _content2);
            model.set("defaultContent", false);
            break;
          }

        case answerContentTypes.ANSWER_CONTENT_RESET_CONTENT:
          {
            var _model = AnswerContent.withId(action.payload);

            if (_model.content.trim() === "") _model.set("content", _model.lastNonEmptyContent);
            break;
          }

        case answerContentTypes.ANSWER_CONTENT_TOGGLE_ANCHOR:
          {
            var current = AnswerContent.withId(action.payload).ref.anchor;
            AnswerContent.withId(action.payload).set("anchor", !current);
            break;
          }

        case answerContentTypes.ANSWER_CONTENT_MOVE:
          {
            var _action$payload3 = action.payload,
                _id3 = _action$payload3.id,
                newSequence = _action$payload3.newSequence;

            var _model2 = AnswerContent.withId(_id3);

            var result = _model2.ref.sequence < newSequence ? newSequence + 0.1 : newSequence - 0.1;

            _model2.set("sequence", result);

            break;
          }

        case answerContentTypes.ANSWER_CONTENT_IMAGE_REQUEST:
          {
            var _model3 = AnswerContent.withId(action.payload.id);

            _model3.set("imageLoading", true);

            _model3.set("imageError", false);

            break;
          }

        case answerContentTypes.ANSWER_CONTENT_IMAGE_SUCCESS:
          {
            var _action$payload4 = action.payload,
                _id4 = _action$payload4.id,
                filename = _action$payload4.filename,
                url = _action$payload4.url;

            var _model4 = AnswerContent.withId(_id4);

            _model4.set("imageFilename", filename);

            _model4.set("imageUrl", url);

            _model4.set("imageLoading", false);

            _model4.set("imageError", false);

            break;
          }

        case answerContentTypes.ANSWER_CONTENT_IMAGE_ERROR:
          {
            var _model5 = AnswerContent.withId(action.payload.id);

            _model5.set("imageError", action.payload.error);

            _model5.set("imageLoading", false);

            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return AnswerContent;
}(Model$2);

AnswerContent.modelName = "AnswerContent";
AnswerContent.fields = {
  content: lib_4$2(),
  anchor: lib_4$2(),
  defaultContent: lib_4$2(),
  imageFilename: lib_4$2(),
  imageUrl: lib_4$2(),
  imageLoading: lib_4$2(),
  imageError: lib_4$2(),
  singleSelect: lib_6("SingleSelect", "rows"),
  multipleSelect: lib_6("MultipleSelect", "rows"),
  singleSelectGridRow: lib_6("SingleSelectGrid", "rows"),
  singleSelectGridColumn: lib_6("SingleSelectGrid", "columns"),
  multipleSelectGridRow: lib_6("MultipleSelectGrid", "rows"),
  multipleSelectGridColumn: lib_6("MultipleSelectGrid", "columns"),
  multipleRating: lib_6("MultipleRating", "rows"),
  multipleSlider: lib_6("MultipleSlider", "rows"),
  rankOrder: lib_6("Ranking", "rows"),
  dropdown: lib_6("Dropdown", "rows"),
  sum: lib_6("Sum", "rows")
};
AnswerContent.defaultProps = {
  content: "New Answer Content",
  lastNonEmptyContent: "New Answer Content",
  defaultContent: true,
  anchor: false,
  imageFilename: false,
  imageUrl: false
};
var groupColors = ["#FCA360", "#52C1A3", "#A878A8", "#EF5277", "#1DC6CE", "#577dd3", "#D17E78", "#51a9ad", "#F4967D", "#5E92B5", "#CA99C5", "#EF8C48", "#50A37D", "#8F9FD8", "#EF738B", "#50698E", "#F794C1", "#B78F6A", "#91C6A6", "#f76e5c"];

var installGraph = function installGraph(hostNode, nodes, session) {
  var childGraph = hostNode.childGraph;
  if (childGraph === undefined) throw new Error();

  if (nodes.length > 0) {
    var incomingRootEdges = nodes[0].incomingEdges.filter(function (e) {
      return e.defaultTail !== null;
    }).toModelArray();
    incomingRootEdges.forEach(function (edge) {
      var tail = edge.tailNode;
      var newEdge = session.DagEdge.create({
        tailNode: tail,
        headNode: hostNode
      });
      edge.delete();
      tail.set("defaultEdge", newEdge);
    });
    var outgoingLeafEdges = nodes[nodes.length - 1].outgoingEdges.filter(function (e) {
      return e.defaultTail !== null;
    }).toModelArray();
    outgoingLeafEdges.forEach(function (edge) {
      var newEdge = session.DagEdge.create({
        tailNode: hostNode,
        headNode: edge.headNode
      });
      edge.delete();
      hostNode.set("defaultEdge", newEdge);
    });
  }

  importNodes(childGraph, nodes, session);
}; // Removes all edges related to the nodes, links them with defaultEdges in the order provided,
// and sets the nodes' parentGraph to the given graph


var importNodes = function importNodes(graph) {
  var nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var session = arguments[2];
  var DagEdge = session.DagEdge;
  nodes.forEach(function (node, index) {
    node.deleteEdges();
    var prevNode = nodes[index - 1];

    if (prevNode) {
      var newEdge = DagEdge.create({
        tailNode: prevNode,
        headNode: node
      });
      prevNode.set("defaultEdge", newEdge);
    }

    return node.set("parentGraph", graph);
  });
}; // Returns a graph's single node that has 0 incoming edges.
// If the graph has >1 root nodes or no root node is found, it throws an error.


var getRootNode = function getRootNode(graph) {
  var nodes = graph.nodes.toModelArray();
  var rootNodes = nodes.filter(function (n) {
    return n.incomingEdges.count() === 0;
  });

  if (rootNodes.length < 1) {
    throw new Error("No root node found. Make sure every graph model has an entry point of exactly one node with 0 incoming edges.");
  }

  if (rootNodes.length > 1) {
    throw new Error("Multiple root nodes found. Make sure every graph model has an entry point of exactly one node with 0 incoming edges.");
  }

  return rootNodes[0];
};

var getLeafNodes = function getLeafNodes(graph) {
  return graph.nodes.toModelArray().filter(function (n) {
    return n.outgoingEdges.count() === 0;
  });
};

var uninstallGraph = function uninstallGraph(graph, newGraph) {
  var hostNode = graph.hostNode;
  if (hostNode === null) throw new Error();
  if (graph.nodes.count() === 0) return; // For each edge coming into the hostNode, re-route it to the rootNode.

  var rootNode = getRootNode(graph);
  var incomingEdges = hostNode.incomingEdges.filter(function (e) {
    return e.defaultTail !== null;
  }).toModelArray();
  incomingEdges.forEach(function (edge) {
    edge.set("headNode", rootNode);
  }); // Reinstall the hostNode's defaultEdge onto the first leaf node available.

  var outgoingEdge = hostNode.defaultEdge;
  var leafNodes = getLeafNodes(graph);

  if (outgoingEdge !== undefined && leafNodes.length > 0) {
    var tailNode = leafNodes[0];
    outgoingEdge.set("tailNode", tailNode);
    tailNode.set("defaultEdge", outgoingEdge);
  } // Move the child nodes to the parentGraph.


  var targetGraph = newGraph || hostNode.parentGraph;
  graph.nodes.toModelArray().forEach(function (n) {
    return n.set("parentGraph", targetGraph);
  });
}; // forwardDefaultEdge replaces the previousNode's defaultEdge with one that points to the targetNode,
// or creates a new defaultEdge if it was previously undefined.


var forwardDefaultEdge = function forwardDefaultEdge(DagEdge, previousNode, targetNode) {
  // Forward the previous Node's existing default edge, if it has one.
  if (previousNode.defaultEdge) {
    var headNode = previousNode.defaultEdge.headNode;
    previousNode.defaultEdge.delete();
    targetNode.set("defaultEdge", DagEdge.create({
      tailNode: targetNode,
      headNode: headNode
    }));
  } // Create a new edge pointing to the new node from the previous node.


  var newEdge = DagEdge.create({
    tailNode: previousNode.id,
    headNode: targetNode.id
  });
  previousNode.set("defaultEdge", newEdge);
  return newEdge;
};

var DagNode = function (_Model) {
  inherits(DagNode, _Model);

  function DagNode() {
    classCallCheck(this, DagNode);
    return possibleConstructorReturn(this, (DagNode.__proto__ || Object.getPrototypeOf(DagNode)).apply(this, arguments));
  }

  createClass(DagNode, [{
    key: "getEdges",
    value: function getEdges() {
      var incomingEdges = this.incomingEdges.toModelArray();
      var outgoingEdges = this.outgoingEdges.toModelArray();
      return incomingEdges.concat(outgoingEdges);
    }
  }, {
    key: "getPreviousNode",
    value: function getPreviousNode() {
      var incomingEdges = this.incomingEdges.toModelArray();
      var incomingDefaultEdges = incomingEdges.filter(function (e) {
        return e.defaultTail !== null;
      });
      if (incomingDefaultEdges.length === 0) return undefined;
      return incomingDefaultEdges[0].tailNode;
    }
  }, {
    key: "getNextNode",
    value: function getNextNode() {
      if (this.defaultEdge !== undefined) return this.defaultEdge.headNode;
      return undefined;
    }
  }, {
    key: "delete",
    value: function _delete() {
      var DagEdge = this.incomingEdges.modelClass;
      var tailNode = this.getPreviousNode();
      var headNode = this.getNextNode();

      if (tailNode !== undefined && headNode !== undefined) {
        var newEdge = DagEdge.create({
          tailNode: tailNode,
          headNode: headNode
        });

        if (tailNode.defaultEdge !== undefined) {
          tailNode.defaultEdge.delete();
        }

        tailNode.set("defaultEdge", newEdge);
      }

      this.deleteEdges();
      get$1(DagNode.prototype.__proto__ || Object.getPrototypeOf(DagNode.prototype), "delete", this).call(this);
    }
  }, {
    key: "deleteEdges",
    value: function deleteEdges() {
      this.getEdges().forEach(function (edge) {
        edge.delete();
      });
    }
  }]);
  return DagNode;
}(Model$2);

DagNode.modelName = "DagNode";
DagNode.fields = {
  parentGraph: lib_6("DagGraph", "nodes"),
  childGraph: lib_3$2("DagGraph", "hostNode"),
  defaultEdge: lib_3$2("DagEdge", "defaultTail"),
  contentType: lib_4$2()
};

var DagEdge = function (_Model) {
  inherits(DagEdge, _Model);

  function DagEdge() {
    classCallCheck(this, DagEdge);
    return possibleConstructorReturn(this, (DagEdge.__proto__ || Object.getPrototypeOf(DagEdge)).apply(this, arguments));
  }

  return DagEdge;
}(Model$2);

DagEdge.modelName = "DagEdge";

var createEdge = function createEdge(edge, DagEdge) {
  var tailNode = edge.tailNode,
      headNode = edge.headNode;
  return DagEdge.create({
    tailNode: tailNode,
    headNode: headNode
  });
};

DagEdge.fields = {
  tailNode: lib_6("DagNode", "outgoingEdges"),
  headNode: lib_6("DagNode", "incomingEdges")
}; // This function helps us abstract away the problem of how to add a new node
// to a graph. This behaves differently based on the parameters and the graph:
//      If previousNodeId is given:
//          point previousNode--->newNode.
//      If no previousNode is given, and the graph has at least 1 node:
//          point newNode--->rootNode.
//      If the graph is empty, don't create any edges.

var installNode = function installNode(session, newNodeId, graphId, previousNodeId) {
  var DagNode$$1 = session.DagNode,
      DagEdge$$1 = session.DagEdge,
      DagGraph = session.DagGraph;
  var newNode = DagNode$$1.withId(newNodeId);

  if (previousNodeId !== undefined) {
    var previousNode = DagNode$$1.withId(previousNodeId);
    forwardDefaultEdge(DagEdge$$1, previousNode, newNode);
    newNode.set("parentGraph", graphId);
    return newNode;
  }

  var graph = DagGraph.withId(graphId);

  if (graph.nodes.count() > 0) {
    var rootNode = getRootNode(graph);
    var edgeProps = {
      tailNode: newNode.id,
      headNode: rootNode.id
    };
    var edge = createEdge(edgeProps, DagEdge$$1);
    newNode.set("defaultEdge", edge);
    newNode.set("parentGraph", graphId);
    return newNode;
  }

  newNode.set("parentGraph", graphId);
  return newNode;
};

var installNodeRange = function installNodeRange(session, root, leaf, previous) {
  var DagNode$$1 = session.DagNode,
      DagEdge$$1 = session.DagEdge;

  if (previous.defaultEdge) {
    var headNode = previous.defaultEdge.headNode;
    previous.defaultEdge.delete();

    var _newEdge = DagEdge$$1.create({
      tailNode: leaf,
      headNode: headNode
    });

    leaf.set("defaultEdge", _newEdge);
  }

  var newEdge = DagEdge$$1.create({
    tailNode: previous,
    headNode: root
  });
  previous.set("defaultEdge", newEdge);
};

var getInboundDefault = function getInboundDefault(node) {
  var incomingEdges = node.incomingEdges.toModelArray().filter(function (e) {
    return e.defaultTail !== null;
  });
  if (incomingEdges.length === 0) return undefined;
  return incomingEdges[0];
};

var uninstallNode = function uninstallNode(node, DagEdge) {
  var defaultEdge = node.defaultEdge;
  var inboundDefaultEdge = getInboundDefault(node);

  if (inboundDefaultEdge !== undefined && defaultEdge !== undefined) {
    var previousNode = inboundDefaultEdge.tailNode;
    var nextNode = defaultEdge.headNode;

    if (previousNode.defaultEdge) {
      previousNode.defaultEdge.delete();
      previousNode.set("defaultEdge", DagEdge.create({
        tailNode: previousNode,
        headNode: nextNode
      }));
    }
  }

  node.set("parentGraph", null);
  node.incomingEdges.toModelArray().forEach(function (e) {
    return e.delete();
  });
  node.outgoingEdges.toModelArray().forEach(function (e) {
    return e.delete();
  });
};

var moveNode = function moveNode(session, node, graph, after) {
  if (after === node.id) return;
  uninstallNode(node, session.DagEdge);
  installNode(session, node.id, graph, after);
}; // Recursively traverses nodes to update the sequence numbers of their associated pages.
// It should first be called on the root node of a given graph.
// The base case occurs when given node has no defaultEdge to the next node.


var updateNodeSequences = function updateNodeSequences(index, questionIndex, node) {
  switch (node.contentType) {
    case "Page":
      {
        if (node.page === null) {
          throw new Error("Node with id " + node.id + " has contentType set to Page, but its page is null.");
        }

        var page = node.page;
        page.set("sequence", index + 1);
        var questions = page.questions.orderBy("sequence").toModelArray();
        questions.forEach(function (q, i) {
          return q.set("sequence", i + questionIndex + 1);
        });
        break;
      }

    case "Section":
    case "Group":
      {
        var childGraph = node.childGraph;
        if (childGraph === undefined) throw new Error("Node with id " + node.id + " has contentType set to " + node.contentType + ", but its childGraph is null.");
        resetGraphSequences(childGraph, index);
        break;
      }

    default:
      throw new Error("Unknown node content type");
  }

  if (!!node.defaultEdge) {
    var nextNode = node.defaultEdge.headNode;
    var nextIndex = index + nodePageCount(node);
    var nextQuestionIndex = questionIndex + nodeQuestionCount(node);
    updateNodeSequences(nextIndex, nextQuestionIndex, nextNode);
  }
}; // Recursively sums the number of pages in all of a node's children, or 1 if the node has no childGraph.


var nodePageCount = function nodePageCount(node) {
  if (node.childGraph === undefined) return 1;
  var childCounts = node.childGraph.nodes.toModelArray().map(nodePageCount);
  return childCounts.reduce(function (acc, val) {
    return acc + val;
  }, 0);
};

var nodeQuestionCount = function nodeQuestionCount(node) {
  if (node.page !== null) return node.page.questions.count();
  if (node.childGraph === undefined) throw new Error();
  var childCounts = node.childGraph.nodes.toModelArray().map(nodeQuestionCount);
  return childCounts.reduce(function (acc, val) {
    return acc + val;
  }, 0);
}; // Initiates the sequence update process for a given graph.


var resetGraphSequences = function resetGraphSequences(graph) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var questionIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (graph.nodes.count() === 0) return;
  var rootNode = getRootNode(graph);
  updateNodeSequences(index, questionIndex, rootNode);
};

var resetRootGraphSequences = function resetRootGraphSequences(session) {
  var survey = session.Survey.first();
  if (survey === undefined) throw new Error();
  var rootGraph = survey.graph;
  resetGraphSequences(rootGraph);
};

var breakBranches = function breakBranches(branches, session) {
  var models = branches.map(function (id) {
    return session.LogicBranch.withId(id);
  });
  models.forEach(function (m) {
    if (m.edge) m.edge.delete();
    m.conditions.toModelArray().forEach(function (c) {
      return c.delete();
    });
    m.delete();
  });
};

var breakConditions = function breakConditions(conditions, session) {
  var models = conditions.map(function (id) {
    return session.LogicCondition.withId(id);
  });
  models.forEach(function (m) {
    return m.delete();
  });
};

var breakPipes = function breakPipes(pipes, session) {
  var models = pipes.map(function (id) {
    return session.Pipe.withId(id);
  });
  models.forEach(function (m) {
    return m.delete();
  });
};

var breakRelations = function breakRelations(relations, session) {
  var skipConditions = relations.skipConditions,
      displayConditions = relations.displayConditions,
      consumerPipes = relations.consumerPipes,
      providerPipes = relations.providerPipes,
      skipBranches = relations.skipBranches;
  if (skipBranches) breakBranches(skipBranches, session);
  if (skipConditions) breakConditions(skipConditions, session);
  if (displayConditions) breakConditions(displayConditions, session);
  if (consumerPipes) breakPipes(consumerPipes, session);
  if (providerPipes) breakPipes(providerPipes, session);
};

var Group = function (_Model) {
  inherits(Group, _Model);

  function Group() {
    classCallCheck(this, Group);
    return possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
  }

  createClass(Group, [{
    key: "delete",
    value: function _delete() {
      var childGraph = this.node.childGraph;

      if (childGraph === undefined) {
        throw new Error("Group model with id " + this.id + " and node id " + this.node.id + " has no childGraph. Make sure the Group model's node has a childGraph set.");
      }

      uninstallGraph(childGraph);
      childGraph.delete();
      this.node.delete();
      get$1(Group.prototype.__proto__ || Object.getPrototypeOf(Group.prototype), "delete", this).call(this);
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Group, session) {
      switch (action.type) {
        case groupTypes.GROUP_CREATE:
          createGroup(action.payload, Group, session);
          break;

        case groupTypes.GROUP_DELETE:
          Group.withId(action.payload).delete();
          break;

        case groupTypes.GROUP_SET_SORT_TYPE:
          {
            var _action$payload = action.payload,
                id = _action$payload.id,
                sortType = _action$payload.sortType;
            Group.withId(id).set("sortType", sortType);
            break;
          }

        case groupTypes.GROUP_SET_CONTENT:
          {
            var _action$payload2 = action.payload,
                _id = _action$payload2.id,
                content = _action$payload2.content;
            Group.withId(_id).set("content", content);
            break;
          }

        case groupTypes.GROUP_MOVE_UNSAFE:
          {
            var _action$payload3 = action.payload,
                _id2 = _action$payload3.id,
                graph = _action$payload3.graph,
                after = _action$payload3.after,
                breakingRelations = _action$payload3.breakingRelations;
            breakRelations(breakingRelations, session);

            var _Group$withId = Group.withId(_id2),
                node = _Group$withId.node;

            moveNode(session, node, graph, after);
            resetRootGraphSequences(session);
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Group;
}(Model$2);

Group.modelName = "Group";
Group.fields = {
  content: lib_4$2(),
  sortType: lib_4$2(),
  survey: lib_6("Survey", "groups"),
  node: lib_3$2("DagNode", "group")
};
Group.defaultProps = {
  content: "New group",
  sortType: "default",
  color: "#000000"
};

function getColor(groupCount) {
  var index = groupCount % groupColors.length;
  return groupColors[index];
}

var createGroup = function createGroup(payload, Group, session) {
  var node = createGroupNode(session);
  var color = getColor(Group.count());
  var sections = payload.sections,
      rest = objectWithoutProperties(payload, ["sections"]);
  var sectionNodes = sections.map(function (s) {
    return session.Section.withId(s).node;
  });
  var newGroup = Group.create(_extends$c({
    node: node,
    color: color
  }, rest));
  installGraph(node, sectionNodes, session);
  return newGroup;
};

var createGroupNode = function createGroupNode(session) {
  var Survey = session.Survey,
      DagNode = session.DagNode,
      DagGraph = session.DagGraph,
      Group = session.Group;
  var survey = Survey.first();
  if (survey === undefined) throw new Error("Survey model's instance is missing. Make sure the Survey model has been instantiated.");
  var rootGraph = survey.graph;
  var childGraph = DagGraph.create();
  return DagNode.create({
    parentGraph: rootGraph,
    childGraph: childGraph,
    contentType: Group.modelName
  });
};

var OPERATOR_EQUAL = "equal";
var OPERATOR_NOT_EQUAL = "notEqual";
var OPERATOR_RANGE = "range";
var OPERATOR_LESS_THAN = "lessThan";
var OPERATOR_GREATER_THAN = "greaterThan";
var discreteOperators = [OPERATOR_EQUAL, OPERATOR_NOT_EQUAL];
var numericOperators = [OPERATOR_EQUAL, OPERATOR_NOT_EQUAL, OPERATOR_RANGE, OPERATOR_LESS_THAN, OPERATOR_GREATER_THAN];
var operatorTypes = {
  OPERATOR_EQUAL: "equal",
  OPERATOR_NOT_EQUAL: "notEqual",
  OPERATOR_RANGE: "range",
  OPERATOR_LESS_THAN: "lessThan",
  OPERATOR_GREATER_THAN: "greaterThan"
};
/*
	Each of these objects represents a set of configurable options by question type.

	type: string. 				The key stored with the actual question model.
	displayType: string. 		The formatted name of the type. Rendered in the UI.
	piping: boolean. 			If true, this type can be used as a piping source.
	images: boolean. 			If true, this type's answer rows can have associated images.
	conditionOperators: <Array[operatorType]> | false.
								Unless false, this array lists compatible logic operators when using this type in logic conditions.
	conditionValueType: string | false.
								The kind of value used in logic conditions.
	conditionAnswer: boolean.	If true, logic conditions using this question type have an "answer" field.
	showButton: boolean. 		If true, render a button for this type in the tool UI.
	icon: React component. 		Renders this type's icon.

	Some properties are also type-specific. Outside of their pertinent types, these fields are undefined.

	maxRows: number.		Maximum number of rows for question types with rows.
	maxColumns: number.		Maximum number of columns for question types with columns.
	upperBound: number. 	The maximum size of Text types.
	minSteps: number.		The minimum range length of Rating types.
	maxSteps: numbers. 		The maximum range length of Rating types.
*/

var QCONFIG_SINGLE_SELECT = {
  type: "single_select",
  displayType: "Single Selection",
  piping: true,
  images: true,
  conditionOperators: discreteOperators,
  conditionValueType: "answer-content",
  conditionAnswer: false,
  showButton: true,
  icon: icons.SingleSelect,
  maxRows: 100
};
var QCONFIG_MULTIPLE_SELECT = {
  type: "multiple_select",
  displayType: "Multiple Selection",
  piping: true,
  images: true,
  conditionOperators: discreteOperators,
  conditionValueType: "answer-content",
  conditionAnswer: false,
  showButton: true,
  icon: icons.MultipleSelect,
  maxRows: 100
};
var QCONFIG_DROPDOWN = {
  type: "dropdown",
  displayType: "Dropdown",
  piping: true,
  images: false,
  conditionOperators: discreteOperators,
  conditionValueType: "answer-content",
  conditionAnswer: false,
  showButton: true,
  icon: icons.Dropdown,
  maxRows: 100
};
var QCONFIG_SINGLE_SELECT_MATRIX = {
  type: "single_select_matrix",
  displayType: "Single Select Grid",
  piping: false,
  images: true,
  conditionOperators: discreteOperators,
  conditionValueType: "grid-content",
  conditionAnswer: false,
  showButton: true,
  icon: icons.SingleSelectGrid,
  maxRows: 11,
  maxColumns: 11
};
var QCONFIG_MULTIPLE_SELECT_MATRIX = {
  type: "multiple_select_matrix",
  displayType: "Multiple Select Grid",
  piping: false,
  images: true,
  conditionOperators: discreteOperators,
  conditionValueType: "grid-content",
  conditionAnswer: false,
  showButton: true,
  icon: icons.MultipleSelectGrid,
  maxRows: 11,
  maxColumns: 11
};
var QCONFIG_RATING = {
  type: "rating",
  displayType: "Rating",
  piping: false,
  images: false,
  minSteps: 2,
  maxSteps: 10,
  conditionOperators: numericOperators,
  conditionValueType: "numeric",
  conditionAnswer: false,
  showButton: true,
  icon: icons.Rating
};
var QCONFIG_MULTIPLE_RATING = {
  type: "multiple_rating",
  displayType: "Rating",
  piping: false,
  images: false,
  minSteps: 2,
  maxSteps: 10,
  conditionOperators: numericOperators,
  conditionValueType: "numeric",
  conditionAnswer: true,
  showButton: false,
  icon: icons.Rating,
  maxRows: 100
};
var QCONFIG_NUMERIC_INPUT = {
  type: "numeric",
  displayType: "Numeric",
  piping: false,
  images: false,
  conditionOperators: numericOperators,
  conditionValueType: "numeric",
  conditionAnswer: false,
  showButton: true,
  icon: icons.Numeric
};
var QCONFIG_SUM_SELECT = {
  type: "sum",
  displayType: "Sum",
  piping: false,
  images: true,
  conditionOperators: numericOperators,
  conditionValueType: "numeric",
  conditionAnswer: true,
  showButton: true,
  icon: icons.Sum,
  maxRows: 100
};
var QCONFIG_RANK_ORDER = {
  type: "rank_order",
  displayType: "Ranking",
  piping: false,
  images: true,
  conditionOperators: numericOperators,
  conditionValueType: "numeric",
  conditionAnswer: true,
  showButton: true,
  icon: icons.Ranking,
  maxRows: 100
};
var QCONFIG_SLIDER = {
  type: "slider",
  displayType: "Slider",
  piping: false,
  images: false,
  conditionOperators: numericOperators,
  conditionValueType: "numeric",
  conditionAnswer: false,
  showButton: true,
  icon: icons.Slider
};
var QCONFIG_MULTIPLE_SLIDER = {
  type: "multiple_slider",
  displayType: "Slider",
  piping: false,
  images: false,
  conditionOperators: numericOperators,
  conditionValueType: "numeric",
  conditionAnswer: true,
  showButton: false,
  icon: icons.Slider,
  maxRows: 100
};
var QCONFIG_SHORT_TEXT_INPUT = {
  type: "short_text_input",
  displayType: "Short Text",
  piping: false,
  images: false,
  upperBound: 400,
  conditionOperators: false,
  conditionValueType: false,
  conditionAnswer: false,
  showButton: true,
  icon: icons.ShortText
};
var QCONFIG_LONG_TEXT_INPUT = {
  type: "long_text_input",
  displayType: "Long Text",
  piping: false,
  images: false,
  upperBound: 2000,
  conditionOperators: false,
  conditionValueType: false,
  conditionAnswer: false,
  showButton: true,
  icon: icons.LongText
};
var QCONFIG_DESCRIPTIVE = {
  type: "descriptive",
  displayType: "Message",
  piping: false,
  images: false,
  conditionOperators: false,
  conditionValueType: false,
  conditionAnswer: false,
  showButton: true,
  icon: icons.Message
};
var questionConfigs = {
  single_select: QCONFIG_SINGLE_SELECT,
  multiple_select: QCONFIG_MULTIPLE_SELECT,
  single_select_matrix: QCONFIG_SINGLE_SELECT_MATRIX,
  multiple_select_matrix: QCONFIG_MULTIPLE_SELECT_MATRIX,
  rating: QCONFIG_RATING,
  multiple_rating: QCONFIG_MULTIPLE_RATING,
  descriptive: QCONFIG_DESCRIPTIVE,
  short_text_input: QCONFIG_SHORT_TEXT_INPUT,
  long_text_input: QCONFIG_LONG_TEXT_INPUT,
  dropdown: QCONFIG_DROPDOWN,
  rank_order: QCONFIG_RANK_ORDER,
  slider: QCONFIG_SLIDER,
  multiple_slider: QCONFIG_MULTIPLE_SLIDER,
  numeric: QCONFIG_NUMERIC_INPUT,
  sum: QCONFIG_SUM_SELECT
};

var LogicCondition = function (_BaseModel) {
  inherits(LogicCondition, _BaseModel);

  function LogicCondition() {
    classCallCheck(this, LogicCondition);
    return possibleConstructorReturn(this, (LogicCondition.__proto__ || Object.getPrototypeOf(LogicCondition)).apply(this, arguments));
  }

  createClass(LogicCondition, [{
    key: "delete",
    value: function _delete() {
      var branches = this.logicBranches.toModelArray(); // Delete now-empty logic branches

      branches.filter(function (b) {
        return b.conditions.count() < 2;
      }).forEach(function (b) {
        return b.delete();
      }); // Delete the condition

      get$1(LogicCondition.prototype.__proto__ || Object.getPrototypeOf(LogicCondition.prototype), "delete", this).call(this); // Sort remaining branches

      branches.forEach(function (b) {
        return b.sortConditions();
      });
    }
  }], [{
    key: "reducer",
    value: function reducer(action, LogicCondition, session) {
      switch (action.type) {
        case logicConditionTypes.LOGIC_CONDITION_CREATE:
          {
            var _action$payload = action.payload,
                _branch = _action$payload.branch,
                previousCondition = _action$payload.previousCondition,
                previousGate = _action$payload.previousGate;
            var previousConditionModel = LogicCondition.withId(previousCondition);
            var _question = previousConditionModel.question.id;

            var _sequence = previousConditionModel.ref.sequence + 1;

            createCondition({
              branch: _branch,
              question: _question,
              sequence: _sequence
            }, session);
            previousConditionModel.set("gate", previousGate);
            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_DELETE:
          LogicCondition.withId(action.payload).delete();
          break;

        case logicConditionTypes.LOGIC_CONDITION_SET_PAGE:
          {
            var _action$payload2 = action.payload,
                id = _action$payload2.id,
                pageId = _action$payload2.pageId;
            LogicCondition.withId(id).set("page", pageId);
            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_QUESTION:
          {
            var _action$payload3 = action.payload,
                _id = _action$payload3.id,
                questionId = _action$payload3.question;
            var condition = LogicCondition.withId(_id);

            var _question2 = session.Question.withId(questionId);

            if (condition && _question2) {
              onQuestionChange(condition, _question2);
              condition.set("question", _question2);
            }

            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_ANSWER:
          {
            var _action$payload4 = action.payload,
                _id2 = _action$payload4.id,
                answerContent = _action$payload4.answerContent;
            var model = LogicCondition.withId(_id2);
            model.set("answer", answerContent);
            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_VALUE:
          {
            var _action$payload5 = action.payload,
                _id3 = _action$payload5.id,
                value = _action$payload5.value;

            var _model = LogicCondition.withId(_id3);

            _model.set("value", value);

            _model.set("specialOptionValue", undefined);

            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_SPECIAL_OPTION_VALUE:
          {
            var _action$payload6 = action.payload,
                _id4 = _action$payload6.id,
                specialOption = _action$payload6.specialOption;

            var _model2 = LogicCondition.withId(_id4);

            _model2.set("specialOptionValue", specialOption);

            _model2.set("value", undefined);

            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_OPERATOR:
          {
            var _action$payload7 = action.payload,
                _id5 = _action$payload7.id,
                operator = _action$payload7.operator;

            var _condition = LogicCondition.withId(_id5);

            var shouldResetValue = operator === "range" || _condition.operator === "range";

            _condition.set("operator", operator);

            if (shouldResetValue) resetValue(_condition);
            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_RESPONSE:
          {
            var _action$payload8 = action.payload,
                _id6 = _action$payload8.id,
                response = _action$payload8.response;
            LogicCondition.withId(_id6).set("response", response);
            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_GATE:
          {
            var _action$payload9 = action.payload,
                _id7 = _action$payload9.id,
                gate = _action$payload9.gate;
            LogicCondition.withId(_id7).set("gate", gate);
            break;
          }

        case logicConditionTypes.LOGIC_CONDITION_SET_TARGET:
          {
            var _action$payload10 = action.payload,
                _id8 = _action$payload10.id,
                target = _action$payload10.target;
            LogicCondition.withId(_id8).set("target", target);
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return LogicCondition;
}(Model$2);

LogicCondition.modelName = "LogicCondition";
LogicCondition.fields = {
  page: lib_6("Page", "referencingConditions"),
  question: lib_6("Question", "referencingConditions"),
  answer: lib_5("AnswerContent"),
  specialOptionValue: lib_6("SpecialOption", "referencingValueConditions"),
  value: lib_4$2(),
  operator: lib_4$2(),
  response: lib_4$2(),
  gate: lib_4$2(),
  target: lib_4$2(),
  sequence: lib_4$2()
};
LogicCondition.defaultProps = {
  operator: operatorTypes.OPERATOR_EQUAL,
  sequence: 0
};

function resetValue(condition) {
  var question = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : condition.question;
  var gridModel = question.singleSelectGrid || question.multipleSelectGrid;

  if (gridModel) {
    var row = gridModel.rows.first();
    var column = gridModel.columns.first();
    if (row && column) condition.set("value", {
      rows: [row.id],
      columns: [column.id]
    });
    return;
  }

  var rowModel = question.singleSelect || question.multipleSelect || question.dropdown;

  if (rowModel) {
    var _row = rowModel.rows.first();

    if (_row) condition.set("value", _row.id);
    return;
  }

  var ratingModel = question.rating || question.multipleRating;

  if (ratingModel) {
    var operator = condition.operator;
    var min = 0;
    var max = ratingModel.ref.steps;
    var value = operator === "range" ? {
      min: min,
      max: max
    } : min;
    return condition.set("value", value);
  }

  var numericModel = question.numeric || question.sum || question.rankOrder || question.slider || question.multipleSlider;

  if (numericModel) {
    var _operator = condition.operator;

    var _min = numericModel.ref.min || 0;

    var _max = numericModel.ref.max || 0;

    var _value = _operator === "range" ? {
      min: _min,
      max: _max
    } : _min;

    return condition.set("value", _value);
  }

  condition.set("value", null);
}

function resetAnswer(condition, question) {
  var answerModel = question.multipleRating || question.multipleSlider || question.sum;

  if (answerModel) {
    var row = answerModel.rows.first();
    if (row) condition.set("answer", [row.id]);
  } else {
    condition.set("answer", []);
  }
}

function resetOperator(condition, question) {
  var newType = question.type;
  var supportedOperators = questionConfigs[newType].conditionOperators;

  if (supportedOperators === false) {
    throw new Error("Logic condition's new question type supports no operators");
  }

  if (!supportedOperators.includes(condition.operator)) {
    condition.set("operator", operatorTypes.OPERATOR_EQUAL);
  }
}

function onQuestionChange(condition, newQuestion) {
  resetOperator(condition, newQuestion);
  resetAnswer(condition, newQuestion);
  resetValue(condition, newQuestion);
}

var getInitialValue = function getInitialValue(questionModel) {
  var typeModel = questionModel.typeModel;

  if (typeModel.rows && typeModel.columns) {
    var model = typeModel;
    var firstRow = model.rows.first();
    var firstColumn = model.columns.first();
    if (firstRow && firstColumn) return {
      rows: [firstRow.id],
      columns: [firstColumn.id]
    };
    throw new Error("Grid question with id " + questionModel.id + " is missing rows or columns");
  }

  if (typeModel.rows) {
    var _model3 = typeModel;

    var value = _model3.rows.first();

    if (value) return value.id;
    return null;
  }

  if (typeModel.ref.minValue !== undefined) return typeModel.ref.minValue;
  if (typeModel.ref.targetSum !== undefined) return 0;
  return null;
};

var getInitialAnswer = function getInitialAnswer(question) {
  var answerModel = question.sum || question.multipleSlider || question.multipleRating;

  if (answerModel) {
    var row = answerModel.rows.first();
    if (row) return [row.id];
  }

  return [];
};

function createCondition(_ref, session) {
  var question = _ref.question,
      branch = _ref.branch,
      sequence = _ref.sequence;
  var Question = session.Question,
      LogicCondition = session.LogicCondition;
  var questionModel = Question.withId(question);
  return LogicCondition.create({
    question: question,
    value: getInitialValue(questionModel),
    answer: getInitialAnswer(questionModel),
    logicBranches: [branch],
    sequence: sequence
  });
}

var LogicBranch = function (_Model) {
  inherits(LogicBranch, _Model);

  function LogicBranch() {
    classCallCheck(this, LogicBranch);
    return possibleConstructorReturn(this, (LogicBranch.__proto__ || Object.getPrototypeOf(LogicBranch)).apply(this, arguments));
  }

  createClass(LogicBranch, [{
    key: "sortConditions",
    value: function sortConditions() {
      var conditions = this.conditions.orderBy("sequence").toModelArray();
      conditions.forEach(function (c, index) {
        return c.set("sequence", index);
      });
      if (conditions.length > 0) conditions[conditions.length - 1].set("gate", undefined);
    }
  }], [{
    key: "reducer",
    value: function reducer(action, LogicBranch, session) {
      switch (action.type) {
        case logicBranchTypes.DISPLAY_LOGIC_CREATE:
          {
            var page = action.payload.page;
            var pageModel = session.Page.withId(page);
            var branch = createLogic(action.payload, session);
            pageModel.set("displayLogicBranch", branch.id);
            break;
          }

        case logicBranchTypes.SKIP_LOGIC_CREATE:
          {
            var _page = action.payload.page;

            var _pageModel = session.Page.withId(_page);

            var _branch = createLogic(action.payload, session);

            _branch.set("skipLogicPage", _pageModel.id);

            setInitialTarget(session, _branch, _pageModel);
            break;
          }

        case logicBranchTypes.SKIP_LOGIC_DELETE:
          {
            var _pageModel2 = session.Page.withId(action.payload);

            var branches = _pageModel2.skipLogicBranches;
            branches.toModelArray().forEach(function (b) {
              if (b.edge !== undefined) b.edge.delete();
              b.delete();
            });
            break;
          }

        case logicBranchTypes.LOGIC_BRANCH_SET_TARGET:
          {
            var _action$payload = action.payload,
                id = _action$payload.id,
                target = _action$payload.target;

            var _branch2 = LogicBranch.withId(id);

            setTarget(session, _branch2, target);
            break;
          }

        case logicBranchTypes.LOGIC_BRANCH_DELETE:
          LogicBranch.withId(action.payload).delete();
          break;

        default:
          return undefined;
      }
    }
  }]);
  return LogicBranch;
}(Model$2);

LogicBranch.modelName = "LogicBranch";

var createLogic = function createLogic(payload, session) {
  var page = payload.page,
      defaultQuestion = payload.defaultQuestion,
      rest = objectWithoutProperties(payload, ["page", "defaultQuestion"]);
  var LogicBranch = session.LogicBranch;
  var newBranch = LogicBranch.create(rest); // Create a default condition for the new branch.

  createCondition({
    question: defaultQuestion,
    branch: newBranch.id,
    sequence: 0
  }, session);
  return newBranch;
}; // Set the initial target of this branch to the defaultEdge target of the given page.
// TODO: This edge might point to a section/group, which will break.


var setInitialTarget = function setInitialTarget(session, branch, pageModel) {
  var defaultEdge = pageModel.node.defaultEdge;
  if (defaultEdge === undefined) return setTargetSpecial(branch, "disqualify");
  var defaultNode = defaultEdge.headNode;
  if (defaultNode.page === null) return setTargetSpecial(branch, "disqualify");
  return setTarget(session, branch, defaultNode.page.id);
};

var setTarget = function setTarget(session, branch, target) {
  if (target === "complete" || target === "disqualify") {
    return setTargetSpecial(branch, target);
  }

  setTargetPage(session, branch, target);
};

var setTargetSpecial = function setTargetSpecial(branch, target) {
  if (branch.edge !== undefined) branch.edge.delete();
  branch.set("target", null);
  branch.set("specialTarget", target);
  return;
};

var setTargetPage = function setTargetPage(session, branch, target) {
  if (branch.skipLogicPage === null) throw new Error("Logic branch with id " + branch.id + " tried to set a Skip Logic Target but has no Skip Logic Page associated.");
  var tailNode = branch.skipLogicPage.node;
  var headNode = session.Page.withId(target).node;

  if (tailNode.parentGraph.ref !== headNode.parentGraph.ref) {
    console.warn("Logic branch with id " + branch.id + " tried to link two nodes from different graphs. Changing to disqual.");
    return setTargetSpecial(branch, "disqualify");
  }

  var graph = tailNode.parentGraph;
  var edge = session.DagEdge.create({
    graph: graph,
    tailNode: tailNode,
    headNode: headNode
  });
  if (branch.edge !== undefined) branch.edge.delete();
  branch.set("edge", edge);
  branch.set("specialTarget", null);
  branch.set("target", target);
};

LogicBranch.fields = {
  conditions: lib_5("LogicCondition", "logicBranches"),
  target: lib_6("Page", "targetingBranches"),
  skipLogicPage: lib_6("Page", "skipLogicBranches"),
  edge: lib_3$2("DagEdge", "logicBranch"),
  specialTarget: lib_4$2()
};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
var hasOwnProperty$b = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty$b.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols$2) {
      symbols = getOwnPropertySymbols$2(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
var immutable = createCommonjsModule(function (module, exports) {
  /**
   *  Copyright (c) 2014-2015, Facebook, Inc.
   *  All rights reserved.
   *
   *  This source code is licensed under the BSD-style license found in the
   *  LICENSE file in the root directory of this source tree. An additional grant
   *  of patent rights can be found in the PATENTS file in the same directory.
   */
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    var SLICE$0 = Array.prototype.slice;

    function createClass(ctor, superClass) {
      if (superClass) {
        ctor.prototype = Object.create(superClass.prototype);
      }

      ctor.prototype.constructor = ctor;
    }

    function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }

    createClass(KeyedIterable, Iterable);

    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }

    createClass(IndexedIterable, Iterable);

    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }

    createClass(SetIterable, Iterable);

    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }

    function isIterable(maybeIterable) {
      return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }

    function isKeyed(maybeKeyed) {
      return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }

    function isIndexed(maybeIndexed) {
      return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }

    function isAssociative(maybeAssociative) {
      return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }

    function isOrdered(maybeOrdered) {
      return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }

    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@'; // Used for setting prototype methods that IE8 chokes on.

    var DELETE = 'delete'; // Constants describing the size of trie nodes.

    var SHIFT = 5; // Resulted in best performance after ______?

    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1; // A consistent shared value representing "not set" which equals nothing other
    // than itself, and nothing that could be provided externally.

    var NOT_SET = {}; // Boolean references, Rough equivalent of `bool &`.

    var CHANGE_LENGTH = {
      value: false
    };
    var DID_ALTER = {
      value: false
    };

    function MakeRef(ref) {
      ref.value = false;
      return ref;
    }

    function SetRef(ref) {
      ref && (ref.value = true);
    } // A function which returns a value representing an "owner" for transient writes
    // to tries. The return value will only ever equal itself, and will not equal
    // the return of any subsequent call of this function.


    function OwnerID() {} // http://jsperf.com/copy-array-inline


    function arrCopy(arr, offset) {
      offset = offset || 0;
      var len = Math.max(0, arr.length - offset);
      var newArr = new Array(len);

      for (var ii = 0; ii < len; ii++) {
        newArr[ii] = arr[ii + offset];
      }

      return newArr;
    }

    function ensureSize(iter) {
      if (iter.size === undefined) {
        iter.size = iter.__iterate(returnTrue);
      }

      return iter.size;
    }

    function wrapIndex(iter, index) {
      // This implements "is array index" which the ECMAString spec defines as:
      //
      //     A String property name P is an array index if and only if
      //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
      //     to 2^32−1.
      //
      // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
      if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32

        if ('' + uint32Index !== index || uint32Index === 4294967295) {
          return NaN;
        }

        index = uint32Index;
      }

      return index < 0 ? ensureSize(iter) + index : index;
    }

    function returnTrue() {
      return true;
    }

    function wholeSlice(begin, end, size) {
      return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
    }

    function resolveBegin(begin, size) {
      return resolveIndex(begin, size, 0);
    }

    function resolveEnd(end, size) {
      return resolveIndex(end, size, size);
    }

    function resolveIndex(index, size, defaultIndex) {
      return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
    }
    /* global Symbol */


    var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

    function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function () {
      return '[Iterator]';
    };

    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;

    Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
      return this.toString();
    };

    Iterator.prototype[ITERATOR_SYMBOL] = function () {
      return this;
    };

    function iteratorValue(type, k, v, iteratorResult) {
      var value = type === 0 ? k : type === 1 ? v : [k, v];
      iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
      };
      return iteratorResult;
    }

    function iteratorDone() {
      return {
        value: undefined,
        done: true
      };
    }

    function hasIterator(maybeIterable) {
      return !!getIteratorFn(maybeIterable);
    }

    function isIterator(maybeIterator) {
      return maybeIterator && typeof maybeIterator.next === 'function';
    }

    function getIterator(iterable) {
      var iteratorFn = getIteratorFn(iterable);
      return iteratorFn && iteratorFn.call(iterable);
    }

    function getIteratorFn(iterable) {
      var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);

      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    function isArrayLike(value) {
      return value && typeof value.length === 'number';
    }

    createClass(Seq, Iterable);

    function Seq(value) {
      return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function ()
    /*...values*/
    {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function () {
      return this;
    };

    Seq.prototype.toString = function () {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function () {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }

      return this;
    }; // abstract __iterateUncached(fn, reverse)


    Seq.prototype.__iterate = function (fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    }; // abstract __iteratorUncached(type, reverse)


    Seq.prototype.__iterator = function (type, reverse) {
      return seqIterator(this, type, reverse, true);
    };

    createClass(KeyedSeq, Seq);

    function KeyedSeq(value) {
      return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function () {
      return this;
    };

    createClass(IndexedSeq, Seq);

    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function ()
    /*...values*/
    {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function () {
      return this;
    };

    IndexedSeq.prototype.toString = function () {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function (fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function (type, reverse) {
      return seqIterator(this, type, reverse, false);
    };

    createClass(SetSeq, Seq);

    function SetSeq(value) {
      return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }

    SetSeq.of = function ()
    /*...values*/
    {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function () {
      return this;
    };

    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);

    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function (index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function (fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;

      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }

      return ii;
    };

    ArraySeq.prototype.__iterator = function (type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function () {
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
      });
    };

    createClass(ObjectSeq, KeyedSeq);

    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function (key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }

      return this._object[key];
    };

    ObjectSeq.prototype.has = function (key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function (fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;

      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];

        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }

      return ii;
    };

    ObjectSeq.prototype.__iterator = function (type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function () {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
      });
    };

    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);

    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }

      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;

      if (isIterator(iterator)) {
        var step;

        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }

      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }

      var iterable = this._iterable;
      var iterator = getIterator(iterable);

      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }

      var iterations = 0;
      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };

    createClass(IteratorSeq, IndexedSeq);

    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }

      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;

      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }

      var step;

      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;

        if (fn(val, iterations++, this) === false) {
          break;
        }
      }

      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }

      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function () {
        if (iterations >= cache.length) {
          var step = iterator.next();

          if (step.done) {
            return step;
          }

          cache[iterations] = step.value;
        }

        return iteratorValue(type, iterations, cache[iterations++]);
      });
    }; // # pragma Helper functions


    function isSeq(maybeSeq) {
      return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }

    var EMPTY_SEQ;

    function emptySequence() {
      return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }

    function keyedSeqFromValue(value) {
      var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;

      if (!seq) {
        throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
      }

      return seq;
    }

    function indexedSeqFromValue(value) {
      var seq = maybeIndexedSeqFromValue(value);

      if (!seq) {
        throw new TypeError('Expected Array or iterable object of values: ' + value);
      }

      return seq;
    }

    function seqFromValue(value) {
      var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);

      if (!seq) {
        throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
      }

      return seq;
    }

    function maybeIndexedSeqFromValue(value) {
      return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
    }

    function seqIterate(seq, fn, reverse, useKeys) {
      var cache = seq._cache;

      if (cache) {
        var maxIndex = cache.length - 1;

        for (var ii = 0; ii <= maxIndex; ii++) {
          var entry = cache[reverse ? maxIndex - ii : ii];

          if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
            return ii + 1;
          }
        }

        return ii;
      }

      return seq.__iterateUncached(fn, reverse);
    }

    function seqIterator(seq, type, reverse, useKeys) {
      var cache = seq._cache;

      if (cache) {
        var maxIndex = cache.length - 1;
        var ii = 0;
        return new Iterator(function () {
          var entry = cache[reverse ? maxIndex - ii : ii];
          return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
        });
      }

      return seq.__iteratorUncached(type, reverse);
    }

    function fromJS(json, converter) {
      return converter ? fromJSWith(converter, json, '', {
        '': json
      }) : fromJSDefault(json);
    }

    function fromJSWith(converter, json, key, parentJSON) {
      if (Array.isArray(json)) {
        return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
          return fromJSWith(converter, v, k, json);
        }));
      }

      if (isPlainObj(json)) {
        return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
          return fromJSWith(converter, v, k, json);
        }));
      }

      return json;
    }

    function fromJSDefault(json) {
      if (Array.isArray(json)) {
        return IndexedSeq(json).map(fromJSDefault).toList();
      }

      if (isPlainObj(json)) {
        return KeyedSeq(json).map(fromJSDefault).toMap();
      }

      return json;
    }

    function isPlainObj(value) {
      return value && (value.constructor === Object || value.constructor === undefined);
    }
    /**
     * An extension of the "same-value" algorithm as [described for use by ES6 Map
     * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
     *
     * NaN is considered the same as NaN, however -0 and 0 are considered the same
     * value, which is different from the algorithm described by
     * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
     *
     * This is extended further to allow Objects to describe the values they
     * represent, by way of `valueOf` or `equals` (and `hashCode`).
     *
     * Note: because of this extension, the key equality of Immutable.Map and the
     * value equality of Immutable.Set will differ from ES6 Map and Set.
     *
     * ### Defining custom values
     *
     * The easiest way to describe the value an object represents is by implementing
     * `valueOf`. For example, `Date` represents a value by returning a unix
     * timestamp for `valueOf`:
     *
     *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
     *     var date2 = new Date(1234567890000);
     *     date1.valueOf(); // 1234567890000
     *     assert( date1 !== date2 );
     *     assert( Immutable.is( date1, date2 ) );
     *
     * Note: overriding `valueOf` may have other implications if you use this object
     * where JavaScript expects a primitive, such as implicit string coercion.
     *
     * For more complex types, especially collections, implementing `valueOf` may
     * not be performant. An alternative is to implement `equals` and `hashCode`.
     *
     * `equals` takes another object, presumably of similar type, and returns true
     * if the it is equal. Equality is symmetrical, so the same result should be
     * returned if this and the argument are flipped.
     *
     *     assert( a.equals(b) === b.equals(a) );
     *
     * `hashCode` returns a 32bit integer number representing the object which will
     * be used to determine how to store the value object in a Map or Set. You must
     * provide both or neither methods, one must not exist without the other.
     *
     * Also, an important relationship between these methods must be upheld: if two
     * values are equal, they *must* return the same hashCode. If the values are not
     * equal, they might have the same hashCode; this is called a hash collision,
     * and while undesirable for performance reasons, it is acceptable.
     *
     *     if (a.equals(b)) {
     *       assert( a.hashCode() === b.hashCode() );
     *     }
     *
     * All Immutable collections implement `equals` and `hashCode`.
     *
     */


    function is(valueA, valueB) {
      if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
        return true;
      }

      if (!valueA || !valueB) {
        return false;
      }

      if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();

        if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
          return true;
        }

        if (!valueA || !valueB) {
          return false;
        }
      }

      if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
        return true;
      }

      return false;
    }

    function deepEqual(a, b) {
      if (a === b) {
        return true;
      }

      if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
        return false;
      }

      if (a.size === 0 && b.size === 0) {
        return true;
      }

      var notAssociative = !isAssociative(a);

      if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function (v, k) {
          var entry = entries.next().value;
          return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
      }

      var flipped = false;

      if (a.size === undefined) {
        if (b.size === undefined) {
          if (typeof a.cacheResult === 'function') {
            a.cacheResult();
          }
        } else {
          flipped = true;
          var _ = a;
          a = b;
          b = _;
        }
      }

      var allEqual = true;

      var bSize = b.__iterate(function (v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
          allEqual = false;
          return false;
        }
      });

      return allEqual && a.size === bSize;
    }

    createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }

      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);

      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }

        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function () {
      if (this.size === 0) {
        return 'Repeat []';
      }

      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function (index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function (searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function (begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function () {
      return this;
    };

    Repeat.prototype.indexOf = function (searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }

      return -1;
    };

    Repeat.prototype.lastIndexOf = function (searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }

      return -1;
    };

    Repeat.prototype.__iterate = function (fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }

      return ii;
    };

    Repeat.prototype.__iterator = function (type, reverse) {
      var this$0 = this;
      var ii = 0;
      return new Iterator(function () {
        return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
      });
    };

    Repeat.prototype.equals = function (other) {
      return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };

    var EMPTY_REPEAT;

    function invariant(condition, error) {
      if (!condition) throw new Error(error);
    }

    createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }

      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;

      if (end === undefined) {
        end = Infinity;
      }

      step = step === undefined ? 1 : Math.abs(step);

      if (end < start) {
        step = -step;
      }

      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);

      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }

        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function () {
      if (this.size === 0) {
        return 'Range []';
      }

      return 'Range [ ' + this._start + '...' + this._end + (this._step > 1 ? ' by ' + this._step : '') + ' ]';
    };

    Range.prototype.get = function (index, notSetValue) {
      return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };

    Range.prototype.includes = function (searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function (begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }

      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);

      if (end <= begin) {
        return new Range(0, 0);
      }

      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function (searchValue) {
      var offsetValue = searchValue - this._start;

      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;

        if (index >= 0 && index < this.size) {
          return index;
        }
      }

      return -1;
    };

    Range.prototype.lastIndexOf = function (searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function (fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;

      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }

        value += reverse ? -step : step;
      }

      return ii;
    };

    Range.prototype.__iterator = function (type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function () {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function (other) {
      return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };

    var EMPTY_RANGE;
    createClass(Collection, Iterable);

    function Collection() {
      throw TypeError('Abstract');
    }

    createClass(KeyedCollection, Collection);

    function KeyedCollection() {}

    createClass(IndexedCollection, Collection);

    function IndexedCollection() {}

    createClass(SetCollection, Collection);

    function SetCollection() {}

    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
      a = a | 0; // int

      b = b | 0; // int

      var c = a & 0xffff;
      var d = b & 0xffff; // Shift by 0 fixes the sign on the high part.

      return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
    }; // v8 has an optimization for storing 31-bit signed numbers.
    // Values which have either 00 or 11 as the high order bits qualify.
    // This function drops the highest order bit in a signed number, maintaining
    // the sign bit.

    function smi(i32) {
      return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
    }

    function hash(o) {
      if (o === false || o === null || o === undefined) {
        return 0;
      }

      if (typeof o.valueOf === 'function') {
        o = o.valueOf();

        if (o === false || o === null || o === undefined) {
          return 0;
        }
      }

      if (o === true) {
        return 1;
      }

      var type = typeof o;

      if (type === 'number') {
        var h = o | 0;

        if (h !== o) {
          h ^= o * 0xFFFFFFFF;
        }

        while (o > 0xFFFFFFFF) {
          o /= 0xFFFFFFFF;
          h ^= o;
        }

        return smi(h);
      }

      if (type === 'string') {
        return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
      }

      if (typeof o.hashCode === 'function') {
        return o.hashCode();
      }

      if (type === 'object') {
        return hashJSObj(o);
      }

      if (typeof o.toString === 'function') {
        return hashString(o.toString());
      }

      throw new Error('Value type ' + type + ' cannot be hashed.');
    }

    function cachedHashString(string) {
      var hash = stringHashCache[string];

      if (hash === undefined) {
        hash = hashString(string);

        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
          STRING_HASH_CACHE_SIZE = 0;
          stringHashCache = {};
        }

        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hash;
      }

      return hash;
    } // http://jsperf.com/hashing-strings


    function hashString(string) {
      // This is the hash from JVM
      // The hash code for a string is computed as
      // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
      // where s[i] is the ith character of the string and n is the length of
      // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
      // (exclusive) by dropping high bits.
      var hash = 0;

      for (var ii = 0; ii < string.length; ii++) {
        hash = 31 * hash + string.charCodeAt(ii) | 0;
      }

      return smi(hash);
    }

    function hashJSObj(obj) {
      var hash;

      if (usingWeakMap) {
        hash = weakMap.get(obj);

        if (hash !== undefined) {
          return hash;
        }
      }

      hash = obj[UID_HASH_KEY];

      if (hash !== undefined) {
        return hash;
      }

      if (!canDefineProperty) {
        hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];

        if (hash !== undefined) {
          return hash;
        }

        hash = getIENodeHash(obj);

        if (hash !== undefined) {
          return hash;
        }
      }

      hash = ++objHashUID;

      if (objHashUID & 0x40000000) {
        objHashUID = 0;
      }

      if (usingWeakMap) {
        weakMap.set(obj, hash);
      } else if (isExtensible !== undefined && isExtensible(obj) === false) {
        throw new Error('Non-extensible objects are not allowed as keys.');
      } else if (canDefineProperty) {
        Object.defineProperty(obj, UID_HASH_KEY, {
          'enumerable': false,
          'configurable': false,
          'writable': false,
          'value': hash
        });
      } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function () {
          return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };

        obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
      } else if (obj.nodeType !== undefined) {
        // At this point we couldn't get the IE `uniqueID` to use as a hash
        // and we couldn't use a non-enumerable property to exploit the
        // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
        // itself.
        obj[UID_HASH_KEY] = hash;
      } else {
        throw new Error('Unable to set a non-enumerable property on object.');
      }

      return hash;
    } // Get references to ES5 object methods.


    var isExtensible = Object.isExtensible; // True if Object.defineProperty works as expected. IE8 fails this test.

    var canDefineProperty = function () {
      try {
        Object.defineProperty({}, '@', {});
        return true;
      } catch (e) {
        return false;
      }
    }(); // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
    // and avoid memory leaks from the IE cloneNode bug.


    function getIENodeHash(node) {
      if (node && node.nodeType > 0) {
        switch (node.nodeType) {
          case 1:
            // Element
            return node.uniqueID;

          case 9:
            // Document
            return node.documentElement && node.documentElement.uniqueID;
        }
      }
    } // If possible, use a WeakMap.


    var usingWeakMap = typeof WeakMap === 'function';
    var weakMap;

    if (usingWeakMap) {
      weakMap = new WeakMap();
    }

    var objHashUID = 0;
    var UID_HASH_KEY = '__immutablehash__';

    if (typeof Symbol === 'function') {
      UID_HASH_KEY = Symbol(UID_HASH_KEY);
    }

    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};

    function assertNotInfinite(size) {
      invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
    }

    createClass(Map, KeyedCollection); // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
        var iter = KeyedIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v, k) {
          return map.set(k, v);
        });
      });
    }

    Map.prototype.toString = function () {
      return this.__toString('Map {', '}');
    }; // @pragma Access


    Map.prototype.get = function (k, notSetValue) {
      return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    }; // @pragma Modification


    Map.prototype.set = function (k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function (keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function () {
        return v;
      });
    };

    Map.prototype.remove = function (k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function (keyPath) {
      return this.updateIn(keyPath, function () {
        return NOT_SET;
      });
    };

    Map.prototype.update = function (k, notSetValue, updater) {
      return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }

      var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return emptyMap();
    }; // @pragma Composition


    Map.prototype.merge = function ()
    /*...iters*/
    {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function (keyPath) {
      var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(keyPath, emptyMap(), function (m) {
        return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
      });
    };

    Map.prototype.mergeDeep = function ()
    /*...iters*/
    {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function (keyPath) {
      var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(keyPath, emptyMap(), function (m) {
        return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
      });
    };

    Map.prototype.sort = function (comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function (mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    }; // @pragma Mutability


    Map.prototype.withMutations = function (fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function () {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function () {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function () {
      return this.__altered;
    };

    Map.prototype.__iterator = function (type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function (entry) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }

      return makeMap(this.size, this._root, ownerID, this.__hash);
    };

    function isMap(maybeMap) {
      return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }

    Map.isMap = isMap;
    var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
    var MapPrototype = Map.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn; // #pragma Trie Nodes

    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      var entries = this.entries;

      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }

      return notSetValue;
    };

    ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var entries = this.entries;
      var idx = 0;

      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }

      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };

    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & bit - 1);
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };

    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      var newCount = this.count;

      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;

        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };

    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      var entries = this.entries;

      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }

      return notSetValue;
    };

    HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }

        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;

      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }

      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };

    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);

      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }

        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    }; // #pragma Iterators


    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
      var entries = this.entries;

      for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
          return false;
        }
      }
    };

    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
      var nodes = this.nodes;

      for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
        var node = nodes[reverse ? maxIndex - ii : ii];

        if (node && node.iterate(fn, reverse) === false) {
          return false;
        }
      }
    };

    ValueNode.prototype.iterate = function (fn, reverse) {
      return fn(this.entry);
    };

    createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function () {
      var type = this._type;
      var stack = this._stack;

      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;

        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;

          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;

          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];

            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }

              stack = this._stack = mapIteratorFrame(subNode, stack);
            }

            continue;
          }
        }

        stack = this._stack = this._stack.__prev;
      }

      return iteratorDone();
    };

    function mapIteratorValue(type, entry) {
      return iteratorValue(type, entry[0], entry[1]);
    }

    function mapIteratorFrame(node, prev) {
      return {
        node: node,
        index: 0,
        __prev: prev
      };
    }

    function makeMap(size, root, ownerID, hash) {
      var map = Object.create(MapPrototype);
      map.size = size;
      map._root = root;
      map.__ownerID = ownerID;
      map.__hash = hash;
      map.__altered = false;
      return map;
    }

    var EMPTY_MAP;

    function emptyMap() {
      return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }

    function updateMap(map, k, v) {
      var newRoot;
      var newSize;

      if (!map._root) {
        if (v === NOT_SET) {
          return map;
        }

        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
      } else {
        var didChangeSize = MakeRef(CHANGE_LENGTH);
        var didAlter = MakeRef(DID_ALTER);
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);

        if (!didAlter.value) {
          return map;
        }

        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
      }

      if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
      }

      return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }

    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (!node) {
        if (value === NOT_SET) {
          return node;
        }

        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [key, value]);
      }

      return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }

    function isLeafNode(node) {
      return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }

    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
      if (node.keyHash === keyHash) {
        return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
      }

      var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
      var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var newNode;
      var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
      return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }

    function createNodes(ownerID, entries, key, value) {
      if (!ownerID) {
        ownerID = new OwnerID();
      }

      var node = new ValueNode(ownerID, hash(key), [key, value]);

      for (var ii = 0; ii < entries.length; ii++) {
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
      }

      return node;
    }

    function packNodes(ownerID, nodes, count, excluding) {
      var bitmap = 0;
      var packedII = 0;
      var packedNodes = new Array(count);

      for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
        var node = nodes[ii];

        if (node !== undefined && ii !== excluding) {
          bitmap |= bit;
          packedNodes[packedII++] = node;
        }
      }

      return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }

    function expandNodes(ownerID, nodes, bitmap, including, node) {
      var count = 0;
      var expandedNodes = new Array(SIZE);

      for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
        expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
      }

      expandedNodes[including] = node;
      return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }

    function mergeIntoMapWith(map, merger, iterables) {
      var iters = [];

      for (var ii = 0; ii < iterables.length; ii++) {
        var value = iterables[ii];
        var iter = KeyedIterable(value);

        if (!isIterable(value)) {
          iter = iter.map(function (v) {
            return fromJS(v);
          });
        }

        iters.push(iter);
      }

      return mergeIntoCollectionWith(map, merger, iters);
    }

    function deepMerger(existing, value, key) {
      return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }

    function deepMergerWith(merger) {
      return function (existing, value, key) {
        if (existing && existing.mergeDeepWith && isIterable(value)) {
          return existing.mergeDeepWith(merger, value);
        }

        var nextValue = merger(existing, value, key);
        return is(existing, nextValue) ? existing : nextValue;
      };
    }

    function mergeIntoCollectionWith(collection, merger, iters) {
      iters = iters.filter(function (x) {
        return x.size !== 0;
      });

      if (iters.length === 0) {
        return collection;
      }

      if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
        return collection.constructor(iters[0]);
      }

      return collection.withMutations(function (collection) {
        var mergeIntoMap = merger ? function (value, key) {
          collection.update(key, NOT_SET, function (existing) {
            return existing === NOT_SET ? value : merger(existing, value, key);
          });
        } : function (value, key) {
          collection.set(key, value);
        };

        for (var ii = 0; ii < iters.length; ii++) {
          iters[ii].forEach(mergeIntoMap);
        }
      });
    }

    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
      var isNotSet = existing === NOT_SET;
      var step = keyPathIter.next();

      if (step.done) {
        var existingValue = isNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
      }

      invariant(isNotSet || existing && existing.set, 'invalid keyPath');
      var key = step.value;
      var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
      var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
      return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }

    function popCount(x) {
      x = x - (x >> 1 & 0x55555555);
      x = (x & 0x33333333) + (x >> 2 & 0x33333333);
      x = x + (x >> 4) & 0x0f0f0f0f;
      x = x + (x >> 8);
      x = x + (x >> 16);
      return x & 0x7f;
    }

    function setIn(array, idx, val, canEdit) {
      var newArray = canEdit ? array : arrCopy(array);
      newArray[idx] = val;
      return newArray;
    }

    function spliceIn(array, idx, val, canEdit) {
      var newLen = array.length + 1;

      if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
      }

      var newArray = new Array(newLen);
      var after = 0;

      for (var ii = 0; ii < newLen; ii++) {
        if (ii === idx) {
          newArray[ii] = val;
          after = -1;
        } else {
          newArray[ii] = array[ii + after];
        }
      }

      return newArray;
    }

    function spliceOut(array, idx, canEdit) {
      var newLen = array.length - 1;

      if (canEdit && idx === newLen) {
        array.pop();
        return array;
      }

      var newArray = new Array(newLen);
      var after = 0;

      for (var ii = 0; ii < newLen; ii++) {
        if (ii === idx) {
          after = 1;
        }

        newArray[ii] = array[ii + after];
      }

      return newArray;
    }

    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List, IndexedCollection); // @pragma Construction

    function List(value) {
      var empty = emptyList();

      if (value === null || value === undefined) {
        return empty;
      }

      if (isList(value)) {
        return value;
      }

      var iter = IndexedIterable(value);
      var size = iter.size;

      if (size === 0) {
        return empty;
      }

      assertNotInfinite(size);

      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }

      return empty.withMutations(function (list) {
        list.setSize(size);
        iter.forEach(function (v, i) {
          return list.set(i, v);
        });
      });
    }

    List.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    List.prototype.toString = function () {
      return this.__toString('List [', ']');
    }; // @pragma Access


    List.prototype.get = function (index, notSetValue) {
      index = wrapIndex(this, index);

      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }

      return notSetValue;
    }; // @pragma Modification


    List.prototype.set = function (index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function (index) {
      return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };

    List.prototype.insert = function (index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return emptyList();
    };

    List.prototype.push = function ()
    /*...values*/
    {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function (list) {
        setListBounds(list, 0, oldSize + values.length);

        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function () {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function ()
    /*...values*/
    {
      var values = arguments;
      return this.withMutations(function (list) {
        setListBounds(list, -values.length);

        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function () {
      return setListBounds(this, 1);
    }; // @pragma Composition


    List.prototype.merge = function ()
    /*...iters*/
    {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function ()
    /*...iters*/
    {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function (size) {
      return setListBounds(this, 0, size);
    }; // @pragma Iteration


    List.prototype.slice = function (begin, end) {
      var size = this.size;

      if (wholeSlice(begin, end, size)) {
        return this;
      }

      return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };

    List.prototype.__iterator = function (type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function () {
        var value = values();
        return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function (fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;

      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }

      return index;
    };

    List.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }

      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };

    function isList(maybeList) {
      return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }

    List.isList = isList;
    var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
    var ListPrototype = List.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;

    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    } // TODO: seems like these methods are very similar


    VNode.prototype.removeBefore = function (ownerID, level, index) {
      if (index === level ? 1 << level : this.array.length === 0) {
        return this;
      }

      var originIndex = index >>> level & MASK;

      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }

      var removingFirst = originIndex === 0;
      var newChild;

      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);

        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }

      if (removingFirst && !newChild) {
        return this;
      }

      var editable = editableVNode(this, ownerID);

      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }

      if (newChild) {
        editable.array[originIndex] = newChild;
      }

      return editable;
    };

    VNode.prototype.removeAfter = function (ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }

      var sizeIndex = index - 1 >>> level & MASK;

      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;

      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);

        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);

      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }

      return editable;
    };

    var DONE = {};

    function iterateList(list, reverse) {
      var left = list._origin;
      var right = list._capacity;
      var tailPos = getTailOffset(right);
      var tail = list._tail;
      return iterateNodeOrLeaf(list._root, list._level, 0);

      function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
      }

      function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;

        if (to > SIZE) {
          to = SIZE;
        }

        return function () {
          if (from === to) {
            return DONE;
          }

          var idx = reverse ? --to : from++;
          return array && array[idx];
        };
      }

      function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;

        if (to > SIZE) {
          to = SIZE;
        }

        return function () {
          do {
            if (values) {
              var value = values();

              if (value !== DONE) {
                return value;
              }

              values = null;
            }

            if (from === to) {
              return DONE;
            }

            var idx = reverse ? --to : from++;
            values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
          } while (true);
        };
      }
    }

    function makeList(origin, capacity, level, root, tail, ownerID, hash) {
      var list = Object.create(ListPrototype);
      list.size = capacity - origin;
      list._origin = origin;
      list._capacity = capacity;
      list._level = level;
      list._root = root;
      list._tail = tail;
      list.__ownerID = ownerID;
      list.__hash = hash;
      list.__altered = false;
      return list;
    }

    var EMPTY_LIST;

    function emptyList() {
      return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }

    function updateList(list, index, value) {
      index = wrapIndex(list, index);

      if (index !== index) {
        return list;
      }

      if (index >= list.size || index < 0) {
        return list.withMutations(function (list) {
          index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
        });
      }

      index += list._origin;
      var newTail = list._tail;
      var newRoot = list._root;
      var didAlter = MakeRef(DID_ALTER);

      if (index >= getTailOffset(list._capacity)) {
        newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
      } else {
        newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
      }

      if (!didAlter.value) {
        return list;
      }

      if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
      }

      return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }

    function updateVNode(node, ownerID, level, index, value, didAlter) {
      var idx = index >>> level & MASK;
      var nodeHas = node && idx < node.array.length;

      if (!nodeHas && value === undefined) {
        return node;
      }

      var newNode;

      if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);

        if (newLowerNode === lowerNode) {
          return node;
        }

        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
      }

      if (nodeHas && node.array[idx] === value) {
        return node;
      }

      SetRef(didAlter);
      newNode = editableVNode(node, ownerID);

      if (value === undefined && idx === newNode.array.length - 1) {
        newNode.array.pop();
      } else {
        newNode.array[idx] = value;
      }

      return newNode;
    }

    function editableVNode(node, ownerID) {
      if (ownerID && node && ownerID === node.ownerID) {
        return node;
      }

      return new VNode(node ? node.array.slice() : [], ownerID);
    }

    function listNodeFor(list, rawIndex) {
      if (rawIndex >= getTailOffset(list._capacity)) {
        return list._tail;
      }

      if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;

        while (node && level > 0) {
          node = node.array[rawIndex >>> level & MASK];
          level -= SHIFT;
        }

        return node;
      }
    }

    function setListBounds(list, begin, end) {
      // Sanitize begin & end using this shorthand for ToInt32(argument)
      // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
      if (begin !== undefined) {
        begin = begin | 0;
      }

      if (end !== undefined) {
        end = end | 0;
      }

      var owner = list.__ownerID || new OwnerID();
      var oldOrigin = list._origin;
      var oldCapacity = list._capacity;
      var newOrigin = oldOrigin + begin;
      var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;

      if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
        return list;
      } // If it's going to end after it starts, it's empty.


      if (newOrigin >= newCapacity) {
        return list.clear();
      }

      var newLevel = list._level;
      var newRoot = list._root; // New origin might need creating a higher root.

      var offsetShift = 0;

      while (newOrigin + offsetShift < 0) {
        newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
      }

      if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
      }

      var oldTailOffset = getTailOffset(oldCapacity);
      var newTailOffset = getTailOffset(newCapacity); // New size might need creating a higher root.

      while (newTailOffset >= 1 << newLevel + SHIFT) {
        newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
        newLevel += SHIFT;
      } // Locate or create the new tail.


      var oldTail = list._tail;
      var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail; // Merge Tail into tree.

      if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;

        for (var level = newLevel; level > SHIFT; level -= SHIFT) {
          var idx = oldTailOffset >>> level & MASK;
          node = node.array[idx] = editableVNode(node.array[idx], owner);
        }

        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
      } // If the size has been reduced, there's a chance the tail needs to be trimmed.


      if (newCapacity < oldCapacity) {
        newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
      } // If the new origin is within the tail, then we do not need a root.


      if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin); // Otherwise, if the root has been trimmed, garbage collect.
      } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0; // Identify the new top root node of the subtree of the old root.

        while (newRoot) {
          var beginIndex = newOrigin >>> newLevel & MASK;

          if (beginIndex !== newTailOffset >>> newLevel & MASK) {
            break;
          }

          if (beginIndex) {
            offsetShift += (1 << newLevel) * beginIndex;
          }

          newLevel -= SHIFT;
          newRoot = newRoot.array[beginIndex];
        } // Trim the new sides of the new root.


        if (newRoot && newOrigin > oldOrigin) {
          newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        }

        if (newRoot && newTailOffset < oldTailOffset) {
          newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        }

        if (offsetShift) {
          newOrigin -= offsetShift;
          newCapacity -= offsetShift;
        }
      }

      if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
      }

      return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }

    function mergeIntoListWith(list, merger, iterables) {
      var iters = [];
      var maxSize = 0;

      for (var ii = 0; ii < iterables.length; ii++) {
        var value = iterables[ii];
        var iter = IndexedIterable(value);

        if (iter.size > maxSize) {
          maxSize = iter.size;
        }

        if (!isIterable(value)) {
          iter = iter.map(function (v) {
            return fromJS(v);
          });
        }

        iters.push(iter);
      }

      if (maxSize > list.size) {
        list = list.setSize(maxSize);
      }

      return mergeIntoCollectionWith(list, merger, iters);
    }

    function getTailOffset(size) {
      return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }

    createClass(OrderedMap, Map); // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
        var iter = KeyedIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v, k) {
          return map.set(k, v);
        });
      });
    }

    OrderedMap.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function () {
      return this.__toString('OrderedMap {', '}');
    }; // @pragma Access


    OrderedMap.prototype.get = function (k, notSetValue) {
      var index = this._map.get(k);

      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    }; // @pragma Modification


    OrderedMap.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = 0;

        this._map.clear();

        this._list.clear();

        return this;
      }

      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function (k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function (k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function () {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._list.__iterate(function (entry) {
        return entry && fn(entry[1], entry[0], this$0);
      }, reverse);
    };

    OrderedMap.prototype.__iterator = function (type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      var newMap = this._map.__ensureOwner(ownerID);

      var newList = this._list.__ensureOwner(ownerID);

      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }

      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };

    function isOrderedMap(maybeOrderedMap) {
      return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }

    OrderedMap.isOrderedMap = isOrderedMap;
    OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

    function makeOrderedMap(map, list, ownerID, hash) {
      var omap = Object.create(OrderedMap.prototype);
      omap.size = map ? map.size : 0;
      omap._map = map;
      omap._list = list;
      omap.__ownerID = ownerID;
      omap.__hash = hash;
      return omap;
    }

    var EMPTY_ORDERED_MAP;

    function emptyOrderedMap() {
      return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }

    function updateOrderedMap(omap, k, v) {
      var map = omap._map;
      var list = omap._list;
      var i = map.get(k);
      var has = i !== undefined;
      var newMap;
      var newList;

      if (v === NOT_SET) {
        // removed
        if (!has) {
          return omap;
        }

        if (list.size >= SIZE && list.size >= map.size * 2) {
          newList = list.filter(function (entry, idx) {
            return entry !== undefined && i !== idx;
          });
          newMap = newList.toKeyedSeq().map(function (entry) {
            return entry[0];
          }).flip().toMap();

          if (omap.__ownerID) {
            newMap.__ownerID = newList.__ownerID = omap.__ownerID;
          }
        } else {
          newMap = map.remove(k);
          newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
      } else {
        if (has) {
          if (v === list.get(i)[1]) {
            return omap;
          }

          newMap = map;
          newList = list.set(i, [k, v]);
        } else {
          newMap = map.set(k, list.size);
          newList = list.set(list.size, [k, v]);
        }
      }

      if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        return omap;
      }

      return makeOrderedMap(newMap, newList);
    }

    createClass(ToKeyedSequence, KeyedSeq);

    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function (key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function (key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function () {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function () {
      var this$0 = this;
      var reversedSequence = reverseFactory(this, true);

      if (!this._useKeys) {
        reversedSequence.valueSeq = function () {
          return this$0._iter.toSeq().reverse();
        };
      }

      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function (mapper, context) {
      var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);

      if (!this._useKeys) {
        mappedSequence.valueSeq = function () {
          return this$0._iter.toSeq().map(mapper, context);
        };
      }

      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      var ii;
      return this._iter.__iterate(this._useKeys ? function (v, k) {
        return fn(v, k, this$0);
      } : (ii = reverse ? resolveSize(this) : 0, function (v) {
        return fn(v, reverse ? --ii : ii++, this$0);
      }), reverse);
    };

    ToKeyedSequence.prototype.__iterator = function (type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }

      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);

    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function (value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function (v) {
        return fn(v, iterations++, this$0);
      }, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function (type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      var iterations = 0;
      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value, step);
      });
    };

    createClass(ToSetSequence, SetSeq);

    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function (key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._iter.__iterate(function (v) {
        return fn(v, v, this$0);
      }, reverse);
    };

    ToSetSequence.prototype.__iterator = function (type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, step.value, step.value, step);
      });
    };

    createClass(FromEntriesSequence, KeyedSeq);

    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function () {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._iter.__iterate(function (entry) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function (type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      return new Iterator(function () {
        while (true) {
          var step = iterator.next();

          if (step.done) {
            return step;
          }

          var entry = step.value; // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.

          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
          }
        }
      });
    };

    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;

    function flipFactory(iterable) {
      var flipSequence = makeSequence(iterable);
      flipSequence._iter = iterable;
      flipSequence.size = iterable.size;

      flipSequence.flip = function () {
        return iterable;
      };

      flipSequence.reverse = function () {
        var reversedSequence = iterable.reverse.apply(this); // super.reverse()

        reversedSequence.flip = function () {
          return iterable.reverse();
        };

        return reversedSequence;
      };

      flipSequence.has = function (key) {
        return iterable.includes(key);
      };

      flipSequence.includes = function (key) {
        return iterable.has(key);
      };

      flipSequence.cacheResult = cacheResultThrough;

      flipSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function (v, k) {
          return fn(k, v, this$0) !== false;
        }, reverse);
      };

      flipSequence.__iteratorUncached = function (type, reverse) {
        if (type === ITERATE_ENTRIES) {
          var iterator = iterable.__iterator(type, reverse);

          return new Iterator(function () {
            var step = iterator.next();

            if (!step.done) {
              var k = step.value[0];
              step.value[0] = step.value[1];
              step.value[1] = k;
            }

            return step;
          });
        }

        return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
      };

      return flipSequence;
    }

    function mapFactory(iterable, mapper, context) {
      var mappedSequence = makeSequence(iterable);
      mappedSequence.size = iterable.size;

      mappedSequence.has = function (key) {
        return iterable.has(key);
      };

      mappedSequence.get = function (key, notSetValue) {
        var v = iterable.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
      };

      mappedSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function (v, k, c) {
          return fn(mapper.call(context, v, k, c), k, this$0) !== false;
        }, reverse);
      };

      mappedSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        return new Iterator(function () {
          var step = iterator.next();

          if (step.done) {
            return step;
          }

          var entry = step.value;
          var key = entry[0];
          return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
        });
      };

      return mappedSequence;
    }

    function reverseFactory(iterable, useKeys) {
      var reversedSequence = makeSequence(iterable);
      reversedSequence._iter = iterable;
      reversedSequence.size = iterable.size;

      reversedSequence.reverse = function () {
        return iterable;
      };

      if (iterable.flip) {
        reversedSequence.flip = function () {
          var flipSequence = flipFactory(iterable);

          flipSequence.reverse = function () {
            return iterable.flip();
          };

          return flipSequence;
        };
      }

      reversedSequence.get = function (key, notSetValue) {
        return iterable.get(useKeys ? key : -1 - key, notSetValue);
      };

      reversedSequence.has = function (key) {
        return iterable.has(useKeys ? key : -1 - key);
      };

      reversedSequence.includes = function (value) {
        return iterable.includes(value);
      };

      reversedSequence.cacheResult = cacheResultThrough;

      reversedSequence.__iterate = function (fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function (v, k) {
          return fn(v, k, this$0);
        }, !reverse);
      };

      reversedSequence.__iterator = function (type, reverse) {
        return iterable.__iterator(type, !reverse);
      };

      return reversedSequence;
    }

    function filterFactory(iterable, predicate, context, useKeys) {
      var filterSequence = makeSequence(iterable);

      if (useKeys) {
        filterSequence.has = function (key) {
          var v = iterable.get(key, NOT_SET);
          return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
        };

        filterSequence.get = function (key, notSetValue) {
          var v = iterable.get(key, NOT_SET);
          return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
        };
      }

      filterSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        var iterations = 0;

        iterable.__iterate(function (v, k, c) {
          if (predicate.call(context, v, k, c)) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0);
          }
        }, reverse);

        return iterations;
      };

      filterSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        var iterations = 0;
        return new Iterator(function () {
          while (true) {
            var step = iterator.next();

            if (step.done) {
              return step;
            }

            var entry = step.value;
            var key = entry[0];
            var value = entry[1];

            if (predicate.call(context, value, key, iterable)) {
              return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
          }
        });
      };

      return filterSequence;
    }

    function countByFactory(iterable, grouper, context) {
      var groups = Map().asMutable();

      iterable.__iterate(function (v, k) {
        groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
          return a + 1;
        });
      });

      return groups.asImmutable();
    }

    function groupByFactory(iterable, grouper, context) {
      var isKeyedIter = isKeyed(iterable);
      var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();

      iterable.__iterate(function (v, k) {
        groups.update(grouper.call(context, v, k, iterable), function (a) {
          return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
        });
      });

      var coerce = iterableClass(iterable);
      return groups.map(function (arr) {
        return reify(iterable, coerce(arr));
      });
    }

    function sliceFactory(iterable, begin, end, useKeys) {
      var originalSize = iterable.size; // Sanitize begin & end using this shorthand for ToInt32(argument)
      // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32

      if (begin !== undefined) {
        begin = begin | 0;
      }

      if (end !== undefined) {
        end = end | 0;
      }

      if (wholeSlice(begin, end, originalSize)) {
        return iterable;
      }

      var resolvedBegin = resolveBegin(begin, originalSize);
      var resolvedEnd = resolveEnd(end, originalSize); // begin or end will be NaN if they were provided as negative numbers and
      // this iterable's size is unknown. In that case, cache first so there is
      // a known size and these do not resolve to NaN.

      if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
        return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
      } // Note: resolvedEnd is undefined when the original sequence's length is
      // unknown and this slice did not supply an end and should contain all
      // elements after resolvedBegin.
      // In that case, resolvedSize will be NaN and sliceSize will remain undefined.


      var resolvedSize = resolvedEnd - resolvedBegin;
      var sliceSize;

      if (resolvedSize === resolvedSize) {
        sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
      }

      var sliceSeq = makeSequence(iterable); // If iterable.size is undefined, the size of the realized sliceSeq is
      // unknown at this point unless the number of items to slice is 0

      sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

      if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
        sliceSeq.get = function (index, notSetValue) {
          index = wrapIndex(this, index);
          return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
      }

      sliceSeq.__iterateUncached = function (fn, reverse) {
        var this$0 = this;

        if (sliceSize === 0) {
          return 0;
        }

        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }

        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;

        iterable.__iterate(function (v, k) {
          if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
          }
        });

        return iterations;
      };

      sliceSeq.__iteratorUncached = function (type, reverse) {
        if (sliceSize !== 0 && reverse) {
          return this.cacheResult().__iterator(type, reverse);
        } // Don't bother instantiating parent iterator if taking 0.


        var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);

        var skipped = 0;
        var iterations = 0;
        return new Iterator(function () {
          while (skipped++ < resolvedBegin) {
            iterator.next();
          }

          if (++iterations > sliceSize) {
            return iteratorDone();
          }

          var step = iterator.next();

          if (useKeys || type === ITERATE_VALUES) {
            return step;
          } else if (type === ITERATE_KEYS) {
            return iteratorValue(type, iterations - 1, undefined, step);
          } else {
            return iteratorValue(type, iterations - 1, step.value[1], step);
          }
        });
      };

      return sliceSeq;
    }

    function takeWhileFactory(iterable, predicate, context) {
      var takeSequence = makeSequence(iterable);

      takeSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }

        var iterations = 0;

        iterable.__iterate(function (v, k, c) {
          return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
        });

        return iterations;
      };

      takeSequence.__iteratorUncached = function (type, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterator(type, reverse);
        }

        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        var iterating = true;
        return new Iterator(function () {
          if (!iterating) {
            return iteratorDone();
          }

          var step = iterator.next();

          if (step.done) {
            return step;
          }

          var entry = step.value;
          var k = entry[0];
          var v = entry[1];

          if (!predicate.call(context, v, k, this$0)) {
            iterating = false;
            return iteratorDone();
          }

          return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
      };

      return takeSequence;
    }

    function skipWhileFactory(iterable, predicate, context, useKeys) {
      var skipSequence = makeSequence(iterable);

      skipSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }

        var isSkipping = true;
        var iterations = 0;

        iterable.__iterate(function (v, k, c) {
          if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0);
          }
        });

        return iterations;
      };

      skipSequence.__iteratorUncached = function (type, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterator(type, reverse);
        }

        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        var skipping = true;
        var iterations = 0;
        return new Iterator(function () {
          var step, k, v;

          do {
            step = iterator.next();

            if (step.done) {
              if (useKeys || type === ITERATE_VALUES) {
                return step;
              } else if (type === ITERATE_KEYS) {
                return iteratorValue(type, iterations++, undefined, step);
              } else {
                return iteratorValue(type, iterations++, step.value[1], step);
              }
            }

            var entry = step.value;
            k = entry[0];
            v = entry[1];
            skipping && (skipping = predicate.call(context, v, k, this$0));
          } while (skipping);

          return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
      };

      return skipSequence;
    }

    function concatFactory(iterable, values) {
      var isKeyedIterable = isKeyed(iterable);
      var iters = [iterable].concat(values).map(function (v) {
        if (!isIterable(v)) {
          v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
        } else if (isKeyedIterable) {
          v = KeyedIterable(v);
        }

        return v;
      }).filter(function (v) {
        return v.size !== 0;
      });

      if (iters.length === 0) {
        return iterable;
      }

      if (iters.length === 1) {
        var singleton = iters[0];

        if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
          return singleton;
        }
      }

      var concatSeq = new ArraySeq(iters);

      if (isKeyedIterable) {
        concatSeq = concatSeq.toKeyedSeq();
      } else if (!isIndexed(iterable)) {
        concatSeq = concatSeq.toSetSeq();
      }

      concatSeq = concatSeq.flatten(true);
      concatSeq.size = iters.reduce(function (sum, seq) {
        if (sum !== undefined) {
          var size = seq.size;

          if (size !== undefined) {
            return sum + size;
          }
        }
      }, 0);
      return concatSeq;
    }

    function flattenFactory(iterable, depth, useKeys) {
      var flatSequence = makeSequence(iterable);

      flatSequence.__iterateUncached = function (fn, reverse) {
        var iterations = 0;
        var stopped = false;

        function flatDeep(iter, currentDepth) {
          var this$0 = this;

          iter.__iterate(function (v, k) {
            if ((!depth || currentDepth < depth) && isIterable(v)) {
              flatDeep(v, currentDepth + 1);
            } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
              stopped = true;
            }

            return !stopped;
          }, reverse);
        }

        flatDeep(iterable, 0);
        return iterations;
      };

      flatSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(type, reverse);

        var stack = [];
        var iterations = 0;
        return new Iterator(function () {
          while (iterator) {
            var step = iterator.next();

            if (step.done !== false) {
              iterator = stack.pop();
              continue;
            }

            var v = step.value;

            if (type === ITERATE_ENTRIES) {
              v = v[1];
            }

            if ((!depth || stack.length < depth) && isIterable(v)) {
              stack.push(iterator);
              iterator = v.__iterator(type, reverse);
            } else {
              return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
          }

          return iteratorDone();
        });
      };

      return flatSequence;
    }

    function flatMapFactory(iterable, mapper, context) {
      var coerce = iterableClass(iterable);
      return iterable.toSeq().map(function (v, k) {
        return coerce(mapper.call(context, v, k, iterable));
      }).flatten(true);
    }

    function interposeFactory(iterable, separator) {
      var interposedSequence = makeSequence(iterable);
      interposedSequence.size = iterable.size && iterable.size * 2 - 1;

      interposedSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        var iterations = 0;

        iterable.__iterate(function (v, k) {
          return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
        }, reverse);

        return iterations;
      };

      interposedSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(ITERATE_VALUES, reverse);

        var iterations = 0;
        var step;
        return new Iterator(function () {
          if (!step || iterations % 2) {
            step = iterator.next();

            if (step.done) {
              return step;
            }
          }

          return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
      };

      return interposedSequence;
    }

    function sortFactory(iterable, comparator, mapper) {
      if (!comparator) {
        comparator = defaultComparator;
      }

      var isKeyedIterable = isKeyed(iterable);
      var index = 0;
      var entries = iterable.toSeq().map(function (v, k) {
        return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
      }).toArray();
      entries.sort(function (a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
      }).forEach(isKeyedIterable ? function (v, i) {
        entries[i].length = 2;
      } : function (v, i) {
        entries[i] = v[1];
      });
      return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }

    function maxFactory(iterable, comparator, mapper) {
      if (!comparator) {
        comparator = defaultComparator;
      }

      if (mapper) {
        var entry = iterable.toSeq().map(function (v, k) {
          return [v, mapper(v, k, iterable)];
        }).reduce(function (a, b) {
          return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
      } else {
        return iterable.reduce(function (a, b) {
          return maxCompare(comparator, a, b) ? b : a;
        });
      }
    }

    function maxCompare(comparator, a, b) {
      var comp = comparator(b, a); // b is considered the new max if the comparator declares them equal, but
      // they are not equal and b is in fact a nullish value.

      return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
    }

    function zipWithFactory(keyIter, zipper, iters) {
      var zipSequence = makeSequence(keyIter);
      zipSequence.size = new ArraySeq(iters).map(function (i) {
        return i.size;
      }).min(); // Note: this a generic base implementation of __iterate in terms of
      // __iterator which may be more generically useful in the future.

      zipSequence.__iterate = function (fn, reverse) {
        /* generic:
        var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
        var step;
        var iterations = 0;
        while (!(step = iterator.next()).done) {
          iterations++;
          if (fn(step.value[1], step.value[0], this) === false) {
            break;
          }
        }
        return iterations;
        */
        // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);

        var step;
        var iterations = 0;

        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }

        return iterations;
      };

      zipSequence.__iteratorUncached = function (type, reverse) {
        var iterators = iters.map(function (i) {
          return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function () {
          var steps;

          if (!isDone) {
            steps = iterators.map(function (i) {
              return i.next();
            });
            isDone = steps.some(function (s) {
              return s.done;
            });
          }

          if (isDone) {
            return iteratorDone();
          }

          return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
            return s.value;
          })));
        });
      };

      return zipSequence;
    } // #pragma Helper Functions


    function reify(iter, seq) {
      return isSeq(iter) ? seq : iter.constructor(seq);
    }

    function validateEntry(entry) {
      if (entry !== Object(entry)) {
        throw new TypeError('Expected [K, V] tuple: ' + entry);
      }
    }

    function resolveSize(iter) {
      assertNotInfinite(iter.size);
      return ensureSize(iter);
    }

    function iterableClass(iterable) {
      return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }

    function makeSequence(iterable) {
      return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
    }

    function cacheResultThrough() {
      if (this._iter.cacheResult) {
        this._iter.cacheResult();

        this.size = this._iter.size;
        return this;
      } else {
        return Seq.prototype.cacheResult.call(this);
      }
    }

    function defaultComparator(a, b) {
      return a > b ? 1 : a < b ? -1 : 0;
    }

    function forceIterator(keyPath) {
      var iter = getIterator(keyPath);

      if (!iter) {
        // Array might not be iterable in this environment, so we need a fallback
        // to our wrapped type.
        if (!isArrayLike(keyPath)) {
          throw new TypeError('Expected iterable or array-like: ' + keyPath);
        }

        iter = getIterator(Iterable(keyPath));
      }

      return iter;
    }

    createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }

        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }

        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }

        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;
      return RecordType;
    }

    Record.prototype.toString = function () {
      return this.__toString(recordName(this) + ' {', '}');
    }; // @pragma Access


    Record.prototype.has = function (k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function (k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }

      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    }; // @pragma Modification


    Record.prototype.clear = function () {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }

      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function (k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }

      var newMap = this._map && this._map.set(k, v);

      if (this.__ownerID || newMap === this._map) {
        return this;
      }

      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function (k) {
      if (!this.has(k)) {
        return this;
      }

      var newMap = this._map && this._map.remove(k);

      if (this.__ownerID || newMap === this._map) {
        return this;
      }

      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function () {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function (type, reverse) {
      var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function (_, k) {
        return this$0.get(k);
      }).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function (_, k) {
        return this$0.get(k);
      }).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      var newMap = this._map && this._map.__ensureOwner(ownerID);

      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }

      return makeRecord(this, newMap, ownerID);
    };

    var RecordPrototype = Record.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;

    function makeRecord(likeRecord, map, ownerID) {
      var record = Object.create(Object.getPrototypeOf(likeRecord));
      record._map = map;
      record.__ownerID = ownerID;
      return record;
    }

    function recordName(record) {
      return record._name || record.constructor.name || 'Record';
    }

    function setProps(prototype, names) {
      try {
        names.forEach(setProp.bind(undefined, prototype));
      } catch (error) {// Object.defineProperty failed. Probably IE8.
      }
    }

    function setProp(prototype, name) {
      Object.defineProperty(prototype, name, {
        get: function get() {
          return this.get(name);
        },
        set: function set(value) {
          invariant(this.__ownerID, 'Cannot set on an immutable record.');
          this.set(name, value);
        }
      });
    }

    createClass(Set, SetCollection); // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
        var iter = SetIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v) {
          return set.add(v);
        });
      });
    }

    Set.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    Set.fromKeys = function (value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function () {
      return this.__toString('Set {', '}');
    }; // @pragma Access


    Set.prototype.has = function (value) {
      return this._map.has(value);
    }; // @pragma Modification


    Set.prototype.add = function (value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function (value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function () {
      return updateSet(this, this._map.clear());
    }; // @pragma Composition


    Set.prototype.union = function () {
      var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function (x) {
        return x.size !== 0;
      });

      if (iters.length === 0) {
        return this;
      }

      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }

      return this.withMutations(function (set) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function (value) {
            return set.add(value);
          });
        }
      });
    };

    Set.prototype.intersect = function () {
      var iters = SLICE$0.call(arguments, 0);

      if (iters.length === 0) {
        return this;
      }

      iters = iters.map(function (iter) {
        return SetIterable(iter);
      });
      var originalSet = this;
      return this.withMutations(function (set) {
        originalSet.forEach(function (value) {
          if (!iters.every(function (iter) {
            return iter.includes(value);
          })) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function () {
      var iters = SLICE$0.call(arguments, 0);

      if (iters.length === 0) {
        return this;
      }

      iters = iters.map(function (iter) {
        return SetIterable(iter);
      });
      var originalSet = this;
      return this.withMutations(function (set) {
        originalSet.forEach(function (value) {
          if (iters.some(function (iter) {
            return iter.includes(value);
          })) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function () {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function (comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function (mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function () {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._map.__iterate(function (_, k) {
        return fn(k, k, this$0);
      }, reverse);
    };

    Set.prototype.__iterator = function (type, reverse) {
      return this._map.map(function (_, k) {
        return k;
      }).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      var newMap = this._map.__ensureOwner(ownerID);

      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }

      return this.__make(newMap, ownerID);
    };

    function isSet(maybeSet) {
      return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }

    Set.isSet = isSet;
    var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
    var SetPrototype = Set.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;

    function updateSet(set, newMap) {
      if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
      }

      return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }

    function makeSet(map, ownerID) {
      var set = Object.create(SetPrototype);
      set.size = map ? map.size : 0;
      set._map = map;
      set.__ownerID = ownerID;
      return set;
    }

    var EMPTY_SET;

    function emptySet() {
      return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
    }

    createClass(OrderedSet, Set); // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
        var iter = SetIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v) {
          return set.add(v);
        });
      });
    }

    OrderedSet.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    OrderedSet.fromKeys = function (value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function () {
      return this.__toString('OrderedSet {', '}');
    };

    function isOrderedSet(maybeOrderedSet) {
      return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }

    OrderedSet.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;

    function makeOrderedSet(map, ownerID) {
      var set = Object.create(OrderedSetPrototype);
      set.size = map ? map.size : 0;
      set._map = map;
      set.__ownerID = ownerID;
      return set;
    }

    var EMPTY_ORDERED_SET;

    function emptyOrderedSet() {
      return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }

    createClass(Stack, IndexedCollection); // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }

    Stack.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    Stack.prototype.toString = function () {
      return this.__toString('Stack [', ']');
    }; // @pragma Access


    Stack.prototype.get = function (index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);

      while (head && index--) {
        head = head.next;
      }

      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function () {
      return this._head && this._head.value;
    }; // @pragma Modification


    Stack.prototype.push = function ()
    /*...values*/
    {
      if (arguments.length === 0) {
        return this;
      }

      var newSize = this.size + arguments.length;
      var head = this._head;

      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }

      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function (iter) {
      iter = IndexedIterable(iter);

      if (iter.size === 0) {
        return this;
      }

      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function (value) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });

      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function () {
      return this.slice(1);
    };

    Stack.prototype.unshift = function ()
    /*...values*/
    {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function (iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function () {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return emptyStack();
    };

    Stack.prototype.slice = function (begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }

      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);

      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }

      var newSize = this.size - resolvedBegin;
      var head = this._head;

      while (resolvedBegin--) {
        head = head.next;
      }

      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return makeStack(newSize, head);
    }; // @pragma Mutability


    Stack.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }

      return makeStack(this.size, this._head, ownerID, this.__hash);
    }; // @pragma Iteration


    Stack.prototype.__iterate = function (fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }

      var iterations = 0;
      var node = this._head;

      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }

        node = node.next;
      }

      return iterations;
    };

    Stack.prototype.__iterator = function (type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }

      var iterations = 0;
      var node = this._head;
      return new Iterator(function () {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }

        return iteratorDone();
      });
    };

    function isStack(maybeStack) {
      return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }

    Stack.isStack = isStack;
    var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
    var StackPrototype = Stack.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;

    function makeStack(size, head, ownerID, hash) {
      var map = Object.create(StackPrototype);
      map.size = size;
      map._head = head;
      map.__ownerID = ownerID;
      map.__hash = hash;
      map.__altered = false;
      return map;
    }

    var EMPTY_STACK;

    function emptyStack() {
      return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    /**
     * Contributes additional methods to a constructor
     */


    function mixin(ctor, methods) {
      var keyCopier = function keyCopier(key) {
        ctor.prototype[key] = methods[key];
      };

      Object.keys(methods).forEach(keyCopier);
      Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
      return ctor;
    }

    Iterable.Iterator = Iterator;
    mixin(Iterable, {
      // ### Conversion to other types
      toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);

        this.valueSeq().__iterate(function (v, i) {
          array[i] = v;
        });

        return array;
      },
      toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
      },
      toJS: function toJS() {
        return this.toSeq().map(function (value) {
          return value && typeof value.toJS === 'function' ? value.toJS() : value;
        }).__toJS();
      },
      toJSON: function toJSON() {
        return this.toSeq().map(function (value) {
          return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
        }).__toJS();
      },
      toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
      },
      toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
      },
      toObject: function toObject() {
        assertNotInfinite(this.size);
        var object = {};

        this.__iterate(function (v, k) {
          object[k] = v;
        });

        return object;
      },
      toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
      },
      toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
      },
      toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
      },
      toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
      },
      toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
      },
      toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
      },
      toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
      },
      // ### Common JavaScript methods and properties
      toString: function toString() {
        return '[Iterable]';
      },
      __toString: function __toString(head, tail) {
        if (this.size === 0) {
          return head + tail;
        }

        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      concat: function concat() {
        var values = SLICE$0.call(arguments, 0);
        return reify(this, concatFactory(this, values));
      },
      includes: function includes(searchValue) {
        return this.some(function (value) {
          return is(value, searchValue);
        });
      },
      entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
      },
      every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;

        this.__iterate(function (v, k, c) {
          if (!predicate.call(context, v, k, c)) {
            returnValue = false;
            return false;
          }
        });

        return returnValue;
      },
      filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
      },
      find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
      },
      findEntry: function findEntry(predicate, context) {
        var found;

        this.__iterate(function (v, k, c) {
          if (predicate.call(context, v, k, c)) {
            found = [k, v];
            return false;
          }
        });

        return found;
      },
      findLastEntry: function findLastEntry(predicate, context) {
        return this.toSeq().reverse().findEntry(predicate, context);
      },
      forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
      },
      join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;

        this.__iterate(function (v) {
          isFirst ? isFirst = false : joined += separator;
          joined += v !== null && v !== undefined ? v.toString() : '';
        });

        return joined;
      },
      keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
      },
      map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
      },
      reduce: function reduce(reducer, initialReduction, context) {
        assertNotInfinite(this.size);
        var reduction;
        var useFirst;

        if (arguments.length < 2) {
          useFirst = true;
        } else {
          reduction = initialReduction;
        }

        this.__iterate(function (v, k, c) {
          if (useFirst) {
            useFirst = false;
            reduction = v;
          } else {
            reduction = reducer.call(context, reduction, v, k, c);
          }
        });

        return reduction;
      },
      reduceRight: function reduceRight(reducer, initialReduction, context) {
        var reversed = this.toKeyedSeq().reverse();
        return reversed.reduce.apply(reversed, arguments);
      },
      reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
      },
      slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
      },
      some: function some(predicate, context) {
        return !this.every(not(predicate), context);
      },
      sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
      },
      values: function values() {
        return this.__iterator(ITERATE_VALUES);
      },
      // ### More sequential methods
      butLast: function butLast() {
        return this.slice(0, -1);
      },
      isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function () {
          return true;
        });
      },
      count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
      },
      countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
      },
      equals: function equals(other) {
        return deepEqual(this, other);
      },
      entrySeq: function entrySeq() {
        var iterable = this;

        if (iterable._cache) {
          // We cache as an entries array, so we can just return the cache!
          return new ArraySeq(iterable._cache);
        }

        var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();

        entriesSequence.fromEntrySeq = function () {
          return iterable.toSeq();
        };

        return entriesSequence;
      },
      filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
      },
      findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
      },
      first: function first() {
        return this.find(returnTrue);
      },
      flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
      },
      flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
      },
      fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
      },
      get: function get(searchKey, notSetValue) {
        return this.find(function (_, key) {
          return is(key, searchKey);
        }, undefined, notSetValue);
      },
      getIn: function getIn(searchKeyPath, notSetValue) {
        var nested = this; // Note: in an ES6 environment, we would prefer:
        // for (var key of searchKeyPath) {

        var iter = forceIterator(searchKeyPath);
        var step;

        while (!(step = iter.next()).done) {
          var key = step.value;
          nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;

          if (nested === NOT_SET) {
            return notSetValue;
          }
        }

        return nested;
      },
      groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
      },
      has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
      },
      hasIn: function hasIn(searchKeyPath) {
        return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
      },
      isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
        return this.every(function (value) {
          return iter.includes(value);
        });
      },
      isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
        return iter.isSubset(this);
      },
      keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
      },
      last: function last() {
        return this.toSeq().reverse().first();
      },
      max: function max(comparator) {
        return maxFactory(this, comparator);
      },
      maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
      },
      min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
      },
      minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
      },
      rest: function rest() {
        return this.slice(1);
      },
      skip: function skip(amount) {
        return this.slice(Math.max(0, amount));
      },
      skipLast: function skipLast(amount) {
        return reify(this, this.toSeq().reverse().skip(amount).reverse());
      },
      skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
      },
      skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
      },
      sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
      },
      take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
      },
      takeLast: function takeLast(amount) {
        return reify(this, this.toSeq().reverse().take(amount).reverse());
      },
      takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
      },
      takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
      },
      valueSeq: function valueSeq() {
        return this.toIndexedSeq();
      },
      // ### Hashable Object
      hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashIterable(this));
      } // ### Internal
      // abstract __iterate(fn, reverse)
      // abstract __iterator(type, reverse)

    }); // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;

    IterablePrototype.inspect = IterablePrototype.toSource = function () {
      return this.toString();
    };

    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes; // Temporary warning about using length

    (function () {
      try {
        Object.defineProperty(IterablePrototype, 'length', {
          get: function get() {
            if (!Iterable.noLengthWarning) {
              var stack;

              try {
                throw new Error();
              } catch (error) {
                stack = error.stack;
              }

              if (stack.indexOf('_wrapObject') === -1) {
                console && console.warn && console.warn('iterable.length has been deprecated, ' + 'use iterable.size or iterable.count(). ' + 'This warning will become a silent error in a future version. ' + stack);
                return this.size;
              }
            }
          }
        });
      } catch (e) {}
    })();

    mixin(KeyedIterable, {
      // ### More sequential methods
      flip: function flip() {
        return reify(this, flipFactory(this));
      },
      findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
      },
      findLastKey: function findLastKey(predicate, context) {
        return this.toSeq().reverse().findKey(predicate, context);
      },
      keyOf: function keyOf(searchValue) {
        return this.findKey(function (value) {
          return is(value, searchValue);
        });
      },
      lastKeyOf: function lastKeyOf(searchValue) {
        return this.findLastKey(function (value) {
          return is(value, searchValue);
        });
      },
      mapEntries: function mapEntries(mapper, context) {
        var this$0 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function (v, k) {
          return mapper.call(context, [k, v], iterations++, this$0);
        }).fromEntrySeq());
      },
      mapKeys: function mapKeys(mapper, context) {
        var this$0 = this;
        return reify(this, this.toSeq().flip().map(function (k, v) {
          return mapper.call(context, k, v, this$0);
        }).flip());
      }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;

    KeyedIterablePrototype.__toStringMapper = function (v, k) {
      return JSON.stringify(k) + ': ' + quoteString(v);
    };

    mixin(IndexedIterable, {
      // ### Conversion to other types
      toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
      },
      findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
      },
      indexOf: function indexOf(searchValue) {
        var key = this.toKeyedSeq().keyOf(searchValue);
        return key === undefined ? -1 : key;
      },
      lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.toKeyedSeq().reverse().keyOf(searchValue);
        return key === undefined ? -1 : key; // var index =
        // return this.toSeq().reverse().indexOf(searchValue);
      },
      reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
      },
      slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
      },
      splice: function splice(index, removeNum
      /*, ...values*/
      ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum | 0, 0);

        if (numArgs === 0 || numArgs === 2 && !removeNum) {
          return this;
        } // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.


        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
      },
      // ### More collection methods
      findLastIndex: function findLastIndex(predicate, context) {
        var key = this.toKeyedSeq().findLastKey(predicate, context);
        return key === undefined ? -1 : key;
      },
      first: function first() {
        return this.get(0);
      },
      flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
      },
      get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
          return key === index;
        }, undefined, notSetValue);
      },
      has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
      },
      interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
      },
      interleave: function interleave()
      /*...iterables*/
      {
        var iterables = [this].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
        var interleaved = zipped.flatten(true);

        if (zipped.size) {
          interleaved.size = zipped.size * iterables.length;
        }

        return reify(this, interleaved);
      },
      last: function last() {
        return this.get(-1);
      },
      skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
      },
      zip: function zip()
      /*, ...iterables */
      {
        var iterables = [this].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, iterables));
      },
      zipWith: function zipWith(zipper
      /*, ...iterables */
      ) {
        var iterables = arrCopy(arguments);
        iterables[0] = this;
        return reify(this, zipWithFactory(this, zipper, iterables));
      }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
      // ### ES6 Collection methods (ES6 Array and Map)
      get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
      },
      includes: function includes(value) {
        return this.has(value);
      },
      // ### More sequential methods
      keySeq: function keySeq() {
        return this.valueSeq();
      }
    });
    SetIterable.prototype.has = IterablePrototype.includes; // Mixin subclasses

    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype); // #pragma Helper functions

    function keyMapper(v, k) {
      return k;
    }

    function entryMapper(v, k) {
      return [k, v];
    }

    function not(predicate) {
      return function () {
        return !predicate.apply(this, arguments);
      };
    }

    function neg(predicate) {
      return function () {
        return -predicate.apply(this, arguments);
      };
    }

    function quoteString(value) {
      return typeof value === 'string' ? JSON.stringify(value) : value;
    }

    function defaultZipper() {
      return arrCopy(arguments);
    }

    function defaultNegComparator(a, b) {
      return a < b ? 1 : a > b ? -1 : 0;
    }

    function hashIterable(iterable) {
      if (iterable.size === Infinity) {
        return 0;
      }

      var ordered = isOrdered(iterable);
      var keyed = isKeyed(iterable);
      var h = ordered ? 1 : 0;

      var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
      } : function (v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
      } : ordered ? function (v) {
        h = 31 * h + hash(v) | 0;
      } : function (v) {
        h = h + hash(v) | 0;
      });

      return murmurHashOfSize(size, h);
    }

    function murmurHashOfSize(size, h) {
      h = imul(h, 0xCC9E2D51);
      h = imul(h << 15 | h >>> -15, 0x1B873593);
      h = imul(h << 13 | h >>> -13, 5);
      h = (h + 0xE6546B64 | 0) ^ size;
      h = imul(h ^ h >>> 16, 0x85EBCA6B);
      h = imul(h ^ h >>> 13, 0xC2B2AE35);
      h = smi(h ^ h >>> 16);
      return h;
    }

    function hashMerge(a, b) {
      return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
    }

    var Immutable = {
      Iterable: Iterable,
      Seq: Seq,
      Collection: Collection,
      Map: Map,
      OrderedMap: OrderedMap,
      List: List,
      Stack: Stack,
      Set: Set,
      OrderedSet: OrderedSet,
      Record: Record,
      Range: Range,
      Repeat: Repeat,
      is: is,
      fromJS: fromJS
    };
    return Immutable;
  });
});
var OrderedMap = immutable.OrderedMap;
var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};
var BlockMapBuilder_1 = BlockMapBuilder;

function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$a(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Map$2 = immutable.Map,
    OrderedSet = immutable.OrderedSet,
    Record = immutable.Record; // Immutable.map is typed such that the value for every key in the map
// must be the same type

var EMPTY_SET = OrderedSet();
var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};
var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits$a(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck$a(this, CharacterMetadata);

    return _possibleConstructorReturn$a(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };
  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    }; // Fill in unspecified properties, if necessary.

    var configMap = Map$2(defaultConfig).merge(config);
    var existing = pool.get(configMap);

    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map$2([[Map$2(defaultRecord), EMPTY]]);
CharacterMetadata.EMPTY = EMPTY;
var CharacterMetadata_1 = CharacterMetadata;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */

/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */

function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;
  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }

      cursor = nextIndex;
    }

    return nextValue;
  });
  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

var findRangesImmutable_1 = findRangesImmutable;

function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$b(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var List = immutable.List,
    Map$3 = immutable.Map,
    OrderedSet$1 = immutable.OrderedSet,
    Record$1 = immutable.Record,
    Repeat = immutable.Repeat;
var EMPTY_SET$1 = OrderedSet$1();
var defaultRecord$1 = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map$3()
};
var ContentBlockRecord = Record$1(defaultRecord$1);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata_1.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = function (_ContentBlockRecord) {
  _inherits$b(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    _classCallCheck$b(this, ContentBlock);

    return _possibleConstructorReturn$b(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
  }

  ContentBlock.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlock.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlock.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlock.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlock.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlock.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlock.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$1;
  };

  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };
  /**
   * Execute a callback for every contiguous range of styles within the block.
   */


  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };
  /**
   * Execute a callback for every contiguous range of entities within the block.
   */


  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

var ContentBlock_1 = ContentBlock;

function _classCallCheck$c(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$c(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$c(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var List$1 = immutable.List,
    Map$4 = immutable.Map,
    OrderedSet$2 = immutable.OrderedSet,
    Record$2 = immutable.Record,
    Repeat$1 = immutable.Repeat;
var EMPTY_SET$2 = OrderedSet$2();
var defaultRecord$2 = {
  parent: null,
  characterList: List$1(),
  data: Map$4(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List$1(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle$1 = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity$1 = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList$1 = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List$1(Repeat$1(CharacterMetadata_1.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits$c(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord$2;

    _classCallCheck$c(this, ContentBlockNode);

    return _possibleConstructorReturn$c(this, _Record.call(this, decorateCharacterList$1(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$2;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualStyle$1, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualEntity$1, filterFn, callback);
  };

  return ContentBlockNode;
}(Record$2(defaultRecord$2));

var ContentBlockNode_1 = ContentBlockNode;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags-core
 * @format
 * 
 */

var DraftFeatureFlags = {
  draft_killswitch_allow_nontextnodes: false,
  draft_segmented_entities_behavior: false,
  draft_handlebeforeinput_composed_text: false,
  draft_tree_data_support: false
};
var DraftFeatureFlagsCore = DraftFeatureFlags;
var DraftFeatureFlags_1 = DraftFeatureFlagsCore;
var Map$5 = immutable.Map;
var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },
  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map$5([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;

    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata_1.applyStyle(current, inlineStyle) : CharacterMetadata_1.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var ContentStateInlineStyle_1 = ContentStateInlineStyle;

function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
  var characterList = contentBlock.getCharacterList();

  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata_1.applyEntity(characterList.get(start), entityKey));
    start++;
  }

  return contentBlock.set('characterList', characterList);
}

var applyEntityToContentBlock_1 = applyEntityToContentBlock;

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock_1(block, sliceStart, sliceEnd, entityKey);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var applyEntityToContentState_1 = applyEntityToContentState;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @format
 * 
 */

/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */

var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function (
    /*string*/
    segment,
    /*number*/
    ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }

      return segment;
    });
    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length; // Our selection overlaps this segment.

      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};
var DraftEntitySegments_1 = DraftEntitySegments;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant$1(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
}

var invariant_1$1 = invariant$1;
/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */

function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({
      start: start,
      end: end
    });
  });
  !!!ranges.length ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Entity key not found in this range.') : invariant_1$1(false) : void 0;
  return ranges;
}

var getRangesForDraftEntity_1 = getRangesForDraftEntity;
/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */

function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);

  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }

  var newSelectionState = selectionState;

  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);

    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);

    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }

  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();

  var entity = entityMap.__get(entityKey);

  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end; // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.

  if (mutability === 'MUTABLE') {
    return selectionState;
  } // Find the entity range that overlaps with our removal range.


  var entityRanges = getRangesForDraftEntity_1(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });
  !(entityRanges.length == 1) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'There should only be one entity range within this removal range.') : invariant_1$1(false) : void 0;
  var entityRange = entityRanges[0]; // For `IMMUTABLE` entity types, we will remove the entire entity range.

  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  } // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.


  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments_1.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

var getCharacterRemovalRange_1 = getCharacterRemovalRange;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */

var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;

  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }

  seenKeys[key] = true;
  return key;
}

var generateRandomKey_1 = generateRandomKey;
var OrderedMap$1 = immutable.OrderedMap;

var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {}; // we keep track of root blocks in order to update subsequent sibling links

  var lastRootBlock = void 0;
  return OrderedMap$1(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey(); // new key that we will use to build linking

      var key = generateRandomKey_1(); // we will add it here to re-use it later

      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);

        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);

        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);

        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap$1(blockMap.toArray().map(function (block) {
    var key = generateRandomKey_1();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode_1;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

var randomizeBlockMapKeys_1 = randomizeBlockMapKeys;

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();
  var updatedBlocks = {};
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);

  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable_1(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = {
        start: start,
        end: end
      };
    }
  });
  !(typeof removalRange === 'object') ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Removal range must exist within character list.') : invariant_1$1(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);

    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;

      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata_1.applyEntity(current, null));
        start++;
      }

      return block.set('characterList', chars);
    }
  }

  return block;
}

var removeEntitiesAtEdges_1 = removeEntitiesAtEdges;

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset(); // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.

  var contentWithoutEdgeEntities = removeEntitiesAtEdges_1(contentState, selectionState);
  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;
  return randomizeBlockMapKeys_1(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

var getContentStateFragment_1 = getContentStateFragment;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * @format
 * 
 */

/**
 * Maintain persistence for target list when appending and prepending.
 */

function insertIntoList(targetList, toInsert, offset) {
  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }

  return targetList;
}

var insertIntoList_1 = insertIntoList;
var List$2 = immutable.List;

var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;
  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList_1(chars, fragmentBlock.getCharacterList(), targetOffset),
    data: fragmentBlock.getData()
  });
  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};
/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */


var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();
  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};
/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */


var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();
  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = []; // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block

  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    } // update the last root block fragment


    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey); // update the original target next block

    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    } // update fragment parent links


    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    }); // update targetBlock parent child links

    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();
      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;
      var newChildrenKeysArray = originalTargetParentChildKeys.toArray(); // insert fragment children

      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
      blockMapState.setIn([targetParentKey, 'children'], List$2(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode_1;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    } // Insert fragment blocks after the head and before the tail.


    fragment // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    }); // update tail

    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });
  var updatedBlockMap = BlockMapBuilder_1.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant_1$1(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys_1(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();
  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode_1) {
    !targetBlock.getChildKeys().isEmpty() ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, '`insertFragment` should not be called when a container node is selected.') : invariant_1$1(false) : void 0;
  } // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block


  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

var insertFragmentIntoContentState_1 = insertFragmentIntoContentState;
var Repeat$2 = immutable.Repeat;

function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, '`insertText` should only be called with a collapsed range.') : invariant_1$1(false) : void 0;
  var len = text.length;

  if (!len) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();
  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList_1(block.getCharacterList(), Repeat$2(characterMetadata, len).toList(), offset)
  });
  var newOffset = offset + len;
  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

var insertTextIntoContentState_1 = insertTextIntoContentState;
var Map$6 = immutable.Map;

function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map$6([[endKey, blockMap.get(endKey)]])).map(operation);
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var modifyBlockForContentState_1 = modifyBlockForContentState;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNextDelimiterBlockKey
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode_1;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);

  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

var getNextDelimiterBlockKey_1 = getNextDelimiterBlockKey;
var List$3 = immutable.List,
    Map$7 = immutable.Map;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};
/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */


var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);

  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();

    if (parentKey) {
      parents.push(parentKey);
    }

    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};
/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */


var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey_1(block, blockMap);

  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);

    nextDelimiters.push(nextDelimiter); // we do not need to keep checking all root node siblings, just the first occurance

    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey_1(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks$1 = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
      });
    }); // update endblock if its retained

    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    }); // update start block parent ancestors

    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update start block next - can only happen if startBlock == endBlock

    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    }); // update start block prev

    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
      });
    }); // update end block next

    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    }); // update end block prev

    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    }); // update end block parent ancestors

    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update next delimiters all the way to a root delimiter

    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey); // we assume that ContentBlockNode and ContentBlocks are not mixed together

  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode_1; // used to retain blocks that should not be deleted to avoid orphan children

  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap); // endBlock has unselected sibblings so we can not remove its ancestors parents

    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    } // endBlock has children so can not remove this block or any of its ancestors


    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    } // we need to retain all ancestors of the next delimiter block


    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey_1(endBlock, blockMap), blockMap));
  }

  var characterList = void 0;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  });
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map$7([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });
  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  });

  if (isExperimentalTreeBlock) {
    updatedBlockMap = updateBlockMapLinks$1(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};
/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */


var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }

  return targetList;
};

var removeRangeFromContentState_1 = removeRangeFromContentState;
var List$4 = immutable.List,
    Map$8 = immutable.Map;

var transformBlock$1 = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks$2 = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey(); // update block parent

    transformBlock$1(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
      return block.merge({
        children: List$4(newChildrenArray)
      });
    }); // update original next block

    transformBlock$1(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    }); // update original block

    transformBlock$1(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    }); // update below block

    transformBlock$1(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Selection range must be collapsed.') : invariant_1$1(false) : void 0;
  var key = selectionState.getAnchorKey();
  var offset = selectionState.getAnchorOffset();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey_1();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode_1;
  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map$8()
  });
  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'ContentBlockNode must not have children') : invariant_1$1(false) : void 0;
    newBlocks = updateBlockMapLinks$2(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

var splitBlockInContentState_1 = splitBlockInContentState;
var OrderedSet$3 = immutable.OrderedSet;
/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState_1(withoutEntities, rangeToReplace);
    var character = CharacterMetadata_1.create({
      style: inlineStyle || OrderedSet$3(),
      entity: entityKey || null
    });
    return insertTextIntoContentState_1(withoutText, withoutText.getSelectionAfter(), text, character);
  },
  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Target range must be collapsed for `insertText`.') : invariant_1$1(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },
  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment_1(contentState, removalRange);
    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },
  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, targetRange);
    var withoutText = removeRangeFromContentState_1(withoutEntities, targetRange);
    return insertFragmentIntoContentState_1(withoutText, withoutText.getSelectionAfter(), fragment);
  },
  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey = void 0,
        endKey = void 0,
        startBlock = void 0,
        endBlock = void 0;

    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }

    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();
    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1); // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.

    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var _adjustedRemovalRange = getCharacterRemovalRange_1(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);

        return removeRangeFromContentState_1(contentState, _adjustedRemovalRange);
      }
    }

    var adjustedRemovalRange = rangeToRemove;

    if (DraftFeatureFlags_1.draft_segmented_entities_behavior) {
      // Adjust the selection to properly delete segemented and immutable
      // entities
      adjustedRemovalRange = getCharacterRemovalRange_1(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
    }

    var withoutEntities = removeEntitiesAtEdges_1(contentState, adjustedRemovalRange);
    return removeRangeFromContentState_1(withoutEntities, adjustedRemovalRange);
  },
  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, selectionState);
    var withoutText = removeRangeFromContentState_1(withoutEntities, selectionState);
    return splitBlockInContentState_1(withoutText, withoutText.getSelectionAfter());
  },
  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle_1.add(contentState, selectionState, inlineStyle);
  },
  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle_1.remove(contentState, selectionState, inlineStyle);
  },
  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState_1(contentState, selectionState, function (block) {
      return block.merge({
        type: blockType,
        depth: 0
      });
    });
  },
  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState_1(contentState, selectionState, function (block) {
      return block.merge({
        data: blockData
      });
    });
  },
  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState_1(contentState, selectionState, function (block) {
      return block.merge({
        data: block.getData().merge(blockData)
      });
    });
  },
  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, selectionState);
    return applyEntityToContentState_1(withoutEntities, selectionState, entityKey);
  }
};
var DraftModifier_1 = DraftModifier;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;
var List$5 = immutable.List,
    Repeat$3 = immutable.Repeat,
    Record$3 = immutable.Record;
var returnTrue = emptyFunction_1.thatReturnsTrue;
var FINGERPRINT_DELIMITER = '-';
var defaultLeafRange = {
  start: null,
  end: null
};
var LeafRange = Record$3(defaultLeafRange);
var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};
var DecoratorRange = Record$3(defaultDecoratorRange);
var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();

    if (!textLength) {
      return List$5.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List$5.of(new LeafRange({
          start: 0,
          end: 0
        }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List$5(Repeat$3(null, textLength));
    var chars = block.getCharacterList();
    findRangesImmutable_1(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });
    return List$5(leafSets);
  },

  /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
  getFingerprint: function getFingerprint(tree) {
    return tree.map(function (leafSet) {
      var decoratorKey = leafSet.get('decoratorKey');
      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
    }).join(FINGERPRINT_DELIMITER);
  }
};
/**
 * Generate LeafRange records for a given character list.
 */

function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable_1(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List$5(leaves);
}

function areEqual(a, b) {
  return a === b;
}

var BlockTree_1 = BlockTree;

function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$d(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Record$4 = immutable.Record;
var DraftEntityInstanceRecord = Record$4({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});
/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = function (_DraftEntityInstanceR) {
  _inherits$d(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    _classCallCheck$d(this, DraftEntityInstance);

    return _possibleConstructorReturn$d(this, _DraftEntityInstanceR.apply(this, arguments));
  }

  DraftEntityInstance.prototype.getType = function getType() {
    return this.get('type');
  };

  DraftEntityInstance.prototype.getMutability = function getMutability() {
    return this.get('mutability');
  };

  DraftEntityInstance.prototype.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

var DraftEntityInstance_1 = DraftEntityInstance;

var _extends$d = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntity
 * @format
 * 
 */


var Map$9 = immutable.Map;
var instances = Map$9();
var instanceKey = 0;
/**
 * Temporary utility for generating the warnings
 */

function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}
/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */


var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },
  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return '' + instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance_1({
      type: type,
      mutability: mutability,
      data: data || {}
    }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    var key = '' + ++instanceKey;
    instances = instances.set(key, instance);
    return key;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Unknown DraftEntity key: %s.', key) : invariant_1$1(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);

    var newData = _extends$d({}, instance.getData(), toMerge);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};
var DraftEntity_1 = DraftEntity;

function _classCallCheck$e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$e(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Record$5 = immutable.Record;
var defaultRecord$3 = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};
var SelectionStateRecord = Record$5(defaultRecord$3);

var SelectionState = function (_SelectionStateRecord) {
  _inherits$e(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    _classCallCheck$e(this, SelectionState);

    return _possibleConstructorReturn$e(this, _SelectionStateRecord.apply(this, arguments));
  }

  SelectionState.prototype.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  SelectionState.prototype.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  SelectionState.prototype.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  SelectionState.prototype.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  };
  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */


  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionEnd && selectionStart <= end;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
    return start <= offsetToCheck && end >= offsetToCheck;
  };

  SelectionState.prototype.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  SelectionState.prototype.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  SelectionState.prototype.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  SelectionState.prototype.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  SelectionState.prototype.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

var SelectionState_1 = SelectionState;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * @format
 * 
 */

var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

var sanitizeDraftText_1 = sanitizeDraftText;

function _classCallCheck$f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$f(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$f(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var List$6 = immutable.List,
    Record$6 = immutable.Record,
    Repeat$4 = immutable.Repeat;
var experimentalTreeDataSupport = DraftFeatureFlags_1.draft_tree_data_support;
var defaultRecord$4 = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};
var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode_1 : ContentBlock_1;
var ContentStateRecord = Record$6(defaultRecord$4);

var ContentState = function (_ContentStateRecord) {
  _inherits$f(ContentState, _ContentStateRecord);

  function ContentState() {
    _classCallCheck$f(this, ContentState);

    return _possibleConstructorReturn$f(this, _ContentStateRecord.apply(this, arguments));
  }

  ContentState.prototype.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity_1;
  };

  ContentState.prototype.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  ContentState.prototype.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  ContentState.prototype.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity_1.__getLastCreatedEntityKey();
  };

  ContentState.prototype.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || blockMap.first().getLength() > 0;
  };

  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__create(type, mutability, data);

    return this;
  };

  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__mergeData(key, toMerge);

    return this;
  };

  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__replaceData(key, newData);

    return this;
  };

  ContentState.prototype.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__add(instance);

    return this;
  };

  ContentState.prototype.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity_1.__get(key);
  };

  ContentState.createFromBlockArray = function createFromBlockArray( // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder_1.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState_1() : SelectionState_1.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity_1,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText_1(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey_1(),
        text: block,
        type: 'unstyled',
        characterList: List$6(Repeat$4(CharacterMetadata_1.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  return ContentState;
}(ContentStateRecord);

var ContentState_1 = ContentState;
var NEUTRAL = 'NEUTRAL'; // No strong direction

var LTR = 'LTR'; // Left-to-Right direction

var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null; // == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */

function isStrong(dir) {
  return dir === LTR || dir === RTL;
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */


function getHTMLDir(dir) {
  !isStrong(dir) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant_1$1(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */


function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant_1$1(false) : void 0;
  !isStrong(otherDir) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant_1$1(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
} // == Global Direction ==

/**
 * Set the global direction.
 */


function setGlobalDir(dir) {
  globalDir = dir;
}
/**
 * Initialize the global direction
 */


function initGlobalDir() {
  setGlobalDir(LTR);
}
/**
 * Get the global direction
 */


function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }

  !globalDir ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Global direction not set.') : invariant_1$1(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};
var UnicodeBidiDirection_1 = UnicodeBidiDirection;
/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */

var RANGE_BY_BIDI_TYPE = {
  L: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB" + "\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8" + "\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377" + "\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" + "\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559" + "\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D" + "\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965" + "\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C" + "\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD" + "\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD" + "\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03" + "\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33" + "\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F" + "\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0" + "\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0" + "\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10" + "\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40" + "\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F" + "\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95" + "\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9" + "\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7" + "\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10" + "\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61" + "\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8" + "\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6" + "\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF" + "\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D" + "\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61" + "\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96" + "\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF" + "\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45" + "\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88" + "\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7" + "\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" + "\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14" + "\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38" + "\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C" + "\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8" + "\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F" + "\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061" + "\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081" + "\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C" + "\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC" + "\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" + "\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5" + "\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368" + "\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E" + "\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0" + "\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736" + "\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5" + "\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9" + "\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA" + "\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931" + "\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB" + "\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16" + "\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64" + "\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD" + "\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B" + "\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0" + "\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7" + "\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B" + "\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59" + "\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1" + "\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B" + "\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15" + "\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D" + "\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" + "\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E" + "\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D" + "\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139" + "\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184" + "\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF" + "\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4" + "\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F" + "\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" + "\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007" + "\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C" + "\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF" + "\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F" + "\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247" + "\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB" + "\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5" + "\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD" + "\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B" + "\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF" + "\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E" + "\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801" + "\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835" + "\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3" + "\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909" + "\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C" + "\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD" + "\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF" + "\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34" + "\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F" + "\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1" + "\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF" + "\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5" + "\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" + "\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4" + "\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3" + "\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9" + "\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70" + "\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF" + "\uFFD2-\uFFD7\uFFDA-\uFFDC",
  R: "\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF" + "\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA" + "\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828" + "\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E" + "\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C" + "\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F",
  AL: "\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640" + "\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6" + "\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F" + "\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF" + "\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2" + "\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7" + "\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75" + "\uFE76-\uFEFC\uFEFD-\uFEFE"
};
var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */

function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */


function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);

  if (strongChar == null) {
    return UnicodeBidiDirection_1.NEUTRAL;
  }

  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection_1.RTL : UnicodeBidiDirection_1.LTR;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */


function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection_1.NEUTRAL;

  if (!str.length) {
    return fallback;
  }

  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection_1.NEUTRAL ? fallback : blockDir;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */


function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection_1.getGlobalDir();
  }

  !UnicodeBidiDirection_1.isStrong(strongFallback) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Fallback direction must be a strong direction') : invariant_1$1(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}
/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */


function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection_1.LTR;
}
/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */


function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection_1.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};
var UnicodeBidi_1 = UnicodeBidi;

function _classCallCheck$g(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var UnicodeBidiService = function () {
  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _classCallCheck$g(this, UnicodeBidiService);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection_1.getGlobalDir();
    } else {
      !UnicodeBidiDirection_1.isStrong(defaultDir) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant_1$1(false) : void 0;
    }

    this._defaultDir = defaultDir;
    this.reset();
  }
  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  UnicodeBidiService.prototype.reset = function reset() {
    this._lastDir = this._defaultDir;
  };
  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi_1.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

var UnicodeBidiService_1 = UnicodeBidiService;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error("Got unexpected null or undefined");
};

var nullthrows_1 = nullthrows;
var OrderedMap$2 = immutable.OrderedMap;
var bidiService;
var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService_1();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows_1(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap$2(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};
var EditorBidiService_1 = EditorBidiService;

var _extends$e = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck$h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var OrderedSet$4 = immutable.OrderedSet,
    Record$7 = immutable.Record,
    Stack$1 = immutable.Stack;
var defaultRecord$5 = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack$1(),
  selection: null,
  treeMap: null,
  undoStack: Stack$1()
};
var EditorStateRecord = Record$7(defaultRecord$5);

var EditorState = function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return EditorState.createWithContent(ContentState_1.createFromText(''), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack$1(),
      redoStack: Stack$1(),
      decorator: decorator || null,
      selection: SelectionState_1.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _extends$e({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService_1.getDirectionMap(currentContent)
    });

    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;

      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;

        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();

      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });
    return new EditorState(map);
  };

  EditorState.prototype.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  EditorState.prototype.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  EditorState.prototype.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  EditorState.prototype.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  EditorState.prototype.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  EditorState.prototype.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  EditorState.prototype.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  EditorState.prototype.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  EditorState.prototype.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  };
  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */


  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, {
      inlineStyleOverride: inlineStyleOverride
    });
  };
  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */


  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();

    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  EditorState.prototype.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  };
  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */


  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };
  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */


  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }

    return updateSelection(editorState, selection, true);
  };
  /**
   * Move selection to the end of the editor without forcing focus.
   */


  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();
    return EditorState.acceptSelection(editorState, new SelectionState_1({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };
  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */


  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };
  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */


  EditorState.push = function push(editorState, contentState, changeType) {
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var forceSelection = changeType !== 'insert-characters';
    var directionMap = EditorBidiService_1.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride(); // Don't discard inline style overrides for the following change types:

    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack$1(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };
    return EditorState.set(editorState, editorStateChanges);
  };
  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */


  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService_1.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };
  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */


  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService_1.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };
  /**
   * Not for public consumption.
   */


  function EditorState(immutable$$1) {
    _classCallCheck$h(this, EditorState);

    this._immutable = immutable$$1;
  }
  /**
   * Not for public consumption.
   */


  EditorState.prototype.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();
/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}
/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */


function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree_1.generate(contentState, block, decorator);
  }).toOrderedMap();
}
/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */


function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree_1.generate(contentState, block, decorator);
  }));
}
/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */


function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree_1.generate(content, block, decorator);
  }));
}
/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */


function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.

  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.


  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If there is a character just inside the selection, use its style.

  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  } // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.


  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();
  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  return OrderedSet$4();
}

var EditorState_1 = EditorState;
var OrderedMap$3 = immutable.OrderedMap,
    List$7 = immutable.List;

var transformBlock$2 = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks$3 = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  } // possible values of 'insertionMode' are: 'after', 'before'


  var isInsertedAfterTarget = insertionMode === 'after';
  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock$2(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
      });
    }); // update old prev

    transformBlock$2(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    }); // update old next

    transformBlock$2(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    }); // update new next

    transformBlock$2(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    }); // update new prev

    transformBlock$2(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    }); // update new parent

    transformBlock$2(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
      return block.merge({
        children: List$7(newChildrenArray)
      });
    }); // update block

    transformBlock$2(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Replacing blocks is not supported.') : invariant_1$1(false) : void 0;
  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();
  !(blockKey !== targetKey) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Block cannot be moved next to itself.') : invariant_1$1(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode_1;
  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey_1(blockToBeMoved, blocks);
      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks['delete'](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });
  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);
  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });
  var newBlocks = OrderedMap$3();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);
    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Block cannot be moved next to itself.') : invariant_1$1(false) : void 0;
    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);
    !(!blockAfter || blockAfter.getKey() !== blockKey) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Block cannot be moved next to itself.') : invariant_1$1(false) : void 0;
    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks$3(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

var moveBlockInContentState_1 = moveBlockInContentState;

var _extends$f = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var experimentalTreeDataSupport$1 = DraftFeatureFlags_1.draft_tree_data_support;
var ContentBlockRecord$1 = experimentalTreeDataSupport$1 ? ContentBlockNode_1 : ContentBlock_1;
var List$8 = immutable.List,
    Repeat$5 = immutable.Repeat;
var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var afterRemoval = DraftModifier_1.removeRange(contentState, selectionState, 'backward');
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier_1.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();
    var asAtomicBlock = DraftModifier_1.setBlockType(afterSplit, insertionTarget, 'atomic');
    var charData = CharacterMetadata_1.create({
      entity: entityKey
    });
    var atomicBlockConfig = {
      key: generateRandomKey_1(),
      type: 'atomic',
      text: character,
      characterList: List$8(Repeat$5(charData, character.length))
    };
    var atomicDividerBlockConfig = {
      key: generateRandomKey_1(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport$1) {
      atomicBlockConfig = _extends$f({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _extends$f({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord$1(atomicBlockConfig), new ContentBlockRecord$1(atomicDividerBlockConfig)];
    var fragment = BlockMapBuilder_1.createFromArray(fragmentArray);
    var withAtomicBlock = DraftModifier_1.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState_1.push(editorState, newContent, 'insert-fragment');
  },
  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var withMovedAtomicBlock = void 0;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
      withMovedAtomicBlock = moveBlockInContentState_1(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier_1.removeRange(contentState, targetRange, 'backward');
      var selectionAfterRemoval = afterRemoval.getSelectionAfter();

      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState_1(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState_1(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier_1.splitBlock(afterRemoval, selectionAfterRemoval);
        var selectionAfterSplit = afterSplit.getSelectionAfter();

        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState_1(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState_1.push(editorState, newContent, 'move-block');
  }
};
var AtomicBlockUtils_1 = AtomicBlockUtils;

function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var List$9 = immutable.List;
var DELIMITER = '.';
/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = function () {
  function CompositeDraftDecorator(decorators) {
    _classCallCheck$i(this, CompositeDraftDecorator); // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.


    this._decorators = decorators.slice();
  }

  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function (
    /*object*/
    decorator,
    /*number*/
    ii) {
      var counter = 0;
      var strategy = decorator.strategy;

      var callback = function callback(
      /*number*/
      start,
      /*number*/
      end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };

      strategy(block, callback, contentState);
    });

    return List$9(decorations);
  };

  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();
/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }

  return true;
}
/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */


function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

var CompositeDraftDecorator_1 = CompositeDraftDecorator;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */

function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }

  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

var cx_1 = cx;
var Map$a = immutable.Map;
var UL_WRAP = React.createElement('ul', {
  className: cx_1('public/DraftStyleDefault/ul')
});
var OL_WRAP = React.createElement('ol', {
  className: cx_1('public/DraftStyleDefault/ol')
});
var PRE_WRAP = React.createElement('pre', {
  className: cx_1('public/DraftStyleDefault/pre')
});
var DefaultDraftBlockRenderMap = Map$a({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});
var DefaultDraftBlockRenderMap_1 = DefaultDraftBlockRenderMap;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * @format
 * 
 */

var DefaultDraftInlineStyle = {
  BOLD: {
    fontWeight: 'bold'
  },
  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },
  ITALIC: {
    fontStyle: 'italic'
  },
  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },
  UNDERLINE: {
    textDecoration: 'underline'
  }
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var Keys = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @format
 * 
 */

/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */

function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();

    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);

      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }

      return filterKey(contentState.getEntityMap(), entityKey);
    }

    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);
  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
  return filterKey(contentState.getEntityMap(), entityKey);
}
/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */


function filterKey(entityMap, entityKey) {
  if (entityKey) {
    var entity = entityMap.__get(entityKey);

    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }

  return null;
}

var getEntityKeyForSelection_1 = getEntityKeyForSelection;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */

/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */

function isEventHandled(value) {
  return value === 'handled' || value === true;
}

var isEventHandled_1 = isEventHandled;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @format
 * 
 */

function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();
  var isAtStart = false;
  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');

        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });
  return isAtStart;
}

var isSelectionAtLeafStart_1 = isSelectionAtLeafStart;
/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */

var RESOLVE_DELAY = 20;
/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */

var resolved = false;
var stillComposing = false;
var textInputData = '';
var DraftEditorCompositionHandler = {
  onBeforeInput: function onBeforeInput(editor, e) {
    textInputData = (textInputData || '') + e.data;
  },

  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);

      editor._onKeyDown(e);

      return;
    }

    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    resolved = true;
    var composedChars = textInputData;
    textInputData = '';
    var editorState = EditorState_1.set(editor._latestEditorState, {
      inCompositionMode: false
    });
    var currentStyle = editorState.getCurrentInlineStyle();
    var entityKey = getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection());
    var mustReset = !composedChars || isSelectionAtLeafStart_1(editorState) || currentStyle.size > 0 || entityKey !== null;

    if (mustReset) {
      editor.restoreEditorDOM();
    }

    editor.exitCurrentMode();

    if (composedChars) {
      // If characters have been composed, re-rendering with the update
      // is sufficient to reset the editor.
      var contentState = DraftModifier_1.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
      editor.update(EditorState_1.push(editorState, contentState, 'insert-characters'));
      return;
    }

    if (mustReset) {
      editor.update(EditorState_1.set(editorState, {
        nativelyRenderedContent: null,
        forceSelection: true
      }));
    }
  }
};
var DraftEditorCompositionHandler_1 = DraftEditorCompositionHandler;
var uaParser = createCommonjsModule(function (module, exports) {
  /*!
   * UAParser.js v0.7.19
   * Lightweight JavaScript-based User-Agent string parser
   * https://github.com/faisalman/ua-parser-js
   *
   * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
   * Dual licensed under GPLv2 or MIT
   */
  (function (window, undefined) {
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '0.7.19',
        EMPTY = '',
        UNKNOWN = '?',
        FUNC_TYPE = 'function',
        UNDEF_TYPE = 'undefined',
        OBJ_TYPE = 'object',
        STR_TYPE = 'string',
        MAJOR = 'major',
        // deprecated
    MODEL = 'model',
        NAME = 'name',
        TYPE = 'type',
        VENDOR = 'vendor',
        VERSION = 'version',
        ARCHITECTURE = 'architecture',
        CONSOLE = 'console',
        MOBILE = 'mobile',
        TABLET = 'tablet',
        SMARTTV = 'smarttv',
        WEARABLE = 'wearable',
        EMBEDDED = 'embedded'; ///////////
    // Helper
    //////////

    var util = {
      extend: function extend(regexes, extensions) {
        var margedRegexes = {};

        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            margedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            margedRegexes[i] = regexes[i];
          }
        }

        return margedRegexes;
      },
      has: function has(str1, str2) {
        if (typeof str1 === "string") {
          return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
        } else {
          return false;
        }
      },
      lowerize: function lowerize(str) {
        return str.toLowerCase();
      },
      major: function major(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined;
      },
      trim: function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
      }
    }; ///////////////
    // Map helper
    //////////////

    var mapper = {
      rgx: function rgx(ua, arrays) {
        //var result = {},
        var i = 0,
            j,
            k,
            p,
            q,
            matches,
            match; //, args = arguments;

        /*// construct object barebones
        for (p = 0; p < args[1].length; p++) {
            q = args[1][p];
            result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
        }*/
        // loop through all regexes maps

        while (i < arrays.length && !matches) {
          var regex = arrays[i],
              // even sequence (0,2,4,..)
          props = arrays[i + 1]; // odd sequence (1,3,5,..)

          j = k = 0; // try matching uastring with regexes

          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);

            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p]; // check if given property is actually array

                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length == 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length == 3) {
                    // check whether function or regex
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                    }
                  } else if (q.length == 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                  }
                } else {
                  this[q] = match ? match : undefined;
                }
              }
            }
          }

          i += 2;
        } // console.log(this);
        //return this;

      },
      str: function str(_str, map) {
        for (var i in map) {
          // check if array
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (util.has(map[i][j], _str)) {
                return i === UNKNOWN ? undefined : i;
              }
            }
          } else if (util.has(map[i], _str)) {
            return i === UNKNOWN ? undefined : i;
          }
        }

        return _str;
      }
    }; ///////////////
    // String map
    //////////////

    var maps = {
      browser: {
        oldsafari: {
          version: {
            '1.0': '/8',
            '1.2': '/1',
            '1.3': '/3',
            '2.0': '/412',
            '2.0.2': '/416',
            '2.0.3': '/417',
            '2.0.4': '/419',
            '?': '/'
          }
        }
      },
      device: {
        amazon: {
          model: {
            'Fire Phone': ['SD', 'KF']
          }
        },
        sprint: {
          model: {
            'Evo Shift 4G': '7373KT'
          },
          vendor: {
            'HTC': 'APA',
            'Sprint': 'Sprint'
          }
        }
      },
      os: {
        windows: {
          version: {
            'ME': '4.90',
            'NT 3.11': 'NT3.51',
            'NT 4.0': 'NT4.0',
            '2000': 'NT 5.0',
            'XP': ['NT 5.1', 'NT 5.2'],
            'Vista': 'NT 6.0',
            '7': 'NT 6.1',
            '8': 'NT 6.2',
            '8.1': 'NT 6.3',
            '10': ['NT 6.4', 'NT 10.0'],
            'RT': 'ARM'
          }
        }
      }
    }; //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[// Presto based
      /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
      /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
      /(opera).+version\/([\w\.]+)/i, // Opera > 9.80
      /(opera)[\/\s]+([\w\.]+)/i // Opera < 9.80
      ], [NAME, VERSION], [/(opios)[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [[NAME, 'Opera Mini'], VERSION], [/\s(opr)\/([\w\.]+)/i // Opera Webkit
      ], [[NAME, 'Opera'], VERSION], [// Mixed
      /(kindle)\/([\w\.]+)/i, // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser/Baidu
      /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
      // Webkit/KHTML based
      /(rekonq)\/([\w\.]*)/i, // Rekonq
      /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
      ], [NAME, VERSION], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i // IE11
      ], [[NAME, 'IE'], VERSION], [/(edge|edgios|edga)\/((\d+)?[\w\.]+)/i // Microsoft Edge
      ], [[NAME, 'Edge'], VERSION], [/(yabrowser)\/([\w\.]+)/i // Yandex
      ], [[NAME, 'Yandex'], VERSION], [/(puffin)\/([\w\.]+)/i // Puffin
      ], [[NAME, 'Puffin'], VERSION], [/(focus)\/([\w\.]+)/i // Firefox Focus
      ], [[NAME, 'Firefox Focus'], VERSION], [/(opt)\/([\w\.]+)/i // Opera Touch
      ], [[NAME, 'Opera Touch'], VERSION], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
      ], [[NAME, 'UCBrowser'], VERSION], [/(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, ' '], VERSION], [/(micromessenger)\/([\w\.]+)/i // WeChat
      ], [[NAME, 'WeChat'], VERSION], [/(brave)\/([\w\.]+)/i // Brave browser
      ], [[NAME, 'Brave'], VERSION], [/(qqbrowserlite)\/([\w\.]+)/i // QQBrowserLite
      ], [NAME, VERSION], [/(QQ)\/([\d\.]+)/i // QQ, aka ShouQ
      ], [NAME, VERSION], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i // QQBrowser
      ], [NAME, VERSION], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i // Baidu Browser
      ], [NAME, VERSION], [/(2345Explorer)[\/\s]?([\w\.]+)/i // 2345 Browser
      ], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i // SouGouBrowser
      ], [NAME], [/(LBBROWSER)/i // LieBao Browser
      ], [NAME], [/xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, 'MIUI Browser']], [/;fbav\/([\w\.]+);/i // Facebook App for iOS & Android
      ], [VERSION, [NAME, 'Facebook']], [/safari\s(line)\/([\w\.]+)/i, // Line App for iOS
      /android.+(line)\/([\w\.]+)\/iab/i // Line App for Android
      ], [NAME, VERSION], [/headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
      ], [VERSION, [NAME, 'Chrome Headless']], [/\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [// Oculus / Samsung Browser
      /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i // Android Browser
      ], [VERSION, [NAME, 'Android Browser']], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/(dolfin)\/([\w\.]+)/i // Dolphin
      ], [[NAME, 'Dolphin'], VERSION], [/((?:android.+)crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [[NAME, 'Chrome'], VERSION], [/(coast)\/([\w\.]+)/i // Opera Coast
      ], [[NAME, 'Opera Coast'], VERSION], [/fxios\/([\w\.-]+)/i // Firefox for iOS
      ], [VERSION, [NAME, 'Firefox']], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i // Mobile Safari
      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Google Search Appliance on iOS
      ], [[NAME, 'GSA'], VERSION], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, // Konqueror
      /(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
      /(navigator|netscape)\/([\w\.-]+)/i // Netscape
      ], [[NAME, 'Netscape'], VERSION], [/(swiftfox)/i, // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, // Mozilla
      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
      /(links)\s\(([\w\.]+)/i, // Links
      /(gobrowser)\/?([\w\.]*)/i, // GoBrowser
      /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
      /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
      ], [NAME, VERSION]
      /* /////////////////////
      // Media players BEGIN
      ////////////////////////
       , [
       /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
      /(coremedia) v((\d+)[\w\._]+)/i
      ], [NAME, VERSION], [
       /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
      ], [NAME, VERSION], [
       /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
      ], [NAME, VERSION], [
       /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                          // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                          // NSPlayer/PSP-InternetRadioPlayer/Videos
      /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
      /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
      /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
      ], [NAME, VERSION], [
      /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
      ], [NAME, VERSION], [
       /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
      ], [[NAME, 'Flip Player'], VERSION], [
       /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                          // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
      ], [NAME], [
       /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                          // Gstreamer
      ], [NAME, VERSION], [
       /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
      /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                          // Java/urllib/requests/wget/cURL
      /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
      ], [NAME, VERSION], [
       /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
      ], [[NAME, /_/g, ' '], VERSION], [
       /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                          // MPlayer SVN
      ], [NAME, VERSION], [
       /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
      ], [NAME, VERSION], [
       /(mplayer)/i,                                                       // MPlayer (no other info)
      /(yourmuze)/i,                                                      // YourMuze
      /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
      ], [NAME], [
       /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
      ], [NAME, VERSION], [
       /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
      ], [NAME, VERSION], [
       /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
      ], [NAME, VERSION], [
       /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
      /(winamp)\s((\d+)[\w\.-]+)/i,
      /(winamp)mpeg\/((\d+)[\w\.-]+)/i
      ], [NAME, VERSION], [
       /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                          // inlight radio
      ], [NAME], [
       /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                          // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                          // SoundTap/Totem/Stagefright/Streamium
      ], [NAME, VERSION], [
       /(smp)((\d+)[\d\.]+)/i                                              // SMP
      ], [NAME, VERSION], [
       /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
      /(vlc)\/((\d+)[\w\.-]+)/i,
      /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
      /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
      /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
      ], [NAME, VERSION], [
       /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
      /(windows-media-player)\/((\d+)[\w\.-]+)/i
      ], [[NAME, /-/g, ' '], VERSION], [
       /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                          // Windows Media Server
      ], [VERSION, [NAME, 'Windows']], [
       /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
      ], [NAME, VERSION], [
       /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
      /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
      ], [[NAME, 'rad.io'], VERSION]
       //////////////////////
      // Media players END
      ////////////////////*/
      ],
      cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64
      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32
      ], [[ARCHITECTURE, 'ia32']], [// PocketPC mistakenly identified as PowerPC
      /windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, util.lowerize]]],
      device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i // iPad/PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/ // iPad
      ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i // Apple TV
      ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [/(archos)\s(gamepad2?)/i, // Archos
      /(hp).+(touchpad)/i, // HP TouchPad
      /(hp).+(tablet)/i, // HP Tablet
      /(kindle)\/([\w\.]+)/i, // Kindle
      /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
      /(dell)\s(strea[kpr\s\d]*[\dko])/i // Dell Streak
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/.+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i // Fire Phone
      ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [/android.+aft([bms])\sbuild/i // Fire TV
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [/\((ip[honed|\s\w*]+);.+(apple)/i // iPod/iPhone
      ], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i // iPod/iPhone
      ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, // BlackBerry
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp)\s([\w\s]+\w)/i, // HP iPAQ
      /(asus)-?(\w+)/i // Asus
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/\(bb10;\s(\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [// Asus Tablets
      /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])\sbuild\//i, // Sony
      /(sony)?(?:sgp.+)\sbuild\//i], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [/\s(ouya)\s/i, // Ouya
      /(nintendo)\s([wids3u]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/android.+;\s(shield)\sbuild/i // Nvidia
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation\s[34portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [/(sprint\s(\w+))/i // Sprint Phones
      ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i // Lenovo tablets
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, // HTC
      /(zte)-(\w*)/i, // ZTE
      /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [/(nexus\s9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i // Huawei
      ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [/(microsoft);\s(lumia[\s\w]+)/i // Microsoft Lumia
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [// Motorola
      /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
      ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [// Samsung
      /smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV], MODEL], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [/sie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, // Nokia
      /(nokia)[\s_-]?([\w-]*)/i], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i // Acer
      ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [/android.+([vl]k\-?\d{3})\s+build/i // LG Tablet
      ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i // LG Tablet
      ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i // LG SmartTV
      ], [VENDOR, MODEL, [TYPE, SMARTTV]], [/(nexus\s[45])/i, // LG
      /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [/android.+(ideatab[a-z0-9\-\s]+)/i // Lenovo
      ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [/linux;.+((jolla));/i // Jolla
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/((pebble))app\/[\d\.]+\s/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/crkey/i // Google Chromecast
      ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [/android.+;\s(glass)\s\d/i // Google Glass
      ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [/android.+;\s(pixel c)[\s)]/i // Google Pixel C
      ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [/android.+;\s(pixel( [23])?( xl)?)\s/i // Google Pixel
      ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [/android.+;\s(\w+)\s+build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
      /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, // Xiaomi Hongmi
      /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, // Xiaomi Mi
      /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i // Redmi Phones
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i // Mi Pad tablets
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [/android.+;\s(m[1-5]\snote)\sbuild/i // Meizu Tablet
      ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [/(mz)-([\w-]{2,})/i // Meizu Phone
      ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [/android.+a000(1)\s+build/i, // OnePlus
      /android.+oneplus\s(a\d{4})\s+build/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i // RCA Tablets
      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i // Verizon Tablet
      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i // Barnes & Noble Tablet
      ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/android.+;\s(k88)\sbuild/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/android.+[;\/]\s*(zur\d{3})\s+build/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i // Zeki Tablets
      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i // Dragon Touch Tablet
      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i // Insignia Tablets
      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i // NextBook Tablets
      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones
      /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i // LvTel Phones
      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/android.+;\s(PH-1)\s/i], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [// Essential PH-1
      /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i // Envizen Tablets
      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i // Le Pan Tablets
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i // Trinity Tablets
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*TU_(1491)\s+build/i // Rotor Tablets
      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/android.+(KS(.+))\s+build/i // Amazon Kindle Tablets
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i // Gigaset Tablets
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
      /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
      ], [[TYPE, util.lowerize], VENDOR, MODEL], [/(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
      ], [MODEL, [VENDOR, 'Generic']]
      /*//////////////////////////
          // TODO: move to string map
          ////////////////////////////
           /(C6603)/i                                                          // Sony Xperia Z C6603
          ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
          /(C6903)/i                                                          // Sony Xperia Z 1
          ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
           /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
          ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
          /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
          ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
          /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
          ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
          /(SM-G313HZ)/i                                                      // Samsung Galaxy V
          ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
          /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
          ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
          /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
          ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
          /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
          ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
           /(T3C)/i                                                            // Advan Vandroid T3C
          ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
          /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
          ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
          /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
          ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
           /(V972M)/i                                                          // ZTE V972M
          ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
           /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
          ], [VENDOR, MODEL, [TYPE, MOBILE]], [
          /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
          ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
          /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
          ], [VENDOR, MODEL, [TYPE, MOBILE]], [
          /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
          ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
           /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
          ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
           /////////////
          // END TODO
          ///////////*/
      ],
      engine: [[/windows.+\sedge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, 'EdgeHTML']], [/(presto)\/([\w\.]+)/i, // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
      /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
      /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
      ], [NAME, VERSION], [/rv\:([\w\.]{1,9}).+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[// Windows based
      /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
      /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, // Windows Phone
      /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [// Mobile/Embedded OS
      /\((bb)(10);/i // BlackBerry 10
      ], [[NAME, 'BlackBerry'], VERSION], [/(blackberry)\w*\/?([\w\.]*)/i, // Blackberry
      /(tizen)[\/\s]([\w\.]+)/i, // Tizen
      /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i, // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
      /linux;.+(sailfish);/i // Sailfish OS
      ], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i // Symbian
      ], [[NAME, 'Symbian'], VERSION], [/\((series40);/i // Series 40
      ], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
      ], [[NAME, 'Firefox OS'], VERSION], [// Console
      /(nintendo|playstation)\s([wids34portablevu]+)/i, // Nintendo/Playstation
      // GNU/Linux based
      /(mint)[\/\s\(]?(\w*)/i, // Mint
      /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
      /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
      // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
      /(hurd|linux)\s?([\w\.]*)/i, // Hurd/Linux
      /(gnu)\s?([\w\.]*)/i // GNU
      ], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
      ], [[NAME, 'Chromium OS'], VERSION], [// Solaris
      /(sunos)\s?([\w\.\d]*)/i // Solaris
      ], [[NAME, 'Solaris'], VERSION], [// BSD based
      /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
      ], [NAME, VERSION], [/(haiku)\s(\w+)/i // Haiku
      ], [NAME, VERSION], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i // iOS
      ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i // Mac OS
      ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Other
      /((?:open)?solaris)[\/\s-]?([\w\.]*)/i, // Solaris
      /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, // AIX
      /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
      /(unix)\s?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    }; /////////////////
    // Constructor
    ////////////////

    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */

    var UAParser = function UAParser(uastring, extensions) {
      if (typeof uastring === 'object') {
        extensions = uastring;
        uastring = undefined;
      }

      if (!(this instanceof UAParser)) {
        return new UAParser(uastring, extensions).getResult();
      }

      var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
      var rgxmap = extensions ? util.extend(regexes, extensions) : regexes; //var browser = new Browser();
      //var cpu = new CPU();
      //var device = new Device();
      //var engine = new Engine();
      //var os = new OS();

      this.getBrowser = function () {
        var browser = {
          name: undefined,
          version: undefined
        };
        mapper.rgx.call(browser, ua, rgxmap.browser);
        browser.major = util.major(browser.version); // deprecated

        return browser;
      };

      this.getCPU = function () {
        var cpu = {
          architecture: undefined
        };
        mapper.rgx.call(cpu, ua, rgxmap.cpu);
        return cpu;
      };

      this.getDevice = function () {
        var device = {
          vendor: undefined,
          model: undefined,
          type: undefined
        };
        mapper.rgx.call(device, ua, rgxmap.device);
        return device;
      };

      this.getEngine = function () {
        var engine = {
          name: undefined,
          version: undefined
        };
        mapper.rgx.call(engine, ua, rgxmap.engine);
        return engine;
      };

      this.getOS = function () {
        var os = {
          name: undefined,
          version: undefined
        };
        mapper.rgx.call(os, ua, rgxmap.os);
        return os;
      };

      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };

      this.getUA = function () {
        return ua;
      };

      this.setUA = function (uastring) {
        ua = uastring; //browser = new Browser();
        //cpu = new CPU();
        //device = new Device();
        //engine = new Engine();
        //os = new OS();

        return this;
      };

      return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
      NAME: NAME,
      MAJOR: MAJOR,
      // deprecated
      VERSION: VERSION
    };
    UAParser.CPU = {
      ARCHITECTURE: ARCHITECTURE
    };
    UAParser.DEVICE = {
      MODEL: MODEL,
      VENDOR: VENDOR,
      TYPE: TYPE,
      CONSOLE: CONSOLE,
      MOBILE: MOBILE,
      SMARTTV: SMARTTV,
      TABLET: TABLET,
      WEARABLE: WEARABLE,
      EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
      NAME: NAME,
      VERSION: VERSION
    };
    UAParser.OS = {
      NAME: NAME,
      VERSION: VERSION
    }; //UAParser.Utils = util;
    ///////////
    // Export
    //////////
    // check js environment

    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = UAParser;
      } // TODO: test!!!!!!!!

      /*
      if (require && require.main === module && process) {
          // cli
          var jsonize = function (arr) {
              var res = [];
              for (var i in arr) {
                  res.push(new UAParser(arr[i]).getResult());
              }
              process.stdout.write(JSON.stringify(res, null, 2) + '\n');
          };
          if (process.stdin.isTTY) {
              // via args
              jsonize(process.argv.slice(2));
          } else {
              // via pipe
              var str = '';
              process.stdin.on('readable', function() {
                  var read = process.stdin.read();
                  if (read !== null) {
                      str += read;
                  }
              });
              process.stdin.on('end', function () {
                  jsonize(str.replace(/\n$/, '').split('\n'));
              });
          }
      }
      */


      exports.UAParser = UAParser;
    } // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.

    var $ = window && (window.jQuery || window.Zepto);

    if (typeof $ !== UNDEF_TYPE && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();

      $.ua.get = function () {
        return parser.getUA();
      };

      $.ua.set = function (uastring) {
        parser.setUA(uastring);
        var result = parser.getResult();

        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === 'object' ? window : commonjsGlobal);
});
var uaParser_1 = uaParser.UAParser;
var UNKNOWN = 'Unknown';
var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};
/**
 * Convert from UAParser platform name to what we expect.
 */

function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}
/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */


function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }

  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}
/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */


var parser = new uaParser();
var results = parser.getResult(); // Do some conversion first.

var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};
var UserAgentData = uaData;
var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;
/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */

function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}
/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);
  !(expressions.length > 0 && expressions.length <= 2) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'the "-" operator expects exactly 2 operands') : invariant_1$1(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];
    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant_1$1(false) : void 0;
    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}
/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkSimpleExpression(range, version) {
  range = range.trim();

  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);

    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);

    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);

    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);

    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);

    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}
/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}
/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}
/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}
/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}
/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}
/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }

  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);

  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}
/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */


function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'expected regex to match but it did not') : invariant_1$1(false) : void 0;
  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}
/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */


function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}
/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */


function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}
/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */


function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}
/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */


function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();
  zeroPad(a, b.length); // mark "x" and "*" components as equal

  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);

    if (matches) {
      b[i] = a[i] = '0'; // final "*" greedily zeros all remaining components

      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);
  return [a, b];
}
/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}
/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compare(a, b) {
  !(typeof a === typeof b) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, '"a" and "b" must be of the same type') : invariant_1$1(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}
/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);

    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};
var VersionRange_1 = VersionRange;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var hasOwnProperty$c = Object.prototype.hasOwnProperty;
/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */

function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }

  var result = {};

  for (var name in object) {
    if (hasOwnProperty$c.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }

  return result;
}

var mapObject_1 = mapObject;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }

    return cache[string];
  };
}

var memoizeStringOnly_1 = memoizeStringOnly;
/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */

function compare$1(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  } // check for non-matching names


  if (!query.startsWith(name)) {
    return false;
  } // full comparison with version


  var range = query.slice(name.length);

  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange_1.contains(range, version);
  }

  return false;
}
/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */


function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}
/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */


var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare$1(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },

  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare$1(UserAgentData.browserArchitecture, null, query);
  },

  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare$1(UserAgentData.deviceName, null, query);
  },

  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare$1(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },

  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare$1(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },

  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare$1(UserAgentData.platformArchitecture, null, query);
  }
};
var UserAgent_1 = mapObject_1(UserAgent, memoizeStringOnly_1);

function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$g(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$g(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.


var useNewlineChar = UserAgent_1.isBrowser('IE <= 11');
/**
 * Check whether the node should be considered a newline.
 */

function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}
/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */


var NEWLINE_A = useNewlineChar ? React.createElement('span', {
  key: 'A',
  'data-text': 'true'
}, '\n') : React.createElement('br', {
  key: 'A',
  'data-text': 'true'
});
var NEWLINE_B = useNewlineChar ? React.createElement('span', {
  key: 'B',
  'data-text': 'true'
}, '\n') : React.createElement('br', {
  key: 'B',
  'data-text': 'true'
});
/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */

var DraftEditorTextNode = function (_React$Component) {
  _inherits$g(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    _classCallCheck$j(this, DraftEditorTextNode); // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.


    var _this = _possibleConstructorReturn$g(this, _React$Component.call(this, props));

    _this._forceFlag = false;
    return _this;
  }

  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = ReactDOM.findDOMNode(this);
    var shouldBeNewline = nextProps.children === '';
    !(node instanceof Element) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'node is not an Element') : invariant_1$1(false) : void 0;

    if (shouldBeNewline) {
      return !isNewline(node);
    }

    return node.textContent !== nextProps.children;
  };

  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.render = function render() {
    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
    }

    return React.createElement('span', {
      key: this._forceFlag ? 'A' : 'B',
      'data-text': 'true'
    }, this.props.children);
  };

  return DraftEditorTextNode;
}(React.Component);

var DraftEditorTextNode_react = DraftEditorTextNode;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */

var DraftJsDebugLogging = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */

function isNode$2(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var isNode_1 = isNode$2;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */

function isTextNode(object) {
  return isNode_1(object) && object.nodeType == 3;
}

var isTextNode_1 = isTextNode;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */

function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode_1(outerNode)) {
    return false;
  } else if (isTextNode_1(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

var containsNode_1 = containsNode;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getActiveElement(doc)
/*?DOMElement*/
{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

var getActiveElement_1 = getActiveElement;

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);

  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !(anonymized instanceof Element) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Node must be an Element if it is not a text node.') : invariant_1$1(false) : void 0;
  return anonymized.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();

  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }

  var childNodes = node.childNodes;

  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node;

  while (currentNode) {
    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */


function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  if (!containsNode_1(document.documentElement, node)) {
    return;
  }

  var selection = commonjsGlobal.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward(); // IE doesn't support backward selection. Swap key/offset pairs.

  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset; // If the selection is entirely bound within this node, set the selection
  // and be done.

  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    } // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.


    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    } // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.


    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}
/**
 * Extend selection towards focus point.
 */


function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement_1();

  if (selection.extend && containsNode_1(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({
          offset: offset
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    } // logging to catch bug that is being reported in t18110632


    var nodeWasFocus = node === selection.focusNode;

    try {
      selection.extend(node, offset);
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];

          if (n === activeElement) {
            labels.push('active element');
          }

          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }

          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }

          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      }); // allow the error to be thrown -
      // better than continuing in a broken state

      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    var range = selection.getRangeAt(0);
    range.setEnd(node, offset);
    selection.addRange(range.cloneRange());
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = document.createRange(); // logging to catch bug that is being reported in t16250795

  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({
        offset: offset
      }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }

  range.setStart(node, offset);
  selection.addRange(range);
}

var setDraftEditorSelection_1 = setDraftEditorSelection;

function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$h(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$h(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */


var DraftEditorLeaf = function (_React$Component) {
  _inherits$h(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    _classCallCheck$k(this, DraftEditorLeaf);

    return _possibleConstructorReturn$h(this, _React$Component.apply(this, arguments));
  }

  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
    var selection = this.props.selection; // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _props = this.props,
        block = _props.block,
        start = _props.start,
        text = _props.text;
    var blockKey = block.getKey();
    var end = start + text.length;

    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    } // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.


    var node = ReactDOM.findDOMNode(this);
    !node ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Missing node') : invariant_1$1(false) : void 0;
    var child = node.firstChild;
    !child ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Missing child') : invariant_1$1(false) : void 0;
    var targetNode = void 0;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (child.tagName === 'BR') {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Missing targetNode') : invariant_1$1(false) : void 0;
    }

    setDraftEditorSelection_1(selection, targetNode, blockKey, start, end);
  };
  /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */


  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = ReactDOM.findDOMNode(this.leaf);
    !leafNode ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Missing leafNode') : invariant_1$1(false) : void 0;
    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
  };

  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text; // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _props2 = this.props,
        customStyleMap = _props2.customStyleMap,
        customStyleFn = _props2.customStyleFn,
        offsetKey = _props2.offsetKey,
        styleSet = _props2.styleSet;
    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return objectAssign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = objectAssign(styleObj, newStyles);
    }

    return React.createElement('span', {
      'data-offset-key': offsetKey,
      ref: function ref(_ref) {
        return _this2.leaf = _ref;
      },
      style: styleObj
    }, React.createElement(DraftEditorTextNode_react, null, text));
  };

  return DraftEditorLeaf;
}(React.Component);

var DraftEditorLeaf_react = DraftEditorLeaf;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */

var KEY_DELIMITER = '-';
var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },
  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};
var DraftOffsetKey_1 = DraftOffsetKey;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */

function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}
/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */


var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};
var Scroll_1 = Scroll;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;
/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */

function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

var camelize_1 = camelize;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */

function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

function asString(value)
/*?string*/
{
  return value == null ? value : String(value);
}

function getStyleProperty(
/*DOMNode*/
node,
/*string*/
name)
/*?string*/
{
  var computedStyle = void 0; // W3C Standard

  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate_1(name)));
    }
  } // Safari


  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null); // A Safari bug causes this to return null for `display: none` elements.

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate_1(name)));
    }

    if (name === 'display') {
      return 'none';
    }
  } // Internet Explorer


  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }

    return asString(node.currentStyle[camelize_1(name)]);
  }

  return asString(node.style && node.style[camelize_1(name)]);
}

var getStyleProperty_1 = getStyleProperty;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */

function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}
/**
 * Utilities for querying and mutating style properties.
 */


var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty_1,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }

    var ownerDocument = node.ownerDocument;

    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }

      node = node.parentNode;
    }

    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }
};
var Style_1 = Style;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */

function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement; // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.

  if (!('getBoundingClientRect' in elem) || !containsNode_1(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  } // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode


  var rect = elem.getBoundingClientRect();
  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

var getElementRect_1 = getElementRect;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */

function getElementPosition(element) {
  var rect = getElementRect_1(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

var getElementPosition_1 = getElementPosition;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getDocumentScrollElement(doc) {
  doc = doc || document;

  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }

  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

var getDocumentScrollElement_1 = getDocumentScrollElement;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }

  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

var getUnboundedScrollPosition_1 = getUnboundedScrollPosition;
/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement_1(scrollable.ownerDocument || scrollable.document);

  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }

  var scrollPosition = getUnboundedScrollPosition_1(scrollable);
  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;
  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
  return scrollPosition;
}

var getScrollPosition_1 = getScrollPosition;

function getViewportWidth() {
  var width = void 0;

  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks
 */


function getViewportHeight() {
  var height = void 0;

  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}
/**
 * Gets the viewport dimensions including any scrollbars.
 */


function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}
/**
 * Gets the viewport dimensions excluding any scrollbars.
 */


getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

var getViewportDimensions_1 = getViewportDimensions;

var _extends$g = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck$l(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$i(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$i(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SCROLL_BUFFER = 10;
/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */

var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */


var DraftEditorBlock = function (_React$Component) {
  _inherits$i(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    _classCallCheck$l(this, DraftEditorBlock);

    return _possibleConstructorReturn$i(this, _React$Component.apply(this, arguments));
  }

  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */


  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = ReactDOM.findDOMNode(this);
    var scrollParent = Style_1.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition_1(scrollParent);
    var scrollDelta = void 0;

    if (scrollParent === window) {
      var nodePosition = getElementPosition_1(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions_1().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !(blockNode instanceof HTMLElement) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'blockNode is not an HTMLElement') : invariant_1$1(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll_1.setTop(scrollParent, Scroll_1.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey_1.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf_react, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();
      var decoratorKey = leafSet.get('decoratorKey');

      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows_1(_this2.props.decorator);
      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);

      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey_1.encode(blockKey, ii, 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end')); // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

      var dir = UnicodeBidiDirection_1.getHTMLDirIfDifferent(UnicodeBidi_1.getDirection(decoratedText), _this2.props.direction);
      return React.createElement(DecoratorComponent, _extends$g({}, decoratorProps, {
        contentState: _this2.props.contentState,
        decoratedText: decoratedText,
        dir: dir,
        key: decoratorOffsetKey,
        entityKey: block.getEntityAt(leafSet.get('start')),
        offsetKey: decoratorOffsetKey
      }), leaves);
    }).toArray();
  };

  DraftEditorBlock.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        offsetKey = _props.offsetKey;
    var className = cx_1({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });
    return React.createElement('div', {
      'data-offset-key': offsetKey,
      className: className
    }, this._renderChildren());
  };

  return DraftEditorBlock;
}(React.Component);

var DraftEditorBlock_react = DraftEditorBlock;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */

/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className
/*, ... */
) {
  if (!className) {
    className = '';
  }

  var nextClass = void 0;
  var argLength = arguments.length;

  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];

      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }

  return className;
}

var joinClasses_1 = joinClasses;

var _extends$h = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck$m(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$j(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$j(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */


var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx_1({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth === 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};
/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */


var DraftEditorContents = function (_React$Component) {
  _inherits$j(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    _classCallCheck$m(this, DraftEditorContents);

    return _possibleConstructorReturn$j(this, _React$Component.apply(this, arguments));
  }

  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  DraftEditorContents.prototype.render = function render() {
    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleMap = _props.customStyleMap,
        customStyleFn = _props.customStyleFn,
        editorState = _props.editorState,
        editorKey = _props.editorKey,
        textDirectionality = _props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows_1(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];
    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];

      var key = _block.getKey();

      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;

      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey_1.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        key: key,
        offsetKey: offsetKey,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };
      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();

      var className = '';

      if (blockStyleFn) {
        className = blockStyleFn(_block);
      } // List items are special snowflakes, since we handle nesting and
      // counters manually.


      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        className = joinClasses_1(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component$$1 = CustomComponent || DraftEditorBlock_react;
      var childProps = {
        className: className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };

      if (customEditable !== undefined) {
        childProps = _extends$h({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps, React.createElement(Component$$1, componentProps));
      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }

      lastWrapperTemplate = wrapperTemplate;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement('div', {
      'data-contents': 'true'
    }, outputBlocks);
  };

  return DraftEditorContents;
}(React.Component);

var DraftEditorContentsCore_react = DraftEditorContents;
var DraftEditorContents_react = DraftEditorContentsCore_react;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && ( // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

var PhotosMimeType_1 = PhotosMimeType;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */

function toArray$1(obj) {
  var length = obj.length; // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).

  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'toArray: Array-like object expected') : invariant_1$1(false) : void 0;
  !(typeof length === 'number') ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'toArray: Object needs a length property') : invariant_1$1(false) : void 0;
  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'toArray: Object should have keys for indices') : invariant_1$1(false) : void 0;
  !(typeof obj.callee !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant_1$1(false) : void 0; // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.

  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {// IE < 9 does not support Array#slice on collections objects
    }
  } // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.


  var ret = Array(length);

  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }

  return ret;
}
/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */


function hasArrayNature(obj) {
  return (// not null/false
    !!obj && ( // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') && // quacks like an array
    'length' in obj && // not window
    !('setInterval' in obj) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && ( // a real array
    Array.isArray(obj) || // arguments
    'callee' in obj || // HTMLCollection/NodeList
    'item' in obj)
  );
}
/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */


function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray$1(obj);
  }
}

var createArrayFromMixed_1 = createArrayFromMixed;

function _classCallCheck$n(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var CR_LF_REGEX = new RegExp('\r\n', 'g');
var LF_ONLY = '\n';
var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};
/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */

function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer = function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    _classCallCheck$n(this, DataTransfer);

    this.data = data; // Types could be DOMStringList or array

    this.types = data.types ? createArrayFromMixed_1(data.types) : [];
  }
  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    } // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.


    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };
  /**
   * Get raw text.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getText = function getText() {
    var text;

    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }

    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };
  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  DataTransfer.prototype.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };
  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };
  /**
   * Get a link url.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }

      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };
  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();

    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;

      if (!PhotosMimeType_1.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  DataTransfer.prototype.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }

    return null;
  };
  /**
   * Get files.
   *
   * @return {array}
   */


  DataTransfer.prototype.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction_1.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };
  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

var DataTransfer_1 = DataTransfer;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @format
 * 
 */

/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

function getSelectionOffsetKeyForNode(node) {
  if (node instanceof Element) {
    var offsetKey = node.getAttribute('data-offset-key');

    if (offsetKey) {
      return offsetKey;
    }

    for (var ii = 0; ii < node.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);

      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }

  return null;
}

var getSelectionOffsetKeyForNode_1 = getSelectionOffsetKeyForNode;
/**
 * Get the key from the node's nearest offset-aware ancestor.
 */

function findAncestorOffsetKey(node) {
  var searchNode = node;

  while (searchNode && searchNode !== document.documentElement) {
    var key = getSelectionOffsetKeyForNode_1(searchNode);

    if (key != null) {
      return key;
    }

    searchNode = searchNode.parentNode;
  }

  return null;
}

var findAncestorOffsetKey_1 = findAncestorOffsetKey;
var TEXT_CLIPPING_REGEX = /\.textClipping$/;
var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
}; // Somewhat arbitrary upper bound on text size. Let's not lock up the browser.

var TEXT_SIZE_UPPER_BOUND = 5000;
/**
 * Extract the text content from a file list.
 */

function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function (
  /*blob*/
  file) {
    readFile(file, function (
    /*string*/
    text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));

      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}
/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */


function readFile(file, callback) {
  if (!commonjsGlobal.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var contents = ''; // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.

    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }

    callback(contents);
    return;
  }

  var reader = new FileReader();

  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant_1$1(false) : void 0;
    callback(result);
  };

  reader.onerror = function () {
    callback('');
  };

  reader.readAsText(file);
}

var getTextContentFromFiles_1 = getTextContentFromFiles;

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows_1(editorState.getSelection());

  if (process.env.NODE_ENV !== 'production') {
    if (!anchorKey || !focusKey) {
      /*eslint-disable no-console */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
      /*eslint-enable no-console */

      return selection;
    }
  }

  var anchorPath = DraftOffsetKey_1.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
  var focusPath = DraftOffsetKey_1.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');
  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;

  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');

    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

var getUpdatedSelectionState_1 = getUpdatedSelectionState;
/**
 * Get a SelectionState for the supplied mouse event.
 */

function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;

  if (typeof document.caretRangeFromPoint === 'function') {
    var dropRange = document.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows_1(node);
  offset = nullthrows_1(offset);
  var offsetKey = nullthrows_1(findAncestorOffsetKey_1(node));
  return getUpdatedSelectionState_1(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer_1(e.nativeEvent.dataTransfer);
    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
    e.preventDefault();
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();

    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled_1(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }

      getTextContentFromFiles_1(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';

    if (editor.props.handleDrop && isEventHandled_1(editor.props.handleDrop(dropSelection, data, dragType))) {
      return;
    }

    if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
      return;
    }

    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
  }
};

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier_1.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState_1.push(editorState, newContentState, 'insert-fragment');
}
/**
 * Insert text at a specified selection.
 */


function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier_1.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState_1.push(editorState, newContentState, 'insert-fragment');
}

var DraftEditorDragHandler_1 = DraftEditorDragHandler;

(function (global, undefined) {
  if (global.setImmediate) {
    return;
  }

  var nextHandle = 1; // Spec says greater than zero

  var tasksByHandle = {};
  var currentlyRunningATask = false;
  var doc = global.document;
  var registerImmediate;

  function setImmediate(callback) {
    // Callback can either be a function or a string
    if (typeof callback !== "function") {
      callback = new Function("" + callback);
    } // Copy function arguments


    var args = new Array(arguments.length - 1);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 1];
    } // Store and register the task


    var task = {
      callback: callback,
      args: args
    };
    tasksByHandle[nextHandle] = task;
    registerImmediate(nextHandle);
    return nextHandle++;
  }

  function clearImmediate(handle) {
    delete tasksByHandle[handle];
  }

  function run(task) {
    var callback = task.callback;
    var args = task.args;

    switch (args.length) {
      case 0:
        callback();
        break;

      case 1:
        callback(args[0]);
        break;

      case 2:
        callback(args[0], args[1]);
        break;

      case 3:
        callback(args[0], args[1], args[2]);
        break;

      default:
        callback.apply(undefined, args);
        break;
    }
  }

  function runIfPresent(handle) {
    // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
    // So if we're currently running a task, we'll need to delay this invocation.
    if (currentlyRunningATask) {
      // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
      // "too much recursion" error.
      setTimeout(runIfPresent, 0, handle);
    } else {
      var task = tasksByHandle[handle];

      if (task) {
        currentlyRunningATask = true;

        try {
          run(task);
        } finally {
          clearImmediate(handle);
          currentlyRunningATask = false;
        }
      }
    }
  }

  function installNextTickImplementation() {
    registerImmediate = function registerImmediate(handle) {
      process.nextTick(function () {
        runIfPresent(handle);
      });
    };
  }

  function canUsePostMessage() {
    // The test against `importScripts` prevents this implementation from being installed inside a web worker,
    // where `global.postMessage` means something completely different and can't be used for this purpose.
    if (global.postMessage && !global.importScripts) {
      var postMessageIsAsynchronous = true;
      var oldOnMessage = global.onmessage;

      global.onmessage = function () {
        postMessageIsAsynchronous = false;
      };

      global.postMessage("", "*");
      global.onmessage = oldOnMessage;
      return postMessageIsAsynchronous;
    }
  }

  function installPostMessageImplementation() {
    // Installs an event handler on `global` for the `message` event: see
    // * https://developer.mozilla.org/en/DOM/window.postMessage
    // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
    var messagePrefix = "setImmediate$" + Math.random() + "$";

    var onGlobalMessage = function onGlobalMessage(event) {
      if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
        runIfPresent(+event.data.slice(messagePrefix.length));
      }
    };

    if (global.addEventListener) {
      global.addEventListener("message", onGlobalMessage, false);
    } else {
      global.attachEvent("onmessage", onGlobalMessage);
    }

    registerImmediate = function registerImmediate(handle) {
      global.postMessage(messagePrefix + handle, "*");
    };
  }

  function installMessageChannelImplementation() {
    var channel = new MessageChannel();

    channel.port1.onmessage = function (event) {
      var handle = event.data;
      runIfPresent(handle);
    };

    registerImmediate = function registerImmediate(handle) {
      channel.port2.postMessage(handle);
    };
  }

  function installReadyStateChangeImplementation() {
    var html = doc.documentElement;

    registerImmediate = function registerImmediate(handle) {
      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var script = doc.createElement("script");

      script.onreadystatechange = function () {
        runIfPresent(handle);
        script.onreadystatechange = null;
        html.removeChild(script);
        script = null;
      };

      html.appendChild(script);
    };
  }

  function installSetTimeoutImplementation() {
    registerImmediate = function registerImmediate(handle) {
      setTimeout(runIfPresent, 0, handle);
    };
  } // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.


  var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
  attachTo = attachTo && attachTo.setTimeout ? attachTo : global; // Don't get fooled by e.g. browserify environments.

  if ({}.toString.call(global.process) === "[object process]") {
    // For Node.js before 0.9
    installNextTickImplementation();
  } else if (canUsePostMessage()) {
    // For non-IE10 modern browsers
    installPostMessageImplementation();
  } else if (global.MessageChannel) {
    // For web workers, where supported
    installMessageChannelImplementation();
  } else if (doc && "onreadystatechange" in doc.createElement("script")) {
    // For IE 6–8
    installReadyStateChangeImplementation();
  } else {
    // For older browsers
    installSetTimeoutImplementation();
  }

  attachTo.setImmediate = setImmediate;
  attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof commonjsGlobal === "undefined" ? commonjsGlobal : commonjsGlobal : self); // setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.


var setImmediate$2 = commonjsGlobal.setImmediate; // When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.

var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent_1.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}
/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */


function replaceText(editorState, text, inlineStyle, entityKey) {
  var contentState = DraftModifier_1.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState_1.push(editorState, contentState, 'insert-characters');
}
/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */


function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;
  var chars = e.data; // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.

  if (!chars) {
    return;
  } // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.


  if (editor.props.handleBeforeInput && isEventHandled_1(editor.props.handleBeforeInput(chars, editorState))) {
    e.preventDefault();
    return;
  } // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.


  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var selectionEnd = selection.getEndOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault(); // If the currently selected text matches what the user is trying to
    // replace it with, let's just update the `SelectionState`. If not, update
    // the `ContentState` with the new text.

    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);

    if (chars === currentlySelectedChars) {
      editor.update(EditorState_1.forceSelection(editorState, selection.merge({
        focusOffset: selectionEnd
      })));
    } else {
      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection())));
    }

    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection())); // Bunch of different cases follow where we need to prevent native insertion.

  var mustPreventNative = false;

  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart_1(editor._latestCommittedEditorState);
  }

  if (!mustPreventNative) {
    // Chrome will also split up a node into two pieces if it contains a Tab
    // char, for no explicable reason. Seemingly caused by this commit:
    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
    var nativeSelection = commonjsGlobal.getSelection(); // Selection is necessarily collapsed at this point due to earlier check.

    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
      var parentNode = nativeSelection.anchorNode.parentNode;
      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
    }
  }

  if (!mustPreventNative) {
    // Check the old and new "fingerprints" of the current block to determine
    // whether this insertion requires any addition or removal of text nodes,
    // in which case we would prevent the native character insertion.
    var originalFingerprint = BlockTree_1.getFingerprint(editorState.getBlockTree(anchorKey));
    var newFingerprint = BlockTree_1.getFingerprint(newEditorState.getBlockTree(anchorKey));
    mustPreventNative = originalFingerprint !== newFingerprint;
  }

  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }

  if (!mustPreventNative) {
    mustPreventNative = nullthrows_1(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows_1(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    editor.update(newEditorState);
    return;
  } // We made it all the way! Let the browser do its thing and insert the char.


  newEditorState = EditorState_1.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  }); // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.

  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate$2(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

var editOnBeforeInput_1 = editOnBeforeInput;

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  if (getActiveElement_1() === document.body) {
    var _selection = commonjsGlobal.getSelection();

    var editorNode = editor.editor;

    if (_selection.rangeCount === 1 && containsNode_1(editorNode, _selection.anchorNode) && containsNode_1(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState_1.acceptSelection(editorState, selection));
}

var editOnBlur_1 = editOnBlur;
/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */

function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState_1.set(editor._latestEditorState, {
    inCompositionMode: true
  })); // Allow composition handler to interpret the compositionstart event

  editor._onCompositionStart(e);
}

var editOnCompositionStart_1 = editOnCompositionStart;

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment_1(editorState.getCurrentContent(), selectionState);
}

var getFragmentFromSelection_1 = getFragmentFromSelection;
/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */

function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection(); // No selection, so there's nothing to copy.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection_1(editor._latestEditorState));
}

var editOnCopy_1 = editOnCopy;
/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */

function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition = void 0; // No selection, so there's nothing to cut.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  } // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.


  if (element instanceof Node) {
    scrollPosition = getScrollPosition_1(Style_1.getScrollParent(element));
  }

  var fragment = getFragmentFromSelection_1(editorState);
  editor.setClipboard(fragment); // Set `cut` mode to disable all event handling temporarily.

  editor.setMode('cut'); // Let native `cut` behavior occur, then recover control.

  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier_1.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState_1.push(editorState, newContent, 'remove-range');
}

var editOnCut_1 = editOnCut;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * @format
 * 
 */

/**
 * Drag behavior has begun from outside the editor element.
 */

function editOnDragOver(editor, e) {
  editor._internalDrag = false;
  editor.setMode('drag');
  e.preventDefault();
}

var editOnDragOver_1 = editOnDragOver;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * @format
 * 
 */

/**
 * A `dragstart` event has begun within the text editor component.
 */

function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

var editOnDragStart_1 = editOnDragStart;

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e); // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.

  if (UserAgent_1.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState_1.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState_1.acceptSelection(editorState, selection));
  }
}

var editOnFocus_1 = editOnFocus;
var isGecko = UserAgent_1.isEngine('Gecko');
var DOUBLE_NEWLINE = '\n\n';
/**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */

function editOnInput(editor) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var domSelection = commonjsGlobal.getSelection();
  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;
  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;
  {
    if (isNotTextOrElementNode) {
      // TODO: (t16149272) figure out context for this change
      return;
    }
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;
    anchorNode.nodeValue = span.textContent;

    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows_1(findAncestorOffsetKey_1(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey_1.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end); // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.

  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  } // No change -- the DOM is up to date. Nothing to do here.


  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly
    return;
  }

  var selection = editorState.getSelection(); // We'll replace the entire leaf with the text content of the target.

  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });
  var entityKey = block.getEntityAt(start);
  var entity = entityKey && content.getEntity(entityKey);
  var entityType = entity && entity.getMutability();
  var preserveEntity = entityType === 'MUTABLE'; // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.

  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
  var newContent = DraftModifier_1.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();
    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  } // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.


  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({
      anchorOffset: anchorOffset,
      focusOffset: focusOffset
    })
  });
  editor.update(EditorState_1.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

var editOnInput_1 = editOnInput;
var isOSX = UserAgent_1.isPlatform('Mac OS X');
var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },
  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },
  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  }
};
var KeyBindingUtil_1 = KeyBindingUtil;
var clipboard = null;
/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */

var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        return editorState;
      }

      targetRange = selection.set('focusOffset', blockEnd);
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows_1(targetRange);
    clipboard = getContentStateFragment_1(content, targetRange);
    var afterRemoval = DraftModifier_1.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState_1.push(editorState, afterRemoval, 'remove-range');
  },
  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier_1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
    return EditorState_1.push(editorState, newContent, 'insert-fragment');
  }
};
var SecondaryClipboard_1 = SecondaryClipboard; // These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.

var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */

function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}
/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */


function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant_1$1(false) : void 0;

  if (index + 1 === str.length) {
    return false;
  }

  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}
/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */


function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}
/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */


function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}
/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */


function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }

  return len;
}
/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */


function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0; // Call the native functions if there's no surrogate char

  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  } // Obvious cases


  var size = str.length;

  if (size <= 0 || start > size || length <= 0) {
    return '';
  } // Find the actual starting position


  var posA = 0;

  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }

    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }

    if (posA < 0) {
      posA = 0;
    }
  } // Find the actual ending position


  var posB = size;

  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}
/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */


function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }

  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}
/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */


function getCodePoints(str) {
  var codePoints = [];

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }

  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};
var UnicodeUtils_1 = UnicodeUtils;
var isChrome = UserAgent_1.isBrowser('Chrome'); // In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437

/* eslint-disable consistent-return */

function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;

    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }

    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);

    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }

    tempRange.setEndBefore(ancestor);
  }

  process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant_1$1(false);
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */


var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};
var getRangeClientRects_1 = getRangeClientRects;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @format
 * 
 */

/**
 * Return the computed line height, in pixels, for the provided element.
 */

function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var div = document.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';
  var documentBody = document.body;
  !documentBody ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Missing document.body') : invariant_1$1(false) : void 0; // forced layout here

  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);
  return rect.height;
}
/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */


function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];

    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }

    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}
/**
 * Return the length of a node, as used by Range offsets.
 */


function getNodeLength$1(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;

    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;

    default:
      return node.childNodes.length;
  }
}
/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */


function expandRangeToStartOfLine(range) {
  !range.collapsed ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant_1$1(false) : void 0;
  range = range.cloneRange();
  var containingElement = range.startContainer;

  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }

  var lineHeight = getLineHeightPx(containingElement); // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects_1(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Found unexpected detached subtree when traversing.') : invariant_1$1(false) : void 0;
    range.setStartBefore(bestContainer);

    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  } // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.
  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.


  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;

    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils_1.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);

      if (areRectsOnOneLine(getRangeClientRects_1(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength$1(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

var expandRangeToStartOfLine_1 = expandRangeToStartOfLine;
/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */

function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE; // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.

  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState_1(editorState, nullthrows_1(findAncestorOffsetKey_1(anchorNode)), anchorOffset, nullthrows_1(findAncestorOffsetKey_1(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true; // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows_1(findAncestorOffsetKey_1(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows_1(findAncestorOffsetKey_1(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset); // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.

    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState_1(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}
/**
 * Identify the first leaf descendant for the given node.
 */


function getFirstLeaf(node) {
  while (node.firstChild && ( // data-blocks has no offset
  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode_1(node.firstChild))) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Identify the last leaf descendant for the given node.
 */


function getLastLeaf(node) {
  while (node.lastChild && ( // data-blocks has no offset
  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode_1(node.lastChild))) {
    node = node.lastChild;
  }

  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey_1(node);
  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Unknown node in selection range.') : invariant_1$1(false) : void 0; // If the editorRoot is the selection, step downward into the content
  // wrapper.

  if (editorRoot === node) {
    node = node.firstChild;
    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Invalid DraftEditorContents structure.') : invariant_1$1(false) : void 0;

    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  } // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.


  if (childOffset === 0) {
    var key = null;

    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows_1(getSelectionOffsetKeyForNode_1(firstLeaf));
    }

    return {
      key: key,
      offset: 0
    };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode_1(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows_1(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows_1(getSelectionOffsetKeyForNode_1(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}
/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */


function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

var getDraftEditorSelectionWithNodes_1 = getDraftEditorSelectionWithNodes;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * @format
 * 
 */

/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */

function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);

    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

var moveSelectionBackward_1 = moveSelectionBackward;
/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */

function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;

  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);

    if (target === selection) {
      return content;
    }
  }

  return DraftModifier_1.removeRange(content, target, direction);
}

var removeTextWithStrategy_1 = removeTextWithStrategy;

function keyCommandBackspaceToStartOfLine(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();

    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward_1(strategyState, 1);
    }

    var domSelection = commonjsGlobal.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine_1(range);
    return getDraftEditorSelectionWithNodes_1(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState_1.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandBackspaceToStartOfLine_1 = keyCommandBackspaceToStartOfLine;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */
// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + "\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F" + "\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D" + "\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E" + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
var TokenizeUtil = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};
var punctuation = TokenizeUtil.getPunctuation(); // The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.

var CHAMELEON_CHARS = "['\u2018\u2019]"; // Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.

var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);
var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },
  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};
var DraftRemovableWord_1 = DraftRemovableWord;
/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */

function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset(); // If there are no words before the cursor, remove the preceding newline.

    if (offset === 0) {
      return moveSelectionBackward_1(strategyState, 1);
    }

    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord_1.getBackward(text);
    return moveSelectionBackward_1(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState_1.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandBackspaceWord_1 = keyCommandBackspaceWord;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * @format
 * 
 */

/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */

function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();
  var focusKey = key;
  var focusOffset;
  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset
  });
}

var moveSelectionForward_1 = moveSelectionForward;
/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */

function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord_1.getForward(text); // If there are no words in front of the cursor, remove the newline.

    return moveSelectionForward_1(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState_1.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandDeleteWord_1 = keyCommandDeleteWord;

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier_1.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState_1.push(editorState, contentState, 'split-block');
}

var keyCommandInsertNewline_1 = keyCommandInsertNewline;
/**
 * See comment for `moveSelectionToStartOfBlock`.
 */

function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState_1.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

var keyCommandMoveSelectionToEndOfBlock_1 = keyCommandMoveSelectionToEndOfBlock;
/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */

function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState_1.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

var keyCommandMoveSelectionToStartOfBlock_1 = keyCommandMoveSelectionToStartOfBlock;
/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */

function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward_1(strategyState, charBehind ? UnicodeUtils_1.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState_1.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

var keyCommandPlainBackspace_1 = keyCommandPlainBackspace;
/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */

function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward_1(strategyState, charAhead ? UnicodeUtils_1.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState_1.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

var keyCommandPlainDelete_1 = keyCommandPlainDelete;
/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */

function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();

  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength(); // Nothing to transpose if there aren't two characters.

  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  } // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.


  var movedFragment = getContentStateFragment_1(content, removalRange);
  var afterRemoval = DraftModifier_1.removeRange(content, removalRange, 'backward'); // After the removal, the insertion target is one character back.

  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });
  var afterInsert = DraftModifier_1.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  var newEditorState = EditorState_1.push(editorState, afterInsert, 'insert-fragment');
  return EditorState_1.acceptSelection(newEditorState, finalSelection);
}

var keyCommandTransposeCharacters_1 = keyCommandTransposeCharacters;

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState_1.undo(editorState); // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.

  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState_1.set(undoneState, {
      nativelyRenderedContent: nativelyRenderedContent
    }));
    return;
  } // Otheriwse, manage the undo behavior manually.


  e.preventDefault();

  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  } // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.


  updateFn(EditorState_1.set(editorState, {
    nativelyRenderedContent: null
  })); // Wait to ensure that the re-render has occurred before performing
  // the undo action.

  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

var keyCommandUndo_1 = keyCommandUndo;
var isOptionKeyCommand = KeyBindingUtil_1.isOptionKeyCommand;
var isChrome$1 = UserAgent_1.isBrowser('Chrome');
/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */

function onKeyCommand(command, editorState) {
  switch (command) {
    case 'redo':
      return EditorState_1.redo(editorState);

    case 'delete':
      return keyCommandPlainDelete_1(editorState);

    case 'delete-word':
      return keyCommandDeleteWord_1(editorState);

    case 'backspace':
      return keyCommandPlainBackspace_1(editorState);

    case 'backspace-word':
      return keyCommandBackspaceWord_1(editorState);

    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine_1(editorState);

    case 'split-block':
      return keyCommandInsertNewline_1(editorState);

    case 'transpose-characters':
      return keyCommandTransposeCharacters_1(editorState);

    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock_1(editorState);

    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock_1(editorState);

    case 'secondary-cut':
      return SecondaryClipboard_1.cut(editorState);

    case 'secondary-paste':
      return SecondaryClipboard_1.paste(editorState);

    default:
      return editorState;
  }
}
/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */


function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault(); // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.

      if (editor.props.handleReturn && isEventHandled_1(editor.props.handleReturn(e, editorState))) {
        return;
      }

      break;

    case Keys.ESC:
      e.preventDefault();
      editor.props.onEscape && editor.props.onEscape(e);
      return;

    case Keys.TAB:
      editor.props.onTab && editor.props.onTab(e);
      return;

    case Keys.UP:
      editor.props.onUpArrow && editor.props.onUpArrow(e);
      return;

    case Keys.RIGHT:
      editor.props.onRightArrow && editor.props.onRightArrow(e);
      return;

    case Keys.DOWN:
      editor.props.onDownArrow && editor.props.onDownArrow(e);
      return;

    case Keys.LEFT:
      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
      return;

    case Keys.SPACE:
      // Handling for OSX where option + space scrolls.
      if (isChrome$1 && isOptionKeyCommand(e)) {
        e.preventDefault(); // Insert a nbsp into the editor.

        var contentState = DraftModifier_1.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
        editor.update(EditorState_1.push(editorState, contentState, 'insert-characters'));
        return;
      }

  }

  var command = editor.props.keyBindingFn(e); // If no command is specified, allow keydown event to continue.

  if (!command) {
    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo_1(e, editorState, editor.update);
    return;
  } // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.


  e.preventDefault(); // Allow components higher up the tree to handle the command first.

  if (editor.props.handleKeyCommand && isEventHandled_1(editor.props.handleKeyCommand(command, editorState))) {
    return;
  }

  var newState = onKeyCommand(command, editorState);

  if (newState !== editorState) {
    editor.update(newState);
  }
}

var editOnKeyDown_1 = editOnKeyDown;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function _classCallCheck$o(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var URI = function () {
  function URI(uri) {
    _classCallCheck$o(this, URI);

    this._uri = uri;
  }

  URI.prototype.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

var URI_1 = URI;
var isOldIE = UserAgent_1.isBrowser('IE <= 9'); // Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null; // Provides a safe context

  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Missing doc.documentElement') : invariant_1$1(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }

  return root;
}

var getSafeBodyFromHTML_1 = getSafeBodyFromHTML;

var _extends$i = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _knownListItemDepthCl;

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _require = immutable,
    Set$1 = _require.Set;
var experimentalTreeDataSupport$2 = DraftFeatureFlags_1.draft_tree_data_support;
var List$a = immutable.List,
    OrderedSet$5 = immutable.OrderedSet;
var NBSP = '&nbsp;';
var SPACE = ' '; // Arbitrary max indent

var MAX_DEPTH = 4; // used for replacing characters in HTML

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g'); // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight

var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', '100', '200', '300', '400']; // Block tag flow is different because LIs do not have
// a deterministic style ;_;

var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};
var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty$2(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth0'), 0), _defineProperty$2(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth1'), 1), _defineProperty$2(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth2'), 2), _defineProperty$2(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth3'), 3), _defineProperty$2(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
var lastBlock = void 0;
var EMPTY_CHUNK = {
  text: '',
  inlines: [],
  entities: [],
  blocks: []
};
var EMPTY_BLOCK = {
  children: List$a(),
  depth: 0,
  key: '',
  type: ''
};

var getListBlockType = function getListBlockType(tag, lastList) {
  if (tag === 'li') {
    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
  }

  return null;
};

var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
  var unstyledElement = blockRenderMap.get('unstyled').element;
  var tags = Set$1([]);
  blockRenderMap.forEach(function (draftBlock) {
    if (draftBlock.aliasedElements) {
      draftBlock.aliasedElements.forEach(function (tag) {
        tags = tags.add(tag);
      });
    }

    tags = tags.add(draftBlock.element);
  });
  return tags.filter(function (tag) {
    return tag && tag !== unstyledElement;
  }).toArray().sort();
}; // custom element conversions


var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
    var matchType = multiMatchExtractor[ii](tag, lastList);

    if (matchType) {
      return matchType;
    }
  }

  return null;
};

var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
      return alias === tag;
    });
  }).keySeq().toSet().toArray().sort(); // if we dont have any matched type, return unstyled
  // if we have one matched type return it
  // if we have multi matched types use the multi-match function to gather type

  switch (matchedTypes.length) {
    case 0:
      return 'unstyled';

    case 1:
      return matchedTypes[0];

    default:
      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
  }
};

var processInlineTag = function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];

  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      var fontWeight = htmlElement.style.fontWeight;
      var fontStyle = htmlElement.style.fontStyle;
      var textDecoration = htmlElement.style.textDecoration;

      if (boldValues.indexOf(fontWeight) >= 0) {
        style.add('BOLD');
      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
        style.remove('BOLD');
      }

      if (fontStyle === 'italic') {
        style.add('ITALIC');
      } else if (fontStyle === 'normal') {
        style.remove('ITALIC');
      }

      if (textDecoration === 'underline') {
        style.add('UNDERLINE');
      }

      if (textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }

      if (textDecoration === 'none') {
        style.remove('UNDERLINE');
        style.remove('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }

  return currentStyle;
};

var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var lastInA = A.text.slice(-1);
  var firstInB = B.text.slice(0, 1);

  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  } // Kill whitespace after blocks


  if (lastInA === '\r') {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks)
  };
};
/**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */


var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
};

var hasValidLinkText = function hasValidLinkText(link) {
  !(link instanceof HTMLAnchorElement) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Link must be an HTMLAnchorElement.') : invariant_1$1(false) : void 0;
  var protocol = link.protocol;
  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
};

var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);

  if (inEntity) {
    entities[0] = inEntity;
  }

  return _extends$i({}, EMPTY_CHUNK, {
    text: SPACE,
    inlines: [OrderedSet$5()],
    entities: entities
  });
};

var getSoftNewlineChunk = function getSoftNewlineChunk() {
  return _extends$i({}, EMPTY_CHUNK, {
    text: '\n',
    inlines: [OrderedSet$5()],
    entities: new Array(1)
  });
};

var getChunkedBlock = function getChunkedBlock() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _extends$i({}, EMPTY_BLOCK, props);
};

var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    text: '\r',
    inlines: [OrderedSet$5()],
    entities: new Array(1),
    blocks: [getChunkedBlock({
      parent: parentKey,
      key: generateRandomKey_1(),
      type: block,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    })]
  };
};
/**
 *  If we're pasting from one DraftEditor to another we can check to see if
 *  existing list item depth classes are being used and preserve this style
 */


var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};

var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
  var lastLastBlock = lastBlock;
  var nodeName = node.nodeName.toLowerCase();
  var newEntityMap = entityMap;
  var nextBlockType = 'unstyled';
  var newBlock = false;
  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);

  var chunk = _extends$i({}, EMPTY_CHUNK);

  var newChunk = null;
  var blockKey = void 0; // Base Case

  if (nodeName === '#text') {
    var _text = node.textContent;

    var nodeTextContent = _text.trim(); // We should not create blocks for leading spaces that are
    // existing around ol/ul and their children list items


    if (lastList && nodeTextContent === '' && node.parentElement) {
      var parentNodeName = node.parentElement.nodeName.toLowerCase();

      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
        return {
          chunk: _extends$i({}, EMPTY_CHUNK),
          entityMap: entityMap
        };
      }
    }

    if (nodeTextContent === '' && inBlock !== 'pre') {
      return {
        chunk: getWhitespaceChunk(inEntity),
        entityMap: entityMap
      };
    }

    if (inBlock !== 'pre') {
      // Can't use empty string because MSWord
      _text = _text.replace(REGEX_LF, SPACE);
    } // save the last block so we can use it later


    lastBlock = nodeName;
    return {
      chunk: {
        text: _text,
        inlines: Array(_text.length).fill(inlineStyle),
        entities: Array(_text.length).fill(inEntity),
        blocks: []
      },
      entityMap: entityMap
    };
  } // save the last block so we can use it later


  lastBlock = nodeName; // BR tags

  if (nodeName === 'br') {
    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
      return {
        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
        entityMap: entityMap
      };
    }

    return {
      chunk: getSoftNewlineChunk(),
      entityMap: entityMap
    };
  } // IMG tags


  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
    var image = node;
    var entityConfig = {};
    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);

      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    }); // Forcing this node to have children because otherwise no entity will be
    // created for this node.
    // The child text node cannot just have a space or return as content -
    // we strip those out.
    // See https://github.com/facebook/draft-js/issues/231 for some context.

    node.textContent = "\uD83D\uDCF7"; // TODO: update this when we remove DraftEntity entirely

    inEntity = DraftEntity_1.__create('IMAGE', 'MUTABLE', entityConfig || {});
  } // Inline tags


  inlineStyle = processInlineTag(nodeName, node, inlineStyle); // Handle lists

  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }

    lastList = nodeName;
  }

  if (!experimentalTreeDataSupport$2 && nodeName === 'li' && node instanceof HTMLElement) {
    depth = getListItemDepth(node, depth);
  }

  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport$2) && blockTags.indexOf(nodeName) !== -1; // Block Tags

  if (inListBlock || inBlockOrHasNestedBlocks) {
    chunk = getBlockDividerChunk(blockType, depth, parentKey);
    blockKey = chunk.blocks[0].key;
    inBlock = nodeName;
    newBlock = !experimentalTreeDataSupport$2;
  } // this is required so that we can handle 'ul' and 'ol'


  if (inListBlock) {
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  } // Recurse through children


  var child = node.firstChild;

  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
      (function () {
        var anchor = child;
        var entityConfig = {};
        anchorAttr.forEach(function (attr) {
          var anchorAttribute = anchor.getAttribute(attr);

          if (anchorAttribute) {
            entityConfig[attr] = anchorAttribute;
          }
        });
        entityConfig.url = new URI_1(anchor.href).toString(); // TODO: update this when we remove DraftEntity completely

        entityId = DraftEntity_1.__create('LINK', 'MUTABLE', entityConfig || {});
      })();
    } else {
      entityId = undefined;
    }

    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport$2 ? blockKey : null),
        generatedChunk = _genFragment.chunk,
        maybeUpdatedEntityMap = _genFragment.entityMap;

    newChunk = generatedChunk;
    newEntityMap = maybeUpdatedEntityMap;
    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport$2);
    var sibling = child.nextSibling; // Put in a newline to break up blocks inside blocks

    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
      chunk = joinChunks(chunk, getSoftNewlineChunk());
    }

    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }

    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
  }

  return {
    chunk: chunk,
    entityMap: newEntityMap
  };
};

var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  }

  lastBlock = null; // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.

  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div']; // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to start with.

  var fragment = genFragment(entityMap, safeBody, OrderedSet$5(), 'ul', null, workingBlocks, -1, blockRenderMap);
  var chunk = fragment.chunk;
  var newEntityMap = fragment.entityMap; // join with previous block to prevent weirdness on paste

  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  } // Kill block delimiter at the end


  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  } // If we saw no block tags, put an unstyled one in


  if (chunk.blocks.length === 0) {
    chunk.blocks.push(_extends$i({}, EMPTY_CHUNK, {
      type: 'unstyled',
      depth: 0
    }));
  } // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content


  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({
      type: 'unstyled',
      depth: 0
    });
  }

  return {
    chunk: chunk,
    entityMap: newEntityMap
  };
};

var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
    return null;
  }

  var initialState = {
    cacheRef: {},
    contentBlocks: []
  };
  var start = 0;
  var rawBlocks = chunk.blocks,
      rawInlines = chunk.inlines,
      rawEntities = chunk.entities;
  var BlockNodeRecord = ContentBlock_1;
  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText_1(textBlock);
    var block = rawBlocks[index];
    var end = start + textBlock.length;
    var inlines = rawInlines.slice(start, end);
    var entities = rawEntities.slice(start, end);
    var characterList = List$a(inlines.map(function (style, index) {
      var data = {
        style: style,
        entity: null
      };

      if (entities[index]) {
        data.entity = entities[index];
      }

      return CharacterMetadata_1.create(data);
    }));
    start = end + 1;
    var depth = block.depth,
        type = block.type,
        parent = block.parent;
    var key = block.key || generateRandomKey_1();
    var parentTextNodeKey = null; // will be used to store container text nodes
    // childrens add themselves to their parents since we are iterating in order

    if (parent) {
      var parentIndex = acc.cacheRef[parent];
      var parentRecord = acc.contentBlocks[parentIndex]; // if parent has text we need to split it into a separate unstyled element

      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
        var parentCharacterList = parentRecord.getCharacterList();
        var parentText = parentRecord.getText();
        parentTextNodeKey = generateRandomKey_1();
        var textNode = new ContentBlockNode_1({
          key: parentTextNodeKey,
          text: parentText,
          characterList: parentCharacterList,
          parent: parent,
          nextSibling: key
        });
        acc.contentBlocks.push(textNode);
        parentRecord = parentRecord.withMutations(function (block) {
          block.set('characterList', List$a()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
        });
      }

      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
    }

    var blockNode = new BlockNodeRecord({
      key: key,
      parent: parent,
      type: type,
      depth: depth,
      text: textBlock,
      characterList: characterList,
      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
    }); // insert node

    acc.contentBlocks.push(blockNode); // cache ref for building links

    acc.cacheRef[blockNode.key] = index;
    return acc;
  }, initialState).contentBlocks;
};

var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML_1;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap_1; // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  // TODO: replace DraftEntity with an OrderedMap here

  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity_1);

  if (chunkData == null) {
    return null;
  }

  var chunk = chunkData.chunk,
      entityMap = chunkData.entityMap;
  var contentBlocks = convertChunkToContentBlocks(chunk);
  return {
    contentBlocks: contentBlocks,
    entityMap: entityMap
  };
};

var convertFromHTMLToContentBlocks = convertFromHTMLtoContentBlocks;
var List$b = immutable.List,
    Repeat$6 = immutable.Repeat;
var ContentBlockRecord$2 = ContentBlock_1;
var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML_1, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText_1(textLine);
      var key = generateRandomKey_1();
      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List$b(Repeat$6(character, textLine.length))
      };
      acc.push(new ContentBlockRecord$2(blockNodeConfig));
      return acc;
    }, []);
  }
};
var DraftPasteProcessor_1 = DraftPasteProcessor;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @format
 * 
 */

function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });
  blockMap = blockMap.merge(blocks);
  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var adjustBlockDepthForContentState_1 = adjustBlockDepthForContentState;
var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },
  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },
  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return {
      url: uri.toString()
    };
  },
  handleKeyCommand: function handleKeyCommand(editorState, command) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');

      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');

      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');

      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);

      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);

      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);

      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },
  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier_1.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
    var newEditorState = EditorState_1.push(editorState, contentState, 'insert-characters');
    return EditorState_1.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    } // First, try to remove a preceding atomic block.


    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });

      if (withoutAtomicBlock !== content) {
        return EditorState_1.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    } // If that doesn't succeed, try to remove the current block style.


    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState_1.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },
  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength(); // The cursor is somewhere within the text. Behave normally.

    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });
    var withoutAtomicBlock = DraftModifier_1.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState_1.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },
  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();

    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();

    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault(); // Only allow indenting one level beyond the block above, and only if
    // the block above is a list item as well.

    var blockAbove = content.getBlockBefore(key);

    if (!blockAbove) {
      return editorState;
    }

    var typeAbove = blockAbove.getType();

    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
      return editorState;
    }

    var depth = block.getDepth();

    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
    var withAdjustment = adjustBlockDepthForContentState_1(content, selection, event.shiftKey ? -1 : 1, maxDepth);
    return EditorState_1.push(editorState, withAdjustment, 'adjust-depth');
  },
  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection; // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.

    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows_1(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
    return EditorState_1.push(editorState, DraftModifier_1.setBlockType(content, target, typeToSet), 'change-block-type');
  },
  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle(); // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.

    if (selection.isCollapsed()) {
      return EditorState_1.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    } // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.


    var content = editorState.getCurrentContent();
    var newContent; // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.

    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier_1.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier_1.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState_1.push(editorState, newContent, 'change-inline-style');
  },
  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier_1.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
    return EditorState_1.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of the first styled block, or
   * an empty styled block, changes block to 'unstyled'. Returns null if
   * block or selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();

    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);
      var firstBlock = content.getFirstBlock();

      if (block.getLength() > 0 && block !== firstBlock) {
        return null;
      }

      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);

      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier_1.setBlockType(content, selection, 'unstyled');
      }
    }

    return null;
  }
};
var RichTextEditorUtil_1 = RichTextEditorUtil;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * @format
 * 
 */

var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

var splitTextIntoTextBlocks_1 = splitTextIntoTextBlocks;
/**
 * Paste content.
 */

function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer_1(e.clipboardData); // Get files, unless this is likely to be a string the user wants inline.

  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();

    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled_1(editor.props.handlePastedFiles(files))) {
        return;
      }

      getTextContentFromFiles_1(files, function (
      /*string*/
      fileText) {
        fileText = fileText || defaultFileText;

        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks_1(fileText);
        var character = CharacterMetadata_1.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil_1.getCurrentBlockType(editorState);
        var text = DraftPasteProcessor_1.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder_1.createFromArray(text);
        var withInsertedText = DraftModifier_1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
        editor.update(EditorState_1.push(editorState, withInsertedText, 'insert-fragment'));
      });
      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.handlePastedText && isEventHandled_1(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks_1(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();

    if (data.isRichText() && internalClipboard) {
      if ( // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      html.indexOf(editor.getEditorKey()) !== -1 || // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment$1(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment$1(editor._latestEditorState, internalClipboard));
      return;
    } // If there is html paste data, try to parse that.


    if (html) {
      var htmlFragment = DraftPasteProcessor_1.processHTML(html, editor.props.blockRenderMap);

      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder_1.createFromArray(contentBlocks);
          editor.update(insertFragment$1(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    } // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.


    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata_1.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection())
    });
    var currentBlockType = RichTextEditorUtil_1.getCurrentBlockType(editorState);
    var textFragment = DraftPasteProcessor_1.processText(textBlocks, character, currentBlockType);
    var textMap = BlockMapBuilder_1.createFromArray(textFragment);
    editor.update(insertFragment$1(editor._latestEditorState, textMap));
  }
}

function insertFragment$1(editorState, fragment, entityMap) {
  var newContent = DraftModifier_1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment); // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState_1.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

var editOnPaste_1 = editOnPaste;
/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */

function getDraftEditorSelection(editorState, root) {
  var selection = commonjsGlobal.getSelection(); // No active selection.

  if (selection.rangeCount === 0) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes_1(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
}

var getDraftEditorSelection_1 = getDraftEditorSelection;

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    return;
  }

  var editorState = editor.props.editorState;
  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
  !editorNode ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Missing editorNode') : invariant_1$1(false) : void 0;
  !(editorNode.firstChild instanceof HTMLElement) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'editorNode.firstChild is not an HTMLElement') : invariant_1$1(false) : void 0;
  var documentSelection = getDraftEditorSelection_1(editorState, editorNode.firstChild);
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState_1.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState_1.acceptSelection(editorState, updatedSelectionState);
    }

    editor.update(editorState);
  }
}

var editOnSelect_1 = editOnSelect;
var DraftEditorEditHandler = {
  onBeforeInput: editOnBeforeInput_1,
  onBlur: editOnBlur_1,
  onCompositionStart: editOnCompositionStart_1,
  onCopy: editOnCopy_1,
  onCut: editOnCut_1,
  onDragOver: editOnDragOver_1,
  onDragStart: editOnDragStart_1,
  onFocus: editOnFocus_1,
  onInput: editOnInput_1,
  onKeyDown: editOnKeyDown_1,
  onPaste: editOnPaste_1,
  onSelect: editOnSelect_1
};
var DraftEditorEditHandler_1 = DraftEditorEditHandler;

function _classCallCheck$p(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$k(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$k(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */


var DraftEditorPlaceholder = function (_React$Component) {
  _inherits$k(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    _classCallCheck$p(this, DraftEditorPlaceholder);

    return _possibleConstructorReturn$k(this, _React$Component.apply(this, arguments));
  }

  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  DraftEditorPlaceholder.prototype.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();
    var className = cx_1({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });
    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };
    return React.createElement('div', {
      className: className
    }, React.createElement('div', {
      className: cx_1('public/DraftEditorPlaceholder/inner'),
      id: this.props.accessibilityID,
      style: contentStyle
    }, this.props.text));
  };

  return DraftEditorPlaceholder;
}(React.Component);

var DraftEditorPlaceholder_react = DraftEditorPlaceholder;
var isOSX$1 = UserAgent_1.isPlatform('Mac OS X');
var isWindows = UserAgent_1.isPlatform('Windows'); // Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.

var shouldFixFirefoxMovement = isOSX$1 && UserAgent_1.isBrowser('Firefox < 29');
var hasCommandModifier = KeyBindingUtil_1.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil_1.isCtrlKeyCommand;

function shouldRemoveWord(e) {
  return isOSX$1 && e.altKey || isCtrlKeyCommand(e);
}
/**
 * Get the appropriate undo/redo command for a Z key command.
 */


function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }

  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for Windows on Shift + Delete.
  if (isWindows && e.shiftKey) {
    return null;
  }

  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX$1) {
    return 'backspace-to-start-of-line';
  }

  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}
/**
 * Retrieve a bound key command for the given event.
 */


function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;

    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;

    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;

    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;

    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;

    case 75:
      // K
      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;

    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 84:
      // T
      return isOSX$1 && isCtrlKeyCommand(e) ? 'transpose-characters' : null;

    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;

    case 87:
      // W
      return isOSX$1 && isCtrlKeyCommand(e) ? 'backspace-word' : null;

    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isWindows ? 'redo' : 'secondary-paste';
      }

      return null;

    case 90:
      // Z
      return getZCommand(e) || null;

    case Keys.RETURN:
      return 'split-block';

    case Keys.DELETE:
      return getDeleteCommand(e);

    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.

    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;

    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;

    default:
      return null;
  }
}

var getDefaultKeyBinding_1 = getDefaultKeyBinding;

var _extends$k = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck$q(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$l(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$l(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isIE = UserAgent_1.isBrowser('IE'); // IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.

var allowSpellCheck = !isIE; // Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.

var handlerMap = {
  edit: DraftEditorEditHandler_1,
  composite: DraftEditorCompositionHandler_1,
  drag: DraftEditorDragHandler_1,
  cut: null,
  render: null
};
/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */

var DraftEditor = function (_React$Component) {
  _inherits$l(DraftEditor, _React$Component);

  function DraftEditor(props) {
    _classCallCheck$q(this, DraftEditor);

    var _this = _possibleConstructorReturn$l(this, _React$Component.call(this, props));

    _this.focus = function (scrollPosition) {
      var editorState = _this.props.editorState;
      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = ReactDOM.findDOMNode(_this.editor);

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style_1.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition_1(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !(editorNode instanceof HTMLElement) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'editorNode is not an HTMLElement') : invariant_1$1(false) : void 0;
      editorNode.focus(); // Restore scroll position

      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll_1.setTop(scrollParent, y);
      } // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.


      if (!alreadyHasFocus) {
        _this.update(EditorState_1.forceSelection(editorState, editorState.getSelection()));
      }
    };

    _this.blur = function () {
      var editorNode = ReactDOM.findDOMNode(_this.editor);
      !(editorNode instanceof HTMLElement) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'editorNode is not an HTMLElement') : invariant_1$1(false) : void 0;
      editorNode.blur();
    };

    _this.setMode = function (mode) {
      _this._handler = handlerMap[mode];
    };

    _this.exitCurrentMode = function () {
      _this.setMode('edit');
    };

    _this.restoreEditorDOM = function (scrollPosition) {
      _this.setState({
        contentsKey: _this.state.contentsKey + 1
      }, function () {
        _this.focus(scrollPosition);
      });
    };

    _this.setClipboard = function (clipboard) {
      _this._clipboard = clipboard;
    };

    _this.getClipboard = function () {
      return _this._clipboard;
    };

    _this.update = function (editorState) {
      _this._latestEditorState = editorState;

      _this.props.onChange(editorState);
    };

    _this.onDragEnter = function () {
      _this._dragCount++;
    };

    _this.onDragLeave = function () {
      _this._dragCount--;

      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    };

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey_1();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;
    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    }; // See `restoreEditorDOM()`.


    _this.state = {
      contentsKey: 0
    };
    return _this;
  }
  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */

  /**
   * Define proxies that can route events to the current handler.
   */


  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        method && method(_this2, e);
      }
    };
  };

  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows_1(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };
      return React.createElement(DraftEditorPlaceholder_react, placeHolderProps);
    }

    return null;
  };

  DraftEditor.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleFn = _props.customStyleFn,
        customStyleMap = _props.customStyleMap,
        editorState = _props.editorState,
        readOnly = _props.readOnly,
        textAlignment = _props.textAlignment,
        textDirectionality = _props.textDirectionality;
    var rootClass = cx_1({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });
    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }; // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.

    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _extends$k({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      key: 'contents' + this.state.contentsKey,
      textDirectionality: textDirectionality
    };
    return React.createElement('div', {
      className: rootClass
    }, this._renderPlaceholder(), React.createElement('div', {
      className: cx_1('DraftEditor/editorContainer'),
      ref: function ref(_ref3) {
        return _this3.editorContainer = _ref3;
      }
    }, React.createElement('div', {
      'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
      'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
      'aria-controls': readOnly ? null : this.props.ariaControls,
      'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
      'aria-expanded': readOnly ? null : ariaExpanded,
      'aria-label': this.props.ariaLabel,
      'aria-labelledby': this.props.ariaLabelledBy,
      'aria-multiline': this.props.ariaMultiline,
      autoCapitalize: this.props.autoCapitalize,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      className: cx_1({
        // Chrome's built-in translation feature mutates the DOM in ways
        // that Draft doesn't expect (ex: adding <font> tags inside
        // DraftEditorLeaf spans) and causes problems. We add notranslate
        // here which makes its autotranslation skip over this subtree.
        notranslate: !readOnly,
        'public/DraftEditor/content': true
      }),
      contentEditable: !readOnly,
      'data-testid': this.props.webDriverTestID,
      onBeforeInput: this._onBeforeInput,
      onBlur: this._onBlur,
      onCompositionEnd: this._onCompositionEnd,
      onCompositionStart: this._onCompositionStart,
      onCopy: this._onCopy,
      onCut: this._onCut,
      onDragEnd: this._onDragEnd,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      onDragOver: this._onDragOver,
      onDragStart: this._onDragStart,
      onDrop: this._onDrop,
      onFocus: this._onFocus,
      onInput: this._onInput,
      onKeyDown: this._onKeyDown,
      onKeyPress: this._onKeyPress,
      onKeyUp: this._onKeyUp,
      onMouseUp: this._onMouseUp,
      onPaste: this._onPaste,
      onSelect: this._onSelect,
      ref: function ref(_ref2) {
        return _this3.editor = _ref2;
      },
      role: readOnly ? null : ariaRole,
      spellCheck: allowSpellCheck && this.props.spellCheck,
      style: contentStyle,
      suppressContentEditableWarning: true,
      tabIndex: this.props.tabIndex
    }, React.createElement(DraftEditorContents_react, editorContentsProps))));
  };

  DraftEditor.prototype.componentDidMount = function componentDidMount() {
    this.setMode('edit');
    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */

    if (isIE) {
      document.execCommand('AutoUrlDetect', false, false);
    }
  };
  /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */


  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    this._blockSelectEvents = true;
    this._latestEditorState = nextProps.editorState;
  };

  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestCommittedEditorState = this.props.editorState;
  };
  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */

  /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */

  /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */

  /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */

  /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */

  /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */

  /**
   * Used in conjunction with `onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */

  /**
   * See `onDragEnter()`.
   */


  return DraftEditor;
}(React.Component);

DraftEditor.defaultProps = {
  blockRenderMap: DefaultDraftBlockRenderMap_1,
  blockRendererFn: emptyFunction_1.thatReturnsNull,
  blockStyleFn: emptyFunction_1.thatReturns(''),
  keyBindingFn: getDefaultKeyBinding_1,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
};
var DraftEditor_react = DraftEditor;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @format
 * 
 */

var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },
  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};
var DraftStringKey_1 = DraftStringKey;
var strlen$1 = UnicodeUtils_1.strlen;
/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function (
  /*number*/
  start,
  /*number*/
  end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen$1(text.slice(0, start)),
      length: strlen$1(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey_1.stringify(key)])
    });
  });
  return encoded;
}

var encodeEntityRanges_1 = encodeEntityRanges;

var areEqual$1 = function areEqual(a, b) {
  return a === b;
};

var isTruthy = function isTruthy(a) {
  return !!a;
};

var EMPTY_ARRAY = [];
/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */

function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = []; // Obtain an array with ranges for only the specified style.

  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();
  findRangesImmutable_1(filteredInlines, areEqual$1, // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils_1.strlen(text.slice(0, start)),
      length: UnicodeUtils_1.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });
  return ranges;
}
/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */


function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });
  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

var encodeInlineStyleRanges_1 = encodeInlineStyleRanges;

var _extends$l = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges_1(block),
    entityRanges: encodeEntityRanges_1(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock_1) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode_1) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'block is not a BlockNode') : invariant_1$1(false) : void 0;
  var parentKey = block.getParentKey();

  var rawBlock = blockCacheRef[block.getKey()] = _extends$l({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;
  var rawBlocks = [];
  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;
  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start); // Stringify to maintain order of otherwise numeric keys.

      var stringifiedEntityKey = DraftStringKey_1.stringify(entityKey); // This makes this function resilient to two entities
      // erroneously having the same key

      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }

      entityCacheRef[stringifiedEntityKey] = entityKey; // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode

      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
      entityStorageKey++;
    });
    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });
  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
}; // Flip storage map so that our storage keys map to global
// DraftEntity keys.


var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;
  var rawEntityMap = {};
  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey_1.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });
  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  }; // add blocks

  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState); // add entities

  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
  return rawDraftContentState;
};

var convertFromDraftStateToRaw_1 = convertFromDraftStateToRaw;

var _extends$m = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftTreeAdapter
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();

  while (stack.length) {
    var _block = stack.pop();

    fn(_block);
    var children = _block.children;
    !Array.isArray(children) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Invalid tree raw block') : invariant_1$1(false) : void 0;
    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }

  var type = block.type;
  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _extends$m({}, child, {
        depth: (block.depth || 0) + 1
      }) : child;
    });
  }
};
/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */


var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to  draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;
    var transformedBlocks = [];
    !Array.isArray(blocks) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Invalid raw state') : invariant_1$1(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _extends$m({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
      }

      delete newBlock.children;
      transformedBlocks.push(newBlock);
    });
    draftTreeState.blocks = transformedBlocks;
    return _extends$m({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },

  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var lastListDepthCacheRef = {};
    var transformedBlocks = [];
    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;

      var treeBlock = _extends$m({}, block, {
        children: []
      });

      if (!isList) {
        // reset the cache path
        lastListDepthCacheRef = {};
        transformedBlocks.push(treeBlock);
        return;
      } // update our depth cache reference path


      lastListDepthCacheRef[depth] = treeBlock; // if we are greater than zero we must have seen a parent already

      if (depth > 0) {
        var parent = lastListDepthCacheRef[depth - 1];
        !parent ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'Invalid depth for RawDraftContentBlock') : invariant_1$1(false) : void 0; // push nested list blocks

        parent.children.push(treeBlock);
        return;
      } // push root list blocks


      transformedBlocks.push(treeBlock);
    });
    return _extends$m({}, draftState, {
      blocks: transformedBlocks
    });
  }
};
var DraftTreeAdapter_1 = DraftTreeAdapter;
var List$c = immutable.List;

function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata_1.create({
      style: style,
      entity: entity
    });
  });
  return List$c(characterArray);
}

var createCharacterList_1 = createCharacterList;
var substr$1 = UnicodeUtils_1.substr;
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);

  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr$1(text, 0, range.offset).length;
      var end = start + substr$1(text, range.offset, range.length).length;

      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }

  return entities;
}

var decodeEntityRanges_1 = decodeEntityRanges;
var OrderedSet$6 = immutable.OrderedSet;
var substr$2 = UnicodeUtils_1.substr;
var EMPTY_SET$3 = OrderedSet$6();
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET$3);

  if (ranges) {
    ranges.forEach(function (
    /*object*/
    range) {
      var cursor = substr$2(text, 0, range.offset).length;
      var end = cursor + substr$2(text, range.offset, range.length).length;

      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }

  return styles;
}

var decodeInlineStyleRanges_1 = decodeInlineStyleRanges;

var _extends$n = objectAssign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var List$d = immutable.List,
    Map$b = immutable.Map,
    OrderedMap$4 = immutable.OrderedMap;

var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;
  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey_1(),
    data: Map$b(data),
    characterList: decodeCharacterList(block, entityMap)
  };
  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;
  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || []; // Translate entity range keys to the DraftEntity map.

  return createCharacterList_1(decodeInlineStyleRanges_1(text, inlineStyleRanges), decodeEntityRanges_1(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _extends$n({}, range, {
      key: entityMap[range.key]
    });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _extends$n({}, block, {
    key: block.key || generateRandomKey_1()
  });
};
/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */


var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _extends$n({}, block, {
      parentRef: parentRef
    });
  }); // since we pop nodes from the stack we need to insert them in reverse

  return stack.concat(nodesWithParentRef.reverse());
};
/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */


var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant_1$1(false) : void 0; // ensure children have valid keys to enable sibling links

    var children = block.children.map(addKeyIfMissing); // root level nodes

    var contentBlockNode = new ContentBlockNode_1(_extends$n({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List$d(children.map(function (child) {
        return child.key;
      }))
    })); // push root node to blockMap

    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

    var stack = updateNodeStack([], children, contentBlockNode); // start computing children nodes

    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop(); // parentRef already points to a converted ContentBlockNode

      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();

      var _index = siblings.indexOf(node.key);

      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant_1$1(false) : void 0;
        break;
      } // ensure children have valid keys to enable sibling links


      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode_1(_extends$n({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List$d(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      })); // push node to blockMap


      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap$4());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap$4(blocks.map(function (block) {
    var contentBlock = new ContentBlock_1(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
  var rawBlocks = rawState.blocks;
  {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter_1.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }
  return decodeContentBlockNodes(rawBlocks, entityMap);
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;
  var entityMap = {}; // TODO: Update this once we completely remove DraftEntity

  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data; // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity_1.__create(type, mutability, data || {});
  });
  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ? process.env.NODE_ENV !== 'production' ? invariant_1$1(false, 'invalid RawDraftContentState') : invariant_1$1(false) : void 0; // decode entities

  var entityMap = decodeRawEntityMap(rawState); // decode blockMap

  var blockMap = decodeRawBlocks(rawState, entityMap); // create initial selection

  var selectionState = blockMap.isEmpty() ? new SelectionState_1() : SelectionState_1.createEmpty(blockMap.first().getKey());
  return new ContentState_1({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

var convertFromRawToDraftState_1 = convertFromRawToDraftState;
/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */

function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects_1(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];

      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

var getRangeBoundingClientRect_1 = getRangeBoundingClientRect;
/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */

function getVisibleSelectionRect(global) {
  var selection = global.getSelection();

  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect_1(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left; // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

var getVisibleSelectionRect_1 = getVisibleSelectionRect;
var DraftPublic = {
  Editor: DraftEditor_react,
  EditorBlock: DraftEditorBlock_react,
  EditorState: EditorState_1,
  CompositeDecorator: CompositeDraftDecorator_1,
  Entity: DraftEntity_1,
  EntityInstance: DraftEntityInstance_1,
  BlockMapBuilder: BlockMapBuilder_1,
  CharacterMetadata: CharacterMetadata_1,
  ContentBlock: ContentBlock_1,
  ContentState: ContentState_1,
  SelectionState: SelectionState_1,
  AtomicBlockUtils: AtomicBlockUtils_1,
  KeyBindingUtil: KeyBindingUtil_1,
  Modifier: DraftModifier_1,
  RichUtils: RichTextEditorUtil_1,
  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap_1,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
  convertFromHTML: convertFromHTMLToContentBlocks,
  convertFromRaw: convertFromRawToDraftState_1,
  convertToRaw: convertFromDraftStateToRaw_1,
  genKey: generateRandomKey_1,
  getDefaultKeyBinding: getDefaultKeyBinding_1,
  getVisibleSelectionRect: getVisibleSelectionRect_1
};
var Draft = DraftPublic;
var Draft_1 = Draft.convertFromRaw;
var Draft_2 = Draft.convertToRaw;
var Draft_3 = Draft.ContentState;
var Draft_4 = Draft.CompositeDecorator;
var Draft_5 = Draft.SelectionState;
var Draft_6 = Draft.Editor;
var Draft_7 = Draft.EditorState;
var Draft_8 = Draft.Modifier;

var createInitialContentsDiscrete = function createInitialContentsDiscrete(AnswerContent, typeName, typeId) {
  return [AnswerContent.create(defineProperty$3({
    content: "Answer Choice 1",
    sequence: 1
  }, typeName, typeId)), AnswerContent.create(defineProperty$3({
    content: "Answer Choice 2",
    sequence: 2
  }, typeName, typeId))];
};

var createInitialContentsGrid = function createInitialContentsGrid(AnswerContent, rowTypeName, columnTypeName, typeId) {
  return {
    rows: [AnswerContent.create(defineProperty$3({
      content: "Row 1",
      sequence: 1
    }, rowTypeName, typeId)), AnswerContent.create(defineProperty$3({
      content: "Row 2",
      sequence: 2
    }, rowTypeName, typeId))],
    columns: [AnswerContent.create(defineProperty$3({
      content: "Column 1",
      sequence: 1
    }, columnTypeName, typeId)), AnswerContent.create(defineProperty$3({
      content: "Column 2",
      sequence: 2
    }, columnTypeName, typeId))]
  };
};

var setQuestionRows = function setQuestionRows(payload, session, questionType) {
  var answerType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : questionType;
  var id = payload.id,
      rows = payload.rows; // $FlowFixMe (Can't dynamically get a question property)

  var model = session.Question.withId(id)[questionType];

  if (model) {
    var existingRows = model.rows.toModelArray();
    existingRows.forEach(function (r) {
      return r.delete();
    });
    rows.forEach(function (content, index) {
      return session.AnswerContent.create(defineProperty$3({
        content: content,
        sequence: index + 1,
        defaultContent: false
      }, answerType, model.id));
    });
  }
};

var setQuestionColumns = function setQuestionColumns(payload, session, questionType) {
  var answerType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : questionType;
  var id = payload.id,
      columns = payload.columns; // $FlowFixMe (Can't dynamically get a question property)

  var model = session.Question.withId(id)[questionType];

  if (model) {
    var existingRows = model.columns.toModelArray();
    existingRows.forEach(function (r) {
      return r.delete();
    });
    columns.forEach(function (content, index) {
      return session.AnswerContent.create(defineProperty$3({
        content: content,
        sequence: index + 1,
        defaultContent: false
      }, answerType, model.id));
    });
  }
};

var updateAnswerSequences = function updateAnswerSequences(querySet) {
  var models = querySet.orderBy("sequence").toModelArray();
  models.forEach(function (model, i) {
    model.set("sequence", i + 1);

    if (model.ref.defaultContent) {
      model.set("content", model.ref.content.replace(/\d+/, "" + (i + 1)));
    }
  });
};

var makeRowReducer = function makeRowReducer(questionType) {
  var answerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : questionType;
  return function (action, Model, session) {
    switch (action.type) {
      case answerContentTypes.ANSWER_CONTENT_CREATE:
        {
          var previous = session.AnswerContent.withId(action.payload.after); // $FlowFixMe

          if (previous[answerType]) {
            updateAnswerSequences(previous[answerType].rows);
          }

          break;
        }

      case answerContentTypes.ANSWER_CONTENT_DELETE:
        {
          var hasModel = session.AnswerContent.hasId(action.payload);
          if (!hasModel) return;
          var model = session.AnswerContent.withId(action.payload); // $FlowFixMe

          var typeModel = model[answerType];

          if (typeModel) {
            model.delete();
            updateAnswerSequences(typeModel.rows);
          }

          break;
        }

      case answerContentTypes.ANSWER_CONTENT_MOVE:
        {
          var _model = session.AnswerContent.withId(action.payload.id); // $FlowFixMe


          var _typeModel = _model[answerType];

          if (_typeModel) {
            updateAnswerSequences(_typeModel.rows);
          }

          break;
        }

      case questionTypes.QUESTION_SET_ROWS:
        {
          setQuestionRows(action.payload, session, questionType, answerType);
          break;
        }

      case questionTypes.QUESTION_TOGGLE_RANDOM_SORT:
        {
          var id = action.payload; // $FlowFixMe

          var _model2 = session.Question.withId(id)[questionType];

          if (_model2) {
            var next = _model2.sortType === "randomize" ? "default" : "randomize";

            _model2.set("sortType", next);
          }

          break;
        }

      case questionTypes.QUESTION_TOGGLE_REVERSE_SORT:
        {
          var _id = action.payload; // $FlowFixMe

          var _model3 = session.Question.withId(_id)[questionType];

          if (_model3) {
            var _next = _model3.sortType === "reverse" ? "default" : "reverse";

            _model3.set("sortType", _next);
          }

          break;
        }

      case questionTypes.QUESTION_TOGGLE_ANSWER_IMAGES:
        {
          // $FlowFixMe
          var _model4 = session.Question.withId(action.payload)[questionType];
          if (_model4) _model4.toggle("imageAnswers");
          break;
        }

      default:
    }
  };
};

var rowReducer = makeRowReducer("dropdown"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var Dropdown = function (_Model) {
  inherits(Dropdown, _Model);

  function Dropdown() {
    classCallCheck(this, Dropdown);
    return possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
  }

  createClass(Dropdown, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          dropdown: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Dropdown, session) {
      rowReducer(action, Dropdown, session);

      switch (action.type) {
        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var model = session.Question.withId(action.payload).dropdown;
            if (model) model.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Dropdown;
}(Model$2);

Dropdown.modelName = "Dropdown";
Dropdown.maxRows = 100;
Dropdown.allowRowImages = false;
Dropdown.fields = {
  question: lib_3$2("Question", "dropdown")
};
Dropdown.defaultProps = {
  require: true
};
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */

function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }

    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }

  return number;
}

var _baseClamp = baseClamp;
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */

function clamp$1(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }

  if (upper !== undefined) {
    upper = toNumber_1(upper);
    upper = upper === upper ? upper : 0;
  }

  if (lower !== undefined) {
    lower = toNumber_1(lower);
    lower = lower === lower ? lower : 0;
  }

  return _baseClamp(toNumber_1(number), lower, upper);
}

var clamp_1 = clamp$1;

var LongText = function (_Model) {
  inherits(LongText, _Model);

  function LongText() {
    classCallCheck(this, LongText);
    return possibleConstructorReturn(this, (LongText.__proto__ || Object.getPrototypeOf(LongText)).apply(this, arguments));
  }

  createClass(LongText, null, [{
    key: "reducer",
    value: function reducer(action, LongText, session) {
      switch (action.type) {
        case questionTypes.QUESTION_SET_MIN_LENGTH:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                minLength = _action$payload.minLength;
            var model = session.Question.withId(_id).longText;
            if (model) model.set("min", minLength);
            break;
          }

        case questionTypes.QUESTION_SET_MAX_LENGTH:
          {
            var _action$payload2 = action.payload,
                _id2 = _action$payload2.id,
                maxLength = _action$payload2.maxLength;
            var _model = session.Question.withId(_id2).longText;
            if (_model) _model.set("max", maxLength);
            break;
          }

        case questionTypes.QUESTION_RECONCILE_LENGTH:
          {
            var _model2 = session.Question.withId(action.payload).longText;
            if (!_model2) return;
            var _model2$ref = _model2.ref,
                _min = _model2$ref.min,
                _max = _model2$ref.max,
                _upperBound = _model2$ref.upperBound;
            var newMax = clamp_1(_max, 0, _upperBound);

            _model2.set("min", clamp_1(_min, 0, newMax));

            _model2.set("max", newMax);

            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model3 = session.Question.withId(action.payload).longText;
            if (_model3) _model3.set("require", !_model3.ref.require);
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return LongText;
}(Model$2);

LongText.modelName = "LongText";
LongText.fields = {
  question: lib_3$2("Question", "longText")
};
var upperBound = questionConfigs.long_text_input.upperBound;
LongText.defaultProps = {
  min: 1,
  max: upperBound,
  upperBound: upperBound,
  require: true
};

var Message = function (_Model) {
  inherits(Message, _Model);

  function Message() {
    classCallCheck(this, Message);
    return possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
  }

  return Message;
}(Model$2);

Message.modelName = "Message";
Message.fields = {
  question: lib_3$2("Question", "message")
};
var rowReducer$1 = makeRowReducer("multipleRating"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var MultipleRating = function (_Model) {
  inherits(MultipleRating, _Model);

  function MultipleRating() {
    classCallCheck(this, MultipleRating);
    return possibleConstructorReturn(this, (MultipleRating.__proto__ || Object.getPrototypeOf(MultipleRating)).apply(this, arguments));
  }

  createClass(MultipleRating, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(MultipleRating.prototype.__proto__ || Object.getPrototypeOf(MultipleRating.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          multipleRating: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Rating, session) {
      rowReducer$1(action, Rating, session);

      switch (action.type) {
        case questionTypes.QUESTION_SET_STEPS:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                _steps = _action$payload.steps;
            var model = session.Question.withId(_id).multipleRating;

            if (model) {
              model.set("steps", _steps);
            }

            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model = session.Question.withId(action.payload).multipleRating;
            if (_model) _model.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return MultipleRating;
}(Model$2);

MultipleRating.modelName = "MultipleRating";
MultipleRating.fields = {
  question: lib_3$2("Question", "multipleRating")
};
MultipleRating.defaultProps = {
  steps: 10,
  require: true
};
var rowReducer$2 = makeRowReducer("multipleSelect"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var MultipleSelect = function (_Model) {
  inherits(MultipleSelect, _Model);

  function MultipleSelect() {
    classCallCheck(this, MultipleSelect);
    return possibleConstructorReturn(this, (MultipleSelect.__proto__ || Object.getPrototypeOf(MultipleSelect)).apply(this, arguments));
  }

  createClass(MultipleSelect, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(MultipleSelect.prototype.__proto__ || Object.getPrototypeOf(MultipleSelect.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          multipleSelect: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, MultipleSelect, session) {
      rowReducer$2(action, MultipleSelect, session);

      switch (action.type) {
        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var model = session.Question.withId(action.payload).multipleSelect;
            if (model) model.toggle("require");
            break;
          }

        case questionTypes.QUESTION_SET_MIN_ANSWERS:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                _min = _action$payload.min;
            var _model = session.Question.withId(_id).multipleSelect;
            if (!_model) return;

            _model.set("min", _min);

            if (_min === null) return;
            if (_model.ref.max !== null && _model.ref.max < _min) _model.set("max", _min);
            break;
          }

        case questionTypes.QUESTION_SET_MAX_ANSWERS:
          {
            var _action$payload2 = action.payload,
                _id2 = _action$payload2.id,
                _max = _action$payload2.max;
            var _model2 = session.Question.withId(_id2).multipleSelect;
            if (!_model2) return;

            _model2.set("max", _max);

            if (_max === null) return;
            if (_model2.ref.min !== null && _model2.ref.min > _max) _model2.set("min", _max);
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return MultipleSelect;
}(Model$2);

MultipleSelect.modelName = "MultipleSelect";
MultipleSelect.maxRows = 100;
MultipleSelect.allowRowImages = true;
MultipleSelect.fields = {
  question: lib_3$2("Question", "multipleSelect")
};
MultipleSelect.defaultProps = {
  require: true,
  minAnswers: null,
  maxAnswers: null,
  sortType: "default"
};

var makeColumnReducer = function makeColumnReducer(questionType) {
  var answerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : questionType;
  return function (action, Model, session) {
    switch (action.type) {
      case answerContentTypes.ANSWER_CONTENT_CREATE:
        {
          var previous = session.AnswerContent.withId(action.payload.after); // $FlowFixMe

          if (previous[answerType]) {
            updateAnswerSequences(previous[answerType].columns);
          }

          break;
        }

      case answerContentTypes.ANSWER_CONTENT_DELETE:
        {
          var hasModel = session.AnswerContent.hasId(action.payload);
          if (!hasModel) return;
          var model = session.AnswerContent.withId(action.payload); // $FlowFixMe

          var typeModel = model[answerType];

          if (typeModel) {
            updateAnswerSequences(typeModel.columns);
            model.delete();
          }

          break;
        }

      case answerContentTypes.ANSWER_CONTENT_MOVE:
        {
          var _model = session.AnswerContent.withId(action.payload.id); // $FlowFixMe


          var _typeModel = _model[answerType];

          if (_typeModel) {
            updateAnswerSequences(_typeModel.columns);
          }

          break;
        }

      case questionTypes.QUESTION_SET_COLUMNS:
        {
          setQuestionColumns(action.payload, session, questionType, answerType);
          break;
        }

      default:
    }
  };
};

var rowReducer$3 = makeRowReducer("multipleSelectGrid", "multipleSelectGridRow");
var columnReducer = makeColumnReducer("multipleSelectGrid", "multipleSelectGridColumn"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var MultipleSelectGrid = function (_Model) {
  inherits(MultipleSelectGrid, _Model);

  function MultipleSelectGrid() {
    classCallCheck(this, MultipleSelectGrid);
    return possibleConstructorReturn(this, (MultipleSelectGrid.__proto__ || Object.getPrototypeOf(MultipleSelectGrid)).apply(this, arguments));
  }

  createClass(MultipleSelectGrid, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(MultipleSelectGrid.prototype.__proto__ || Object.getPrototypeOf(MultipleSelectGrid.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          multipleSelectGridRow: newModel.id
        });
      });
      this.columns.toModelArray().forEach(function (r) {
        return r.duplicate({
          multipleSelectGridColumn: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, MultipleSelectGrid, session) {
      rowReducer$3(action, MultipleSelectGrid, session);
      columnReducer(action, MultipleSelectGrid, session);

      switch (action.type) {
        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var model = session.Question.withId(action.payload).multipleSelectGrid;
            if (model) model.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return MultipleSelectGrid;
}(Model$2);

MultipleSelectGrid.modelName = "MultipleSelectGrid";
MultipleSelectGrid.maxRows = 10;
MultipleSelectGrid.maxColumns = 10;
MultipleSelectGrid.allowRowImages = false;
MultipleSelectGrid.allowColumnImages = false;
MultipleSelectGrid.fields = {
  question: lib_3$2("Question", "multipleSelectGrid")
};
MultipleSelectGrid.defaultProps = {
  require: true,
  sortType: "default"
};
var rowReducer$4 = makeRowReducer("multipleSlider"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var MultipleSlider = function (_Model) {
  inherits(MultipleSlider, _Model);

  function MultipleSlider() {
    classCallCheck(this, MultipleSlider);
    return possibleConstructorReturn(this, (MultipleSlider.__proto__ || Object.getPrototypeOf(MultipleSlider)).apply(this, arguments));
  }

  createClass(MultipleSlider, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(MultipleSlider.prototype.__proto__ || Object.getPrototypeOf(MultipleSlider.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          multipleSlider: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, MultipleSlider, session) {
      rowReducer$4(action, MultipleSlider, session);

      switch (action.type) {
        case questionTypes.QUESTION_SET_MIN_VALUE:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                minValue = _action$payload.minValue;
            var model = session.Question.withId(_id).multipleSlider;
            if (model) model.set("min", minValue);
            break;
          }

        case questionTypes.QUESTION_SET_MAX_VALUE:
          {
            var _action$payload2 = action.payload,
                _id2 = _action$payload2.id,
                maxValue = _action$payload2.maxValue;
            var _model = session.Question.withId(_id2).multipleSlider;
            if (_model) _model.set("max", maxValue);
            break;
          }

        case questionTypes.QUESTION_SET_INCREMENT:
          {
            var _action$payload3 = action.payload,
                _id3 = _action$payload3.id,
                _increment = _action$payload3.increment;
            var _model2 = session.Question.withId(_id3).multipleSlider;
            if (_model2) _model2.set("increment", _increment);
            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model3 = session.Question.withId(action.payload).multipleSlider;
            if (_model3) _model3.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return MultipleSlider;
}(Model$2);

MultipleSlider.modelName = "MultipleSlider";
MultipleSlider.fields = {
  question: lib_3$2("Question", "multipleSlider")
};
MultipleSlider.defaultProps = {
  min: 1,
  max: 10,
  increment: 1,
  require: true
};

var Numeric = function (_Model) {
  inherits(Numeric, _Model);

  function Numeric() {
    classCallCheck(this, Numeric);
    return possibleConstructorReturn(this, (Numeric.__proto__ || Object.getPrototypeOf(Numeric)).apply(this, arguments));
  }

  createClass(Numeric, null, [{
    key: "reducer",
    value: function reducer(action, ShortText, session) {
      switch (action.type) {
        case questionTypes.QUESTION_SET_MIN_VALUE:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                minValue = _action$payload.minValue;
            var model = session.Question.withId(_id).numeric;
            if (model) model.set("min", minValue);
            break;
          }

        case questionTypes.QUESTION_SET_MAX_VALUE:
          {
            var _action$payload2 = action.payload,
                _id2 = _action$payload2.id,
                maxValue = _action$payload2.maxValue;
            var _model = session.Question.withId(_id2).numeric;
            if (_model) _model.set("max", maxValue);
            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model2 = session.Question.withId(action.payload).numeric;
            if (_model2) _model2.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Numeric;
}(Model$2);

Numeric.modelName = "Numeric";
Numeric.fields = {
  question: lib_3$2("Question", "numeric")
};
Numeric.defaultProps = {
  min: 1,
  max: 100,
  require: true
};
var rowReducer$5 = makeRowReducer("rankOrder"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var Ranking = function (_Model) {
  inherits(Ranking, _Model);

  function Ranking() {
    classCallCheck(this, Ranking);
    return possibleConstructorReturn(this, (Ranking.__proto__ || Object.getPrototypeOf(Ranking)).apply(this, arguments));
  }

  createClass(Ranking, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(Ranking.prototype.__proto__ || Object.getPrototypeOf(Ranking.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          rankOrder: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Dropdown, session) {
      rowReducer$5(action, Ranking, session);

      switch (action.type) {
        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var model = session.Question.withId(action.payload).rankOrder;
            if (model) model.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Ranking;
}(Model$2);

Ranking.modelName = "Ranking";
Ranking.maxRows = 10;
Ranking.allowRowImages = false;
Ranking.fields = {
  question: lib_3$2("Question", "rankOrder")
};
Ranking.defaultProps = {
  require: true
};

var Rating = function (_Model) {
  inherits(Rating, _Model);

  function Rating() {
    classCallCheck(this, Rating);
    return possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).apply(this, arguments));
  }

  createClass(Rating, null, [{
    key: "reducer",
    value: function reducer(action, Rating, session) {
      switch (action.type) {
        case questionTypes.QUESTION_SET_STEPS:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                _steps = _action$payload.steps;
            var model = session.Question.withId(_id).rating;

            if (model) {
              model.set("steps", _steps);
            }

            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model = session.Question.withId(action.payload).rating;
            if (_model) _model.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Rating;
}(Model$2);

Rating.modelName = "Rating";
Rating.fields = {
  question: lib_3$2("Question", "rating")
};
Rating.defaultProps = {
  steps: 10,
  require: true
};

var ShortText = function (_Model) {
  inherits(ShortText, _Model);

  function ShortText() {
    classCallCheck(this, ShortText);
    return possibleConstructorReturn(this, (ShortText.__proto__ || Object.getPrototypeOf(ShortText)).apply(this, arguments));
  }

  createClass(ShortText, null, [{
    key: "reducer",
    value: function reducer(action, ShortText, session) {
      switch (action.type) {
        case questionTypes.QUESTION_SET_MIN_LENGTH:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                minLength = _action$payload.minLength;
            var model = session.Question.withId(_id).shortText;
            if (model) model.set("min", minLength);
            break;
          }

        case questionTypes.QUESTION_SET_MAX_LENGTH:
          {
            var _action$payload2 = action.payload,
                _id2 = _action$payload2.id,
                maxLength = _action$payload2.maxLength;
            var _model = session.Question.withId(_id2).shortText;
            if (_model) _model.set("max", maxLength);
            break;
          }

        case questionTypes.QUESTION_RECONCILE_LENGTH:
          {
            var _model2 = session.Question.withId(action.payload).shortText;
            if (!_model2) return;
            var _model2$ref = _model2.ref,
                _min = _model2$ref.min,
                _max = _model2$ref.max,
                _upperBound = _model2$ref.upperBound;
            var newMax = clamp_1(_max, 0, _upperBound);

            _model2.set("min", clamp_1(_min, 0, newMax));

            _model2.set("max", newMax);

            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model3 = session.Question.withId(action.payload).shortText;
            if (_model3) _model3.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return ShortText;
}(Model$2);

ShortText.modelName = "ShortText";
ShortText.fields = {
  question: lib_3$2("Question", "shortText")
};
var upperBound$1 = questionConfigs.short_text_input.upperBound;
ShortText.defaultProps = {
  min: 1,
  max: upperBound$1,
  upperBound: upperBound$1,
  require: true
};
var rowReducer$6 = makeRowReducer("singleSelect"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var SingleSelect = function (_Model) {
  inherits(SingleSelect, _Model);

  function SingleSelect() {
    classCallCheck(this, SingleSelect);
    return possibleConstructorReturn(this, (SingleSelect.__proto__ || Object.getPrototypeOf(SingleSelect)).apply(this, arguments));
  }

  createClass(SingleSelect, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(SingleSelect.prototype.__proto__ || Object.getPrototypeOf(SingleSelect.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          singleSelect: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, SingleSelect, session) {
      rowReducer$6(action, SingleSelect, session);

      switch (action.type) {
        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var model = session.Question.withId(action.payload).singleSelect;
            if (model) model.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return SingleSelect;
}(Model$2);

SingleSelect.modelName = "SingleSelect";
SingleSelect.maxRows = 100;
SingleSelect.allowRowImages = true;
SingleSelect.fields = {
  question: lib_3$2("Question", "singleSelect")
};
SingleSelect.defaultProps = {
  require: true,
  sortType: "default",
  imageAnswers: false
};
var rowReducer$7 = makeRowReducer("singleSelectGrid", "singleSelectGridRow");
var columnReducer$1 = makeColumnReducer("singleSelectGrid", "singleSelectGridColumn"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var SingleSelectGrid = function (_Model) {
  inherits(SingleSelectGrid, _Model);

  function SingleSelectGrid() {
    classCallCheck(this, SingleSelectGrid);
    return possibleConstructorReturn(this, (SingleSelectGrid.__proto__ || Object.getPrototypeOf(SingleSelectGrid)).apply(this, arguments));
  }

  createClass(SingleSelectGrid, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(SingleSelectGrid.prototype.__proto__ || Object.getPrototypeOf(SingleSelectGrid.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          singleSelectGridRow: newModel.id
        });
      });
      this.columns.toModelArray().forEach(function (r) {
        return r.duplicate({
          singleSelectGridColumn: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, SingleSelectGrid, session) {
      rowReducer$7(action, SingleSelectGrid, session);
      columnReducer$1(action, SingleSelectGrid, session);

      switch (action.type) {
        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var model = session.Question.withId(action.payload).singleSelectGrid;
            if (model) model.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return SingleSelectGrid;
}(Model$2);

SingleSelectGrid.modelName = "SingleSelectGrid";
SingleSelectGrid.fields = {
  question: lib_3$2("Question", "singleSelectGrid")
};
SingleSelectGrid.defaultProps = {
  require: true,
  sortType: "default"
};

var Slider$1 = function (_Model) {
  inherits(Slider$$1, _Model);

  function Slider$$1() {
    classCallCheck(this, Slider$$1);
    return possibleConstructorReturn(this, (Slider$$1.__proto__ || Object.getPrototypeOf(Slider$$1)).apply(this, arguments));
  }

  createClass(Slider$$1, null, [{
    key: "reducer",
    value: function reducer(action, ShortText, session) {
      switch (action.type) {
        case questionTypes.QUESTION_SET_MIN_VALUE:
          {
            var _action$payload = action.payload,
                _id = _action$payload.id,
                minValue = _action$payload.minValue;
            var model = session.Question.withId(_id).slider;
            if (model) model.set("min", minValue);
            break;
          }

        case questionTypes.QUESTION_SET_MAX_VALUE:
          {
            var _action$payload2 = action.payload,
                _id2 = _action$payload2.id,
                maxValue = _action$payload2.maxValue;
            var _model = session.Question.withId(_id2).slider;
            if (_model) _model.set("max", maxValue);
            break;
          }

        case questionTypes.QUESTION_SET_INCREMENT:
          {
            var _action$payload3 = action.payload,
                _id3 = _action$payload3.id,
                _increment = _action$payload3.increment;
            var _model2 = session.Question.withId(_id3).slider;
            if (_model2) _model2.set("increment", _increment);
            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model3 = session.Question.withId(action.payload).slider;
            if (_model3) _model3.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Slider$$1;
}(Model$2);

Slider$1.modelName = "Slider";
Slider$1.fields = {
  question: lib_3$2("Question", "slider")
};
Slider$1.defaultProps = {
  min: 1,
  max: 10,
  increment: 1,
  require: true
};
var rowReducer$8 = makeRowReducer("sum"); // $FlowFixMe (Covariant property `create` incompatible with invariant use in statics of `Model`)

var Sum = function (_Model) {
  inherits(Sum, _Model);

  function Sum() {
    classCallCheck(this, Sum);
    return possibleConstructorReturn(this, (Sum.__proto__ || Object.getPrototypeOf(Sum)).apply(this, arguments));
  }

  createClass(Sum, [{
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newModel = get$1(Sum.prototype.__proto__ || Object.getPrototypeOf(Sum.prototype), "duplicate", this).call(this, newAttrs);
      this.rows.toModelArray().forEach(function (r) {
        return r.duplicate({
          sum: newModel.id
        });
      });
      return newModel;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Sum, session) {
      rowReducer$8(action, Sum, session);

      switch (action.type) {
        case questionTypes.QUESTION_TOGGLE_VALIDATES_SUM:
          {
            var model = session.Question.withId(action.payload).sum;
            if (model) model.set("validatesSum", !model.ref.validatesSum);
            break;
          }

        case questionTypes.QUESTION_SET_TARGET_SUM:
          {
            var _model = session.Question.withId(action.payload.id).sum;
            if (_model) _model.set("targetSum", action.payload.targetSum);
            break;
          }

        case questionTypes.QUESTION_TOGGLE_REQUIRED:
          {
            var _model2 = session.Question.withId(action.payload).sum;
            if (_model2) _model2.toggle("require");
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Sum;
}(Model$2);

Sum.modelName = "Sum";
Sum.fields = {
  question: lib_3$2("Question", "sum")
};
Sum.defaultProps = {
  validatesSum: false,
  targetSum: 100,
  require: true
};
var typeMap = {
  single_select: {
    table: SingleSelect,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsDiscrete(AnswerContent, "singleSelect", id);
    }
  },
  multiple_select: {
    table: MultipleSelect,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsDiscrete(AnswerContent, "multipleSelect", id);
    }
  },
  single_select_matrix: {
    table: SingleSelectGrid,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsGrid(AnswerContent, "singleSelectGridRow", "singleSelectGridColumn", id);
    }
  },
  multiple_select_matrix: {
    table: MultipleSelectGrid,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsGrid(AnswerContent, "multipleSelectGridRow", "multipleSelectGridColumn", id);
    }
  },
  rating: {
    table: Rating
  },
  multiple_rating: {
    table: MultipleRating,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsDiscrete(AnswerContent, "multipleRating", id);
    }
  },
  descriptive: {
    table: Message
  },
  short_text_input: {
    table: ShortText
  },
  long_text_input: {
    table: LongText
  },
  dropdown: {
    table: Dropdown,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsDiscrete(AnswerContent, "dropdown", id);
    }
  },
  rank_order: {
    table: Ranking,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsDiscrete(AnswerContent, "rankOrder", id);
    }
  },
  slider: {
    table: Slider$1
  },
  multiple_slider: {
    table: MultipleSlider,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsDiscrete(AnswerContent, "multipleSlider", id);
    }
  },
  numeric: {
    table: Numeric
  },
  sum: {
    table: Sum,
    initialize: function initialize(id, AnswerContent) {
      return createInitialContentsDiscrete(AnswerContent, "sum", id);
    }
  }
};

var createQuestionTypeModel = function createQuestionTypeModel(props, type, session) {
  var table = typeMap[type].table;
  var newModel = session[table.modelName].create(props, true);
  if (typeMap[type].initialize) typeMap[type].initialize(newModel.id, session.AnswerContent);
  return newModel;
}; // $FlowFixMe (some kind of invariant problem)


var Question = function (_Model) {
  inherits(Question, _Model);

  function Question() {
    classCallCheck(this, Question);
    return possibleConstructorReturn(this, (Question.__proto__ || Object.getPrototypeOf(Question)).apply(this, arguments));
  }

  createClass(Question, [{
    key: "delete",
    value: function _delete() {
      this.typeModel.delete();
      if (this.providerPipe) this.providerPipe.delete();
      this.consumerPipes.toModelArray().forEach(function (p) {
        return p.delete();
      });
      get$1(Question.prototype.__proto__ || Object.getPrototypeOf(Question.prototype), "delete", this).call(this);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var newAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = this.ref,
          id = _ref.id,
          type = _ref.type,
          attrs = objectWithoutProperties(_ref, ["id", "type"]);
      var newModel = this.constructor.create(_extends$c({}, attrs, {
        sequence: this.ref.sequence + 0.5
      }, newAttrs));
      this.typeModel.duplicate({
        question: newModel.id
      }); // Set the model's type after creation to avoid creation of an extra typeModel.

      newModel.set("type", type);
      return newModel;
    }
  }, {
    key: "typeModel",
    get: function get() {
      if (this.dropdown) return this.dropdown;
      if (this.sum) return this.sum;
      if (this.singleSelect) return this.singleSelect;
      if (this.singleSelectGrid) return this.singleSelectGrid;
      if (this.multipleRating) return this.multipleRating;
      if (this.multipleSelect) return this.multipleSelect;
      if (this.multipleSelectGrid) return this.multipleSelectGrid;
      if (this.multipleSlider) return this.multipleSlider;
      if (this.numeric) return this.numeric;
      if (this.rankOrder) return this.rankOrder;
      if (this.rating) return this.rating;
      if (this.shortText) return this.shortText;
      if (this.slider) return this.slider;
      if (this.longText) return this.longText;
      if (this.message) return this.message;
      throw new Error("No typeModel found for question with id " + this.id);
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Question, session) {
      switch (action.type) {
        case questionTypes.QUESTION_CREATE:
          createQuestion(session, action.payload);
          resetRootGraphSequences(session);
          break;

        case questionTypes.QUESTION_DELETE:
          {
            if (Question.hasId(action.payload)) {
              Question.withId(action.payload).delete();
            }

            resetRootGraphSequences(session);
            break;
          }

        case questionTypes.QUESTION_TOGGLE_RATING_TYPE:
          {
            var _id = action.payload;
            var model = Question.withId(_id);

            if (model.rating) {
              var _model$rating$ref = model.rating.ref,
                  _ = _model$rating$ref.id,
                  attrs = objectWithoutProperties(_model$rating$ref, ["id"]);
              model.rating.delete();
              model.set("type", "multiple_rating");
              return createQuestionTypeModel(_extends$c({}, attrs), "multiple_rating", session);
            }

            if (model.multipleRating) {
              var _model$multipleRating = model.multipleRating.ref,
                  _2 = _model$multipleRating.id,
                  _attrs = objectWithoutProperties(_model$multipleRating, ["id"]);

              model.multipleRating.delete();
              model.set("type", "rating");
              return createQuestionTypeModel(_extends$c({}, _attrs), "rating", session);
            }

            break;
          }

        case questionTypes.QUESTION_TOGGLE_SLIDER_TYPE:
          {
            var _id2 = action.payload;

            var _model = Question.withId(_id2);

            if (_model.slider) {
              var _model$slider$ref = _model.slider.ref,
                  _3 = _model$slider$ref.id,
                  _attrs2 = objectWithoutProperties(_model$slider$ref, ["id"]);

              _model.slider.delete();

              _model.set("type", "multiple_slider");

              return createQuestionTypeModel(_extends$c({}, _attrs2), "multiple_slider", session);
            }

            if (_model.multipleSlider) {
              var _model$multipleSlider = _model.multipleSlider.ref,
                  _4 = _model$multipleSlider.id,
                  _attrs3 = objectWithoutProperties(_model$multipleSlider, ["id"]);

              _model.multipleSlider.delete();

              _model.set("type", "slider");

              return createQuestionTypeModel(_extends$c({}, _attrs3), "slider", session);
            }

            break;
          }

        case questionTypes.QUESTION_UPDATE_EDITOR:
          {
            var _action$payload = action.payload,
                _id3 = _action$payload.id,
                _draftRawContent = _action$payload.draftRawContent,
                selectionState = _action$payload.selectionState;

            var _model2 = Question.withId(_id3);

            _model2.set("draftRawContent", _draftRawContent);

            _model2.set("draftSelectionState", selectionState);

            _model2.set("content", Draft_1(_draftRawContent).getPlainText());

            break;
          }

        case questionTypes.QUESTION_MOVE_UNSAFE:
          {
            var _action$payload2 = action.payload,
                _id4 = _action$payload2.id,
                _page = _action$payload2.page,
                _after = _action$payload2.after,
                breakingRelations = _action$payload2.breakingRelations;
            breakRelations(breakingRelations, session);

            var _model3 = Question.withId(_id4);

            var _sequence = _after === undefined ? 0 : Question.withId(_after).ref.sequence + 0.5;

            var previousPage = _model3.page;

            _model3.set("sequence", _sequence);

            _model3.set("page", _page);

            if (previousPage.questions.count() === 0) {
              previousPage.delete();
            }

            resetRootGraphSequences(session);
            break;
          }

        case questionTypes.QUESTION_DUPLICATE:
          {
            var _model4 = Question.withId(action.payload);

            _model4.duplicate();

            resetRootGraphSequences(session);
            break;
          }

        case questionTypes.QUESTION_SET_CONTENT:
          {
            var _action$payload3 = action.payload,
                _id5 = _action$payload3.id,
                _content = _action$payload3.content;

            var _model5 = Question.withId(_id5);

            _model5.set("content", _content);

            if (_content.trim() !== "") _model5.set("lastNonEmptyContent", _content);
            break;
          }

        case questionTypes.QUESTION_RESET_CONTENT:
          {
            var _model6 = Question.withId(action.payload);

            if (_model6.content.trim() === "") {
              var draftContent = Draft_3.createFromText(_model6.lastNonEmptyContent);

              var _draftRawContent2 = Draft_2(draftContent);

              var selection = Draft_5.createEmpty(draftContent.getFirstBlock().getKey());

              _model6.set("draftRawContent", _draftRawContent2);

              _model6.set("draftSelectionState", selection);

              _model6.set("content", _model6.lastNonEmptyContent);
            }

            break;
          }

        case questionTypes.QUESTION_SET_DESCRIPTION:
          {
            var _action$payload4 = action.payload,
                _id6 = _action$payload4.id,
                _description = _action$payload4.description;
            Question.withId(_id6).set("description", _description);
            break;
          }

        case questionTypes.QUESTION_TOGGLE_DESCRIPTION:
          Question.withId(action.payload).toggle("hasDescription");
          break;

        case questionTypes.QUESTION_TOGGLE_MEDIA:
          Question.withId(action.payload).toggle("hasMedia");
          break;

        case questionTypes.QUESTION_TOGGLE_MEDIA_TYPE:
          {
            var _id7 = action.payload;
            var current = Question.withId(_id7).ref.mediaType;
            var next = current === "image" ? "video" : "image";
            Question.withId(_id7).set("mediaType", next);
            break;
          }

        case questionTypes.QUESTION_IMAGE_REQUEST:
          {
            var _id8 = action.payload.id;

            var _model7 = Question.withId(_id8);

            _model7.set("imageLoading", true);

            _model7.set("imageError", false);

            break;
          }

        case questionTypes.QUESTION_IMAGE_SUCCESS:
          {
            var _action$payload5 = action.payload,
                _id9 = _action$payload5.id,
                filename = _action$payload5.filename,
                url = _action$payload5.url;

            var _model8 = Question.withId(_id9);

            _model8.set("imageFilename", filename);

            _model8.set("imageUrl", url);

            _model8.set("imageLoading", false);

            _model8.set("imageError", false);

            break;
          }

        case questionTypes.QUESTION_IMAGE_ERROR:
          {
            var _id10 = action.payload.id;

            var _model9 = Question.withId(_id10);

            _model9.set("imageError", true);

            _model9.set("imageLoading", false);

            break;
          }

        case questionTypes.QUESTION_IMAGE_CLEAR:
          {
            var _model10 = Question.withId(action.payload);

            _model10.set("imageFilename", undefined);

            _model10.set("imageUrl", undefined);

            _model10.set("imageLoading", false);

            _model10.set("imageError", false);

            break;
          }

        case questionTypes.QUESTION_SET_VIDEO_URL:
          {
            var _action$payload6 = action.payload,
                _id11 = _action$payload6.id,
                _url = _action$payload6.url;

            var _model11 = Question.withId(_id11);

            _model11.set("videoUrl", _url);

            break;
          }

        default:
          return undefined;
      }
    }
  }, {
    key: "create",
    value: function create(props) {
      var model = get$1(Question.__proto__ || Object.getPrototypeOf(Question), "create", this).call(this, props);
      if (props.type) createQuestionTypeModel({
        question: model.id
      }, props.type, this.session);
      return model;
    }
  }]);
  return Question;
}(Model$2);

Question.modelName = "Question";

var injectPipe = function injectPipe(session, payload) {
  var endQuestion = payload.endQuestion;
  var model = session.Question.withId(endQuestion);
  var _model$ref = model.ref,
      draftRawContent = _model$ref.draftRawContent,
      draftSelectionState = _model$ref.draftSelectionState;
  var contentState = Draft_1(draftRawContent);
  var contentWithoutPipes = stripPipes(contentState);

  var _applyPipe = applyPipe(contentWithoutPipes, draftSelectionState, payload, payload.placeholder),
      content = _applyPipe.content,
      selection = _applyPipe.selection;

  model.set("draftRawContent", Draft_2(content));
  model.set("draftSelectionState", selection);
  model.set("content", content.getPlainText());
};

var stripPipes = function stripPipes(contentState) {
  var newContentState = contentState;
  contentState.blockMap.forEach(function (block, blockKey) {
    block.findEntityRanges(function (value) {
      return value.getEntity();
    }, function (start, end) {
      var selection = new Draft_5({
        anchorKey: blockKey,
        anchorOffset: start,
        focusKey: blockKey,
        focusOffset: end
      });
      newContentState = Draft_8.applyEntity(newContentState, selection, null);
    });
  });
  return newContentState;
};

var applyPipe = function applyPipe(contentState, selection, data, text) {
  var contentWithText = Draft_8.replaceText(contentState, selection, text);
  var startKey = selection.getStartKey();
  var newSelection = Draft_5.createEmpty(startKey).merge({
    anchorOffset: selection.getStartOffset(),
    focusOffset: selection.getStartOffset() + text.length
  });
  var contentWithEntity = contentWithText.createEntity("TOKEN", "IMMUTABLE", data);
  var entityKey = contentWithEntity.getLastCreatedEntityKey();
  var contentWithPipe = Draft_8.applyEntity(contentWithEntity, newSelection, entityKey);
  return {
    content: contentWithPipe,
    selection: newSelection
  };
};

var createQuestion = function createQuestion(session, payload) {
  var after = payload.after,
      attrs = objectWithoutProperties(payload, ["after"]);
  var sequence = after === undefined ? 0 : session.Question.withId(after).ref.sequence + 0.5;
  return session.Question.create(_extends$c({
    sequence: sequence
  }, attrs));
};

var defaultDraftContent = Draft_3.createFromText("New question");
var defaultSelection = Draft_5.createEmpty(defaultDraftContent.getFirstBlock().getKey());
Question.fields = {
  page: lib_6("Page", "questions")
};
Question.defaultProps = {
  content: "New question",
  lastNonEmptyContent: "New question",
  visibility: "visible",
  draftRawContent: Draft_2(defaultDraftContent),
  draftSelectionState: defaultSelection,
  description: "",
  hasDescription: false,
  hasMedia: false,
  hasAnswerImages: false,
  mediaType: "image",
  anchor: false
};

var Page = function (_Model) {
  inherits(Page, _Model);

  function Page() {
    classCallCheck(this, Page);
    return possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
  }

  createClass(Page, [{
    key: "delete",
    value: function _delete() {
      this.questions.toModelArray().forEach(function (q) {
        return q.delete();
      });
      var hostNode = this.node.parentGraph.hostNode;

      if (hostNode && hostNode.section) {
        var section = hostNode.section;

        if (this.node.parentGraph.nodes.count() === 1) {
          section.delete();
        }
      }

      this.node.delete();
      get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), "delete", this).call(this);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var session = this.constructor.session;
      var _ref = this.ref,
          id = _ref.id,
          node = _ref.node,
          attrs = objectWithoutProperties(_ref, ["id", "node"]);

      var _session$DagNode$with = session.DagNode.withId(node),
          parentGraph = _session$DagNode$with.parentGraph;

      var payload = _extends$c({
        graph: parentGraph.id,
        after: node
      }, attrs);

      var newPage = createPage(payload, session.Page, session);
      var questions = this.questions.toModelArray();
      questions.forEach(function (q) {
        return q.duplicate({
          page: newPage.id
        });
      });
      return newPage;
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Page, session) {
      switch (action.type) {
        case pageTypes.PAGE_DELETE:
          Page.withId(action.payload).delete();
          resetRootGraphSequences(session);
          break;

        case pageTypes.PAGE_CREATE_WITH_NEW_QUESTION:
          createPageWithNewQuestion(action.payload, Page, session);
          break;

        case pageTypes.PAGE_CREATE_WITH_EXISTING_QUESTION_UNSAFE:
          createPageWithExistingQuestion(action.payload, Page, session);
          break;

        case pageTypes.PAGE_DUPLICATE:
          {
            var _page = Page.withId(action.payload);

            _page.duplicate();

            resetRootGraphSequences(session);
            break;
          }

        case pageTypes.PAGE_SET_CONTENT:
          {
            var _action$payload = action.payload,
                _id2 = _action$payload.id,
                _content = _action$payload.content;
            Page.withId(_id2).set("content", _content);
            break;
          }

        case pageTypes.PAGE_TOGGLE_RANDOM_SORT:
          {
            var current = Page.withId(action.payload).sortType;
            var next = current === "randomize" ? "default" : "randomize";
            Page.withId(action.payload).set("sortType", next);
            break;
          }

        case pageTypes.PAGE_TOGGLE_REVERSE_SORT:
          {
            var _current = Page.withId(action.payload).sortType;

            var _next = _current === "reverse" ? "default" : "reverse";

            Page.withId(action.payload).set("sortType", _next);
          }
          break;

        case pageTypes.PAGE_TOGGLE_ANCHOR:
          Page.withId(action.payload).toggle("anchor");
          break;

        case pageTypes.PAGE_MOVE_UNSAFE:
          var _action$payload2 = action.payload,
              _id = _action$payload2.id,
              _graph = _action$payload2.graph,
              _after = _action$payload2.after,
              breakingRelations = _action$payload2.breakingRelations;
          breakRelations(breakingRelations, session);
          var page = Page.withId(_id);
          var hostNode = page.node.parentGraph.hostNode;
          var hostSection = hostNode ? hostNode.section : undefined;
          moveNode(session, page.node, _graph, _after);

          if (hostSection && hostSection.node.childGraph && hostSection.node.childGraph.nodes.count() === 0) {
            hostSection.delete();
          }

          resetRootGraphSequences(session);
          break;

        case questionTypes.QUESTION_DELETE:
          {
            var _page2 = session.Question.withId(action.payload).page;

            if (_page2.questions.count() === 1) {
              _page2.delete();
            }

            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Page;
}(Model$2);

Page.modelName = "Page";

var createPage = function createPage(page, Page, session) {
  var graph = page.graph,
      after = page.after,
      attrs = objectWithoutProperties(page, ["graph", "after"]);
  var newPage = Page.create(attrs);
  var newNode = createPageNode(session, graph, after);
  newPage.set("node", newNode.id);
  return newPage;
};

var createPageNode = function createPageNode(session, graphId, after) {
  var DagNode = session.DagNode;
  var newNode = DagNode.create({
    contentType: "Page"
  });
  installNode(session, newNode.id, graphId, after);
  return newNode;
};

var createPageWithNewQuestion = function createPageWithNewQuestion(payload, Page, session) {
  var page = payload.page,
      question = payload.question,
      surveyHashRoute = payload.surveyHashRoute;
  var newPage = createPage(page, Page, session);
  createQuestion(session, _extends$c({}, question, {
    page: newPage.id,
    surveyHashRoute: surveyHashRoute
  }));
  resetRootGraphSequences(session);
};

var createPageWithExistingQuestion = function createPageWithExistingQuestion(payload, Page, session) {
  var page = payload.page,
      question = payload.question,
      breakingRelations = payload.breakingRelations;
  breakRelations(breakingRelations, session);
  var Question$$1 = session.Question;
  var newPage = createPage(page, Page, session);
  var questionModel = Question$$1.withId(question);
  var currentPage = questionModel.page;
  questionModel.set("page", newPage);

  if (currentPage.questions.count() === 0) {
    currentPage.delete();
  }

  resetRootGraphSequences(session);
};

Page.fields = {
  content: lib_4$2(),
  anchor: lib_4$2(),
  sortType: lib_4$2(),
  sequence: lib_4$2(),
  dragSize: lib_4$2(),
  dropCoords: lib_4$2(),
  displayLogicBranch: lib_3$2("LogicBranch", "displayLogicPage"),
  survey: lib_6("Survey", "pages"),
  node: lib_3$2("DagNode", "page")
};
Page.defaultProps = {
  anchor: false,
  sequence: 0,
  sortType: "default"
};

var Pipe = function (_Model) {
  inherits(Pipe, _Model);

  function Pipe() {
    classCallCheck(this, Pipe);
    return possibleConstructorReturn(this, (Pipe.__proto__ || Object.getPrototypeOf(Pipe)).apply(this, arguments));
  }

  createClass(Pipe, [{
    key: "delete",
    value: function _delete() {
      var endQuestion = this.endQuestion;
      var draftRawContent = endQuestion.ref.draftRawContent;
      var newContentState = stripPipes(Draft_1(draftRawContent));
      endQuestion.set("draftRawContent", Draft_2(newContentState));
      get$1(Pipe.prototype.__proto__ || Object.getPrototypeOf(Pipe.prototype), "delete", this).call(this);
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Pipe, session) {
      switch (action.type) {
        case pipeTypes.PIPE_CREATE:
          {
            var _action$payload = action.payload,
                _endQuestion = _action$payload.endQuestion,
                _selected = _action$payload.selected,
                _sourceQuestion = _action$payload.sourceQuestion;

            var _session$Question$wit = session.Question.withId(_endQuestion),
                providerPipe = _session$Question$wit.providerPipe;

            if (providerPipe) providerPipe.delete();
            var text = getPipeText(session, _selected, _sourceQuestion);

            var payloadWithPlaceholder = _extends$c({}, action.payload, {
              placeholder: text
            });

            var newPipe = Pipe.create(payloadWithPlaceholder);

            var injectPayload = _extends$c({}, payloadWithPlaceholder, {
              id: newPipe.id
            });

            injectPipe(session, injectPayload);
            break;
          }

        case pipeTypes.PIPE_DELETE:
          Pipe.withId(action.payload).delete();
          break;

        default:
          return undefined;
      }
    }
  }]);
  return Pipe;
}(lib_14);

Pipe.modelName = "Pipe";

var getPipeText = function getPipeText(session, selected, sourceQuestion) {
  var sequence = session.Question.withId(sourceQuestion).ref.sequence;
  var type = selected ? "Selected" : "Unselected";
  return "{ " + type + " from Q" + sequence + " }";
};

Pipe.fields = {
  sourceQuestion: lib_6("Question", "consumerPipes"),
  endQuestion: lib_3$2("Question", "providerPipe"),
  placeholder: lib_4$2(),
  selected: lib_4$2()
};

var mergeGraphs = function mergeGraphs(sourceModel, targetModel, session) {
  var start = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var DagGraph = session.DagGraph,
      DagEdge = session.DagEdge; // Get the end of the merger's first graph.

  var leafNodes = start ? getLeafNodes(sourceModel) : getLeafNodes(targetModel);
  if (leafNodes.length !== 1) throw new Error("Tried to merge two sections but could not find a leaf node in the first section");
  var tailNode = leafNodes[0]; // Get the start of the merger's second graph.

  var headNode = start ? getRootNode(targetModel) : getRootNode(sourceModel); // Finalize the merge.

  var newEdge = DagEdge.create({
    tailNode: tailNode,
    headNode: headNode
  });
  tailNode.set("defaultEdge", newEdge);
  sourceModel.nodes.toModelArray().forEach(function (n) {
    return n.set("parentGraph", targetModel);
  });
  sourceModel.delete();
  return targetModel;
};

var Section = function (_Model) {
  inherits(Section, _Model);

  function Section() {
    classCallCheck(this, Section);
    return possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
  }

  createClass(Section, [{
    key: "delete",
    value: function _delete() {
      // TODO: Release pages into root graph instead of section's parent
      var _node = this.node,
          childGraph = _node.childGraph,
          parentGraph = _node.parentGraph;

      if (childGraph !== undefined) {
        if (parentGraph.hostNode) {
          var session = this.constructor.session;
          uninstallSectionFromGroup(session, this);
        } else {
          uninstallGraph(childGraph);
        }

        childGraph.delete();
      }

      this.node.delete();
      get$1(Section.prototype.__proto__ || Object.getPrototypeOf(Section.prototype), "delete", this).call(this);
    }
  }], [{
    key: "reducer",
    value: function reducer(action, Section, session) {
      switch (action.type) {
        case sectionTypes.SECTION_CREATE:
          createSection(action.payload, Section, session);
          break;

        case sectionTypes.SECTION_DELETE:
          Section.withId(action.payload).delete();
          break;

        case sectionTypes.SECTION_SET_SORT_TYPE:
          {
            var _action$payload = action.payload,
                id = _action$payload.id,
                _sortType = _action$payload.sortType;
            Section.withId(id).set("sortType", _sortType);
            break;
          }

        case sectionTypes.SECTION_SET_CONTENT:
          {
            var _action$payload2 = action.payload,
                _id = _action$payload2.id,
                _content = _action$payload2.content;
            Section.withId(_id).set("content", _content);
            break;
          }

        case sectionTypes.SECTION_MERGE:
          {
            var _action$payload3 = action.payload,
                _id2 = _action$payload3.id,
                target = _action$payload3.target,
                start = _action$payload3.start;
            mergeSections(session, _id2, target, start);
            resetRootGraphSequences(session);
            break;
          }

        case sectionTypes.SECTION_MOVE_UNSAFE:
          {
            var _action$payload4 = action.payload,
                _id3 = _action$payload4.id,
                graph = _action$payload4.graph,
                after = _action$payload4.after,
                breakingRelations = _action$payload4.breakingRelations;
            breakRelations(breakingRelations, session);

            var _Section$withId = Section.withId(_id3),
                _node2 = _Section$withId.node;

            var hostNode = _node2.parentGraph.hostNode;
            var hostGroup = hostNode ? hostNode.group : undefined;
            moveNode(session, _node2, graph, after);

            if (hostGroup && hostGroup.node.childGraph && hostGroup.node.childGraph.nodes.count() === 0) {
              hostGroup.delete();
            }

            resetRootGraphSequences(session);
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Section;
}(Model$2);

Section.modelName = "Section"; // The payload's 'pages' property should contain all of the section's pages
// in order. For edge traversal purposes, the first page will be used as the root,
// and the last will be used as the end.

var createSection = function createSection(payload, Section, session) {
  var sequence = Section.count() + 1;
  var pages = payload.pages,
      rest = objectWithoutProperties(payload, ["pages"]);
  var sectionNode = createSectionNode(session);
  var newSection = Section.create(_extends$c({
    sequence: sequence,
    node: sectionNode
  }, rest));
  var nodes = pages.map(function (p) {
    return session.Page.withId(p).node;
  });
  installGraph(sectionNode, nodes, session);
  var counts = nodes.map(function (n) {
    return n.incomingEdges.count();
  });
  var surveyModel = session.Survey.first();
  if (surveyModel === undefined) throw new Error("Survey model is missing its instance. Make sure the Survey model is instantiated.");
  var rootGraph = surveyModel.graph;
  sectionNode.set("parentGraph", rootGraph.id);
  return newSection;
};

var createSectionNode = function createSectionNode(session) {
  var DagGraph = session.DagGraph,
      DagNode = session.DagNode;
  var childGraph = DagGraph.create();
  return DagNode.create({
    childGraph: childGraph,
    contentType: "Section"
  });
};

var mergeSections = function mergeSections(session, source, target) {
  var start = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var Section = session.Section;
  var sourceGraph = Section.withId(source).node.childGraph;
  var targetGraph = Section.withId(target).node.childGraph;
  if (!sourceGraph || !targetGraph) throw new Error("Tried to merge two sections but a graph was missing");
  mergeGraphs(sourceGraph, targetGraph, session, start);
  Section.withId(source).delete();
};

var uninstallSectionFromGroup = function uninstallSectionFromGroup(session, section) {
  var node = section.node;
  var childGraph = node.childGraph,
      parentGraph = node.parentGraph;
  var groupNode = parentGraph.hostNode;
  if (!groupNode || !childGraph) throw new Error(); // Delete any edges incoming to the section.

  uninstallNode(node, session.DagEdge); // TODO: import the section's pages into the root graph immediately following the section.

  var root = getRootNode(childGraph);
  var leaf = getLeafNodes(childGraph)[0];
  installNodeRange(session, root, leaf, groupNode);
  childGraph.nodes.toModelArray().forEach(function (n) {
    return n.set("parentGraph", groupNode.parentGraph);
  });
};

Section.fields = {
  survey: lib_6("Survey", "sections"),
  group: lib_6("Group", "sections"),
  sortType: lib_4$2(),
  content: lib_4$2(),
  anchor: lib_4$2(),
  node: lib_3$2("DagNode", "section")
};
Section.defaultProps = {
  content: "New section",
  sortType: "default"
};

var SpecialOption = function (_Model) {
  inherits(SpecialOption, _Model);

  function SpecialOption() {
    classCallCheck(this, SpecialOption);
    return possibleConstructorReturn(this, (SpecialOption.__proto__ || Object.getPrototypeOf(SpecialOption)).apply(this, arguments));
  }

  createClass(SpecialOption, null, [{
    key: "reducer",
    value: function reducer(action, SpecialOption, session) {
      switch (action.type) {
        case specialOptionTypes.SPECIAL_OPTION_CREATE:
          {
            var _action$payload = action.payload,
                question = _action$payload.question,
                attrs = objectWithoutProperties(_action$payload, ["question"]);
            var model = session.Question.withId(question);

            var relation = function () {
              if (model.singleSelect) return {
                singleSelect: model.singleSelect.id
              };
              if (model.multipleSelect) return {
                multipleSelect: model.multipleSelect.id
              };
              if (model.dropdown) return {
                dropdown: model.dropdown.id
              };
              throw new Error("No special option type for question with id " + model.id);
            }();

            SpecialOption.create(_extends$c({}, attrs, relation));
            break;
          }

        case specialOptionTypes.SPECIAL_OPTION_DELETE:
          SpecialOption.withId(action.payload).delete();
          break;

        case specialOptionTypes.SPECIAL_OPTION_SET_TEXT:
          {
            var _action$payload2 = action.payload,
                _id = _action$payload2.id,
                _text = _action$payload2.text;
            SpecialOption.withId(_id).set("text", _text);
            break;
          }

        case specialOptionTypes.SPECIAL_OPTION_TOGGLE_OPEN_ANSWER_REQUIRED:
          SpecialOption.withId(action.payload).toggle("openAnswerRequired");
          break;

        case specialOptionTypes.SPECIAL_OPTION_SET_OPEN_ANSWER_TEXT:
          {
            var _action$payload3 = action.payload,
                _id2 = _action$payload3.id,
                _text2 = _action$payload3.text;
            SpecialOption.withId(_id2).set("openAnswerText", _text2);
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return SpecialOption;
}(Model$2);

SpecialOption.modelName = "SpecialOption";
SpecialOption.fields = {
  singleSelect: lib_6("SingleSelect", "specialOptions"),
  multipleSelect: lib_6("MultipleSelect", "specialOptions"),
  dropdown: lib_6("Dropdown", "specialOptions"),
  type: lib_4$2(),
  text: lib_4$2(),
  openAnswerRequired: lib_4$2(),
  openAnswerText: lib_4$2()
};
SpecialOption.defaultProps = {
  text: ""
};

var Survey = function (_Model) {
  inherits(Survey, _Model);

  function Survey() {
    classCallCheck(this, Survey);
    return possibleConstructorReturn(this, (Survey.__proto__ || Object.getPrototypeOf(Survey)).apply(this, arguments));
  }

  createClass(Survey, null, [{
    key: "reducer",
    value: function reducer(action, Survey, session) {
      switch (action.type) {
        case surveyTypes.SURVEY_SET_TITLE:
          {
            var model = Survey.first();
            if (model) model.set("title", action.payload);
            break;
          }

        case surveyTypes.SURVEY_SET_HASH:
          {
            var _model = Survey.first();

            if (_model && _model.hash === undefined) _model.set("hash", action.payload);
            break;
          }

        case surveyTypes.SURVEY_SET_PREVIEW_LINK:
          {
            var _model2 = Survey.first();

            if (_model2) _model2.set("previewLink", action.payload);
            break;
          }

        default:
          return undefined;
      }
    }
  }]);
  return Survey;
}(Model$2);

Survey.modelName = "Survey";
Survey.fields = {
  title: lib_4$2(),
  graph: lib_3$2("DagGraph", "survey")
};
Survey.defaultProps = {
  title: "New Survey"
};

var DagGraph = function (_Model) {
  inherits(DagGraph, _Model);

  function DagGraph() {
    classCallCheck(this, DagGraph);
    return possibleConstructorReturn(this, (DagGraph.__proto__ || Object.getPrototypeOf(DagGraph)).apply(this, arguments));
  }

  return DagGraph;
}(Model$2);

DagGraph.modelName = "DagGraph";
var orm = new lib_13(); // Registers all of the models with the orm. Initializes the orm's state.
// The models' reducers are run in the order of registration.

orm.register(AnswerContent, Group, LogicBranch, LogicCondition, Page, Pipe, Question, Section, SpecialOption, Survey, DagGraph, DagNode, DagEdge, Dropdown, LongText, Message, MultipleRating, MultipleSelect, MultipleSelectGrid, MultipleSlider, Numeric, Ranking, Rating, ShortText, SingleSelect, SingleSelectGrid, Slider$1, Sum);

var selectOrm = function selectOrm(state) {
  return state.orm.present;
};

var uiSelector = function uiSelector(state) {
  return state.ui;
};

var createArraysEqualSelector = createSelectorCreator(defaultMemoize, function (a, b) {
  return a.length === b.length && a.every(function (model, index) {
    return model === b[index];
  });
});
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */

function uniqBy(array, iteratee) {
  return array && array.length ? _baseUniq(array, _baseIteratee(iteratee, 2)) : [];
}

var uniqBy_1 = uniqBy;

var getParents = function getParents(leafNode) {
  return leafNode.incomingEdges.toModelArray().map(function (e) {
    return e.tailNode;
  });
};

var getPreviousNodes = function getPreviousNodes(node) {
  var queue = getParents(node);
  var result = [];

  while (queue.length > 0) {
    var ancestor = queue.pop();
    result.push(ancestor);

    if (ancestor.childGraph) {
      var leafNodes = getLeafNodes(ancestor.childGraph);
      var newNodes = leafNodes.reduce(function (list, leafNode) {
        return [].concat(toConsumableArray(list), [leafNode], toConsumableArray(getPreviousNodes(leafNode)));
      }, []);
      queue.unshift.apply(queue, toConsumableArray(newNodes));
    }

    queue.unshift.apply(queue, toConsumableArray(getParents(ancestor)));
  }

  return uniqBy_1(result, function (node) {
    return node.id;
  });
};

var selectId = function selectId(_, graph) {
  return graph;
};

var makeRootGraphSelector = function makeRootGraphSelector() {
  return lib_1$2(orm, selectOrm, function (session) {
    var survey = session.Survey.first();

    if (survey === null) {
      throw new Error("Could not find survey model");
    }

    return survey.graph.id;
  });
};

var rootGraphSelector = makeRootGraphSelector(); // defaultNodesSelector traverses the defaultEdge of each node passed to it,
// and returns an array of all nodes visited.

var defaultNodes = function defaultNodes(rootNode) {
  var nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!rootNode.defaultEdge) return [].concat(toConsumableArray(nodes), [rootNode]);
  var nextNode = rootNode.defaultEdge.headNode;
  return defaultNodes(nextNode, [].concat(toConsumableArray(nodes), [rootNode]));
};

var defaultNodesSelector = lib_1$2(orm, defaultNodes); // nodeContentSelector maps a node to the kind of content the node represents.

var nodeContent = function nodeContent(node) {
  switch (node.contentType) {
    case "Page":
      if (node.page !== null) return {
        contentType: "Page",
        id: node.page.id,
        node: node.id
      };
      throw new Error("Node with id " + node.id + " has contentType Page, but its page is null.");

    case "Section":
      if (node.section !== null) return {
        contentType: "Section",
        id: node.section.id,
        node: node.id
      };
      throw new Error("Node with id " + node.id + " has contentType Section, but its section is null.");

    case "Group":
      if (node.group !== null) return {
        contentType: "Group",
        id: node.group.id,
        node: node.id
      };
      throw new Error("Node with id " + node.id + " has contentType Group, but its group is null.");

    default:
      throw new Error("Node with id " + node.id + " has unknown contentType " + node.contentType + ".");
  }
};

var nodeContentSelector = lib_1$2(orm, nodeContent);

var nodesToContent = function nodesToContent(nodes) {
  return nodes.map(nodeContent);
};

var makeGraphContentSelector = function makeGraphContentSelector() {
  return lib_1$2(orm, selectOrm, selectId, function (session, graphId) {
    var graphRootNode = rootNode(session, graphId);
    if (!graphRootNode) return [];
    var graphNodes = defaultNodes(graphRootNode);
    return nodesToContent(graphNodes);
  });
};

var graphContentSelector = makeGraphContentSelector();

var makeChildGraphSelector = function makeChildGraphSelector() {
  return lib_1$2(orm, selectOrm, selectId, function (session, nodeId) {
    return session.DagNode.withId(nodeId).childGraph.ref;
  });
};

var contentTitle = function contentTitle(session, c) {
  switch (c.contentType) {
    case "Page":
      {
        var page = session.Page.withId(c.id);
        return page.content ? "P" + page.sequence + ": " + page.content : "P" + page.sequence;
      }

    case "Section":
      {
        var section = session.Section.withId(c.id);
        return section.ref.content;
      }

    case "Group":
      {
        var group = session.Group.withId(c.id);
        return group.content;
      }

    default:
      throw new Error();
  }
};

var makeGraphContentOptionSelector = function makeGraphContentOptionSelector() {
  return lib_1$2(orm, selectOrm, graphContentSelector, function (session, contents) {
    var base = [{
      label: "Beginning of survey",
      value: ""
    }];
    return base.concat(contents.map(function (c) {
      return {
        label: contentTitle(session, c),
        value: c.node + "-" + c.contentType,
        node: c.node
      };
    }));
  });
};

var graphContentOptionSelector = makeGraphContentOptionSelector(); // rootNodeSelector searches a graph's nodes for a node that has no incoming edges.
// Returns undefined if the graph is empty.

var rootNode = function rootNode(session, id) {
  var DagGraph = session.DagGraph;
  var graph = DagGraph.withId(id);
  var nodes = graph.nodes.toModelArray();
  if (nodes.length === 0) return undefined;
  var rootNodes = nodes.filter(function (n) {
    return n.incomingEdges.count() === 0;
  });

  if (rootNodes.length > 1) {
    throw new Error("Multiple root nodes found in root-node selector. Make sure every graph model has an entry point of exactly one node with 0 incoming edges.");
  }

  if (rootNodes.length < 1) {
    throw new Error("No root node found in root node selector. Make sure every graph model has an entry point of exactly one node with 0 incoming edges.");
  }

  return rootNodes[0];
};

var rootNodeSelector = lib_1$2(orm, rootNode);
var previousNodesSelector = lib_1$2(orm, selectOrm, selectId, function (session, id) {
  var node = session.DagNode.withId(id);
  return getPreviousNodes(node);
});

var selectId$1 = function selectId(state, id) {
  return id;
};

var makePageByIdSelector = function makePageByIdSelector() {
  return lib_1$2(orm, selectOrm, selectId$1, function (session, id) {
    return session.Page.withId(id).ref;
  });
};

var pageByIdSelector = makePageByIdSelector();

var makePageQuestionsSelector = function makePageQuestionsSelector() {
  return lib_1$2(orm, selectOrm, selectId$1, function (session, id) {
    var pageModel = session.Page.withId(id);
    return pageModel.questions.orderBy("sequence").toRefArray();
  });
};

var makePageQuestionIdsSelector = function makePageQuestionIdsSelector() {
  var getQuestions = makePageQuestionsSelector();
  return createArraysEqualSelector(getQuestions, function (questions) {
    return questions.map(function (q) {
      return q.id;
    });
  });
};

var pageByQuestionIdSelector = lib_1$2(orm, selectOrm, selectId$1, function (session, id) {
  return session.Question.withId(id).page.ref;
});
var pageExistsSelector = lib_1$2(orm, selectOrm, selectId$1, function (session, id) {
  return session.Page.hasId(id);
});

var getRoot = function getRoot(session, graph) {
  var rootArray = graph.nodes.filter(function (n) {
    var model = session.DagNode.withId(n.id);
    return model.incomingEdges.count() === 0;
  }).toModelArray();
  if (rootArray.length === 0) return undefined;
  return rootArray[0];
};

var getLastNode = function getLastNode(session, rootNode) {
  if (rootNode === undefined) return undefined;

  if (rootNode.childGraph) {
    var nextRoot = getRoot(session, rootNode.childGraph);
    return getLastNode(session, nextRoot);
  }

  if (!rootNode.defaultEdge) return rootNode;
  return getLastNode(session, rootNode.defaultEdge.headNode);
};

var lastNodeSelector = lib_1$2(orm, selectOrm, selectId$1, function (session, graphId) {
  var graph = session.DagGraph.withId(graphId);
  var root = getRoot(session, graph);
  var result = getLastNode(session, root);
  return result;
});
var lastPageSelector = lib_1$2(orm, selectOrm, lastNodeSelector, function (session, node) {
  if (node === undefined) return undefined;
  if (!node.page) throw new Error();
  return node.page.ref;
});
var skipLogicTargetsSelector = lib_1$2(orm, selectOrm, selectId$1, previousNodesSelector, function (session, id, previousNodes) {
  var node = session.DagNode.withId(id);
  var graphNodes = node.parentGraph.nodes;
  var previousNodeIds = previousNodes.map(function (n) {
    return n.id;
  });
  return graphNodes.toModelArray().filter(function (model) {
    return !previousNodeIds.includes(model.id) && model.page !== null && model.id !== node.id;
  }).map(function (n) {
    var page = n.page;
    return {
      id: page.id,
      sequence: page.sequence
    };
  });
});

var selectId$2 = function selectId(state, id) {
  return id;
};

var makeSectionSelector = function makeSectionSelector() {
  return lib_1$2(orm, selectOrm, selectId$2, function (session, id) {
    return session.Section.withId(id).ref;
  });
};

var sectionSelector = makeSectionSelector();
var allSectionsSelector = lib_1$2(orm, selectOrm, function (session) {
  return session.Section.all().toRefArray();
});

var makeSectionsWithoutIdSelector = function makeSectionsWithoutIdSelector() {
  return lib_1$2(orm, selectOrm, selectId$2, allSectionsSelector, function (session, id, sections) {
    return sections.filter(function (s) {
      return s.id !== id;
    });
  });
};

var makeSectionMergeOptionsSelector = function makeSectionMergeOptionsSelector() {
  var getOtherSections = makeSectionsWithoutIdSelector();
  return lib_1$2(orm, selectOrm, getOtherSections, function (session, sections) {
    return sections.reduce(function (acc, section) {
      var start = {
        label: "Start of " + section.content,
        value: section.id + "-start",
        id: section.id,
        start: true
      };
      var end = {
        label: "End of " + section.content,
        value: section.id + "-end",
        id: section.id,
        start: false
      };
      return [].concat(toConsumableArray(acc), [start, end]);
    }, []);
  });
};

var makeSectionPagesSelector = function makeSectionPagesSelector() {
  var getContents = makeGraphContentSelector();
  return lib_1$2(orm, selectOrm, getContents, function (session, contents) {
    return contents.map(function (p) {
      return {
        id: p.id,
        node: p.node
      };
    });
  });
};

var questionsFromNode = function questionsFromNode(node) {
  switch (node.contentType) {
    case "Page":
      // $FlowFixMe (need some way to type node class)
      return node.page.questions.toRefArray();

    case "Section":
    case "Group":
      // $FlowFixMe
      var childNodes = node.childGraph.nodes.toModelArray();
      return childNodes.reduce(function (list, node) {
        return [].concat(toConsumableArray(list), toConsumableArray(questionsFromNode(node)));
      }, []);

    default:
      throw new Error("Node with id " + node.id + " has unrecognized contentType " + node.contentType);
  }
};

var selectId$3 = function selectId(state, id) {
  return id;
};

var makeQuestionByIdSelector = function makeQuestionByIdSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    return session.Question.withId(id).ref;
  });
};

var makeQuestionTypeModelSelector = function makeQuestionTypeModelSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    return session.Question.withId(id).typeModel.ref;
  });
};

var makeGetRowsFromType = function makeGetRowsFromType() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);

    if (model.typeModel.rows) {
      var typeModel = model.typeModel;
      return typeModel.rows.orderBy("sequence").toRefArray();
    }

    throw new Error("No typeModel with rows for question with id " + id);
  });
};

var makeGetColumnsFromType = function makeGetColumnsFromType() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);

    if (model.typeModel.columns) {
      var typeModel = model.typeModel;
      return typeModel.columns.orderBy("sequence").toRefArray();
    }

    throw new Error("No typeModel with columns for question with id " + id);
  });
};

var makeRowCountSelector = function makeRowCountSelector() {
  var getRows = makeGetRowsFromType();
  return createArraysEqualSelector(getRows, function (rows) {
    return rows.length;
  });
};

var makeRowsWithContentSelector = function makeRowsWithContentSelector() {
  var getRows = makeGetRowsFromType();
  return createArraysEqualSelector(getRows, function (rows) {
    return {
      rows: rows.map(function (r) {
        return r.id;
      }),
      rowContents: rows.map(function (r) {
        return r.content;
      })
    };
  });
};

var makeContentRowsSelector = function makeContentRowsSelector() {
  var getRows = makeGetRowsFromType();
  return createArraysEqualSelector(getRows, function (rows) {
    return rows.map(function (r) {
      return {
        id: r.id,
        content: r.content
      };
    });
  });
};

var makeContentColumnsSelector = function makeContentColumnsSelector() {
  var getColumns = makeGetColumnsFromType();
  return createArraysEqualSelector(getColumns, function (columns) {
    return columns.map(function (c) {
      return {
        id: c.id,
        content: c.content
      };
    });
  });
};

var makeDiscreteColumnsSelector = function makeDiscreteColumnsSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);

    var columns = function () {
      if (model.singleSelectGrid) return model.singleSelectGrid.columns;
      if (model.multipleSelectGrid) return model.multipleSelectGrid.columns;
      return null;
    }();

    if (columns === null) {
      throw new Error("No associated model with columns for question with id " + id);
    }

    var refs = columns.toRefArray();
    return {
      columns: refs.map(function (c) {
        return c.id;
      }),
      columnContents: refs.map(function (c) {
        return c.content;
      })
    };
  });
};

var makeRatingSelector = function makeRatingSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);

    var rating = function () {
      if (model.rating) return model.rating.ref;
      if (model.multipleRating) return model.multipleRating.ref;
    }();

    if (!rating) throw new Error("No associated Rating model for question with id " + id);
    return _extends$c({}, rating, {
      multiple: !!model.multipleRating
    });
  });
};

var makeTextSelector = function makeTextSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);
    if (model.shortText) return model.shortText.ref;
    if (model.longText) return model.longText.ref;
    throw new Error("No associated Text model for question with id " + id);
  });
};

var makeNumericSelector = function makeNumericSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);
    if (model.numeric) return model.numeric.ref;
    if (model.slider) return model.slider.ref;
    throw new Error("No associated numeric model for question with id " + id);
  });
};

var makeSliderSelector = function makeSliderSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);

    var typeModel = function () {
      if (model.slider) return model.slider.ref;
      if (model.multipleSlider) return model.multipleSlider.ref;
      throw new Error("No associated slider model for question with id " + id);
    }();

    return _extends$c({}, typeModel, {
      multiple: !!model.multipleSlider
    });
  });
};

var makeRowModelSelector = function makeRowModelSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id).typeModel;

    if (model.rows) {
      // $FlowFixMe (refinement issue)
      var _model$getClass = model.getClass(),
          _maxRows = _model$getClass.maxRows,
          _allowRowImages = _model$getClass.allowRowImages;

      return _extends$c({
        maxRows: _maxRows,
        allowRowImages: _allowRowImages
      }, model.ref);
    }

    throw new Error("No question type model with rows for question with id " + id);
  });
};

var makeColumnModelSelector = function makeColumnModelSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);

    if (model.typeModel.columns) {
      // $FlowFixMe (need a better type refinement here)
      var _model$typeModel$getC = model.typeModel.getClass(),
          _maxColumns = _model$typeModel$getC.maxColumns,
          _allowColumnImages = _model$typeModel$getC.allowColumnImages;

      return _extends$c({
        maxColumns: _maxColumns,
        allowColumnImages: _allowColumnImages
      }, model.typeModel.ref);
    }

    throw new Error();
  });
};

var makeMultipleSelectSelector = function makeMultipleSelectSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);
    if (model.multipleSelect) return model.multipleSelect.ref;
    throw new Error("No associated Multiple Select model for question with id " + id);
  });
};

var makeSumSelector = function makeSumSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var model = session.Question.withId(id);
    if (model.sum) return model.sum.ref;
    throw new Error("No associated Sum model for question with id " + id);
  });
};

var makeQuestionOutlineSelector = function makeQuestionOutlineSelector() {
  var modelSelector = makeQuestionByIdSelector();
  return createSelector(modelSelector, function (ref) {
    return {
      type: ref.type,
      sequence: ref.sequence,
      content: ref.content
    };
  });
};

var makeGridContentSelector = function makeGridContentSelector() {
  var getRows = makeContentRowsSelector();
  var getColumns = makeContentColumnsSelector();
  return createArraysEqualSelector(getRows, getColumns, function (rows, columns) {
    return {
      rows: rows,
      columns: columns
    };
  });
};

var makeQuestionPageCountSelector = function makeQuestionPageCountSelector() {
  return lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
    var question = session.Question.withId(id);
    return question.page.questions.count();
  });
};

var questionExistsSelector = lib_1$2(orm, selectOrm, selectId$3, function (session, id) {
  return session.Question.hasId(id);
});

var makeAllQuestionsSelector = function makeAllQuestionsSelector() {
  return lib_1$2(orm, selectOrm, function (session, id) {
    return session.Question.all().orderBy("sequence").toRefArray();
  });
};

var allQuestionsSelector = makeAllQuestionsSelector();

var makeQuestionOptionsSelector = function makeQuestionOptionsSelector() {
  var getAllQuestions = makeAllQuestionsSelector();
  return lib_1$2(orm, selectOrm, getAllQuestions, function (session, questions) {
    return questions.map(function (q) {
      var page = session.Page.withId(q.page).ref;
      return {
        value: q.id,
        label: "Q" + q.sequence + " / P" + page.sequence,
        pageId: page.id
      };
    });
  });
};

var pastQuestionsSelector = lib_1$2(orm, selectOrm, selectId$3, previousNodesSelector, function (session, id, previousNodes) {
  var questions = previousNodes.filter(function (n) {
    return n.contentType === "Page";
  }).reduce(function (list, node) {
    return [].concat(toConsumableArray(list), toConsumableArray(questionsFromNode(node)));
  }, []);
  return sortBy_1(questions, ["sequence"]);
});
var pipeQuestionsSelector = lib_1$2(orm, selectOrm, selectId$3, pastQuestionsSelector, function (session, id, questions) {
  return questions.filter(function (q) {
    return questionConfigs[q.type].piping;
  });
});

var getPipeValue = function getPipeValue(id, selected) {
  return selected ? id + "_selected" : id + "_unselected";
};

var optionsFromPipeQuestion = function optionsFromPipeQuestion(question) {
  var id = question.id,
      sequence = question.sequence,
      content = question.content;
  var selected = {
    id: id,
    value: getPipeValue(id, true),
    label: "Selected from Q" + sequence + ": " + content,
    selected: true
  };
  var unselected = {
    id: id,
    value: getPipeValue(id, false),
    label: "Unselected from Q" + sequence + ": " + content,
    selected: false
  };
  return [selected, unselected];
};

var pipeOptionsSelector = createArraysEqualSelector(pipeQuestionsSelector, function (questions) {
  return questions.reduce(function (acc, q) {
    return acc.concat(optionsFromPipeQuestion(q));
  }, []);
});
var displayLogicQuestionsSelector = createArraysEqualSelector(pastQuestionsSelector, function (questions) {
  var filteredQuestions = questions.filter(function (q) {
    return questionConfigs[q.type].conditionOperators;
  });
  return filteredQuestions.map(function (q) {
    return {
      id: q.id,
      content: q.content,
      sequence: q.sequence
    };
  });
});
var skipLogicQuestionsSelector = lib_1$2(orm, selectOrm, selectId$3, displayLogicQuestionsSelector, function (session, id, questions) {
  var _session$DagNode$with = session.DagNode.withId(id),
      page = _session$DagNode$with.page;

  if (page === null) throw new Error();
  var filteredQuestions = page.questions.toRefArray().filter(function (q) {
    return questionConfigs[q.type].conditionOperators;
  });
  var pageQuestions = filteredQuestions.map(function (q) {
    return {
      id: q.id,
      content: q.content,
      sequence: q.sequence
    };
  });
  return questions.concat(pageQuestions);
});

var selectId$4 = function selectId(state, id) {
  return id;
};

var makeAnswerContentSelector = function makeAnswerContentSelector() {
  return lib_1$2(orm, selectOrm, selectId$4, function (session, id) {
    return session.AnswerContent.withId(id).ref;
  });
};

var answersByConditionSelector = lib_1$2(orm, selectOrm, selectId$4, function (session, id) {
  var condition = session.LogicCondition.withId(id);
  var typeModel = condition.question.typeModel;
  if (!typeModel.rows) throw new Error("No typeModel with rows found for question with id " + id);
  var rows = typeModel.rows.orderBy("sequence").toRefArray();
  var specialOptions = typeModel.specialOptions ? typeModel.specialOptions.toRefArray() : [];
  return {
    rows: rows,
    specialOptions: specialOptions
  };
});
var rowsSelector = lib_1$2(orm, selectOrm, selectId$4, function (session, id) {
  return session.Question.withId(id).rows.orderBy("sequence").toRefArray();
});
var rowsIdSelector = createArraysEqualSelector(rowsSelector, function (rows) {
  return rows.map(function (r) {
    return r.id;
  });
});
var rowsContentSelector = createArraysEqualSelector(rowsSelector, function (rows) {
  return rows.map(function (r) {
    return r.content;
  });
});
var columnsSelector = lib_1$2(orm, selectOrm, selectId$4, function (session, id) {
  return session.Question.withId(id).columns.orderBy("sequence").toRefArray();
});
var columnsIdSelector = createArraysEqualSelector(columnsSelector, function (columns) {
  return columns.map(function (c) {
    return c.id;
  });
});
var columnsContentSelector = createArraysEqualSelector(columnsSelector, function (columns) {
  return columns.map(function (c) {
    return c.content;
  });
});

var selectId$5 = function selectId(state, id) {
  return id;
};

var makeSkipLogicSelector = function makeSkipLogicSelector() {
  return lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
    if (!session.Page.hasId(id)) return [];

    var _session$Page$withId = session.Page.withId(id),
        skipLogicBranches = _session$Page$withId.skipLogicBranches;

    return skipLogicBranches.toRefArray().map(function (b) {
      return b.id;
    });
  });
};

var makeDisplayLogicSelector = function makeDisplayLogicSelector() {
  return lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
    if (!session.Page.hasId(id)) return undefined;
    var logicBranch = session.Page.withId(id).displayLogicBranch;
    if (logicBranch === undefined) return undefined;
    return logicBranch.id;
  });
};

var conditionAnswerSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
  return session.LogicCondition.withId(id).answer.toRefArray();
});
var questionByConditionIdSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
  return session.LogicCondition.withId(id).question.ref;
});

var makeConditionByIdSelector = function makeConditionByIdSelector() {
  return lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
    return session.LogicCondition.withId(id).ref;
  });
};

var conditionByIdSelector = makeConditionByIdSelector();
var logicBranchTargetSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
  return session.LogicBranch.withId(id).target;
});
var logicBranchByIdSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
  return session.LogicBranch.withId(id).ref;
});
var conditionsByBranchSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
  return session.LogicBranch.withId(id).conditions.orderBy("sequence").toRefArray().map(function (c) {
    return c.id;
  });
});
var displayLogicSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, pageId) {
  var model = session.Page.withId(pageId).displayLogicBranch;
  if (model === undefined) return undefined;
  return model.ref;
});
var skipLogicSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, pageId) {
  if (!session.Page.hasId(pageId)) return [];

  var _session$Page$withId2 = session.Page.withId(pageId),
      skipLogicBranches = _session$Page$withId2.skipLogicBranches;

  return skipLogicBranches.toRefArray();
});
var skipLogicIdSelector = lib_1$2(orm, selectOrm, skipLogicSelector, function (session, branches) {
  return branches.map(function (b) {
    return b.id;
  });
});
var logicConditionSelector = lib_1$2(orm, selectOrm, selectId$5, function (session, id) {
  var conditionModel = session.LogicCondition.withId(id);
  var question = conditionModel.question,
      operator = conditionModel.operator,
      value = conditionModel.value,
      gate = conditionModel.gate,
      specialOptionValue = conditionModel.specialOptionValue;
  var specialOptionValueId = specialOptionValue === undefined ? undefined : specialOptionValue.id;
  return {
    question: question.id,
    questionType: question.type,
    answer: conditionModel.answer.toModelArray().map(function (a) {
      return a.id;
    }),
    value: value,
    specialOptionValue: specialOptionValueId,
    operator: operator,
    gate: gate
  };
});

var selectId$6 = function selectId(state, id) {
  return id;
};

var nodeByPageIdSelector = lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
  return session.Page.withId(id).node.ref;
});

var makePipeByIdSelector = function makePipeByIdSelector() {
  return lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
    return session.Pipe.withId(id).ref;
  });
};

var pipeByIdSelector = makePipeByIdSelector();
var pipeByEndQuestionIdSelector = lib_1$2(orm, selectOrm, selectId$6, function (session, endQuestion) {
  var question = session.Question.withId(endQuestion);
  var pipe = question.providerPipe;
  if (pipe === null) return null;
  return {
    selected: pipe.selected,
    sourceQuestion: pipe.sourceQuestion,
    endQuestion: pipe.endQuestion
  };
});
var specialOptionSelector = lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
  return session.SpecialOption.withId(id).ref;
});
var specialOptionsByQuestionIdSelector = lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
  var _session$Question$wit = session.Question.withId(id),
      typeModel = _session$Question$wit.typeModel;

  if (typeModel.specialOptions) {
    var model = typeModel;
    var options = model.specialOptions.toRefArray();
    var other = options.find(function (o) {
      return o.type === "other";
    });
    var none = options.find(function (o) {
      return o.type === "none";
    });
    return {
      other: other ? other.id : undefined,
      none: none ? none.id : undefined
    };
  }

  throw new Error("No type model with special options for question with id " + id);
});
var autosaveSelector = lib_1$2(orm, selectOrm, function (session) {
  return session.Autosave.first().ref;
});

var modalSelector = function modalSelector(state) {
  return state.ui.modal;
};

var makeGroupSelector = function makeGroupSelector() {
  return lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
    return session.Group.withId(id).ref;
  });
};

var groupSelector = makeGroupSelector();

var makeGroupGraphSelector = function makeGroupGraphSelector() {
  return lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
    return session.Group.withId(id).node.childGraph.ref;
  });
};

var makeGroupSectionIdSelector = function makeGroupSectionIdSelector() {
  return lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
    return session.Group.withId(id).node.childGraph.nodes.toModelArray().map(function (n) {
      return n.section.id;
    });
  });
};

var devToolsSelector = lib_1$2(orm, selectOrm, selectId$6, function (session, graphId) {
  var graph = session.DagGraph.withId(graphId);
  var nodes = graph.nodes.toModelArray();
  var edges = graph.edges.toModelArray();
  return {
    nodes: nodes,
    edges: edges
  };
});
var questionByIdSelector = lib_1$2(orm, selectOrm, selectId$6, function (session, id) {
  return session.Question.withId(id).ref;
});
var surveySelector = lib_1$2(orm, selectOrm, function (session) {
  var model = session.Survey.first();
  if (!model) throw new Error("Survey instance missing");
  return model.ref;
});
var outlineHeaderSelector = createSelector(selectOrm, uiSelector, function (orm$$1, ui) {
  var outlineHeader = ui.outlineHeader;
  var sectionId = outlineHeader.section,
      groupId = outlineHeader.group;
  var section = sectionId === null ? null : orm$$1.Section.itemsById[sectionId].content;
  var group = groupId === null ? null : {
    content: orm$$1.Group.itemsById[groupId].content,
    color: orm$$1.Group.itemsById[groupId].color
  };
  return {
    section: section,
    group: group
  };
});

var toggleExpandQuestions = function toggleExpandQuestions() {
  return {
    type: interfaceTypes.INTERFACE_TOGGLE_EXPAND_QUESTIONS
  };
};

var toggleOutlineOverlay = function toggleOutlineOverlay() {
  return {
    type: interfaceTypes.INTERFACE_TOGGLE_OUTLINE_OVERLAY
  };
};

var setOutlineHeader = function setOutlineHeader(payload) {
  return {
    type: interfaceTypes.INTERFACE_SET_OUTLINE_HEADER,
    payload: payload
  };
};

var setError = function setError(payload) {
  return {
    type: interfaceTypes.INTERFACE_SET_ERROR,
    payload: payload
  };
};

var toggleTemplate = function toggleTemplate() {
  return {
    type: interfaceTypes.INTERFACE_TOGGLE_TEMPLATE
  };
};

var requestSave = function requestSave() {
  return {
    type: autosaveTypes.AUTOSAVE_REQUEST
  };
};

var autosaveSuccess = function autosaveSuccess() {
  return {
    type: autosaveTypes.AUTOSAVE_SUCCESS,
    payload: Date.now()
  };
};

var autosaveError = function autosaveError(error) {
  return {
    type: autosaveTypes.AUTOSAVE_ERROR,
    error: error
  };
};

var mapStateToProps = function mapStateToProps(state) {
  var _uiSelector = uiSelector(state),
      error = _uiSelector.error;

  return {
    error: error
  };
};

var AppErrorBoundaryContainer = connect(mapStateToProps, {
  setError: setError
})(AppErrorBoundary);

var _templateObject$1 = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmin-height: 55px;\n\tpadding: 0 3.5em;\n\tfont-size: 14px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmin-height: 55px;\n\tpadding: 0 3.5em;\n\tfont-size: 14px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n"]),
    _templateObject2$1 = taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tcolor: ", ";\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tbackground-color: ", ";\n\tcolor: ", ";\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"]),
    _templateObject3 = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tcolor: ", ";\n\tfont-weight: 600;\n\ttext-decoration: underline;\n\ttext-underline-position: under;\n\tcursor: pointer;\n\tmargin-right: 1em;\n"], ["\n\tfont-size: 12px;\n\tcolor: ", ";\n\tfont-weight: 600;\n\ttext-decoration: underline;\n\ttext-underline-position: under;\n\tcursor: pointer;\n\tmargin-right: 1em;\n"]);

var StyledBar = styled.div(_templateObject$1, function (props) {
  return props.theme.primary["2"];
}, function (props) {
  return props.theme.neutralLight["7"];
});
var StyledButton = styled(Button)(_templateObject2$1, function (props) {
  return props.theme.neutralLight["7"];
}, function (props) {
  return props.theme.primary["2"];
}, function (props) {
  return props.theme.neutralLight["6"];
});
var Cancel = styled.a(_templateObject3, function (props) {
  return props.theme.neutralLight["7"];
});

var TemplateBar = function TemplateBar(_ref) {
  var onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm;
  return React.createElement(StyledBar, null, React.createElement("div", null, "Would you like to use this template?"), React.createElement("div", null, React.createElement(Cancel, {
    onClick: onCancel
  }, "Cancel"), React.createElement(StyledButton, {
    onClick: onConfirm
  }, "Use")));
};

var lib$5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  exports.parseActions = parseActions;
  exports.default = undoable;
  exports.distinctState = distinctState;
  exports.includeAction = includeAction;
  exports.ifAction = ifAction;
  exports.excludeAction = excludeAction;

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  } // debug output


  var __DEBUG__ = undefined;

  function debug() {
    if (__DEBUG__) {
      var _console;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!console.group) {
        args.unshift('%credux-undo', 'font-style: italic');
      }

      (_console = console).log.apply(_console, args);
    }
  }

  function debugStart(action, state) {
    if (__DEBUG__) {
      var args = ['action', action.type];

      if (console.group) {
        var _console2;

        args.unshift('%credux-undo', 'font-style: italic');

        (_console2 = console).groupCollapsed.apply(_console2, args);

        console.log('received', {
          state: state,
          action: action
        });
      } else {
        debug.apply(undefined, args);
      }
    }
  }

  function debugEnd() {
    if (__DEBUG__) {
      return console.groupEnd && console.groupEnd();
    }
  } // /debug output
  // action types


  var ActionTypes = exports.ActionTypes = {
    UNDO: '@@redux-undo/UNDO',
    REDO: '@@redux-undo/REDO',
    JUMP_TO_FUTURE: '@@redux-undo/JUMP_TO_FUTURE',
    JUMP_TO_PAST: '@@redux-undo/JUMP_TO_PAST'
  }; // /action types
  // action creators to change the state

  var ActionCreators = exports.ActionCreators = {
    undo: function undo() {
      return {
        type: ActionTypes.UNDO
      };
    },
    redo: function redo() {
      return {
        type: ActionTypes.REDO
      };
    },
    jumpToFuture: function jumpToFuture(index) {
      return {
        type: ActionTypes.JUMP_TO_FUTURE,
        index: index
      };
    },
    jumpToPast: function jumpToPast(index) {
      return {
        type: ActionTypes.JUMP_TO_PAST,
        index: index
      };
    }
  }; // /action creators
  // length: get length of history

  function length(history) {
    var past = history.past;
    var future = history.future;
    return past.length + 1 + future.length;
  } // /length
  // insert: insert `state` into history, which means adding the current state
  //         into `past`, setting the new `state` as `present` and erasing
  //         the `future`.


  function insert(history, state, limit) {
    debug('insert', {
      state: state,
      history: history,
      free: limit - length(history)
    });
    var past = history.past;
    var present = history.present;
    var historyOverflow = limit && length(history) >= limit;

    if (present === undefined) {
      // init history
      return {
        past: [],
        present: state,
        future: []
      };
    }

    return {
      past: [].concat(_toConsumableArray(past.slice(historyOverflow ? 1 : 0)), [present]),
      present: state,
      future: []
    };
  } // /insert
  // undo: go back to the previous point in history


  function undo(history) {
    debug('undo', {
      history: history
    });
    var past = history.past;
    var present = history.present;
    var future = history.future;
    if (past.length <= 0) return history;
    return {
      past: past.slice(0, past.length - 1),
      // remove last element from past
      present: past[past.length - 1],
      // set element as new present
      future: [present].concat(_toConsumableArray(future))
    };
  } // /undo
  // redo: go to the next point in history


  function redo(history) {
    debug('redo', {
      history: history
    });
    var past = history.past;
    var present = history.present;
    var future = history.future;
    if (future.length <= 0) return history;
    return {
      future: future.slice(1, future.length),
      // remove element from future
      present: future[0],
      // set element as new present
      past: [].concat(_toConsumableArray(past), [present // old present state is in the past now
      ])
    };
  } // /redo
  // jumpToFuture: jump to requested index in future history


  function jumpToFuture(history, index) {
    if (index === 0) return redo(history);
    var past = history.past;
    var present = history.present;
    var future = history.future;
    return {
      future: future.slice(index + 1),
      present: future[index],
      past: past.concat([present]).concat(future.slice(0, index))
    };
  } // /jumpToFuture
  // jumpToPast: jump to requested index in past history


  function jumpToPast(history, index) {
    if (index === history.past.length - 1) return undo(history);
    var past = history.past;
    var present = history.present;
    var future = history.future;
    return {
      future: past.slice(index + 1).concat([present]).concat(future),
      present: past[index],
      past: past.slice(0, index)
    };
  } // /jumpToPast
  // wrapState: for backwards compatibility to 0.4


  function wrapState(state) {
    return _extends({}, state, {
      history: state
    });
  } // /wrapState
  // updateState


  function updateState(state, history) {
    return wrapState(_extends({}, state, history));
  } // /updateState
  // createHistory


  function createHistory(state) {
    return {
      past: [],
      present: state,
      future: []
    };
  } // /createHistory
  // parseActions


  function parseActions(rawActions) {
    var defaultValue = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

    if (Array.isArray(rawActions)) {
      return rawActions;
    } else if (typeof rawActions === 'string') {
      return [rawActions];
    }

    return defaultValue;
  } // /parseActions
  // redux-undo higher order reducer


  function undoable(reducer) {
    var rawConfig = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    __DEBUG__ = rawConfig.debug;
    var config = {
      initialState: rawConfig.initialState,
      initTypes: parseActions(rawConfig.initTypes, ['@@redux/INIT', '@@INIT']),
      limit: rawConfig.limit,
      filter: rawConfig.filter || function () {
        return true;
      },
      undoType: rawConfig.undoType || ActionTypes.UNDO,
      redoType: rawConfig.redoType || ActionTypes.REDO,
      jumpToPastType: rawConfig.jumpToPastType || ActionTypes.JUMP_TO_PAST,
      jumpToFutureType: rawConfig.jumpToFutureType || ActionTypes.JUMP_TO_FUTURE
    };
    config.history = rawConfig.initialHistory || createHistory(config.initialState);

    if (config.initTypes.length === 0) {
      console.warn('redux-undo: supply at least one action type in initTypes to ensure initial state');
    }

    return function (state, action) {
      debugStart(action, state);
      var res = undefined;

      switch (action.type) {
        case config.undoType:
          res = undo(state);
          debug('after undo', res);
          debugEnd();
          return res ? updateState(state, res) : state;

        case config.redoType:
          res = redo(state);
          debug('after redo', res);
          debugEnd();
          return res ? updateState(state, res) : state;

        case config.jumpToPastType:
          res = jumpToPast(state, action.index);
          debug('after jumpToPast', res);
          debugEnd();
          return res ? updateState(state, res) : state;

        case config.jumpToFutureType:
          res = jumpToFuture(state, action.index);
          debug('after jumpToFuture', res);
          debugEnd();
          return res ? updateState(state, res) : state;

        default:
          res = reducer(state && state.present, action);

          if (config.initTypes.some(function (actionType) {
            return actionType === action.type;
          })) {
            debug('reset history due to init action');
            debugEnd();
            return wrapState(_extends({}, state, createHistory(res)));
          }

          if (config.filter && typeof config.filter === 'function') {
            if (!config.filter(action, res, state && state.present)) {
              debug('filter prevented action, not storing it');
              debugEnd();
              return wrapState(_extends({}, state, {
                present: res
              }));
            }
          }

          var history = state && state.present !== undefined ? state : config.history;
          var updatedHistory = insert(history, res, config.limit);
          debug('after insert', {
            history: updatedHistory,
            free: config.limit - length(updatedHistory)
          });
          debugEnd();
          return wrapState(_extends({}, state, updatedHistory));
      }
    };
  } // /redux-undo
  // distinctState helper


  function distinctState() {
    return function (action, currentState, previousState) {
      return currentState !== previousState;
    };
  } // /distinctState
  // includeAction helper


  function includeAction(rawActions) {
    var actions = parseActions(rawActions);
    return function (action) {
      return actions.indexOf(action.type) >= 0;
    };
  } // /includeAction
  // deprecated ifAction helper


  function ifAction(rawActions) {
    console.error('Deprecation Warning: Please change `ifAction` to `includeAction`');
    return includeAction(rawActions);
  } // /ifAction
  // excludeAction helper


  function excludeAction() {
    var rawActions = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
    var actions = parseActions(rawActions);
    return function (action) {
      return actions.indexOf(action.type) < 0;
    };
  } // /excludeAction

});
var undoable = unwrapExports(lib$5);
var lib_1$4 = lib$5.groupByActionTypes;
var lib_2$3 = lib$5.parseActions;
var lib_3$3 = lib$5.distinctState;
var lib_4$3 = lib$5.includeAction;
var lib_5$1 = lib$5.ifAction;
var lib_6$1 = lib$5.excludeAction;
var lib_7$1 = lib$5.ActionTypes;
var lib_8$1 = lib$5.ActionCreators;

var _templateObject$2 = taggedTemplateLiteral(["\n  width: 32px;\n  padding-left: 0;\n  padding-right: 0;\n\n  &:focus {\n    box-shadow: ", ";\n  }\n  &:first-child {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-right: 0.2em;\n  }\n  &:last-child {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  svg {\n    height: 1.3em;\n    width: auto;\n    vertical-align: text-top;\n  }\n"], ["\n  width: 32px;\n  padding-left: 0;\n  padding-right: 0;\n\n  &:focus {\n    box-shadow: ", ";\n  }\n  &:first-child {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-right: 0.2em;\n  }\n  &:last-child {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  svg {\n    height: 1.3em;\n    width: auto;\n    vertical-align: text-top;\n  }\n"]);

var Undo = icons.Undo,
    Redo = icons.Redo;
var StyledButton$1 = styled(Button)(_templateObject$2, function (props) {
  return props.theme.focusShadowB;
});

var ActionHistory = function ActionHistory(_ref) {
  var undo = _ref.undo,
      redo = _ref.redo,
      pastEmpty = _ref.pastEmpty,
      futureEmpty = _ref.futureEmpty,
      disabled = _ref.disabled;
  return React.createElement("div", null, React.createElement(StyledButton$1, {
    onClick: undo,
    "aria-label": "Undo",
    disabled: pastEmpty || disabled,
    swatch: "neutralDark",
    "data-testid": "UNDO"
  }, React.createElement(Undo, {
    fill: "#e7e8eb"
  })), React.createElement(StyledButton$1, {
    onClick: redo,
    "aria-label": "Redo",
    disabled: futureEmpty || disabled,
    swatch: "neutralDark",
    "data-testid": "REDO"
  }, React.createElement(Redo, {
    fill: "#e7e8eb"
  })));
};

var mapStateToProps$1 = function mapStateToProps(state) {
  return {
    pastEmpty: state.orm.past.length === 0,
    futureEmpty: state.orm.future.length === 0
  };
};

var ActionHistory$1 = connect(mapStateToProps$1, {
  undo: lib_8$1.undo,
  redo: lib_8$1.redo
})(ActionHistory);

var _templateObject$3 = taggedTemplateLiteral(["\n\tmargin-right: 0.5em;\n"], ["\n\tmargin-right: 0.5em;\n"]),
    _templateObject2$2 = taggedTemplateLiteral(["\n\tfill: ", ";\n\theight: 1.3em;\n\twidth: auto;\n\tmargin-right: 0.5em;\n"], ["\n\tfill: ", ";\n\theight: 1.3em;\n\twidth: auto;\n\tmargin-right: 0.5em;\n"]),
    _templateObject3$1 = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\t> span {\n\t\tvertical-align: middle;\n\t}\n\t", " {\n\t\theight: 1.5em;\n\t\tvertical-align: middle;\n\t}\n"], ["\n\tfont-size: 12px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\t> span {\n\t\tvertical-align: middle;\n\t}\n\t", " {\n\t\theight: 1.5em;\n\t\tvertical-align: middle;\n\t}\n"]);

var Alert$1 = icons.Alert;
var StyledSpinner = styled(Spinner)(_templateObject$3);
var StyledAlert = styled(Alert$1)(_templateObject2$2, function (_ref) {
  var theme = _ref.theme;
  return theme.danger["2"];
});
var Wrapper$1 = styled.div(_templateObject3$1, Spinner);

var Autosave = function Autosave(_ref2) {
  var savePending = _ref2.savePending,
      saveError = _ref2.saveError,
      lastSave = _ref2.lastSave;

  if (savePending) {
    return React.createElement(Wrapper$1, null, React.createElement(StyledSpinner, null), React.createElement("span", null, "Saving..."));
  }

  if (saveError) {
    return React.createElement(Wrapper$1, null, React.createElement(StyledAlert, null), React.createElement("span", null, "There was an error saving your survey"));
  }

  if (lastSave !== undefined) {
    return React.createElement(Wrapper$1, null, "All changes saved");
  }

  return null;
};

var mapStateToProps$2 = function mapStateToProps(state) {
  var _uiSelector = uiSelector(state),
      savePending = _uiSelector.savePending,
      saveError = _uiSelector.saveError,
      lastSave = _uiSelector.lastSave;

  return {
    savePending: savePending,
    saveError: saveError,
    lastSave: lastSave
  };
};

var Autosave$1 = connect(mapStateToProps$2)(Autosave);

var _templateObject$4 = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\t> span {\n\t\tcolor: ", ";\n\t\tfont-size: 12px;\n\t\tmargin-right: 1em;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\t> span {\n\t\tcolor: ", ";\n\t\tfont-size: 12px;\n\t\tmargin-right: 1em;\n\t}\n"]);

var Wrapper$2 = styled.label(_templateObject$4, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralLight["7"];
});

var ExpandQuestions = function ExpandQuestions(_ref2) {
  var expandQuestions = _ref2.expandQuestions,
      toggleExpandQuestions = _ref2.toggleExpandQuestions,
      disabled = _ref2.disabled;
  return React.createElement(Wrapper$2, null, React.createElement("span", null, "Expand Questions"), React.createElement(Toggle, {
    disabled: disabled,
    checked: expandQuestions,
    onChange: toggleExpandQuestions
  }));
};

var mapStateToProps$3 = function mapStateToProps(state) {
  var _uiSelector = uiSelector(state),
      expandQuestions = _uiSelector.expandQuestions;

  return {
    expandQuestions: expandQuestions
  };
};

var ExpandQuestions$1 = connect(mapStateToProps$3, {
  toggleExpandQuestions: toggleExpandQuestions
})(ExpandQuestions);

var _templateObject$5 = taggedTemplateLiteral(["\n  display: flex;\n  font-family: ", ";\n  font-size: 15px;\n  color: ", ";\n  background-color: ", ";\n  min-height: 4.33em;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  font-family: ", ";\n  font-size: 15px;\n  color: ", ";\n  background-color: ", ";\n  min-height: 4.33em;\n  flex-shrink: 0;\n"]),
    _templateObject2$3 = taggedTemplateLiteral(["\n  flex-grow: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  min-width: 720px;\n  max-width: 1440px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  padding-left: 25px;\n  padding-right: 40px;\n"], ["\n  flex-grow: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  min-width: 720px;\n  max-width: 1440px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  padding-left: 25px;\n  padding-right: 40px;\n"]),
    _templateObject3$2 = taggedTemplateLiteral(["\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  > span {\n    margin-right: 1em;\n  }\n"], ["\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  > span {\n    margin-right: 1em;\n  }\n"]),
    _templateObject4 = taggedTemplateLiteral(["\n  display: flex;\n  > button {\n    width: 88px;\n    padding: 0;\n    &:focus {\n      box-shadow: ", ";\n    }\n  }\n  > :not(:last-child) {\n    margin-right: 1em;\n  }\n"], ["\n  display: flex;\n  > button {\n    width: 88px;\n    padding: 0;\n    &:focus {\n      box-shadow: ", ";\n    }\n  }\n  > :not(:last-child) {\n    margin-right: 1em;\n  }\n"]),
    _templateObject5 = taggedTemplateLiteral(["\n  color: ", ";\n"], ["\n  color: ", ";\n"]),
    _templateObject6 = taggedTemplateLiteral(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"]);

var StyledBar$1 = styled.div(_templateObject$5, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.neutralLight["1"];
}, function (props) {
  return props.theme.neutralDark["1"];
});
var StyledWrapper = styled.div(_templateObject2$3);
var TitleWrapper = styled.div(_templateObject3$2);

var ProjectTitle = function ProjectTitle(props) {
  return props.title !== undefined ? React.createElement("span", null, props.title) : null;
};

var ButtonsWrapper = styled.div(_templateObject4, function (props) {
  return props.theme.focusShadowB;
});
var StyledInputLine = styled(TextInputLine)(_templateObject5, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralLight["5"];
});
var StyledAnchor = styled.a(_templateObject6);

var Topbar = function Topbar(_ref2) {
  var projectTitle = _ref2.projectTitle,
      previewLink = _ref2.previewLink,
      hasError = _ref2.hasError,
      templateActive = _ref2.templateActive,
      toggleTemplate = _ref2.toggleTemplate,
      setSurveyTitle = _ref2.setSurveyTitle,
      title = _ref2.title,
      readOnly = _ref2.readOnly,
      exitLink = _ref2.exitLink;
  var templateBar = templateActive ? React.createElement(TemplateBar, {
    onCancel: toggleTemplate,
    onConfirm: toggleTemplate
  }) : null;
  var exitButton = exitLink ? React.createElement(StyledAnchor, {
    href: exitLink
  }, React.createElement(Button, {
    tabIndex: "-1",
    swatch: "neutralDark"
  }, "Exit")) : null;
  return React.createElement("div", null, React.createElement(StyledBar$1, null, React.createElement(StyledWrapper, null, React.createElement(TitleWrapper, null, React.createElement(ProjectTitle, {
    title: projectTitle
  }), React.createElement(StyledInputLine, {
    readOnly: readOnly,
    value: title,
    onChange: function onChange(e) {
      return setSurveyTitle(e.currentTarget.value);
    }
  }), React.createElement(Autosave$1, null)), React.createElement(ButtonsWrapper, null, React.createElement(ExpandQuestions$1, {
    disabled: hasError
  }), React.createElement(ActionHistory$1, {
    disabled: hasError
  }), React.createElement(StyledAnchor, {
    href: previewLink,
    disabled: hasError || !previewLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(Button, {
    tabIndex: "-1",
    disabled: hasError || !previewLink,
    swatch: "accent"
  }, "Preview")), exitButton))), templateBar);
};

var setSurveyTitle = function setSurveyTitle(payload) {
  return {
    type: surveyTypes.SURVEY_SET_TITLE,
    payload: payload
  };
};

var setSurveyHash = function setSurveyHash(payload) {
  return {
    type: surveyTypes.SURVEY_SET_HASH,
    payload: payload
  };
};

var setSurveyPreviewLink = function setSurveyPreviewLink(payload) {
  return {
    type: surveyTypes.SURVEY_SET_PREVIEW_LINK,
    payload: payload
  };
};

var mapStateToProps$4 = function mapStateToProps(state) {
  var _uiSelector = uiSelector(state),
      error = _uiSelector.error,
      templateActive = _uiSelector.templateActive,
      readOnly = _uiSelector.readOnly;

  var _surveySelector = surveySelector(state),
      title = _surveySelector.title,
      previewLink = _surveySelector.previewLink;

  return {
    hasError: !!error,
    templateActive: templateActive,
    previewLink: previewLink,
    title: title,
    readOnly: readOnly
  };
};

var TopbarContainer = connect(mapStateToProps$4, {
  toggleTemplate: toggleTemplate,
  setSurveyTitle: setSurveyTitle
})(Topbar);

var _templateObject$6 = taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\twidth: 100%;\n\ttop: 0;\n\tposition: absolute;\n\ttransform: translateX(0);\n\tz-index: 20;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\twidth: 100%;\n\ttop: 0;\n\tposition: absolute;\n\ttransform: translateX(0);\n\tz-index: 20;\n"]),
    _templateObject2$4 = taggedTemplateLiteral(["\n\tflex-shrink: 0;\n\tfont-size: 16px;\n\tpadding: 1.25em 30px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmin-height: 62px;\n\tbox-sizing: border-box;\n"], ["\n\tflex-shrink: 0;\n\tfont-size: 16px;\n\tpadding: 1.25em 30px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmin-height: 62px;\n\tbox-sizing: border-box;\n"]),
    _templateObject3$3 = taggedTemplateLiteral(["\n\toverflow: auto;\n\tbackground-color: ", ";\n\tflex-grow: 1;\n"], ["\n\toverflow: auto;\n\tbackground-color: ", ";\n\tflex-grow: 1;\n"]),
    _templateObject4$1 = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tmin-height: 66px;\n"], ["\n\tfont-size: 12px;\n\tmin-height: 66px;\n"]),
    _templateObject5$1 = taggedTemplateLiteral(["\n\tcolor: ", ";\n\tfont-size: 14px;\n\tpadding: 30px;\n\tborder-bottom: 2px solid ", ";\n"], ["\n\tcolor: ", ";\n\tfont-size: 14px;\n\tpadding: 30px;\n\tborder-bottom: 2px solid ", ";\n"]),
    _templateObject6$1 = taggedTemplateLiteral(["\n\tcolor: ", ";\n\tfont-weight: 600;\n"], ["\n\tcolor: ", ";\n\tfont-weight: 600;\n"]),
    _templateObject7 = taggedTemplateLiteral(["\n\tfont-size: 1em;\n\tmargin-bottom: 0.5em;\n\tdisplay: flex;\n\talign-items: center;\n\t> label {\n\t\tflex-grow: 1;\n\t}\n\t> span {\n\t\tfont-size: 12px;\n\t\tmargin-right: 0.75em;\n\t}\n"], ["\n\tfont-size: 1em;\n\tmargin-bottom: 0.5em;\n\tdisplay: flex;\n\talign-items: center;\n\t> label {\n\t\tflex-grow: 1;\n\t}\n\t> span {\n\t\tfont-size: 12px;\n\t\tmargin-right: 0.75em;\n\t}\n"]);

var DrawerMenu = styled.div(_templateObject$6);
var DrawerMenuHeader = styled.div(_templateObject2$4, function (props) {
  return props.theme.neutralDark["4"];
}, function (props) {
  return props.theme.neutralLight["7"];
});
var DrawerMenuBody = styled.div(_templateObject3$3, function (props) {
  return props.theme.neutralLight["7"];
});
var DrawerMenuFooter = styled(DrawerMenuHeader)(_templateObject4$1);
var DrawerBodySegment = styled.div(_templateObject5$1, function (props) {
  return props.theme.neutralDark["4"];
}, function (props) {
  return props.theme.neutralLight["6"];
});
var DrawerBodyLabel = styled.label(_templateObject6$1, function (props) {
  return props.theme.neutralDark["4"];
});
var DrawerBodyRow = styled.div(_templateObject7);
var interfaces = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var HandlerRole;

  (function (HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
  })(HandlerRole = exports.HandlerRole || (exports.HandlerRole = {}));
});
unwrapExports(interfaces);
var interfaces_1 = interfaces.HandlerRole;
var types = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.INIT_COORDS = 'dnd-core/INIT_COORDS';
  exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
  exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
  exports.HOVER = 'dnd-core/HOVER';
  exports.DROP = 'dnd-core/DROP';
  exports.END_DRAG = 'dnd-core/END_DRAG';
});
unwrapExports(types);
var types_1 = types.INIT_COORDS;
var types_2 = types.BEGIN_DRAG;
var types_3 = types.PUBLISH_DRAG_SOURCE;
var types_4 = types.HOVER;
var types_5 = types.DROP;
var types_6 = types.END_DRAG;
var setClientOffset_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function setClientOffset(clientOffset, sourceClientOffset) {
    return {
      type: types.INIT_COORDS,
      payload: {
        sourceClientOffset: sourceClientOffset || null,
        clientOffset: clientOffset || null
      }
    };
  }

  exports.setClientOffset = setClientOffset;
});
unwrapExports(setClientOffset_1);
var setClientOffset_2 = setClientOffset_1.setClientOffset;
var beginDrag = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ResetCoordinatesAction = {
    type: types.INIT_COORDS,
    payload: {
      clientOffset: null,
      sourceClientOffset: null
    }
  };

  function createBeginDrag(manager) {
    return function beginDrag(sourceIds, options) {
      if (sourceIds === void 0) {
        sourceIds = [];
      }

      if (options === void 0) {
        options = {
          publishSource: true
        };
      }

      var _a = options.publishSource,
          publishSource = _a === void 0 ? true : _a,
          clientOffset = options.clientOffset,
          getSourceClientOffset = options.getSourceClientOffset;
      var monitor = manager.getMonitor();
      var registry = manager.getRegistry(); // Initialize the coordinates using the client offset

      manager.dispatch(setClientOffset_1.setClientOffset(clientOffset));
      verifyInvariants(sourceIds, monitor, registry); // Get the draggable source

      var sourceId = getDraggableSource(sourceIds, monitor);

      if (sourceId === null) {
        manager.dispatch(ResetCoordinatesAction);
        return;
      } // Get the source client offset


      var sourceClientOffset = null;

      if (clientOffset) {
        verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
        sourceClientOffset = getSourceClientOffset(sourceId);
      } // Initialize the full coordinates


      manager.dispatch(setClientOffset_1.setClientOffset(clientOffset, sourceClientOffset));
      var source = registry.getSource(sourceId);
      var item = source.beginDrag(monitor, sourceId);
      verifyItemIsObject(item);
      registry.pinSource(sourceId);
      var itemType = registry.getSourceType(sourceId);
      return {
        type: types.BEGIN_DRAG,
        payload: {
          itemType: itemType,
          item: item,
          sourceId: sourceId,
          clientOffset: clientOffset || null,
          sourceClientOffset: sourceClientOffset || null,
          isSourcePublic: !!publishSource
        }
      };
    };
  }

  exports.default = createBeginDrag;

  function verifyInvariants(sourceIds, monitor, registry) {
    invariant_1(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');

    for (var _i = 0, sourceIds_1 = sourceIds; _i < sourceIds_1.length; _i++) {
      var s = sourceIds_1[_i];
      invariant_1(registry.getSource(s), 'Expected sourceIds to be registered.');
    }
  }

  function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    invariant_1(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
  }

  function verifyItemIsObject(item) {
    invariant_1(isObject_1(item), 'Item must be an object.');
  }

  function getDraggableSource(sourceIds, monitor) {
    var sourceId = null;

    for (var i = sourceIds.length - 1; i >= 0; i--) {
      if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
      }
    }

    return sourceId;
  }
});
unwrapExports(beginDrag);
var publishDragSource = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function createPublishDragSource(manager) {
    return function publishDragSource() {
      var monitor = manager.getMonitor();

      if (monitor.isDragging()) {
        return {
          type: types.PUBLISH_DRAG_SOURCE
        };
      }
    };
  }

  exports.default = createPublishDragSource;
});
unwrapExports(publishDragSource);
var matchesType_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) {
      return targetType === null;
    }

    return Array.isArray(targetType) ? targetType.some(function (t) {
      return t === draggedItemType;
    }) : targetType === draggedItemType;
  }

  exports.default = matchesType;
});
unwrapExports(matchesType_1);
var hover = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function createHover(manager) {
    return function hover(targetIdsArg, _a) {
      var clientOffset = (_a === void 0 ? {} : _a).clientOffset;
      verifyTargetIdsIsArray(targetIdsArg);
      var targetIds = targetIdsArg.slice(0);
      var monitor = manager.getMonitor();
      var registry = manager.getRegistry();
      checkInvariants(targetIds, monitor, registry);
      var draggedItemType = monitor.getItemType();
      removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
      hoverAllTargets(targetIds, monitor, registry);
      return {
        type: types.HOVER,
        payload: {
          targetIds: targetIds,
          clientOffset: clientOffset || null
        }
      };
    };
  }

  exports.default = createHover;

  function verifyTargetIdsIsArray(targetIdsArg) {
    invariant_1(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
  }

  function checkInvariants(targetIds, monitor, registry) {
    invariant_1(monitor.isDragging(), 'Cannot call hover while not dragging.');
    invariant_1(!monitor.didDrop(), 'Cannot call hover after drop.');

    for (var i = 0; i < targetIds.length; i++) {
      var targetId = targetIds[i];
      invariant_1(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
      var target = registry.getTarget(targetId);
      invariant_1(target, 'Expected targetIds to be registered.');
    }
  }

  function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for (var i = targetIds.length - 1; i >= 0; i--) {
      var targetId = targetIds[i];
      var targetType = registry.getTargetType(targetId);

      if (!matchesType_1.default(targetType, draggedItemType)) {
        targetIds.splice(i, 1);
      }
    }
  }

  function hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    for (var _i = 0, targetIds_1 = targetIds; _i < targetIds_1.length; _i++) {
      var targetId = targetIds_1[_i];
      var target = registry.getTarget(targetId);
      target.hover(monitor, targetId);
    }
  }
});
unwrapExports(hover);
var drop = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function createDrop(manager) {
    return function drop(options) {
      if (options === void 0) {
        options = {};
      }

      var monitor = manager.getMonitor();
      var registry = manager.getRegistry();
      verifyInvariants(monitor);
      var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action

      targetIds.forEach(function (targetId, index) {
        var dropResult = determineDropResult(targetId, index, registry, monitor);
        var action = {
          type: types.DROP,
          payload: {
            dropResult: __assign({}, options, dropResult)
          }
        };
        manager.dispatch(action);
      });
    };
  }

  exports.default = createDrop;

  function verifyInvariants(monitor) {
    invariant_1(monitor.isDragging(), 'Cannot call drop while not dragging.');
    invariant_1(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
  }

  function determineDropResult(targetId, index, registry, monitor) {
    var target = registry.getTarget(targetId);
    var dropResult = target.drop(monitor, targetId);
    verifyDropResultType(dropResult);

    if (typeof dropResult === 'undefined') {
      dropResult = index === 0 ? {} : monitor.getDropResult();
    }

    return dropResult;
  }

  function verifyDropResultType(dropResult) {
    invariant_1(typeof dropResult === 'undefined' || isObject_1(dropResult), 'Drop result must either be an object or undefined.');
  }

  function getDroppableTargets(monitor) {
    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
  }
});
unwrapExports(drop);
var endDrag = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function createEndDrag(manager) {
    return function endDrag() {
      var monitor = manager.getMonitor();
      var registry = manager.getRegistry();
      verifyIsDragging(monitor);
      var sourceId = monitor.getSourceId();
      var source = registry.getSource(sourceId, true);
      source.endDrag(monitor, sourceId);
      registry.unpinSource();
      return {
        type: types.END_DRAG
      };
    };
  }

  exports.default = createEndDrag;

  function verifyIsDragging(monitor) {
    invariant_1(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
  }
});
unwrapExports(endDrag);
var dragDrop = createCommonjsModule(function (module, exports) {
  function __export(m) {
    for (var p in m) {
      if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  __export(types);

  function createDragDropActions(manager) {
    return {
      beginDrag: beginDrag.default(manager),
      publishDragSource: publishDragSource.default(manager),
      hover: hover.default(manager),
      drop: drop.default(manager),
      endDrag: endDrag.default(manager)
    };
  }

  exports.default = createDragDropActions;
});
unwrapExports(dragDrop);
var equality = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.strictEquality = function (a, b) {
    return a === b;
  };
  /**
   * Determine if two cartesian coordinate offsets are equal
   * @param offsetA
   * @param offsetB
   */


  function areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) {
      return true;
    } else if (!offsetA || !offsetB) {
      return false;
    } else {
      return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
    }
  }

  exports.areCoordsEqual = areCoordsEqual;
  /**
   * Determines if two arrays of items are equal
   * @param a The first array of items
   * @param b The second array of items
   */

  function areArraysEqual(a, b, isEqual) {
    if (isEqual === void 0) {
      isEqual = exports.strictEquality;
    }

    if (a.length !== b.length) {
      return false;
    }

    for (var i = 0; i < a.length; ++i) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }

    return true;
  }

  exports.areArraysEqual = areArraysEqual;
});
unwrapExports(equality);
var equality_1 = equality.strictEquality;
var equality_2 = equality.areCoordsEqual;
var equality_3 = equality.areArraysEqual;
var dragOffset_1 = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
  };

  function dragOffset(state, action) {
    if (state === void 0) {
      state = initialState;
    }

    var payload = action.payload;

    switch (action.type) {
      case dragDrop.INIT_COORDS:
      case dragDrop.BEGIN_DRAG:
        return {
          initialSourceClientOffset: payload.sourceClientOffset,
          initialClientOffset: payload.clientOffset,
          clientOffset: payload.clientOffset
        };

      case dragDrop.HOVER:
        if (equality.areCoordsEqual(state.clientOffset, payload.clientOffset)) {
          return state;
        }

        return __assign({}, state, {
          clientOffset: payload.clientOffset
        });

      case dragDrop.END_DRAG:
      case dragDrop.DROP:
        return initialState;

      default:
        return state;
    }
  }

  exports.default = dragOffset;
});
unwrapExports(dragOffset_1);
var registry = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
  exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
  exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
  exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';

  function addSource(sourceId) {
    return {
      type: exports.ADD_SOURCE,
      payload: {
        sourceId: sourceId
      }
    };
  }

  exports.addSource = addSource;

  function addTarget(targetId) {
    return {
      type: exports.ADD_TARGET,
      payload: {
        targetId: targetId
      }
    };
  }

  exports.addTarget = addTarget;

  function removeSource(sourceId) {
    return {
      type: exports.REMOVE_SOURCE,
      payload: {
        sourceId: sourceId
      }
    };
  }

  exports.removeSource = removeSource;

  function removeTarget(targetId) {
    return {
      type: exports.REMOVE_TARGET,
      payload: {
        targetId: targetId
      }
    };
  }

  exports.removeTarget = removeTarget;
});
unwrapExports(registry);
var registry_1 = registry.ADD_SOURCE;
var registry_2 = registry.ADD_TARGET;
var registry_3 = registry.REMOVE_SOURCE;
var registry_4 = registry.REMOVE_TARGET;
var registry_5 = registry.addSource;
var registry_6 = registry.addTarget;
var registry_7 = registry.removeSource;
var registry_8 = registry.removeTarget;
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */

var without = _baseRest(function (array, values) {
  return isArrayLikeObject_1(array) ? _baseDifference(array, values) : [];
});

var without_1 = without;
var dragOperation_1 = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
  };

  function dragOperation(state, action) {
    if (state === void 0) {
      state = initialState;
    }

    var payload = action.payload;

    switch (action.type) {
      case dragDrop.BEGIN_DRAG:
        return __assign({}, state, {
          itemType: payload.itemType,
          item: payload.item,
          sourceId: payload.sourceId,
          isSourcePublic: payload.isSourcePublic,
          dropResult: null,
          didDrop: false
        });

      case dragDrop.PUBLISH_DRAG_SOURCE:
        return __assign({}, state, {
          isSourcePublic: true
        });

      case dragDrop.HOVER:
        return __assign({}, state, {
          targetIds: payload.targetIds
        });

      case registry.REMOVE_TARGET:
        if (state.targetIds.indexOf(payload.targetId) === -1) {
          return state;
        }

        return __assign({}, state, {
          targetIds: without_1(state.targetIds, payload.targetId)
        });

      case dragDrop.DROP:
        return __assign({}, state, {
          dropResult: payload.dropResult,
          didDrop: true,
          targetIds: []
        });

      case dragDrop.END_DRAG:
        return __assign({}, state, {
          itemType: null,
          item: null,
          sourceId: null,
          dropResult: null,
          didDrop: false,
          isSourcePublic: null,
          targetIds: []
        });

      default:
        return state;
    }
  }

  exports.default = dragOperation;
});
unwrapExports(dragOperation_1);
var refCount_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function refCount(state, action) {
    if (state === void 0) {
      state = 0;
    }

    switch (action.type) {
      case registry.ADD_SOURCE:
      case registry.ADD_TARGET:
        return state + 1;

      case registry.REMOVE_SOURCE:
      case registry.REMOVE_TARGET:
        return state - 1;

      default:
        return state;
    }
  }

  exports.default = refCount;
});
unwrapExports(refCount_1);
var dirtiness = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.NONE = [];
  exports.ALL = [];
  /**
   * Determines if the given handler IDs are dirty or not.
   *
   * @param dirtyIds The set of dirty handler ids
   * @param handlerIds The set of handler ids to check
   */

  function areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === exports.NONE) {
      return false;
    }

    if (dirtyIds === exports.ALL || typeof handlerIds === 'undefined') {
      return true;
    }

    return intersection_1(handlerIds, dirtyIds).length > 0;
  }

  exports.areDirty = areDirty;
});
unwrapExports(dirtiness);
var dirtiness_1 = dirtiness.NONE;
var dirtiness_2 = dirtiness.ALL;
var dirtiness_3 = dirtiness.areDirty;
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */

function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;

  if (length < 2) {
    return length ? _baseUniq(arrays[0]) : [];
  }

  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = _baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }

  return _baseUniq(_baseFlatten(result, 1), iteratee, comparator);
}

var _baseXor = baseXor;
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */

var xor = _baseRest(function (arrays) {
  return _baseXor(_arrayFilter(arrays, isArrayLikeObject_1));
});

var xor_1 = xor;
var dirtyHandlerIds_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function dirtyHandlerIds(state, action) {
    if (state === void 0) {
      state = dirtiness.NONE;
    }

    switch (action.type) {
      case dragDrop.HOVER:
        break;

      case registry.ADD_SOURCE:
      case registry.ADD_TARGET:
      case registry.REMOVE_TARGET:
      case registry.REMOVE_SOURCE:
        return dirtiness.NONE;

      case dragDrop.BEGIN_DRAG:
      case dragDrop.PUBLISH_DRAG_SOURCE:
      case dragDrop.END_DRAG:
      case dragDrop.DROP:
      default:
        return dirtiness.ALL;
    }

    var _a = action.payload,
        _b = _a.targetIds,
        targetIds = _b === void 0 ? [] : _b,
        _c = _a.prevTargetIds,
        prevTargetIds = _c === void 0 ? [] : _c;
    var result = xor_1(targetIds, prevTargetIds);
    var didChange = result.length > 0 || !equality.areArraysEqual(targetIds, prevTargetIds);

    if (!didChange) {
      return dirtiness.NONE;
    } // Check the target ids at the innermost position. If they are valid, add them
    // to the result


    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];

    if (prevInnermostTargetId !== innermostTargetId) {
      if (prevInnermostTargetId) {
        result.push(prevInnermostTargetId);
      }

      if (innermostTargetId) {
        result.push(innermostTargetId);
      }
    }

    return result;
  }

  exports.default = dirtyHandlerIds;
});
unwrapExports(dirtyHandlerIds_1);
var stateId_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function stateId(state) {
    if (state === void 0) {
      state = 0;
    }

    return state + 1;
  }

  exports.default = stateId;
});
unwrapExports(stateId_1);
var reducers = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function reduce(state, action) {
    if (state === void 0) {
      state = {};
    }

    return {
      dirtyHandlerIds: dirtyHandlerIds_1.default(state.dirtyHandlerIds, {
        type: action.type,
        payload: __assign({}, action.payload, {
          prevTargetIds: get_1(state, 'dragOperation.targetIds', [])
        })
      }),
      dragOffset: dragOffset_1.default(state.dragOffset, action),
      refCount: refCount_1.default(state.refCount, action),
      dragOperation: dragOperation_1.default(state.dragOperation, action),
      stateId: stateId_1.default(state.stateId)
    };
  }

  exports.default = reduce;
});
unwrapExports(reducers);
var coords = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Coordinate addition
   * @param a The first coordinate
   * @param b The second coordinate
   */

  function add(a, b) {
    return {
      x: a.x + b.x,
      y: a.y + b.y
    };
  }

  exports.add = add;
  /**
   * Coordinate subtraction
   * @param a The first coordinate
   * @param b The second coordinate
   */

  function subtract(a, b) {
    return {
      x: a.x - b.x,
      y: a.y - b.y
    };
  }

  exports.subtract = subtract;
  /**
   * Returns the cartesian distance of the drag source component's position, based on its position
   * at the time when the current drag operation has started, and the movement difference.
   *
   * Returns null if no item is being dragged.
   *
   * @param state The offset state to compute from
   */

  function getSourceClientOffset(state) {
    var clientOffset = state.clientOffset,
        initialClientOffset = state.initialClientOffset,
        initialSourceClientOffset = state.initialSourceClientOffset;

    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
      return null;
    }

    return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
  }

  exports.getSourceClientOffset = getSourceClientOffset;
  /**
   * Determines the x,y offset between the client offset and the initial client offset
   *
   * @param state The offset state to compute from
   */

  function getDifferenceFromInitialOffset(state) {
    var clientOffset = state.clientOffset,
        initialClientOffset = state.initialClientOffset;

    if (!clientOffset || !initialClientOffset) {
      return null;
    }

    return subtract(clientOffset, initialClientOffset);
  }

  exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
});
unwrapExports(coords);
var coords_1 = coords.add;
var coords_2 = coords.subtract;
var coords_3 = coords.getSourceClientOffset;
var coords_4 = coords.getDifferenceFromInitialOffset;
var DragDropMonitorImpl_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var DragDropMonitorImpl =
  /** @class */
  function () {
    function DragDropMonitorImpl(store, registry) {
      this.store = store;
      this.registry = registry;
    }

    DragDropMonitorImpl.prototype.subscribeToStateChange = function (listener, options) {
      var _this = this;

      if (options === void 0) {
        options = {
          handlerIds: undefined
        };
      }

      var handlerIds = options.handlerIds;
      invariant_1(typeof listener === 'function', 'listener must be a function.');
      invariant_1(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
      var prevStateId = this.store.getState().stateId;

      var handleChange = function handleChange() {
        var state = _this.store.getState();

        var currentStateId = state.stateId;

        try {
          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !dirtiness.areDirty(state.dirtyHandlerIds, handlerIds);

          if (!canSkipListener) {
            listener();
          }
        } finally {
          prevStateId = currentStateId;
        }
      };

      return this.store.subscribe(handleChange);
    };

    DragDropMonitorImpl.prototype.subscribeToOffsetChange = function (listener) {
      var _this = this;

      invariant_1(typeof listener === 'function', 'listener must be a function.');
      var previousState = this.store.getState().dragOffset;

      var handleChange = function handleChange() {
        var nextState = _this.store.getState().dragOffset;

        if (nextState === previousState) {
          return;
        }

        previousState = nextState;
        listener();
      };

      return this.store.subscribe(handleChange);
    };

    DragDropMonitorImpl.prototype.canDragSource = function (sourceId) {
      var source = this.registry.getSource(sourceId);
      invariant_1(source, 'Expected to find a valid source.');

      if (this.isDragging()) {
        return false;
      }

      return source.canDrag(this, sourceId);
    };

    DragDropMonitorImpl.prototype.canDropOnTarget = function (targetId) {
      var target = this.registry.getTarget(targetId);
      invariant_1(target, 'Expected to find a valid target.');

      if (!this.isDragging() || this.didDrop()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      return matchesType_1.default(targetType, draggedItemType) && target.canDrop(this, targetId);
    };

    DragDropMonitorImpl.prototype.isDragging = function () {
      return Boolean(this.getItemType());
    };

    DragDropMonitorImpl.prototype.isDraggingSource = function (sourceId) {
      var source = this.registry.getSource(sourceId, true);
      invariant_1(source, 'Expected to find a valid source.');

      if (!this.isDragging() || !this.isSourcePublic()) {
        return false;
      }

      var sourceType = this.registry.getSourceType(sourceId);
      var draggedItemType = this.getItemType();

      if (sourceType !== draggedItemType) {
        return false;
      }

      return source.isDragging(this, sourceId);
    };

    DragDropMonitorImpl.prototype.isOverTarget = function (targetId, options) {
      if (options === void 0) {
        options = {
          shallow: false
        };
      }

      var shallow = options.shallow;

      if (!this.isDragging()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();

      if (draggedItemType && !matchesType_1.default(targetType, draggedItemType)) {
        return false;
      }

      var targetIds = this.getTargetIds();

      if (!targetIds.length) {
        return false;
      }

      var index = targetIds.indexOf(targetId);

      if (shallow) {
        return index === targetIds.length - 1;
      } else {
        return index > -1;
      }
    };

    DragDropMonitorImpl.prototype.getItemType = function () {
      return this.store.getState().dragOperation.itemType;
    };

    DragDropMonitorImpl.prototype.getItem = function () {
      return this.store.getState().dragOperation.item;
    };

    DragDropMonitorImpl.prototype.getSourceId = function () {
      return this.store.getState().dragOperation.sourceId;
    };

    DragDropMonitorImpl.prototype.getTargetIds = function () {
      return this.store.getState().dragOperation.targetIds;
    };

    DragDropMonitorImpl.prototype.getDropResult = function () {
      return this.store.getState().dragOperation.dropResult;
    };

    DragDropMonitorImpl.prototype.didDrop = function () {
      return this.store.getState().dragOperation.didDrop;
    };

    DragDropMonitorImpl.prototype.isSourcePublic = function () {
      return this.store.getState().dragOperation.isSourcePublic;
    };

    DragDropMonitorImpl.prototype.getInitialClientOffset = function () {
      return this.store.getState().dragOffset.initialClientOffset;
    };

    DragDropMonitorImpl.prototype.getInitialSourceClientOffset = function () {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    };

    DragDropMonitorImpl.prototype.getClientOffset = function () {
      return this.store.getState().dragOffset.clientOffset;
    };

    DragDropMonitorImpl.prototype.getSourceClientOffset = function () {
      return coords.getSourceClientOffset(this.store.getState().dragOffset);
    };

    DragDropMonitorImpl.prototype.getDifferenceFromInitialOffset = function () {
      return coords.getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    };

    return DragDropMonitorImpl;
  }();

  exports.default = DragDropMonitorImpl;
});
unwrapExports(DragDropMonitorImpl_1);
var getNextUniqueId_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var nextUniqueId = 0;

  function getNextUniqueId() {
    return nextUniqueId++;
  }

  exports.default = getNextUniqueId;
});
unwrapExports(getNextUniqueId_1);
var contracts = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function validateSourceContract(source) {
    invariant_1(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    invariant_1(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    invariant_1(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
  }

  exports.validateSourceContract = validateSourceContract;

  function validateTargetContract(target) {
    invariant_1(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    invariant_1(typeof target.hover === 'function', 'Expected hover to be a function.');
    invariant_1(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
  }

  exports.validateTargetContract = validateTargetContract;

  function validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
      type.forEach(function (t) {
        return validateType(t, false);
      });
      return;
    }

    invariant_1(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
  }

  exports.validateType = validateType;
});
unwrapExports(contracts);
var contracts_1 = contracts.validateSourceContract;
var contracts_2 = contracts.validateTargetContract;
var contracts_3 = contracts.validateType;
var domain; // This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).

function EventHandlers() {}

EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
} // nodejs oddity
// require('events') === require('events').EventEmitter


EventEmitter.EventEmitter = EventEmitter;
EventEmitter.usingDomains = false;
EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.

EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function () {
  this.domain = null;

  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active && !(this instanceof domain.Domain)) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.


EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
}; // These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.


function emitNone(handler, isFn, self) {
  if (isFn) handler.call(self);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self);
    }
  }
}

function emitOne(handler, isFn, self, arg1) {
  if (isFn) handler.call(self, arg1);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1);
    }
  }
}

function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn) handler.call(self, arg1, arg2);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1, arg2);
    }
  }
}

function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn) handler.call(self, arg1, arg2, arg3);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1, arg2, arg3);
    }
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn) handler.apply(self, args);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].apply(self, args);
    }
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = type === 'error';
  events = this._events;
  if (events) doError = doError && events.error == null;else if (!doError) return false;
  domain = this.domain; // If there is no 'error' event listener then throw.

  if (doError) {
    er = arguments[1];

    if (domain) {
      if (!er) er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }

    return false;
  }

  handler = events[type];
  if (!handler) return false;
  var isFn = typeof handler === 'function';
  len = arguments.length;

  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;

    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;

    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;

    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower

    default:
      args = new Array(len - 1);

      for (i = 1; i < len; i++) {
        args[i - 1] = arguments[i];
      }

      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = target._events;

  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object

      events = target._events;
    }

    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    } // Check for listener leak


    if (!existing.warned) {
      m = $getMaxListeners(target);

      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}

function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function _onceWrap(target, type, listener) {
  var fired = false;

  function g() {
    target.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }

  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
}; // emits a 'removeListener' event iff the listener was removed


EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = this._events;
  if (!events) return this;
  list = events[type];
  if (!list) return this;

  if (list === listener || list.listener && list.listener === listener) {
    if (--this._eventsCount === 0) this._events = new EventHandlers();else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length; i-- > 0;) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (list.length === 1) {
      list[0] = undefined;

      if (--this._eventsCount === 0) {
        this._events = new EventHandlers();
        return this;
      } else {
        delete events[type];
      }
    } else {
      spliceOne$1(list, position);
    }

    if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events;
  events = this._events;
  if (!events) return this; // not listening for removeListener, no need to emit

  if (!events.removeListener) {
    if (arguments.length === 0) {
      this._events = new EventHandlers();
      this._eventsCount = 0;
    } else if (events[type]) {
      if (--this._eventsCount === 0) this._events = new EventHandlers();else delete events[type];
    }

    return this;
  } // emit removeListener for all listeners on all events


  if (arguments.length === 0) {
    var keys = Object.keys(events);

    for (var i = 0, key; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }

    this.removeAllListeners('removeListener');
    this._events = new EventHandlers();
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    do {
      this.removeListener(type, listeners[listeners.length - 1]);
    } while (listeners[0]);
  }

  return this;
};

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;
  if (!events) ret = [];else {
    evlistener = events[type];
    if (!evlistener) ret = [];else if (typeof evlistener === 'function') ret = [evlistener.listener || evlistener];else ret = unwrapListeners(evlistener);
  }
  return ret;
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;

function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
}; // About 1.5x faster than the two-arg version of Array#splice().


function spliceOne$1(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);

  while (i--) {
    copy[i] = arr[i];
  }

  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);

  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }

  return ret;
}

var inherits$3;

if (typeof Object.create === 'function') {
  inherits$3 = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  inherits$3 = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;

    var TempCtor = function TempCtor() {};

    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

var inherits$4 = inherits$3;
/*
<!-- LICENSEFILE/ -->

<h1>License</h1>

Unless stated otherwise all works are:

<ul><li>Copyright &copy; 2013+ <a href="http://bevry.me">Bevry Pty Ltd</a></li></ul>

and licensed under:

<ul><li><a href="http://spdx.org/licenses/MIT.html">MIT License</a></li></ul>

<h2>MIT License</h2>

<pre>
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
</pre>

<!-- /LICENSEFILE -->
*/

inherits$4(Domain, EventEmitter);

function createEmitError(d) {
  return emitError;

  function emitError(e) {
    d.emit('error', e);
  }
}

function Domain() {
  EventEmitter.call(this);
  this.__emitError = createEmitError(this);
}

Domain.prototype.add = function (emitter) {
  emitter.on('error', this.__emitError);
};

Domain.prototype.remove = function (emitter) {
  emitter.removeListener('error', this.__emitError);
};

Domain.prototype.bind = function (fn) {
  var emitError = this.__emitError;
  return function () {
    var args = Array.prototype.slice.call(arguments);

    try {
      fn.apply(null, args);
    } catch (err) {
      emitError(err);
    }
  };
};

Domain.prototype.intercept = function (fn) {
  var emitError = this.__emitError;
  return function (err) {
    if (err) {
      emitError(err);
    } else {
      var args = Array.prototype.slice.call(arguments, 1);

      try {
        fn.apply(null, args);
      } catch (err) {
        emitError(err);
      }
    }
  };
};

Domain.prototype.run = function (fn) {
  var emitError = this.__emitError;

  try {
    fn();
  } catch (err) {
    emitError(err);
  }

  return this;
};

Domain.prototype.dispose = function () {
  this.removeAllListeners();
  return this;
};

Domain.prototype.enter = Domain.prototype.exit = function () {
  return this;
};

function createDomain() {
  return new Domain();
}

var create$3 = createDomain;
var require$$0 = {
  Domain: Domain,
  createDomain: createDomain,
  create: create$3
};
var domain$1; // The domain module is executed on demand

var hasSetImmediate = typeof setImmediate === "function"; // Use the fastest means possible to execute a task in its own turn, with
// priority over other events including network IO events in Node.js.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.

var raw = rawAsap;

function rawAsap(task) {
  if (!queue$1.length) {
    requestFlush();
    flushing = true;
  } // Avoids a function call


  queue$1[queue$1.length] = task;
}

var queue$1 = []; // Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.

var flushing = false; // The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.

var index$7 = 0; // If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory excaustion, the task queue will periodically
// truncate already-completed tasks.

var capacity = 1024; // The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.

function flush() {
  while (index$7 < queue$1.length) {
    var currentIndex = index$7; // Advance the index before calling the task. This ensures that we will
    // begin flushing on the next task the task throws an error.

    index$7 = index$7 + 1;
    queue$1[currentIndex].call(); // Prevent leaking memory for long chains of recursive calls to `asap`.
    // If we call `asap` within tasks scheduled by `asap`, the queue will
    // grow, but to avoid an O(n) walk for every task we execute, we don't
    // shift tasks off the queue after they have been executed.
    // Instead, we periodically shift 1024 tasks off the queue.

    if (index$7 > capacity) {
      // Manually shift all values starting at the index back to the
      // beginning of the queue.
      for (var scan = 0, newLength = queue$1.length - index$7; scan < newLength; scan++) {
        queue$1[scan] = queue$1[scan + index$7];
      }

      queue$1.length -= index$7;
      index$7 = 0;
    }
  }

  queue$1.length = 0;
  index$7 = 0;
  flushing = false;
}

rawAsap.requestFlush = requestFlush;

function requestFlush() {
  // Ensure flushing is not bound to any domain.
  // It is not sufficient to exit the domain, because domains exist on a stack.
  // To execute code outside of any domain, the following dance is necessary.
  var parentDomain = process.domain;

  if (parentDomain) {
    if (!domain$1) {
      // Lazy execute the domain module.
      // Only employed if the user elects to use domains.
      domain$1 = require$$0;
    }

    domain$1.active = process.domain = null;
  } // `setImmediate` is slower that `process.nextTick`, but `process.nextTick`
  // cannot handle recursion.
  // `requestFlush` will only be called recursively from `asap.js`, to resume
  // flushing after an error is thrown into a domain.
  // Conveniently, `setImmediate` was introduced in the same version
  // `process.nextTick` started throwing recursion errors.


  if (flushing && hasSetImmediate) {
    setImmediate(flush);
  } else {
    process.nextTick(flush);
  }

  if (parentDomain) {
    domain$1.active = process.domain = parentDomain;
  }
}

var freeTasks = [];
/**
 * Calls a task as soon as possible after returning, in its own event, with
 * priority over IO events. An exception thrown in a task can be handled by
 * `process.on("uncaughtException") or `domain.on("error")`, but will otherwise
 * crash the process. If the error is handled, all subsequent tasks will
 * resume.
 *
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */

var asap_1 = asap;

function asap(task) {
  var rawTask;

  if (freeTasks.length) {
    rawTask = freeTasks.pop();
  } else {
    rawTask = new RawTask();
  }

  rawTask.task = task;
  rawTask.domain = process.domain;
  raw(rawTask);
}

function RawTask() {
  this.task = null;
  this.domain = null;
}

RawTask.prototype.call = function () {
  if (this.domain) {
    this.domain.enter();
  }

  var threw = true;

  try {
    this.task.call();
    threw = false; // If the task throws an exception (presumably) Node.js restores the
    // domain stack for the next event.

    if (this.domain) {
      this.domain.exit();
    }
  } finally {
    // We use try/finally and a threw flag to avoid messing up stack traces
    // when we catch and release errors.
    if (threw) {
      // In Node.js, uncaught exceptions are considered fatal errors.
      // Re-throw them to interrupt flushing!
      // Ensure that flushing continues if an uncaught exception is
      // suppressed listening process.on("uncaughtException") or
      // domain.on("error").
      raw.requestFlush();
    } // If the task threw an error, we do not want to exit the domain here.
    // Exiting the domain would prevent the domain from catching the error.


    this.task = null;
    this.domain = null;
    freeTasks.push(this);
  }
};

var HandlerRegistryImpl_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function getNextHandlerId(role) {
    var id = getNextUniqueId_1.default().toString();

    switch (role) {
      case interfaces.HandlerRole.SOURCE:
        return "S" + id;

      case interfaces.HandlerRole.TARGET:
        return "T" + id;

      default:
        throw new Error("Unknown Handler Role: " + role);
    }
  }

  function parseRoleFromHandlerId(handlerId) {
    switch (handlerId[0]) {
      case 'S':
        return interfaces.HandlerRole.SOURCE;

      case 'T':
        return interfaces.HandlerRole.TARGET;

      default:
        invariant_1(false, "Cannot parse handler ID: " + handlerId);
    }
  }

  function mapContainsValue(map, searchValue) {
    var entries = map.entries();
    var isDone = false;

    do {
      var _a = entries.next(),
          done = _a.done,
          _b = _a.value,
          value = _b[1];

      if (value === searchValue) {
        return true;
      }

      isDone = done;
    } while (!isDone);

    return false;
  }

  var HandlerRegistryImpl =
  /** @class */
  function () {
    function HandlerRegistryImpl(store) {
      this.store = store;
      this.types = new Map();
      this.dragSources = new Map();
      this.dropTargets = new Map();
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    }

    HandlerRegistryImpl.prototype.addSource = function (type, source) {
      contracts.validateType(type);
      contracts.validateSourceContract(source);
      var sourceId = this.addHandler(interfaces.HandlerRole.SOURCE, type, source);
      this.store.dispatch(registry.addSource(sourceId));
      return sourceId;
    };

    HandlerRegistryImpl.prototype.addTarget = function (type, target) {
      contracts.validateType(type, true);
      contracts.validateTargetContract(target);
      var targetId = this.addHandler(interfaces.HandlerRole.TARGET, type, target);
      this.store.dispatch(registry.addTarget(targetId));
      return targetId;
    };

    HandlerRegistryImpl.prototype.containsHandler = function (handler) {
      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    };

    HandlerRegistryImpl.prototype.getSource = function (sourceId, includePinned) {
      if (includePinned === void 0) {
        includePinned = false;
      }

      invariant_1(this.isSourceId(sourceId), 'Expected a valid source ID.');
      var isPinned = includePinned && sourceId === this.pinnedSourceId;
      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
      return source;
    };

    HandlerRegistryImpl.prototype.getTarget = function (targetId) {
      invariant_1(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.dropTargets.get(targetId);
    };

    HandlerRegistryImpl.prototype.getSourceType = function (sourceId) {
      invariant_1(this.isSourceId(sourceId), 'Expected a valid source ID.');
      return this.types.get(sourceId);
    };

    HandlerRegistryImpl.prototype.getTargetType = function (targetId) {
      invariant_1(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.types.get(targetId);
    };

    HandlerRegistryImpl.prototype.isSourceId = function (handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === interfaces.HandlerRole.SOURCE;
    };

    HandlerRegistryImpl.prototype.isTargetId = function (handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === interfaces.HandlerRole.TARGET;
    };

    HandlerRegistryImpl.prototype.removeSource = function (sourceId) {
      var _this = this;

      invariant_1(this.getSource(sourceId), 'Expected an existing source.');
      this.store.dispatch(registry.removeSource(sourceId));
      asap_1(function () {
        _this.dragSources.delete(sourceId);

        _this.types.delete(sourceId);
      });
    };

    HandlerRegistryImpl.prototype.removeTarget = function (targetId) {
      invariant_1(this.getTarget(targetId), 'Expected an existing target.');
      this.store.dispatch(registry.removeTarget(targetId));
      this.dropTargets.delete(targetId);
      this.types.delete(targetId);
    };

    HandlerRegistryImpl.prototype.pinSource = function (sourceId) {
      var source = this.getSource(sourceId);
      invariant_1(source, 'Expected an existing source.');
      this.pinnedSourceId = sourceId;
      this.pinnedSource = source;
    };

    HandlerRegistryImpl.prototype.unpinSource = function () {
      invariant_1(this.pinnedSource, 'No source is pinned at the time.');
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    };

    HandlerRegistryImpl.prototype.addHandler = function (role, type, handler) {
      var id = getNextHandlerId(role);
      this.types.set(id, type);

      if (role === interfaces.HandlerRole.SOURCE) {
        this.dragSources.set(id, handler);
      } else if (role === interfaces.HandlerRole.TARGET) {
        this.dropTargets.set(id, handler);
      }

      return id;
    };

    return HandlerRegistryImpl;
  }();

  exports.default = HandlerRegistryImpl;
});
unwrapExports(HandlerRegistryImpl_1);
var DragDropManagerImpl_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return redux.createStore(reducers.default, debugMode && reduxDevTools && reduxDevTools({
      name: 'dnd-core',
      instanceId: 'dnd-core'
    }));
  }

  var DragDropManagerImpl =
  /** @class */
  function () {
    function DragDropManagerImpl(createBackend, context, debugMode) {
      if (context === void 0) {
        context = {};
      }

      if (debugMode === void 0) {
        debugMode = false;
      }

      var _this = this;

      this.context = context;
      this.isSetUp = false;

      this.handleRefCountChange = function () {
        var shouldSetUp = _this.store.getState().refCount > 0;

        if (shouldSetUp && !_this.isSetUp) {
          _this.backend.setup();

          _this.isSetUp = true;
        } else if (!shouldSetUp && _this.isSetUp) {
          _this.backend.teardown();

          _this.isSetUp = false;
        }
      };

      var store = makeStoreInstance(debugMode);
      this.store = store;
      this.monitor = new DragDropMonitorImpl_1.default(store, new HandlerRegistryImpl_1.default(store));
      this.backend = createBackend(this);
      store.subscribe(this.handleRefCountChange);
    }

    DragDropManagerImpl.prototype.getContext = function () {
      return this.context;
    };

    DragDropManagerImpl.prototype.getMonitor = function () {
      return this.monitor;
    };

    DragDropManagerImpl.prototype.getBackend = function () {
      return this.backend;
    };

    DragDropManagerImpl.prototype.getRegistry = function () {
      return this.monitor.registry;
    };

    DragDropManagerImpl.prototype.getActions = function () {
      var manager = this;
      var dispatch = this.store.dispatch;

      function bindActionCreator(actionCreator) {
        return function () {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          var action = actionCreator.apply(manager, args);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      var actions = dragDrop.default(this);
      return Object.keys(actions).reduce(function (boundActions, key) {
        var action = actions[key];
        boundActions[key] = bindActionCreator(action);
        return boundActions;
      }, {});
    };

    DragDropManagerImpl.prototype.dispatch = function (action) {
      this.store.dispatch(action);
    };

    return DragDropManagerImpl;
  }();

  exports.default = DragDropManagerImpl;
});
unwrapExports(DragDropManagerImpl_1);
var factories$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function createDragDropManager(backend, context, debugMode) {
    return new DragDropManagerImpl_1.default(backend, context, debugMode);
  }

  exports.createDragDropManager = createDragDropManager;
});
unwrapExports(factories$1);
var factories_1 = factories$1.createDragDropManager;
var lib$6 = createCommonjsModule(function (module, exports) {
  function __export(m) {
    for (var p in m) {
      if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  __export(interfaces);

  __export(factories$1);
});
unwrapExports(lib$6);
var checkDecoratorArguments_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function checkDecoratorArguments(functionName, signature) {
    var args = [];

    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }

    if (process.env.NODE_ENV !== 'production') {
      for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];

        if (arg && arg.prototype && arg.prototype.render) {
          // tslint:disable-next-line no-console
          console.error('You seem to be applying the arguments in the wrong order. ' + ("It should be " + functionName + "(" + signature + ")(Component), not the other way around. ") + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
          return;
        }
      }
    }
  }

  exports.default = checkDecoratorArguments;
});
unwrapExports(checkDecoratorArguments_1);
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS$2 = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS$2 = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS$1 = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var TYPE_STATICS$1 = {};
TYPE_STATICS$1[reactIs.ForwardRef] = FORWARD_REF_STATICS$1;
var defineProperty$b = Object.defineProperty;
var getOwnPropertyNames$2 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$3 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$5 = Object.getPrototypeOf;
var objectPrototype$2 = Object.prototype;

function hoistNonReactStatics$2(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype$2) {
      var inheritedComponent = getPrototypeOf$5(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype$2) {
        hoistNonReactStatics$2(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames$2(sourceComponent);

    if (getOwnPropertySymbols$3) {
      keys = keys.concat(getOwnPropertySymbols$3(sourceComponent));
    }

    var targetStatics = TYPE_STATICS$1[targetComponent['$$typeof']] || REACT_STATICS$2;
    var sourceStatics = TYPE_STATICS$1[sourceComponent['$$typeof']] || REACT_STATICS$2;

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS$2[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$5(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$b(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs$2 = hoistNonReactStatics$2;
var isClassComponent_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var isClassComponent = function isClassComponent(Component$$1) {
    return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
  };

  var _default = isClassComponent;
  exports.default = _default;
});
unwrapExports(isClassComponent_1);
var DragDropContext_1 = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics = function extendStatics(d, b) {
      _extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics(d, b);
    };

    return function (d, b) {
      _extendStatics(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _a;

  var isClassComponent = isClassComponent_1.default;
  /**
   * Create the React Context
   */

  exports.Consumer = (_a = React.createContext({
    dragDropManager: undefined
  }), _a.Consumer), exports.Provider = _a.Provider;
  /**
   * Creates the context object we're providing
   * @param backend
   * @param context
   */

  function createChildContext(backend, context, debugMode) {
    return {
      dragDropManager: lib$6.createDragDropManager(backend, context, debugMode)
    };
  }

  exports.createChildContext = createChildContext;
  /**
   * A React component that provides the React-DnD context
   */

  exports.DragDropContextProvider = function (_a) {
    var backend = _a.backend,
        context = _a.context,
        debugMode = _a.debugMode,
        children = _a.children;
    var contextValue = createChildContext(backend, context, debugMode);
    return React.createElement(exports.Provider, {
      value: contextValue
    }, children);
  };
  /**
   * Wrap the root component of your application with DragDropContext decorator to set up React DnD.
   * This lets you specify the backend, and sets up the shared DnD state behind the scenes.
   * @param backendFactory The DnD backend factory
   * @param backendContext The backend context
   */


  function DragDropContext(backendFactory, backendContext, debugMode) {
    checkDecoratorArguments_1.default('DragDropContext', 'backend', backendFactory);
    var childContext = createChildContext(backendFactory, backendContext, debugMode);
    return function decorateContext(DecoratedComponent) {
      var Decorated = DecoratedComponent;
      var displayName = Decorated.displayName || Decorated.name || 'Component';

      var DragDropContextContainer =
      /** @class */
      function (_super) {
        __extends(DragDropContextContainer, _super);

        function DragDropContextContainer() {
          var _this = _super !== null && _super.apply(this, arguments) || this;

          _this.ref = React.createRef();

          _this.getManager = function () {
            return childContext.dragDropManager;
          };

          return _this;
        }

        DragDropContextContainer.prototype.getDecoratedComponentInstance = function () {
          invariant_1(this.ref.current, 'In order to access an instance of the decorated component it can not be a stateless component.');
          return this.ref.current;
        };

        DragDropContextContainer.prototype.render = function () {
          return React.createElement(exports.Provider, {
            value: childContext
          }, React.createElement(Decorated, __assign({}, this.props, {
            ref: isClassComponent(Decorated) ? this.ref : undefined
          })));
        };

        DragDropContextContainer.DecoratedComponent = DecoratedComponent;
        DragDropContextContainer.displayName = "DragDropContext(" + displayName + ")";
        return DragDropContextContainer;
      }(React.Component);

      return hoistNonReactStatics_cjs$2(DragDropContextContainer, DecoratedComponent);
    };
  }

  exports.DragDropContext = DragDropContext;
});
unwrapExports(DragDropContext_1);
var DragDropContext_2 = DragDropContext_1.Consumer;
var DragDropContext_3 = DragDropContext_1.Provider;
var DragDropContext_4 = DragDropContext_1.createChildContext;
var DragDropContext_5 = DragDropContext_1.DragDropContextProvider;
var DragDropContext_6 = DragDropContext_1.DragDropContext;
/** Built-in value references. */

var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;
/** `Object#toString` result references. */

var objectTag$3 = '[object Object]';
/** Used for built-in method references. */

var funcProto$2 = Function.prototype,
    objectProto$c = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$d = objectProto$c.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject$2(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }

  var proto = _getPrototype(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$d.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$2; //

var shallowequal = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

var DragLayer_1 = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics2 = function extendStatics(d, b) {
      _extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics2(d, b);
    };

    return function (d, b) {
      _extendStatics2(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var isClassComponent = isClassComponent_1.default;

  function DragLayer(collect, options) {
    if (options === void 0) {
      options = {};
    }

    checkDecoratorArguments_1.default('DragLayer', 'collect[, options]', collect, options);
    invariant_1(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
    invariant_1(isPlainObject_1(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
    return function decorateLayer(DecoratedComponent) {
      var Decorated = DecoratedComponent;
      var _a = options.arePropsEqual,
          arePropsEqual = _a === void 0 ? shallowequal : _a;
      var displayName = Decorated.displayName || Decorated.name || 'Component';

      var DragLayerContainer =
      /** @class */
      function (_super) {
        __extends(DragLayerContainer, _super);

        function DragLayerContainer() {
          var _this = _super !== null && _super.apply(this, arguments) || this;

          _this.isCurrentlyMounted = false;
          _this.ref = React.createRef();

          _this.handleChange = function () {
            if (!_this.isCurrentlyMounted) {
              return;
            }

            var nextState = _this.getCurrentState();

            if (!shallowequal(nextState, _this.state)) {
              _this.setState(nextState);
            }
          };

          return _this;
        }

        DragLayerContainer.prototype.getDecoratedComponentInstance = function () {
          invariant_1(this.ref.current, 'In order to access an instance of the decorated component it can not be a stateless component.');
          return this.ref.current;
        };

        DragLayerContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
          return !arePropsEqual(nextProps, this.props) || !shallowequal(nextState, this.state);
        };

        DragLayerContainer.prototype.componentDidMount = function () {
          this.isCurrentlyMounted = true;
          this.handleChange();
        };

        DragLayerContainer.prototype.componentWillUnmount = function () {
          this.isCurrentlyMounted = false;

          if (this.unsubscribeFromOffsetChange) {
            this.unsubscribeFromOffsetChange();
            this.unsubscribeFromOffsetChange = undefined;
          }

          if (this.unsubscribeFromStateChange) {
            this.unsubscribeFromStateChange();
            this.unsubscribeFromStateChange = undefined;
          }
        };

        DragLayerContainer.prototype.render = function () {
          var _this = this;

          return React.createElement(DragDropContext_1.Consumer, null, function (_a) {
            var dragDropManager = _a.dragDropManager;

            if (dragDropManager === undefined) {
              return null;
            }

            _this.receiveDragDropManager(dragDropManager); // Let componentDidMount fire to initialize the collected state


            if (!_this.isCurrentlyMounted) {
              return null;
            }

            return React.createElement(Decorated, __assign({}, _this.props, _this.state, {
              ref: isClassComponent(Decorated) ? _this.ref : undefined
            }));
          });
        };

        DragLayerContainer.prototype.receiveDragDropManager = function (dragDropManager) {
          if (this.manager !== undefined) {
            return;
          }

          this.manager = dragDropManager;
          invariant_1(typeof dragDropManager === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
          var monitor = this.manager.getMonitor();
          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
        };

        DragLayerContainer.prototype.getCurrentState = function () {
          if (!this.manager) {
            return {};
          }

          var monitor = this.manager.getMonitor();
          return collect(monitor, this.props);
        };

        DragLayerContainer.displayName = "DragLayer(" + displayName + ")";
        DragLayerContainer.DecoratedComponent = DecoratedComponent;
        return DragLayerContainer;
      }(React.Component);

      return hoistNonReactStatics_cjs$2(DragLayerContainer, DecoratedComponent);
    };
  }

  exports.default = DragLayer;
});
unwrapExports(DragLayer_1);
var Disposable_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Provides a set of static methods for creating Disposables.
   * @param {Function} action Action to run during the first call to dispose.
   * The action is guaranteed to be run at most once.
   */

  var Disposable =
  /** @class */
  function () {
    function Disposable(action) {
      this.isDisposed = false;
      this.action = isFunction_1(action) ? action : noop_1;
    }
    /**
     * Validates whether the given object is a disposable
     * @param {Object} Object to test whether it has a dispose method
     * @returns {Boolean} true if a disposable object, else false.
     */


    Disposable.isDisposable = function (d) {
      return d && isFunction_1(d.dispose);
    };

    Disposable._fixup = function (result) {
      return Disposable.isDisposable(result) ? result : Disposable.empty;
    };
    /**
     * Creates a disposable object that invokes the specified action when disposed.
     * @param {Function} dispose Action to run during the first call to dispose.
     * The action is guaranteed to be run at most once.
     * @return {Disposable} The disposable object that runs the given action upon disposal.
     */


    Disposable.create = function (action) {
      return new Disposable(action);
    };
    /** Performs the task of cleaning up resources. */


    Disposable.prototype.dispose = function () {
      if (!this.isDisposed) {
        this.action();
        this.isDisposed = true;
      }
    };
    /**
     * Gets the disposable that does nothing when disposed.
     */


    Disposable.empty = {
      dispose: noop_1
    };
    return Disposable;
  }();

  exports.Disposable = Disposable;
});
unwrapExports(Disposable_1);
var Disposable_2 = Disposable_1.Disposable;
var SerialDisposable_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Represents a disposable resource whose underlying disposable resource can
   * be replaced by another disposable resource, causing automatic disposal of
   * the previous underlying disposable resource.
   */

  var SerialDisposable =
  /** @class */
  function () {
    function SerialDisposable() {
      this.isDisposed = false;
    }
    /**
     * Gets the underlying disposable.
     * @returns {Any} the underlying disposable.
     */


    SerialDisposable.prototype.getDisposable = function () {
      return this.current;
    };

    SerialDisposable.prototype.setDisposable = function (value) {
      var shouldDispose = this.isDisposed;

      if (!shouldDispose) {
        var old = this.current;
        this.current = value;

        if (old) {
          old.dispose();
        }
      }

      if (shouldDispose && value) {
        value.dispose();
      }
    };
    /** Performs the task of cleaning up resources. */


    SerialDisposable.prototype.dispose = function () {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var old = this.current;
        this.current = undefined;

        if (old) {
          old.dispose();
        }
      }
    };

    return SerialDisposable;
  }();

  exports.SerialDisposable = SerialDisposable;
});
unwrapExports(SerialDisposable_1);
var SerialDisposable_2 = SerialDisposable_1.SerialDisposable;
var CompositeDisposable_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Represents a group of disposable resources that are disposed together.
   * @constructor
   */

  var CompositeDisposable =
  /** @class */
  function () {
    function CompositeDisposable() {
      var disposables = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        disposables[_i] = arguments[_i];
      }

      this.isDisposed = false;
      this.disposables = disposables;
    }
    /**
     * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
     * @param {Any} item Disposable to add.
     */


    CompositeDisposable.prototype.add = function (item) {
      if (this.isDisposed) {
        item.dispose();
      } else {
        this.disposables.push(item);
      }
    };
    /**
     * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
     * @param {Any} item Disposable to remove.
     * @returns {Boolean} true if found; false otherwise.
     */


    CompositeDisposable.prototype.remove = function (item) {
      var shouldDispose = false;

      if (!this.isDisposed) {
        var idx = this.disposables.indexOf(item);

        if (idx !== -1) {
          shouldDispose = true;
          this.disposables.splice(idx, 1);
          item.dispose();
        }
      }

      return shouldDispose;
    };
    /**
     *  Disposes all disposables in the group and removes them from the group but
     *  does not dispose the CompositeDisposable.
     */


    CompositeDisposable.prototype.clear = function () {
      if (!this.isDisposed) {
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var i = 0; i < len; i++) {
          currentDisposables[i] = this.disposables[i];
        }

        this.disposables = [];

        for (var i = 0; i < len; i++) {
          currentDisposables[i].dispose();
        }
      }
    };
    /**
     *  Disposes all disposables in the group and removes them from the group.
     */


    CompositeDisposable.prototype.dispose = function () {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var i = 0; i < len; i++) {
          currentDisposables[i] = this.disposables[i];
        }

        this.disposables = [];

        for (var i = 0; i < len; i++) {
          currentDisposables[i].dispose();
        }
      }
    };

    return CompositeDisposable;
  }();

  exports.CompositeDisposable = CompositeDisposable;
});
unwrapExports(CompositeDisposable_1);
var CompositeDisposable_2 = CompositeDisposable_1.CompositeDisposable;
var disposables = createCommonjsModule(function (module, exports) {
  function __export(m) {
    for (var p in m) {
      if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  __export(Disposable_1);

  __export(SerialDisposable_1);

  __export(CompositeDisposable_1);
});
unwrapExports(disposables);
var decorateHandler_1 = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics3 = function extendStatics(d, b) {
      _extendStatics3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics3(d, b);
    };

    return function (d, b) {
      _extendStatics3(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var isClassComponent = isClassComponent_1.default;

  function decorateHandler(_a) {
    var DecoratedComponent = _a.DecoratedComponent,
        createHandler = _a.createHandler,
        createMonitor = _a.createMonitor,
        createConnector = _a.createConnector,
        registerHandler = _a.registerHandler,
        containerDisplayName = _a.containerDisplayName,
        getType = _a.getType,
        collect = _a.collect,
        options = _a.options;
    var _b = options.arePropsEqual,
        arePropsEqual = _b === void 0 ? shallowequal : _b;
    var Decorated = DecoratedComponent;
    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

    var DragDropContainer =
    /** @class */
    function (_super) {
      __extends(DragDropContainer, _super);

      function DragDropContainer(props) {
        var _this = _super.call(this, props) || this;

        _this.isCurrentlyMounted = false;

        _this.handleChange = function () {
          if (!_this.isCurrentlyMounted) {
            return;
          }

          var nextState = _this.getCurrentState();

          if (!shallowequal(nextState, _this.state)) {
            _this.setState(nextState);
          }
        };

        _this.disposable = new disposables.SerialDisposable();

        _this.receiveProps(props);

        _this.dispose();

        return _this;
      }

      DragDropContainer.prototype.getHandlerId = function () {
        return this.handlerId;
      };

      DragDropContainer.prototype.getDecoratedComponentInstance = function () {
        if (!this.handler) {
          return null;
        }

        return this.handler.ref.current;
      };

      DragDropContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !arePropsEqual(nextProps, this.props) || !shallowequal(nextState, this.state);
      };

      DragDropContainer.prototype.componentDidMount = function () {
        this.isCurrentlyMounted = true;
        this.disposable = new disposables.SerialDisposable();
        this.currentType = undefined;
        this.receiveProps(this.props);
        this.handleChange();
      };

      DragDropContainer.prototype.componentDidUpdate = function (prevProps) {
        if (!arePropsEqual(this.props, prevProps)) {
          this.receiveProps(this.props);
          this.handleChange();
        }
      };

      DragDropContainer.prototype.componentWillUnmount = function () {
        this.dispose();
        this.isCurrentlyMounted = false;
      };

      DragDropContainer.prototype.receiveProps = function (props) {
        if (!this.handler) {
          return;
        }

        this.handler.receiveProps(props);
        this.receiveType(getType(props));
      };

      DragDropContainer.prototype.receiveType = function (type) {
        if (!this.handlerMonitor || !this.manager || !this.handlerConnector) {
          return;
        }

        if (type === this.currentType) {
          return;
        }

        this.currentType = type;

        var _a = registerHandler(type, this.handler, this.manager),
            handlerId = _a.handlerId,
            unregister = _a.unregister;

        this.handlerId = handlerId;
        this.handlerMonitor.receiveHandlerId(handlerId);
        this.handlerConnector.receiveHandlerId(handlerId);
        var globalMonitor = this.manager.getMonitor();
        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
          handlerIds: [handlerId]
        });
        this.disposable.setDisposable(new disposables.CompositeDisposable(new disposables.Disposable(unsubscribe), new disposables.Disposable(unregister)));
      };

      DragDropContainer.prototype.dispose = function () {
        this.disposable.dispose();

        if (this.handlerConnector) {
          this.handlerConnector.receiveHandlerId(null);
        }
      };

      DragDropContainer.prototype.getCurrentState = function () {
        if (!this.handlerConnector) {
          return {};
        }

        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);

        if (process.env.NODE_ENV !== 'production') {
          invariant_1(isPlainObject_1(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
        }

        return nextState;
      };

      DragDropContainer.prototype.render = function () {
        var _this = this;

        return React.createElement(DragDropContext_1.Consumer, null, function (_a) {
          var dragDropManager = _a.dragDropManager;

          if (dragDropManager === undefined) {
            return null;
          }

          _this.receiveDragDropManager(dragDropManager); // Let componentDidMount fire to initialize the collected state


          if (!_this.isCurrentlyMounted) {
            return null;
          }

          return React.createElement(Decorated, __assign({}, _this.props, _this.state, {
            ref: _this.handler && isClassComponent(Decorated) ? _this.handler.ref : undefined
          }));
        });
      };

      DragDropContainer.prototype.receiveDragDropManager = function (dragDropManager) {
        if (this.manager !== undefined) {
          return;
        }

        this.manager = dragDropManager;
        invariant_1(typeof dragDropManager === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
        this.handlerMonitor = createMonitor(dragDropManager);
        this.handlerConnector = createConnector(dragDropManager.getBackend());
        this.handler = createHandler(this.handlerMonitor);
      };

      DragDropContainer.DecoratedComponent = DecoratedComponent;
      DragDropContainer.displayName = containerDisplayName + "(" + displayName + ")";
      return DragDropContainer;
    }(React.Component);

    return hoistNonReactStatics_cjs$2(DragDropContainer, DecoratedComponent);
  }

  exports.default = decorateHandler;
});
unwrapExports(decorateHandler_1);
var registerSource_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function registerSource(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);

    function unregisterSource() {
      registry.removeSource(sourceId);
    }

    return {
      handlerId: sourceId,
      unregister: unregisterSource
    };
  }

  exports.default = registerSource;
});
unwrapExports(registerSource_1);
var createSourceFactory_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
  var REQUIRED_SPEC_METHODS = ['beginDrag'];

  function createSourceFactory(spec) {
    Object.keys(spec).forEach(function (key) {
      invariant_1(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
      invariant_1(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
    });
    REQUIRED_SPEC_METHODS.forEach(function (key) {
      invariant_1(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
    });

    var SourceImpl =
    /** @class */
    function () {
      function SourceImpl(monitor) {
        var _this = this;

        this.monitor = monitor;
        this.props = null;
        this.ref = React.createRef();

        this.beginDrag = function () {
          if (!_this.props) {
            return;
          }

          var item = spec.beginDrag(_this.props, _this.monitor, _this.ref.current);

          if (process.env.NODE_ENV !== 'production') {
            invariant_1(isPlainObject_1(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
          }

          return item;
        };
      }

      SourceImpl.prototype.receiveProps = function (props) {
        this.props = props;
      };

      SourceImpl.prototype.canDrag = function () {
        if (!this.props) {
          return false;
        }

        if (!spec.canDrag) {
          return true;
        }

        return spec.canDrag(this.props, this.monitor);
      };

      SourceImpl.prototype.isDragging = function (globalMonitor, sourceId) {
        if (!this.props) {
          return false;
        }

        if (!spec.isDragging) {
          return sourceId === globalMonitor.getSourceId();
        }

        return spec.isDragging(this.props, this.monitor);
      };

      SourceImpl.prototype.endDrag = function () {
        if (!this.props) {
          return;
        }

        if (!spec.endDrag) {
          return;
        }

        spec.endDrag(this.props, this.monitor, this.ref.current);
      };

      return SourceImpl;
    }();

    return function createSource(monitor) {
      return new SourceImpl(monitor);
    };
  }

  exports.default = createSourceFactory;
});
unwrapExports(createSourceFactory_1);
var createSourceMonitor_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var isCallingCanDrag = false;
  var isCallingIsDragging = false;

  var SourceMonitor =
  /** @class */
  function () {
    function SourceMonitor(manager) {
      this.internalMonitor = manager.getMonitor();
    }

    SourceMonitor.prototype.receiveHandlerId = function (sourceId) {
      this.sourceId = sourceId;
    };

    SourceMonitor.prototype.canDrag = function () {
      invariant_1(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    };

    SourceMonitor.prototype.isDragging = function () {
      invariant_1(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    };

    SourceMonitor.prototype.subscribeToStateChange = function (listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    };

    SourceMonitor.prototype.isDraggingSource = function (sourceId) {
      return this.internalMonitor.isDraggingSource(sourceId);
    };

    SourceMonitor.prototype.isOverTarget = function (targetId, options) {
      return this.internalMonitor.isOverTarget(targetId, options);
    };

    SourceMonitor.prototype.getTargetIds = function () {
      return this.internalMonitor.getTargetIds();
    };

    SourceMonitor.prototype.isSourcePublic = function () {
      return this.internalMonitor.isSourcePublic();
    };

    SourceMonitor.prototype.getSourceId = function () {
      return this.internalMonitor.getSourceId();
    };

    SourceMonitor.prototype.subscribeToOffsetChange = function (listener) {
      return this.internalMonitor.subscribeToOffsetChange(listener);
    };

    SourceMonitor.prototype.canDragSource = function (sourceId) {
      return this.internalMonitor.canDragSource(sourceId);
    };

    SourceMonitor.prototype.canDropOnTarget = function (targetId) {
      return this.internalMonitor.canDropOnTarget(targetId);
    };

    SourceMonitor.prototype.getItemType = function () {
      return this.internalMonitor.getItemType();
    };

    SourceMonitor.prototype.getItem = function () {
      return this.internalMonitor.getItem();
    };

    SourceMonitor.prototype.getDropResult = function () {
      return this.internalMonitor.getDropResult();
    };

    SourceMonitor.prototype.didDrop = function () {
      return this.internalMonitor.didDrop();
    };

    SourceMonitor.prototype.getInitialClientOffset = function () {
      return this.internalMonitor.getInitialClientOffset();
    };

    SourceMonitor.prototype.getInitialSourceClientOffset = function () {
      return this.internalMonitor.getInitialSourceClientOffset();
    };

    SourceMonitor.prototype.getSourceClientOffset = function () {
      return this.internalMonitor.getSourceClientOffset();
    };

    SourceMonitor.prototype.getClientOffset = function () {
      return this.internalMonitor.getClientOffset();
    };

    SourceMonitor.prototype.getDifferenceFromInitialOffset = function () {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    };

    return SourceMonitor;
  }();

  function createSourceMonitor(manager) {
    return new SourceMonitor(manager);
  }

  exports.default = createSourceMonitor;
});
unwrapExports(createSourceMonitor_1);
var cloneWithRef_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function cloneWithRef(element, newRef) {
    var previousRef = element.ref;
    invariant_1(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

    if (!previousRef) {
      // When there is no ref on the element, use the new ref directly
      return React.cloneElement(element, {
        ref: newRef
      });
    }

    return React.cloneElement(element, {
      ref: function ref(node) {
        newRef(node);

        if (previousRef) {
          previousRef(node);
        }
      }
    });
  }

  exports.default = cloneWithRef;
});
unwrapExports(cloneWithRef_1);
var wrapConnectorHooks_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') {
      return;
    }

    var displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ("You can either wrap " + displayName + " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
  }

  function wrapHookToRecognizeElement(hook) {
    return function (elementOrNode, options) {
      if (elementOrNode === void 0) {
        elementOrNode = null;
      }

      if (options === void 0) {
        options = null;
      } // When passed a node, call the hook straight away.


      if (!React.isValidElement(elementOrNode)) {
        var node = elementOrNode;
        hook(node, options);
        return undefined;
      } // If passed a ReactElement, clone it and attach this function as a ref.
      // This helps us achieve a neat API where user doesn't even know that refs
      // are being used under the hood.


      var element = elementOrNode;
      throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly

      var ref = options ? function (node) {
        return hook(node, options);
      } : hook;
      return cloneWithRef_1.default(element, ref);
    };
  }

  function wrapConnectorHooks(hooks) {
    var wrappedHooks = {};
    Object.keys(hooks).forEach(function (key) {
      var hook = hooks[key];
      var wrappedHook = wrapHookToRecognizeElement(hook);

      wrappedHooks[key] = function () {
        return wrappedHook;
      };
    });
    return wrappedHooks;
  }

  exports.default = wrapConnectorHooks;
});
unwrapExports(wrapConnectorHooks_1);
var createSourceConnector_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function createSourceConnector(backend) {
    var currentHandlerId;
    var currentDragSourceNode;
    var currentDragSourceOptions;
    var disconnectCurrentDragSource;
    var currentDragPreviewNode;
    var currentDragPreviewOptions;
    var disconnectCurrentDragPreview;

    function reconnectDragSource() {
      if (disconnectCurrentDragSource) {
        disconnectCurrentDragSource();
        disconnectCurrentDragSource = undefined;
      }

      if (currentHandlerId && currentDragSourceNode) {
        disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
      }
    }

    function reconnectDragPreview() {
      if (disconnectCurrentDragPreview) {
        disconnectCurrentDragPreview();
        disconnectCurrentDragPreview = undefined;
      }

      if (currentHandlerId && currentDragPreviewNode) {
        disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
      }
    }

    function receiveHandlerId(handlerId) {
      if (handlerId === currentHandlerId) {
        return;
      }

      currentHandlerId = handlerId;
      reconnectDragSource();
      reconnectDragPreview();
    }

    var hooks = wrapConnectorHooks_1.default({
      dragSource: function connectDragSource(node, options) {
        if (node === currentDragSourceNode && shallowequal(options, currentDragSourceOptions)) {
          return;
        }

        currentDragSourceNode = node;
        currentDragSourceOptions = options;
        reconnectDragSource();
      },
      dragPreview: function connectDragPreview(node, options) {
        if (node === currentDragPreviewNode && shallowequal(options, currentDragPreviewOptions)) {
          return;
        }

        currentDragPreviewNode = node;
        currentDragPreviewOptions = options;
        reconnectDragPreview();
      }
    });
    return {
      receiveHandlerId: receiveHandlerId,
      hooks: hooks
    };
  }

  exports.default = createSourceConnector;
});
unwrapExports(createSourceConnector_1);
var isValidType_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function isValidType(type, allowArray) {
    return typeof type === 'string' || typeof type === 'symbol' || !!allowArray && Array.isArray(type) && type.every(function (t) {
      return isValidType(t, false);
    });
  }

  exports.default = isValidType;
});
unwrapExports(isValidType_1);
var DragSource_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Decorates a component as a dragsource
   * @param type The dragsource type
   * @param spec The drag source specification
   * @param collect The props collector function
   * @param options DnD options
   */

  function DragSource(type, spec, collect, options) {
    if (options === void 0) {
      options = {};
    }

    checkDecoratorArguments_1.default('DragSource', 'type, spec, collect[, options]', type, spec, collect, options);
    var getType = type;

    if (typeof type !== 'function') {
      invariant_1(isValidType_1.default(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);

      getType = function getType() {
        return type;
      };
    }

    invariant_1(isPlainObject_1(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
    var createSource = createSourceFactory_1.default(spec);
    invariant_1(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
    invariant_1(isPlainObject_1(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
    return function decorateSource(DecoratedComponent) {
      return decorateHandler_1.default({
        containerDisplayName: 'DragSource',
        createHandler: createSource,
        registerHandler: registerSource_1.default,
        createMonitor: createSourceMonitor_1.default,
        createConnector: createSourceConnector_1.default,
        DecoratedComponent: DecoratedComponent,
        getType: getType,
        collect: collect,
        options: options
      });
    };
  }

  exports.default = DragSource;
});
unwrapExports(DragSource_1);
var registerTarget_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function registerTarget(type, target, manager) {
    var registry = manager.getRegistry();
    var targetId = registry.addTarget(type, target);

    function unregisterTarget() {
      registry.removeTarget(targetId);
    }

    return {
      handlerId: targetId,
      unregister: unregisterTarget
    };
  }

  exports.default = registerTarget;
});
unwrapExports(registerTarget_1);
var createTargetFactory_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

  function createTargetFactory(spec) {
    Object.keys(spec).forEach(function (key) {
      invariant_1(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
      invariant_1(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
    });

    var TargetImpl =
    /** @class */
    function () {
      function TargetImpl(monitor) {
        this.monitor = monitor;
        this.props = null;
        this.ref = React.createRef();
      }

      TargetImpl.prototype.receiveProps = function (props) {
        this.props = props;
      };

      TargetImpl.prototype.receiveMonitor = function (monitor) {
        this.monitor = monitor;
      };

      TargetImpl.prototype.canDrop = function () {
        if (!spec.canDrop) {
          return true;
        }

        return spec.canDrop(this.props, this.monitor);
      };

      TargetImpl.prototype.hover = function () {
        if (!spec.hover) {
          return;
        }

        spec.hover(this.props, this.monitor, this.ref.current);
      };

      TargetImpl.prototype.drop = function () {
        if (!spec.drop) {
          return undefined;
        }

        var dropResult = spec.drop(this.props, this.monitor, this.ref.current);

        if (process.env.NODE_ENV !== 'production') {
          invariant_1(typeof dropResult === 'undefined' || isPlainObject_1(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
        }

        return dropResult;
      };

      return TargetImpl;
    }();

    return function createTarget(monitor) {
      return new TargetImpl(monitor);
    };
  }

  exports.default = createTargetFactory;
});
unwrapExports(createTargetFactory_1);
var createTargetMonitor_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var isCallingCanDrop = false;

  var TargetMonitor =
  /** @class */
  function () {
    function TargetMonitor(manager) {
      this.internalMonitor = manager.getMonitor();
    }

    TargetMonitor.prototype.receiveHandlerId = function (targetId) {
      this.targetId = targetId;
    };

    TargetMonitor.prototype.canDrop = function () {
      invariant_1(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    };

    TargetMonitor.prototype.isOver = function (options) {
      return this.internalMonitor.isOverTarget(this.targetId, options);
    };

    TargetMonitor.prototype.getItemType = function () {
      return this.internalMonitor.getItemType();
    };

    TargetMonitor.prototype.getItem = function () {
      return this.internalMonitor.getItem();
    };

    TargetMonitor.prototype.getDropResult = function () {
      return this.internalMonitor.getDropResult();
    };

    TargetMonitor.prototype.didDrop = function () {
      return this.internalMonitor.didDrop();
    };

    TargetMonitor.prototype.getInitialClientOffset = function () {
      return this.internalMonitor.getInitialClientOffset();
    };

    TargetMonitor.prototype.getInitialSourceClientOffset = function () {
      return this.internalMonitor.getInitialSourceClientOffset();
    };

    TargetMonitor.prototype.getSourceClientOffset = function () {
      return this.internalMonitor.getSourceClientOffset();
    };

    TargetMonitor.prototype.getClientOffset = function () {
      return this.internalMonitor.getClientOffset();
    };

    TargetMonitor.prototype.getDifferenceFromInitialOffset = function () {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    };

    return TargetMonitor;
  }();

  exports.TargetMonitor = TargetMonitor;

  function createTargetMonitor(manager) {
    return new TargetMonitor(manager);
  }

  exports.default = createTargetMonitor;
});
unwrapExports(createTargetMonitor_1);
var createTargetMonitor_2 = createTargetMonitor_1.TargetMonitor;
var createTargetConnector_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function createTargetConnector(backend) {
    var currentHandlerId;
    var currentDropTargetNode;
    var currentDropTargetOptions;
    var disconnectCurrentDropTarget;

    function reconnectDropTarget() {
      if (disconnectCurrentDropTarget) {
        disconnectCurrentDropTarget();
        disconnectCurrentDropTarget = undefined;
      }

      if (currentHandlerId && currentDropTargetNode) {
        disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
      }
    }

    function receiveHandlerId(handlerId) {
      if (handlerId === currentHandlerId) {
        return;
      }

      currentHandlerId = handlerId;
      reconnectDropTarget();
    }

    var hooks = wrapConnectorHooks_1.default({
      dropTarget: function connectDropTarget(node, options) {
        if (node === currentDropTargetNode && shallowequal(options, currentDropTargetOptions)) {
          return;
        }

        currentDropTargetNode = node;
        currentDropTargetOptions = options;
        reconnectDropTarget();
      }
    });
    return {
      receiveHandlerId: receiveHandlerId,
      hooks: hooks
    };
  }

  exports.default = createTargetConnector;
});
unwrapExports(createTargetConnector_1);
var DropTarget_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function DropTarget(type, spec, collect, options) {
    if (options === void 0) {
      options = {};
    }

    checkDecoratorArguments_1.default('DropTarget', 'type, spec, collect[, options]', type, spec, collect, options);
    var getType = type;

    if (typeof type !== 'function') {
      invariant_1(isValidType_1.default(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);

      getType = function getType() {
        return type;
      };
    }

    invariant_1(isPlainObject_1(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
    var createTarget = createTargetFactory_1.default(spec);
    invariant_1(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
    invariant_1(isPlainObject_1(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
    return function decorateTarget(DecoratedComponent) {
      return decorateHandler_1.default({
        containerDisplayName: 'DropTarget',
        createHandler: createTarget,
        registerHandler: registerTarget_1.default,
        createMonitor: createTargetMonitor_1.default,
        createConnector: createTargetConnector_1.default,
        DecoratedComponent: DecoratedComponent,
        getType: getType,
        collect: collect,
        options: options
      });
    };
  }

  exports.default = DropTarget;
});
unwrapExports(DropTarget_1);
var lib$7 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DragDropContext = DragDropContext_1.DragDropContext;
  exports.DragDropContextProvider = DragDropContext_1.DragDropContextProvider;
  exports.DragLayer = DragLayer_1.default;
  exports.DragSource = DragSource_1.default;
  exports.DropTarget = DropTarget_1.default;
});
unwrapExports(lib$7);
var lib_1$5 = lib$7.DragDropContext;
var lib_2$4 = lib$7.DragDropContextProvider;
var lib_3$4 = lib$7.DragLayer;
var lib_4$4 = lib$7.DragSource;
var lib_5$2 = lib$7.DropTarget;
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

var isobject = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

function isObjectObject(o) {
  return isobject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}

var isPlainObject$3 = function isPlainObject(o) {
  var ctor, prot;
  if (isObjectObject(o) === false) return false; // If has modified constructor

  ctor = o.constructor;
  if (typeof ctor !== 'function') return false; // If has modified prototype

  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false; // If constructor does not have an Object-specific method

  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  } // Most likely a plain Object


  return true;
};

var isExtendable = function isExtendable(val) {
  return isPlainObject$3(val) || typeof val === 'function' || Array.isArray(val);
};

var object_omit = function omit(obj, props, fn) {
  if (!isExtendable(obj)) return {};

  if (typeof props === 'function') {
    fn = props;
    props = [];
  }

  if (typeof props === 'string') {
    props = [props];
  }

  var isFunction = typeof fn === 'function';
  var keys = Object.keys(obj);
  var res = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];

    if (!props || props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj))) {
      res[key] = val;
    }
  }

  return res;
};

var noop$2 = function noop$2() {};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$r(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$m(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$m(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _class = function (_React$Component) {
  _inherits$m(_class, _React$Component);

  function _class(props) {
    _classCallCheck$r(this, _class);

    var _this = _possibleConstructorReturn$m(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      isHovering: false
    };
    _this.onMouseEnter = _this.onMouseEnter.bind(_this);
    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
    _this.onMouseOver = _this.onMouseOver.bind(_this);
    _this.onMouseOut = _this.onMouseOut.bind(_this);
    _this.setIsHovering = _this.setIsHovering.bind(_this);
    _this.unsetIsHovering = _this.unsetIsHovering.bind(_this);
    _this.componentWillUnmount = _this.componentWillUnmount.bind(_this);
    _this.timerIds = [];
    return _this;
  }

  _createClass(_class, [{
    key: 'onMouseEnter',
    value: function onMouseEnter(e) {
      this.props.onMouseEnter({
        e: e,
        setIsHovering: this.setIsHovering,
        unsetIsHovering: this.unsetIsHovering
      });
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave(e) {
      this.props.onMouseLeave({
        e: e,
        setIsHovering: this.setIsHovering,
        unsetIsHovering: this.unsetIsHovering
      });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver(e) {
      this.props.onMouseOver({
        e: e,
        setIsHovering: this.setIsHovering,
        unsetIsHovering: this.unsetIsHovering
      });
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut(e) {
      this.props.onMouseOut({
        e: e,
        setIsHovering: this.setIsHovering,
        unsetIsHovering: this.unsetIsHovering
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimers();
    }
  }, {
    key: 'setIsHovering',
    value: function setIsHovering() {
      var _this2 = this;

      this.clearTimers();
      var hoverScheduleId = setTimeout(function () {
        var newState = {
          isHovering: true
        };

        _this2.setState(newState, function () {
          _this2.props.onHoverChanged(newState);
        });
      }, this.props.hoverDelayInMs);
      this.timerIds.push(hoverScheduleId);
    }
  }, {
    key: 'unsetIsHovering',
    value: function unsetIsHovering() {
      var _this3 = this;

      this.clearTimers();
      var hoverOffScheduleId = setTimeout(function () {
        var newState = {
          isHovering: false
        };

        _this3.setState(newState, function () {
          _this3.props.onHoverChanged(newState);
        });
      }, this.props.hoverOffDelayInMs);
      this.timerIds.push(hoverOffScheduleId);
    }
  }, {
    key: 'clearTimers',
    value: function clearTimers() {
      var ids = this.timerIds;

      while (ids.length) {
        clearTimeout(ids.pop());
      }
    }
  }, {
    key: 'getIsReactComponent',
    value: function getIsReactComponent(reactElement) {
      return typeof reactElement.type === 'function';
    }
  }, {
    key: 'shouldDecorateChild',
    value: function shouldDecorateChild(child) {
      return !!child && this.getIsReactComponent(child) && this.props.shouldDecorateChildren;
    }
  }, {
    key: 'decorateChild',
    value: function decorateChild(child, props) {
      return cloneElement(child, props);
    }
  }, {
    key: 'renderChildrenWithProps',
    value: function renderChildrenWithProps(children, props) {
      var _this4 = this;

      if (typeof children === 'function') {
        return children(props);
      }

      return Children.map(children, function (child) {
        return _this4.shouldDecorateChild(child) ? _this4.decorateChild(child, props) : child;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;
      var childProps = objectAssign({}, {
        isHovering: this.state.isHovering
      }, object_omit(this.props, ['children', 'className', 'hoverDelayInMs', 'hoverOffDelayInMs', 'onHoverChanged', 'onMouseEnter', 'onMouseLeave', 'onMouseOver', 'onMouseOut', 'shouldDecorateChildren']));
      return React.createElement('div', {
        className: className,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut
      }, this.renderChildrenWithProps(children, childProps));
    }
  }]);

  return _class;
}(React.Component);

_class.displayName = 'ReactHoverObserver';
_class.defaultProps = {
  hoverDelayInMs: 0,
  hoverOffDelayInMs: 0,
  onHoverChanged: noop$2,
  onMouseEnter: function onMouseEnter(_ref) {
    var setIsHovering = _ref.setIsHovering;
    return setIsHovering();
  },
  onMouseLeave: function onMouseLeave(_ref2) {
    var unsetIsHovering = _ref2.unsetIsHovering;
    return unsetIsHovering();
  },
  onMouseOver: noop$2,
  onMouseOut: noop$2,
  shouldDecorateChildren: true
};
_class.propTypes = {
  className: PropTypes.string,
  hoverDelayInMs: PropTypes.number,
  hoverOffDelayInMs: PropTypes.number,
  onHoverChanged: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  shouldDecorateChildren: PropTypes.bool
};

var _templateObject$7 = taggedTemplateLiteral(["\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tcursor: pointer;\n\t\tfont-size: 20px;\n\t\tborder: 0 none;\n\t\tpadding: 0;\n\t\tbackground: transparent;\n\t\t&:focus {\n\t\t\toutline: thin dotted;\n\t\t}\n\t\t> svg {\n\t\t\tfill: ", ";\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t}\n\t\t&:hover svg {\n\t\t\tfill: ", ";\n\t\t}\n\t\t&[disabled] > svg {\n\t\t\tcursor: default;\n\t\t\tfill: ", ";\n\t\t}\n\t"], ["\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tcursor: pointer;\n\t\tfont-size: 20px;\n\t\tborder: 0 none;\n\t\tpadding: 0;\n\t\tbackground: transparent;\n\t\t&:focus {\n\t\t\toutline: thin dotted;\n\t\t}\n\t\t> svg {\n\t\t\tfill: ", ";\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t}\n\t\t&:hover svg {\n\t\t\tfill: ", ";\n\t\t}\n\t\t&[disabled] > svg {\n\t\t\tcursor: default;\n\t\t\tfill: ", ";\n\t\t}\n\t"]);

var iconButtonStyler = function iconButtonStyler(Component$$1) {
  var func = typeof Component$$1 === "string" ? styled[Component$$1] : styled(Component$$1);
  return func(_templateObject$7, function (props) {
    return props.theme.primary["2"];
  }, function (props) {
    return props.theme.primary["1"];
  }, function (props) {
    return props.theme.neutralLight["1"];
  });
};

var StyledButton$2 = iconButtonStyler("button");

var IconButton = function IconButton(props) {
  if (props.title !== undefined) {
    return React.createElement(Tooltip, {
      placement: "top",
      overlay: props.title,
      mouseLeaveDelay: 0
    }, React.createElement(StyledButton$2, props));
  }

  return React.createElement(StyledButton$2, props);
};

var _templateObject$8 = taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  height: 2.8em;\n  input {\n    padding: 0.6em 2.7em;\n    height: 36px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  margin-bottom: 0.8em;\n  button:not(.upload) {\n    opacity: 1;\n    &.anchor {\n      opacity: 1;\n    }\n  }\n  &:hover,\n  &.focus {\n    button:not(.upload) {\n      opacity: ", ";\n    }\n  }\n  opacity: ", ";\n  &.contentTransition-enter {\n    height: 10em;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  height: 2.8em;\n  input {\n    padding: 0.6em 2.7em;\n    height: 36px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  margin-bottom: 0.8em;\n  button:not(.upload) {\n    opacity: 1;\n    &.anchor {\n      opacity: 1;\n    }\n  }\n  &:hover,\n  &.focus {\n    button:not(.upload) {\n      opacity: ", ";\n    }\n  }\n  opacity: ", ";\n  &.contentTransition-enter {\n    height: 10em;\n  }\n"]),
    _templateObject2$5 = taggedTemplateLiteral(["\n  flex-grow: 1;\n  white-space: nowrap;\n  position: relative;\n  > div {\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    margin-right: 0.5em;\n  }\n"], ["\n  flex-grow: 1;\n  white-space: nowrap;\n  position: relative;\n  > div {\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    margin-right: 0.5em;\n  }\n"]),
    _templateObject3$4 = taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  left: 0.86em;\n  top: 50%;\n  transform: translateY(-50%);\n"], ["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  left: 0.86em;\n  top: 50%;\n  transform: translateY(-50%);\n"]),
    _templateObject4$2 = taggedTemplateLiteral(["\n  font-size: 1.5em;\n  height: 1em;\n  display: inline-block;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  > button,\n  > span {\n    font-size: 1em;\n    &:not(:last-child) {\n      margin-right: 0.5em;\n    }\n  }\n"], ["\n  font-size: 1.5em;\n  height: 1em;\n  display: inline-block;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  > button,\n  > span {\n    font-size: 1em;\n    &:not(:last-child) {\n      margin-right: 0.5em;\n    }\n  }\n"]),
    _templateObject5$2 = taggedTemplateLiteral(["\n  width: 6em;\n  margin-right: 0.7em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  width: 6em;\n  margin-right: 0.7em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]),
    _templateObject6$2 = taggedTemplateLiteral(["\n  color: ", ";\n"], ["\n  color: ", ";\n"]);

var Wrapper$3 = styled.div(_templateObject$8, function (props) {
  return props.isDragging ? 0 : 1;
}, function (props) {
  return props.isDragging ? 0 : 1;
});
var Label = styled.label(_templateObject2$5);
var Index = styled.span(_templateObject3$4, function (props) {
  return props.theme.neutralDark["4"];
});
var ButtonGroup$1 = styled.div(_templateObject4$2);
var ImageName = styled.span(_templateObject5$2);
var ImageError = styled.span(_templateObject6$2, function (_ref) {
  var theme = _ref.theme;
  return theme.danger["2"];
});

var _templateObject$9 = taggedTemplateLiteral(["\n\tsvg {\n\t\tfill: ", ";\n\t}\n"], ["\n\tsvg {\n\t\tfill: ", ";\n\t}\n"]),
    _templateObject2$6 = taggedTemplateLiteral(["\n\twidth: 6em;\n\tpadding-left: 0;\n\tpadding-right: 0;\n"], ["\n\twidth: 6em;\n\tpadding-left: 0;\n\tpadding-right: 0;\n"]);

var Anchor = icons.Anchor,
    Move = icons.Move,
    Add = icons.Add,
    Delete = icons.Delete;
var DragHandle = iconButtonStyler(function (_ref) {
  var connectDragSource = _ref.connectDragSource,
      className = _ref.className,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;
  return connectDragSource(React.createElement("button", {
    className: className,
    onFocus: onFocus,
    onBlur: onBlur
  }, React.createElement(Move, null)));
});
var AnchorButton = styled(iconButtonStyler(function (props) {
  var anchor = props.anchor,
      rest = objectWithoutProperties(props, ["anchor"]);
  return React.createElement("button", rest, React.createElement(Anchor, null));
}))(_templateObject$9, function (props) {
  return props.anchor ? props.theme.primary["2"] : props.theme.primary["3"];
});
var StyledUpload = styled(Upload)(_templateObject2$6);

var Upload$1 = function Upload$$1(_ref2) {
  var id = _ref2.id,
      imageFilename = _ref2.imageFilename,
      uploadAnswerContentImage = _ref2.uploadAnswerContentImage,
      loading = _ref2.loading,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur;
  if (imageFilename) return React.createElement(ImageName, null, imageFilename);

  var onChange = function onChange(e) {
    var file = e.currentTarget.files[0];
    if (file === undefined) return;
    uploadAnswerContentImage(id, file);
  };

  return React.createElement(StyledUpload, {
    accept: "image/*",
    swatch: "neutralDark",
    loading: loading,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  });
};

var Controls = function Controls(_ref3) {
  var id = _ref3.id,
      connectDragSource = _ref3.connectDragSource,
      anchor = _ref3.anchor,
      toggleAnchor = _ref3.toggleAnchor,
      createAnswerContent = _ref3.createAnswerContent,
      deleteAnswerContent = _ref3.deleteAnswerContent,
      _ref3$addDisabled = _ref3.addDisabled,
      addDisabled = _ref3$addDisabled === undefined ? false : _ref3$addDisabled,
      _ref3$deleteDisabled = _ref3.deleteDisabled,
      deleteDisabled = _ref3$deleteDisabled === undefined ? false : _ref3$deleteDisabled,
      onFocus = _ref3.onFocus,
      onBlur = _ref3.onBlur,
      hasImage = _ref3.hasImage,
      imageFilename = _ref3.imageFilename,
      imageLoading = _ref3.imageLoading,
      uploadAnswerContentImage = _ref3.uploadAnswerContentImage,
      readOnly = _ref3.readOnly;
  var conditionalUpload = hasImage ? React.createElement(Upload$1, {
    id: id,
    loading: imageLoading,
    imageFilename: imageFilename,
    uploadAnswerContentImage: uploadAnswerContentImage,
    onFocus: function (_onFocus) {
      function onFocus() {
        return _onFocus.apply(this, arguments);
      }

      onFocus.toString = function () {
        return _onFocus.toString();
      };

      return onFocus;
    }(function () {
      return onFocus("upload");
    }),
    onBlur: function (_onBlur) {
      function onBlur() {
        return _onBlur.apply(this, arguments);
      }

      onBlur.toString = function () {
        return _onBlur.toString();
      };

      return onBlur;
    }(function () {
      return onBlur("upload");
    })
  }) : null;
  return React.createElement(ButtonGroup$1, null, React.createElement(Tooltip, {
    placement: "top",
    overlay: "Move"
  }, React.createElement(DragHandle, {
    connectDragSource: connectDragSource,
    onFocus: function (_onFocus2) {
      function onFocus() {
        return _onFocus2.apply(this, arguments);
      }

      onFocus.toString = function () {
        return _onFocus2.toString();
      };

      return onFocus;
    }(function () {
      return onFocus("move");
    }),
    onBlur: function (_onBlur2) {
      function onBlur() {
        return _onBlur2.apply(this, arguments);
      }

      onBlur.toString = function () {
        return _onBlur2.toString();
      };

      return onBlur;
    }(function () {
      return onBlur("move");
    }),
    disabled: readOnly
  })), React.createElement(Tooltip, {
    placement: "top",
    overlay: "Anchor"
  }, React.createElement(AnchorButton, {
    title: "Anchor",
    anchor: anchor,
    onClick: function onClick() {
      return toggleAnchor(id);
    },
    onFocus: function (_onFocus3) {
      function onFocus() {
        return _onFocus3.apply(this, arguments);
      }

      onFocus.toString = function () {
        return _onFocus3.toString();
      };

      return onFocus;
    }(function () {
      return onFocus("anchor");
    }),
    onBlur: function (_onBlur3) {
      function onBlur() {
        return _onBlur3.apply(this, arguments);
      }

      onBlur.toString = function () {
        return _onBlur3.toString();
      };

      return onBlur;
    }(function () {
      return onBlur("anchor");
    }),
    disabled: readOnly
  })), conditionalUpload, React.createElement(IconButton, {
    title: "Add",
    onClick: function onClick() {
      return createAnswerContent({
        after: id
      });
    },
    disabled: addDisabled || readOnly,
    onFocus: function (_onFocus4) {
      function onFocus() {
        return _onFocus4.apply(this, arguments);
      }

      onFocus.toString = function () {
        return _onFocus4.toString();
      };

      return onFocus;
    }(function () {
      return onFocus("add");
    }),
    onBlur: function (_onBlur4) {
      function onBlur() {
        return _onBlur4.apply(this, arguments);
      }

      onBlur.toString = function () {
        return _onBlur4.toString();
      };

      return onBlur;
    }(function () {
      return onBlur("add");
    })
  }, React.createElement(Add, null)), React.createElement(IconButton, {
    title: "Delete",
    onClick: function onClick() {
      return deleteAnswerContent(id);
    },
    disabled: deleteDisabled || readOnly,
    onFocus: function (_onFocus5) {
      function onFocus() {
        return _onFocus5.apply(this, arguments);
      }

      onFocus.toString = function () {
        return _onFocus5.toString();
      };

      return onFocus;
    }(function () {
      return onFocus("delete");
    }),
    onBlur: function (_onBlur5) {
      function onBlur() {
        return _onBlur5.apply(this, arguments);
      }

      onBlur.toString = function () {
        return _onBlur5.toString();
      };

      return onBlur;
    }(function () {
      return onBlur("delete");
    })
  }, React.createElement(Delete, null)));
};

var createAnswerContent = function createAnswerContent(payload) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_CREATE,
    payload: payload
  };
};

var deleteAnswerContent = function deleteAnswerContent(id) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_DELETE,
    payload: id
  };
};

var resetAnswerContentContent = function resetAnswerContentContent(id) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_RESET_CONTENT,
    payload: id
  };
};

var setAnswerContentContent = function setAnswerContentContent(id, content) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_SET_CONTENT,
    payload: {
      id: id,
      content: content
    }
  };
};

var toggleAnswerContentAnchor = function toggleAnswerContentAnchor(id) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_TOGGLE_ANCHOR,
    payload: id
  };
};

var moveAnswerContent = function moveAnswerContent(id, newSequence) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_MOVE,
    payload: {
      id: id,
      newSequence: newSequence
    }
  };
};

var uploadAnswerContentImage = function uploadAnswerContentImage(id, file) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_IMAGE_REQUEST,
    payload: {
      id: id,
      file: file
    }
  };
};

var answerContentImageSuccess = function answerContentImageSuccess(id, filename, url) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_IMAGE_SUCCESS,
    payload: {
      id: id,
      filename: filename,
      url: url
    }
  };
};

var answerContentImageError = function answerContentImageError(id, error) {
  return {
    type: answerContentTypes.ANSWER_CONTENT_IMAGE_ERROR,
    payload: {
      id: id,
      error: error
    }
  };
}; // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps = function makeMapStateToProps() {
  var answerContentSelector = makeAnswerContentSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _answerContentSelecto = answerContentSelector(state, ownProps.id),
        anchor = _answerContentSelecto.anchor,
        imageFilename = _answerContentSelecto.imageFilename,
        imageLoading = _answerContentSelecto.imageLoading;

    var _uiSelector = uiSelector(state),
        readOnly = _uiSelector.readOnly;

    return {
      anchor: anchor,
      imageFilename: imageFilename,
      imageLoading: imageLoading,
      readOnly: readOnly
    };
  };

  return mapStateToProps;
};

var ControlsContainer = connect(makeMapStateToProps, {
  toggleAnchor: toggleAnswerContentAnchor,
  createAnswerContent: createAnswerContent,
  deleteAnswerContent: deleteAnswerContent,
  uploadAnswerContentImage: uploadAnswerContentImage
})(Controls);

var Input = function Input(_ref) {
  var id = _ref.id,
      sequence = _ref.sequence,
      content = _ref.content,
      setContent = _ref.setContent,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      readOnly = _ref.readOnly;

  var onChange = function onChange(e) {
    return setContent(id, e.currentTarget.value);
  };

  return React.createElement(Label, null, React.createElement(Index, null, sequence), React.createElement(TextInput, {
    readOnly: readOnly,
    value: content,
    onChange: onChange,
    onFocus: function (_onFocus) {
      function onFocus() {
        return _onFocus.apply(this, arguments);
      }

      onFocus.toString = function () {
        return _onFocus.toString();
      };

      return onFocus;
    }(function () {
      return onFocus("input");
    }),
    onBlur: function (_onBlur) {
      function onBlur() {
        return _onBlur.apply(this, arguments);
      }

      onBlur.toString = function () {
        return _onBlur.toString();
      };

      return onBlur;
    }(function () {
      return onBlur("input");
    }),
    "data-testid": "ANSWER_CONTENT_INPUT"
  }));
}; // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$1 = function makeMapStateToProps() {
  var answerContentSelector = makeAnswerContentSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _answerContentSelecto = answerContentSelector(state, ownProps.id),
        sequence = _answerContentSelecto.sequence,
        content = _answerContentSelecto.content;

    var _uiSelector = uiSelector(state),
        readOnly = _uiSelector.readOnly;

    return {
      sequence: sequence,
      content: content,
      readOnly: readOnly
    };
  };

  return mapStateToProps;
};

var InputContainer = connect(makeMapStateToProps$1, {
  setContent: setAnswerContentContent
})(Input);

var AnswerContent$1 = function (_React$Component) {
  inherits(AnswerContent, _React$Component);

  function AnswerContent(props) {
    classCallCheck(this, AnswerContent);

    var _this = possibleConstructorReturn(this, (AnswerContent.__proto__ || Object.getPrototypeOf(AnswerContent)).call(this, props));

    _this.state = {
      focus: {}
    };
    _this.focusOn = _this.focusOn.bind(_this);
    _this.focusOff = _this.focusOff.bind(_this);
    _this.isFocused = _this.isFocused.bind(_this);
    return _this;
  }

  createClass(AnswerContent, [{
    key: "focusOn",
    value: function focusOn(key) {
      this.setState({
        focus: _extends$c({}, this.state.focus, defineProperty$3({}, key, true))
      });
    }
  }, {
    key: "focusOff",
    value: function focusOff(key) {
      var _this2 = this;

      this.props.resetAnswerContentContent(this.props.id);
      setTimeout(function () {
        _this2.setState({
          focus: _extends$c({}, _this2.state.focus, defineProperty$3({}, key, false))
        });
      }, 0);
    }
  }, {
    key: "isFocused",
    value: function isFocused() {
      return Object.values(this.state.focus).some(function (v) {
        return v;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          isDragging = _props.isDragging,
          className = _props.className,
          hasImage = _props.hasImage,
          readOnly = _props.readOnly,
          connectDropTarget = _props.connectDropTarget,
          connectDragPreview = _props.connectDragPreview,
          connectDragSource = _props.connectDragSource,
          addDisabled = _props.addDisabled,
          deleteDisabled = _props.deleteDisabled;
      var hasFocus = this.isFocused();
      var classNameWithFocus = (className || "") + " " + (hasFocus ? "focus" : "");
      var renderControls = !readOnly;
      var conditionalControls = renderControls ? React.createElement(ControlsContainer, {
        id: id,
        onFocus: this.focusOn,
        onBlur: this.focusOff,
        connectDragSource: connectDragSource,
        hasImage: hasImage,
        addDisabled: addDisabled,
        deleteDisabled: deleteDisabled
      }) : null;
      return connectDropTarget(React.createElement("div", null, connectDragPreview(React.createElement("div", null, React.createElement(Wrapper$3, {
        isDragging: isDragging,
        className: classNameWithFocus,
        key: id
      }, React.createElement(InputContainer, {
        id: id,
        onFocus: this.focusOn,
        onBlur: this.focusOff
      }), conditionalControls)))));
    }
  }]);
  return AnswerContent;
}(React.Component);

AnswerContent$1.defaultProps = {
  hasImage: false
};

var AnswerContentWithHover = function AnswerContentWithHover(props) {
  return React.createElement(_class, null, function (_ref) {
    var isHovering = _ref.isHovering;
    return React.createElement(AnswerContent$1, _extends$c({
      isHovering: isHovering
    }, props));
  });
};

var DragTypes = {
  ANSWER_CONTENT: "ANSWER_CONTENT",
  QUESTION_TYPE: "QUESTION_TYPE",
  QUESTION: "QUESTION",
  PAGE: "PAGE",
  SECTION: "SECTION",
  GROUP: "GROUP"
};
var dragSource = {
  canDrag: function canDrag(props) {
    return !props.readOnly;
  },
  beginDrag: function beginDrag(props, monitor, component) {
    var id = props.id,
        sequence = props.sequence;
    return {
      sequence: sequence,
      id: id
    };
  }
};
var dropTarget = {
  hover: function hover(props, monitor, component) {
    var hoverSequence = props.sequence,
        moveAnswerContent = props.moveAnswerContent;
    var dragSequence = monitor.getItem().sequence;
    if (dragSequence === hoverSequence) return; // Don't replace items with themselves

    var node = findDOMNode(component);

    if (!(node instanceof HTMLElement)) {
      console.warn("Expected drop target node to be an HTMLElement. Drop event cancelled.");
      return;
    }

    var hoverRect = node.getBoundingClientRect();
    var hoverMiddleY = (hoverRect.bottom - hoverRect.top) / 2;
    var clientOffset = monitor.getClientOffset(); // Determine mouse position

    var hoverClientY = clientOffset.y - hoverRect.top; // Get pixels to the top

    if (dragSequence < hoverSequence && hoverClientY < hoverMiddleY || // Dragging down
    dragSequence > hoverSequence && hoverClientY > hoverMiddleY // Dragging up
    ) {
        return;
      }

    moveAnswerContent(monitor.getItem().id, hoverSequence);
    monitor.getItem().sequence = hoverSequence;
  }
};
var AnswerContentSortable = lib_5$2(DragTypes.ANSWER_CONTENT, dropTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
})(lib_4$4(DragTypes.ANSWER_CONTENT, dragSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
})(AnswerContentWithHover));

var makeMapStateToProps$2 = function makeMapStateToProps() {
  var answerContentSelector = makeAnswerContentSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _answerContentSelecto = answerContentSelector(state, ownProps.id),
        sequence = _answerContentSelecto.sequence;

    var _uiSelector = uiSelector(state),
        readOnly = _uiSelector.readOnly;

    return {
      sequence: sequence,
      readOnly: readOnly
    };
  };

  return mapStateToProps;
};

var AnswerContentContainer = connect(makeMapStateToProps$2, {
  moveAnswerContent: moveAnswerContent,
  resetAnswerContentContent: resetAnswerContentContent
})( // $FlowFixMe
AnswerContentSortable);
var MOVE_LAST_QUESTION = "MOVE_LAST_QUESTION";
var DELETE_LAST_QUESTION = "DELETE_LAST_QUESTION";
var DELETE_PAGE = "DELETE_PAGE";
var BULK_ANSWERS = "BULK_ANSWERS";
var MOVE_ITEM_WARNING = "MOVE_ITEM_WARNING";

var _templateObject$a = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\t> span {\n\t\tmargin-right: 0.75em;\n\t}\n"], ["\n\tfont-size: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\t> span {\n\t\tmargin-right: 0.75em;\n\t}\n"]),
    _templateObject2$7 = taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tmargin-bottom: 1em;\n\tfont-size: 13px;\n\tcolor: ", ";\n\ttext-decoration: underline;\n"], ["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tmargin-bottom: 1em;\n\tfont-size: 13px;\n\tcolor: ", ";\n\ttext-decoration: underline;\n"]);

var ImageLabel = styled.label(_templateObject$a);
var Link$1 = styled.a(_templateObject2$7, function (props) {
  return props.theme.neutralDark["4"];
});

var List$e = function List(props) {
  var id = props.id,
      answers = props.answers,
      maxAnswers = props.maxAnswers,
      answerContents = props.answerContents,
      header = props.header,
      imageAnswers = props.imageAnswers,
      allowImages = props.allowImages,
      toggleQuestionAnswerImages = props.toggleQuestionAnswerImages,
      showModal = props.showModal,
      setAnswers = props.setAnswers,
      readOnly = props.readOnly;

  var showBulkAnswers = function showBulkAnswers() {
    return showModal(BULK_ANSWERS, {
      setAnswers: function (_setAnswers) {
        function setAnswers(_x) {
          return _setAnswers.apply(this, arguments);
        }

        setAnswers.toString = function () {
          return _setAnswers.toString();
        };

        return setAnswers;
      }(function (list) {
        return setAnswers(id, list);
      }),
      initialAnswers: answerContents,
      maxAnswers: maxAnswers
    });
  };

  var deleteDisabled = answers.length <= 2;
  var addDisabled = answers.length === maxAnswers;
  var conditionalLink = readOnly ? null : React.createElement(Link$1, {
    href: "#",
    onClick: showBulkAnswers
  }, "Add Bulk Answers");
  return React.createElement("div", null, React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, header || "Answer choices"), allowImages ? React.createElement(ImageLabel, null, React.createElement("span", null, "Add images"), " ", React.createElement(Toggle, {
    disabled: readOnly,
    checked: imageAnswers,
    onChange: function onChange() {
      return toggleQuestionAnswerImages(id);
    }
  })) : null), conditionalLink, React.createElement("div", null, answers.map(function (r) {
    return React.createElement(AnswerContentContainer, {
      deleteDisabled: deleteDisabled,
      addDisabled: addDisabled,
      key: r,
      id: r,
      hasImage: imageAnswers
    });
  })));
};

var showModal$1 = function showModal(modalType) {
  var modalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: modalTypes.MODAL_SHOW,
    payload: {
      modalType: modalType,
      modalProps: modalProps
    }
  };
};

var closeModal$1 = function closeModal() {
  return {
    type: modalTypes.MODAL_CLOSE
  };
};

var warnBreakingRelations = function warnBreakingRelations(breakingRelations, onConfirm) {
  return {
    type: modalTypes.MODAL_SHOW,
    payload: {
      modalType: MOVE_ITEM_WARNING,
      modalProps: {
        breakingRelations: breakingRelations,
        onConfirm: onConfirm
      }
    }
  };
};

var getChildren = function getChildren(rootNode) {
  return rootNode.outgoingEdges.toModelArray().map(function (e) {
    return e.headNode;
  });
};

var getForwardNodes = function getForwardNodes(node) {
  var queue = getChildren(node);
  var result = [];

  while (queue.length > 0) {
    var child = queue.pop();
    result.push(child);

    if (child.childGraph) {
      var rootNode = getRootNode(child.childGraph);
      queue.unshift.apply(queue, [rootNode].concat(toConsumableArray(getForwardNodes(rootNode))));
    }

    queue.unshift.apply(queue, toConsumableArray(getChildren(child)));
  }

  return uniqBy_1(result, function (node) {
    return node.id;
  });
}; // This function returns an array of consumer pipes
// that would break after moving the providing question to a new page.


var getBreakingConsumerPipes = function getBreakingConsumerPipes(question, forwardNodes, session) {
  var consumerPipes = question.consumerPipes;
  return consumerPipes.toModelArray().reduce(function (breakingPipes, pipe) {
    var consumerNode = pipe.endQuestion.page.node;
    if (forwardNodes.includes(consumerNode.ref)) return breakingPipes;
    return [].concat(toConsumableArray(breakingPipes), [pipe.id]);
  }, []);
};

var getBreakingProviderPipes = function getBreakingProviderPipes(question, previousNodes, session) {
  if (!question.providerPipe) return [];
  var providerPipe = question.providerPipe;
  var sourceQuestion = providerPipe.sourceQuestion;
  var sourceNode = sourceQuestion.page.node;
  if (previousNodes.includes(sourceNode.ref)) return [];
  return [providerPipe.id];
};

var getBreakingConditions = function getBreakingConditions(conditions, branchReducePredicate, pageSomePredicate) {
  var breakingConditions = conditions.filter(function (c) {
    var branches = c.logicBranches.toModelArray();
    var pages = branches.reduce(branchReducePredicate, []);
    return pages.some(pageSomePredicate);
  });
  return breakingConditions.map(function (c) {
    return c.id;
  });
};

var getBreakingSkipConditions = function getBreakingSkipConditions(conditions, targetNode) {
  var pagePredicate = function pagePredicate(page) {
    var nodes = [page.node.ref].concat(toConsumableArray(getPreviousNodes(page.node).map(function (n) {
      return n.ref;
    })));
    return !nodes.includes(targetNode);
  };

  var branchPredicate = function branchPredicate(list, branch) {
    return branch.skipLogicPage ? [].concat(toConsumableArray(list), [branch.skipLogicPage]) : list;
  };

  return getBreakingConditions(conditions, branchPredicate, pagePredicate);
};

var getBreakingDisplayConditions = function getBreakingDisplayConditions(conditions, targetNode) {
  var pagePredicate = function pagePredicate(page) {
    return !getPreviousNodes(page.node).map(function (n) {
      return n.ref;
    }).includes(targetNode);
  };

  var branchPredicate = function branchPredicate(list, branch) {
    return branch.displayLogicPage ? [].concat(toConsumableArray(list), [branch.displayLogicPage]) : list;
  };

  return getBreakingConditions(conditions, branchPredicate, pagePredicate);
};
/**
 * getBreakingRelations builds an object of related models that will break
 * upon moving the given question to the given page. The object's keys are undefined
 * if no breaking relations of that type apply.
 */


var getBreakingRelations = function getBreakingRelations(question, forwardNodes, previousNodes, rootNode, session) {
  var providerPipes = getBreakingProviderPipes(question, previousNodes, session);
  var consumerPipes = getBreakingConsumerPipes(question, forwardNodes, session);
  var allConditions = question.referencingConditions.toModelArray();
  var skipConditions = getBreakingSkipConditions(allConditions, rootNode);
  var displayConditions = getBreakingDisplayConditions(allConditions, rootNode);
  return _extends$c({}, providerPipes.length ? {
    providerPipes: providerPipes
  } : undefined, consumerPipes.length ? {
    consumerPipes: consumerPipes
  } : undefined, skipConditions.length ? {
    skipConditions: skipConditions
  } : undefined, displayConditions.length ? {
    displayConditions: displayConditions
  } : undefined);
}; // This function injects some default values for type-specific attributes.


var configNewQuestionPayload = function configNewQuestionPayload(payload) {
  switch (payload.type) {
    case "rating":
      return _extends$c({
        steps: 10
      }, payload);

    case "short_text_input":
      return _extends$c({
        minLength: 1,
        maxLength: 400
      }, payload);

    case "long_text_input":
      return _extends$c({
        minLength: 1,
        maxLength: 2000
      }, payload);

    case "slider":
      return _extends$c({
        minValue: 0,
        maxValue: 10,
        increment: 1
      }, payload);

    case "numeric":
      return _extends$c({
        minValue: 1,
        maxValue: 100
      }, payload);

    case "sum":
      return _extends$c({
        targetSum: 100
      }, payload);

    default:
      return payload;
  }
};

var createQuestion$1 = function createQuestion(payload) {
  var configuredPayload = configNewQuestionPayload(payload);
  return {
    type: questionTypes.QUESTION_CREATE,
    payload: configuredPayload
  };
};

var deleteQuestion = function deleteQuestion(id) {
  return {
    type: questionTypes.QUESTION_DELETE,
    payload: id
  };
};

var resetQuestionContent = function resetQuestionContent(id) {
  return {
    type: questionTypes.QUESTION_RESET_CONTENT,
    payload: id
  };
};

var moveQuestionUnsafe = function moveQuestionUnsafe(id, page, after, breakingRelations) {
  return {
    type: questionTypes.QUESTION_MOVE_UNSAFE,
    payload: {
      id: id,
      page: page,
      after: after,
      breakingRelations: breakingRelations
    }
  };
};

var moveQuestion = function moveQuestion(id, pageId, after) {
  return function (dispatch, getState) {
    var ormState = selectOrm(getState());
    var session = orm.session(ormState);
    var rootNode = session.Page.withId(pageId).node;
    var question = session.Question.withId(id);
    var forwardNodes = getForwardNodes(rootNode).map(function (n) {
      return n.ref;
    });
    var previousNodes = getPreviousNodes(rootNode).map(function (n) {
      return n.ref;
    });
    var breakingRelations = getBreakingRelations(question, forwardNodes, previousNodes, rootNode.ref, session);

    var dispatchMove = function dispatchMove() {
      return dispatch(moveQuestionUnsafe(id, pageId, after, breakingRelations));
    };

    if (Object.keys(breakingRelations).length) {
      return dispatch(warnBreakingRelations(breakingRelations, dispatchMove));
    }

    return dispatchMove();
  };
};

var updateQuestionEditor = function updateQuestionEditor(id, draftRawContent, selectionState) {
  return {
    type: questionTypes.QUESTION_UPDATE_EDITOR,
    payload: {
      id: id,
      draftRawContent: draftRawContent,
      selectionState: selectionState
    }
  };
};

var duplicateQuestion = function duplicateQuestion(payload) {
  return {
    type: questionTypes.QUESTION_DUPLICATE,
    payload: payload
  };
};

var toggleQuestionRatingType = function toggleQuestionRatingType(payload) {
  return {
    type: questionTypes.QUESTION_TOGGLE_RATING_TYPE,
    payload: payload
  };
};

var toggleQuestionSliderType = function toggleQuestionSliderType(payload) {
  return {
    type: questionTypes.QUESTION_TOGGLE_SLIDER_TYPE,
    payload: payload
  };
};

var toggleQuestionDescription = function toggleQuestionDescription(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_DESCRIPTION,
    payload: id
  };
};

var toggleQuestionRequired = function toggleQuestionRequired(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_REQUIRED,
    payload: id
  };
};

var toggleQuestionRandomSort = function toggleQuestionRandomSort(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_RANDOM_SORT,
    payload: id
  };
};

var toggleQuestionReverseSort = function toggleQuestionReverseSort(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_REVERSE_SORT,
    payload: id
  };
};

var toggleQuestionAnswerImages = function toggleQuestionAnswerImages(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_ANSWER_IMAGES,
    payload: id
  };
};

var setQuestionDescription = function setQuestionDescription(id, description) {
  return {
    type: questionTypes.QUESTION_SET_DESCRIPTION,
    payload: {
      id: id,
      description: description
    }
  };
};

var toggleQuestionMedia = function toggleQuestionMedia(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_MEDIA,
    payload: id
  };
};

var toggleQuestionMediaType = function toggleQuestionMediaType(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_MEDIA_TYPE,
    payload: id
  };
};

var setQuestionMinAnswers = function setQuestionMinAnswers(id, min) {
  return {
    type: questionTypes.QUESTION_SET_MIN_ANSWERS,
    payload: {
      id: id,
      min: min
    }
  };
};

var setQuestionMaxAnswers = function setQuestionMaxAnswers(id, max) {
  return {
    type: questionTypes.QUESTION_SET_MAX_ANSWERS,
    payload: {
      id: id,
      max: max
    }
  };
};

var setQuestionMinLength = function setQuestionMinLength(id, minLength) {
  return {
    type: questionTypes.QUESTION_SET_MIN_LENGTH,
    payload: {
      id: id,
      minLength: minLength
    }
  };
};

var setQuestionMaxLength = function setQuestionMaxLength(id, maxLength) {
  return {
    type: questionTypes.QUESTION_SET_MAX_LENGTH,
    payload: {
      id: id,
      maxLength: maxLength
    }
  };
};

var reconcileQuestionLength = function reconcileQuestionLength(id) {
  return {
    type: questionTypes.QUESTION_RECONCILE_LENGTH,
    payload: id
  };
};

var setQuestionMinValue = function setQuestionMinValue(id, minValue) {
  return {
    type: questionTypes.QUESTION_SET_MIN_VALUE,
    payload: {
      id: id,
      minValue: minValue
    }
  };
};

var setQuestionMaxValue = function setQuestionMaxValue(id, maxValue) {
  return {
    type: questionTypes.QUESTION_SET_MAX_VALUE,
    payload: {
      id: id,
      maxValue: maxValue
    }
  };
};

var setQuestionIncrement = function setQuestionIncrement(id, increment) {
  return {
    type: questionTypes.QUESTION_SET_INCREMENT,
    payload: {
      id: id,
      increment: increment
    }
  };
};

var setQuestionSteps = function setQuestionSteps(id, steps) {
  return {
    type: questionTypes.QUESTION_SET_STEPS,
    payload: {
      id: id,
      steps: steps
    }
  };
};

var toggleQuestionValidatesSum = function toggleQuestionValidatesSum(id) {
  return {
    type: questionTypes.QUESTION_TOGGLE_VALIDATES_SUM,
    payload: id
  };
};

var setQuestionTargetSum = function setQuestionTargetSum(id, targetSum) {
  return {
    type: questionTypes.QUESTION_SET_TARGET_SUM,
    payload: {
      id: id,
      targetSum: targetSum
    }
  };
};

var uploadQuestionImage = function uploadQuestionImage(id, file) {
  return {
    type: questionTypes.QUESTION_IMAGE_REQUEST,
    payload: {
      id: id,
      file: file
    }
  };
};

var questionImageSuccess = function questionImageSuccess(id, filename, url) {
  return {
    type: questionTypes.QUESTION_IMAGE_SUCCESS,
    payload: {
      id: id,
      filename: filename,
      url: url
    }
  };
};

var questionImageError = function questionImageError(id, error) {
  return {
    type: questionTypes.QUESTION_IMAGE_ERROR,
    payload: {
      id: id,
      error: error
    }
  };
};

var clearQuestionImage = function clearQuestionImage(id) {
  return {
    type: questionTypes.QUESTION_IMAGE_CLEAR,
    payload: id
  };
};

var setQuestionVideoUrl = function setQuestionVideoUrl(id, url) {
  return {
    type: questionTypes.QUESTION_SET_VIDEO_URL,
    payload: {
      id: id,
      url: url
    }
  };
};

var setQuestionRows$1 = function setQuestionRows(id, rows) {
  return {
    type: questionTypes.QUESTION_SET_ROWS,
    payload: {
      id: id,
      rows: rows
    }
  };
};

var setQuestionColumns$1 = function setQuestionColumns(id, columns) {
  return {
    type: questionTypes.QUESTION_SET_COLUMNS,
    payload: {
      id: id,
      columns: columns
    }
  };
};

var getProps = makeRowModelSelector();
var getRows = makeRowsWithContentSelector();

var mapStateToProps$5 = function mapStateToProps(state, ownProps) {
  var _getProps = getProps(state, ownProps.id),
      imageAnswers = _getProps.imageAnswers,
      maxRows = _getProps.maxRows,
      allowRowImages = _getProps.allowRowImages;

  var _getRows = getRows(state, ownProps.id),
      rows = _getRows.rows,
      rowContents = _getRows.rowContents;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    imageAnswers: imageAnswers,
    readOnly: readOnly,
    answerContents: rowContents,
    answers: rows,
    maxAnswers: maxRows,
    allowImages: allowRowImages
  };
};

var RowListContainer = connect(mapStateToProps$5, {
  toggleQuestionAnswerImages: toggleQuestionAnswerImages,
  setAnswers: setQuestionRows$1,
  showModal: showModal$1
})(List$e);
var getProps$1 = makeColumnModelSelector();
var getColumns = makeDiscreteColumnsSelector();

var mapStateToProps$6 = function mapStateToProps(state, ownProps) {
  var _getProps = getProps$1(state, ownProps.id),
      imageAnswers = _getProps.imageAnswers,
      maxColumns = _getProps.maxColumns,
      allowColumnImages = _getProps.allowColumnImages;

  var _getColumns = getColumns(state, ownProps.id),
      columns = _getColumns.columns,
      columnContents = _getColumns.columnContents;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    imageAnswers: imageAnswers,
    readOnly: readOnly,
    answerContents: columnContents,
    answers: columns,
    maxAnswers: maxColumns,
    allowImages: allowColumnImages
  };
};

var ColumnListContainer = connect(mapStateToProps$6, {
  toggleQuestionAnswerImages: toggleQuestionAnswerImages,
  setAnswers: setQuestionColumns$1,
  showModal: showModal$1
})(List$e);

var TextOptions = function TextOptions(_ref) {
  var id = _ref.id,
      min = _ref.min,
      max = _ref.max,
      upperBound = _ref.upperBound,
      readOnly = _ref.readOnly,
      setQuestionMinLength = _ref.setQuestionMinLength,
      setQuestionMaxLength = _ref.setQuestionMaxLength,
      reconcileQuestionLength = _ref.reconcileQuestionLength;
  return React.createElement("div", null, React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Minimum Characters"), React.createElement(TextInput, {
    type: "number",
    value: min,
    onChange: function onChange(e) {
      return setQuestionMinLength(id, parseInt(e.target.value, 10));
    },
    onBlur: function onBlur() {
      return reconcileQuestionLength(id);
    },
    min: 0,
    max: upperBound,
    readOnly: readOnly
  })), React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Maximum Characters"), React.createElement(TextInput, {
    type: "number",
    value: max,
    onChange: function onChange(e) {
      return setQuestionMaxLength(id, parseInt(e.target.value, 10));
    },
    onBlur: function onBlur() {
      return reconcileQuestionLength(id);
    },
    min: 0,
    max: upperBound,
    readOnly: readOnly
  })));
};

var getText = makeTextSelector();

function mapStateToProps$7(state, ownProps) {
  var _getText = getText(state, ownProps.id),
      min = _getText.min,
      max = _getText.max,
      upperBound = _getText.upperBound;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    min: min,
    max: max,
    upperBound: upperBound,
    readOnly: readOnly
  };
}

var dispatchProps = {
  setQuestionMinLength: setQuestionMinLength,
  setQuestionMaxLength: setQuestionMaxLength,
  reconcileQuestionLength: reconcileQuestionLength
};
var TextContainer = connect(mapStateToProps$7, dispatchProps)(TextOptions);

var _templateObject$b = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tlabel {\n\t\tflex-grow: 1;\n\t}\n\t.Select {\n\t\tmin-width: 65px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tlabel {\n\t\tflex-grow: 1;\n\t}\n\t.Select {\n\t\tmin-width: 65px;\n\t}\n"]);

var StyledSegment = styled(DrawerBodySegment)(_templateObject$b);

var Steps = function Steps(props) {
  var id = props.id,
      steps = props.steps,
      setQuestionSteps = props.setQuestionSteps,
      readOnly = props.readOnly;
  var _questionConfigs$rati = questionConfigs["rating"],
      minSteps = _questionConfigs$rati.minSteps,
      maxSteps = _questionConfigs$rati.maxSteps;

  var onChange = function onChange(e) {
    return setQuestionSteps(id, e.currentTarget.value);
  };

  return React.createElement(StyledSegment, null, React.createElement(DrawerBodyLabel, null, "Steps"), React.createElement(TextInput, {
    onChange: onChange,
    value: steps,
    type: "number",
    readOnly: readOnly,
    min: minSteps,
    max: maxSteps
  }));
};

var RatingToggle = function RatingToggle(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      readOnly = _ref.readOnly,
      toggleType = _ref.toggleType;

  var onChange = function onChange() {
    return toggleType(id);
  };

  return React.createElement(DrawerBodySegment, null, React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Multiple Ratings"), React.createElement(Toggle, {
    disabled: readOnly,
    onChange: onChange,
    checked: checked
  })));
};

var RatingOptions = function RatingOptions(props) {
  var id = props.id,
      steps = props.steps,
      readOnly = props.readOnly,
      setQuestionSteps = props.setQuestionSteps,
      toggleType = props.toggleType,
      multiple = props.multiple;
  return React.createElement("div", null, React.createElement(Steps, {
    id: id,
    steps: steps,
    readOnly: readOnly,
    setQuestionSteps: setQuestionSteps
  }), React.createElement(RatingToggle, {
    id: id,
    checked: multiple,
    readOnly: readOnly,
    toggleType: toggleType
  }));
};

var getRating = makeRatingSelector();

var mapStateToProps$8 = function mapStateToProps(state, ownProps) {
  var id = ownProps.id;

  var _getRating = getRating(state, id),
      steps = _getRating.steps,
      multiple = _getRating.multiple;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    steps: steps,
    readOnly: readOnly,
    multiple: multiple
  };
};

var dispatchProps$1 = {
  setQuestionSteps: setQuestionSteps,
  toggleType: toggleQuestionRatingType
};
var RatingContainer = connect(mapStateToProps$8, dispatchProps$1)(RatingOptions);

var _templateObject$c = taggedTemplateLiteral(["\n\twidth: 4em;\n\tpadding: 0.6em 0.4em 0.6em 0.9em;\n"], ["\n\twidth: 4em;\n\tpadding: 0.6em 0.4em 0.6em 0.9em;\n"]);

var StyledInput = styled(TextInput)(_templateObject$c);

var SliderOptions = function (_React$Component) {
  inherits(SliderOptions, _React$Component);

  function SliderOptions(props) {
    classCallCheck(this, SliderOptions);

    var _this = possibleConstructorReturn(this, (SliderOptions.__proto__ || Object.getPrototypeOf(SliderOptions)).call(this, props));

    _this.handleMinValueChange = _this.handleMinValueChange.bind(_this);
    _this.handleMaxValueChange = _this.handleMaxValueChange.bind(_this);
    _this.handleIncrementChange = _this.handleIncrementChange.bind(_this);
    return _this;
  }

  createClass(SliderOptions, [{
    key: "handleMinValueChange",
    value: function handleMinValueChange(e) {
      var _props = this.props,
          id = _props.id,
          setQuestionMinValue = _props.setQuestionMinValue;
      var value = parseFloat(e.target.value);
      setQuestionMinValue(id, value);
    }
  }, {
    key: "handleMaxValueChange",
    value: function handleMaxValueChange(e) {
      var _props2 = this.props,
          id = _props2.id,
          setQuestionMaxValue = _props2.setQuestionMaxValue;
      var value = parseFloat(e.target.value);
      setQuestionMaxValue(id, value);
    }
  }, {
    key: "handleIncrementChange",
    value: function handleIncrementChange(e) {
      // TODO: Add restriction/validation to increment field
      var _props3 = this.props,
          id = _props3.id,
          setQuestionIncrement = _props3.setQuestionIncrement;
      var value = parseFloat(e.target.value);
      setQuestionIncrement(id, value);
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          id = _props4.id,
          min = _props4.min,
          max = _props4.max,
          increment = _props4.increment,
          readOnly = _props4.readOnly,
          multiple = _props4.multiple,
          toggleType = _props4.toggleType;
      return React.createElement("div", null, React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Min Value"), React.createElement(StyledInput, {
        onChange: this.handleMinValueChange,
        value: min,
        type: "number",
        readOnly: readOnly
      })), React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Max Value"), React.createElement(StyledInput, {
        onChange: this.handleMaxValueChange,
        value: max,
        type: "number",
        readOnly: readOnly
      })), React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Increment"), React.createElement(StyledInput, {
        onChange: this.handleIncrementChange,
        value: increment,
        type: "number",
        readOnly: readOnly
      })), React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Multiple Sliders"), React.createElement(Toggle, {
        disabled: readOnly,
        onChange: function onChange() {
          return toggleType(id);
        },
        checked: multiple
      })));
    }
  }]);
  return SliderOptions;
}(React.Component);

var getSlider = makeSliderSelector();

var mapStateToProps$9 = function mapStateToProps(state, ownProps) {
  var _getSlider = getSlider(state, ownProps.id),
      min = _getSlider.min,
      max = _getSlider.max,
      increment = _getSlider.increment,
      multiple = _getSlider.multiple;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    min: min,
    max: max,
    increment: increment,
    multiple: multiple,
    readOnly: readOnly
  };
};

var dispatchProps$2 = {
  setQuestionMinValue: setQuestionMinValue,
  setQuestionMaxValue: setQuestionMaxValue,
  setQuestionIncrement: setQuestionIncrement,
  toggleType: toggleQuestionSliderType
};
var SliderContainer = connect(mapStateToProps$9, dispatchProps$2)(SliderOptions);

var _templateObject$d = taggedTemplateLiteral(["\n\twidth: 4em;\n\tpadding: 0.6em 0.4em 0.6em 0.9em;\n"], ["\n\twidth: 4em;\n\tpadding: 0.6em 0.4em 0.6em 0.9em;\n"]);

var StyledInput$1 = styled(TextInput)(_templateObject$d);

var NumericOptions = function (_React$Component) {
  inherits(NumericOptions, _React$Component);

  function NumericOptions(props) {
    classCallCheck(this, NumericOptions);

    var _this = possibleConstructorReturn(this, (NumericOptions.__proto__ || Object.getPrototypeOf(NumericOptions)).call(this, props));

    _this.handleMinValueChange = _this.handleMinValueChange.bind(_this);
    _this.handleMaxValueChange = _this.handleMaxValueChange.bind(_this);
    return _this;
  }

  createClass(NumericOptions, [{
    key: "handleMinValueChange",
    value: function handleMinValueChange(e) {
      var _props = this.props,
          id = _props.id,
          setQuestionMinValue = _props.setQuestionMinValue;
      var min = parseFloat(e.currentTarget.value);
      setQuestionMinValue(id, min);
    }
  }, {
    key: "handleMaxValueChange",
    value: function handleMaxValueChange(e) {
      var _props2 = this.props,
          id = _props2.id,
          setQuestionMaxValue = _props2.setQuestionMaxValue;
      var max = parseFloat(e.currentTarget.value);
      setQuestionMaxValue(id, max);
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          min = _props3.min,
          max = _props3.max,
          readOnly = _props3.readOnly;
      return React.createElement(DrawerBodySegment, null, React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Min Value"), React.createElement(StyledInput$1, {
        onChange: this.handleMinValueChange,
        value: min,
        type: "number",
        readOnly: readOnly
      })), React.createElement(DrawerBodyRow, null, React.createElement(DrawerBodyLabel, null, "Max Value"), React.createElement(StyledInput$1, {
        onChange: this.handleMaxValueChange,
        value: max,
        type: "number",
        readOnly: readOnly
      })));
    }
  }]);
  return NumericOptions;
}(React.Component);

var getNumeric = makeNumericSelector();

var mapStateToProps$a = function mapStateToProps(state, ownProps) {
  var _getNumeric = getNumeric(state, ownProps.id),
      min = _getNumeric.min,
      max = _getNumeric.max;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    min: min,
    max: max,
    readOnly: readOnly
  };
};

var dispatchProps$3 = {
  setQuestionMinValue: setQuestionMinValue,
  setQuestionMaxValue: setQuestionMaxValue
};
var NumericContainer = connect(mapStateToProps$a, dispatchProps$3)(NumericOptions);

var _templateObject$e = taggedTemplateLiteral(["\n\tdiv:first-child {\n\t\tflex-grow: 1;\n\t}\n\tdisplay: flex;\n\talign-items: center;\n\tspan {\n\t\tmargin-right: 1em;\n\t}\n\tinput {\n\t\twidth: 3.5em;\n\t}\n"], ["\n\tdiv:first-child {\n\t\tflex-grow: 1;\n\t}\n\tdisplay: flex;\n\talign-items: center;\n\tspan {\n\t\tmargin-right: 1em;\n\t}\n\tinput {\n\t\twidth: 3.5em;\n\t}\n"]);

var Wrapper$4 = styled.div(_templateObject$e);

var SumOptions = function (_React$Component) {
  inherits(SumOptions, _React$Component);

  function SumOptions(props) {
    classCallCheck(this, SumOptions);

    var _this = possibleConstructorReturn(this, (SumOptions.__proto__ || Object.getPrototypeOf(SumOptions)).call(this, props));

    _this.setSum = _this.setSum.bind(_this);
    _this.toggleValidate = _this.toggleValidate.bind(_this);
    return _this;
  }

  createClass(SumOptions, [{
    key: "setSum",
    value: function setSum(e) {
      var _props = this.props,
          id = _props.id,
          setQuestionTargetSum = _props.setQuestionTargetSum;
      var value = parseFloat(e.currentTarget.value);
      setQuestionTargetSum(id, value);
    }
  }, {
    key: "toggleValidate",
    value: function toggleValidate() {
      var _props2 = this.props,
          id = _props2.id,
          toggleQuestionValidatesSum = _props2.toggleQuestionValidatesSum;
      toggleQuestionValidatesSum(id);
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          validatesSum = _props3.validatesSum,
          targetSum = _props3.targetSum,
          readOnly = _props3.readOnly;
      return React.createElement(Wrapper$4, null, React.createElement("div", null, React.createElement("span", null, "Validate that sum equals:"), React.createElement(TextInput, {
        disabled: !validatesSum,
        value: targetSum,
        type: "number",
        min: 1,
        onChange: this.setSum,
        readOnly: readOnly
      })), React.createElement(Toggle, {
        disabled: readOnly,
        checked: validatesSum,
        onChange: this.toggleValidate
      }));
    }
  }]);
  return SumOptions;
}(React.Component);

var getSum = makeSumSelector();

var mapStateToProps$b = function mapStateToProps(state, ownProps) {
  var _getSum = getSum(state, ownProps.id),
      validatesSum = _getSum.validatesSum,
      targetSum = _getSum.targetSum;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    validatesSum: validatesSum,
    targetSum: targetSum,
    readOnly: readOnly
  };
};

var dispatchProps$4 = {
  toggleQuestionValidatesSum: toggleQuestionValidatesSum,
  setQuestionTargetSum: setQuestionTargetSum
};
var SumContainer = connect(mapStateToProps$b, dispatchProps$4)(SumOptions);

var _templateObject$f = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n"]),
    _templateObject2$8 = taggedTemplateLiteral(["\n\tflex-grow: 1;\n"], ["\n\tflex-grow: 1;\n"]);

var FlexLabel = styled.label(_templateObject$f);
var Name = styled.span(_templateObject2$8);

var ToggleRow = function ToggleRow(_ref) {
  var readOnly = _ref.readOnly,
      label = _ref.label,
      checked = _ref.checked,
      onChange = _ref.onChange;
  return React.createElement(DrawerBodyRow, null, React.createElement(FlexLabel, null, React.createElement(Name, null, label), React.createElement(Toggle, {
    disabled: !!readOnly,
    checked: checked,
    onChange: onChange
  })));
};

var getProps$2 = makeQuestionTypeModelSelector();

var mapStateToProps$c = function mapStateToProps(state, ownProps) {
  var typeModel = getProps$2(state, ownProps.id);
  if (typeModel.require === undefined) throw new Error("No require prop found for question with id " + ownProps.id);
  var require = typeModel.require;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    label: "Require this question",
    checked: require,
    readOnly: readOnly
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onChange: function onChange() {
      return dispatch(toggleQuestionRequired(ownProps.id));
    }
  };
};

var RequireOptionContainer = connect(mapStateToProps$c, mapDispatchToProps)(ToggleRow);

var RowOptions = function RowOptions(_ref) {
  var id = _ref.id,
      readOnly = _ref.readOnly,
      require = _ref.require,
      sortType = _ref.sortType,
      toggleQuestionRandomSort = _ref.toggleQuestionRandomSort,
      toggleQuestionReverseSort = _ref.toggleQuestionReverseSort;
  return React.createElement("div", null, React.createElement(ToggleRow, {
    label: "Randomize answer choices",
    checked: sortType === "randomize",
    onChange: function onChange() {
      return toggleQuestionRandomSort(id);
    },
    readOnly: readOnly
  }), React.createElement(ToggleRow, {
    label: "Reverse order answer choices",
    checked: sortType === "reverse",
    onChange: function onChange() {
      return toggleQuestionReverseSort(id);
    },
    readOnly: readOnly
  }));
};

var getProps$3 = makeRowModelSelector();

var mapStateToProps$d = function mapStateToProps(state, ownProps) {
  var _getProps = getProps$3(state, ownProps.id),
      sortType = _getProps.sortType;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    sortType: sortType,
    readOnly: readOnly
  };
};

var dispatchProps$5 = {
  toggleQuestionRandomSort: toggleQuestionRandomSort,
  toggleQuestionReverseSort: toggleQuestionReverseSort
};
var RowOptionsContainer = connect(mapStateToProps$d, dispatchProps$5)(RowOptions);
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeCeil = Math.ceil,
    nativeMax$3 = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */

function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$3(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }

  return result;
}

var _baseRange = baseRange;
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */

function createRange(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != 'number' && _isIterateeCall(start, end, step)) {
      end = step = undefined;
    } // Ensure the sign of `-0` is preserved.


    start = toFinite_1(start);

    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite_1(end);
    }

    step = step === undefined ? start < end ? 1 : -1 : toFinite_1(step);
    return _baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange;
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */

var range = _createRange();

var range_1 = range;

var NumberSelect = function NumberSelect(props) {
  var max = props.max,
      value = props.value,
      onChange = props.onChange,
      readOnly = props.readOnly;
  var numberRange = range_1(1, max);
  var options = numberRange.map(function (num) {
    return {
      value: num,
      label: num
    };
  });
  return React.createElement(Select, {
    disabled: readOnly,
    searchable: false,
    placeholder: "",
    options: options,
    value: options.find(function (o) {
      return o.value === value;
    }),
    onChange: onChange
  });
};

var MultipleRowOptions = function MultipleRowOptions(_ref) {
  var id = _ref.id,
      readOnly = _ref.readOnly,
      rowCount = _ref.rowCount,
      minAnswers = _ref.minAnswers,
      maxAnswers = _ref.maxAnswers,
      setQuestionMinAnswers = _ref.setQuestionMinAnswers,
      setQuestionMaxAnswers = _ref.setQuestionMaxAnswers;
  return React.createElement("div", null, React.createElement(DrawerBodyRow, null, React.createElement("label", null, "Minimum number of answers required"), React.createElement(NumberSelect, {
    readOnly: readOnly,
    max: rowCount + 1,
    value: minAnswers,
    onChange: function onChange(option) {
      var value = option ? option.value : null;
      setQuestionMinAnswers(id, value);
    }
  })), React.createElement(DrawerBodyRow, null, React.createElement("label", null, "Maximum number of answers required"), React.createElement(NumberSelect, {
    readOnly: readOnly,
    max: rowCount + 1,
    value: maxAnswers,
    onChange: function onChange(option) {
      var value = option ? option.value : null;
      setQuestionMaxAnswers(id, value);
    }
  })));
};

var getModel = makeMultipleSelectSelector();
var getRowCount = makeRowCountSelector();

var mapStateToProps$e = function mapStateToProps(state, ownProps) {
  var _getModel = getModel(state, ownProps.id),
      min = _getModel.min,
      max = _getModel.max;

  var rowCount = getRowCount(state, ownProps.id);

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    minAnswers: min,
    maxAnswers: max,
    readOnly: readOnly,
    rowCount: rowCount
  };
};

var dispatchProps$6 = {
  setQuestionMaxAnswers: setQuestionMaxAnswers,
  setQuestionMinAnswers: setQuestionMinAnswers
};
var MultipleRowOptionsContainer = connect(mapStateToProps$e, dispatchProps$6)(MultipleRowOptions);

var _templateObject$g = taggedTemplateLiteral(["\n  position: relative;\n  svg {\n    font-size: 1em;\n    display: inline-block;\n    height: 1em;\n    width: 1em;\n    position: absolute;\n    left: 1em;\n    pointer-events: none;\n  }\n  input {\n    margin-right: 0.7em;\n    padding-right: 1em;\n    &:disabled + svg {\n      fill: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  svg {\n    font-size: 1em;\n    display: inline-block;\n    height: 1em;\n    width: 1em;\n    position: absolute;\n    left: 1em;\n    pointer-events: none;\n  }\n  input {\n    margin-right: 0.7em;\n    padding-right: 1em;\n    &:disabled + svg {\n      fill: ", ";\n    }\n  }\n"]);

var Wrapper$5 = styled(Wrapper$3)(_templateObject$g, function (props) {
  return props.theme.neutralLight["3"];
});

var SpecialOption$1 = function SpecialOption(_ref) {
  var id = _ref.id,
      questionId = _ref.questionId,
      type = _ref.type,
      text = _ref.text,
      readOnly = _ref.readOnly,
      createSpecialOption = _ref.createSpecialOption,
      deleteSpecialOption = _ref.deleteSpecialOption,
      setSpecialOptionText = _ref.setSpecialOptionText,
      defaultText = _ref.defaultText,
      Icon = _ref.Icon;
  var exists = id !== undefined;
  var handleChange = id === undefined ? function () {
    return createSpecialOption(questionId, type);
  } : function () {
    return deleteSpecialOption(id);
  };
  return React.createElement(Wrapper$5, null, React.createElement(TextInput, {
    readOnly: readOnly,
    disabled: id === undefined,
    value: text || defaultText,
    onChange: function onChange(e) {
      return setSpecialOptionText(id, e.currentTarget.value);
    }
  }), React.createElement(Icon, null), React.createElement(Toggle, {
    disabled: readOnly,
    onChange: handleChange,
    checked: exists
  }));
};

var createSpecialOption = function createSpecialOption(question, type) {
  var typedPayload = function () {
    switch (type) {
      case "other":
        return {
          text: "Other",
          openAnswerRequired: true,
          openAnswerText: "Please specify"
        };

      case "none":
        return {
          text: "None of the above"
        };

      default:
        throw new Error("Unrecognized special option type " + type);
    }
  }();

  return {
    type: specialOptionTypes.SPECIAL_OPTION_CREATE,
    payload: _extends$c({
      question: question,
      type: type
    }, typedPayload)
  };
};

var deleteSpecialOption = function deleteSpecialOption(id) {
  return {
    type: specialOptionTypes.SPECIAL_OPTION_DELETE,
    payload: id
  };
};

var setSpecialOptionText = function setSpecialOptionText(id, text) {
  return {
    type: specialOptionTypes.SPECIAL_OPTION_SET_TEXT,
    payload: {
      id: id,
      text: text
    }
  };
};

var toggleSpecialOptionOpenAnswerRequired = function toggleSpecialOptionOpenAnswerRequired(id) {
  return {
    type: specialOptionTypes.SPECIAL_OPTION_TOGGLE_OPEN_ANSWER_REQUIRED,
    payload: id
  };
};

var setSpecialOptionOpenAnswerText = function setSpecialOptionOpenAnswerText(id, text) {
  return {
    type: specialOptionTypes.SPECIAL_OPTION_SET_OPEN_ANSWER_TEXT,
    payload: {
      id: id,
      text: text
    }
  };
};

var mapStateToProps$f = function mapStateToProps(state, ownProps) {
  var base = {
    readOnly: uiSelector(state).readOnly
  };

  if (ownProps.id !== undefined) {
    var specialOption = specialOptionSelector(state, ownProps.id);
    return _extends$c({}, base, specialOption);
  }

  return base;
};

var dispatchProps$7 = {
  setSpecialOptionText: setSpecialOptionText,
  createSpecialOption: createSpecialOption,
  deleteSpecialOption: deleteSpecialOption
};
var SpecialOptionContainer = connect(mapStateToProps$f, dispatchProps$7)(SpecialOption$1);

var _templateObject$h = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tmargin-left: 2em;\n"], ["\n\tfont-size: 12px;\n\tmargin-left: 2em;\n"]),
    _templateObject2$9 = taggedTemplateLiteral(["\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tmargin-bottom: 0.8em;\n"], ["\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tmargin-bottom: 0.8em;\n"]);

var Wrapper$6 = styled.div(_templateObject$h);
var Input$1 = styled(TextInput)(_templateObject2$9);

var OpenAnswer = function OpenAnswer(_ref) {
  var id = _ref.id,
      value = _ref.value,
      required = _ref.required,
      updateValue = _ref.updateValue,
      toggleRequired = _ref.toggleRequired,
      readOnly = _ref.readOnly;
  return React.createElement(Wrapper$6, null, React.createElement("div", null, React.createElement(Input$1, {
    readOnly: readOnly,
    value: value,
    onChange: function onChange(e) {
      return updateValue(id, e.currentTarget.value);
    }
  })), React.createElement(ToggleRow, {
    readOnly: readOnly,
    label: "Require text field",
    checked: !!required,
    onChange: function onChange() {
      return toggleRequired(id);
    }
  }));
};

var mapStateToProps$g = function mapStateToProps(state, ownProps) {
  var _specialOptionSelecto = specialOptionSelector(state, ownProps.id),
      openAnswerText = _specialOptionSelecto.openAnswerText,
      openAnswerRequired = _specialOptionSelecto.openAnswerRequired;

  if (openAnswerText === undefined || openAnswerRequired === undefined) throw new Error("Missing open answer props");

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    value: openAnswerText,
    required: openAnswerRequired,
    readOnly: readOnly
  };
};

var dispatchProps$8 = {
  updateValue: setSpecialOptionOpenAnswerText,
  toggleRequired: toggleSpecialOptionOpenAnswerRequired
};
var OpenAnswerContainer = connect(mapStateToProps$g, dispatchProps$8)(OpenAnswer);
var NoSymbol = icons.NoSymbol,
    Ellipsis = icons.Ellipsis;

var None = function None(props) {
  return React.createElement(SpecialOptionContainer, _extends$c({}, props, {
    type: "none",
    defaultText: "None of the above",
    Icon: NoSymbol
  }));
};

var Other = function Other(props) {
  var conditionalOpenAnswer = props.id === undefined ? null : React.createElement(OpenAnswerContainer, {
    id: props.id
  });
  return React.createElement("div", null, React.createElement(SpecialOptionContainer, _extends$c({}, props, {
    type: "other",
    defaultText: "Other",
    Icon: Ellipsis,
    openAnswer: true
  })), conditionalOpenAnswer);
};

var SpecialOptions = function SpecialOptions(_ref) {
  var id = _ref.id,
      options = _ref.options;
  return React.createElement("div", null, React.createElement(Other, {
    id: options.other,
    questionId: id
  }), React.createElement(None, {
    id: options.none,
    questionId: id
  }));
};

var mapStateToProps$h = function mapStateToProps(state, ownProps) {
  return {
    options: specialOptionsByQuestionIdSelector(state, ownProps.id)
  };
};

var dispatchProps$9 = {
  setSpecialOptionText: setSpecialOptionText,
  createSpecialOption: createSpecialOption,
  deleteSpecialOption: deleteSpecialOption
};
var SpecialOptionListContainer = connect(mapStateToProps$h, dispatchProps$9)(SpecialOptions);

var SingleSelect$1 = function SingleSelect(_ref) {
  var id = _ref.id;
  return React.createElement("div", null, React.createElement(DrawerBodySegment, null, React.createElement(RowListContainer, {
    id: id
  }), React.createElement(SpecialOptionListContainer, {
    id: id
  })), React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  }), React.createElement(RowOptionsContainer, {
    id: id
  })));
};

var Ranking$1 = function Ranking(_ref2) {
  var id = _ref2.id;
  return React.createElement("div", null, React.createElement(DrawerBodySegment, null, React.createElement(RowListContainer, {
    id: id
  })), React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  }), React.createElement(RowOptionsContainer, {
    id: id
  })));
};

var MultipleSelect$1 = function MultipleSelect(_ref3) {
  var id = _ref3.id;
  return React.createElement("div", null, React.createElement(DrawerBodySegment, null, React.createElement(RowListContainer, {
    id: id
  }), React.createElement(SpecialOptionListContainer, {
    id: id
  })), React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  }), React.createElement(RowOptionsContainer, {
    id: id
  }), React.createElement(MultipleRowOptionsContainer, {
    id: id
  })));
};

var Grid = function Grid(_ref4) {
  var id = _ref4.id;
  return React.createElement("div", null, React.createElement(DrawerBodySegment, null, React.createElement(RowListContainer, {
    id: id,
    header: "Row options"
  }), React.createElement(ColumnListContainer, {
    id: id,
    header: "Column options"
  })), React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  }), React.createElement(RowOptionsContainer, {
    id: id
  })));
};

var Text = function Text(_ref5) {
  var id = _ref5.id;
  return React.createElement("div", null, React.createElement(DrawerBodySegment, null, React.createElement(TextContainer, {
    id: id
  })), React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  })));
};

var Rating$1 = function Rating(_ref6) {
  var id = _ref6.id,
      multiple = _ref6.multiple;
  return React.createElement("div", null, React.createElement(RatingContainer, {
    id: id
  }), multiple ? React.createElement(DrawerBodySegment, null, React.createElement(RowListContainer, {
    id: id
  })) : null, React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  }), multiple ? React.createElement(RowOptionsContainer, {
    id: id
  }) : null));
};

var Slider$2 = function Slider$$1(_ref7) {
  var id = _ref7.id,
      multiple = _ref7.multiple;
  return React.createElement("div", null, React.createElement(DrawerBodySegment, null, React.createElement(SliderContainer, {
    id: id
  })), multiple ? React.createElement(DrawerBodySegment, null, React.createElement(RowListContainer, {
    id: id
  })) : null, React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  }), multiple ? React.createElement(RowOptionsContainer, {
    id: id
  }) : null));
};

var Numeric$1 = function Numeric(_ref8) {
  var id = _ref8.id;
  return React.createElement("div", null, React.createElement(NumericContainer, {
    id: id
  }), React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  })));
};

var Sum$1 = function Sum(_ref9) {
  var id = _ref9.id;
  return React.createElement("div", null, React.createElement(DrawerBodySegment, null, React.createElement(SumContainer, {
    id: id
  })), React.createElement(DrawerBodySegment, null, React.createElement(RowListContainer, {
    id: id
  })), React.createElement(DrawerBodySegment, null, React.createElement(RequireOptionContainer, {
    id: id
  }), React.createElement(RowOptionsContainer, {
    id: id
  })));
};

var TypeMap = function TypeMap(_ref10) {
  var type = _ref10.type,
      id = _ref10.id;

  switch (type) {
    case "single_select":
    case "dropdown":
      return React.createElement(SingleSelect$1, {
        id: id
      });

    case "rank_order":
      return React.createElement(Ranking$1, {
        id: id
      });

    case "multiple_select":
      return React.createElement(MultipleSelect$1, {
        id: id
      });

    case "single_select_matrix":
    case "multiple_select_matrix":
      return React.createElement(Grid, {
        id: id
      });

    case "short_text_input":
    case "long_text_input":
      return React.createElement(Text, {
        id: id
      });

    case "rating":
      return React.createElement(Rating$1, {
        id: id
      });

    case "multiple_rating":
      return React.createElement(Rating$1, {
        id: id,
        multiple: true
      });

    case "slider":
      return React.createElement(Slider$2, {
        id: id
      });

    case "multiple_slider":
      return React.createElement(Slider$2, {
        id: id,
        multiple: true
      });

    case "numeric":
      return React.createElement(Numeric$1, {
        id: id
      });

    case "sum":
      return React.createElement(Sum$1, {
        id: id
      });

    default:
      return null;
  }
};

var _templateObject$i = taggedTemplateLiteral(["\n\tcolor: ", ";\n\tuser-select: none;\n"], ["\n\tcolor: ", ";\n\tuser-select: none;\n"]);

var Token = styled.span(_templateObject$i, function (_ref) {
  var selected = _ref.selected,
      theme = _ref.theme;
  return selected ? theme.primary["2"] : theme.danger["2"];
});

var PipeToken = function PipeToken(_ref2) {
  var selected = _ref2.selected,
      sequence = _ref2.sequence,
      content = _ref2.content,
      children = _ref2.children;
  return React.createElement(Tooltip, {
    placement: "top",
    overlay: content,
    mouseLeaveDelay: 0
  }, React.createElement(Token, {
    selected: selected
  }, children));
};

var mapStateToProps$i = function mapStateToProps(state, ownProps) {
  var contentState = ownProps.contentState,
      entityKey = ownProps.entityKey;
  var data = contentState.getEntity(entityKey).data;

  var _pipeByIdSelector = pipeByIdSelector(state, data.id),
      sourceQuestion = _pipeByIdSelector.sourceQuestion,
      selected = _pipeByIdSelector.selected;

  var _questionByIdSelector = questionByIdSelector(state, sourceQuestion),
      sequence = _questionByIdSelector.sequence,
      content = _questionByIdSelector.content;

  return {
    selected: selected,
    sequence: sequence,
    content: content
  };
};

var PipeTokenContainer = connect(mapStateToProps$i)(PipeToken);

var _templateObject$j = taggedTemplateLiteral(["\n  .public-DraftEditor-content {\n    font-size: 1em;\n    border-radius: 0.5em;\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    margin-right: 0.25em;\n    padding: 0.6em 0.9em;\n    transition: border-color 0.125s, box-shadow 0.125s;\n    &:focus {\n      outline: none;\n      border-color: transparent;\n      box-shadow: 0 0 0 2px ", ";\n    }\n    resize: none;\n    height: 60px;\n    white-space: pre-wrap;\n    overflow-y: auto;\n    margin: 1em 0 1.86em;\n  }\n"], ["\n  .public-DraftEditor-content {\n    font-size: 1em;\n    border-radius: 0.5em;\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    margin-right: 0.25em;\n    padding: 0.6em 0.9em;\n    transition: border-color 0.125s, box-shadow 0.125s;\n    &:focus {\n      outline: none;\n      border-color: transparent;\n      box-shadow: 0 0 0 2px ", ";\n    }\n    resize: none;\n    height: 60px;\n    white-space: pre-wrap;\n    overflow-y: auto;\n    margin: 1em 0 1.86em;\n  }\n"]);

var StyledEditor = styled.div.attrs({
  "data-testid": "QUESTION_TEXT"
})(_templateObject$j, function (props) {
  return props.theme.neutralLight["4"];
}, function (props) {
  return props.theme.neutralLight["7"];
}, function (props) {
  return props.theme.neutralDark["2"];
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.primary["2"];
});

var findTokenEntities = function findTokenEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === "TOKEN";
  }, callback);
};

var decorator = new Draft_4([{
  strategy: findTokenEntities,
  component: PipeTokenContainer
}]);

var QuestionTextEditor = function (_React$Component) {
  inherits(QuestionTextEditor, _React$Component);

  function QuestionTextEditor(props) {
    classCallCheck(this, QuestionTextEditor);

    var _this = possibleConstructorReturn(this, (QuestionTextEditor.__proto__ || Object.getPrototypeOf(QuestionTextEditor)).call(this, props));

    _this.handleEditorChange = _this.handleEditorChange.bind(_this);
    return _this;
  }

  createClass(QuestionTextEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.domEditor && !this.props.readOnly) {
        this.domEditor.focus();

        if (document.execCommand) {
          document.execCommand("selectAll", false);
        }
      }
    }
  }, {
    key: "handleEditorChange",
    value: function handleEditorChange(editorState) {
      var _props = this.props,
          id = _props.id,
          updateQuestionEditor = _props.updateQuestionEditor;
      var raw = Draft_2(editorState.getCurrentContent());
      var selection = editorState.getSelection();
      updateQuestionEditor(id, raw, selection);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          id = _props2.id,
          rawContent = _props2.rawContent,
          selectionState = _props2.selectionState,
          resetQuestionContent = _props2.resetQuestionContent,
          readOnly = _props2.readOnly;
      var currentContent = Draft_1(rawContent);
      var selection = Draft_5.createEmpty(selectionState.anchorKey).merge(selectionState);
      var editorState = Draft_7.create({
        currentContent: currentContent,
        selection: selection,
        decorator: decorator
      });
      return React.createElement(StyledEditor, null, React.createElement(Draft_6, {
        ref: function ref(_ref) {
          return _this2.domEditor = _ref;
        },
        editorState: editorState,
        onChange: this.handleEditorChange,
        onBlur: function onBlur() {
          return resetQuestionContent(id);
        },
        readOnly: readOnly,
        "data-testid": "QUESTION_TEXT"
      }));
    }
  }]);
  return QuestionTextEditor;
}(React.Component);

var mapStateToProps$j = function mapStateToProps(state, ownProps) {
  var _questionByIdSelector = questionByIdSelector(state, ownProps.id),
      draftRawContent = _questionByIdSelector.draftRawContent,
      draftSelectionState = _questionByIdSelector.draftSelectionState;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    rawContent: draftRawContent,
    selectionState: draftSelectionState,
    readOnly: readOnly
  };
};

var EditorContainer = connect(mapStateToProps$j, {
  updateQuestionEditor: updateQuestionEditor,
  resetQuestionContent: resetQuestionContent
})(QuestionTextEditor);

var PipeSelect = function PipeSelect(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange,
      readOnly = props.readOnly;
  if (options.length === 0) return null;
  return React.createElement(Select, {
    onChange: onChange,
    value: options.find(function (o) {
      return o.value === value;
    }),
    options: options,
    searchable: false,
    clearable: false,
    disabled: readOnly
  });
};

var createPipe = function createPipe(payload) {
  var sourceQuestion = payload.sourceQuestion,
      endQuestion = payload.endQuestion;
  var placeholder = "pipe_" + sourceQuestion + "_" + endQuestion;
  return {
    type: pipeTypes.PIPE_CREATE,
    payload: _extends$c({}, payload, {
      placeholder: placeholder
    })
  };
};

var makeOnChange = function makeOnChange(createPipe$$1, endId) {
  return function (_ref) {
    var id = _ref.id,
        selected = _ref.selected;
    createPipe$$1({
      endQuestion: endId,
      sourceQuestion: id,
      selected: selected
    });
  };
};

var mapStateToProps$k = function mapStateToProps(state, ownProps) {
  var pageId = pageByQuestionIdSelector(state, ownProps.endQuestion).id;
  var nodeId = nodeByPageIdSelector(state, pageId).id;
  var options = pipeOptionsSelector(state, nodeId);
  var pipe = pipeByEndQuestionIdSelector(state, ownProps.endQuestion);
  var value = pipe === null ? undefined : getPipeValue(pipe.sourceQuestion.id, pipe.selected);

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    options: options,
    value: value,
    readOnly: readOnly
  };
};

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch, ownProps) {
  var endQuestion = ownProps.endQuestion;
  var onChange = makeOnChange(function (payload) {
    return dispatch(createPipe(payload));
  }, endQuestion);
  return {
    onChange: onChange
  };
};

var PipeSelectContainer = connect(mapStateToProps$k, mapDispatchToProps$1)(PipeSelect);

var _templateObject$k = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\t> label {\n\t\twhite-space: nowrap;\n\t\tmargin-right: 1em;\n\t}\n\t> div {\n\t\tdisplay: inline-block;\n\t\tflex-grow: 1;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\t> label {\n\t\twhite-space: nowrap;\n\t\tmargin-right: 1em;\n\t}\n\t> div {\n\t\tdisplay: inline-block;\n\t\tflex-grow: 1;\n\t}\n"]);

var Header$1 = styled.div(_templateObject$k);

var Content = function Content(_ref) {
  var id = _ref.id;
  return React.createElement("div", null, React.createElement(Header$1, null, React.createElement(DrawerBodyLabel, null, "Question text"), React.createElement(PipeSelectContainer, {
    endQuestion: id
  })), React.createElement(EditorContainer, {
    id: id
  }));
};

var _templateObject$l = taggedTemplateLiteral(["\n  width: 100%;\n  resize: none;\n  box-sizing: border-box;\n  margin: 0 0 1em;\n"], ["\n  width: 100%;\n  resize: none;\n  box-sizing: border-box;\n  margin: 0 0 1em;\n"]);

var StyledTextArea = styled(TextInput.withComponent("textarea"))(_templateObject$l);

var DescriptionTextarea = function DescriptionTextarea(props) {
  var hasDescription = props.hasDescription,
      description = props.description,
      setQuestionDescription = props.setQuestionDescription;
  if (hasDescription) return React.createElement(StyledTextArea, {
    value: description,
    onChange: function onChange(e) {
      return setQuestionDescription(e.currentTarget.value);
    }
  });
  return null;
};

var Description = function Description(props) {
  var hasDescription = props.hasDescription,
      description = props.description,
      toggleQuestionDescription = props.toggleQuestionDescription,
      setQuestionDescription = props.setQuestionDescription,
      readOnly = props.readOnly;
  return React.createElement("div", null, React.createElement(ToggleRow, {
    readOnly: readOnly,
    checked: hasDescription,
    onChange: toggleQuestionDescription,
    label: "Description"
  }), React.createElement(DescriptionTextarea, {
    hasDescription: hasDescription,
    description: description,
    setQuestionDescription: setQuestionDescription,
    disabled: readOnly
  }));
};

function mapStateToProps$l(state, ownProps) {
  var _questionByIdSelector = questionByIdSelector(state, ownProps.id),
      hasDescription = _questionByIdSelector.hasDescription,
      description = _questionByIdSelector.description;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    hasDescription: hasDescription,
    description: description,
    readOnly: readOnly
  };
}

function mapDispatchToProps$2(dispatch, ownProps) {
  return {
    toggleQuestionDescription: function toggleQuestionDescription$$1() {
      dispatch(toggleQuestionDescription(ownProps.id));
    },
    setQuestionDescription: function setQuestionDescription$$1(description) {
      dispatch(setQuestionDescription(ownProps.id, description));
    }
  };
}

var DescriptionContainer = connect(mapStateToProps$l, mapDispatchToProps$2)(Description);

var _templateObject$m = taggedTemplateLiteral(["\n\tdisplay: flex;\n\t> span {\n\t\tflex-grow: 1;\n\t}\n"], ["\n\tdisplay: flex;\n\t> span {\n\t\tflex-grow: 1;\n\t}\n"]);

var Delete$1 = icons.Delete;
var Wrapper$7 = styled.div(_templateObject$m);

var ImageMenu = function ImageMenu(_ref) {
  var uploadQuestionImage = _ref.uploadQuestionImage,
      clearQuestionImage = _ref.clearQuestionImage,
      imageFilename = _ref.imageFilename,
      imageLoading = _ref.imageLoading,
      readOnly = _ref.readOnly;

  var onChange = function onChange(e) {
    var file = e.currentTarget.files[0];
    if (file === undefined) return;
    uploadQuestionImage(file);
  };

  var conditionalDelete = imageFilename === undefined ? null : React.createElement(IconButton, {
    disabled: readOnly,
    onClick: clearQuestionImage
  }, React.createElement(Delete$1, null));
  var conditionalUpload = imageFilename === undefined ? React.createElement(Upload, {
    disabled: readOnly,
    loading: imageLoading,
    onChange: onChange,
    swatch: "neutralDark",
    accept: "image/*"
  }, "Upload Image") : React.createElement("span", null, imageFilename);
  return React.createElement(Wrapper$7, null, conditionalUpload, conditionalDelete);
};

function mapStateToProps$m(state, ownProps) {
  var _questionByIdSelector = questionByIdSelector(state, ownProps.id),
      imageFilename = _questionByIdSelector.imageFilename,
      imageLoading = _questionByIdSelector.imageLoading;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    imageFilename: imageFilename,
    imageLoading: imageLoading,
    readOnly: readOnly
  };
}

function mapDispatchToProps$3(dispatch, ownProps) {
  return {
    uploadQuestionImage: function uploadQuestionImage$$1(file) {
      return dispatch(uploadQuestionImage(ownProps.id, file));
    },
    clearQuestionImage: function clearQuestionImage$$1() {
      return dispatch(clearQuestionImage(ownProps.id));
    }
  };
}

var ImageMenuContainer = connect(mapStateToProps$m, mapDispatchToProps$3)(ImageMenu);

var _templateObject$n = taggedTemplateLiteral(["\n\tdisplay: flex;\n\t> input {\n\t\tfont-size: 12px;\n\t\tbox-sizing: border-box;\n\t\tflex-grow: 1;\n\t\tmargin-right: 1em;\n\t}\n"], ["\n\tdisplay: flex;\n\t> input {\n\t\tfont-size: 12px;\n\t\tbox-sizing: border-box;\n\t\tflex-grow: 1;\n\t\tmargin-right: 1em;\n\t}\n"]);

var Wrapper$8 = styled.div(_templateObject$n);

var VideoMenu = function (_React$Component) {
  inherits(VideoMenu, _React$Component);

  function VideoMenu(props) {
    classCallCheck(this, VideoMenu);

    var _this = possibleConstructorReturn(this, (VideoMenu.__proto__ || Object.getPrototypeOf(VideoMenu)).call(this, props));

    _this.state = {
      inputValue: props.videoUrl || "http://"
    };
    _this.setInput = _this.setInput.bind(_this);
    _this.setVideoUrl = _this.setVideoUrl.bind(_this);
    return _this;
  }

  createClass(VideoMenu, [{
    key: "setInput",
    value: function setInput(e) {
      var inputValue = e.currentTarget.value;
      this.setState({
        inputValue: inputValue
      });
    }
  }, {
    key: "setVideoUrl",
    value: function setVideoUrl() {
      var setQuestionVideoUrl = this.props.setQuestionVideoUrl;
      var inputValue = this.state.inputValue;
      setQuestionVideoUrl(inputValue);
    }
  }, {
    key: "render",
    value: function render() {
      var inputValue = this.state.inputValue;
      return React.createElement(Wrapper$8, null, React.createElement(TextInput, {
        value: inputValue,
        onChange: this.setInput
      }), React.createElement(Button, {
        swatch: "neutralDark",
        onClick: this.setVideoUrl
      }, "Submit"));
    }
  }]);
  return VideoMenu;
}(React.Component);

function mapStateToProps$n(state, ownProps) {
  var model = questionByIdSelector(state, ownProps.id);
  return {
    videoUrl: model.videoUrl
  };
}

function mapDispatchToProps$4(dispatch, ownProps) {
  return {
    setQuestionVideoUrl: function setQuestionVideoUrl$$1(url) {
      return dispatch(setQuestionVideoUrl(ownProps.id, url));
    }
  };
}

var VideoMenuContainer = connect(mapStateToProps$n, mapDispatchToProps$4)(VideoMenu);

var _templateObject$o = taggedTemplateLiteral(["\n  margin-bottom: 1em;\n"], ["\n  margin-bottom: 1em;\n"]);

var StyledButtonGroup = styled(ButtonGroup)(_templateObject$o);

var MediaTypeSelect = function MediaTypeSelect(_ref) {
  var hasMedia = _ref.hasMedia,
      mediaType = _ref.mediaType,
      toggleQuestionMediaType = _ref.toggleQuestionMediaType,
      disabled = _ref.disabled;

  if (hasMedia) {
    var imageActive = mediaType === "image" ? "active" : null;
    var videoActive = mediaType === "video" ? "active" : null;
    return React.createElement(StyledButtonGroup, null, React.createElement(GroupedButton, {
      onClick: toggleQuestionMediaType,
      className: imageActive,
      disabled: disabled
    }, "Image"), React.createElement(GroupedButton, {
      onClick: toggleQuestionMediaType,
      className: videoActive,
      disabled: disabled
    }, "Video"));
  }

  return null;
};

var Media = function Media(props) {
  var id = props.id,
      hasMedia = props.hasMedia,
      mediaType = props.mediaType,
      toggleQuestionMedia = props.toggleQuestionMedia,
      toggleQuestionMediaType = props.toggleQuestionMediaType,
      readOnly = props.readOnly;
  var menu = hasMedia ? mediaType === "image" ? React.createElement(ImageMenuContainer, {
    id: id
  }) : React.createElement(VideoMenuContainer, {
    id: id
  }) : null;
  return React.createElement("div", null, React.createElement(ToggleRow, {
    label: "Image/video",
    readOnly: readOnly,
    checked: hasMedia,
    onChange: toggleQuestionMedia
  }), React.createElement(MediaTypeSelect, {
    hasMedia: hasMedia,
    mediaType: mediaType,
    toggleQuestionMediaType: toggleQuestionMediaType,
    disabled: readOnly
  }), menu);
};

function mapStateToProps$o(state, ownProps) {
  var _questionByIdSelector = questionByIdSelector(state, ownProps.id),
      hasMedia = _questionByIdSelector.hasMedia,
      mediaType = _questionByIdSelector.mediaType;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    hasMedia: hasMedia,
    mediaType: mediaType,
    readOnly: readOnly
  };
}

function mapDispatchToProps$5(dispatch, ownProps) {
  return {
    toggleQuestionMedia: function toggleQuestionMedia$$1() {
      dispatch(toggleQuestionMedia(ownProps.id));
    },
    toggleQuestionMediaType: function toggleQuestionMediaType$$1() {
      dispatch(toggleQuestionMediaType(ownProps.id));
    }
  };
}

var MediaContainer = connect(mapStateToProps$o, mapDispatchToProps$5)(Media);

var Basics = function Basics(_ref) {
  var id = _ref.id;
  return React.createElement(DrawerBodySegment, null, React.createElement(Content, {
    id: id
  }), React.createElement(DescriptionContainer, {
    id: id
  }), React.createElement(MediaContainer, {
    id: id
  }));
};

var _templateObject$p = taggedTemplateLiteral(["\n\tdisplay: flex;\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: ", ";\n\t}\n\t> :first-child {\n\t\tflex-grow: 1;\n\t}\n"], ["\n\tdisplay: flex;\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: ", ";\n\t}\n\t> :first-child {\n\t\tflex-grow: 1;\n\t}\n"]),
    _templateObject2$a = taggedTemplateLiteral(["\n\t&:focus {\n\t\tbox-shadow: ", ";\n\t}\n"], ["\n\t&:focus {\n\t\tbox-shadow: ", ";\n\t}\n"]);

var StyledHeader = styled(DrawerMenuHeader)(_templateObject$p, function (props) {
  return props.theme.neutralLight["1"];
});
var StyledButton$3 = styled(Button)(_templateObject2$a, function (props) {
  return props.theme.focusShadowB;
});

var Header$2 = function Header(_ref) {
  var page = _ref.page,
      pageSequence = _ref.pageSequence,
      sequence = _ref.sequence,
      type = _ref.type;
  return React.createElement(StyledHeader, null, React.createElement("span", null, React.createElement(Link, {
    to: {
      pathname: "/page/" + page
    }
  }, "Page " + pageSequence + ",", " "), React.createElement("span", null, "Question " + sequence)), React.createElement("span", null, questionConfigs[type].displayType));
};

var Body = function Body(_ref2) {
  var type = _ref2.type,
      id = _ref2.id;
  return React.createElement(DrawerMenuBody, null, React.createElement(Basics, {
    id: id
  }), React.createElement(TypeMap, {
    type: type,
    id: id
  }));
};

var Footer = function Footer(_ref3) {
  var surveyHashRoute = _ref3.surveyHashRoute;
  return React.createElement(DrawerMenuFooter, null, React.createElement(Link, {
    tabIndex: "-1",
    to: {
      pathname: "/" + surveyHashRoute + "/build"
    }
  }, React.createElement(StyledButton$3, null, "Done")));
};

var QuestionMenu = function QuestionMenu(props) {
  var surveyHashRoute = props.surveyHashRoute;
  if (props.notFound === true) return React.createElement(Redirect, {
    to: {
      pathname: "/" + surveyHashRoute + "/build"
    }
  });
  return React.createElement(DrawerMenu, null, React.createElement(Header$2, props), React.createElement(Body, props), React.createElement(Footer, {
    surveyHashRoute: surveyHashRoute
  }));
};

function mapStateToProps$p(state, ownProps) {
  var id = ownProps.id;
  var exists = questionExistsSelector(state, id);
  if (!exists) return {
    notFound: true
  };

  var _questionByIdSelector = questionByIdSelector(state, id),
      page = _questionByIdSelector.page,
      type = _questionByIdSelector.type,
      sequence = _questionByIdSelector.sequence;

  var _pageByIdSelector = pageByIdSelector(state, page),
      pageSequence = _pageByIdSelector.sequence;

  return {
    id: id,
    type: type,
    sequence: sequence,
    page: page,
    pageSequence: pageSequence
  };
}

var QuestionMenuContainer = connect(mapStateToProps$p)(QuestionMenu);

var SortMenu = function SortMenu(_ref) {
  var sortType = _ref.sortType,
      togglePageRandomSort = _ref.togglePageRandomSort,
      togglePageReverseSort = _ref.togglePageReverseSort,
      readOnly = _ref.readOnly;
  return React.createElement(DrawerBodySegment, null, React.createElement(DrawerBodyRow, null, React.createElement("label", null, "Randomize questions"), React.createElement(Toggle, {
    disabled: readOnly,
    checked: sortType === "randomize",
    onChange: togglePageRandomSort
  })), React.createElement(DrawerBodyRow, null, React.createElement("label", null, "Reverse order questions"), React.createElement(Toggle, {
    disabled: readOnly,
    checked: sortType === "reverse",
    onChange: togglePageReverseSort
  })));
};

var getConditionTargetNode = function getConditionTargetNode(graphId, after, session) {
  if (after !== undefined) return session.DagNode.withId(after);
  var graph = session.DagGraph.withId(graphId);
  return getRootNode(graph);
};

var getParentPreviousNodes = function getParentPreviousNodes(graph) {
  if (graph.hostNode) {
    return getPreviousNodes(graph.hostNode);
  }

  return [];
};

var getParentForwardNodes = function getParentForwardNodes(graph) {
  if (graph.hostNode) {
    return getForwardNodes(graph.hostNode);
  }

  return [];
}; // Get the nodes that this branch can target.


var getForwardRelationNodes = function getForwardRelationNodes(graph, after, session) {
  var graphModel = session.DagGraph.withId(graph);
  var rootNode = after === undefined ? getRootNode(graphModel) : session.DagNode.withId(after);
  var graphForwardNodes = getForwardNodes(rootNode);
  var parentForwardNodes = getParentForwardNodes(graphModel);
  return [].concat(toConsumableArray(graphForwardNodes), toConsumableArray(parentForwardNodes));
};

var getBreakingConsumerPipesPage = function getBreakingConsumerPipesPage(page, forwardNodes, session) {
  return page.questions.toModelArray().reduce(function (pipes, question) {
    return [].concat(toConsumableArray(pipes), toConsumableArray(getBreakingConsumerPipes(question, forwardNodes, session)));
  }, []);
};

var pagesFromNode = function pagesFromNode(node) {
  if (node.page) return [node.page.ref];

  if (node.childGraph) {
    return node.childGraph.nodes.toModelArray().reduce(function (list, childNode) {
      return [].concat(toConsumableArray(list), toConsumableArray(pagesFromNode(childNode)));
    }, []);
  }

  throw new Error("Invalid node with id " + node.id + " has no page and no child graph");
}; // Filters for branches targeting unreachable pages.


var getBreakingOwnBranches = function getBreakingOwnBranches(branches, graph, after, session) {
  var nodes = getForwardRelationNodes(graph, after, session);
  var forwardPages = nodes.reduce(function (list, node) {
    return [].concat(toConsumableArray(list), toConsumableArray(pagesFromNode(node)));
  }, []);
  return branches.filter(function (b) {
    if (b.target) return !forwardPages.includes(b.target.ref);
    return false;
  });
};

var getBreakingTargetingBranches = function getBreakingTargetingBranches(page, graph, after, session) {
  var branches = page.targetingBranches.toModelArray();
  return branches.filter(function (b) {
    if (!b.skipLogicPage) return false;
    var skipPage = b.skipLogicPage;

    var _session$DagGraph$wit = session.DagGraph.withId(graph),
        hostNode = _session$DagGraph$wit.hostNode;

    if (after === undefined && hostNode === null) return true; // Target has moved to start of survey, can't be targeted

    var forwardNodes = [skipPage.node.ref].concat(toConsumableArray(getForwardNodes(skipPage.node).map(function (n) {
      return n.ref;
    })));

    var checkNode = function () {
      if (after !== undefined) return session.DagNode.withId(after).ref; // Moving to start of new section/group

      if (hostNode !== null) return hostNode.ref;
      return undefined;
    }();

    if (checkNode === undefined) return [];
    return !forwardNodes.includes(checkNode);
  });
}; // Filters for conditions using questions from unreached pages.


var getBreakingBranchConditions = function getBreakingBranchConditions(branch, graph, after, session, nodes) {
  var previousQuestions = nodes.reduce(function (list, node) {
    return [].concat(toConsumableArray(list), toConsumableArray(questionsFromNode(node)));
  }, []);
  var breakingConditions = branch.conditions.toModelArray().filter(function (c) {
    return !previousQuestions.includes(c.question.ref);
  });
  return breakingConditions.map(function (c) {
    return c.id;
  });
};

var questionConditions = function questionConditions(q) {
  return q.referencingConditions.toModelArray();
};

var getPageQuestionConditions = function getPageQuestionConditions(page) {
  return page.questions.toModelArray().reduce(function (list, q) {
    return [].concat(toConsumableArray(list), toConsumableArray(questionConditions(q)));
  }, []);
};

var getBreakingDisplayConditionsPage = function getBreakingDisplayConditionsPage(page, graph, after, session, displayNodes) {
  var pageConditions = page.displayLogicBranch ? getBreakingBranchConditions(page.displayLogicBranch, graph, after, session, displayNodes) : [];
  var questionConditions = getBreakingQuestionDisplayConditions(page, graph, after, session);
  return [].concat(toConsumableArray(pageConditions), toConsumableArray(questionConditions));
};

var getBreakingQuestionDisplayConditions = function getBreakingQuestionDisplayConditions(page, graph, after, session) {
  var targetNode = getConditionTargetNode(graph, after, session);
  var pageQuestionConditions = getPageQuestionConditions(page);
  return getBreakingDisplayConditions(pageQuestionConditions, targetNode.ref);
};

var getBreakingSkipConditionsPage = function getBreakingSkipConditionsPage(page, graph, after, session, skipNodes) {
  var pageConditions = page.skipLogicBranches.toModelArray().reduce(function (conditions, branch) {
    return [].concat(toConsumableArray(conditions), toConsumableArray(getBreakingBranchConditions(branch, graph, after, session, skipNodes)));
  }, []);
  var questionConditions = getBreakingQuestionSkipConditions(page, graph, after, session);
  return [].concat(toConsumableArray(pageConditions), toConsumableArray(questionConditions));
};

var getBreakingQuestionSkipConditions = function getBreakingQuestionSkipConditions(page, graph, after, session) {
  var targetNode = getConditionTargetNode(graph, after, session);
  var pageQuestionConditions = getPageQuestionConditions(page);

  var branchPredicate = function branchPredicate(list, branch) {
    return branch.skipLogicPage ? [].concat(toConsumableArray(list), [branch.skipLogicPage]) : list;
  };

  var pagePredicate = function pagePredicate(page) {
    return !getPreviousNodes(page.node).map(function (n) {
      return n.ref;
    }).includes(targetNode.ref);
  };

  return getBreakingConditions(pageQuestionConditions, branchPredicate, pagePredicate);
};

var getBreakingProviderPipesPage = function getBreakingProviderPipesPage(page, previousNodes, session) {
  return page.questions.toModelArray().reduce(function (pipes, question) {
    return [].concat(toConsumableArray(pipes), toConsumableArray(getBreakingProviderPipes(question, previousNodes, session)));
  }, []);
};
/*
    Validate:
        - page's own display logic branch
        - page's own skip logic branches
        - other skip logic branches targeting this page
*/
// Returns an array of nodes valid for use in conditions.


var getPreviousRelationNodes = function getPreviousRelationNodes(graph, after, session) {
  if (after === undefined) {
    var graphModel = session.DagGraph.withId(graph);
    return getParentPreviousNodes(graphModel);
  }

  var afterNode = session.DagNode.withId(after);
  return [afterNode].concat(toConsumableArray(getPreviousNodes(afterNode)));
};

var getBreakingRelationsPage = function getBreakingRelationsPage(page, graph, after, session) {
  var previousNodes = getPreviousRelationNodes(graph, after, session);
  var forwardRelationNodes = getForwardRelationNodes(graph, after, session);
  var displayConditions = getBreakingDisplayConditionsPage(page, graph, after, session, previousNodes);
  var skipNodes = [page.node].concat(toConsumableArray(getPreviousRelationNodes(graph, after, session)));
  var skipConditions = getBreakingSkipConditionsPage(page, graph, after, session, skipNodes);
  var ownBreakingSkipBranches = getBreakingOwnBranches(page.skipLogicBranches.toModelArray(), graph, after, session);
  var outerBreakingSkipBranches = getBreakingTargetingBranches(page, graph, after, session);
  var skipBranches = [].concat(toConsumableArray(ownBreakingSkipBranches), toConsumableArray(outerBreakingSkipBranches)).map(function (b) {
    return b.id;
  });
  var consumerPipes = getBreakingConsumerPipesPage(page, forwardRelationNodes.map(function (n) {
    return n.ref;
  }), session);
  var providerPipes = getBreakingProviderPipesPage(page, previousNodes.map(function (n) {
    return n.ref;
  }), session);
  return _extends$c({}, displayConditions.length ? {
    displayConditions: displayConditions
  } : undefined, skipConditions.length ? {
    skipConditions: skipConditions
  } : undefined, skipBranches.length ? {
    skipBranches: skipBranches
  } : undefined, consumerPipes.length ? {
    consumerPipes: consumerPipes
  } : undefined, providerPipes.length ? {
    providerPipes: providerPipes
  } : undefined);
};

var createPageWithNewQuestion$1 = function createPageWithNewQuestion(page, type, surveyHashRoute) {
  var question = configNewQuestionPayload({
    type: type
  });
  return {
    type: pageTypes.PAGE_CREATE_WITH_NEW_QUESTION,
    payload: {
      page: page,
      question: question,
      surveyHashRoute: surveyHashRoute
    }
  };
};

var createPageWithExistingQuestionUnsafe = function createPageWithExistingQuestionUnsafe(page, question, breakingRelations) {
  return {
    type: pageTypes.PAGE_CREATE_WITH_EXISTING_QUESTION_UNSAFE,
    payload: {
      page: page,
      question: question,
      breakingRelations: breakingRelations
    }
  };
};

var createPageWithExistingQuestion$1 = function createPageWithExistingQuestion(page, questionId) {
  return function (dispatch, getState) {
    var ormState = selectOrm(getState());
    var session = orm.session(ormState);
    var rootNode = getConditionTargetNode(page.graph, page.after, session);
    var question = session.Question.withId(questionId);
    var forwardNodes = getForwardNodes(rootNode).map(function (n) {
      return n.ref;
    });
    var previousNodes = getPreviousNodes(rootNode).map(function (n) {
      return n.ref;
    });
    var providerPipes = getBreakingProviderPipes(question, previousNodes, session);
    var consumerPipes = getBreakingConsumerPipes(question, forwardNodes, session);
    var displayConditions = getBreakingConditions(question.referencingConditions.toModelArray(), function (list, branch) {
      return branch.displayLogicPage ? [].concat(toConsumableArray(list), [branch.displayLogicPage]) : list;
    }, function (page) {
      return !getPreviousNodes(page.node).map(function (n) {
        return n.ref;
      }).includes(rootNode);
    });
    var skipConditions = getBreakingConditions(question.referencingConditions.toModelArray(), function (list, branch) {
      return branch.skipLogicPage ? [].concat(toConsumableArray(list), [branch.skipLogicPage]) : list;
    }, function (page) {
      return !getPreviousNodes(page.node).map(function (n) {
        return n.ref;
      }).includes(rootNode);
    });

    var breakingRelations = _extends$c({}, providerPipes.length ? {
      providerPipes: providerPipes
    } : undefined, consumerPipes.length ? {
      consumerPipes: consumerPipes
    } : undefined, skipConditions.length ? {
      skipConditions: skipConditions
    } : undefined, displayConditions.length ? {
      displayConditions: displayConditions
    } : undefined);

    var dispatchCreate = function dispatchCreate() {
      return dispatch(createPageWithExistingQuestionUnsafe(page, questionId, breakingRelations));
    };

    if (Object.keys(breakingRelations).length) {
      return dispatch(warnBreakingRelations(breakingRelations, dispatchCreate));
    }

    return dispatchCreate();
  };
};

var setPageContent = function setPageContent(id, content) {
  return {
    type: pageTypes.PAGE_SET_CONTENT,
    payload: {
      id: id,
      content: content
    }
  };
};

var deletePage = function deletePage(id) {
  return {
    type: pageTypes.PAGE_DELETE,
    payload: id
  };
};

var duplicatePage = function duplicatePage(id) {
  return {
    type: pageTypes.PAGE_DUPLICATE,
    payload: id
  };
};

var togglePageAnchor = function togglePageAnchor(id) {
  return {
    type: pageTypes.PAGE_TOGGLE_ANCHOR,
    payload: id
  };
};

var togglePageRandomSort = function togglePageRandomSort(id) {
  return {
    type: pageTypes.PAGE_TOGGLE_RANDOM_SORT,
    payload: id
  };
};

var togglePageReverseSort = function togglePageReverseSort(id) {
  return {
    type: pageTypes.PAGE_TOGGLE_REVERSE_SORT,
    payload: id
  };
};

var movePageUnsafe = function movePageUnsafe(id, graph, after, breakingRelations) {
  return {
    type: pageTypes.PAGE_MOVE_UNSAFE,
    payload: {
      id: id,
      graph: graph,
      after: after,
      breakingRelations: breakingRelations
    }
  };
};

var movePage = function movePage(id, graph, after) {
  return function (dispatch, getState) {
    var ormState = selectOrm(getState());
    var session = orm.session(ormState);
    var page = session.Page.withId(id);
    var breakingRelations = getBreakingRelationsPage(page, graph, after, session);

    var dispatchMove = function dispatchMove() {
      return dispatch(movePageUnsafe(id, graph, after, breakingRelations));
    };

    if (Object.keys(breakingRelations).length) {
      return dispatch(warnBreakingRelations(breakingRelations, dispatchMove));
    }

    return dispatchMove();
  };
};

function mapStateToProps$q(state, ownProps) {
  var _pageByIdSelector = pageByIdSelector(state, ownProps.id),
      sortType = _pageByIdSelector.sortType;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    sortType: sortType,
    readOnly: readOnly
  };
}

function mapDispatchToProps$6(dispatch, ownProps) {
  return {
    togglePageRandomSort: function togglePageRandomSort$$1() {
      return dispatch(togglePageRandomSort(ownProps.id));
    },
    togglePageReverseSort: function togglePageReverseSort$$1() {
      return dispatch(togglePageReverseSort(ownProps.id));
    }
  };
}

var SortMenuContainer = connect(mapStateToProps$q, mapDispatchToProps$6)(SortMenu);

var _templateObject$q = taggedTemplateLiteral(["\n\theight: 1.4em;\n\twidth: 1.4em;\n\tvertical-align: middle;\n\tmargin-right: 0.75em;\n\tfill: ", ";\n"], ["\n\theight: 1.4em;\n\twidth: 1.4em;\n\tvertical-align: middle;\n\tmargin-right: 0.75em;\n\tfill: ", ";\n"]);

var DisplayBase = icons.DisplayLogic,
    SkipBase = icons.SkipLogic;
var DisplayLogic = styled(DisplayBase)(_templateObject$q, function (props) {
  return props.theme.neutralLight["3"];
});
var SkipLogic = DisplayLogic.withComponent(SkipBase);

var DisplayLogicToggle = function (_React$Component) {
  inherits(DisplayLogicToggle, _React$Component);

  function DisplayLogicToggle(props) {
    classCallCheck(this, DisplayLogicToggle);

    var _this = possibleConstructorReturn(this, (DisplayLogicToggle.__proto__ || Object.getPrototypeOf(DisplayLogicToggle)).call(this, props));

    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }

  createClass(DisplayLogicToggle, [{
    key: "handleToggle",
    value: function handleToggle() {
      var _props = this.props,
          createDisplayLogic = _props.createDisplayLogic,
          deleteLogicBranch = _props.deleteLogicBranch,
          pageId = _props.pageId,
          logicBranchId = _props.logicBranchId,
          defaultQuestion = _props.defaultQuestion;
      if (defaultQuestion === undefined) throw new Error("Display logic toggle for page with id " + pageId + " is missing a defaultQuestion. Make sure the Toggle is disabled if no valid question exists.");
      if (logicBranchId === undefined) return createDisplayLogic({
        page: pageId,
        defaultQuestion: defaultQuestion
      });
      return deleteLogicBranch(logicBranchId);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          logicBranchId = _props2.logicBranchId,
          defaultQuestion = _props2.defaultQuestion,
          readOnly = _props2.readOnly;
      return React.createElement(DrawerBodyRow, null, React.createElement(DisplayLogic, null), React.createElement(DrawerBodyLabel, null, "Display Logic"), React.createElement(Toggle, {
        disabled: defaultQuestion === undefined || readOnly,
        checked: logicBranchId !== undefined,
        onChange: this.handleToggle
      }));
    }
  }]);
  return DisplayLogicToggle;
}(React.Component);

var createDisplayLogic = function createDisplayLogic(payload) {
  return {
    type: logicBranchTypes.DISPLAY_LOGIC_CREATE,
    payload: payload
  };
};

var createSkipLogic = function createSkipLogic(payload) {
  return {
    type: logicBranchTypes.SKIP_LOGIC_CREATE,
    payload: payload
  };
};

var deleteSkipLogic = function deleteSkipLogic(page) {
  return {
    type: logicBranchTypes.SKIP_LOGIC_DELETE,
    payload: page
  };
};

var deleteLogicBranch = function deleteLogicBranch(id) {
  return {
    type: logicBranchTypes.LOGIC_BRANCH_DELETE,
    payload: id
  };
};

var setLogicBranchTarget = function setLogicBranchTarget(id, target) {
  return {
    type: logicBranchTypes.LOGIC_BRANCH_SET_TARGET,
    payload: {
      id: id,
      target: target
    }
  };
};

function mapStateToProps$r(state, ownProps) {
  var nodeId = nodeByPageIdSelector(state, ownProps.pageId).id;
  var questions = displayLogicQuestionsSelector(state, nodeId);
  var defaultQuestion = questions.length ? questions[0].id : undefined;
  return {
    defaultQuestion: defaultQuestion
  };
}

var ToggleContainer = connect(mapStateToProps$r, {
  createDisplayLogic: createDisplayLogic,
  deleteLogicBranch: deleteLogicBranch
})(DisplayLogicToggle);

var _templateObject$r = taggedTemplateLiteral(["\n\theight: 32px;\n\t.Select-control {\n\t\tdisplay: block;\n\t\theight: 32px;\n\t\t.Select-value {\n\t\t\tline-height: 32px !important;\n\t\t}\n\t}\n\t.Select-arrow-zone {\n\t\tposition: absolute;\n\t\tright: 0;\n\t\ttop: 0;\n\t\theight: 100%;\n\t\tsvg {\n\t\t\tposition: absolute;\n\t\t\ttop: calc(50% - 0.5em);\n\t\t\tright: calc(50% - 0.5em);\n\t\t}\n\t}\n"], ["\n\theight: 32px;\n\t.Select-control {\n\t\tdisplay: block;\n\t\theight: 32px;\n\t\t.Select-value {\n\t\t\tline-height: 32px !important;\n\t\t}\n\t}\n\t.Select-arrow-zone {\n\t\tposition: absolute;\n\t\tright: 0;\n\t\ttop: 0;\n\t\theight: 100%;\n\t\tsvg {\n\t\t\tposition: absolute;\n\t\t\ttop: calc(50% - 0.5em);\n\t\t\tright: calc(50% - 0.5em);\n\t\t}\n\t}\n"]);

var StyledSelect = styled(Select)(_templateObject$r);

var _templateObject$s = taggedTemplateLiteral(["\n\t&.Select {\n\t\tposition: static;\n\t}\n\t&& {\n\t\tposition: static;\n\t}\n\tflex: 0 0 5em;\n\t.Select-menu-outer {\n\t\twidth: 100%;\n\t\tleft: 0;\n\t\tmargin-top: 0.5em;\n\t}\n\t.Select-control {\n\t\theight: 32px;\n\t}\n"], ["\n\t&.Select {\n\t\tposition: static;\n\t}\n\t&& {\n\t\tposition: static;\n\t}\n\tflex: 0 0 5em;\n\t.Select-menu-outer {\n\t\twidth: 100%;\n\t\tleft: 0;\n\t\tmargin-top: 0.5em;\n\t}\n\t.Select-control {\n\t\theight: 32px;\n\t}\n"]);

var StyledSelect$1 = styled(StyledSelect)(_templateObject$s);

var optionFromQuestion = function optionFromQuestion(_ref) {
  var id = _ref.id,
      sequence = _ref.sequence,
      content = _ref.content;
  return {
    value: id,
    label: "Q" + sequence + ": " + content,
    selectedLabel: "Q" + sequence,
    sequence: sequence
  };
};

var valueRenderer = function valueRenderer(option) {
  return option.selectedLabel;
};

var createChangeHandler = function createChangeHandler(id, setLogicConditionQuestion) {
  return function (_ref2) {
    var value = _ref2.value;
    return setLogicConditionQuestion(id, value);
  };
};

var QuestionSelect = function QuestionSelect(_ref3) {
  var id = _ref3.id,
      value = _ref3.value,
      setLogicConditionQuestion = _ref3.setLogicConditionQuestion,
      _ref3$eligibleQuestio = _ref3.eligibleQuestions,
      eligibleQuestions = _ref3$eligibleQuestio === undefined ? [] : _ref3$eligibleQuestio,
      readOnly = _ref3.readOnly;
  var options = eligibleQuestions.map(optionFromQuestion);
  var sortedOptions = sortBy_1(options, function (o) {
    return o.sequence;
  });
  return React.createElement(StyledSelect$1, {
    disabled: readOnly,
    searchable: false,
    clearable: false,
    value: sortedOptions.find(function (o) {
      return o.value === value;
    }),
    options: sortedOptions,
    onChange: createChangeHandler(id, setLogicConditionQuestion),
    valueRenderer: valueRenderer
  });
};

var createLogicCondition = function createLogicCondition(payload) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_CREATE,
    payload: payload
  };
};

var deleteLogicCondition = function deleteLogicCondition(id) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_DELETE,
    payload: id
  };
};

var setLogicConditionValue = function setLogicConditionValue(id, value) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_SET_VALUE,
    payload: {
      id: id,
      value: value
    }
  };
};

var setLogicConditionSpecialOptionValue = function setLogicConditionSpecialOptionValue(id, specialOption) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_SET_SPECIAL_OPTION_VALUE,
    payload: {
      id: id,
      specialOption: specialOption
    }
  };
};

var setLogicConditionAnswer = function setLogicConditionAnswer(id, answerContent) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_SET_ANSWER,
    payload: {
      id: id,
      answerContent: answerContent
    }
  };
};

var setLogicConditionQuestion = function setLogicConditionQuestion(id, question) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_SET_QUESTION,
    payload: {
      id: id,
      question: question
    }
  };
};

var setLogicConditionOperator = function setLogicConditionOperator(id, operator) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_SET_OPERATOR,
    payload: {
      id: id,
      operator: operator
    }
  };
};

var setLogicConditionGate = function setLogicConditionGate(id, gate) {
  return {
    type: logicConditionTypes.LOGIC_CONDITION_SET_GATE,
    payload: {
      id: id,
      gate: gate
    }
  };
};

function mapStateToProps$s(state, ownProps) {
  var question = questionByConditionIdSelector(state, ownProps.id);

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    value: question.id,
    readOnly: readOnly
  };
}

var QuestionSelectContainer = connect(mapStateToProps$s, {
  setLogicConditionQuestion: setLogicConditionQuestion
})(QuestionSelect);

var _templateObject$t = taggedTemplateLiteral(["\n  flex: ", " 0 6em;\n"], ["\n  flex: ", " 0 6em;\n"]); // If we have more than 2 options, we're dealing with numeric operators.
// These labels are longer and would like a longer flex-basis.


var StyledSelect$2 = styled(StyledSelect)(_templateObject$t, function (props) {
  return props.options.length > 2 ? "1" : "0";
});

var labelFromOperator = function labelFromOperator(op, opLength) {
  switch (op) {
    // In cases where we're dealing with numeric equality, we want to say "is equal to".
    // If we're dealing with discrete-answer equality, we just want to say "is".
    // We check for numeracy by checking how many possible operators are available.
    case operatorTypes.OPERATOR_EQUAL:
      return opLength > 2 ? "is equal to" : "is";

    case operatorTypes.OPERATOR_NOT_EQUAL:
      return opLength > 2 ? "is not equal to" : "is not";

    case operatorTypes.OPERATOR_RANGE:
      return "is a range from";

    case operatorTypes.OPERATOR_LESS_THAN:
      return "is less than";

    case operatorTypes.OPERATOR_GREATER_THAN:
      return "is greater than";

    default:
      return "";
  }
};

var optionFromOperator = function optionFromOperator(op, opLength) {
  return {
    value: op,
    label: labelFromOperator(op, opLength)
  };
};

var createChangeHandler$1 = function createChangeHandler(id, setLogicConditionOperator) {
  return function (_ref) {
    var value = _ref.value;
    return setLogicConditionOperator(id, value);
  };
};

var OperatorSelect = function OperatorSelect(_ref2) {
  var id = _ref2.id,
      setLogicConditionOperator = _ref2.setLogicConditionOperator,
      value = _ref2.value,
      readOnly = _ref2.readOnly,
      questionType = _ref2.questionType;
  var operators = questionConfigs[questionType].conditionOperators;
  if (operators === false) return null;
  var options = operators.map(function (o) {
    return optionFromOperator(o, operators.length);
  });
  return React.createElement(StyledSelect$2, {
    disabled: readOnly,
    searchable: false,
    clearable: false,
    value: options.find(function (o) {
      return o.value === value;
    }),
    options: options,
    onChange: createChangeHandler$1(id, setLogicConditionOperator)
  });
};

function mapStateToProps$t(state, ownProps) {
  var condition = conditionByIdSelector(state, ownProps.id);
  var question = questionByConditionIdSelector(state, ownProps.id);

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    questionType: question.type,
    value: condition.operator,
    readOnly: readOnly
  };
}

var OperatorSelectContainer = connect(mapStateToProps$t, {
  setLogicConditionOperator: setLogicConditionOperator
})(OperatorSelect);

var _templateObject$u = taggedTemplateLiteral(["\n  position: static;\n  flex: 1 0 0;\n"], ["\n  position: static;\n  flex: 1 0 0;\n"]),
    _templateObject2$b = taggedTemplateLiteral(["\n  font-size: 14px;\n  pointer-events: none;\n  margin-right: 10px;\n"], ["\n  font-size: 14px;\n  pointer-events: none;\n  margin-right: 10px;\n"]),
    _templateObject3$5 = taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 35px;\n  padding-left: 20px;\n  strong {\n    font-weight: 600;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  height: 35px;\n  padding-left: 20px;\n  strong {\n    font-weight: 600;\n  }\n"]),
    _templateObject4$3 = taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
    _templateObject5$3 = taggedTemplateLiteral(["\n  white-space: nowrap;\n  display: inline-block;\n  padding: 0em 0.2em;\n"], ["\n  white-space: nowrap;\n  display: inline-block;\n  padding: 0em 0.2em;\n"]);

var StyledSelect$3 = styled(StyledSelect)(_templateObject$u);
var StyledCheckbox = styled(Checkbox)(_templateObject2$b);
var StyledRow = styled.div(_templateObject3$5);

var optionFromModel = function optionFromModel(model, type) {
  return {
    value: model.id,
    label: model.content,
    type: type
  };
};

var SelectValue = function SelectValue(_ref) {
  var value = _ref.value;
  return React.createElement("span", null, value.label);
};

var MenuRow = function MenuRow(props) {
  var label = props.label,
      isSelected = props.isSelected;
  return React.createElement(components.Option, props, React.createElement(StyledCheckbox, {
    checked: isSelected,
    readOnly: true
  }), label);
};

var MenuOuter = styled.div(_templateObject4$3);

var GroupHeading = function GroupHeading(props) {
  return React.createElement(components.GroupHeading, props, React.createElement("span", null, React.createElement("strong", null, props.children, " "), " (1 answer min.)"));
};

var rowStyles = {
  display: "flex",
  alignItems: "center",
  height: "35px",
  paddingLeft: "20px"
};
var ValueSpan = styled.span(_templateObject5$3);

var MultiValue = function MultiValue(_ref2) {
  var children = _ref2.children;
  return React.createElement(ValueSpan, null, children);
};

var ValueSelectGrid = function (_React$Component) {
  inherits(ValueSelectGrid, _React$Component);

  function ValueSelectGrid(props) {
    classCallCheck(this, ValueSelectGrid);

    var _this = possibleConstructorReturn(this, (ValueSelectGrid.__proto__ || Object.getPrototypeOf(ValueSelectGrid)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.selectRows = _this.selectRows.bind(_this);
    _this.selectColumns = _this.selectColumns.bind(_this);
    return _this;
  }

  createClass(ValueSelectGrid, [{
    key: "handleChange",
    value: function handleChange(selected) {
      var _props = this.props,
          id = _props.id,
          setLogicConditionValue = _props.setLogicConditionValue;
      var value = {
        rows: selected.filter(function (o) {
          return o.type === "row";
        }).map(function (r) {
          return r.value;
        }),
        columns: selected.filter(function (o) {
          return o.type === "column";
        }).map(function (c) {
          return c.value;
        })
      };
      if (value.rows.length > 0 && value.columns.length > 0) setLogicConditionValue(id, value);
    }
  }, {
    key: "selectRows",
    value: function selectRows() {
      var _props2 = this.props,
          id = _props2.id,
          rows = _props2.rows,
          value = _props2.value,
          setLogicConditionValue = _props2.setLogicConditionValue;
      var selectedRows = value.rows;
      var newRows = selectedRows.length === rows.length ? [] : rows.map(function (r) {
        return r.id;
      });
      return setLogicConditionValue(id, {
        rows: newRows,
        columns: value.columns
      });
    }
  }, {
    key: "selectColumns",
    value: function selectColumns() {
      var _props3 = this.props,
          id = _props3.id,
          columns = _props3.columns,
          value = _props3.value,
          setLogicConditionValue = _props3.setLogicConditionValue;
      var selectedColumns = value.columns;
      var newColumns = selectedColumns.length === columns.length ? [] : columns.map(function (c) {
        return c.id;
      });
      return setLogicConditionValue(id, {
        rows: value.rows,
        columns: newColumns
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _React$createElement;

      var _props4 = this.props,
          rows = _props4.rows,
          columns = _props4.columns,
          value = _props4.value,
          readOnly = _props4.readOnly;
      var rowOptions = rows.map(function (r) {
        return optionFromModel(r, "row");
      });
      var columnOptions = columns.map(function (c) {
        return optionFromModel(c, "column");
      });
      var options = columnOptions.concat(rowOptions);
      var selectedIds = value.columns.concat(value.rows);
      var groupedOptions = [{
        label: "Columns",
        options: columnOptions
      }, {
        label: "Rows",
        options: rowOptions
      }];
      return React.createElement(StyledSelect$3, (_React$createElement = {
        disabled: readOnly,
        isSearchable: false,
        isClearable: false,
        options: options,
        isMulti: true,
        value: options.filter(function (o) {
          return selectedIds.includes(o.value);
        }),
        components: {
          GroupHeading: GroupHeading,
          Option: MenuRow,
          MultiValue: MultiValue
        },
        styles: {
          option: function option(base) {
            return _extends$c({}, base, rowStyles);
          },
          groupHeading: function groupHeading(base) {
            return _extends$c({}, base, rowStyles, {
              fontSize: "inherit",
              color: "inherit",
              textTransform: "none"
            });
          },
          menu: function menu(base) {
            return _extends$c({}, base, {
              left: 0
            });
          },
          container: function container(base) {
            return _extends$c({}, base, {
              position: "static"
            });
          },
          valueContainer: function valueContainer(base) {
            return _extends$c({}, base, {
              flexWrap: "nowrap",
              maxWidth: "14em",
              textOverflow: "ellipsis"
            });
          },
          multiValue: function multiValue(base) {
            return _extends$c({}, base, {
              flexShrink: 0
            });
          }
        },
        hideSelectedOptions: false,
        onChange: this.handleChange,
        removeSelected: false
      }, defineProperty$3(_React$createElement, "options", groupedOptions), defineProperty$3(_React$createElement, "valueComponent", SelectValue), defineProperty$3(_React$createElement, "closeMenuOnSelect", false), defineProperty$3(_React$createElement, "blurInputOnSelect", false), _React$createElement));
    }
  }]);
  return ValueSelectGrid;
}(React.Component); // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$3 = function makeMapStateToProps() {
  var getCondition = makeConditionByIdSelector();
  var getGridContent = makeGridContentSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var id = ownProps.id;

    var _getCondition = getCondition(state, id),
        question = _getCondition.question;

    var _getGridContent = getGridContent(state, question),
        rows = _getGridContent.rows,
        columns = _getGridContent.columns;

    return {
      rows: rows,
      columns: columns
    };
  };

  return mapStateToProps;
};

var GridValueContainer = connect(makeMapStateToProps$3)(ValueSelectGrid);

var _templateObject$v = taggedTemplateLiteral(["\n  flex: 1 0 0;\n  &.Select {\n    position: static;\n  }\n  .Select-menu-outer {\n    width: 100%;\n    left: 0;\n    margin-top: 0.5em;\n  }\n"], ["\n  flex: 1 0 0;\n  &.Select {\n    position: static;\n  }\n  .Select-menu-outer {\n    width: 100%;\n    left: 0;\n    margin-top: 0.5em;\n  }\n"]);

var StyledSelect$4 = styled(StyledSelect)(_templateObject$v);

var rowToValue = function rowToValue(id) {
  return "row_" + id;
};

var specialToValue = function specialToValue(id) {
  return "special_" + id;
};

var optionFromModel$1 = function optionFromModel(model) {
  return {
    value: rowToValue(model.id),
    id: model.id,
    label: "A" + model.sequence + ": " + model.content,
    isRow: true
  };
};

var optionFromSpecial = function optionFromSpecial(specialOption) {
  return {
    value: specialToValue(specialOption.id),
    id: specialOption.id,
    label: specialOption.text,
    isRow: false
  };
};

var selectFormattedValue = function selectFormattedValue(rowOptions, specialOptions, rowValue, specialOptionValue) {
  if (rowValue !== undefined) {
    var formatted = rowToValue(rowValue);
    return rowOptions.find(function (o) {
      return o.value === formatted;
    });
  }

  if (specialOptionValue !== undefined) {
    var _formatted = specialToValue(specialOptionValue);

    return specialOptions.find(function (o) {
      return o.value === _formatted;
    });
  }

  return undefined;
};

var ValueSelectDiscrete = function ValueSelectDiscrete(props) {
  var id = props.id,
      setLogicConditionValue = props.setLogicConditionValue,
      setLogicConditionSpecialOptionValue = props.setLogicConditionSpecialOptionValue,
      rows = props.rows,
      specialOptions = props.specialOptions,
      specialOptionValue = props.specialOptionValue,
      readOnly = props.readOnly,
      value = props.value;

  var onChange = function onChange(o) {
    return o.isRow ? setLogicConditionValue(id, o.id) : setLogicConditionSpecialOptionValue(id, o.id);
  };

  var rowOptions = rows.map(optionFromModel$1);
  var specials = specialOptions.map(optionFromSpecial);
  var options = [].concat(toConsumableArray(rowOptions), toConsumableArray(specials));
  var val = selectFormattedValue(rowOptions, specials, value, specialOptionValue);
  return React.createElement(StyledSelect$4, {
    disabled: readOnly,
    searchable: false,
    clearable: false,
    value: val,
    options: options,
    onChange: onChange
  });
};

function mapStateToProps$u(state, ownProps) {
  var _answersByConditionSe = answersByConditionSelector(state, ownProps.id),
      rows = _answersByConditionSe.rows,
      specialOptions = _answersByConditionSe.specialOptions;

  return {
    rows: rows,
    specialOptions: specialOptions
  };
}

var DiscreteValueContainer = connect(mapStateToProps$u)(ValueSelectDiscrete);

var _templateObject$w = taggedTemplateLiteral(["\n  width: 2.3em;\n  padding: 0.52em 0.9em;\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n  }\n"], ["\n  width: 2.3em;\n  padding: 0.52em 0.9em;\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n  }\n"]);

var StyledInput$2 = styled(TextInput)(_templateObject$w);

var NumberValue = function (_React$Component) {
  inherits(NumberValue, _React$Component);

  function NumberValue(props) {
    classCallCheck(this, NumberValue);

    var _this = possibleConstructorReturn(this, (NumberValue.__proto__ || Object.getPrototypeOf(NumberValue)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  createClass(NumberValue, [{
    key: "handleChange",
    value: function handleChange(e) {
      var _props = this.props,
          id = _props.id,
          setLogicConditionValue = _props.setLogicConditionValue;
      setLogicConditionValue(id, e.currentTarget.value);
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.props.condition.value;
      return React.createElement(StyledInput$2, {
        readOnly: this.props.readOnly,
        type: "number",
        value: value,
        onChange: this.handleChange
      });
    }
  }]);
  return NumberValue;
}(React.Component);

var RangeValue = function (_React$Component2) {
  inherits(RangeValue, _React$Component2);

  function RangeValue(props) {
    classCallCheck(this, RangeValue);

    var _this2 = possibleConstructorReturn(this, (RangeValue.__proto__ || Object.getPrototypeOf(RangeValue)).call(this, props));

    _this2.handleMinChange = _this2.handleMinChange.bind(_this2);
    _this2.handleMaxChange = _this2.handleMaxChange.bind(_this2);
    return _this2;
  }

  createClass(RangeValue, [{
    key: "handleMinChange",
    value: function handleMinChange(e) {
      var _props2 = this.props,
          id = _props2.id,
          setLogicConditionValue = _props2.setLogicConditionValue,
          condition = _props2.condition;
      var value = condition.value;
      var newValue = {
        min: e.currentTarget.value,
        max: value.max
      };
      setLogicConditionValue(id, newValue);
    }
  }, {
    key: "handleMaxChange",
    value: function handleMaxChange(e) {
      var _props3 = this.props,
          id = _props3.id,
          setLogicConditionValue = _props3.setLogicConditionValue,
          condition = _props3.condition;
      var value = condition.value;
      var newValue = {
        min: value.min,
        max: e.currentTarget.value
      };
      setLogicConditionValue(id, newValue);
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.props.condition.value;
      var min = value.min,
          max = value.max;
      return [React.createElement(StyledInput$2, {
        type: "number",
        key: "min",
        readOnly: this.props.readOnly,
        value: min,
        onChange: this.handleMinChange
      }), React.createElement("span", {
        key: "label"
      }, "to"), React.createElement(StyledInput$2, {
        type: "number",
        key: "max",
        readOnly: this.props.readOnly,
        value: max,
        onChange: this.handleMaxChange
      })];
    }
  }]);
  return RangeValue;
}(React.Component);

var ValueSwitch = function ValueSwitch(_ref) {
  var id = _ref.id,
      condition = _ref.condition,
      readOnly = _ref.readOnly,
      setLogicConditionValue = _ref.setLogicConditionValue,
      setLogicConditionSpecialOptionValue = _ref.setLogicConditionSpecialOptionValue;

  switch (condition.questionType) {
    case "sum":
    case "multiple_rating":
    case "multiple_slider":
    case "rank_order":
    case "numeric":
    case "rating":
    case "slider":
      if (condition.operator === "range") {
        return React.createElement(RangeValue, {
          id: id,
          condition: condition,
          readOnly: readOnly,
          setLogicConditionValue: setLogicConditionValue
        });
      }

      return React.createElement(NumberValue, {
        id: id,
        condition: condition,
        readOnly: readOnly,
        setLogicConditionValue: setLogicConditionValue
      });

    case "single_select":
    case "multiple_select":
    case "dropdown":
      return React.createElement(DiscreteValueContainer, {
        id: id,
        value: condition.value,
        readOnly: readOnly,
        setLogicConditionValue: setLogicConditionValue,
        setLogicConditionSpecialOptionValue: setLogicConditionSpecialOptionValue,
        specialOptionValue: condition.specialOptionValue,
        question: condition.question
      });

    case "single_select_matrix":
    case "multiple_select_matrix":
      return React.createElement(GridValueContainer, {
        id: id,
        readOnly: readOnly,
        value: condition.value,
        setLogicConditionValue: setLogicConditionValue
      });

    default:
      return null;
  }
};

function mapStateToProps$v(state, ownProps) {
  var condition = logicConditionSelector(state, ownProps.id);

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    condition: condition,
    readOnly: readOnly
  };
}

var ValueSwitchContainer = connect(mapStateToProps$v, {
  setLogicConditionValue: setLogicConditionValue,
  setLogicConditionSpecialOptionValue: setLogicConditionSpecialOptionValue
})(ValueSwitch);

var _templateObject$x = taggedTemplateLiteral(["\n  &.Select {\n    position: static;\n  }\n  flex: 1 0 0;\n  min-width: 0;\n  margin-right: 1em;\n  .Select-menu-outer {\n    width: 100%;\n    left: 0;\n    margin-top: 0.5em;\n  }\n  .Select-value {\n    margin-top: 0;\n    font-size: 1em;\n    color: inherit;\n    background: transparent;\n    border: 0 none;\n    border-radius: 0;\n    white-space: nowrap;\n  }\n  .Select-value-label {\n    top: 50%;\n    position: relative;\n    transform: translateY(-50%);\n    padding: 2px 3px;\n  }\n  .Select-arrow-zone {\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    svg {\n      position: absolute;\n      top: calc(50% - 0.5em);\n      right: calc(50% - 0.5em);\n    }\n  }\n  .Select-control {\n    display: block;\n    height: 32px;\n  }\n  .Select-value-icon {\n    display: none;\n  }\n  .Select-multi-value-wrapper {\n    display: flex;\n    overflow: hidden;\n    height: 100%;\n  }\n"], ["\n  &.Select {\n    position: static;\n  }\n  flex: 1 0 0;\n  min-width: 0;\n  margin-right: 1em;\n  .Select-menu-outer {\n    width: 100%;\n    left: 0;\n    margin-top: 0.5em;\n  }\n  .Select-value {\n    margin-top: 0;\n    font-size: 1em;\n    color: inherit;\n    background: transparent;\n    border: 0 none;\n    border-radius: 0;\n    white-space: nowrap;\n  }\n  .Select-value-label {\n    top: 50%;\n    position: relative;\n    transform: translateY(-50%);\n    padding: 2px 3px;\n  }\n  .Select-arrow-zone {\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    svg {\n      position: absolute;\n      top: calc(50% - 0.5em);\n      right: calc(50% - 0.5em);\n    }\n  }\n  .Select-control {\n    display: block;\n    height: 32px;\n  }\n  .Select-value-icon {\n    display: none;\n  }\n  .Select-multi-value-wrapper {\n    display: flex;\n    overflow: hidden;\n    height: 100%;\n  }\n"]);

var StyledSelect$5 = styled(StyledSelect)(_templateObject$x);

var optionFromModel$2 = function optionFromModel(model, index) {
  return {
    value: model.id,
    label: "" + model.content,
    index: index
  };
};

var AnswerSelect = function AnswerSelect(props) {
  var id = props.id,
      setLogicConditionAnswer = props.setLogicConditionAnswer,
      rows = props.rows,
      specialOptions = props.specialOptions,
      value = props.value,
      specialOption = props.specialOption,
      readOnly = props.readOnly;
  var options = rows.map(function (model, index) {
    return optionFromModel$2(model, index);
  });

  function onChange(options) {
    var values = options.split(",").map(function (o) {
      return parseInt(o, 10);
    });
    setLogicConditionAnswer(id, values);
  }

  return React.createElement(StyledSelect$5, {
    disabled: readOnly,
    multi: true,
    removeSelected: false,
    closeOnSelect: false,
    searchable: false,
    clearable: false,
    value: options.find(function (o) {
      return o.isRow ? o.value === value : o.value === specialOption.id;
    }),
    options: options,
    onChange: onChange,
    simpleValue: true
  });
};

var makeMapStateToProps$4 = function makeMapStateToProps() {
  return function (state, ownProps) {
    var id = ownProps.id;

    var _conditionByIdSelecto = conditionByIdSelector(state, id),
        answer = _conditionByIdSelecto.answer;

    var question = questionByConditionIdSelector(state, id);

    var _answersByConditionSe = answersByConditionSelector(state, question.id),
        rows = _answersByConditionSe.rows,
        specialOptions = _answersByConditionSe.specialOptions;

    var _uiSelector = uiSelector(state),
        readOnly = _uiSelector.readOnly;

    return {
      rows: rows,
      specialOptions: specialOptions,
      value: answer,
      readOnly: readOnly
    };
  };
};

var AnswerSelectContainer = connect(makeMapStateToProps$4, {
  setLogicConditionAnswer: setLogicConditionAnswer
})(AnswerSelect);

var _templateObject$y = taggedTemplateLiteral(["\n\tmax-width: 15em;\n\tmargin: 0 auto;\n\t.Select-placeholder {\n\t\ttext-transform: uppercase;\n\t\tcolor: inherit;\n\t}\n"], ["\n\tmax-width: 15em;\n\tmargin: 0 auto;\n\t.Select-placeholder {\n\t\ttext-transform: uppercase;\n\t\tcolor: inherit;\n\t}\n"]),
    _templateObject2$c = taggedTemplateLiteral(["\n\ttext-align: center;\n\tposition: relative;\n\twidth: 100%;\n\tmargin-bottom: 1em;\n"], ["\n\ttext-align: center;\n\tposition: relative;\n\twidth: 100%;\n\tmargin-bottom: 1em;\n"]),
    _templateObject3$6 = taggedTemplateLiteral(["\n\ttop: 0;\n\tleft: 0;\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: visible;\n"], ["\n\ttop: 0;\n\tleft: 0;\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: visible;\n"]),
    _templateObject4$4 = taggedTemplateLiteral(["\n\tfill: none;\n\tstroke: ", ";\n\tstroke-width: 2;\n\tstroke-dasharray: 12;\n"], ["\n\tfill: none;\n\tstroke: ", ";\n\tstroke-width: 2;\n\tstroke-dasharray: 12;\n"]);

var StyledSelect$6 = styled(Select)(_templateObject$y);
var Wrapper$9 = styled.div(_templateObject2$c);
var Graphic = styled.svg(_templateObject3$6);
var Line = styled.line(_templateObject4$4, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralLight["4"];
});
var options = [{
  label: "AND",
  value: "AND"
}, {
  label: "OR",
  value: "OR"
}];

var GateSelect = function GateSelect(_ref2) {
  var id = _ref2.id,
      gate = _ref2.value,
      branch = _ref2.branch,
      readOnly = _ref2.readOnly,
      createLogicCondition = _ref2.createLogicCondition,
      setLogicConditionGate = _ref2.setLogicConditionGate;

  var onChange = function onChange(_ref3) {
    var value = _ref3.value;

    if (gate === undefined) {
      return createLogicCondition({
        branch: branch,
        previousCondition: id,
        previousGate: value
      });
    }

    setLogicConditionGate(id, value);
  };

  return React.createElement(Wrapper$9, null, React.createElement(Graphic, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 738 2"
  }, React.createElement(Line, {
    height: "100%",
    width: "100%",
    x1: "0",
    y1: "1",
    x2: "738",
    y2: "1"
  })), React.createElement(StyledSelect$6, {
    disabled: readOnly,
    value: options.find(function (o) {
      return o.value === gate;
    }),
    options: options,
    onChange: onChange,
    searchable: false,
    clearable: false,
    placeholder: "+ Add Condition"
  }));
};

var mapStateToProps$w = function mapStateToProps(state, _ref) {
  var id = _ref.id;

  var _conditionByIdSelecto = conditionByIdSelector(state, id),
      gate = _conditionByIdSelecto.gate;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    readOnly: readOnly,
    value: gate
  };
};

var GateSelectContainer = connect(mapStateToProps$w, {
  createLogicCondition: createLogicCondition,
  setLogicConditionGate: setLogicConditionGate
})(GateSelect);

var _templateObject$z = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tposition: relative;\n\t> :not(:last-child) {\n\t\tmargin-right: 0.7em;\n\t}\n\tmargin-bottom: 1em;\n"], ["\n\tfont-size: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tposition: relative;\n\t> :not(:last-child) {\n\t\tmargin-right: 0.7em;\n\t}\n\tmargin-bottom: 1em;\n"]),
    _templateObject2$d = taggedTemplateLiteral(["\n\tflex-wrap: wrap;\n\t> :not(:last-child) {\n\t\tmargin-right: 0;\n\t}\n"], ["\n\tflex-wrap: wrap;\n\t> :not(:last-child) {\n\t\tmargin-right: 0;\n\t}\n"]),
    _templateObject3$7 = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tposition: relative;\n\tmargin-bottom: 0.7em;\n\t> :not(:last-child) {\n\t\tmargin-right: 0.7em;\n\t}\n\t&:last-child > :last-child {\n\t\tmargin-right: 2.7em;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tposition: relative;\n\tmargin-bottom: 0.7em;\n\t> :not(:last-child) {\n\t\tmargin-right: 0.7em;\n\t}\n\t&:last-child > :last-child {\n\t\tmargin-right: 2.7em;\n\t}\n"]);

var Delete$2 = icons.Delete;
var Wrapper$a = styled.div(_templateObject$z);
var AnswerWrapper = styled(Wrapper$a)(_templateObject2$d);
var AnswerRow = styled.div(_templateObject3$7);

var LogicConditionWithAnswer = function LogicConditionWithAnswer(props) {
  var id = props.id,
      branch = props.branch,
      deleteLogicCondition = props.deleteLogicCondition,
      _props$eligibleQuesti = props.eligibleQuestions,
      eligibleQuestions = _props$eligibleQuesti === undefined ? [] : _props$eligibleQuesti,
      readOnly = props.readOnly;
  return [React.createElement(AnswerWrapper, {
    key: "condition"
  }, React.createElement(AnswerRow, null, React.createElement(QuestionSelectContainer, {
    id: id,
    eligibleQuestions: eligibleQuestions
  }), React.createElement("span", null, "is"), React.createElement(AnswerSelectContainer, {
    id: id
  }), React.createElement(IconButton, {
    disabled: readOnly,
    onClick: function onClick() {
      return deleteLogicCondition(id);
    }
  }, React.createElement(Delete$2, null))), React.createElement(AnswerRow, null, React.createElement(OperatorSelectContainer, {
    id: id
  }), React.createElement(ValueSwitchContainer, {
    id: id
  }))), React.createElement(GateSelectContainer, {
    key: "gate",
    id: id,
    branch: branch
  })];
};

var LogicConditionWithoutAnswer = function LogicConditionWithoutAnswer(props) {
  var id = props.id,
      branch = props.branch,
      deleteLogicCondition = props.deleteLogicCondition,
      _props$eligibleQuesti2 = props.eligibleQuestions,
      eligibleQuestions = _props$eligibleQuesti2 === undefined ? [] : _props$eligibleQuesti2,
      readOnly = props.readOnly;
  return [React.createElement(Wrapper$a, {
    key: "condition"
  }, React.createElement(QuestionSelectContainer, {
    id: id,
    eligibleQuestions: eligibleQuestions
  }), React.createElement(OperatorSelectContainer, {
    id: id
  }), React.createElement(ValueSwitchContainer, {
    id: id
  }), React.createElement(IconButton, {
    disabled: readOnly,
    onClick: function onClick() {
      return deleteLogicCondition(id);
    }
  }, React.createElement(Delete$2, null))), React.createElement(GateSelectContainer, {
    key: "gate",
    id: id,
    branch: branch
  })];
};

var LogicCondition$1 = function LogicCondition(props) {
  var questionType = props.questionType;
  var useAnswer = questionConfigs[questionType].conditionAnswer;
  return useAnswer ? React.createElement(LogicConditionWithAnswer, props) : React.createElement(LogicConditionWithoutAnswer, props);
};

function mapStateToProps$x(state, ownProps) {
  var _questionByConditionI = questionByConditionIdSelector(state, ownProps.id),
      type = _questionByConditionI.type;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    questionType: type,
    readOnly: readOnly
  };
}

var LogicConditionContainer = connect(mapStateToProps$x, {
  deleteLogicCondition: deleteLogicCondition
})(LogicCondition$1);

var _templateObject$A = taggedTemplateLiteral([""], [""]);

var ConditionWrapper = styled.div(_templateObject$A);

var ConditionList = function ConditionList(_ref) {
  var id = _ref.id,
      _ref$conditions = _ref.conditions,
      conditions = _ref$conditions === undefined ? [] : _ref$conditions,
      _ref$eligibleQuestion = _ref.eligibleQuestions,
      eligibleQuestions = _ref$eligibleQuestion === undefined ? [] : _ref$eligibleQuestion;
  return conditions.map(function (c) {
    return React.createElement(ConditionWrapper, {
      key: c
    }, React.createElement(LogicConditionContainer, {
      eligibleQuestions: eligibleQuestions,
      id: c,
      branch: id
    }));
  });
};

function mapStateToProps$y(state, ownProps) {
  return {
    conditions: conditionsByBranchSelector(state, ownProps.id)
  };
}

var ConditionListContainer = connect(mapStateToProps$y)(ConditionList);

var _templateObject$B = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttext-align: center;\n\tborder-radius: 7px;\n\tpadding: 1.3em 0;\n\tmargin-top: 20px;\n\tmargin-bottom: 15px;\n\tbackground: ", ";\n"], ["\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttext-align: center;\n\tborder-radius: 7px;\n\tpadding: 1.3em 0;\n\tmargin-top: 20px;\n\tmargin-bottom: 15px;\n\tbackground: ", ";\n"]);

var LogicHeader = styled.header(_templateObject$B, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralLight["5"];
});

var renderMenu = function renderMenu(logicBranchId, eligibleQuestions) {
  return logicBranchId === undefined ? null : React.createElement("div", null, React.createElement(LogicHeader, null, "Display this page only if:"), React.createElement(ConditionListContainer, {
    id: logicBranchId,
    eligibleQuestions: eligibleQuestions
  }));
};

var DisplayLogicMenu = function DisplayLogicMenu(_ref) {
  var pageId = _ref.pageId,
      logicBranchId = _ref.logicBranchId,
      eligibleQuestions = _ref.eligibleQuestions,
      readOnly = _ref.readOnly;
  return React.createElement(DrawerBodySegment, null, React.createElement(ToggleContainer, {
    readOnly: readOnly || eligibleQuestions.length === 0,
    pageId: pageId,
    logicBranchId: logicBranchId
  }), renderMenu(logicBranchId, eligibleQuestions));
};

function mapStateToProps$z(state, _ref) {
  var pageId = _ref.pageId;
  var logicBranch = displayLogicSelector(state, pageId);
  var logicBranchId = logicBranch ? logicBranch.id : undefined;
  var nodeId = nodeByPageIdSelector(state, pageId).id;
  var eligibleQuestions = displayLogicQuestionsSelector(state, nodeId);

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    logicBranchId: logicBranchId,
    eligibleQuestions: eligibleQuestions,
    readOnly: readOnly
  };
}

var DisplayLogicMenuContainer = connect(mapStateToProps$z)(DisplayLogicMenu);

var _templateObject$C = taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\twidth: 10em;\n\tvertical-align: middle;\n\ttext-align: left;\n\tmargin: 0 0.5em;\n\tfont-weight: normal;\n"], ["\n\tdisplay: inline-block;\n\twidth: 10em;\n\tvertical-align: middle;\n\ttext-align: left;\n\tmargin: 0 0.5em;\n\tfont-weight: normal;\n"]);

var StyledSelect$7 = styled(Select)(_templateObject$C);

var getSelectOptions = function getSelectOptions(pages) {
  return [{
    value: "complete",
    label: "Complete"
  }, {
    value: "disqualify",
    label: "Disqualify"
  }].concat(toConsumableArray(pages.map(function (p) {
    return {
      value: p.id,
      label: "Page " + p.sequence
    };
  })));
};

var TargetSelect = function TargetSelect(_ref) {
  var id = _ref.id,
      pages = _ref.pages,
      value = _ref.value,
      setLogicBranchTarget = _ref.setLogicBranchTarget,
      readOnly = _ref.readOnly;

  var onChange = function onChange(_ref2) {
    var value = _ref2.value;
    setLogicBranchTarget(id, value);
  };

  var options = getSelectOptions(pages);
  return React.createElement(StyledSelect$7, {
    options: options,
    disabled: readOnly,
    value: options.find(function (o) {
      return o.value === value;
    }),
    onChange: onChange,
    searchable: false,
    clearable: false
  });
};

var mapStateToProps$A = function mapStateToProps(state, ownProps) {
  var id = ownProps.id;
  var target = logicBranchTargetSelector(state, id);

  var _logicBranchByIdSelec = logicBranchByIdSelector(state, id),
      specialTarget = _logicBranchByIdSelec.specialTarget;

  var value = specialTarget === "complete" || specialTarget === "disqualify" ? specialTarget : target.id;
  return {
    value: value
  };
};

var TargetSelectContainer = connect(mapStateToProps$A, {
  setLogicBranchTarget: setLogicBranchTarget
})(TargetSelect);

var _templateObject$D = taggedTemplateLiteral(["\n\tfont-size: 1em;\n\tfont-weight: 600;\n\tcolor: ", ";\n\tmargin: 1em 0 0;\n"], ["\n\tfont-size: 1em;\n\tfont-weight: 600;\n\tcolor: ", ";\n\tmargin: 1em 0 0;\n"]),
    _templateObject2$e = taggedTemplateLiteral(["\n\tmargin-top: 1em;\n"], ["\n\tmargin-top: 1em;\n"]);

var StyledH1 = styled.h1(_templateObject$D, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralLight["1"];
});
var StyledLogicHeader = styled(LogicHeader)(_templateObject2$e);

var LogicBranch$1 = function LogicBranch(_ref2) {
  var id = _ref2.id,
      index = _ref2.index,
      eligibleQuestions = _ref2.eligibleQuestions,
      eligibleTargets = _ref2.eligibleTargets,
      readOnly = _ref2.readOnly;
  return React.createElement("div", null, React.createElement(StyledH1, null, "Branch ", index + 1), React.createElement(StyledLogicHeader, null, "Go to", " ", React.createElement(TargetSelectContainer, {
    readOnly: readOnly,
    id: id,
    pages: eligibleTargets
  }), " ", "if"), React.createElement(ConditionListContainer, {
    id: id,
    eligibleQuestions: eligibleQuestions
  }));
};

var BranchList = function BranchList(_ref) {
  var logicBranches = _ref.logicBranches,
      eligibleQuestions = _ref.eligibleQuestions,
      eligibleTargets = _ref.eligibleTargets,
      readOnly = _ref.readOnly;
  return logicBranches.map(function (b, i) {
    return React.createElement(LogicBranch$1, {
      key: b,
      id: b,
      index: i,
      eligibleQuestions: eligibleQuestions,
      eligibleTargets: eligibleTargets,
      readOnly: readOnly
    });
  });
};

var SkipLogicToggle = function SkipLogicToggle(props) {
  var pageId = props.pageId,
      defaultQuestion = props.defaultQuestion,
      skipLogicBranches = props.skipLogicBranches,
      createSkipLogic = props.createSkipLogic,
      deleteSkipLogic = props.deleteSkipLogic,
      disabled = props.disabled;

  var onChange = function onChange() {
    if (defaultQuestion === undefined) throw new Error("Skip Logic toggle is missing a default question. Make sure the control is disabled or has a defaultQuestion.");
    if (skipLogicBranches.length === 0) return createSkipLogic({
      page: pageId,
      defaultQuestion: defaultQuestion
    });
    return deleteSkipLogic(pageId);
  };

  return React.createElement(DrawerBodyRow, null, React.createElement(SkipLogic, null), React.createElement(DrawerBodyLabel, null, "Skip Logic"), React.createElement(Toggle, {
    disabled: disabled,
    onChange: onChange,
    checked: skipLogicBranches.length > 0
  }));
};

var ToggleContainer$1 = connect(null, {
  createSkipLogic: createSkipLogic,
  deleteSkipLogic: deleteSkipLogic
})(SkipLogicToggle);

var _templateObject$E = taggedTemplateLiteral(["\n  width: 12em;\n  margin-top: 1em;\n"], ["\n  width: 12em;\n  margin-top: 1em;\n"]);

var StyledButton$4 = styled(Button)(_templateObject$E);

var renderList = function renderList() {
  var skipLogicBranches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var eligibleQuestions = arguments[1];
  var eligibleTargets = arguments[2];
  var onClick = arguments[3];
  var readOnly = arguments[4];
  return skipLogicBranches.length === 0 ? null : [React.createElement(BranchList, {
    key: "list",
    eligibleQuestions: eligibleQuestions,
    eligibleTargets: eligibleTargets,
    logicBranches: skipLogicBranches,
    readOnly: readOnly
  }), React.createElement(StyledButton$4, {
    disabled: readOnly,
    onClick: onClick,
    key: "new",
    swatch: "neutralDark"
  }, "+ Add Logic Branch")];
};

var SkipLogicMenu = function SkipLogicMenu(_ref) {
  var pageId = _ref.pageId,
      skipLogicBranches = _ref.skipLogicBranches,
      defaultQuestion = _ref.defaultQuestion,
      eligibleQuestions = _ref.eligibleQuestions,
      eligibleTargets = _ref.eligibleTargets,
      createSkipLogic = _ref.createSkipLogic,
      readOnly = _ref.readOnly;

  var onClick = function onClick() {
    if (defaultQuestion === undefined) throw new Error("Skip Logic menu is missing its default question. Make sure the toggle is disabled or has a default question.");
    createSkipLogic({
      page: pageId,
      defaultQuestion: defaultQuestion
    });
  };

  return React.createElement(DrawerBodySegment, null, React.createElement(ToggleContainer$1, {
    pageId: pageId,
    disabled: eligibleTargets.length === 0 || readOnly,
    skipLogicBranches: skipLogicBranches,
    defaultQuestion: defaultQuestion
  }), renderList(skipLogicBranches, eligibleQuestions, eligibleTargets, onClick, readOnly));
};

function mapStateToProps$B(state, ownProps) {
  var pageId = ownProps.pageId;
  var nodeId = nodeByPageIdSelector(state, pageId).id;
  var skipLogicBranches = skipLogicIdSelector(state, pageId);
  var eligibleQuestions = skipLogicQuestionsSelector(state, nodeId);
  var defaultQuestion = eligibleQuestions.length === 0 ? undefined : eligibleQuestions[0].id;
  var eligibleTargets = skipLogicTargetsSelector(state, nodeId);

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    skipLogicBranches: skipLogicBranches,
    defaultQuestion: defaultQuestion,
    eligibleQuestions: eligibleQuestions,
    eligibleTargets: eligibleTargets,
    readOnly: readOnly
  };
}

var SkipLogicMenuContainer = connect(mapStateToProps$B, {
  createSkipLogic: createSkipLogic
})(SkipLogicMenu);

var _templateObject$F = taggedTemplateLiteral(["\n  margin-left: 1em;\n"], ["\n  margin-left: 1em;\n"]);

var StyledTextInput = styled(TextInputLine)(_templateObject$F);

var PageMenu = function PageMenu(props) {
  var surveyHashRoute = props.surveyHashRoute;
  var redirect = {
    pathname: "/" + surveyHashRoute + "/build"
  };
  if (props.notFound) return React.createElement(Redirect, {
    to: redirect
  });
  var sequence = props.sequence,
      id = props.id,
      setPageContent = props.setPageContent,
      readOnly = props.readOnly,
      content = props.content;

  var inputChange = function inputChange(e) {
    return setPageContent(id, e.currentTarget.value);
  };

  return React.createElement(DrawerMenu, null, React.createElement(DrawerMenuHeader, null, React.createElement("span", null, "Page " + sequence), React.createElement(StyledTextInput, {
    readOnly: readOnly,
    onChange: inputChange,
    value: content
  })), React.createElement(DrawerMenuBody, null, React.createElement(SortMenuContainer, {
    id: id
  }), React.createElement(DisplayLogicMenuContainer, {
    pageId: id
  }), React.createElement(SkipLogicMenuContainer, {
    pageId: id
  })), React.createElement(DrawerMenuFooter, null, React.createElement(Link, {
    to: redirect
  }, React.createElement(Button, null, "Done"))));
};

function mapStateToProps$C(state, ownProps) {
  var pageExists = pageExistsSelector(state, ownProps.id);
  if (!pageExists) return {
    notFound: true
  };

  var _pageByIdSelector = pageByIdSelector(state, ownProps.id),
      content = _pageByIdSelector.content,
      sequence = _pageByIdSelector.sequence;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    content: content,
    readOnly: readOnly,
    sequence: sequence,
    notFound: false
  };
}

var PageMenuContainer = connect(mapStateToProps$C, {
  setPageContent: setPageContent
})(PageMenu);

var _templateObject$G = taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: 1em;\n  font-family: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 0.58em;\n  padding: 0 1.08em;\n  background-color: ", ";\n  height: 3.5em;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: left;\n  box-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n  &:active {\n    box-shadow: none;\n  }\n  > svg {\n    vertical-align: middle;\n    margin-top: -0.2em;\n    font-size: 1em;\n    height: 1em;\n    width: 1em;\n    display: inline-block;\n    fill: ", ";\n    margin-right: 0.8em;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: 1em;\n  font-family: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 0.58em;\n  padding: 0 1.08em;\n  background-color: ", ";\n  height: 3.5em;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: left;\n  box-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n  &:active {\n    box-shadow: none;\n  }\n  > svg {\n    vertical-align: middle;\n    margin-top: -0.2em;\n    font-size: 1em;\n    height: 1em;\n    width: 1em;\n    display: inline-block;\n    fill: ", ";\n    margin-right: 0.8em;\n  }\n"]);

var StyledButton$5 = styled.div(_templateObject$G, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.neutralDark["3"];
}, function (props) {
  return props.theme.neutralLight["4"];
}, function (props) {
  return props.theme.neutralLight["7"];
}, function (props) {
  return props.theme.focusShadowA;
}, function (props) {
  return props.theme.neutralLight["5"];
}, function (props) {
  return props.theme.neutralLight["3"];
}, function (props) {
  return props.theme.neutralDark["3"];
});

var TypeIcon = function TypeIcon(icon) {
  return icon ? React.createElement(icon) : null;
};

var QuestionTypeButton = function (_React$Component) {
  inherits(QuestionTypeButton, _React$Component);

  function QuestionTypeButton(props) {
    classCallCheck(this, QuestionTypeButton);

    var _this = possibleConstructorReturn(this, (QuestionTypeButton.__proto__ || Object.getPrototypeOf(QuestionTypeButton)).call(this, props));

    _this.clickHandler = _this.clickHandler.bind(_this);
    _this.keydownHandler = _this.keydownHandler.bind(_this);
    _this.createQuestion = _this.createQuestion.bind(_this);
    _this.createPageWithNewQuestion = _this.createPageWithNewQuestion.bind(_this);
    return _this;
  }

  createClass(QuestionTypeButton, [{
    key: "clickHandler",
    value: function clickHandler() {
      if (this.props.disabled) return;
      if (this.props.lastPageId === undefined) this.createPageWithNewQuestion();else this.createQuestion();
    }
  }, {
    key: "keydownHandler",
    value: function keydownHandler(e) {
      switch (e.key) {
        case " ":
        case "Enter":
          e.preventDefault();
          this.clickHandler();
          return;

        default:
          return;
      }
    }
  }, {
    key: "createQuestion",
    value: function createQuestion() {
      var _props = this.props,
          createQuestion = _props.createQuestion,
          type = _props.type,
          surveyHashRoute = _props.surveyHashRoute,
          page = _props.lastPageId;
      createQuestion({
        type: type,
        page: page,
        surveyHashRoute: surveyHashRoute
      });
    }
  }, {
    key: "createPageWithNewQuestion",
    value: function createPageWithNewQuestion() {
      var _props2 = this.props,
          createPageWithNewQuestion = _props2.createPageWithNewQuestion,
          surveyHashRoute = _props2.surveyHashRoute,
          type = _props2.type,
          rootGraph = _props2.rootGraph;
      createPageWithNewQuestion({
        graph: rootGraph
      }, type, surveyHashRoute);
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          typeIcon = _props3.typeIcon,
          typeDisplay = _props3.typeDisplay,
          connectDragSource = _props3.connectDragSource;
      return connectDragSource(React.createElement("span", null, React.createElement(StyledButton$5, {
        tabIndex: "0",
        onKeyDown: this.keydownHandler,
        onClick: this.clickHandler
      }, TypeIcon(typeIcon), typeDisplay)));
    }
  }]);
  return QuestionTypeButton;
}(React.Component);

var dragSource$1 = {
  canDrag: function canDrag(props) {
    return !props.disabled;
  },
  beginDrag: function beginDrag(props, monitor, component) {
    var type = props.type;
    var node = findDOMNode(component);

    if (!(node instanceof HTMLElement)) {
      console.warn("Expected drag node to be an HTMLElement. Drop event cancelled.");
      return {};
    }

    var dragRect = node.getBoundingClientRect();
    var dragSize = {
      width: dragRect.width,
      height: dragRect.height
    };
    var dragCoords = {
      x: (dragRect.left + dragRect.right) / 2,
      y: (dragRect.top + dragRect.bottom) / 2
    };
    return {
      dragSize: dragSize,
      dragCoords: dragCoords,
      type: type
    };
  }
};

var collect = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var QuestionTypeButtonDraggable = lib_4$4(DragTypes.QUESTION_TYPE, dragSource$1, collect)(QuestionTypeButton);

function mapStateToProps$D(state) {
  var rootGraph = rootGraphSelector(state);
  var lastPage = lastPageSelector(state, rootGraph);
  var lastPageId = lastPage === undefined ? undefined : lastPage.id;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    rootGraph: rootGraph,
    lastPageId: lastPageId,
    disabled: readOnly
  };
}

var TypeButton = withRouter(connect(mapStateToProps$D, {
  createQuestion: createQuestion$1,
  createPageWithNewQuestion: createPageWithNewQuestion$1
})(QuestionTypeButtonDraggable));

var _templateObject$H = taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\talign-items: stretch;\n\t> * {\n\t\tfont-size: 12px;\n\t\tflex-grow: 1;\n\t\twidth: 13.33em;\n\t\tmax-width: calc(50% - 0.58em);\n\t\tmargin-bottom: 1.1em;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\talign-items: stretch;\n\t> * {\n\t\tfont-size: 12px;\n\t\tflex-grow: 1;\n\t\twidth: 13.33em;\n\t\tmax-width: calc(50% - 0.58em);\n\t\tmargin-bottom: 1.1em;\n\t}\n"]);

var buttonTypes = Object.keys(questionConfigs).filter(function (t) {
  return questionConfigs[t].showButton;
});
var StyledDiv = styled.div(_templateObject$H);

var BuildMenu = function BuildMenu(_ref) {
  var surveyHashRoute = _ref.surveyHashRoute;
  return React.createElement(StyledDiv, null, buttonTypes.map(function (type) {
    var config = questionConfigs[type];

    var _ref2 = config ? [config.icon, config.displayType] : [null, null],
        _ref3 = slicedToArray(_ref2, 2),
        icon = _ref3[0],
        displayType = _ref3[1];

    return React.createElement(TypeButton, {
      key: type,
      type: type,
      typeIcon: icon,
      surveyHashRoute: surveyHashRoute,
      typeDisplay: displayType
    });
  }));
};

var _templateObject$I = taggedTemplateLiteral(["\n\tfont-size: 16px;\n\tposition: absolute;\n\tbottom: 7px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\t> svg {\n\t\ttransition: fill 0s;\n\t\tfill: ", ";\n\t}\n\topacity: ", ";\n\t&:focus {\n\t\topacity: 1;\n\t}\n"], ["\n\tfont-size: 16px;\n\tposition: absolute;\n\tbottom: 7px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\t> svg {\n\t\ttransition: fill 0s;\n\t\tfill: ", ";\n\t}\n\topacity: ", ";\n\t&:focus {\n\t\topacity: 1;\n\t}\n"]);

var AnchorButton$1 = styled(IconButton)(_templateObject$I, function (_ref) {
  var anchor = _ref.anchor,
      theme = _ref.theme;
  return anchor ? theme.primary["2"] : theme.primary["3"];
}, function (_ref2) {
  var anchor = _ref2.anchor;
  return anchor ? 1 : 0;
});

var _templateObject$J = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\ttext-align: center;\n\tflex-shrink: 0;\n\tdisplay: inline-block;\n\theight: 6.25em;\n\tline-height: 6.25em;\n\twidth: 4.58em;\n\tmargin: 0.6em 0;\n\tposition: relative;\n\tborder-radius: 0.42em;\n\tborder: 1px solid ", ";\n\tbox-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.1);\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t}\n\t&:hover ", " {\n\t\topacity: 1;\n\t}\n\t&.highlight {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\ttext-align: center;\n\tflex-shrink: 0;\n\tdisplay: inline-block;\n\theight: 6.25em;\n\tline-height: 6.25em;\n\twidth: 4.58em;\n\tmargin: 0.6em 0;\n\tposition: relative;\n\tborder-radius: 0.42em;\n\tborder: 1px solid ", ";\n\tbox-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.1);\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t}\n\t&:hover ", " {\n\t\topacity: 1;\n\t}\n\t&.highlight {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t}\n"]);

var Card = styled.div(_templateObject$J, function (props) {
  return props.theme.neutralDark["1"];
}, function (props) {
  return props.theme.neutralLight["4"];
}, function (props) {
  return props.theme.primary["2"];
}, function (props) {
  return props.theme.neutralLight["6"];
}, AnchorButton$1, function (props) {
  return props.theme.primary["2"];
}, function (props) {
  return props.theme.neutralLight["6"];
});

var _templateObject$K = taggedTemplateLiteral(["\n\tfont-size: 24px;\n\tposition: absolute;\n\tdisplay: none;\n\ttop: 3px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\t> svg {\n\t\tfill: ", ";\n\t}\n\t&.highlight {\n\t\tdisplay: block;\n\t}\n"], ["\n\tfont-size: 24px;\n\tposition: absolute;\n\tdisplay: none;\n\ttop: 3px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\t> svg {\n\t\tfill: ", ";\n\t}\n\t&.highlight {\n\t\tdisplay: block;\n\t}\n"]),
    _templateObject2$f = taggedTemplateLiteral(["\n\t&:hover {\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"], ["\n\t&:hover {\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"]);

var Anchor$1 = icons.Anchor,
    Link$2 = icons.Link;
var SectionButton = styled(IconButton)(_templateObject$K, function (_ref) {
  var theme = _ref.theme;
  return theme.primary["2"];
});
var PageWrap = styled.div(_templateObject2$f, SectionButton);

var Page$1 = function (_React$Component) {
  inherits(Page, _React$Component);

  function Page(props) {
    classCallCheck(this, Page);

    var _this = possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));

    _this.toggleAnchor = _this.toggleAnchor.bind(_this);
    _this.renderAnchor = _this.renderAnchor.bind(_this);
    _this.renderSectionButton = _this.renderSectionButton.bind(_this);
    _this.endSection = _this.endSection.bind(_this);
    return _this;
  }

  createClass(Page, [{
    key: "toggleAnchor",
    value: function toggleAnchor() {
      var _props = this.props,
          toggleAnchor = _props.toggleAnchor,
          id = _props.id;
      toggleAnchor(id);
    }
  }, {
    key: "endSection",
    value: function endSection() {
      var _props2 = this.props,
          endSection = _props2.endSection,
          id = _props2.id;
      if (endSection === undefined) return;
      endSection(id);
    }
  }, {
    key: "renderAnchor",
    value: function renderAnchor() {
      var _props3 = this.props,
          showAnchor = _props3.showAnchor,
          anchor = _props3.anchor,
          readOnly = _props3.readOnly;
      if (!showAnchor) return null;
      return React.createElement(AnchorButton$1, {
        disabled: readOnly,
        onClick: this.toggleAnchor,
        anchor: anchor
      }, React.createElement(Anchor$1, null));
    }
  }, {
    key: "renderSectionButton",
    value: function renderSectionButton() {
      var _props4 = this.props,
          showSectionButton = _props4.showSectionButton,
          startSection = _props4.startSection,
          id = _props4.id,
          readOnly = _props4.readOnly,
          showHighlight = _props4.showHighlight;
      if (!showSectionButton) return null;
      return React.createElement(SectionButton, {
        className: showHighlight ? "highlight" : "",
        disabled: readOnly,
        onClick: function onClick() {
          return startSection ? startSection(id) : undefined;
        }
      }, React.createElement(Link$2, null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props5 = this.props,
          sequence = _props5.sequence,
          connectDropTarget = _props5.connectDropTarget,
          connectDragSource = _props5.connectDragSource,
          onMouseOver = _props5.onMouseOver,
          onMouseOut = _props5.onMouseOut,
          showHighlight = _props5.showHighlight;
      return connectDragSource(React.createElement("span", null, connectDropTarget(React.createElement("span", null, React.createElement(PageWrap, null, React.createElement(Card, {
        onClick: function onClick(e) {
          return _this2.endSection();
        },
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        className: showHighlight ? "highlight" : "",
        "data-testid": "ORGANIZE_PAGE"
      }, this.renderSectionButton(), "P" + sequence, this.renderAnchor()))))));
    }
  }]);
  return Page;
}(React.Component);

Page$1.defaultProps = {
  showAnchor: false,
  showSectionButton: false,
  showHighlight: false
};

var questionDrop = function questionDrop(props, monitor, component) {
  var _monitor$getItem = monitor.getItem(),
      id = _monitor$getItem.id;

  var pageId = props.id,
      moveQuestion = props.moveQuestion;
  moveQuestion(id, pageId);
};

var dropTarget$1 = {
  drop: function drop(props, monitor, component) {
    switch (monitor.getItemType()) {
      case DragTypes.QUESTION:
        return questionDrop(props, monitor, component);

      default:
        throw new Error("Unhandled drop type " + monitor.getItemType());
    }
  }
};

var collect$1 = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget()
  };
};

var types$2 = [DragTypes.QUESTION];
var PageDroppable = lib_5$2(types$2, dropTarget$1, collect$1)(Page$1);
var dragSource$2 = {
  canDrag: function canDrag(props) {
    return !props.readOnly;
  },
  beginDrag: function beginDrag(props) {
    return {
      id: props.id
    };
  }
};

var collect$2 = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var PageDraggable = lib_4$4(DragTypes.PAGE, dragSource$2, collect$2)(PageDroppable);

function mapStateToProps$E(state, ownProps) {
  var _pageByIdSelector = pageByIdSelector(state, ownProps.id),
      sequence = _pageByIdSelector.sequence,
      anchor = _pageByIdSelector.anchor;

  var _uiSelector = uiSelector(state),
      readOnly = _uiSelector.readOnly;

  return {
    sequence: sequence,
    anchor: anchor,
    readOnly: readOnly
  };
}

var PageContainer = connect(mapStateToProps$E, {
  toggleAnchor: togglePageAnchor,
  moveQuestion: moveQuestion
})( // $FlowFixMe (I have no idea)
PageDraggable);

var _templateObject$L = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\theight: 6.25em;\n\twidth: 5px;\n\tpadding: 0 0.3em;\n\tline {\n\t\topacity: ", ";\n\t\tstroke: ", ";\n\t\tstroke-width: 8;\n\t\tstroke-linecap: round;\n\t\tstroke-dasharray: 14;\n\t}\n"], ["\n\tfont-size: 12px;\n\theight: 6.25em;\n\twidth: 5px;\n\tpadding: 0 0.3em;\n\tline {\n\t\topacity: ", ";\n\t\tstroke: ", ";\n\t\tstroke-width: 8;\n\t\tstroke-linecap: round;\n\t\tstroke-dasharray: 14;\n\t}\n"]);

var Line$1 = styled.svg(_templateObject$L, function (props) {
  return props.hovered ? 1 : 0;
}, function (props) {
  return props.theme.primary["2"];
});

var Dropzone = function Dropzone(_ref) {
  var className = _ref.className,
      _ref$hovered = _ref.hovered,
      hovered = _ref$hovered === undefined ? false : _ref$hovered,
      connectDropTarget = _ref.connectDropTarget;
  return connectDropTarget(React.createElement("span", null, React.createElement(Line$1, {
    height: "100%",
    width: "100%",
    viewBox: "0 0 5 300",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    hovered: hovered
  }, React.createElement("line", {
    x1: "3",
    x2: "3",
    y1: "0",
    y2: "300"
  }))));
};

var types$3 = [DragTypes.PAGE];
var spec = {
  drop: function drop(props, monitor, component) {
    var movePage = props.movePage,
        graph = props.graph,
        after = props.after;

    var _monitor$getItem = monitor.getItem(),
        id = _monitor$getItem.id;

    movePage(id, graph, after);
  }
};

var collect$3 = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    hovered: monitor.isOver()
  };
};

var DropzoneDroppable = lib_5$2(types$3, spec, collect$3)(Dropzone);

var _templateObject$M = taggedTemplateLiteral([""], [""]),
    _templateObject2$g = taggedTemplateLiteral(["\n\t", " {\n\t\tdisplay: inline-block;\n\t}\n\t", " {\n\t\tdisplay: none;\n\t}\n\t&:hover {\n\t\t", " {\n\t\t\tdisplay: none;\n\t\t}\n\t\t", " {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n"], ["\n\t", " {\n\t\tdisplay: inline-block;\n\t}\n\t", " {\n\t\tdisplay: none;\n\t}\n\t&:hover {\n\t\t", " {\n\t\t\tdisplay: none;\n\t\t}\n\t\t", " {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n"]),
    _templateObject3$8 = taggedTemplateLiteral(["\n\twidth: 100%;\n\ttext-align: center;\n"], ["\n\twidth: 100%;\n\ttext-align: center;\n"]);

var Link$3 = icons.Link,
    LinkBreak = icons.LinkBreak;
var StyledLink = styled(Link$3)(_templateObject$M);
var StyledLinkBreak = styled(LinkBreak)(_templateObject$M);
var StyledButton$6 = styled(IconButton)(_templateObject2$g, StyledLink, StyledLinkBreak, StyledLink, StyledLinkBreak);
var Wrapper$b = styled.div(_templateObject3$8);

var CreateGroupButton = function (_React$Component) {
  inherits(CreateGroupButton, _React$Component);

  function CreateGroupButton(props) {
    classCallCheck(this, CreateGroupButton);

    var _this = possibleConstructorReturn(this, (CreateGroupButton.__proto__ || Object.getPrototypeOf(CreateGroupButton)).call(this, props));

    _this.createGroup = _this.createGroup.bind(_this);
    return _this;
  }

  createClass(CreateGroupButton, [{
    key: "createGroup",
    value: function createGroup() {
      var _props = this.props,
          sections = _props.sections,
          createGroup = _props.createGroup;
      createGroup.apply(undefined, toConsumableArray(sections));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Wrapper$b, null, React.createElement(StyledButton$6, {
        onClick: this.createGroup
      }, React.createElement(StyledLink, null), React.createElement(StyledLinkBreak, null)));
    }
  }]);
  return CreateGroupButton;
}(React.Component);

var _templateObject$N = taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 0.1em;\n\tright: 0.75em;\n\tpadding: 0 0.2em;\n\ttransform: translateY(-50%);\n\tbackground: ", ";\n\tz-index: 1;\n\tbutton {\n\t\tmargin: 0 0.2em;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0.1em;\n\tright: 0.75em;\n\tpadding: 0 0.2em;\n\ttransform: translateY(-50%);\n\tbackground: ", ";\n\tz-index: 1;\n\tbutton {\n\t\tmargin: 0 0.2em;\n\t}\n"]);

var Wrapper$c = styled.div(_templateObject$N, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralLight["7"];
});

var _templateObject$O = taggedTemplateLiteral(["\n\twidth: 100%;\n\t> div {\n\t\tfont-size: 12px;\n\t\tposition: relative;\n\t\tborder-radius: 0.58em;\n\t\tpadding: 1.2em 0.8em;\n\t\twidth: 100%;\n\t\tborder: 1px solid ", ";\n\t\tpadding: 1.2em 0.8em;\n\t\tmargin: 0.5em -0.75em 1em;\n\t\tbox-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.1);\n\t\t", " {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&:hover ", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"], ["\n\twidth: 100%;\n\t> div {\n\t\tfont-size: 12px;\n\t\tposition: relative;\n\t\tborder-radius: 0.58em;\n\t\tpadding: 1.2em 0.8em;\n\t\twidth: 100%;\n\t\tborder: 1px solid ", ";\n\t\tpadding: 1.2em 0.8em;\n\t\tmargin: 0.5em -0.75em 1em;\n\t\tbox-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.1);\n\t\t", " {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&:hover ", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"]);

var Wrapper$d = styled.div(_templateObject$O, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralLight["4"];
}, Wrapper$c, Wrapper$c);

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.setOpen = _this.setOpen.bind(_this);
    _this.state = {
      open: false
    };
    return _this;
  }

  createClass(Popover, [{
    key: "handleClick",
    value: function handleClick() {
      if (!this.state.open) {
        document.addEventListener("click", this.handleOutsideClick, false);
      } else {
        document.removeEventListener("click", this.handleOutsideClick, false);
      }

      this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      // ignore clicks on the component itself
      // $FlowFixMe (this thinks target may potentially not be a Node, somehow)
      if (this.node && this.node.contains(e.target)) {
        e.stopPropagation();
        return;
      }

      this.handleClick();
    }
  }, {
    key: "setOpen",
    value: function setOpen() {
      var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.setState({
        open: open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var open = this.state.open;
      var _props = this.props,
          children = _props.children,
          className = _props.className;
      return React.createElement("span", {
        className: className,
        ref: function ref(node) {
          _this2.node = node;
        }
      }, children(open, this.handleClick));
    }
  }]);
  return Popover;
}(React.Component);

var _templateObject$P = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tfont-size: 14px;\n\tborder-radius: 0.5em;\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\tborder-width: 1px;\n\tborder-style: solid;\n\tpadding: 1em;\n\tbox-shadow: ", ";\n\ttransition: border-color 0.125s, background-color 0.125s, box-shadow 0.125s,\n\t\ttransform 0.4s cubic-bezier(0.23, 1, 0.32, 1);\n\th1 {\n\t\tfont-size: inherit;\n\t\tfont-weight: 600;\n\t\tcolor: ", ";\n\t\tmargin-top: 0;\n\t}\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t\t&:not(.active) {\n\t\t\ttransition: border-color 0.125s, background-color 0.125s;\n\t\t}\n\t}\n\t&.active {\n\t\tbox-shadow: 0px 0px 0px 2px ", ";\n\t\tborder-color: transparent;\n\t}\n"], ["\n\tfont-family: ", ";\n\tfont-size: 14px;\n\tborder-radius: 0.5em;\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\tborder-width: 1px;\n\tborder-style: solid;\n\tpadding: 1em;\n\tbox-shadow: ", ";\n\ttransition: border-color 0.125s, background-color 0.125s, box-shadow 0.125s,\n\t\ttransform 0.4s cubic-bezier(0.23, 1, 0.32, 1);\n\th1 {\n\t\tfont-size: inherit;\n\t\tfont-weight: 600;\n\t\tcolor: ", ";\n\t\tmargin-top: 0;\n\t}\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t\t&:not(.active) {\n\t\t\ttransition: border-color 0.125s, background-color 0.125s;\n\t\t}\n\t}\n\t&.active {\n\t\tbox-shadow: 0px 0px 0px 2px ", ";\n\t\tborder-color: transparent;\n\t}\n"]);

var Card$1 = styled.div(_templateObject$P, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.neutralLight["7"];
}, function (props) {
  return props.theme.neutralLight["4"];
}, function (props) {
  return props.theme.panelShadowA;
}, function (props) {
  return props.theme.neutralDark["4"];
}, function (props) {
  return props.theme.focusShadowA;
}, function (props) {
  return props.theme.primary["2"];
});

var _templateObject$Q = taggedTemplateLiteral(["\n\tposition: absolute;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tbox-shadow: none;\n\t> * {\n\t\tmargin-right: 1em;\n\t}\n\t> ", " {\n\t\tmargin-right: 0;\n\t}\n"], ["\n\tposition: absolute;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tbox-shadow: none;\n\t> * {\n\t\tmargin-right: 1em;\n\t}\n\t> ", " {\n\t\tmargin-right: 0;\n\t}\n"]),
    _templateObject2$h = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tfont-weight: 600;\n\twhite-space: nowrap;\n"], ["\n\tfont-size: 12px;\n\tfont-weight: 600;\n\twhite-space: nowrap;\n"]),
    _templateObject3$9 = taggedTemplateLiteral(["\n\twidth: 150px;\n"], ["\n\twidth: 150px;\n"]);

var StyledCard = styled(Card$1)(_templateObject$Q, Button);
var Text$1 = styled.span(_templateObject2$h);
var StyledSelect$8 = styled(Select)(_templateObject3$9);

var MoveMenu = function (_React$Component) {
  inherits(MoveMenu, _React$Component);

  function MoveMenu(props) {
    classCallCheck(this, MoveMenu);

    var _this = possibleConstructorReturn(this, (MoveMenu.__proto__ || Object.getPrototypeOf(MoveMenu)).call(this, props));

    _this.state = {
      selected: null
    };
    return _this;
  }

  createClass(MoveMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          options = _props.options,
          onSubmit = _props.onSubmit,
          close = _props.close;
      var value = this.state.selected ? this.state.selected.value : null;
      return React.createElement(StyledCard, null, React.createElement(Text$1, null, title), React.createElement(StyledSelect$8, {
        options: options,
        value: options.find(function (o) {
          return o.value === value;
        }),
        onChange: function onChange(option) {
          return _this2.setState({
            selected: option
          });
        },
        closeOnSelect: false
      }), React.createElement(Button, {
        onClick: function onClick() {
          if (_this2.state.selected) {
            onSubmit(_this2.state.selected);
            close();
          }
        },
        disabled: value === null
      }, "Go"));
    }
  }]);
  return MoveMenu;
}(React.Component);

MoveMenu.defaultProps = {
  title: "Move after"
};
var MergeIcon = icons.Merge;

var Merge = function (_React$Component) {
  inherits(Merge, _React$Component);

  function Merge(props) {
    classCallCheck(this, Merge);

    var _this = possibleConstructorReturn(this, (Merge.__proto__ || Object.getPrototypeOf(Merge)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.renderPopover = _this.renderPopover.bind(_this);
    return _this;
  }

  createClass(Merge, [{
    key: "renderPopover",
    value: function renderPopover(open, toggle) {
      var options = this.props.options;
      var button = React.createElement(IconButton, {
        onClick: toggle,
        title: "Merge Section"
      }, React.createElement(MergeIcon, null));

      if (open) {
        return React.createElement("span", null, button, React.createElement(MoveMenu, {
          title: "Merge into",
          close: toggle,
          options: options,
          onSubmit: this.handleSubmit
        }));
      }

      return button;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(_ref) {
      var targetId = _ref.id,
          start = _ref.start;
      var _props = this.props,
          id = _props.id,
          mergeSections = _props.mergeSections;
      mergeSections(id, targetId, start);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Popover, null, this.renderPopover);
    }
  }]);
  return Merge;
}(React.Component);

var MoveIcon = icons.Move;

var Move$1 = function (_React$Component) {
  inherits(Move, _React$Component);

  function Move(props) {
    classCallCheck(this, Move);

    var _this = possibleConstructorReturn(this, (Move.__proto__ || Object.getPrototypeOf(Move)).call(this, props));

    _this.renderPopover = _this.renderPopover.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  createClass(Move, [{
    key: "renderPopover",
    value: function renderPopover(open, toggle) {
      var _this2 = this;

      var options = this.props.options;
      var button = React.createElement(IconButton, {
        onClick: toggle,
        title: "Move Section"
      }, React.createElement(MoveIcon, null));

      if (open) {
        return React.createElement("span", null, button, React.createElement(MoveMenu, {
          close: toggle,
          options: options,
          onSubmit: function onSubmit(o) {
            _this2.handleSubmit(o);

            toggle();
          }
        }));
      }

      return button;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(option) {
      var _props = this.props,
          rootGraph = _props.rootGraph,
          onSubmit = _props.onSubmit;
      var node = option.node;
      onSubmit(rootGraph, node);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Popover, null, this.renderPopover);
    }
  }]);
  return Move;
}(React.Component);

var _templateObject$R = taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tfont-family: ", ";\n\tborder: 0 none;\n\tpadding: 3px 12px;\n\twidth: 100%;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\tsvg {\n\t\tfill: ", ";\n\t\twidth: 18px;\n\t\theight: auto;\n\t\tdisplay: inline-block;\n\t\tmargin-right: 0.5em;\n\t}\n"], ["\n\tfont-size: 12px;\n\tfont-family: ", ";\n\tborder: 0 none;\n\tpadding: 3px 12px;\n\twidth: 100%;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\tsvg {\n\t\tfill: ", ";\n\t\twidth: 18px;\n\t\theight: auto;\n\t\tdisplay: inline-block;\n\t\tmargin-right: 0.5em;\n\t}\n"]),
    _templateObject2$i = taggedTemplateLiteral(["\n\tposition: absolute;\n\tbox-shadow: none;\n\tpadding: 5px 0;\n\t> ", " {\n\t\tmargin: 0;\n\t}\n"], ["\n\tposition: absolute;\n\tbox-shadow: none;\n\tpadding: 5px 0;\n\t> ", " {\n\t\tmargin: 0;\n\t}\n"]);

var SortRandomize = icons.SortRandomize,
    SortSequential = icons.SortSequential,
    SortReverse = icons.SortReverse;
var sortIconMap = {
  randomize: SortRandomize,
  reverse: SortReverse,
  default: SortSequential
};
var sortTitleMap = {
  randomize: "Randomize",
  reverse: "Reverse",
  default: "Sequential"
};

var SortButton = function SortButton(props) {
  var onClick = props.onClick,
      setSortType = props.setSortType,
      sortType = props.sortType,
      children = props.children,
      className = props.className;

  var handler = function handler(e) {
    setSortType(sortType);
    onClick(e);
  };

  return React.createElement("button", {
    className: className,
    onClick: handler
  }, children);
};

var StyledSortButton = styled(SortButton)(_templateObject$R, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.neutralLight["7"];
}, function (props) {
  return props.theme.neutralLight["6"];
}, function (props) {
  return props.theme.primary["2"];
});
var StyledCard$1 = styled(Card$1)(_templateObject2$i, StyledSortButton);

var SortMenu$1 = function SortMenu(_ref) {
  var close = _ref.close,
      setSortType = _ref.setSortType;
  return React.createElement(StyledCard$1, null, React.createElement(StyledSortButton, {
    sortType: "default",
    onClick: close,
    setSortType: setSortType
  }, React.createElement(SortSequential, null), React.createElement("span", null, "Sequential")), React.createElement(StyledSortButton, {
    sortType: "randomize",
    onClick: close,
    setSortType: setSortType
  }, React.createElement(SortRandomize, null), React.createElement("span", null, "Randomize")), React.createElement(StyledSortButton, {
    sortType: "reverse",
    onClick: close,
    setSortType: setSortType
  }, React.createElement(SortReverse, null), React.createElement("span", null, "Reverse")));
};

var Sort = function (_React$Component) {
  inherits(Sort, _React$Component);

  function Sort(props) {
    classCallCheck(this, Sort);

    var _this = possibleConstructorReturn(this, (Sort.__proto__ || Object.getPrototypeOf(Sort)).call(this, props));

    _this.renderPopover = _this.renderPopover.bind(_this);
    return _this;
  }

  createClass(Sort, [{
    key: "renderPopover",
    value: function renderPopover(open, handleClick) {
      var _props = this.props,
          sortType = _props.sortType,
          setSortType = _props.setSortType;
      var Icon = sortIconMap[sortType];
      var button = React.createElement(IconButton, {
        title: "Sort Type: " + sortTitleMap[sortType],
        onClick: handleClick
      }, React.createElement(Icon, null));

      if (open) {
        return React.createElement("span", null, button, React.createElement(SortMenu$1, {
          close: handleClick,
          setSortType: setSortType
        }));
      }

      return button;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Popover, null, this.renderPopover);
    }
  }]);
  return Sort;
}(React.Component);

var Trash = icons.Delete;

var Delete$3 = function Delete(_ref) {
  var deleteSection = _ref.deleteSection,
      id = _ref.id;
  return React.createElement(IconButton, {
    title: "Delete Section",
    onClick: function onClick() {
      return deleteSection(id);
    }
  }, React.createElement(Trash, null));
};

var Controls$1 = function Controls(_ref2) {
  var id = _ref2.id,
      sortType = _ref2.sortType,
      deleteSection = _ref2.deleteSection,
      setSectionSortType = _ref2.setSectionSortType,
      rootGraph = _ref2.rootGraph,
      mergeOptions = _ref2.mergeOptions,
      mergeSections = _ref2.mergeSections,
      moveOptions = _ref2.moveOptions,
      moveSection = _ref2.moveSection;

  var setSortType = function setSortType(type) {
    return setSectionSortType(id, type);
  };

  var onMove = function onMove(graph, after) {
    return moveSection(id, graph, after);
  };

  return React.createElement(Wrapper$c, null, React.createElement(Merge, {
    id: id,
    options: mergeOptions,
    mergeSections: mergeSections
  }), React.createElement(Sort, {
    setSortType: setSortType,
    sortType: sortType
  }), React.createElement(Move$1, {
    options: moveOptions,
    rootGraph: rootGraph,
    onSubmit: onMove
  }), React.createElement(Delete$3, {
    id: id,
    deleteSection: deleteSection
  }));
};
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */


function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq_1(object[key], value) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
});
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */


function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray;
/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject_1(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
}

var _initCloneObject = initCloneObject;
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;
/** Used for built-in method references. */

var objectProto$d = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$e = objectProto$d.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$e.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject;
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn;
/** Used for built-in method references. */

var objectProto$e = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$f = objectProto$e.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }

  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$f.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */

function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);

    return;
  }

  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);
    newValue = srcValue;

    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;

      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      } else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }

  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }

  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }

  _baseFor(source, function (srcValue, key) {
    if (isObject_1(srcValue)) {
      stack || (stack = new _Stack());

      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(_safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }

      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */

function createAssigner(assigner) {
  return _baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }

    object = Object(object);

    while (++index < length) {
      var source = sources[index];

      if (source) {
        assigner(object, source, index, customizer);
      }
    }

    return object;
  });
}

var _createAssigner = createAssigner;
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */

var mergeWith = _createAssigner(function (object, source, srcIndex, customizer) {
  _baseMerge(object, source, srcIndex, customizer);
});

var mergeWith_1 = mergeWith;

var mergeArrays = function mergeArrays(a, b) {
  if (Array.isArray(a)) {
    return a.concat(b);
  }
};

var getBreakingRelationsSection = function getBreakingRelationsSection(section, graph, after, session) {
  var childGraph = section.node.childGraph;
  if (!childGraph) throw new Error();
  var pages = childGraph.nodes.toModelArray().reduce(function (list, node) {
    return node.page ? [].concat(toConsumableArray(list), [node.page]) : list;
  }, []);
  var pageRelationMap = pages.map(function (p) {
    return getBreakingRelationsPage(p, graph, after, session);
  });
  return pageRelationMap.reduce(function (acc, val) {
    var dup = _extends$c({}, acc);

    return mergeWith_1(dup, val, mergeArrays);
  }, {});
};

var createSection$1 = function createSection(payload) {
  return {
    type: sectionTypes.SECTION_CREATE,
    payload: payload
  };
};

var deleteSection = function deleteSection(payload) {
  return {
    type: sectionTypes.SECTION_DELETE,
    payload: payload
  };
};

var setSectionContent = function setSectionContent(id, content) {
  return {
    type: sectionTypes.SECTION_SET_CONTENT,
    payload: {
      id: id,
      content: content
    }
  };
};

var setSectionSortType = function setSectionSortType(id, sortType) {
  return {
    type: sectionTypes.SECTION_SET_SORT_TYPE,
    payload: {
      id: id,
      sortType: sortType
    }
  };
};

var mergeSections$1 = function mergeSections(id, target, start) {
  return {
    type: sectionTypes.SECTION_MERGE,
    payload: {
      id: id,
      target: target,
      start: start
    }
  };
};

var moveSectionUnsafe = function moveSectionUnsafe(id, graph, after, breakingRelations) {
  return {
    type: sectionTypes.SECTION_MOVE_UNSAFE,
    payload: {
      id: id,
      graph: graph,
      after: after,
      breakingRelations: breakingRelations
    }
  };
};

var moveSection = function moveSection(id, graph, after) {
  return function (dispatch, getState) {
    var session = orm.session(selectOrm(getState()));
    var section = session.Section.withId(id);
    var breakingRelations = getBreakingRelationsSection(section, graph, after, session);

    var dispatchMove = function dispatchMove() {
      return dispatch(moveSectionUnsafe(id, graph, after, breakingRelations));
    };

    if (Object.keys(breakingRelations).length) {
      return dispatch(warnBreakingRelations(breakingRelations, dispatchMove));
    }

    return dispatchMove();
  };
}; // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$5 = function makeMapStateToProps() {
  var sectionSelector$$1 = makeSectionSelector();
  var rootGraphSelector$$1 = makeRootGraphSelector();
  var mergeSelector = makeSectionMergeOptionsSelector();
  var moveSelector = makeGraphContentOptionSelector();

  var mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id;

    var _sectionSelector = sectionSelector$$1(state, id),
        sortType = _sectionSelector.sortType;

    var rootGraph = rootGraphSelector$$1(state);
    var mergeOptions = mergeSelector(state, id);
    var moveOptions = moveSelector(state, rootGraph);
    return {
      sortType: sortType,
      rootGraph: rootGraph,
      mergeOptions: mergeOptions,
      moveOptions: moveOptions
    };
  };

  return mapStateToProps;
};

var dispatchProps$a = {
  deleteSection: deleteSection,
  setSectionSortType: setSectionSortType,
  mergeSections: mergeSections$1,
  moveSection: moveSection
};
var ControlsContainer$1 = connect(makeMapStateToProps$5, dispatchProps$a)(Controls$1);

var _templateObject$S = taggedTemplateLiteral(["\n\tposition: absolute;\n\ttransform: translateY(-50%);\n\ttop: 0;\n\t> input {\n\t\tfont-size: 14px;\n\t\tfont-family: ", ";\n\t\tcolor: ", ";\n\t\tfont-weight: 600;\n\t\tborder: 0 none;\n\t\tborder-radius: 5px;\n\t\tmargin: 0;\n\t\tpadding: 0 1.86em 0 0.5em;\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\t> svg {\n\t\tfont-size: 16px;\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tfill: ", ";\n\t\tvertical-align: sub;\n\t\ttransform: translateX(-135%);\n\t}\n"], ["\n\tposition: absolute;\n\ttransform: translateY(-50%);\n\ttop: 0;\n\t> input {\n\t\tfont-size: 14px;\n\t\tfont-family: ", ";\n\t\tcolor: ", ";\n\t\tfont-weight: 600;\n\t\tborder: 0 none;\n\t\tborder-radius: 5px;\n\t\tmargin: 0;\n\t\tpadding: 0 1.86em 0 0.5em;\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\t> svg {\n\t\tfont-size: 16px;\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tfill: ", ";\n\t\tvertical-align: sub;\n\t\ttransform: translateX(-135%);\n\t}\n"]);

var Edit = icons.Edit;
var ContentWrapper = styled.div(_templateObject$S, function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.neutralDark["4"];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.focusShadowA;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.neutralLight["4"];
});

var Content$1 = function Content(props) {
  return React.createElement(ContentWrapper, null, React.createElement("input", _extends$c({}, props, {
    type: "text"
  })), React.createElement(Edit, null));
};

var _templateObject$T = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n"]);

var renderCreateGroup = function renderCreateGroup(startSection, endSection, createGroup) {
  return endSection === undefined ? null : React.createElement(CreateGroupButton, {
    key: endSection,
    sections: [startSection, endSection],
    createGroup: createGroup
  });
};

var PageWrapper = styled.div(_templateObject$T);

var Section$1 = function (_React$Component) {
  inherits(Section, _React$Component);

  function Section(props) {
    classCallCheck(this, Section);

    var _this = possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    _this.renderPage = _this.renderPage.bind(_this);
    return _this;
  }

  createClass(Section, [{
    key: "onChange",
    value: function onChange(e) {
      var _props = this.props,
          id = _props.id,
          setSectionContent = _props.setSectionContent;
      var content = e.target.value;
      setSectionContent(id, content);
    }
  }, {
    key: "renderPage",
    value: function renderPage(_ref) {
      var id = _ref.id,
          node = _ref.node;
      var _props2 = this.props,
          movePage = _props2.movePage,
          graph = _props2.graph;
      return [React.createElement(PageContainer, {
        showAnchor: true,
        key: id,
        id: id
      }),
      /* $FlowFixMe (something is wrong with the injection of props here) */
      React.createElement(DropzoneDroppable, {
        movePage: movePage,
        key: id + "-drop",
        graph: graph,
        after: node
      })];
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          id = _props3.id,
          content = _props3.content,
          pages = _props3.pages,
          adjacentSection = _props3.adjacentSection,
          createGroup = _props3.createGroup,
          graph = _props3.graph,
          movePage = _props3.movePage,
          readOnly = _props3.readOnly,
          connectDragSource = _props3.connectDragSource;
      var controls = readOnly ? null : React.createElement(ControlsContainer$1, {
        id: id
      });
      var createGroupButton = readOnly ? null : renderCreateGroup(id, adjacentSection, createGroup);
      return [React.createElement(Wrapper$d, {
        key: id
      }, connectDragSource(React.createElement("div", null, React.createElement(Content$1, {
        readOnly: readOnly,
        value: content,
        onChange: this.onChange
      }), controls, React.createElement(PageWrapper, null, React.createElement(DropzoneDroppable, {
        movePage: movePage,
        graph: graph
      }), pages.map(this.renderPage))))), createGroupButton];
    }
  }]);
  return Section;
}(React.Component);

var dragSource$3 = {
  canDrag: function canDrag(props) {
    return !props.readOnly;
  },
  beginDrag: function beginDrag(_ref) {
    var id = _ref.id;
    return {
      id: id
    };
  }
};

var collect$4 = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var SectionDraggable = lib_4$4(DragTypes.SECTION, dragSource$3, collect$4)(Section$1);

var mergeArrays$1 = function mergeArrays(a, b) {
  if (Array.isArray(a)) {
    return a.concat(b);
  }
};

var getBreakingRelationsGroup = function getBreakingRelationsGroup(group, graph, after, session) {
  var childGraph = group.node.childGraph;
  if (!childGraph) throw new Error();
  var sections = childGraph.nodes.toModelArray().reduce(function (list, node) {
    return node.section ? [].concat(toConsumableArray(list), [node.section]) : list;
  }, []);
  var sectionRelationMap = sections.map(function (s) {
    return getBreakingRelationsSection(s, graph, after, session);
  });
  return sectionRelationMap.reduce(function (acc, val) {
    var dup = _extends$c({}, acc);

    return mergeWith_1(dup, val, mergeArrays$1);
  }, {});
};

var createGroup$1 = function createGroup() {
  for (var _len = arguments.length, sections = Array(_len), _key = 0; _key < _len; _key++) {
    sections[_key] = arguments[_key];
  }

  return {
    type: groupTypes.GROUP_CREATE,
    payload: {
      sections: sections
    }
  };
};

var deleteGroup = function deleteGroup(id) {
  return {
    type: groupTypes.GROUP_DELETE,
    payload: id
  };
};

var setGroupContent = function setGroupContent(id, content) {
  return {
    type: groupTypes.GROUP_SET_CONTENT,
    payload: {
      id: id,
      content: content
    }
  };
};

var setGroupSortType = function setGroupSortType(id, sortType) {
  return {
    type: groupTypes.GROUP_SET_SORT_TYPE,
    payload: {
      id: id,
      sortType: sortType
    }
  };
};

var moveGroupUnsafe = function moveGroupUnsafe(id, graph, after, breakingRelations) {
  return {
    type: groupTypes.GROUP_MOVE_UNSAFE,
    payload: {
      id: id,
      graph: graph,
      after: after,
      breakingRelations: breakingRelations
    }
  };
};

var moveGroup = function moveGroup(id, graph, after) {
  return function (dispatch, getState) {
    var session = orm.session(selectOrm(getState()));
    var group = session.Group.withId(id);
    var breakingRelations = getBreakingRelationsGroup(group, graph, after, session);

    var dispatchMove = function dispatchMove() {
      return dispatch(moveGroupUnsafe(id, graph, after, breakingRelations));
    };

    if (Object.keys(breakingRelations).length) {
      return dispatch(warnBreakingRelations(breakingRelations, dispatchMove));
    }

    return dispatchMove();
  };
};

var makeMapStateToProps$6 = function makeMapStateToProps() {
  var sectionSelector$$1 = makeSectionSelector();
  var graphSelector = makeChildGraphSelector();
  var pagesSelector = makeSectionPagesSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var id = ownProps.id;

    var _sectionSelector = sectionSelector$$1(state, id),
        content = _sectionSelector.content,
        node = _sectionSelector.node;

    var _graphSelector = graphSelector(state, node),
        graphId = _graphSelector.id;

    var pages = pagesSelector(state, graphId);

    var _uiSelector = uiSelector(state),
        readOnly = _uiSelector.readOnly;

    return {
      content: content,
      pages: pages,
      graph: graphId,
      readOnly: readOnly
    };
  };

  return mapStateToProps;
};

var dispatchProps$b = {
  setSectionContent: setSectionContent,
  createGroup: createGroup$1,
  movePage: movePage
}; // $FlowFixMe (issue with react-redux + react-dnd)

var SectionContainer = connect(makeMapStateToProps$6, dispatchProps$b)(SectionDraggable);

var _templateObject$U = taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tbackground-color: ", ";\n\tborder-radius: 1em;\n\tpadding: 0.36em 0.71em;\n\tborder: 0 none;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n"], ["\n\tfont-family: ", ";\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tbackground-color: ", ";\n\tborder-radius: 1em;\n\tpadding: 0.36em 0.71em;\n\tborder: 0 none;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n"]);

var Content$2 = function Content(props) {
  var color = props.color,
      rest = objectWithoutProperties(props, ["color"]);
  return React.createElement("div", rest);
}; // This component is sometimes used with an <input> tag,
// so it has some extra styles to ensure it looks consistent there.


var GroupLabel = styled(Content$2)(_templateObject$U, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.color;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.focusShadowA;
});

var _templateObject$V = taggedTemplateLiteral(["\n\tpadding: 2px 15px;\n"], ["\n\tpadding: 2px 15px;\n"]),
    _templateObject2$j = taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 0;\n\ttransform: translateY(-50%);\n\tsvg {\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tposition: absolute;\n\t\tright: 0.5em;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tfill: rgba(255, 255, 255, 0.5);\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\ttransform: translateY(-50%);\n\tsvg {\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tposition: absolute;\n\t\tright: 0.5em;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tfill: rgba(255, 255, 255, 0.5);\n\t}\n"]);

var Edit$1 = icons.Edit;

var TextInput$1 = function TextInput$$1(props) {
  var color = props.color,
      rest = objectWithoutProperties(props, ["color"]);
  return React.createElement("input", _extends$c({
    type: "text"
  }, rest));
};

var ContentInput = styled(GroupLabel)(_templateObject$V).withComponent(TextInput$1);
var Wrapper$e = styled.div(_templateObject2$j);

var Content$3 = function Content(props) {
  return React.createElement(Wrapper$e, null, React.createElement(ContentInput, props), React.createElement(Edit$1, null));
};

var Trash$1 = icons.Delete;

var Delete$4 = function Delete(_ref) {
  var id = _ref.id,
      deleteGroup = _ref.deleteGroup;
  return React.createElement(IconButton, {
    title: "Delete Group",
    onClick: function onClick() {
      return deleteGroup(id);
    }
  }, React.createElement(Trash$1, null));
};

var Controls$2 = function Controls(_ref2) {
  var id = _ref2.id,
      sortType = _ref2.sortType,
      rootGraph = _ref2.rootGraph,
      deleteGroup = _ref2.deleteGroup,
      setGroupSortType = _ref2.setGroupSortType,
      moveGroup = _ref2.moveGroup,
      moveOptions = _ref2.moveOptions;

  var setSortType = function setSortType(type) {
    return setGroupSortType(id, type);
  };

  var onMove = function onMove(graph, after) {
    return moveGroup(id, graph, after);
  };

  return React.createElement(Wrapper$c, null, React.createElement(Sort, {
    sortType: sortType,
    setSortType: setSortType
  }), React.createElement(Move$1, {
    rootGraph: rootGraph,
    options: moveOptions,
    onSubmit: onMove
  }), React.createElement(Delete$4, {
    id: id,
    deleteGroup: deleteGroup
  }));
};

var _templateObject$W = taggedTemplateLiteral(["\n\tfill: none;\n\tborder-radius: inherit;\n\tstroke-width: 3;\n\tstroke-linecap: round;\n\tstroke-dasharray: 0.25 8;\n"], ["\n\tfill: none;\n\tborder-radius: inherit;\n\tstroke-width: 3;\n\tstroke-linecap: round;\n\tstroke-dasharray: 0.25 8;\n"]),
    _templateObject2$k = taggedTemplateLiteral(["\n\tposition: relative;\n\t> svg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\toverflow: visible;\n\t\tborder-radius: inherit;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t}\n"], ["\n\tposition: relative;\n\t> svg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\toverflow: visible;\n\t\tborder-radius: inherit;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t}\n"]);

var Wrapper$f = function Wrapper(props) {
  var borderColor = props.borderColor,
      children = props.children,
      rest = objectWithoutProperties(props, ["borderColor", "children"]);
  return React.createElement("div", rest, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement(Rect, {
    stroke: borderColor,
    height: "100%",
    width: "100%",
    rx: "7",
    ry: "7"
  })), children);
};

var Rect = styled.rect(_templateObject$W);
var DottedOutline = styled(Wrapper$f)(_templateObject2$k);

var _templateObject$X = taggedTemplateLiteral(["\n\twidth: 100%;\n\tmargin: 5px -20px 20px;\n\tpadding: 15px 20px 1px;\n"], ["\n\twidth: 100%;\n\tmargin: 5px -20px 20px;\n\tpadding: 15px 20px 1px;\n"]),
    _templateObject2$l = taggedTemplateLiteral(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"]);

var renderSection = function renderSection(s) {
  return React.createElement(SectionContainer, {
    key: s,
    id: s
  });
};

var Wrapper$g = styled(DottedOutline)(_templateObject$X);

var Group$1 = function (_React$Component) {
  inherits(Group, _React$Component);

  function Group(props) {
    classCallCheck(this, Group);

    var _this = possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).call(this, props));

    _this.setGroupContent = _this.setGroupContent.bind(_this);
    return _this;
  }

  createClass(Group, [{
    key: "setGroupContent",
    value: function setGroupContent(e) {
      var _props = this.props,
          id = _props.id,
          setGroupContent = _props.setGroupContent;
      setGroupContent(id, e.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          color = _props2.color,
          sections = _props2.sections,
          content = _props2.content,
          deleteGroup = _props2.deleteGroup,
          setGroupSortType = _props2.setGroupSortType,
          moveGroup = _props2.moveGroup,
          sortType = _props2.sortType,
          rootGraph = _props2.rootGraph,
          moveOptions = _props2.moveOptions,
          connectDragSource = _props2.connectDragSource,
          readOnly = _props2.readOnly,
          className = _props2.className;
      var controls = readOnly ? null : React.createElement(Controls$2, {
        id: id,
        deleteGroup: deleteGroup,
        setGroupSortType: setGroupSortType,
        moveGroup: moveGroup,
        sortType: sortType,
        rootGraph: rootGraph,
        moveOptions: moveOptions
      });
      return connectDragSource(React.createElement("div", {
        className: className
      }, React.createElement(Wrapper$g, {
        borderColor: color
      }, React.createElement(Content$3, {
        readOnly: readOnly,
        onChange: this.setGroupContent,
        color: color,
        value: content
      }), controls, sections.map(renderSection))));
    }
  }]);
  return Group;
}(React.Component);

var StyledGroup = styled(Group$1)(_templateObject2$l);
var dragSource$4 = {
  canDrag: function canDrag(props) {
    return !props.readOnly;
  },
  beginDrag: function beginDrag(_ref) {
    var id = _ref.id;
    return {
      id: id
    };
  }
};

var collect$5 = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var GroupDraggable = lib_4$4(DragTypes.GROUP, dragSource$4, collect$5)(StyledGroup);

var makeMapStateToProps$7 = function makeMapStateToProps() {
  var getGroup = makeGroupSelector();
  var getSections = makeGroupSectionIdSelector();
  var getRootGraph = makeRootGraphSelector();
  var getMoveOptions = makeGraphContentOptionSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var id = ownProps.id;

    var _getGroup = getGroup(state, id),
        content = _getGroup.content,
        sortType = _getGroup.sortType,
        color = _getGroup.color;

    var sections = getSections(state, id);
    var rootGraph = getRootGraph(state);
    var moveOptions = getMoveOptions(state, rootGraph);

    var _uiSelector = uiSelector(state),
        readOnly = _uiSelector.readOnly;

    return {
      content: content,
      sortType: sortType,
      color: color,
      rootGraph: rootGraph,
      moveOptions: moveOptions,
      sections: sections,
      readOnly: readOnly
    };
  };

  return mapStateToProps;
};

var GroupContainer = connect(makeMapStateToProps$7, {
  setGroupContent: setGroupContent,
  deleteGroup: deleteGroup,
  setGroupSortType: setGroupSortType,
  moveGroup: moveGroup // $FlowFixMe

})(GroupDraggable);

var ContentSwitch = function ContentSwitch(_ref) {
  var contentType = _ref.contentType,
      id = _ref.id,
      adjacentSection = _ref.adjacentSection;

  switch (contentType) {
    case "Section":
      return React.createElement(SectionContainer, {
        adjacentSection: adjacentSection,
        id: id
      });

    case "Group":
      return React.createElement(GroupContainer, {
        id: id
      });

    default:
      throw new Error("Unrecognized contentType " + contentType);
  }
};

var types$4 = [DragTypes.PAGE, DragTypes.SECTION, DragTypes.GROUP];

var pageDrop = function pageDrop(props, monitor, component) {
  var movePage = props.movePage,
      graph = props.graph,
      after = props.after;

  var _monitor$getItem = monitor.getItem(),
      id = _monitor$getItem.id;

  movePage(id, graph, after);
};

var sectionDrop = function sectionDrop(props, monitor, component) {
  var moveSection = props.moveSection,
      graph = props.graph,
      after = props.after;

  var _monitor$getItem2 = monitor.getItem(),
      id = _monitor$getItem2.id;

  moveSection(id, graph, after);
};

var groupDrop = function groupDrop(props, monitor, component) {
  var moveGroup = props.moveGroup,
      graph = props.graph,
      after = props.after;

  var _monitor$getItem3 = monitor.getItem(),
      id = _monitor$getItem3.id;

  moveGroup(id, graph, after);
};

var spec$1 = {
  drop: function drop(props, monitor, component) {
    switch (monitor.getItemType()) {
      case DragTypes.PAGE:
        return pageDrop(props, monitor, component);

      case DragTypes.SECTION:
        return sectionDrop(props, monitor, component);

      case DragTypes.GROUP:
        return groupDrop(props, monitor, component);

      default:
        return {};
    }
  }
};

var collect$6 = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    hovered: monitor.isOver()
  };
};

var DropzoneDroppable$1 = lib_5$2(types$4, spec$1, collect$6)(Dropzone);
var DropzoneContainer = connect(null, {
  movePage: movePage,
  moveSection: moveSection,
  moveGroup: moveGroup
})(DropzoneDroppable$1);

var SectionCreatorGroup = function (_React$Component) {
  inherits(SectionCreatorGroup, _React$Component);

  function SectionCreatorGroup(props) {
    classCallCheck(this, SectionCreatorGroup);

    var _this = possibleConstructorReturn(this, (SectionCreatorGroup.__proto__ || Object.getPrototypeOf(SectionCreatorGroup)).call(this, props));

    _this.state = {};
    _this.getSectionChildren = _this.getSectionChildren.bind(_this);
    _this.startSection = _this.startSection.bind(_this);
    _this.endSection = _this.endSection.bind(_this);
    _this.setPageHovered = _this.setPageHovered.bind(_this);
    _this.clearPageHovered = _this.clearPageHovered.bind(_this);
    return _this;
  }

  createClass(SectionCreatorGroup, [{
    key: "getSectionChildren",
    value: function getSectionChildren(page) {
      var pages = this.props.pages;
      var sectionStart = this.state.sectionStart;
      if (page === undefined) return [];
      var range = [pages.indexOf(pages.find(function (p) {
        return p.id === sectionStart;
      })), pages.indexOf(pages.find(function (p) {
        return p.id === page;
      }))].sort();
      return pages.slice(range[0], range[1] + 1).map(function (p) {
        return p.id;
      });
    }
  }, {
    key: "setPageHovered",
    value: function setPageHovered(page) {
      if (this.state.sectionStart !== undefined) {
        this.setState({
          sectionEnd: page
        });
      }
    }
  }, {
    key: "clearPageHovered",
    value: function clearPageHovered() {
      this.setState({
        sectionEnd: undefined
      });
    }
  }, {
    key: "startSection",
    value: function startSection(page) {
      var toggleOutlineOverlay = this.props.toggleOutlineOverlay;
      toggleOutlineOverlay();

      if (this.state.sectionStart === page) {
        return this.setState({
          sectionStart: undefined
        });
      }

      this.setState({
        sectionStart: page
      });
    }
  }, {
    key: "endSection",
    value: function endSection(page) {
      var _props = this.props,
          createSection = _props.createSection,
          toggleOutlineOverlay = _props.toggleOutlineOverlay;
      var sectionStart = this.state.sectionStart;
      if (sectionStart === undefined) return;
      toggleOutlineOverlay();
      var sectionPages = this.getSectionChildren(page);
      createSection({
        pages: sectionPages
      });
      this.setState({
        sectionStart: undefined
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          pages = _props2.pages,
          rootGraph = _props2.rootGraph;
      var sectionPages = this.getSectionChildren(this.state.sectionEnd);
      return pages.map(function (p) {
        return [React.createElement(PageContainer, {
          id: p.id,
          key: p.id,
          showHighlight: sectionPages.includes(p.id),
          showSectionButton: true,
          onMouseOver: function onMouseOver() {
            return _this2.setPageHovered(p.id);
          },
          onMouseOut: _this2.clearPageHovered,
          startSection: _this2.state.sectionStart === undefined ? _this2.startSection : undefined,
          endSection: _this2.endSection
        }), React.createElement(DropzoneContainer, {
          key: p.id + "-drop",
          graph: rootGraph,
          after: p.node
        })];
      });
    }
  }]);
  return SectionCreatorGroup;
}(React.Component);
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */


function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

var _baseSlice = baseSlice;
/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */

function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}

  return isDrop ? _baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : _baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
}

var _baseWhile = baseWhile;
/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */

function takeWhile(array, predicate) {
  return array && array.length ? _baseWhile(array, _baseIteratee(predicate, 3)) : [];
}

var takeWhile_1 = takeWhile;

var _templateObject$Y = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 0 auto;\n\tmax-width: 360px;\n\tflex-wrap: wrap;\n\tjustify-content: left;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 0 auto;\n\tmax-width: 360px;\n\tflex-wrap: wrap;\n\tjustify-content: left;\n"]);

var Wrapper$h = styled.div(_templateObject$Y);

var isPage = function isPage(content) {
  return !Array.isArray(content) && content.contentType === "Page";
}; // When rendering the root graph, we want to render any adjacent "loose" pages
// together in a single parent SectionCreatorGroup. This function replaces
// contiguous page contents with a single array.


var bundlePageContents = function bundlePageContents(contents) {
  var startIndex = findIndex_1(contents, isPage);
  if (startIndex === -1) return contents; // $FlowFixMe (flow isn't recognizing that this function filters out non-page contents)

  var bundledPages = takeWhile_1(contents.slice(startIndex), isPage);
  var result = contents.slice();
  result.splice(startIndex, bundledPages.length, bundledPages);
  return bundlePageContents(result);
};

var getAdjacentSection = function getAdjacentSection(content, nextContent) {
  return content.contentType === "Section" && nextContent !== undefined && nextContent.contentType === "Section" ? nextContent.id : undefined;
};

var OrganizeMenu = function (_React$Component) {
  inherits(OrganizeMenu, _React$Component);

  function OrganizeMenu(props) {
    classCallCheck(this, OrganizeMenu);

    var _this = possibleConstructorReturn(this, (OrganizeMenu.__proto__ || Object.getPrototypeOf(OrganizeMenu)).call(this, props));

    _this.renderContent = _this.renderContent.bind(_this);
    _this.renderContents = _this.renderContents.bind(_this);
    _this.renderPageBundle = _this.renderPageBundle.bind(_this);
    return _this;
  }

  createClass(OrganizeMenu, [{
    key: "renderPageBundle",
    value: function renderPageBundle(pages) {
      var _props = this.props,
          createSection = _props.createSection,
          toggleOutlineOverlay = _props.toggleOutlineOverlay,
          rootGraph = _props.rootGraph;
      return React.createElement(SectionCreatorGroup, {
        pages: pages,
        rootGraph: rootGraph,
        createSection: createSection,
        toggleOutlineOverlay: toggleOutlineOverlay,
        key: "SectionCreatorGroup-" + pages[0].id
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent(content, index) {
      var _props2 = this.props,
          contents = _props2.contents,
          createSection = _props2.createSection,
          rootGraph = _props2.rootGraph;
      var contentType = content.contentType,
          id = content.id;
      var key = contentType + "-" + id;
      var nextContent = contents[index + 1]; // TODO: Determine adjacent section in the SectionContainer instead of here

      return [React.createElement(ContentSwitch, _extends$c({
        key: key,
        adjacentSection: getAdjacentSection(content, nextContent),
        createSection: createSection
      }, content)), React.createElement(DropzoneContainer, {
        key: key + "-drop",
        graph: rootGraph,
        after: content.node
      })];
    }
  }, {
    key: "renderContents",
    value: function renderContents() {
      var _this2 = this;

      var contents = this.props.contents; // $FlowFixMe (flow isn't recognizing Array<Content> as a superset of Array<Content | Array<Page>>)

      return bundlePageContents(contents).map(function (c, i) {
        if (Array.isArray(c)) {
          return _this2.renderPageBundle(c);
        }

        return _this2.renderContent(c, i);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          rootGraph = _props3.rootGraph,
          contents = _props3.contents;
      var dropzoneWide = contents[0] ? contents[0].contentType !== "Page" : false;
      return React.createElement(Wrapper$h, null, React.createElement(DropzoneContainer, {
        wide: dropzoneWide,
        graph: rootGraph
      }), this.renderContents());
    }
  }]);
  return OrganizeMenu;
}(React.Component);

function mapStateToProps$F(state) {
  var rootGraph = rootGraphSelector(state);
  var contents = graphContentSelector(state, rootGraph);
  return {
    rootGraph: rootGraph,
    contents: contents
  };
}

var OrganizeMenuContainer = connect(mapStateToProps$F, {
  createSection: createSection$1,
  toggleOutlineOverlay: toggleOutlineOverlay
})(OrganizeMenu);

var _templateObject$Z = taggedTemplateLiteral(["\n\toverflow: auto;\n\tbox-sizing: border-box;\n\tz-index: 10;\n\tpadding: 35px 25px 30px;\n\theight: 100%;\n"], ["\n\toverflow: auto;\n\tbox-sizing: border-box;\n\tz-index: 10;\n\tpadding: 35px 25px 30px;\n\theight: 100%;\n"]),
    _templateObject2$m = taggedTemplateLiteral(["\n\ttext-decoration: none;\n"], ["\n\ttext-decoration: none;\n"]),
    _templateObject3$a = taggedTemplateLiteral(["\n\tmargin-top: 30px;\n"], ["\n\tmargin-top: 30px;\n"]);

var StyledDiv$1 = styled.div(_templateObject$Z);
var StyledLink$1 = styled(NavLink)(_templateObject2$m);
var GroupedLink = GroupedButton.withComponent(StyledLink$1);
var Submenu = styled.div(_templateObject3$a);

var SurveyMenu = function SurveyMenu(_ref) {
  var surveyHashRoute = _ref.surveyHashRoute;
  return React.createElement(StyledDiv$1, null, React.createElement(ButtonGroup, null, React.createElement(GroupedLink, {
    to: {
      pathname: "/" + surveyHashRoute + "/build"
    }
  }, "Build"), React.createElement(GroupedLink, {
    to: {
      pathname: "/" + surveyHashRoute + "/organize"
    }
  }, "Organize")), React.createElement(Submenu, null, React.createElement(Route, {
    path: "/:surveyHashRoute/build",
    render: function render() {
      return React.createElement(BuildMenu, {
        surveyHashRoute: surveyHashRoute
      });
    }
  }), React.createElement(Route, {
    path: "/:surveyHashRoute/organize",
    render: function render() {
      return React.createElement(OrganizeMenuContainer, {
        surveyHashRoute: surveyHashRoute
      });
    }
  })));
};

var _templateObject$_ = taggedTemplateLiteral(["\n  background-color: ", ";\n  flex-grow: 1;\n  flex-basis: 0;\n  position: relative;\n  min-width: 350px;\n  max-width: 450px;\n  overflow: hidden;\n  > span > * {\n    right: 0;\n    position: absolute;\n    width: 100%;\n    max-width: 450px;\n    height: 100%;\n  }\n"], ["\n  background-color: ", ";\n  flex-grow: 1;\n  flex-basis: 0;\n  position: relative;\n  min-width: 350px;\n  max-width: 450px;\n  overflow: hidden;\n  > span > * {\n    right: 0;\n    position: absolute;\n    width: 100%;\n    max-width: 450px;\n    height: 100%;\n  }\n"]);

var StyledWrapper$1 = styled.div(_templateObject$_, function (props) {
  return props.theme.neutralLight["7"];
});

var RootRedirect = function RootRedirect(_ref) {
  var surveyHashRoute = _ref.surveyHashRoute;
  return React.createElement(Redirect, {
    to: {
      pathname: "/" + surveyHashRoute + "/build"
    }
  });
};

var QuestionMenuMatched = function QuestionMenuMatched(_ref2) {
  var location = _ref2.location,
      match = _ref2.match,
      surveyHashRoute = _ref2.surveyHashRoute;

  if (match.params.id === undefined) {
    return React.createElement(RootRedirect, {
      surveyHashRoute: surveyHashRoute
    });
  }

  return React.createElement(QuestionMenuContainer, {
    surveyHashRoute: surveyHashRoute,
    locationPath: location.pathname,
    id: parseInt(match.params.id, 10)
  });
};

var PageMenuMatched = function PageMenuMatched(_ref3) {
  var location = _ref3.location,
      match = _ref3.match,
      surveyHashRoute = _ref3.surveyHashRoute;

  if (match.params.key === undefined) {
    return React.createElement(RootRedirect, {
      surveyHashRoute: surveyHashRoute
    });
  }

  return React.createElement(PageMenuContainer, {
    surveyHashRoute: surveyHashRoute,
    locationPath: location.pathname,
    id: parseInt(match.params.key, 10)
  });
};

var Sidebar = function (_React$Component) {
  inherits(Sidebar, _React$Component);

  function Sidebar() {
    classCallCheck(this, Sidebar);
    return possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
  }

  createClass(Sidebar, [{
    key: "render",
    value: function render() {
      var location = this.props.location;
      return React.createElement(StyledWrapper$1, null, React.createElement(Switch, {
        location: location
      }, React.createElement(Route, {
        path: "/:surveyHashRoute/page/:key",
        render: function render(_ref4) {
          var match = _ref4.match,
              location = _ref4.location;
          if (match === null) return null;
          return React.createElement(PageMenuMatched, {
            location: location,
            match: match,
            surveyHashRoute: match.params.surveyHashRoute
          });
        }
      }), React.createElement(Route, {
        path: "/:surveyHashRoute/question/:id",
        render: function render(_ref5) {
          var match = _ref5.match,
              location = _ref5.location;
          if (match === null) return null;
          return React.createElement(QuestionMenuMatched, {
            match: match,
            location: location,
            surveyHashRoute: match.params.surveyHashRoute
          });
        }
      }), React.createElement(Route, {
        path: "/:surveyHashRoute/(build|organize)",
        render: function render(_ref6) {
          var match = _ref6.match;
          if (match === null) return null;
          return React.createElement(SurveyMenu, {
            surveyHashRoute: match.params.surveyHashRoute
          });
        }
      })));
    }
  }]);
  return Sidebar;
}(React.Component);

var Sidebar$1 = withRouter(Sidebar);

var confirmAndClose = function confirmAndClose(onConfirm, closeModal) {
  return function () {
    onConfirm();
    closeModal();
  };
};

var DeleteLastQuestion = function DeleteLastQuestion(_ref) {
  var onConfirm = _ref.onConfirm,
      closeModal = _ref.closeModal,
      body = _ref.body;
  return React.createElement("div", null, React.createElement(ModalHeader, null, "Confirm Deletion"), React.createElement(ModalBody, null, body), React.createElement(ModalFooter, null, React.createElement(ModalCancel, {
    href: "#",
    onClick: closeModal
  }, "Cancel"), React.createElement(Button, {
    onClick: confirmAndClose(onConfirm, closeModal),
    swatch: "danger"
  }, "Delete")));
};

var DeletePage = function DeletePage(props) {
  var body = React.createElement("div", null, React.createElement("span", null, "Are you sure you want to delete this page?"), React.createElement("br", null), React.createElement("span", null, "It contains ", props.questionCount, " ", props.questionCount > 1 ? "questions" : "question", "."));
  return React.createElement(DeleteLastQuestion, _extends$c({
    body: body
  }, props));
};

var DeleteLastQuestion$1 = function DeleteLastQuestion$$1(props) {
  var body = React.createElement("div", null, React.createElement("span", null, "Deleting the last question on a page will delete the page."), React.createElement("br", null), React.createElement("span", null, "Are you sure you want to delete this page?"));
  return React.createElement(DeleteLastQuestion, _extends$c({
    body: body
  }, props));
};

var MoveLastQuestion = function MoveLastQuestion(props) {
  var body = React.createElement("div", null, React.createElement("span", null, "Moving this page's last question will delete the page."), React.createElement("br", null), React.createElement("span", null, "Are you sure you want to delete this page?"));
  return React.createElement(DeleteLastQuestion, _extends$c({
    body: body
  }, props));
};

var _templateObject$10 = taggedTemplateLiteral(["\n  width: 100%;\n  resize: none;\n  box-sizing: border-box;\n  height: 300px;\n"], ["\n  width: 100%;\n  resize: none;\n  box-sizing: border-box;\n  height: 300px;\n"]),
    _templateObject2$n = taggedTemplateLiteral(["\n  p {\n    text-align: left;\n  }\n"], ["\n  p {\n    text-align: left;\n  }\n"]),
    _templateObject3$b = taggedTemplateLiteral(["\n  display: flex;\n"], ["\n  display: flex;\n"]);

var AnswerInput = styled(TextInput.withComponent("textarea"))(_templateObject$10);
var BulkAnswersBody = styled(ModalBody)(_templateObject2$n);
var StyledAlert$1 = styled(Alert)(_templateObject3$b);

var BulkAnswers = function (_React$Component) {
  inherits(BulkAnswers, _React$Component);

  function BulkAnswers(props) {
    classCallCheck(this, BulkAnswers);

    var _this = possibleConstructorReturn(this, (BulkAnswers.__proto__ || Object.getPrototypeOf(BulkAnswers)).call(this, props));

    _this.handleChange = function (e) {
      _this.setState({
        value: e.target.value
      });
    };

    _this.handleConfirm = function (e) {
      var _this$props = _this.props,
          setAnswers = _this$props.setAnswers,
          closeModal = _this$props.closeModal,
          maxAnswers = _this$props.maxAnswers;

      var answers = _this.getAnswers();

      setAnswers(answers.slice(0, maxAnswers));
      closeModal();
    };

    _this.getAnswers = function () {
      var split = _this.state.value.split(/\r\n|\r|\n/);

      return split.filter(function (ans) {
        return ans !== "";
      });
    };

    _this.getAnswerCount = function () {
      return _this.getAnswers().length;
    };

    _this.renderMaxAlert = function () {
      var maxAnswers = _this.props.maxAnswers;
      var value = _this.state.value;

      var answerCount = _this.getAnswerCount();

      if (answerCount > maxAnswers) {
        var message = "The list has exceeded the " + maxAnswers + "-choice limit. By continuing, additional answer choices will be removed.";
        return React.createElement(StyledAlert$1, null, message);
      }

      return null;
    };

    _this.renderMinAlert = function () {
      var answerCount = _this.getAnswerCount();

      if (answerCount < 2) {
        return React.createElement(StyledAlert$1, null, "Add at least two answer choices to continue.");
      }

      return null;
    };

    var initialText = props.initialAnswers ? props.initialAnswers.join("\n") : "";
    _this.state = {
      value: initialText,
      error: null
    };
    return _this;
  }

  createClass(BulkAnswers, [{
    key: "componentDidCatch",
    value: function componentDidCatch(e) {
      console.error(e);
      this.setState({
        error: e
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          closeModal = _props.closeModal,
          _props$maxAnswers = _props.maxAnswers,
          maxAnswers = _props$maxAnswers === undefined ? 100 : _props$maxAnswers;
      var error = this.state.error;
      var continueDisabled = this.getAnswerCount() < 2;
      if (error) return React.createElement("div", null, React.createElement(ModalHeader, null, "Error"), React.createElement(ModalBody, null, "Something went wrong. Please try again."), React.createElement(ModalFooter, null, React.createElement(Button, {
        onClick: closeModal
      }, "Ok")));
      return React.createElement("div", null, React.createElement(ModalHeader, null, "Add bulk answers"), React.createElement(BulkAnswersBody, null, React.createElement("p", null, "Add line separated text below:"), React.createElement(AnswerInput, {
        autoFocus: true,
        value: this.state.value,
        onChange: this.handleChange
      }), React.createElement("p", null, "Maximum " + maxAnswers + " answer choices"), this.renderMaxAlert(), this.renderMinAlert()), React.createElement(ModalFooter, null, React.createElement(ModalCancel, {
        href: "#",
        onClick: closeModal
      }, "Cancel"), React.createElement(Button, {
        disabled: continueDisabled,
        onClick: this.handleConfirm,
        swatch: "neutralDark"
      }, "Continue")));
    }
  }]);
  return BulkAnswers;
}(React.Component);

BulkAnswers.defaultProps = {
  initialAnswers: [],
  maxAnswers: 100
};

var getErrorChildren = function getErrorChildren(breakingRelations) {
  var children = [];

  if (breakingRelations.hasOwnProperty("providerPipes") || breakingRelations.hasOwnProperty("consumerPipes")) {
    children.push(React.createElement("p", {
      key: "pipe"
    }, "Moving this content will remove piping."));
  }

  if (breakingRelations.hasOwnProperty("skipConditions") || breakingRelations.hasOwnProperty("displayConditions")) {
    children.push(React.createElement("p", {
      key: "logic"
    }, "Moving this content will remove logic conditions."));
  }

  if (breakingRelations.hasOwnProperty("skipBranches")) {
    children.push(React.createElement("p", {
      key: "branches"
    }, "Moving this content will remove skip logic."));
  }

  children.push(React.createElement("p", {
    key: "warn"
  }, "Are you sure you would like to continue?"));
  return children;
};

var MoveQuestionWarning = function MoveQuestionWarning(_ref) {
  var onConfirm = _ref.onConfirm,
      closeModal = _ref.closeModal,
      breakingRelations = _ref.breakingRelations;

  var confirmAndClose = function confirmAndClose() {
    onConfirm();
    closeModal();
  };

  var errorChildren = getErrorChildren(breakingRelations);
  return React.createElement("div", null, React.createElement(ModalHeader, null, "Confirm Movement"), React.createElement(ModalBody, null, errorChildren), React.createElement(ModalFooter, null, React.createElement(ModalCancel, {
    href: "#",
    onClick: closeModal
  }, "Cancel"), React.createElement(Button, {
    onClick: confirmAndClose
  }, "Continue")));
};

var getModalSize = function getModalSize(modalType) {
  switch (modalType) {
    case MOVE_LAST_QUESTION:
    case DELETE_LAST_QUESTION:
    case DELETE_PAGE:
    case MOVE_ITEM_WARNING:
      return "sm";

    case BULK_ANSWERS:
    default:
      return "lg";
  }
};

var getModalLabel = function getModalLabel(modalType) {
  switch (modalType) {
    case MOVE_LAST_QUESTION:
    case DELETE_LAST_QUESTION:
    case DELETE_PAGE:
      return "Confirm deletion";

    case BULK_ANSWERS:
      return "Add bulk answers";

    default:
      return "";
  }
}; // RootModal is a singleton component rendered as part of the app's layout.
// It's responsible for reading the modalType and selecting a modal component.


var RootModal = function (_React$Component) {
  inherits(RootModal, _React$Component);

  function RootModal() {
    classCallCheck(this, RootModal);
    return possibleConstructorReturn(this, (RootModal.__proto__ || Object.getPrototypeOf(RootModal)).apply(this, arguments));
  }

  createClass(RootModal, [{
    key: "renderChild",
    value: function renderChild() {
      var _props = this.props,
          modalType = _props.modalType,
          modalProps = _props.modalProps,
          closeModal = _props.closeModal;

      switch (modalType) {
        case MOVE_LAST_QUESTION:
          return React.createElement(MoveLastQuestion, _extends$c({
            closeModal: closeModal
          }, modalProps));

        case DELETE_LAST_QUESTION:
          return React.createElement(DeleteLastQuestion$1, _extends$c({
            closeModal: closeModal
          }, modalProps));

        case DELETE_PAGE:
          return React.createElement(DeletePage, _extends$c({
            closeModal: closeModal
          }, modalProps));

        case BULK_ANSWERS:
          return React.createElement(BulkAnswers, _extends$c({
            closeModal: closeModal
          }, modalProps));

        case MOVE_ITEM_WARNING:
          return React.createElement(MoveQuestionWarning, _extends$c({
            closeModal: closeModal
          }, modalProps));

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          modalType = _props2.modalType,
          closeModal = _props2.closeModal;
      return React.createElement(Modal, {
        contentLabel: getModalLabel(modalType),
        onRequestClose: closeModal,
        isOpen: modalType !== null,
        size: getModalSize(modalType),
        appElement: document.getElementById("root")
      }, this.renderChild());
    }
  }]);
  return RootModal;
}(React.Component);

function mapStateToProps$G(state) {
  var _modalSelector = modalSelector(state),
      modalType = _modalSelector.modalType,
      modalProps = _modalSelector.modalProps;

  return {
    modalType: modalType,
    modalProps: modalProps
  };
}

var ModalContainer = connect(mapStateToProps$G, {
  closeModal: closeModal$1
})(RootModal);

var _templateObject$11 = taggedTemplateLiteral(["\n\tposition: absolute;\n\tbackground-color: ", ";\n\twidth: calc(100% - 15px);\n\tmax-width: 990px;\n\tz-index: 10;\n\tpadding: 15px 60px 0;\n\tbox-sizing: border-box;\n\tborder-bottom: 2px solid ", ";\n"], ["\n\tposition: absolute;\n\tbackground-color: ", ";\n\twidth: calc(100% - 15px);\n\tmax-width: 990px;\n\tz-index: 10;\n\tpadding: 15px 60px 0;\n\tbox-sizing: border-box;\n\tborder-bottom: 2px solid ", ";\n"]),
    _templateObject2$o = taggedTemplateLiteral(["\n\tpadding: 15px 20px;\n\tmargin: 0 -20px;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n\tborder-bottom-width: 0;\n\tbox-shadow: none;\n\t> h1 {\n\t\tmargin-bottom: 0;\n\t}\n"], ["\n\tpadding: 15px 20px;\n\tmargin: 0 -20px;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n\tborder-bottom-width: 0;\n\tbox-shadow: none;\n\t> h1 {\n\t\tmargin-bottom: 0;\n\t}\n"]),
    _templateObject3$c = taggedTemplateLiteral(["\n\tborder-color: ", ";\n\tborder-width: 4px 4px 0 4px;\n\tborder-style: dotted;\n\tborder-radius: 0.5em 0.5em 0 0;\n\tmargin: 0 -20px;\n\tpadding: 0 36px;\n"], ["\n\tborder-color: ", ";\n\tborder-width: 4px 4px 0 4px;\n\tborder-style: dotted;\n\tborder-radius: 0.5em 0.5em 0 0;\n\tmargin: 0 -20px;\n\tpadding: 0 36px;\n"]);

var Header$3 = styled.header(_templateObject$11, function (props) {
  return props.theme.neutralLight["5"];
}, function (props) {
  return props.theme.neutralLight["4"];
});
var SectionCap = styled(Card$1)(_templateObject2$o);
var GroupCap = styled.div(_templateObject3$c, function (p) {
  return p.color;
});

var FixedHeader = function FixedHeader(props) {
  if (props.group) {
    var _section = props.section ? React.createElement(SectionCap, null, props.section) : null;

    return React.createElement(Header$3, null, React.createElement(GroupCap, {
      color: props.group.color
    }, props.group.content, _section));
  }

  if (props.section) {
    return React.createElement(Header$3, null, React.createElement(SectionCap, null, React.createElement("h1", null, props.section)));
  }

  return null;
};

var _templateObject$12 = taggedTemplateLiteral(["\n\tdisplay: none;\n"], ["\n\tdisplay: none;\n"]),
    _templateObject2$p = taggedTemplateLiteral(["\n\tpadding: ", ";\n\tmargin-top: ", ";\n\t&.highlight {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t}\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"], ["\n\tpadding: ", ";\n\tmargin-top: ", ";\n\t&.highlight {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t}\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"]);

var ControlWrapper = styled.div(_templateObject$12);
var Card$2 = styled(Card$1)(_templateObject2$p, function (props) {
  return props.demo ? "20px" : "20px 20px 5px";
}, function (props) {
  return props.demo ? "25px" : "0";
}, function (props) {
  return props.theme.primary["3"];
}, function (props) {
  return props.theme.primary["5"];
}, function (props) {
  return props.theme.primary["3"];
}, function (props) {
  return props.demo ? props.theme.neutralLight["7"] : props.theme.primary["5"];
}, ControlWrapper);

var _templateObject$13 = taggedTemplateLiteral(["\n\tbutton {\n\t\tmargin-right: 1em;\n\t}\n\t> button:last-child {\n\t\tmargin-right: 0;\n\t}\n"], ["\n\tbutton {\n\t\tmargin-right: 1em;\n\t}\n\t> button:last-child {\n\t\tmargin-right: 0;\n\t}\n"]),
    _templateObject2$q = taggedTemplateLiteral(["\n\tposition: relative;\n"], ["\n\tposition: relative;\n"]);

var Edit$2 = icons.Edit,
    Duplicate = icons.Duplicate,
    Move$2 = icons.Move,
    Delete$5 = icons.Delete;
var Container = styled.div(_templateObject$13);
var MoveWrapper = styled.span(_templateObject2$q);

var PageOutlineControls = function (_React$Component) {
  inherits(PageOutlineControls, _React$Component);

  function PageOutlineControls(props) {
    classCallCheck(this, PageOutlineControls);

    var _this = possibleConstructorReturn(this, (PageOutlineControls.__proto__ || Object.getPrototypeOf(PageOutlineControls)).call(this, props));

    _this.renderPopover = function (open, toggle) {
      var moveOptions = _this.props.moveOptions;

      var handler = function handler(e) {
        e.stopPropagation();
        toggle();
      };

      var button = React.createElement(IconButton, {
        disabled: moveOptions.length < 2,
        onClick: handler,
        title: "Move"
      }, React.createElement(Move$2, null));

      if (open) {
        return React.createElement(MoveWrapper, null, React.createElement(MoveMenu, {
          options: moveOptions,
          onSubmit: _this.handleMove,
          close: toggle
        }), button);
      }

      return button;
    };

    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.handleDuplicate = _this.handleDuplicate.bind(_this);
    _this.handleMove = _this.handleMove.bind(_this);
    _this.renderPopover = _this.renderPopover.bind(_this);
    return _this;
  }

  createClass(PageOutlineControls, [{
    key: "handleDelete",
    value: function handleDelete(e) {
      var _props = this.props,
          showModal = _props.showModal,
          deletePage = _props.deletePage,
          id = _props.id,
          questionCount = _props.questionCount;
      e.stopPropagation();
      showModal(DELETE_PAGE, {
        onConfirm: function onConfirm() {
          return deletePage(id);
        },
        questionCount: questionCount
      });
    }
  }, {
    key: "handleDuplicate",
    value: function handleDuplicate(e) {
      var _props2 = this.props,
          id = _props2.id,
          duplicatePage = _props2.duplicatePage;
      e.stopPropagation();
      duplicatePage(id);
    }
  }, {
    key: "handleMove",
    value: function handleMove(option) {
      var _props3 = this.props,
          id = _props3.id,
          rootGraph = _props3.rootGraph,
          movePage = _props3.movePage;
      var node = option.node;
      movePage(id, rootGraph, node);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Container, null, React.createElement(IconButton, {
        title: "Edit"
      }, React.createElement(Edit$2, null)), React.createElement(IconButton, {
        onClick: this.handleDuplicate,
        title: "Duplicate"
      }, React.createElement(Duplicate, null)), React.createElement(Popover, null, this.renderPopover), React.createElement(IconButton, {
        onClick: this.handleDelete,
        title: "Delete"
      }, React.createElement(Delete$5, null)));
    }
  }]);
  return PageOutlineControls;
}(React.Component);

var mapStateToProps$H = function mapStateToProps(state, ownProps) {
  var id = ownProps.id,
      questionCount = ownProps.questionCount;
  var rootGraph = rootGraphSelector(state);
  var moveOptions = graphContentOptionSelector(state, rootGraph);
  return {
    id: id,
    rootGraph: rootGraph,
    moveOptions: moveOptions,
    questionCount: questionCount
  };
};

var ControlsContainer$2 = connect(mapStateToProps$H, {
  deletePage: deletePage,
  duplicatePage: duplicatePage,
  movePage: movePage,
  showModal: showModal$1
})(PageOutlineControls);

var _templateObject$14 = taggedTemplateLiteral(["\n\theight: ", ";\n\twidth: 100%;\n\tsvg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\topacity: ", ";\n\t\tline {\n\t\t\tstroke: ", ";\n\t\t\tstroke-width: 1;\n\t\t\tstroke-linecap: round;\n\t\t\tstroke-dasharray: 3;\n\t\t}\n\t}\n"], ["\n\theight: ", ";\n\twidth: 100%;\n\tsvg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\topacity: ", ";\n\t\tline {\n\t\t\tstroke: ", ";\n\t\t\tstroke-width: 1;\n\t\t\tstroke-linecap: round;\n\t\t\tstroke-dasharray: 3;\n\t\t}\n\t}\n"]);

var Dropzone$1 = styled.div(_templateObject$14, function (props) {
  return props.hovered ? "30px" : "15px";
}, function (props) {
  return props.hovered ? "1" : "0";
}, function (props) {
  return props.theme.primary["2"];
});

var QuestionDrop = function QuestionDrop(_ref) {
  var connectDropTarget = _ref.connectDropTarget,
      hovered = _ref.hovered;
  return connectDropTarget(React.createElement("div", null, React.createElement(Dropzone$1, {
    hovered: hovered
  }, React.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "0 0 300 5",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("line", {
    x1: "0",
    x2: "300",
    y1: "3",
    y2: "3"
  })))));
};

var types$5 = [DragTypes.QUESTION_TYPE, DragTypes.QUESTION];

var questionTypeDrop = function questionTypeDrop(props, monitor, component) {
  var createQuestion = props.createQuestion,
      id = props.id,
      after = props.after,
      surveyHashRoute = props.surveyHashRoute;

  var _monitor$getItem = monitor.getItem(),
      type = _monitor$getItem.type;

  createQuestion({
    type: type,
    after: after,
    page: id,
    surveyHashRoute: surveyHashRoute
  });
};

var questionDrop$1 = function questionDrop(props, monitor, component) {
  var moveQuestion = props.moveQuestion,
      showModal = props.showModal,
      id = props.id,
      after = props.after;

  var _monitor$getItem2 = monitor.getItem(),
      questionId = _monitor$getItem2.id,
      pageQuestionCount = _monitor$getItem2.pageQuestionCount;

  if (pageQuestionCount === 1) {
    return showModal(MOVE_LAST_QUESTION, {
      onConfirm: function onConfirm() {
        return moveQuestion(questionId, id, after);
      }
    });
  }

  moveQuestion(questionId, id, after);
};

var spec$2 = {
  drop: function drop(props, monitor, component) {
    switch (monitor.getItemType()) {
      case DragTypes.QUESTION_TYPE:
        return questionTypeDrop(props, monitor, component);

      case DragTypes.QUESTION:
        return questionDrop$1(props, monitor, component);

      default:
        return {};
    }
  }
};

var collect$7 = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    hovered: monitor.isOver()
  };
};

var AddQuestionDroppable = lib_5$2(types$5, spec$2, collect$7)(QuestionDrop);
var AddQuestionContainer = withRouter(connect(null, {
  createQuestion: createQuestion$1,
  moveQuestion: moveQuestion,
  showModal: showModal$1 // $FlowFixMe

})(AddQuestionDroppable));
var getMoveOptions = makeQuestionOptionsSelector();

var mapStateToProps$I = function mapStateToProps(state) {
  return {
    options: getMoveOptions(state)
  };
};

var MoveContainer = connect(mapStateToProps$I)(MoveMenu);

var _templateObject$15 = taggedTemplateLiteral(["\n\tbutton {\n\t\tmargin-right: 1em;\n\t}\n\t> button:last-child {\n\t\tmargin-right: 0;\n\t}\n"], ["\n\tbutton {\n\t\tmargin-right: 1em;\n\t}\n\t> button:last-child {\n\t\tmargin-right: 0;\n\t}\n"]),
    _templateObject2$r = taggedTemplateLiteral(["\n\tposition: relative;\n"], ["\n\tposition: relative;\n"]);

var Edit$3 = icons.Edit,
    Duplicate$1 = icons.Duplicate,
    Move$3 = icons.Move,
    Delete$6 = icons.Delete;
var StyledWrapper$2 = styled.div(_templateObject$15);
var MoveWrapper$1 = styled.span(_templateObject2$r);

var showDeleteModal = function showDeleteModal(showModal, onConfirm) {
  return showModal(DELETE_LAST_QUESTION, {
    onConfirm: onConfirm
  });
};

var showMoveLastModal = function showMoveLastModal(showModal, onConfirm) {
  return showModal(MOVE_LAST_QUESTION, {
    onConfirm: onConfirm
  });
};

var DuplicateButton = function DuplicateButton(_ref) {
  var id = _ref.id,
      duplicateQuestion = _ref.duplicateQuestion;

  var onClick = function onClick(e) {
    e.stopPropagation();
    duplicateQuestion(id);
  };

  return React.createElement(IconButton, {
    onClick: onClick,
    title: "Duplicate"
  }, React.createElement(Duplicate$1, null));
};

var DeleteButton = function DeleteButton(_ref2) {
  var id = _ref2.id,
      pageQuestionCount = _ref2.pageQuestionCount,
      showModal = _ref2.showModal,
      deleteQuestion = _ref2.deleteQuestion;

  var onClick = function onClick(e) {
    e.stopPropagation();

    if (pageQuestionCount === 1) {
      return showDeleteModal(showModal, function () {
        return deleteQuestion(id);
      });
    }

    deleteQuestion(id);
  };

  return React.createElement(IconButton, {
    onClick: onClick,
    title: "Delete"
  }, React.createElement(Delete$6, null));
};

var QuestionOutlineControls = function (_React$Component) {
  inherits(QuestionOutlineControls, _React$Component);

  function QuestionOutlineControls(props) {
    classCallCheck(this, QuestionOutlineControls);

    var _this = possibleConstructorReturn(this, (QuestionOutlineControls.__proto__ || Object.getPrototypeOf(QuestionOutlineControls)).call(this, props));

    _this.renderPopover = _this.renderPopover.bind(_this);
    return _this;
  }

  createClass(QuestionOutlineControls, [{
    key: "renderPopover",
    value: function renderPopover(open, toggle) {
      var _props = this.props,
          id = _props.id,
          moveQuestion = _props.moveQuestion,
          pageQuestionCount = _props.pageQuestionCount,
          showModal = _props.showModal;
      var button = React.createElement(IconButton, {
        onClick: toggle,
        title: "Move"
      }, React.createElement(Move$3, null));

      var onSubmit = function onSubmit(option) {
        var after = option.value;

        if (pageQuestionCount === 1) {
          return showMoveLastModal(showModal, function () {
            return moveQuestion(id, option.pageId, after);
          });
        }

        moveQuestion(id, option.pageId, after);
      };

      if (open) {
        return React.createElement(MoveWrapper$1, null, React.createElement(MoveContainer, {
          onSubmit: onSubmit,
          close: toggle
        }), button);
      }

      return button;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          duplicateQuestion = _props2.duplicateQuestion,
          pageQuestionCount = _props2.pageQuestionCount,
          showModal = _props2.showModal,
          deleteQuestion = _props2.deleteQuestion;
      return React.createElement(StyledWrapper$2, null, React.createElement(IconButton, {
        title: "Edit"
      }, React.createElement(Edit$3, null)), React.createElement(DuplicateButton, {
        id: id,
        duplicateQuestion: duplicateQuestion
      }), React.createElement(Popover, null, this.renderPopover), React.createElement(DeleteButton, {
        id: id,
        pageQuestionCount: pageQuestionCount,
        showModal: showModal,
        deleteQuestion: deleteQuestion
      }));
    }
  }]);
  return QuestionOutlineControls;
}(React.Component); // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$8 = function makeMapStateToProps() {
  var getCount = makeQuestionPageCountSelector();
  return function (state, ownProps) {
    return {
      pageQuestionCount: getCount(state, ownProps.id)
    };
  };
};

var ControlsContainer$3 = connect(makeMapStateToProps$8, {
  deleteQuestion: deleteQuestion,
  duplicateQuestion: duplicateQuestion,
  moveQuestion: moveQuestion,
  showModal: showModal$1
})(QuestionOutlineControls);

var _templateObject$16 = taggedTemplateLiteral(["\n  from {\n    transform: scaleY(1);\n  }\n  to {\n    transform: scaleY(0);\n  }\n"], ["\n  from {\n    transform: scaleY(1);\n  }\n  to {\n    transform: scaleY(0);\n  }\n"]),
    _templateObject2$s = taggedTemplateLiteral(["\n\tdisplay: none;\n"], ["\n\tdisplay: none;\n"]),
    _templateObject3$d = taggedTemplateLiteral(["\n\tcolor: ", ";\n\tpadding: 0 1em 0 2em;\n\tbox-sizing: border-box;\n\ttransform-origin: top;\n\tmin-height: 60px;\n\t&.transition-entering {\n\t\ttransform: scaleY(0);\n\t}\n\t&.transition-entered {\n\t\ttransform: scaleY(1);\n\t}\n\t&.transition-exiting {\n\t\ttransform: scaleY(0);\n\t\tanimation: ", " 0.125s linear;\n\t}\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\t&:not(:last-child) {\n\t\tmargin-bottom: 1em;\n\t}\n"], ["\n\tcolor: ", ";\n\tpadding: 0 1em 0 2em;\n\tbox-sizing: border-box;\n\ttransform-origin: top;\n\tmin-height: 60px;\n\t&.transition-entering {\n\t\ttransform: scaleY(0);\n\t}\n\t&.transition-entered {\n\t\ttransform: scaleY(1);\n\t}\n\t&.transition-exiting {\n\t\ttransform: scaleY(0);\n\t\tanimation: ", " 0.125s linear;\n\t}\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\t&:not(:last-child) {\n\t\tmargin-bottom: 1em;\n\t}\n"]);

var exit = keyframes(_templateObject$16);
var ControlWrapper$1 = styled.div(_templateObject2$s);
var Card$3 = styled(Card$1)(_templateObject3$d, function (props) {
  return props.theme.neutralDark["2"];
}, exit, function (props) {
  return props.theme.primary["3"];
}, function (props) {
  return props.theme.primary["5"];
}, ControlWrapper$1);
var immutable$1 = extend;
var hasOwnProperty$g = Object.prototype.hasOwnProperty;

function extend() {
  var target = {};

  for (var i = 0; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (hasOwnProperty$g.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}

var hasOwn$1 = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty$c = Object.defineProperty;
var gOPD$6 = Object.getOwnPropertyDescriptor;

var isArray$1 = function isArray(arr) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(arr);
  }

  return toStr.call(arr) === '[object Array]';
};

var isPlainObject$4 = function isPlainObject(obj) {
  if (!obj || toStr.call(obj) !== '[object Object]') {
    return false;
  }

  var hasOwnConstructor = hasOwn$1.call(obj, 'constructor');
  var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn$1.call(obj.constructor.prototype, 'isPrototypeOf'); // Not own constructor property must be Object

  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  } // Own properties are enumerated firstly, so to speed up,
  // if last one is own, then all properties are own.


  var key;

  for (key in obj) {
    /**/
  }

  return typeof key === 'undefined' || hasOwn$1.call(obj, key);
}; // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target


var setProperty = function setProperty(target, options) {
  if (defineProperty$c && options.name === '__proto__') {
    defineProperty$c(target, options.name, {
      enumerable: true,
      configurable: true,
      value: options.newValue,
      writable: true
    });
  } else {
    target[options.name] = options.newValue;
  }
}; // Return undefined instead of __proto__ if '__proto__' is not an own property


var getProperty = function getProperty(obj, name) {
  if (name === '__proto__') {
    if (!hasOwn$1.call(obj, name)) {
      return void 0;
    } else if (gOPD$6) {
      // In early versions of node, obj['__proto__'] is buggy when obj has
      // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
      return gOPD$6(obj, name).value;
    }
  }

  return obj[name];
};

var extend$1 = function extend() {
  var options, name, src, copy, copyIsArray, clone;
  var target = arguments[0];
  var i = 1;
  var length = arguments.length;
  var deep = false; // Handle a deep copy situation

  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {}; // skip the boolean and the target

    i = 2;
  }

  if (target == null || typeof target !== 'object' && typeof target !== 'function') {
    target = {};
  }

  for (; i < length; ++i) {
    options = arguments[i]; // Only deal with non-null/undefined values

    if (options != null) {
      // Extend the base object
      for (name in options) {
        src = getProperty(target, name);
        copy = getProperty(options, name); // Prevent never-ending loop

        if (target !== copy) {
          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (isPlainObject$4(copy) || (copyIsArray = isArray$1(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && isArray$1(src) ? src : [];
            } else {
              clone = src && isPlainObject$4(src) ? src : {};
            } // Never move original objects, clone them


            setProperty(target, {
              name: name,
              newValue: extend(deep, clone, copy)
            }); // Don't bring in undefined values
          } else if (typeof copy !== 'undefined') {
            setProperty(target, {
              name: name,
              newValue: copy
            });
          }
        }
      }
    }
  } // Return the modified object


  return target;
};

var bail_1 = bail;

function bail(err) {
  if (err) {
    throw err;
  }
}

var own = {}.hasOwnProperty;
var unistUtilStringifyPosition = stringify;

function stringify(value) {
  /* Nothing. */
  if (!value || typeof value !== 'object') {
    return null;
  }
  /* Node. */


  if (own.call(value, 'position') || own.call(value, 'type')) {
    return position(value.position);
  }
  /* Position. */


  if (own.call(value, 'start') || own.call(value, 'end')) {
    return position(value);
  }
  /* Point. */


  if (own.call(value, 'line') || own.call(value, 'column')) {
    return point(value);
  }
  /* ? */


  return null;
}

function point(point) {
  if (!point || typeof point !== 'object') {
    point = {};
  }

  return index$b(point.line) + ':' + index$b(point.column);
}

function position(pos) {
  if (!pos || typeof pos !== 'object') {
    pos = {};
  }

  return point(pos.start) + '-' + point(pos.end);
}

function index$b(value) {
  return value && typeof value === 'number' ? value : 1;
}

var vfileMessage = VMessage; // Inherit from `Error#`.

function VMessagePrototype() {}

VMessagePrototype.prototype = Error.prototype;
VMessage.prototype = new VMessagePrototype(); // Message properties.

var proto$5 = VMessage.prototype;
proto$5.file = '';
proto$5.name = '';
proto$5.reason = '';
proto$5.message = '';
proto$5.stack = '';
proto$5.fatal = null;
proto$5.column = null;
proto$5.line = null; // Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.

function VMessage(reason, position, origin) {
  var parts;
  var range;
  var location;

  if (typeof position === 'string') {
    origin = position;
    position = null;
  }

  parts = parseOrigin(origin);
  range = unistUtilStringifyPosition(position) || '1:1';
  location = {
    start: {
      line: null,
      column: null
    },
    end: {
      line: null,
      column: null
    }
  }; // Node.

  if (position && position.position) {
    position = position.position;
  }

  if (position) {
    // Position.
    if (position.start) {
      location = position;
      position = position.start;
    } else {
      // Point.
      location.start = position;
    }
  }

  if (reason.stack) {
    this.stack = reason.stack;
    reason = reason.message;
  }

  this.message = reason;
  this.name = range;
  this.reason = reason;
  this.line = position ? position.line : null;
  this.column = position ? position.column : null;
  this.location = location;
  this.source = parts[0];
  this.ruleId = parts[1];
}

function parseOrigin(origin) {
  var result = [null, null];
  var index;

  if (typeof origin === 'string') {
    index = origin.indexOf(':');

    if (index === -1) {
      result[1] = origin;
    } else {
      result[0] = origin.slice(0, index);
      result[1] = origin.slice(index + 1);
    }
  }

  return result;
} // Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)


function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;

  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];

    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  } // if the path is allowed to go above the root, restore leading ..s


  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
} // Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.


var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;

var splitPath = function splitPath(filename) {
  return splitPathRe.exec(filename).slice(1);
}; // path.resolve([from ...], to)
// posix version


function resolve() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = i >= 0 ? arguments[i] : '/'; // Skip empty and invalid entries

    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  } // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)
  // Normalize the path


  resolvedPath = normalizeArray(filter$1(resolvedPath.split('/'), function (p) {
    return !!p;
  }), !resolvedAbsolute).join('/');
  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
} // path.normalize(path)
// posix version


function normalize(path) {
  var isPathAbsolute = isAbsolute$1(path),
      trailingSlash = substr$3(path, -1) === '/'; // Normalize the path

  path = normalizeArray(filter$1(path.split('/'), function (p) {
    return !!p;
  }), !isPathAbsolute).join('/');

  if (!path && !isPathAbsolute) {
    path = '.';
  }

  if (path && trailingSlash) {
    path += '/';
  }

  return (isPathAbsolute ? '/' : '') + path;
} // posix version


function isAbsolute$1(path) {
  return path.charAt(0) === '/';
} // posix version


function join() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return normalize(filter$1(paths, function (p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }

    return p;
  }).join('/'));
} // path.relative(from, to)
// posix version


function relative(from, to) {
  from = resolve(from).substr(1);
  to = resolve(to).substr(1);

  function trim(arr) {
    var start = 0;

    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;

    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));
  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;

  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];

  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));
  return outputParts.join('/');
}

var sep = '/';
var delimiter = ':';

function dirname(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
}

function basename(path, ext) {
  var f = splitPath(path)[2]; // TODO: make this comparison case-insensitive on windows?

  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }

  return f;
}

function extname(path) {
  return splitPath(path)[3];
}

var path = {
  extname: extname,
  basename: basename,
  dirname: dirname,
  sep: sep,
  delimiter: delimiter,
  relative: relative,
  join: join,
  isAbsolute: isAbsolute$1,
  normalize: normalize,
  resolve: resolve
};

function filter$1(xs, f) {
  if (xs.filter) return xs.filter(f);
  var res = [];

  for (var i = 0; i < xs.length; i++) {
    if (f(xs[i], i, xs)) res.push(xs[i]);
  }

  return res;
} // String.prototype.substr - negative index don't work in IE8


var substr$3 = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
  return str.substr(start, len);
} : function (str, start, len) {
  if (start < 0) start = str.length + start;
  return str.substr(start, len);
};

function replaceExt(npath, ext) {
  if (typeof npath !== 'string') {
    return npath;
  }

  if (npath.length === 0) {
    return npath;
  }

  var nFileName = path.basename(npath, path.extname(npath)) + ext;
  return path.join(path.dirname(npath), nFileName);
}

var replaceExt_1 = replaceExt;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually

var isBuffer_1$1 = function isBuffer_1$1(obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
} // For Node v0.10 support. Remove this eventually.


function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

var core = VFile;
var own$1 = {}.hasOwnProperty;
var proto$6 = VFile.prototype;
proto$6.toString = toString$5;
/* Order of setting (least specific to most), we need this because
 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
 * is needed before a stem can be set. */

var order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname'];
/* Construct a new file. */

function VFile(options) {
  var prop;
  var index;
  var length;

  if (!options) {
    options = {};
  } else if (typeof options === 'string' || isBuffer_1$1(options)) {
    options = {
      contents: options
    };
  } else if ('message' in options && 'messages' in options) {
    return options;
  }

  if (!(this instanceof VFile)) {
    return new VFile(options);
  }

  this.data = {};
  this.messages = [];
  this.history = [];
  this.cwd = process.cwd();
  /* Set path related properties in the correct order. */

  index = -1;
  length = order.length;

  while (++index < length) {
    prop = order[index];

    if (own$1.call(options, prop)) {
      this[prop] = options[prop];
    }
  }
  /* Set non-path related properties. */


  for (prop in options) {
    if (order.indexOf(prop) === -1) {
      this[prop] = options[prop];
    }
  }
}
/* Access full path (`~/index.min.js`). */


Object.defineProperty(proto$6, 'path', {
  get: function get() {
    return this.history[this.history.length - 1];
  },
  set: function set(path$$1) {
    assertNonEmpty(path$$1, 'path');

    if (path$$1 !== this.path) {
      this.history.push(path$$1);
    }
  }
});
/* Access parent path (`~`). */

Object.defineProperty(proto$6, 'dirname', {
  get: function get() {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
  },
  set: function set(dirname) {
    assertPath(this.path, 'dirname');
    this.path = path.join(dirname || '', this.basename);
  }
});
/* Access basename (`index.min.js`). */

Object.defineProperty(proto$6, 'basename', {
  get: function get() {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
  },
  set: function set(basename) {
    assertNonEmpty(basename, 'basename');
    assertPart(basename, 'basename');
    this.path = path.join(this.dirname || '', basename);
  }
});
/* Access extname (`.js`). */

Object.defineProperty(proto$6, 'extname', {
  get: function get() {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
  },
  set: function set(extname) {
    var ext = extname || '';
    assertPart(ext, 'extname');
    assertPath(this.path, 'extname');

    if (ext) {
      if (ext.charAt(0) !== '.') {
        throw new Error('`extname` must start with `.`');
      }

      if (ext.indexOf('.', 1) !== -1) {
        throw new Error('`extname` cannot contain multiple dots');
      }
    }

    this.path = replaceExt_1(this.path, ext);
  }
});
/* Access stem (`index.min`). */

Object.defineProperty(proto$6, 'stem', {
  get: function get() {
    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
  },
  set: function set(stem) {
    assertNonEmpty(stem, 'stem');
    assertPart(stem, 'stem');
    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
  }
});
/* Get the value of the file. */

function toString$5(encoding) {
  var value = this.contents || '';
  return isBuffer_1$1(value) ? value.toString(encoding) : String(value);
}
/* Assert that `part` is not a path (i.e., does
 * not contain `path.sep`). */


function assertPart(part, name) {
  if (part.indexOf(path.sep) !== -1) {
    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
  }
}
/* Assert that `part` is not empty. */


function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty');
  }
}
/* Assert `path` exists. */


function assertPath(path$$1, name) {
  if (!path$$1) {
    throw new Error('Setting `' + name + '` requires `path` to be set too');
  }
}

var vfile = core;
var proto$7 = core.prototype;
proto$7.message = message;
proto$7.info = info;
proto$7.fail = fail;
/* Slight backwards compatibility.  Remove in the future. */

proto$7.warn = message;
/* Create a message with `reason` at `position`.
 * When an error is passed in as `reason`, copies the stack. */

function message(reason, position, origin) {
  var filePath = this.path;
  var message = new vfileMessage(reason, position, origin);

  if (filePath) {
    message.name = filePath + ':' + message.name;
    message.file = filePath;
  }

  message.fatal = false;
  this.messages.push(message);
  return message;
}
/* Fail. Creates a vmessage, associates it with the file,
 * and throws it. */


function fail() {
  var message = this.message.apply(this, arguments);
  message.fatal = true;
  throw message;
}
/* Info. Creates a vmessage, associates it with the file,
 * and marks the fatality as null. */


function info() {
  var message = this.message.apply(this, arguments);
  message.fatal = null;
  return message;
}

var slice$1 = [].slice;
var wrap_1 = wrap$3;
/* Wrap `fn`.  Can be sync or async; return a promise,
 * receive a completion handler, return new values and
 * errors. */

function wrap$3(fn, callback) {
  var invoked;
  return wrapped;

  function wrapped() {
    var params = slice$1.call(arguments, 0);
    var callback = fn.length > params.length;
    var result;

    if (callback) {
      params.push(done);
    }

    try {
      result = fn.apply(null, params);
    } catch (err) {
      /* Well, this is quite the pickle.  `fn` received
       * a callback and invoked it (thus continuing the
       * pipeline), but later also threw an error.
       * We’re not about to restart the pipeline again,
       * so the only thing left to do is to throw the
       * thing instea. */
      if (callback && invoked) {
        throw err;
      }

      return done(err);
    }

    if (!callback) {
      if (result && typeof result.then === 'function') {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }
  /* Invoke `next`, only once. */


  function done() {
    if (!invoked) {
      invoked = true;
      callback.apply(null, arguments);
    }
  }
  /* Invoke `done` with one value.
   * Tracks if an error is passed, too. */


  function then(value) {
    done(null, value);
  }
}

var trough_1 = trough;
trough.wrap = wrap_1;
var slice$2 = [].slice;
/* Create new middleware. */

function trough() {
  var fns = [];
  var middleware = {};
  middleware.run = run;
  middleware.use = use;
  return middleware;
  /* Run `fns`.  Last argument must be
   * a completion handler. */

  function run() {
    var index = -1;
    var input = slice$2.call(arguments, 0, -1);
    var done = arguments[arguments.length - 1];

    if (typeof done !== 'function') {
      throw new Error('Expected function as last argument, not ' + done);
    }

    next.apply(null, [null].concat(input));
    /* Run the next `fn`, if any. */

    function next(err) {
      var fn = fns[++index];
      var params = slice$2.call(arguments, 0);
      var values = params.slice(1);
      var length = input.length;
      var pos = -1;

      if (err) {
        done(err);
        return;
      }
      /* Copy non-nully input into values. */


      while (++pos < length) {
        if (values[pos] === null || values[pos] === undefined) {
          values[pos] = input[pos];
        }
      }

      input = values;
      /* Next or done. */

      if (fn) {
        wrap_1(fn, next).apply(null, input);
      } else {
        done.apply(null, [null].concat(input));
      }
    }
  }
  /* Add `fn` to the list. */


  function use(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Expected `fn` to be a function, not ' + fn);
    }

    fns.push(fn);
    return middleware;
  }
}

var toString$6 = Object.prototype.toString;
var xIsString = isString$1;

function isString$1(obj) {
  return toString$6.call(obj) === "[object String]";
}

var toString$7 = Object.prototype.toString;

var isPlainObj = function isPlainObj(x) {
  var prototype;
  return toString$7.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};
/* Dependencies. */

/* Expose a frozen processor. */


var unified_1 = unified().freeze();
var slice$3 = [].slice;
var own$2 = {}.hasOwnProperty;
/* Process pipeline. */

var pipeline = trough_1().use(pipelineParse).use(pipelineRun).use(pipelineStringify);

function pipelineParse(p, ctx) {
  ctx.tree = p.parse(ctx.file);
}

function pipelineRun(p, ctx, next) {
  p.run(ctx.tree, ctx.file, done);

  function done(err, tree, file) {
    if (err) {
      next(err);
    } else {
      ctx.tree = tree;
      ctx.file = file;
      next();
    }
  }
}

function pipelineStringify(p, ctx) {
  ctx.file.contents = p.stringify(ctx.tree, ctx.file);
}
/* Function to create the first processor. */


function unified() {
  var attachers = [];
  var transformers = trough_1();
  var namespace = {};
  var frozen = false;
  var freezeIndex = -1;
  /* Data management. */

  processor.data = data;
  /* Lock. */

  processor.freeze = freeze;
  /* Plug-ins. */

  processor.attachers = attachers;
  processor.use = use;
  /* API. */

  processor.parse = parse;
  processor.stringify = stringify;
  processor.run = run;
  processor.runSync = runSync;
  processor.process = process;
  processor.processSync = processSync;
  /* Expose. */

  return processor;
  /* Create a new processor based on the processor
   * in the current scope. */

  function processor() {
    var destination = unified();
    var length = attachers.length;
    var index = -1;

    while (++index < length) {
      destination.use.apply(null, attachers[index]);
    }

    destination.data(extend$1(true, {}, namespace));
    return destination;
  }
  /* Freeze: used to signal a processor that has finished
   * configuration.
   *
   * For example, take unified itself.  It’s frozen.
   * Plug-ins should not be added to it.  Rather, it should
   * be extended, by invoking it, before modifying it.
   *
   * In essence, always invoke this when exporting a
   * processor. */


  function freeze() {
    var values;
    var plugin;
    var options;
    var transformer;

    if (frozen) {
      return processor;
    }

    while (++freezeIndex < attachers.length) {
      values = attachers[freezeIndex];
      plugin = values[0];
      options = values[1];
      transformer = null;

      if (options === false) {
        continue;
      }

      if (options === true) {
        values[1] = undefined;
      }

      transformer = plugin.apply(processor, values.slice(1));

      if (typeof transformer === 'function') {
        transformers.use(transformer);
      }
    }

    frozen = true;
    freezeIndex = Infinity;
    return processor;
  }
  /* Data management.
   * Getter / setter for processor-specific informtion. */


  function data(key, value) {
    if (xIsString(key)) {
      /* Set `key`. */
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen);
        namespace[key] = value;
        return processor;
      }
      /* Get `key`. */


      return own$2.call(namespace, key) && namespace[key] || null;
    }
    /* Set space. */


    if (key) {
      assertUnfrozen('data', frozen);
      namespace = key;
      return processor;
    }
    /* Get space. */


    return namespace;
  }
  /* Plug-in management.
   *
   * Pass it:
   * *   an attacher and options,
   * *   a preset,
   * *   a list of presets, attachers, and arguments (list
   *     of attachers and options). */


  function use(value) {
    var settings;
    assertUnfrozen('use', frozen);
    if (value === null || value === undefined) ;else if (typeof value === 'function') {
      addPlugin.apply(null, arguments);
    } else if (typeof value === 'object') {
      if ('length' in value) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new Error('Expected usable value, not `' + value + '`');
    }

    if (settings) {
      namespace.settings = extend$1(namespace.settings || {}, settings);
    }

    return processor;

    function addPreset(result) {
      addList(result.plugins);

      if (result.settings) {
        settings = extend$1(settings || {}, result.settings);
      }
    }

    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value);
      } else if (typeof value === 'object') {
        if ('length' in value) {
          addPlugin.apply(null, value);
        } else {
          addPreset(value);
        }
      } else {
        throw new Error('Expected usable value, not `' + value + '`');
      }
    }

    function addList(plugins) {
      var length;
      var index;
      if (plugins === null || plugins === undefined) ;else if (typeof plugins === 'object' && 'length' in plugins) {
        length = plugins.length;
        index = -1;

        while (++index < length) {
          add(plugins[index]);
        }
      } else {
        throw new Error('Expected a list of plugins, not `' + plugins + '`');
      }
    }

    function addPlugin(plugin, value) {
      var entry = find(plugin);

      if (entry) {
        if (isPlainObj(entry[1]) && isPlainObj(value)) {
          value = extend$1(entry[1], value);
        }

        entry[1] = value;
      } else {
        attachers.push(slice$3.call(arguments));
      }
    }
  }

  function find(plugin) {
    var length = attachers.length;
    var index = -1;
    var entry;

    while (++index < length) {
      entry = attachers[index];

      if (entry[0] === plugin) {
        return entry;
      }
    }
  }
  /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the
   * processor. */


  function parse(doc) {
    var file = vfile(doc);
    var Parser;
    freeze();
    Parser = processor.Parser;
    assertParser('parse', Parser);

    if (newable(Parser)) {
      return new Parser(String(file), file).parse();
    }

    return Parser(String(file), file); // eslint-disable-line new-cap
  }
  /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), async. */


  function run(node, file, cb) {
    assertNode(node);
    freeze();

    if (!cb && typeof file === 'function') {
      cb = file;
      file = null;
    }

    if (!cb) {
      return new Promise(executor);
    }

    executor(null, cb);

    function executor(resolve, reject) {
      transformers.run(node, vfile(file), done);

      function done(err, tree, file) {
        tree = tree || node;

        if (err) {
          reject(err);
        } else if (resolve) {
          resolve(tree);
        } else {
          cb(null, tree, file);
        }
      }
    }
  }
  /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), sync. */


  function runSync(node, file) {
    var complete = false;
    var result;
    run(node, file, done);
    assertDone('runSync', 'run', complete);
    return result;

    function done(err, tree) {
      complete = true;
      bail_1(err);
      result = tree;
    }
  }
  /* Stringify a Unist node representation of a file
   * (in string or VFile representation) into a string
   * using the `Compiler` on the processor. */


  function stringify(node, doc) {
    var file = vfile(doc);
    var Compiler;
    freeze();
    Compiler = processor.Compiler;
    assertCompiler('stringify', Compiler);
    assertNode(node);

    if (newable(Compiler)) {
      return new Compiler(node, file).compile();
    }

    return Compiler(node, file); // eslint-disable-line new-cap
  }
  /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the processor,
   * then run transforms on that node, and compile the
   * resulting node using the `Compiler` on the processor,
   * and store that result on the VFile. */


  function process(doc, cb) {
    freeze();
    assertParser('process', processor.Parser);
    assertCompiler('process', processor.Compiler);

    if (!cb) {
      return new Promise(executor);
    }

    executor(null, cb);

    function executor(resolve, reject) {
      var file = vfile(doc);
      pipeline.run(processor, {
        file: file
      }, done);

      function done(err) {
        if (err) {
          reject(err);
        } else if (resolve) {
          resolve(file);
        } else {
          cb(null, file);
        }
      }
    }
  }
  /* Process the given document (in string or VFile
   * representation), sync. */


  function processSync(doc) {
    var complete = false;
    var file;
    freeze();
    assertParser('processSync', processor.Parser);
    assertCompiler('processSync', processor.Compiler);
    file = vfile(doc);
    process(file, done);
    assertDone('processSync', 'process', complete);
    return file;

    function done(err) {
      complete = true;
      bail_1(err);
    }
  }
}
/* Check if `func` is a constructor. */


function newable(value) {
  return typeof value === 'function' && keys$6(value.prototype);
}
/* Check if `value` is an object with keys. */


function keys$6(value) {
  var key;

  for (key in value) {
    return true;
  }

  return false;
}
/* Assert a parser is available. */


function assertParser(name, Parser) {
  if (typeof Parser !== 'function') {
    throw new Error('Cannot `' + name + '` without `Parser`');
  }
}
/* Assert a compiler is available. */


function assertCompiler(name, Compiler) {
  if (typeof Compiler !== 'function') {
    throw new Error('Cannot `' + name + '` without `Compiler`');
  }
}
/* Assert the processor is not frozen. */


function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(['Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ', 'processor first, by invoking it: use `processor()` instead of ', '`processor`.'].join(''));
  }
}
/* Assert `node` is a Unist node. */


function assertNode(node) {
  if (!node || !xIsString(node.type)) {
    throw new Error('Expected node, got `' + node + '`');
  }
}
/* Assert that `complete` is `true`. */


function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
  }
} // shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js


function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}

function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}

var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;

if (typeof global.setTimeout === 'function') {
  cachedSetTimeout = setTimeout;
}

if (typeof global.clearTimeout === 'function') {
  cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  } // if setTimeout wasn't available but was latter defined


  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}

function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  } // if clearTimeout wasn't available but was latter defined


  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}

var queue$2 = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }

  draining = false;

  if (currentQueue.length) {
    queue$2 = currentQueue.concat(queue$2);
  } else {
    queueIndex = -1;
  }

  if (queue$2.length) {
    drainQueue();
  }
}

function drainQueue() {
  if (draining) {
    return;
  }

  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue$2.length;

  while (len) {
    currentQueue = queue$2;
    queue$2 = [];

    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }

    queueIndex = -1;
    len = queue$2.length;
  }

  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}

function nextTick(fun) {
  var args = new Array(arguments.length - 1);

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }

  queue$2.push(new Item(fun, args));

  if (queue$2.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
} // v8 likes predictible objects


function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}

Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};

var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues

var versions$1 = {};
var release = {};
var config = {};

function noop$3() {}

var on = noop$3;
var addListener = noop$3;
var once = noop$3;
var off = noop$3;
var removeListener = noop$3;
var removeAllListeners = noop$3;
var emit = noop$3;

function binding(name) {
  throw new Error('process.binding is not supported');
}

function cwd() {
  return '/';
}

function chdir(dir) {
  throw new Error('process.chdir is not supported');
}

function umask() {
  return 0;
} // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js


var performance$1 = global.performance || {};

var performanceNow = performance$1.now || performance$1.mozNow || performance$1.msNow || performance$1.oNow || performance$1.webkitNow || function () {
  return new Date().getTime();
}; // generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime


function hrtime(previousTimestamp) {
  var clocktime = performanceNow.call(performance$1) * 1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor(clocktime % 1 * 1e9);

  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];

    if (nanoseconds < 0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }

  return [seconds, nanoseconds];
}

var startTime = new Date();

function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var process$4 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions$1,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
}; // Copyright Joyent, Inc. and other Node contributors.

var formatRegExp = /%[sdj%]/g;

function format(f) {
  if (!isString$2(f)) {
    var objects = [];

    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }

    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function (x) {
    if (x === '%%') return '%';
    if (i >= len) return x;

    switch (x) {
      case '%s':
        return String(args[i++]);

      case '%d':
        return Number(args[i++]);

      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }

      default:
        return x;
    }
  });

  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject$1(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }

  return str;
} // Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.


function deprecate(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function () {
      return deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;

  function deprecated() {
    if (!warned) {
      {
        console.error(msg);
      }
      warned = true;
    }

    return fn.apply(this, arguments);
  }

  return deprecated;
}

var debugs = {};
var debugEnviron;

function debuglog(set) {
  if (isUndefined(debugEnviron)) debugEnviron = process$4.env.NODE_DEBUG || '';
  set = set.toUpperCase();

  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = 0;

      debugs[set] = function () {
        var msg = format.apply(null, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function () {};
    }
  }

  return debugs[set];
}
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */

/* legacy: obj, showHidden, depth, colors*/


function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  }; // legacy...

  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];

  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    _extend(ctx, opts);
  } // set default options


  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
} // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics


inspect.colors = {
  'bold': [1, 22],
  'italic': [3, 23],
  'underline': [4, 24],
  'inverse': [7, 27],
  'white': [37, 39],
  'grey': [90, 39],
  'black': [30, 39],
  'blue': [34, 39],
  'cyan': [36, 39],
  'green': [32, 39],
  'magenta': [35, 39],
  'red': [31, 39],
  'yellow': [33, 39]
}; // Don't use 'blue' not visible on cmd.exe

inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};

function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}

function stylizeNoColor(str, styleType) {
  return str;
}

function arrayToHash(array) {
  var hash = {};
  array.forEach(function (val, idx) {
    hash[val] = true;
  });
  return hash;
}

function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect && value && isFunction$1(value.inspect) && // Filter out the util module, it's inspect function is special
  value.inspect !== inspect && // Also filter out any prototype objects using the circular check.
  !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);

    if (!isString$2(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }

    return ret;
  } // Primitive types cannot have properties


  var primitive = formatPrimitive(ctx, value);

  if (primitive) {
    return primitive;
  } // Look up the keys of the object.


  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  } // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx


  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  } // Some type of object without properties can be shortcutted.


  if (keys.length === 0) {
    if (isFunction$1(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }

    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }

    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }

    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '',
      array = false,
      braces = ['{', '}']; // Make Array say that they are Array

  if (isArray$2(value)) {
    array = true;
    braces = ['[', ']'];
  } // Make functions say that they are functions


  if (isFunction$1(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  } // Make RegExps say that they are RegExps


  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  } // Make dates with properties first say the date


  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  } // Make error with message first say the error


  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);
  var output;

  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function (key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();
  return reduceToSingleString(output, base, braces);
}

function formatPrimitive(ctx, value) {
  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');

  if (isString$2(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }

  if (isNumber$1(value)) return ctx.stylize('' + value, 'number');
  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.

  if (isNull(value)) return ctx.stylize('null', 'null');
}

function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}

function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];

  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty$h(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    } else {
      output.push('');
    }
  }

  keys.forEach(function (key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    }
  });
  return output;
}

function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || {
    value: value[key]
  };

  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }

  if (!hasOwnProperty$h(visibleKeys, key)) {
    name = '[' + key + ']';
  }

  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }

      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function (line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function (line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }

  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }

    name = JSON.stringify('' + key);

    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}

function reduceToSingleString(output, base, braces) {
  var length = output.reduce(function (prev, cur) {
    if (cur.indexOf('\n') >= 0) ;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
} // NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.


function isArray$2(ar) {
  return Array.isArray(ar);
}

function isBoolean(arg) {
  return typeof arg === 'boolean';
}

function isNull(arg) {
  return arg === null;
}

function isNullOrUndefined(arg) {
  return arg == null;
}

function isNumber$1(arg) {
  return typeof arg === 'number';
}

function isString$2(arg) {
  return typeof arg === 'string';
}

function isSymbol$3(arg) {
  return typeof arg === 'symbol';
}

function isUndefined(arg) {
  return arg === void 0;
}

function isRegExp(re) {
  return isObject$1(re) && objectToString$1(re) === '[object RegExp]';
}

function isObject$1(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isDate(d) {
  return isObject$1(d) && objectToString$1(d) === '[object Date]';
}

function isError(e) {
  return isObject$1(e) && (objectToString$1(e) === '[object Error]' || e instanceof Error);
}

function isFunction$1(arg) {
  return typeof arg === 'function';
}

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}

function isBuffer$1(maybeBuf) {
  return Buffer.isBuffer(maybeBuf);
}

function objectToString$1(o) {
  return Object.prototype.toString.call(o);
}

function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; // 26 Feb 16:19:34

function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
} // log is just a thin wrapper to console.log that prepends a timestamp


function log$1() {
  console.log('%s - %s', timestamp(), format.apply(null, arguments));
}

function _extend(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject$1(add)) return origin;
  var keys = Object.keys(add);
  var i = keys.length;

  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }

  return origin;
}

function hasOwnProperty$h(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var require$$0$1 = {
  inherits: inherits$4,
  _extend: _extend,
  log: log$1,
  isBuffer: isBuffer$1,
  isPrimitive: isPrimitive,
  isFunction: isFunction$1,
  isError: isError,
  isDate: isDate,
  isObject: isObject$1,
  isRegExp: isRegExp,
  isUndefined: isUndefined,
  isSymbol: isSymbol$3,
  isString: isString$2,
  isNumber: isNumber$1,
  isNullOrUndefined: isNullOrUndefined,
  isNull: isNull,
  isBoolean: isBoolean,
  isArray: isArray$2,
  inspect: inspect,
  deprecate: deprecate,
  format: format,
  debuglog: debuglog
};
var inherits_browser = createCommonjsModule(function (module) {
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;

      var TempCtor = function TempCtor() {};

      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
});
var inherits$5 = createCommonjsModule(function (module) {
  try {
    var util = require$$0$1;
    if (typeof util.inherits !== 'function') throw '';
    module.exports = util.inherits;
  } catch (e) {
    module.exports = inherits_browser;
  }
});
var unherit_1 = unherit;
/* Create a custom constructor which can be modified
 * without affecting the original class. */

function unherit(Super) {
  var result;
  var key;
  var value;
  inherits$5(Of, Super);
  inherits$5(From, Of);
  /* Clone values. */

  result = Of.prototype;

  for (key in result) {
    value = result[key];

    if (value && typeof value === 'object') {
      result[key] = 'concat' in value ? value.concat() : immutable$1(value);
    }
  }

  return Of;
  /* Constructor accepting a single argument,
   * which itself is an `arguments` object. */

  function From(parameters) {
    return Super.apply(this, parameters);
  }
  /* Constructor accepting variadic arguments. */


  function Of() {
    if (!(this instanceof Of)) {
      return new From(arguments);
    }

    return Super.apply(this, arguments);
  }
}

var stateToggle = factory;
/* Construct a state `toggler`: a function which inverses
 * `property` in context based on its current value.
 * The by `toggler` returned function restores that value. */

function factory(key, state, ctx) {
  return enter;

  function enter() {
    var context = ctx || this;
    var current = context[key];
    context[key] = !state;
    return exit;

    function exit() {
      context[key] = current;
    }
  }
}

var vfileLocation = factory$1;

function factory$1(file) {
  var contents = indices(String(file));
  return {
    toPosition: offsetToPositionFactory(contents),
    toOffset: positionToOffsetFactory(contents)
  };
} // Factory to get the line and column-based `position` for `offset` in the bound
// indices.


function offsetToPositionFactory(indices) {
  return offsetToPosition; // Get the line and column-based `position` for `offset` in the bound indices.

  function offsetToPosition(offset) {
    var index = -1;
    var length = indices.length;

    if (offset < 0) {
      return {};
    }

    while (++index < length) {
      if (indices[index] > offset) {
        return {
          line: index + 1,
          column: offset - (indices[index - 1] || 0) + 1,
          offset: offset
        };
      }
    }

    return {};
  }
} // Factory to get the `offset` for a line and column-based `position` in the
// bound indices.


function positionToOffsetFactory(indices) {
  return positionToOffset; // Get the `offset` for a line and column-based `position` in the bound
  // indices.

  function positionToOffset(position) {
    var line = position && position.line;
    var column = position && position.column;

    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
      return (indices[line - 2] || 0) + column - 1 || 0;
    }

    return -1;
  }
} // Get indices of line-breaks in `value`.


function indices(value) {
  var result = [];
  var index = value.indexOf('\n');

  while (index !== -1) {
    result.push(index + 1);
    index = value.indexOf('\n', index + 1);
  }

  result.push(value.length + 1);
  return result;
}

var _unescape = factory$2;
/* Factory to de-escape a value, based on a list at `key`
 * in `ctx`. */

function factory$2(ctx, key) {
  return unescape;
  /* De-escape a string using the expression at `key`
   * in `ctx`. */

  function unescape(value) {
    var prev = 0;
    var index = value.indexOf('\\');
    var escape = ctx[key];
    var queue = [];
    var character;

    while (index !== -1) {
      queue.push(value.slice(prev, index));
      prev = index + 1;
      character = value.charAt(prev);
      /* If the following character is not a valid escape,
       * add the slash. */

      if (!character || escape.indexOf(character) === -1) {
        queue.push('\\');
      }

      index = value.indexOf('\\', prev);
    }

    queue.push(value.slice(prev));
    return queue.join('');
  }
}

var AElig = "Æ";
var AMP = "&";
var Aacute = "Á";
var Acirc = "Â";
var Agrave = "À";
var Aring = "Å";
var Atilde = "Ã";
var Auml = "Ä";
var COPY = "©";
var Ccedil = "Ç";
var ETH = "Ð";
var Eacute = "É";
var Ecirc = "Ê";
var Egrave = "È";
var Euml = "Ë";
var GT = ">";
var Iacute = "Í";
var Icirc = "Î";
var Igrave = "Ì";
var Iuml = "Ï";
var LT = "<";
var Ntilde = "Ñ";
var Oacute = "Ó";
var Ocirc = "Ô";
var Ograve = "Ò";
var Oslash = "Ø";
var Otilde = "Õ";
var Ouml = "Ö";
var QUOT = "\"";
var REG = "®";
var THORN = "Þ";
var Uacute = "Ú";
var Ucirc = "Û";
var Ugrave = "Ù";
var Uuml = "Ü";
var Yacute = "Ý";
var aacute = "á";
var acirc = "â";
var acute = "´";
var aelig = "æ";
var agrave = "à";
var amp = "&";
var aring = "å";
var atilde = "ã";
var auml = "ä";
var brvbar = "¦";
var ccedil = "ç";
var cedil = "¸";
var cent = "¢";
var copy = "©";
var curren = "¤";
var deg = "°";
var divide$1 = "÷";
var eacute = "é";
var ecirc = "ê";
var egrave = "è";
var eth = "ð";
var euml = "ë";
var frac12 = "½";
var frac14 = "¼";
var frac34 = "¾";
var gt = ">";
var iacute = "í";
var icirc = "î";
var iexcl = "¡";
var igrave = "ì";
var iquest = "¿";
var iuml = "ï";
var laquo = "«";
var lt = "<";
var macr = "¯";
var micro = "µ";
var middot = "·";
var nbsp = " ";
var not = "¬";
var ntilde = "ñ";
var oacute = "ó";
var ocirc = "ô";
var ograve = "ò";
var ordf = "ª";
var ordm = "º";
var oslash = "ø";
var otilde = "õ";
var ouml = "ö";
var para = "¶";
var plusmn = "±";
var pound = "£";
var quot$1 = "\"";
var raquo = "»";
var reg = "®";
var sect = "§";
var shy = "­";
var sup1 = "¹";
var sup2 = "²";
var sup3 = "³";
var szlig = "ß";
var thorn = "þ";
var times = "×";
var uacute = "ú";
var ucirc = "û";
var ugrave = "ù";
var uml = "¨";
var uuml = "ü";
var yacute = "ý";
var yen = "¥";
var yuml = "ÿ";
var index$c = {
  AElig: AElig,
  AMP: AMP,
  Aacute: Aacute,
  Acirc: Acirc,
  Agrave: Agrave,
  Aring: Aring,
  Atilde: Atilde,
  Auml: Auml,
  COPY: COPY,
  Ccedil: Ccedil,
  ETH: ETH,
  Eacute: Eacute,
  Ecirc: Ecirc,
  Egrave: Egrave,
  Euml: Euml,
  GT: GT,
  Iacute: Iacute,
  Icirc: Icirc,
  Igrave: Igrave,
  Iuml: Iuml,
  LT: LT,
  Ntilde: Ntilde,
  Oacute: Oacute,
  Ocirc: Ocirc,
  Ograve: Ograve,
  Oslash: Oslash,
  Otilde: Otilde,
  Ouml: Ouml,
  QUOT: QUOT,
  REG: REG,
  THORN: THORN,
  Uacute: Uacute,
  Ucirc: Ucirc,
  Ugrave: Ugrave,
  Uuml: Uuml,
  Yacute: Yacute,
  aacute: aacute,
  acirc: acirc,
  acute: acute,
  aelig: aelig,
  agrave: agrave,
  amp: amp,
  aring: aring,
  atilde: atilde,
  auml: auml,
  brvbar: brvbar,
  ccedil: ccedil,
  cedil: cedil,
  cent: cent,
  copy: copy,
  curren: curren,
  deg: deg,
  divide: divide$1,
  eacute: eacute,
  ecirc: ecirc,
  egrave: egrave,
  eth: eth,
  euml: euml,
  frac12: frac12,
  frac14: frac14,
  frac34: frac34,
  gt: gt,
  iacute: iacute,
  icirc: icirc,
  iexcl: iexcl,
  igrave: igrave,
  iquest: iquest,
  iuml: iuml,
  laquo: laquo,
  lt: lt,
  macr: macr,
  micro: micro,
  middot: middot,
  nbsp: nbsp,
  not: not,
  ntilde: ntilde,
  oacute: oacute,
  ocirc: ocirc,
  ograve: ograve,
  ordf: ordf,
  ordm: ordm,
  oslash: oslash,
  otilde: otilde,
  ouml: ouml,
  para: para,
  plusmn: plusmn,
  pound: pound,
  quot: quot$1,
  raquo: raquo,
  reg: reg,
  sect: sect,
  shy: shy,
  sup1: sup1,
  sup2: sup2,
  sup3: sup3,
  szlig: szlig,
  thorn: thorn,
  times: times,
  uacute: uacute,
  ucirc: ucirc,
  ugrave: ugrave,
  uml: uml,
  uuml: uuml,
  yacute: yacute,
  yen: yen,
  yuml: yuml
};
var characterEntitiesLegacy =
/*#__PURE__*/
Object.freeze({
  AElig: AElig,
  AMP: AMP,
  Aacute: Aacute,
  Acirc: Acirc,
  Agrave: Agrave,
  Aring: Aring,
  Atilde: Atilde,
  Auml: Auml,
  COPY: COPY,
  Ccedil: Ccedil,
  ETH: ETH,
  Eacute: Eacute,
  Ecirc: Ecirc,
  Egrave: Egrave,
  Euml: Euml,
  GT: GT,
  Iacute: Iacute,
  Icirc: Icirc,
  Igrave: Igrave,
  Iuml: Iuml,
  LT: LT,
  Ntilde: Ntilde,
  Oacute: Oacute,
  Ocirc: Ocirc,
  Ograve: Ograve,
  Oslash: Oslash,
  Otilde: Otilde,
  Ouml: Ouml,
  QUOT: QUOT,
  REG: REG,
  THORN: THORN,
  Uacute: Uacute,
  Ucirc: Ucirc,
  Ugrave: Ugrave,
  Uuml: Uuml,
  Yacute: Yacute,
  aacute: aacute,
  acirc: acirc,
  acute: acute,
  aelig: aelig,
  agrave: agrave,
  amp: amp,
  aring: aring,
  atilde: atilde,
  auml: auml,
  brvbar: brvbar,
  ccedil: ccedil,
  cedil: cedil,
  cent: cent,
  copy: copy,
  curren: curren,
  deg: deg,
  divide: divide$1,
  eacute: eacute,
  ecirc: ecirc,
  egrave: egrave,
  eth: eth,
  euml: euml,
  frac12: frac12,
  frac14: frac14,
  frac34: frac34,
  gt: gt,
  iacute: iacute,
  icirc: icirc,
  iexcl: iexcl,
  igrave: igrave,
  iquest: iquest,
  iuml: iuml,
  laquo: laquo,
  lt: lt,
  macr: macr,
  micro: micro,
  middot: middot,
  nbsp: nbsp,
  not: not,
  ntilde: ntilde,
  oacute: oacute,
  ocirc: ocirc,
  ograve: ograve,
  ordf: ordf,
  ordm: ordm,
  oslash: oslash,
  otilde: otilde,
  ouml: ouml,
  para: para,
  plusmn: plusmn,
  pound: pound,
  quot: quot$1,
  raquo: raquo,
  reg: reg,
  sect: sect,
  shy: shy,
  sup1: sup1,
  sup2: sup2,
  sup3: sup3,
  szlig: szlig,
  thorn: thorn,
  times: times,
  uacute: uacute,
  ucirc: ucirc,
  ugrave: ugrave,
  uml: uml,
  uuml: uuml,
  yacute: yacute,
  yen: yen,
  yuml: yuml,
  default: index$c
});
var index$d = {
  "0": "�",
  "128": "€",
  "130": "‚",
  "131": "ƒ",
  "132": "„",
  "133": "…",
  "134": "†",
  "135": "‡",
  "136": "ˆ",
  "137": "‰",
  "138": "Š",
  "139": "‹",
  "140": "Œ",
  "142": "Ž",
  "145": "‘",
  "146": "’",
  "147": "“",
  "148": "”",
  "149": "•",
  "150": "–",
  "151": "—",
  "152": "˜",
  "153": "™",
  "154": "š",
  "155": "›",
  "156": "œ",
  "158": "ž",
  "159": "Ÿ"
};
var characterReferenceInvalid =
/*#__PURE__*/
Object.freeze({
  default: index$d
});
var isDecimal = decimal;
/* Check if the given character code, or the character
 * code at the first character, is decimal. */

function decimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character;
  return code >= 48 && code <= 57;
  /* 0-9 */
}

var isHexadecimal = hexadecimal;
/* Check if the given character code, or the character
 * code at the first character, is hexadecimal. */

function hexadecimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character;
  return code >= 97
  /* a */
  && code <= 102 ||
  /* z */
  code >= 65
  /* A */
  && code <= 70
  /* Z */
  || code >= 48
  /* A */
  && code <= 57
  /* Z */
  ;
}

var isAlphabetical = alphabetical;
/* Check if the given character code, or the character
 * code at the first character, is alphabetical. */

function alphabetical(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character;
  return code >= 97 && code <= 122 ||
  /* a-z */
  code >= 65 && code <= 90
  /* A-Z */
  ;
}

var isAlphanumerical = alphanumerical;
/* Check if the given character code, or the character
 * code at the first character, is alphanumerical. */

function alphanumerical(character) {
  return isAlphabetical(character) || isDecimal(character);
}

var AEli = "Æ";
var AElig$1 = "Æ";
var AM = "&";
var AMP$1 = "&";
var Aacut = "Á";
var Aacute$1 = "Á";
var Abreve = "Ă";
var Acir = "Â";
var Acirc$1 = "Â";
var Acy = "А";
var Afr = "𝔄";
var Agrav = "À";
var Agrave$1 = "À";
var Alpha = "Α";
var Amacr = "Ā";
var And = "⩓";
var Aogon = "Ą";
var Aopf = "𝔸";
var ApplyFunction = "⁡";
var Arin = "Å";
var Aring$1 = "Å";
var Ascr = "𝒜";
var Assign = "≔";
var Atild = "Ã";
var Atilde$1 = "Ã";
var Aum = "Ä";
var Auml$1 = "Ä";
var Backslash = "∖";
var Barv = "⫧";
var Barwed = "⌆";
var Bcy = "Б";
var Because = "∵";
var Bernoullis = "ℬ";
var Beta = "Β";
var Bfr = "𝔅";
var Bopf = "𝔹";
var Breve = "˘";
var Bscr = "ℬ";
var Bumpeq = "≎";
var CHcy = "Ч";
var COP = "©";
var COPY$1 = "©";
var Cacute = "Ć";
var Cap = "⋒";
var CapitalDifferentialD = "ⅅ";
var Cayleys = "ℭ";
var Ccaron = "Č";
var Ccedi = "Ç";
var Ccedil$1 = "Ç";
var Ccirc = "Ĉ";
var Cconint = "∰";
var Cdot = "Ċ";
var Cedilla = "¸";
var CenterDot = "·";
var Cfr = "ℭ";
var Chi = "Χ";
var CircleDot = "⊙";
var CircleMinus = "⊖";
var CirclePlus = "⊕";
var CircleTimes = "⊗";
var ClockwiseContourIntegral = "∲";
var CloseCurlyDoubleQuote = "”";
var CloseCurlyQuote = "’";
var Colon = "∷";
var Colone = "⩴";
var Congruent = "≡";
var Conint = "∯";
var ContourIntegral = "∮";
var Copf = "ℂ";
var Coproduct = "∐";
var CounterClockwiseContourIntegral = "∳";
var Cross = "⨯";
var Cscr = "𝒞";
var Cup = "⋓";
var CupCap = "≍";
var DD = "ⅅ";
var DDotrahd = "⤑";
var DJcy = "Ђ";
var DScy = "Ѕ";
var DZcy = "Џ";
var Dagger = "‡";
var Darr = "↡";
var Dashv = "⫤";
var Dcaron = "Ď";
var Dcy = "Д";
var Del = "∇";
var Delta = "Δ";
var Dfr = "𝔇";
var DiacriticalAcute = "´";
var DiacriticalDot = "˙";
var DiacriticalDoubleAcute = "˝";
var DiacriticalGrave = "`";
var DiacriticalTilde = "˜";
var Diamond = "⋄";
var DifferentialD = "ⅆ";
var Dopf = "𝔻";
var Dot = "¨";
var DotDot = "⃜";
var DotEqual = "≐";
var DoubleContourIntegral = "∯";
var DoubleDot = "¨";
var DoubleDownArrow = "⇓";
var DoubleLeftArrow = "⇐";
var DoubleLeftRightArrow = "⇔";
var DoubleLeftTee = "⫤";
var DoubleLongLeftArrow = "⟸";
var DoubleLongLeftRightArrow = "⟺";
var DoubleLongRightArrow = "⟹";
var DoubleRightArrow = "⇒";
var DoubleRightTee = "⊨";
var DoubleUpArrow = "⇑";
var DoubleUpDownArrow = "⇕";
var DoubleVerticalBar = "∥";
var DownArrow = "↓";
var DownArrowBar = "⤓";
var DownArrowUpArrow = "⇵";
var DownBreve = "̑";
var DownLeftRightVector = "⥐";
var DownLeftTeeVector = "⥞";
var DownLeftVector = "↽";
var DownLeftVectorBar = "⥖";
var DownRightTeeVector = "⥟";
var DownRightVector = "⇁";
var DownRightVectorBar = "⥗";
var DownTee = "⊤";
var DownTeeArrow = "↧";
var Downarrow = "⇓";
var Dscr = "𝒟";
var Dstrok = "Đ";
var ENG = "Ŋ";
var ET = "Ð";
var ETH$1 = "Ð";
var Eacut = "É";
var Eacute$1 = "É";
var Ecaron = "Ě";
var Ecir = "Ê";
var Ecirc$1 = "Ê";
var Ecy = "Э";
var Edot = "Ė";
var Efr = "𝔈";
var Egrav = "È";
var Egrave$1 = "È";
var Element$1 = "∈";
var Emacr = "Ē";
var EmptySmallSquare = "◻";
var EmptyVerySmallSquare = "▫";
var Eogon = "Ę";
var Eopf = "𝔼";
var Epsilon = "Ε";
var Equal = "⩵";
var EqualTilde = "≂";
var Equilibrium = "⇌";
var Escr = "ℰ";
var Esim = "⩳";
var Eta = "Η";
var Eum = "Ë";
var Euml$1 = "Ë";
var Exists = "∃";
var ExponentialE = "ⅇ";
var Fcy = "Ф";
var Ffr = "𝔉";
var FilledSmallSquare = "◼";
var FilledVerySmallSquare = "▪";
var Fopf = "𝔽";
var ForAll = "∀";
var Fouriertrf = "ℱ";
var Fscr = "ℱ";
var GJcy = "Ѓ";
var G = ">";
var GT$1 = ">";
var Gamma = "Γ";
var Gammad = "Ϝ";
var Gbreve = "Ğ";
var Gcedil = "Ģ";
var Gcirc = "Ĝ";
var Gcy = "Г";
var Gdot = "Ġ";
var Gfr = "𝔊";
var Gg = "⋙";
var Gopf = "𝔾";
var GreaterEqual = "≥";
var GreaterEqualLess = "⋛";
var GreaterFullEqual = "≧";
var GreaterGreater = "⪢";
var GreaterLess = "≷";
var GreaterSlantEqual = "⩾";
var GreaterTilde = "≳";
var Gscr = "𝒢";
var Gt = "≫";
var HARDcy = "Ъ";
var Hacek = "ˇ";
var Hat = "^";
var Hcirc = "Ĥ";
var Hfr = "ℌ";
var HilbertSpace = "ℋ";
var Hopf = "ℍ";
var HorizontalLine = "─";
var Hscr = "ℋ";
var Hstrok = "Ħ";
var HumpDownHump = "≎";
var HumpEqual = "≏";
var IEcy = "Е";
var IJlig = "Ĳ";
var IOcy = "Ё";
var Iacut = "Í";
var Iacute$1 = "Í";
var Icir = "Î";
var Icirc$1 = "Î";
var Icy = "И";
var Idot = "İ";
var Ifr = "ℑ";
var Igrav = "Ì";
var Igrave$1 = "Ì";
var Im = "ℑ";
var Imacr = "Ī";
var ImaginaryI = "ⅈ";
var Implies = "⇒";
var Int = "∬";
var Integral = "∫";
var Intersection = "⋂";
var InvisibleComma = "⁣";
var InvisibleTimes = "⁢";
var Iogon = "Į";
var Iopf = "𝕀";
var Iota = "Ι";
var Iscr = "ℐ";
var Itilde = "Ĩ";
var Iukcy = "І";
var Ium = "Ï";
var Iuml$1 = "Ï";
var Jcirc = "Ĵ";
var Jcy = "Й";
var Jfr = "𝔍";
var Jopf = "𝕁";
var Jscr = "𝒥";
var Jsercy = "Ј";
var Jukcy = "Є";
var KHcy = "Х";
var KJcy = "Ќ";
var Kappa = "Κ";
var Kcedil = "Ķ";
var Kcy = "К";
var Kfr = "𝔎";
var Kopf = "𝕂";
var Kscr = "𝒦";
var LJcy = "Љ";
var L = "<";
var LT$1 = "<";
var Lacute = "Ĺ";
var Lambda = "Λ";
var Lang = "⟪";
var Laplacetrf = "ℒ";
var Larr = "↞";
var Lcaron = "Ľ";
var Lcedil = "Ļ";
var Lcy = "Л";
var LeftAngleBracket = "⟨";
var LeftArrow = "←";
var LeftArrowBar = "⇤";
var LeftArrowRightArrow = "⇆";
var LeftCeiling = "⌈";
var LeftDoubleBracket = "⟦";
var LeftDownTeeVector = "⥡";
var LeftDownVector = "⇃";
var LeftDownVectorBar = "⥙";
var LeftFloor = "⌊";
var LeftRightArrow = "↔";
var LeftRightVector = "⥎";
var LeftTee = "⊣";
var LeftTeeArrow = "↤";
var LeftTeeVector = "⥚";
var LeftTriangle = "⊲";
var LeftTriangleBar = "⧏";
var LeftTriangleEqual = "⊴";
var LeftUpDownVector = "⥑";
var LeftUpTeeVector = "⥠";
var LeftUpVector = "↿";
var LeftUpVectorBar = "⥘";
var LeftVector = "↼";
var LeftVectorBar = "⥒";
var Leftarrow = "⇐";
var Leftrightarrow = "⇔";
var LessEqualGreater = "⋚";
var LessFullEqual = "≦";
var LessGreater = "≶";
var LessLess = "⪡";
var LessSlantEqual = "⩽";
var LessTilde = "≲";
var Lfr = "𝔏";
var Ll = "⋘";
var Lleftarrow = "⇚";
var Lmidot = "Ŀ";
var LongLeftArrow = "⟵";
var LongLeftRightArrow = "⟷";
var LongRightArrow = "⟶";
var Longleftarrow = "⟸";
var Longleftrightarrow = "⟺";
var Longrightarrow = "⟹";
var Lopf = "𝕃";
var LowerLeftArrow = "↙";
var LowerRightArrow = "↘";
var Lscr = "ℒ";
var Lsh = "↰";
var Lstrok = "Ł";
var Lt = "≪";
var Mcy = "М";
var MediumSpace = " ";
var Mellintrf = "ℳ";
var Mfr = "𝔐";
var MinusPlus = "∓";
var Mopf = "𝕄";
var Mscr = "ℳ";
var Mu = "Μ";
var NJcy = "Њ";
var Nacute = "Ń";
var Ncaron = "Ň";
var Ncedil = "Ņ";
var Ncy = "Н";
var NegativeMediumSpace = "​";
var NegativeThickSpace = "​";
var NegativeThinSpace = "​";
var NegativeVeryThinSpace = "​";
var NestedGreaterGreater = "≫";
var NestedLessLess = "≪";
var NewLine = "\n";
var Nfr = "𝔑";
var NoBreak = "⁠";
var NonBreakingSpace = " ";
var Nopf = "ℕ";
var Not = "⫬";
var NotCongruent = "≢";
var NotCupCap = "≭";
var NotDoubleVerticalBar = "∦";
var NotElement = "∉";
var NotEqual = "≠";
var NotEqualTilde = "≂̸";
var NotExists = "∄";
var NotGreater = "≯";
var NotGreaterEqual = "≱";
var NotGreaterFullEqual = "≧̸";
var NotGreaterGreater = "≫̸";
var NotGreaterLess = "≹";
var NotGreaterSlantEqual = "⩾̸";
var NotGreaterTilde = "≵";
var NotHumpDownHump = "≎̸";
var NotHumpEqual = "≏̸";
var NotLeftTriangle = "⋪";
var NotLeftTriangleBar = "⧏̸";
var NotLeftTriangleEqual = "⋬";
var NotLess = "≮";
var NotLessEqual = "≰";
var NotLessGreater = "≸";
var NotLessLess = "≪̸";
var NotLessSlantEqual = "⩽̸";
var NotLessTilde = "≴";
var NotNestedGreaterGreater = "⪢̸";
var NotNestedLessLess = "⪡̸";
var NotPrecedes = "⊀";
var NotPrecedesEqual = "⪯̸";
var NotPrecedesSlantEqual = "⋠";
var NotReverseElement = "∌";
var NotRightTriangle = "⋫";
var NotRightTriangleBar = "⧐̸";
var NotRightTriangleEqual = "⋭";
var NotSquareSubset = "⊏̸";
var NotSquareSubsetEqual = "⋢";
var NotSquareSuperset = "⊐̸";
var NotSquareSupersetEqual = "⋣";
var NotSubset = "⊂⃒";
var NotSubsetEqual = "⊈";
var NotSucceeds = "⊁";
var NotSucceedsEqual = "⪰̸";
var NotSucceedsSlantEqual = "⋡";
var NotSucceedsTilde = "≿̸";
var NotSuperset = "⊃⃒";
var NotSupersetEqual = "⊉";
var NotTilde = "≁";
var NotTildeEqual = "≄";
var NotTildeFullEqual = "≇";
var NotTildeTilde = "≉";
var NotVerticalBar = "∤";
var Nscr = "𝒩";
var Ntild = "Ñ";
var Ntilde$1 = "Ñ";
var Nu = "Ν";
var OElig = "Œ";
var Oacut = "Ó";
var Oacute$1 = "Ó";
var Ocir = "Ô";
var Ocirc$1 = "Ô";
var Ocy = "О";
var Odblac = "Ő";
var Ofr = "𝔒";
var Ograv = "Ò";
var Ograve$1 = "Ò";
var Omacr = "Ō";
var Omega = "Ω";
var Omicron = "Ο";
var Oopf = "𝕆";
var OpenCurlyDoubleQuote = "“";
var OpenCurlyQuote = "‘";
var Or = "⩔";
var Oscr = "𝒪";
var Oslas = "Ø";
var Oslash$1 = "Ø";
var Otild = "Õ";
var Otilde$1 = "Õ";
var Otimes = "⨷";
var Oum = "Ö";
var Ouml$1 = "Ö";
var OverBar = "‾";
var OverBrace = "⏞";
var OverBracket = "⎴";
var OverParenthesis = "⏜";
var PartialD = "∂";
var Pcy = "П";
var Pfr = "𝔓";
var Phi = "Φ";
var Pi = "Π";
var PlusMinus = "±";
var Poincareplane = "ℌ";
var Popf = "ℙ";
var Pr = "⪻";
var Precedes = "≺";
var PrecedesEqual = "⪯";
var PrecedesSlantEqual = "≼";
var PrecedesTilde = "≾";
var Prime = "″";
var Product = "∏";
var Proportion = "∷";
var Proportional = "∝";
var Pscr = "𝒫";
var Psi = "Ψ";
var QUO = "\"";
var QUOT$1 = "\"";
var Qfr = "𝔔";
var Qopf = "ℚ";
var Qscr = "𝒬";
var RBarr = "⤐";
var RE = "®";
var REG$1 = "®";
var Racute = "Ŕ";
var Rang = "⟫";
var Rarr = "↠";
var Rarrtl = "⤖";
var Rcaron = "Ř";
var Rcedil = "Ŗ";
var Rcy = "Р";
var Re = "ℜ";
var ReverseElement = "∋";
var ReverseEquilibrium = "⇋";
var ReverseUpEquilibrium = "⥯";
var Rfr = "ℜ";
var Rho = "Ρ";
var RightAngleBracket = "⟩";
var RightArrow = "→";
var RightArrowBar = "⇥";
var RightArrowLeftArrow = "⇄";
var RightCeiling = "⌉";
var RightDoubleBracket = "⟧";
var RightDownTeeVector = "⥝";
var RightDownVector = "⇂";
var RightDownVectorBar = "⥕";
var RightFloor = "⌋";
var RightTee = "⊢";
var RightTeeArrow = "↦";
var RightTeeVector = "⥛";
var RightTriangle = "⊳";
var RightTriangleBar = "⧐";
var RightTriangleEqual = "⊵";
var RightUpDownVector = "⥏";
var RightUpTeeVector = "⥜";
var RightUpVector = "↾";
var RightUpVectorBar = "⥔";
var RightVector = "⇀";
var RightVectorBar = "⥓";
var Rightarrow = "⇒";
var Ropf = "ℝ";
var RoundImplies = "⥰";
var Rrightarrow = "⇛";
var Rscr = "ℛ";
var Rsh = "↱";
var RuleDelayed = "⧴";
var SHCHcy = "Щ";
var SHcy = "Ш";
var SOFTcy = "Ь";
var Sacute = "Ś";
var Sc = "⪼";
var Scaron = "Š";
var Scedil = "Ş";
var Scirc = "Ŝ";
var Scy = "С";
var Sfr = "𝔖";
var ShortDownArrow = "↓";
var ShortLeftArrow = "←";
var ShortRightArrow = "→";
var ShortUpArrow = "↑";
var Sigma = "Σ";
var SmallCircle = "∘";
var Sopf = "𝕊";
var Sqrt = "√";
var Square = "□";
var SquareIntersection = "⊓";
var SquareSubset = "⊏";
var SquareSubsetEqual = "⊑";
var SquareSuperset = "⊐";
var SquareSupersetEqual = "⊒";
var SquareUnion = "⊔";
var Sscr = "𝒮";
var Star = "⋆";
var Sub = "⋐";
var Subset = "⋐";
var SubsetEqual = "⊆";
var Succeeds = "≻";
var SucceedsEqual = "⪰";
var SucceedsSlantEqual = "≽";
var SucceedsTilde = "≿";
var SuchThat = "∋";
var Sum$2 = "∑";
var Sup = "⋑";
var Superset = "⊃";
var SupersetEqual = "⊇";
var Supset = "⋑";
var THOR = "Þ";
var THORN$1 = "Þ";
var TRADE = "™";
var TSHcy = "Ћ";
var TScy = "Ц";
var Tab = "\t";
var Tau = "Τ";
var Tcaron = "Ť";
var Tcedil = "Ţ";
var Tcy = "Т";
var Tfr = "𝔗";
var Therefore = "∴";
var Theta = "Θ";
var ThickSpace = "  ";
var ThinSpace = " ";
var Tilde = "∼";
var TildeEqual = "≃";
var TildeFullEqual = "≅";
var TildeTilde = "≈";
var Topf = "𝕋";
var TripleDot = "⃛";
var Tscr = "𝒯";
var Tstrok = "Ŧ";
var Uacut = "Ú";
var Uacute$1 = "Ú";
var Uarr = "↟";
var Uarrocir = "⥉";
var Ubrcy = "Ў";
var Ubreve = "Ŭ";
var Ucir = "Û";
var Ucirc$1 = "Û";
var Ucy = "У";
var Udblac = "Ű";
var Ufr = "𝔘";
var Ugrav = "Ù";
var Ugrave$1 = "Ù";
var Umacr = "Ū";
var UnderBar = "_";
var UnderBrace = "⏟";
var UnderBracket = "⎵";
var UnderParenthesis = "⏝";
var Union = "⋃";
var UnionPlus = "⊎";
var Uogon = "Ų";
var Uopf = "𝕌";
var UpArrow = "↑";
var UpArrowBar = "⤒";
var UpArrowDownArrow = "⇅";
var UpDownArrow = "↕";
var UpEquilibrium = "⥮";
var UpTee = "⊥";
var UpTeeArrow = "↥";
var Uparrow = "⇑";
var Updownarrow = "⇕";
var UpperLeftArrow = "↖";
var UpperRightArrow = "↗";
var Upsi = "ϒ";
var Upsilon = "Υ";
var Uring = "Ů";
var Uscr = "𝒰";
var Utilde = "Ũ";
var Uum = "Ü";
var Uuml$1 = "Ü";
var VDash = "⊫";
var Vbar = "⫫";
var Vcy = "В";
var Vdash = "⊩";
var Vdashl = "⫦";
var Vee = "⋁";
var Verbar = "‖";
var Vert = "‖";
var VerticalBar = "∣";
var VerticalLine = "|";
var VerticalSeparator = "❘";
var VerticalTilde = "≀";
var VeryThinSpace = " ";
var Vfr = "𝔙";
var Vopf = "𝕍";
var Vscr = "𝒱";
var Vvdash = "⊪";
var Wcirc = "Ŵ";
var Wedge = "⋀";
var Wfr = "𝔚";
var Wopf = "𝕎";
var Wscr = "𝒲";
var Xfr = "𝔛";
var Xi = "Ξ";
var Xopf = "𝕏";
var Xscr = "𝒳";
var YAcy = "Я";
var YIcy = "Ї";
var YUcy = "Ю";
var Yacut = "Ý";
var Yacute$1 = "Ý";
var Ycirc = "Ŷ";
var Ycy = "Ы";
var Yfr = "𝔜";
var Yopf = "𝕐";
var Yscr = "𝒴";
var Yuml = "Ÿ";
var ZHcy = "Ж";
var Zacute = "Ź";
var Zcaron = "Ž";
var Zcy = "З";
var Zdot = "Ż";
var ZeroWidthSpace = "​";
var Zeta = "Ζ";
var Zfr = "ℨ";
var Zopf = "ℤ";
var Zscr = "𝒵";
var aacut = "á";
var aacute$1 = "á";
var abreve = "ă";
var ac = "∾";
var acE = "∾̳";
var acd = "∿";
var acir = "â";
var acirc$1 = "â";
var acut = "´";
var acute$1 = "´";
var acy = "а";
var aeli = "æ";
var aelig$1 = "æ";
var af = "⁡";
var afr = "𝔞";
var agrav = "à";
var agrave$1 = "à";
var alefsym = "ℵ";
var aleph = "ℵ";
var alpha = "α";
var amacr = "ā";
var amalg = "⨿";
var am = "&";
var amp$1 = "&";
var and = "∧";
var andand = "⩕";
var andd = "⩜";
var andslope = "⩘";
var andv = "⩚";
var ang = "∠";
var ange = "⦤";
var angle = "∠";
var angmsd = "∡";
var angmsdaa = "⦨";
var angmsdab = "⦩";
var angmsdac = "⦪";
var angmsdad = "⦫";
var angmsdae = "⦬";
var angmsdaf = "⦭";
var angmsdag = "⦮";
var angmsdah = "⦯";
var angrt = "∟";
var angrtvb = "⊾";
var angrtvbd = "⦝";
var angsph = "∢";
var angst = "Å";
var angzarr = "⍼";
var aogon = "ą";
var aopf = "𝕒";
var ap = "≈";
var apE = "⩰";
var apacir = "⩯";
var ape = "≊";
var apid = "≋";
var apos = "'";
var approx = "≈";
var approxeq = "≊";
var arin = "å";
var aring$1 = "å";
var ascr = "𝒶";
var ast = "*";
var asymp = "≈";
var asympeq = "≍";
var atild = "ã";
var atilde$1 = "ã";
var aum = "ä";
var auml$1 = "ä";
var awconint = "∳";
var awint = "⨑";
var bNot = "⫭";
var backcong = "≌";
var backepsilon = "϶";
var backprime = "‵";
var backsim = "∽";
var backsimeq = "⋍";
var barvee = "⊽";
var barwed = "⌅";
var barwedge = "⌅";
var bbrk = "⎵";
var bbrktbrk = "⎶";
var bcong = "≌";
var bcy = "б";
var bdquo = "„";
var becaus = "∵";
var because = "∵";
var bemptyv = "⦰";
var bepsi = "϶";
var bernou = "ℬ";
var beta = "β";
var beth = "ℶ";
var between = "≬";
var bfr = "𝔟";
var bigcap = "⋂";
var bigcirc = "◯";
var bigcup = "⋃";
var bigodot = "⨀";
var bigoplus = "⨁";
var bigotimes = "⨂";
var bigsqcup = "⨆";
var bigstar = "★";
var bigtriangledown = "▽";
var bigtriangleup = "△";
var biguplus = "⨄";
var bigvee = "⋁";
var bigwedge = "⋀";
var bkarow = "⤍";
var blacklozenge = "⧫";
var blacksquare = "▪";
var blacktriangle = "▴";
var blacktriangledown = "▾";
var blacktriangleleft = "◂";
var blacktriangleright = "▸";
var blank = "␣";
var blk12 = "▒";
var blk14 = "░";
var blk34 = "▓";
var block = "█";
var bne = "=⃥";
var bnequiv = "≡⃥";
var bnot = "⌐";
var bopf = "𝕓";
var bot = "⊥";
var bottom = "⊥";
var bowtie = "⋈";
var boxDL = "╗";
var boxDR = "╔";
var boxDl = "╖";
var boxDr = "╓";
var boxH = "═";
var boxHD = "╦";
var boxHU = "╩";
var boxHd = "╤";
var boxHu = "╧";
var boxUL = "╝";
var boxUR = "╚";
var boxUl = "╜";
var boxUr = "╙";
var boxV = "║";
var boxVH = "╬";
var boxVL = "╣";
var boxVR = "╠";
var boxVh = "╫";
var boxVl = "╢";
var boxVr = "╟";
var boxbox = "⧉";
var boxdL = "╕";
var boxdR = "╒";
var boxdl = "┐";
var boxdr = "┌";
var boxh = "─";
var boxhD = "╥";
var boxhU = "╨";
var boxhd = "┬";
var boxhu = "┴";
var boxminus = "⊟";
var boxplus = "⊞";
var boxtimes = "⊠";
var boxuL = "╛";
var boxuR = "╘";
var boxul = "┘";
var boxur = "└";
var boxv = "│";
var boxvH = "╪";
var boxvL = "╡";
var boxvR = "╞";
var boxvh = "┼";
var boxvl = "┤";
var boxvr = "├";
var bprime = "‵";
var breve = "˘";
var brvba = "¦";
var brvbar$1 = "¦";
var bscr = "𝒷";
var bsemi = "⁏";
var bsim = "∽";
var bsime = "⋍";
var bsol = "\\";
var bsolb = "⧅";
var bsolhsub = "⟈";
var bull = "•";
var bullet = "•";
var bump = "≎";
var bumpE = "⪮";
var bumpe = "≏";
var bumpeq = "≏";
var cacute = "ć";
var cap = "∩";
var capand = "⩄";
var capbrcup = "⩉";
var capcap = "⩋";
var capcup = "⩇";
var capdot = "⩀";
var caps = "∩︀";
var caret = "⁁";
var caron = "ˇ";
var ccaps = "⩍";
var ccaron = "č";
var ccedi = "ç";
var ccedil$1 = "ç";
var ccirc = "ĉ";
var ccups = "⩌";
var ccupssm = "⩐";
var cdot = "ċ";
var cedi = "¸";
var cedil$1 = "¸";
var cemptyv = "⦲";
var cen = "¢";
var cent$1 = "¢";
var centerdot = "·";
var cfr = "𝔠";
var chcy = "ч";
var check$2 = "✓";
var checkmark = "✓";
var chi = "χ";
var cir = "○";
var cirE = "⧃";
var circ = "ˆ";
var circeq = "≗";
var circlearrowleft = "↺";
var circlearrowright = "↻";
var circledR = "®";
var circledS = "Ⓢ";
var circledast = "⊛";
var circledcirc = "⊚";
var circleddash = "⊝";
var cire = "≗";
var cirfnint = "⨐";
var cirmid = "⫯";
var cirscir = "⧂";
var clubs = "♣";
var clubsuit = "♣";
var colon = ":";
var colone = "≔";
var coloneq = "≔";
var comma = ",";
var commat = "@";
var comp = "∁";
var compfn = "∘";
var complement = "∁";
var complexes = "ℂ";
var cong = "≅";
var congdot = "⩭";
var conint = "∮";
var copf = "𝕔";
var coprod = "∐";
var cop = "©";
var copy$1 = "©";
var copysr = "℗";
var crarr = "↵";
var cross = "✗";
var cscr = "𝒸";
var csub = "⫏";
var csube = "⫑";
var csup = "⫐";
var csupe = "⫒";
var ctdot = "⋯";
var cudarrl = "⤸";
var cudarrr = "⤵";
var cuepr = "⋞";
var cuesc = "⋟";
var cularr = "↶";
var cularrp = "⤽";
var cup = "∪";
var cupbrcap = "⩈";
var cupcap = "⩆";
var cupcup = "⩊";
var cupdot = "⊍";
var cupor = "⩅";
var cups = "∪︀";
var curarr = "↷";
var curarrm = "⤼";
var curlyeqprec = "⋞";
var curlyeqsucc = "⋟";
var curlyvee = "⋎";
var curlywedge = "⋏";
var curre = "¤";
var curren$1 = "¤";
var curvearrowleft = "↶";
var curvearrowright = "↷";
var cuvee = "⋎";
var cuwed = "⋏";
var cwconint = "∲";
var cwint = "∱";
var cylcty = "⌭";
var dArr = "⇓";
var dHar = "⥥";
var dagger = "†";
var daleth = "ℸ";
var darr = "↓";
var dash = "‐";
var dashv = "⊣";
var dbkarow = "⤏";
var dblac = "˝";
var dcaron = "ď";
var dcy = "д";
var dd = "ⅆ";
var ddagger = "‡";
var ddarr = "⇊";
var ddotseq = "⩷";
var de = "°";
var deg$1 = "°";
var delta = "δ";
var demptyv = "⦱";
var dfisht = "⥿";
var dfr = "𝔡";
var dharl = "⇃";
var dharr = "⇂";
var diam = "⋄";
var diamond = "⋄";
var diamondsuit = "♦";
var diams = "♦";
var die = "¨";
var digamma = "ϝ";
var disin = "⋲";
var div = "÷";
var divid = "÷";
var divide$2 = "÷";
var divideontimes = "⋇";
var divonx = "⋇";
var djcy = "ђ";
var dlcorn = "⌞";
var dlcrop = "⌍";
var dollar = "$";
var dopf = "𝕕";
var dot = "˙";
var doteq = "≐";
var doteqdot = "≑";
var dotminus = "∸";
var dotplus = "∔";
var dotsquare = "⊡";
var doublebarwedge = "⌆";
var downarrow = "↓";
var downdownarrows = "⇊";
var downharpoonleft = "⇃";
var downharpoonright = "⇂";
var drbkarow = "⤐";
var drcorn = "⌟";
var drcrop = "⌌";
var dscr = "𝒹";
var dscy = "ѕ";
var dsol = "⧶";
var dstrok = "đ";
var dtdot = "⋱";
var dtri = "▿";
var dtrif = "▾";
var duarr = "⇵";
var duhar = "⥯";
var dwangle = "⦦";
var dzcy = "џ";
var dzigrarr = "⟿";
var eDDot = "⩷";
var eDot = "≑";
var eacut = "é";
var eacute$1 = "é";
var easter = "⩮";
var ecaron = "ě";
var ecir = "ê";
var ecirc$1 = "ê";
var ecolon = "≕";
var ecy = "э";
var edot = "ė";
var ee = "ⅇ";
var efDot = "≒";
var efr = "𝔢";
var eg = "⪚";
var egrav = "è";
var egrave$1 = "è";
var egs = "⪖";
var egsdot = "⪘";
var el = "⪙";
var elinters = "⏧";
var ell = "ℓ";
var els = "⪕";
var elsdot = "⪗";
var emacr = "ē";
var empty$1 = "∅";
var emptyset = "∅";
var emptyv = "∅";
var emsp13 = " ";
var emsp14 = " ";
var emsp = " ";
var eng = "ŋ";
var ensp = " ";
var eogon = "ę";
var eopf = "𝕖";
var epar = "⋕";
var eparsl = "⧣";
var eplus = "⩱";
var epsi = "ε";
var epsilon = "ε";
var epsiv = "ϵ";
var eqcirc = "≖";
var eqcolon = "≕";
var eqsim = "≂";
var eqslantgtr = "⪖";
var eqslantless = "⪕";
var equals = "=";
var equest = "≟";
var equiv = "≡";
var equivDD = "⩸";
var eqvparsl = "⧥";
var erDot = "≓";
var erarr = "⥱";
var escr = "ℯ";
var esdot = "≐";
var esim = "≂";
var eta = "η";
var et = "ð";
var eth$1 = "ð";
var eum = "ë";
var euml$1 = "ë";
var euro = "€";
var excl = "!";
var exist = "∃";
var expectation = "ℰ";
var exponentiale = "ⅇ";
var fallingdotseq = "≒";
var fcy = "ф";
var female = "♀";
var ffilig = "ﬃ";
var fflig = "ﬀ";
var ffllig = "ﬄ";
var ffr = "𝔣";
var filig = "ﬁ";
var fjlig = "fj";
var flat = "♭";
var fllig = "ﬂ";
var fltns = "▱";
var fnof = "ƒ";
var fopf = "𝕗";
var forall = "∀";
var fork = "⋔";
var forkv = "⫙";
var fpartint = "⨍";
var frac1 = "¼";
var frac12$1 = "½";
var frac13 = "⅓";
var frac14$1 = "¼";
var frac15 = "⅕";
var frac16 = "⅙";
var frac18 = "⅛";
var frac23 = "⅔";
var frac25 = "⅖";
var frac3 = "¾";
var frac34$1 = "¾";
var frac35 = "⅗";
var frac38 = "⅜";
var frac45 = "⅘";
var frac56 = "⅚";
var frac58 = "⅝";
var frac78 = "⅞";
var frasl = "⁄";
var frown = "⌢";
var fscr = "𝒻";
var gE = "≧";
var gEl = "⪌";
var gacute = "ǵ";
var gamma = "γ";
var gammad = "ϝ";
var gap = "⪆";
var gbreve = "ğ";
var gcirc = "ĝ";
var gcy = "г";
var gdot = "ġ";
var ge = "≥";
var gel = "⋛";
var geq = "≥";
var geqq = "≧";
var geqslant = "⩾";
var ges = "⩾";
var gescc = "⪩";
var gesdot = "⪀";
var gesdoto = "⪂";
var gesdotol = "⪄";
var gesl = "⋛︀";
var gesles = "⪔";
var gfr = "𝔤";
var gg = "≫";
var ggg = "⋙";
var gimel = "ℷ";
var gjcy = "ѓ";
var gl = "≷";
var glE = "⪒";
var gla = "⪥";
var glj = "⪤";
var gnE = "≩";
var gnap = "⪊";
var gnapprox = "⪊";
var gne = "⪈";
var gneq = "⪈";
var gneqq = "≩";
var gnsim = "⋧";
var gopf = "𝕘";
var grave = "`";
var gscr = "ℊ";
var gsim = "≳";
var gsime = "⪎";
var gsiml = "⪐";
var g = ">";
var gt$1 = ">";
var gtcc = "⪧";
var gtcir = "⩺";
var gtdot = "⋗";
var gtlPar = "⦕";
var gtquest = "⩼";
var gtrapprox = "⪆";
var gtrarr = "⥸";
var gtrdot = "⋗";
var gtreqless = "⋛";
var gtreqqless = "⪌";
var gtrless = "≷";
var gtrsim = "≳";
var gvertneqq = "≩︀";
var gvnE = "≩︀";
var hArr = "⇔";
var hairsp = " ";
var half = "½";
var hamilt = "ℋ";
var hardcy = "ъ";
var harr = "↔";
var harrcir = "⥈";
var harrw = "↭";
var hbar = "ℏ";
var hcirc = "ĥ";
var hearts = "♥";
var heartsuit = "♥";
var hellip = "…";
var hercon = "⊹";
var hfr = "𝔥";
var hksearow = "⤥";
var hkswarow = "⤦";
var hoarr = "⇿";
var homtht = "∻";
var hookleftarrow = "↩";
var hookrightarrow = "↪";
var hopf = "𝕙";
var horbar = "―";
var hscr = "𝒽";
var hslash = "ℏ";
var hstrok = "ħ";
var hybull = "⁃";
var hyphen = "‐";
var iacut = "í";
var iacute$1 = "í";
var ic = "⁣";
var icir = "î";
var icirc$1 = "î";
var icy = "и";
var iecy = "е";
var iexc = "¡";
var iexcl$1 = "¡";
var iff = "⇔";
var ifr = "𝔦";
var igrav = "ì";
var igrave$1 = "ì";
var ii = "ⅈ";
var iiiint = "⨌";
var iiint = "∭";
var iinfin = "⧜";
var iiota = "℩";
var ijlig = "ĳ";
var imacr = "ī";
var image = "ℑ";
var imagline = "ℐ";
var imagpart = "ℑ";
var imath = "ı";
var imof = "⊷";
var imped = "Ƶ";
var incare = "℅";
var infin = "∞";
var infintie = "⧝";
var inodot = "ı";
var int = "∫";
var intcal = "⊺";
var integers = "ℤ";
var intercal = "⊺";
var intlarhk = "⨗";
var intprod = "⨼";
var iocy = "ё";
var iogon = "į";
var iopf = "𝕚";
var iota = "ι";
var iprod = "⨼";
var iques = "¿";
var iquest$1 = "¿";
var iscr = "𝒾";
var isin = "∈";
var isinE = "⋹";
var isindot = "⋵";
var isins = "⋴";
var isinsv = "⋳";
var isinv = "∈";
var it = "⁢";
var itilde = "ĩ";
var iukcy = "і";
var ium = "ï";
var iuml$1 = "ï";
var jcirc = "ĵ";
var jcy = "й";
var jfr = "𝔧";
var jmath = "ȷ";
var jopf = "𝕛";
var jscr = "𝒿";
var jsercy = "ј";
var jukcy = "є";
var kappa = "κ";
var kappav = "ϰ";
var kcedil = "ķ";
var kcy = "к";
var kfr = "𝔨";
var kgreen = "ĸ";
var khcy = "х";
var kjcy = "ќ";
var kopf = "𝕜";
var kscr = "𝓀";
var lAarr = "⇚";
var lArr = "⇐";
var lAtail = "⤛";
var lBarr = "⤎";
var lE = "≦";
var lEg = "⪋";
var lHar = "⥢";
var lacute = "ĺ";
var laemptyv = "⦴";
var lagran = "ℒ";
var lambda = "λ";
var lang = "⟨";
var langd = "⦑";
var langle = "⟨";
var lap = "⪅";
var laqu = "«";
var laquo$1 = "«";
var larr = "←";
var larrb = "⇤";
var larrbfs = "⤟";
var larrfs = "⤝";
var larrhk = "↩";
var larrlp = "↫";
var larrpl = "⤹";
var larrsim = "⥳";
var larrtl = "↢";
var lat = "⪫";
var latail = "⤙";
var late = "⪭";
var lates = "⪭︀";
var lbarr = "⤌";
var lbbrk = "❲";
var lbrace = "{";
var lbrack = "[";
var lbrke = "⦋";
var lbrksld = "⦏";
var lbrkslu = "⦍";
var lcaron = "ľ";
var lcedil = "ļ";
var lceil = "⌈";
var lcub = "{";
var lcy = "л";
var ldca = "⤶";
var ldquo = "“";
var ldquor = "„";
var ldrdhar = "⥧";
var ldrushar = "⥋";
var ldsh = "↲";
var le = "≤";
var leftarrow = "←";
var leftarrowtail = "↢";
var leftharpoondown = "↽";
var leftharpoonup = "↼";
var leftleftarrows = "⇇";
var leftrightarrow = "↔";
var leftrightarrows = "⇆";
var leftrightharpoons = "⇋";
var leftrightsquigarrow = "↭";
var leftthreetimes = "⋋";
var leg = "⋚";
var leq = "≤";
var leqq = "≦";
var leqslant = "⩽";
var les = "⩽";
var lescc = "⪨";
var lesdot = "⩿";
var lesdoto = "⪁";
var lesdotor = "⪃";
var lesg = "⋚︀";
var lesges = "⪓";
var lessapprox = "⪅";
var lessdot = "⋖";
var lesseqgtr = "⋚";
var lesseqqgtr = "⪋";
var lessgtr = "≶";
var lesssim = "≲";
var lfisht = "⥼";
var lfloor = "⌊";
var lfr = "𝔩";
var lg = "≶";
var lgE = "⪑";
var lhard = "↽";
var lharu = "↼";
var lharul = "⥪";
var lhblk = "▄";
var ljcy = "љ";
var ll = "≪";
var llarr = "⇇";
var llcorner = "⌞";
var llhard = "⥫";
var lltri = "◺";
var lmidot = "ŀ";
var lmoust = "⎰";
var lmoustache = "⎰";
var lnE = "≨";
var lnap = "⪉";
var lnapprox = "⪉";
var lne = "⪇";
var lneq = "⪇";
var lneqq = "≨";
var lnsim = "⋦";
var loang = "⟬";
var loarr = "⇽";
var lobrk = "⟦";
var longleftarrow = "⟵";
var longleftrightarrow = "⟷";
var longmapsto = "⟼";
var longrightarrow = "⟶";
var looparrowleft = "↫";
var looparrowright = "↬";
var lopar = "⦅";
var lopf = "𝕝";
var loplus = "⨭";
var lotimes = "⨴";
var lowast = "∗";
var lowbar = "_";
var loz = "◊";
var lozenge = "◊";
var lozf = "⧫";
var lpar = "(";
var lparlt = "⦓";
var lrarr = "⇆";
var lrcorner = "⌟";
var lrhar = "⇋";
var lrhard = "⥭";
var lrm = "‎";
var lrtri = "⊿";
var lsaquo = "‹";
var lscr = "𝓁";
var lsh = "↰";
var lsim = "≲";
var lsime = "⪍";
var lsimg = "⪏";
var lsqb = "[";
var lsquo = "‘";
var lsquor = "‚";
var lstrok = "ł";
var l$1 = "<";
var lt$1 = "<";
var ltcc = "⪦";
var ltcir = "⩹";
var ltdot = "⋖";
var lthree = "⋋";
var ltimes = "⋉";
var ltlarr = "⥶";
var ltquest = "⩻";
var ltrPar = "⦖";
var ltri = "◃";
var ltrie = "⊴";
var ltrif = "◂";
var lurdshar = "⥊";
var luruhar = "⥦";
var lvertneqq = "≨︀";
var lvnE = "≨︀";
var mDDot = "∺";
var mac = "¯";
var macr$1 = "¯";
var male = "♂";
var malt = "✠";
var maltese = "✠";
var map = "↦";
var mapsto = "↦";
var mapstodown = "↧";
var mapstoleft = "↤";
var mapstoup = "↥";
var marker = "▮";
var mcomma = "⨩";
var mcy = "м";
var mdash = "—";
var measuredangle = "∡";
var mfr = "𝔪";
var mho = "℧";
var micr = "µ";
var micro$1 = "µ";
var mid = "∣";
var midast = "*";
var midcir = "⫰";
var middo = "·";
var middot$1 = "·";
var minus = "−";
var minusb = "⊟";
var minusd = "∸";
var minusdu = "⨪";
var mlcp = "⫛";
var mldr = "…";
var mnplus = "∓";
var models = "⊧";
var mopf = "𝕞";
var mp = "∓";
var mscr = "𝓂";
var mstpos = "∾";
var mu = "μ";
var multimap = "⊸";
var mumap = "⊸";
var nGg = "⋙̸";
var nGt = "≫⃒";
var nGtv = "≫̸";
var nLeftarrow = "⇍";
var nLeftrightarrow = "⇎";
var nLl = "⋘̸";
var nLt = "≪⃒";
var nLtv = "≪̸";
var nRightarrow = "⇏";
var nVDash = "⊯";
var nVdash = "⊮";
var nabla = "∇";
var nacute = "ń";
var nang = "∠⃒";
var nap = "≉";
var napE = "⩰̸";
var napid = "≋̸";
var napos = "ŉ";
var napprox = "≉";
var natur = "♮";
var natural = "♮";
var naturals = "ℕ";
var nbs = " ";
var nbsp$1 = " ";
var nbump = "≎̸";
var nbumpe = "≏̸";
var ncap = "⩃";
var ncaron = "ň";
var ncedil = "ņ";
var ncong = "≇";
var ncongdot = "⩭̸";
var ncup = "⩂";
var ncy = "н";
var ndash = "–";
var ne = "≠";
var neArr = "⇗";
var nearhk = "⤤";
var nearr = "↗";
var nearrow = "↗";
var nedot = "≐̸";
var nequiv = "≢";
var nesear = "⤨";
var nesim = "≂̸";
var nexist = "∄";
var nexists = "∄";
var nfr = "𝔫";
var ngE = "≧̸";
var nge = "≱";
var ngeq = "≱";
var ngeqq = "≧̸";
var ngeqslant = "⩾̸";
var nges = "⩾̸";
var ngsim = "≵";
var ngt = "≯";
var ngtr = "≯";
var nhArr = "⇎";
var nharr = "↮";
var nhpar = "⫲";
var ni = "∋";
var nis = "⋼";
var nisd = "⋺";
var niv = "∋";
var njcy = "њ";
var nlArr = "⇍";
var nlE = "≦̸";
var nlarr = "↚";
var nldr = "‥";
var nle = "≰";
var nleftarrow = "↚";
var nleftrightarrow = "↮";
var nleq = "≰";
var nleqq = "≦̸";
var nleqslant = "⩽̸";
var nles = "⩽̸";
var nless = "≮";
var nlsim = "≴";
var nlt = "≮";
var nltri = "⋪";
var nltrie = "⋬";
var nmid = "∤";
var nopf = "𝕟";
var no = "¬";
var not$1 = "¬";
var notin = "∉";
var notinE = "⋹̸";
var notindot = "⋵̸";
var notinva = "∉";
var notinvb = "⋷";
var notinvc = "⋶";
var notni = "∌";
var notniva = "∌";
var notnivb = "⋾";
var notnivc = "⋽";
var npar = "∦";
var nparallel = "∦";
var nparsl = "⫽⃥";
var npart = "∂̸";
var npolint = "⨔";
var npr = "⊀";
var nprcue = "⋠";
var npre = "⪯̸";
var nprec = "⊀";
var npreceq = "⪯̸";
var nrArr = "⇏";
var nrarr = "↛";
var nrarrc = "⤳̸";
var nrarrw = "↝̸";
var nrightarrow = "↛";
var nrtri = "⋫";
var nrtrie = "⋭";
var nsc = "⊁";
var nsccue = "⋡";
var nsce = "⪰̸";
var nscr = "𝓃";
var nshortmid = "∤";
var nshortparallel = "∦";
var nsim = "≁";
var nsime = "≄";
var nsimeq = "≄";
var nsmid = "∤";
var nspar = "∦";
var nsqsube = "⋢";
var nsqsupe = "⋣";
var nsub = "⊄";
var nsubE = "⫅̸";
var nsube = "⊈";
var nsubset = "⊂⃒";
var nsubseteq = "⊈";
var nsubseteqq = "⫅̸";
var nsucc = "⊁";
var nsucceq = "⪰̸";
var nsup = "⊅";
var nsupE = "⫆̸";
var nsupe = "⊉";
var nsupset = "⊃⃒";
var nsupseteq = "⊉";
var nsupseteqq = "⫆̸";
var ntgl = "≹";
var ntild = "ñ";
var ntilde$1 = "ñ";
var ntlg = "≸";
var ntriangleleft = "⋪";
var ntrianglelefteq = "⋬";
var ntriangleright = "⋫";
var ntrianglerighteq = "⋭";
var nu = "ν";
var num = "#";
var numero = "№";
var numsp = " ";
var nvDash = "⊭";
var nvHarr = "⤄";
var nvap = "≍⃒";
var nvdash = "⊬";
var nvge = "≥⃒";
var nvgt = ">⃒";
var nvinfin = "⧞";
var nvlArr = "⤂";
var nvle = "≤⃒";
var nvlt = "<⃒";
var nvltrie = "⊴⃒";
var nvrArr = "⤃";
var nvrtrie = "⊵⃒";
var nvsim = "∼⃒";
var nwArr = "⇖";
var nwarhk = "⤣";
var nwarr = "↖";
var nwarrow = "↖";
var nwnear = "⤧";
var oS = "Ⓢ";
var oacut = "ó";
var oacute$1 = "ó";
var oast = "⊛";
var ocir = "ô";
var ocirc$1 = "ô";
var ocy = "о";
var odash = "⊝";
var odblac = "ő";
var odiv = "⨸";
var odot = "⊙";
var odsold = "⦼";
var oelig = "œ";
var ofcir = "⦿";
var ofr = "𝔬";
var ogon = "˛";
var ograv = "ò";
var ograve$1 = "ò";
var ogt = "⧁";
var ohbar = "⦵";
var ohm = "Ω";
var oint = "∮";
var olarr = "↺";
var olcir = "⦾";
var olcross = "⦻";
var oline = "‾";
var olt = "⧀";
var omacr = "ō";
var omega = "ω";
var omicron = "ο";
var omid = "⦶";
var ominus = "⊖";
var oopf = "𝕠";
var opar = "⦷";
var operp = "⦹";
var oplus = "⊕";
var or = "∨";
var orarr = "↻";
var ord = "º";
var order$1 = "ℴ";
var orderof = "ℴ";
var ordf$1 = "ª";
var ordm$1 = "º";
var origof = "⊶";
var oror = "⩖";
var orslope = "⩗";
var orv = "⩛";
var oscr = "ℴ";
var oslas = "ø";
var oslash$1 = "ø";
var osol = "⊘";
var otild = "õ";
var otilde$1 = "õ";
var otimes = "⊗";
var otimesas = "⨶";
var oum = "ö";
var ouml$1 = "ö";
var ovbar = "⌽";
var par = "¶";
var para$1 = "¶";
var parallel = "∥";
var parsim = "⫳";
var parsl = "⫽";
var part = "∂";
var pcy = "п";
var percnt = "%";
var period = ".";
var permil = "‰";
var perp = "⊥";
var pertenk = "‱";
var pfr = "𝔭";
var phi = "φ";
var phiv = "ϕ";
var phmmat = "ℳ";
var phone = "☎";
var pi = "π";
var pitchfork = "⋔";
var piv = "ϖ";
var planck = "ℏ";
var planckh = "ℎ";
var plankv = "ℏ";
var plus = "+";
var plusacir = "⨣";
var plusb = "⊞";
var pluscir = "⨢";
var plusdo = "∔";
var plusdu = "⨥";
var pluse = "⩲";
var plusm = "±";
var plusmn$1 = "±";
var plussim = "⨦";
var plustwo = "⨧";
var pm = "±";
var pointint = "⨕";
var popf = "𝕡";
var poun = "£";
var pound$1 = "£";
var pr = "≺";
var prE = "⪳";
var prap = "⪷";
var prcue = "≼";
var pre = "⪯";
var prec = "≺";
var precapprox = "⪷";
var preccurlyeq = "≼";
var preceq = "⪯";
var precnapprox = "⪹";
var precneqq = "⪵";
var precnsim = "⋨";
var precsim = "≾";
var prime = "′";
var primes = "ℙ";
var prnE = "⪵";
var prnap = "⪹";
var prnsim = "⋨";
var prod = "∏";
var profalar = "⌮";
var profline = "⌒";
var profsurf = "⌓";
var prop = "∝";
var propto = "∝";
var prsim = "≾";
var prurel = "⊰";
var pscr = "𝓅";
var psi = "ψ";
var puncsp = " ";
var qfr = "𝔮";
var qint = "⨌";
var qopf = "𝕢";
var qprime = "⁗";
var qscr = "𝓆";
var quaternions = "ℍ";
var quatint = "⨖";
var quest = "?";
var questeq = "≟";
var quo = "\"";
var quot$2 = "\"";
var rAarr = "⇛";
var rArr = "⇒";
var rAtail = "⤜";
var rBarr = "⤏";
var rHar = "⥤";
var race = "∽̱";
var racute = "ŕ";
var radic = "√";
var raemptyv = "⦳";
var rang = "⟩";
var rangd = "⦒";
var range$1 = "⦥";
var rangle = "⟩";
var raqu = "»";
var raquo$1 = "»";
var rarr = "→";
var rarrap = "⥵";
var rarrb = "⇥";
var rarrbfs = "⤠";
var rarrc = "⤳";
var rarrfs = "⤞";
var rarrhk = "↪";
var rarrlp = "↬";
var rarrpl = "⥅";
var rarrsim = "⥴";
var rarrtl = "↣";
var rarrw = "↝";
var ratail = "⤚";
var ratio = "∶";
var rationals = "ℚ";
var rbarr = "⤍";
var rbbrk = "❳";
var rbrace = "}";
var rbrack = "]";
var rbrke = "⦌";
var rbrksld = "⦎";
var rbrkslu = "⦐";
var rcaron = "ř";
var rcedil = "ŗ";
var rceil = "⌉";
var rcub = "}";
var rcy = "р";
var rdca = "⤷";
var rdldhar = "⥩";
var rdquo = "”";
var rdquor = "”";
var rdsh = "↳";
var real = "ℜ";
var realine = "ℛ";
var realpart = "ℜ";
var reals = "ℝ";
var rect = "▭";
var re = "®";
var reg$1 = "®";
var rfisht = "⥽";
var rfloor = "⌋";
var rfr = "𝔯";
var rhard = "⇁";
var rharu = "⇀";
var rharul = "⥬";
var rho = "ρ";
var rhov = "ϱ";
var rightarrow = "→";
var rightarrowtail = "↣";
var rightharpoondown = "⇁";
var rightharpoonup = "⇀";
var rightleftarrows = "⇄";
var rightleftharpoons = "⇌";
var rightrightarrows = "⇉";
var rightsquigarrow = "↝";
var rightthreetimes = "⋌";
var ring = "˚";
var risingdotseq = "≓";
var rlarr = "⇄";
var rlhar = "⇌";
var rlm = "‏";
var rmoust = "⎱";
var rmoustache = "⎱";
var rnmid = "⫮";
var roang = "⟭";
var roarr = "⇾";
var robrk = "⟧";
var ropar = "⦆";
var ropf = "𝕣";
var roplus = "⨮";
var rotimes = "⨵";
var rpar = ")";
var rpargt = "⦔";
var rppolint = "⨒";
var rrarr = "⇉";
var rsaquo = "›";
var rscr = "𝓇";
var rsh = "↱";
var rsqb = "]";
var rsquo = "’";
var rsquor = "’";
var rthree = "⋌";
var rtimes = "⋊";
var rtri = "▹";
var rtrie = "⊵";
var rtrif = "▸";
var rtriltri = "⧎";
var ruluhar = "⥨";
var rx = "℞";
var sacute = "ś";
var sbquo = "‚";
var sc = "≻";
var scE = "⪴";
var scap = "⪸";
var scaron = "š";
var sccue = "≽";
var sce = "⪰";
var scedil = "ş";
var scirc = "ŝ";
var scnE = "⪶";
var scnap = "⪺";
var scnsim = "⋩";
var scpolint = "⨓";
var scsim = "≿";
var scy = "с";
var sdot = "⋅";
var sdotb = "⊡";
var sdote = "⩦";
var seArr = "⇘";
var searhk = "⤥";
var searr = "↘";
var searrow = "↘";
var sec = "§";
var sect$1 = "§";
var semi = ";";
var seswar = "⤩";
var setminus = "∖";
var setmn = "∖";
var sext = "✶";
var sfr = "𝔰";
var sfrown = "⌢";
var sharp = "♯";
var shchcy = "щ";
var shcy = "ш";
var shortmid = "∣";
var shortparallel = "∥";
var sh = "­";
var shy$1 = "­";
var sigma = "σ";
var sigmaf = "ς";
var sigmav = "ς";
var sim = "∼";
var simdot = "⩪";
var sime = "≃";
var simeq = "≃";
var simg = "⪞";
var simgE = "⪠";
var siml = "⪝";
var simlE = "⪟";
var simne = "≆";
var simplus = "⨤";
var simrarr = "⥲";
var slarr = "←";
var smallsetminus = "∖";
var smashp = "⨳";
var smeparsl = "⧤";
var smid = "∣";
var smile = "⌣";
var smt = "⪪";
var smte = "⪬";
var smtes = "⪬︀";
var softcy = "ь";
var sol = "/";
var solb = "⧄";
var solbar = "⌿";
var sopf = "𝕤";
var spades = "♠";
var spadesuit = "♠";
var spar = "∥";
var sqcap = "⊓";
var sqcaps = "⊓︀";
var sqcup = "⊔";
var sqcups = "⊔︀";
var sqsub = "⊏";
var sqsube = "⊑";
var sqsubset = "⊏";
var sqsubseteq = "⊑";
var sqsup = "⊐";
var sqsupe = "⊒";
var sqsupset = "⊐";
var sqsupseteq = "⊒";
var squ = "□";
var square = "□";
var squarf = "▪";
var squf = "▪";
var srarr = "→";
var sscr = "𝓈";
var ssetmn = "∖";
var ssmile = "⌣";
var sstarf = "⋆";
var star = "☆";
var starf = "★";
var straightepsilon = "ϵ";
var straightphi = "ϕ";
var strns = "¯";
var sub = "⊂";
var subE = "⫅";
var subdot = "⪽";
var sube = "⊆";
var subedot = "⫃";
var submult = "⫁";
var subnE = "⫋";
var subne = "⊊";
var subplus = "⪿";
var subrarr = "⥹";
var subset = "⊂";
var subseteq = "⊆";
var subseteqq = "⫅";
var subsetneq = "⊊";
var subsetneqq = "⫋";
var subsim = "⫇";
var subsub = "⫕";
var subsup = "⫓";
var succ = "≻";
var succapprox = "⪸";
var succcurlyeq = "≽";
var succeq = "⪰";
var succnapprox = "⪺";
var succneqq = "⪶";
var succnsim = "⋩";
var succsim = "≿";
var sum = "∑";
var sung = "♪";
var sup = "⊃";
var sup1$1 = "¹";
var sup2$1 = "²";
var sup3$1 = "³";
var supE = "⫆";
var supdot = "⪾";
var supdsub = "⫘";
var supe = "⊇";
var supedot = "⫄";
var suphsol = "⟉";
var suphsub = "⫗";
var suplarr = "⥻";
var supmult = "⫂";
var supnE = "⫌";
var supne = "⊋";
var supplus = "⫀";
var supset = "⊃";
var supseteq = "⊇";
var supseteqq = "⫆";
var supsetneq = "⊋";
var supsetneqq = "⫌";
var supsim = "⫈";
var supsub = "⫔";
var supsup = "⫖";
var swArr = "⇙";
var swarhk = "⤦";
var swarr = "↙";
var swarrow = "↙";
var swnwar = "⤪";
var szli = "ß";
var szlig$1 = "ß";
var target = "⌖";
var tau = "τ";
var tbrk = "⎴";
var tcaron = "ť";
var tcedil = "ţ";
var tcy = "т";
var tdot = "⃛";
var telrec = "⌕";
var tfr = "𝔱";
var there4 = "∴";
var therefore = "∴";
var theta = "θ";
var thetasym = "ϑ";
var thetav = "ϑ";
var thickapprox = "≈";
var thicksim = "∼";
var thinsp = " ";
var thkap = "≈";
var thksim = "∼";
var thor = "þ";
var thorn$1 = "þ";
var tilde = "˜";
var time = "×";
var times$1 = "×";
var timesb = "⊠";
var timesbar = "⨱";
var timesd = "⨰";
var tint = "∭";
var toea = "⤨";
var top = "⊤";
var topbot = "⌶";
var topcir = "⫱";
var topf = "𝕥";
var topfork = "⫚";
var tosa = "⤩";
var tprime = "‴";
var trade = "™";
var triangle = "▵";
var triangledown = "▿";
var triangleleft = "◃";
var trianglelefteq = "⊴";
var triangleq = "≜";
var triangleright = "▹";
var trianglerighteq = "⊵";
var tridot = "◬";
var trie = "≜";
var triminus = "⨺";
var triplus = "⨹";
var trisb = "⧍";
var tritime = "⨻";
var trpezium = "⏢";
var tscr = "𝓉";
var tscy = "ц";
var tshcy = "ћ";
var tstrok = "ŧ";
var twixt = "≬";
var twoheadleftarrow = "↞";
var twoheadrightarrow = "↠";
var uArr = "⇑";
var uHar = "⥣";
var uacut = "ú";
var uacute$1 = "ú";
var uarr = "↑";
var ubrcy = "ў";
var ubreve = "ŭ";
var ucir = "û";
var ucirc$1 = "û";
var ucy = "у";
var udarr = "⇅";
var udblac = "ű";
var udhar = "⥮";
var ufisht = "⥾";
var ufr = "𝔲";
var ugrav = "ù";
var ugrave$1 = "ù";
var uharl = "↿";
var uharr = "↾";
var uhblk = "▀";
var ulcorn = "⌜";
var ulcorner = "⌜";
var ulcrop = "⌏";
var ultri = "◸";
var umacr = "ū";
var um = "¨";
var uml$1 = "¨";
var uogon = "ų";
var uopf = "𝕦";
var uparrow = "↑";
var updownarrow = "↕";
var upharpoonleft = "↿";
var upharpoonright = "↾";
var uplus = "⊎";
var upsi = "υ";
var upsih = "ϒ";
var upsilon = "υ";
var upuparrows = "⇈";
var urcorn = "⌝";
var urcorner = "⌝";
var urcrop = "⌎";
var uring = "ů";
var urtri = "◹";
var uscr = "𝓊";
var utdot = "⋰";
var utilde = "ũ";
var utri = "▵";
var utrif = "▴";
var uuarr = "⇈";
var uum = "ü";
var uuml$1 = "ü";
var uwangle = "⦧";
var vArr = "⇕";
var vBar = "⫨";
var vBarv = "⫩";
var vDash = "⊨";
var vangrt = "⦜";
var varepsilon = "ϵ";
var varkappa = "ϰ";
var varnothing = "∅";
var varphi = "ϕ";
var varpi = "ϖ";
var varpropto = "∝";
var varr = "↕";
var varrho = "ϱ";
var varsigma = "ς";
var varsubsetneq = "⊊︀";
var varsubsetneqq = "⫋︀";
var varsupsetneq = "⊋︀";
var varsupsetneqq = "⫌︀";
var vartheta = "ϑ";
var vartriangleleft = "⊲";
var vartriangleright = "⊳";
var vcy = "в";
var vdash = "⊢";
var vee = "∨";
var veebar = "⊻";
var veeeq = "≚";
var vellip = "⋮";
var verbar = "|";
var vert = "|";
var vfr = "𝔳";
var vltri = "⊲";
var vnsub = "⊂⃒";
var vnsup = "⊃⃒";
var vopf = "𝕧";
var vprop = "∝";
var vrtri = "⊳";
var vscr = "𝓋";
var vsubnE = "⫋︀";
var vsubne = "⊊︀";
var vsupnE = "⫌︀";
var vsupne = "⊋︀";
var vzigzag = "⦚";
var wcirc = "ŵ";
var wedbar = "⩟";
var wedge = "∧";
var wedgeq = "≙";
var weierp = "℘";
var wfr = "𝔴";
var wopf = "𝕨";
var wp = "℘";
var wr = "≀";
var wreath = "≀";
var wscr = "𝓌";
var xcap = "⋂";
var xcirc = "◯";
var xcup = "⋃";
var xdtri = "▽";
var xfr = "𝔵";
var xhArr = "⟺";
var xharr = "⟷";
var xi = "ξ";
var xlArr = "⟸";
var xlarr = "⟵";
var xmap = "⟼";
var xnis = "⋻";
var xodot = "⨀";
var xopf = "𝕩";
var xoplus = "⨁";
var xotime = "⨂";
var xrArr = "⟹";
var xrarr = "⟶";
var xscr = "𝓍";
var xsqcup = "⨆";
var xuplus = "⨄";
var xutri = "△";
var xvee = "⋁";
var xwedge = "⋀";
var yacut = "ý";
var yacute$1 = "ý";
var yacy = "я";
var ycirc = "ŷ";
var ycy = "ы";
var ye = "¥";
var yen$1 = "¥";
var yfr = "𝔶";
var yicy = "ї";
var yopf = "𝕪";
var yscr = "𝓎";
var yucy = "ю";
var yum = "ÿ";
var yuml$1 = "ÿ";
var zacute = "ź";
var zcaron = "ž";
var zcy = "з";
var zdot = "ż";
var zeetrf = "ℨ";
var zeta = "ζ";
var zfr = "𝔷";
var zhcy = "ж";
var zigrarr = "⇝";
var zopf = "𝕫";
var zscr = "𝓏";
var zwj = "‍";
var zwnj = "‌";
var index$e = {
  AEli: AEli,
  AElig: AElig$1,
  AM: AM,
  AMP: AMP$1,
  Aacut: Aacut,
  Aacute: Aacute$1,
  Abreve: Abreve,
  Acir: Acir,
  Acirc: Acirc$1,
  Acy: Acy,
  Afr: Afr,
  Agrav: Agrav,
  Agrave: Agrave$1,
  Alpha: Alpha,
  Amacr: Amacr,
  And: And,
  Aogon: Aogon,
  Aopf: Aopf,
  ApplyFunction: ApplyFunction,
  Arin: Arin,
  Aring: Aring$1,
  Ascr: Ascr,
  Assign: Assign,
  Atild: Atild,
  Atilde: Atilde$1,
  Aum: Aum,
  Auml: Auml$1,
  Backslash: Backslash,
  Barv: Barv,
  Barwed: Barwed,
  Bcy: Bcy,
  Because: Because,
  Bernoullis: Bernoullis,
  Beta: Beta,
  Bfr: Bfr,
  Bopf: Bopf,
  Breve: Breve,
  Bscr: Bscr,
  Bumpeq: Bumpeq,
  CHcy: CHcy,
  COP: COP,
  COPY: COPY$1,
  Cacute: Cacute,
  Cap: Cap,
  CapitalDifferentialD: CapitalDifferentialD,
  Cayleys: Cayleys,
  Ccaron: Ccaron,
  Ccedi: Ccedi,
  Ccedil: Ccedil$1,
  Ccirc: Ccirc,
  Cconint: Cconint,
  Cdot: Cdot,
  Cedilla: Cedilla,
  CenterDot: CenterDot,
  Cfr: Cfr,
  Chi: Chi,
  CircleDot: CircleDot,
  CircleMinus: CircleMinus,
  CirclePlus: CirclePlus,
  CircleTimes: CircleTimes,
  ClockwiseContourIntegral: ClockwiseContourIntegral,
  CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
  CloseCurlyQuote: CloseCurlyQuote,
  Colon: Colon,
  Colone: Colone,
  Congruent: Congruent,
  Conint: Conint,
  ContourIntegral: ContourIntegral,
  Copf: Copf,
  Coproduct: Coproduct,
  CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
  Cross: Cross,
  Cscr: Cscr,
  Cup: Cup,
  CupCap: CupCap,
  DD: DD,
  DDotrahd: DDotrahd,
  DJcy: DJcy,
  DScy: DScy,
  DZcy: DZcy,
  Dagger: Dagger,
  Darr: Darr,
  Dashv: Dashv,
  Dcaron: Dcaron,
  Dcy: Dcy,
  Del: Del,
  Delta: Delta,
  Dfr: Dfr,
  DiacriticalAcute: DiacriticalAcute,
  DiacriticalDot: DiacriticalDot,
  DiacriticalDoubleAcute: DiacriticalDoubleAcute,
  DiacriticalGrave: DiacriticalGrave,
  DiacriticalTilde: DiacriticalTilde,
  Diamond: Diamond,
  DifferentialD: DifferentialD,
  Dopf: Dopf,
  Dot: Dot,
  DotDot: DotDot,
  DotEqual: DotEqual,
  DoubleContourIntegral: DoubleContourIntegral,
  DoubleDot: DoubleDot,
  DoubleDownArrow: DoubleDownArrow,
  DoubleLeftArrow: DoubleLeftArrow,
  DoubleLeftRightArrow: DoubleLeftRightArrow,
  DoubleLeftTee: DoubleLeftTee,
  DoubleLongLeftArrow: DoubleLongLeftArrow,
  DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
  DoubleLongRightArrow: DoubleLongRightArrow,
  DoubleRightArrow: DoubleRightArrow,
  DoubleRightTee: DoubleRightTee,
  DoubleUpArrow: DoubleUpArrow,
  DoubleUpDownArrow: DoubleUpDownArrow,
  DoubleVerticalBar: DoubleVerticalBar,
  DownArrow: DownArrow,
  DownArrowBar: DownArrowBar,
  DownArrowUpArrow: DownArrowUpArrow,
  DownBreve: DownBreve,
  DownLeftRightVector: DownLeftRightVector,
  DownLeftTeeVector: DownLeftTeeVector,
  DownLeftVector: DownLeftVector,
  DownLeftVectorBar: DownLeftVectorBar,
  DownRightTeeVector: DownRightTeeVector,
  DownRightVector: DownRightVector,
  DownRightVectorBar: DownRightVectorBar,
  DownTee: DownTee,
  DownTeeArrow: DownTeeArrow,
  Downarrow: Downarrow,
  Dscr: Dscr,
  Dstrok: Dstrok,
  ENG: ENG,
  ET: ET,
  ETH: ETH$1,
  Eacut: Eacut,
  Eacute: Eacute$1,
  Ecaron: Ecaron,
  Ecir: Ecir,
  Ecirc: Ecirc$1,
  Ecy: Ecy,
  Edot: Edot,
  Efr: Efr,
  Egrav: Egrav,
  Egrave: Egrave$1,
  Element: Element$1,
  Emacr: Emacr,
  EmptySmallSquare: EmptySmallSquare,
  EmptyVerySmallSquare: EmptyVerySmallSquare,
  Eogon: Eogon,
  Eopf: Eopf,
  Epsilon: Epsilon,
  Equal: Equal,
  EqualTilde: EqualTilde,
  Equilibrium: Equilibrium,
  Escr: Escr,
  Esim: Esim,
  Eta: Eta,
  Eum: Eum,
  Euml: Euml$1,
  Exists: Exists,
  ExponentialE: ExponentialE,
  Fcy: Fcy,
  Ffr: Ffr,
  FilledSmallSquare: FilledSmallSquare,
  FilledVerySmallSquare: FilledVerySmallSquare,
  Fopf: Fopf,
  ForAll: ForAll,
  Fouriertrf: Fouriertrf,
  Fscr: Fscr,
  GJcy: GJcy,
  G: G,
  GT: GT$1,
  Gamma: Gamma,
  Gammad: Gammad,
  Gbreve: Gbreve,
  Gcedil: Gcedil,
  Gcirc: Gcirc,
  Gcy: Gcy,
  Gdot: Gdot,
  Gfr: Gfr,
  Gg: Gg,
  Gopf: Gopf,
  GreaterEqual: GreaterEqual,
  GreaterEqualLess: GreaterEqualLess,
  GreaterFullEqual: GreaterFullEqual,
  GreaterGreater: GreaterGreater,
  GreaterLess: GreaterLess,
  GreaterSlantEqual: GreaterSlantEqual,
  GreaterTilde: GreaterTilde,
  Gscr: Gscr,
  Gt: Gt,
  HARDcy: HARDcy,
  Hacek: Hacek,
  Hat: Hat,
  Hcirc: Hcirc,
  Hfr: Hfr,
  HilbertSpace: HilbertSpace,
  Hopf: Hopf,
  HorizontalLine: HorizontalLine,
  Hscr: Hscr,
  Hstrok: Hstrok,
  HumpDownHump: HumpDownHump,
  HumpEqual: HumpEqual,
  IEcy: IEcy,
  IJlig: IJlig,
  IOcy: IOcy,
  Iacut: Iacut,
  Iacute: Iacute$1,
  Icir: Icir,
  Icirc: Icirc$1,
  Icy: Icy,
  Idot: Idot,
  Ifr: Ifr,
  Igrav: Igrav,
  Igrave: Igrave$1,
  Im: Im,
  Imacr: Imacr,
  ImaginaryI: ImaginaryI,
  Implies: Implies,
  Int: Int,
  Integral: Integral,
  Intersection: Intersection,
  InvisibleComma: InvisibleComma,
  InvisibleTimes: InvisibleTimes,
  Iogon: Iogon,
  Iopf: Iopf,
  Iota: Iota,
  Iscr: Iscr,
  Itilde: Itilde,
  Iukcy: Iukcy,
  Ium: Ium,
  Iuml: Iuml$1,
  Jcirc: Jcirc,
  Jcy: Jcy,
  Jfr: Jfr,
  Jopf: Jopf,
  Jscr: Jscr,
  Jsercy: Jsercy,
  Jukcy: Jukcy,
  KHcy: KHcy,
  KJcy: KJcy,
  Kappa: Kappa,
  Kcedil: Kcedil,
  Kcy: Kcy,
  Kfr: Kfr,
  Kopf: Kopf,
  Kscr: Kscr,
  LJcy: LJcy,
  L: L,
  LT: LT$1,
  Lacute: Lacute,
  Lambda: Lambda,
  Lang: Lang,
  Laplacetrf: Laplacetrf,
  Larr: Larr,
  Lcaron: Lcaron,
  Lcedil: Lcedil,
  Lcy: Lcy,
  LeftAngleBracket: LeftAngleBracket,
  LeftArrow: LeftArrow,
  LeftArrowBar: LeftArrowBar,
  LeftArrowRightArrow: LeftArrowRightArrow,
  LeftCeiling: LeftCeiling,
  LeftDoubleBracket: LeftDoubleBracket,
  LeftDownTeeVector: LeftDownTeeVector,
  LeftDownVector: LeftDownVector,
  LeftDownVectorBar: LeftDownVectorBar,
  LeftFloor: LeftFloor,
  LeftRightArrow: LeftRightArrow,
  LeftRightVector: LeftRightVector,
  LeftTee: LeftTee,
  LeftTeeArrow: LeftTeeArrow,
  LeftTeeVector: LeftTeeVector,
  LeftTriangle: LeftTriangle,
  LeftTriangleBar: LeftTriangleBar,
  LeftTriangleEqual: LeftTriangleEqual,
  LeftUpDownVector: LeftUpDownVector,
  LeftUpTeeVector: LeftUpTeeVector,
  LeftUpVector: LeftUpVector,
  LeftUpVectorBar: LeftUpVectorBar,
  LeftVector: LeftVector,
  LeftVectorBar: LeftVectorBar,
  Leftarrow: Leftarrow,
  Leftrightarrow: Leftrightarrow,
  LessEqualGreater: LessEqualGreater,
  LessFullEqual: LessFullEqual,
  LessGreater: LessGreater,
  LessLess: LessLess,
  LessSlantEqual: LessSlantEqual,
  LessTilde: LessTilde,
  Lfr: Lfr,
  Ll: Ll,
  Lleftarrow: Lleftarrow,
  Lmidot: Lmidot,
  LongLeftArrow: LongLeftArrow,
  LongLeftRightArrow: LongLeftRightArrow,
  LongRightArrow: LongRightArrow,
  Longleftarrow: Longleftarrow,
  Longleftrightarrow: Longleftrightarrow,
  Longrightarrow: Longrightarrow,
  Lopf: Lopf,
  LowerLeftArrow: LowerLeftArrow,
  LowerRightArrow: LowerRightArrow,
  Lscr: Lscr,
  Lsh: Lsh,
  Lstrok: Lstrok,
  Lt: Lt,
  "Map": "⤅",
  Mcy: Mcy,
  MediumSpace: MediumSpace,
  Mellintrf: Mellintrf,
  Mfr: Mfr,
  MinusPlus: MinusPlus,
  Mopf: Mopf,
  Mscr: Mscr,
  Mu: Mu,
  NJcy: NJcy,
  Nacute: Nacute,
  Ncaron: Ncaron,
  Ncedil: Ncedil,
  Ncy: Ncy,
  NegativeMediumSpace: NegativeMediumSpace,
  NegativeThickSpace: NegativeThickSpace,
  NegativeThinSpace: NegativeThinSpace,
  NegativeVeryThinSpace: NegativeVeryThinSpace,
  NestedGreaterGreater: NestedGreaterGreater,
  NestedLessLess: NestedLessLess,
  NewLine: NewLine,
  Nfr: Nfr,
  NoBreak: NoBreak,
  NonBreakingSpace: NonBreakingSpace,
  Nopf: Nopf,
  Not: Not,
  NotCongruent: NotCongruent,
  NotCupCap: NotCupCap,
  NotDoubleVerticalBar: NotDoubleVerticalBar,
  NotElement: NotElement,
  NotEqual: NotEqual,
  NotEqualTilde: NotEqualTilde,
  NotExists: NotExists,
  NotGreater: NotGreater,
  NotGreaterEqual: NotGreaterEqual,
  NotGreaterFullEqual: NotGreaterFullEqual,
  NotGreaterGreater: NotGreaterGreater,
  NotGreaterLess: NotGreaterLess,
  NotGreaterSlantEqual: NotGreaterSlantEqual,
  NotGreaterTilde: NotGreaterTilde,
  NotHumpDownHump: NotHumpDownHump,
  NotHumpEqual: NotHumpEqual,
  NotLeftTriangle: NotLeftTriangle,
  NotLeftTriangleBar: NotLeftTriangleBar,
  NotLeftTriangleEqual: NotLeftTriangleEqual,
  NotLess: NotLess,
  NotLessEqual: NotLessEqual,
  NotLessGreater: NotLessGreater,
  NotLessLess: NotLessLess,
  NotLessSlantEqual: NotLessSlantEqual,
  NotLessTilde: NotLessTilde,
  NotNestedGreaterGreater: NotNestedGreaterGreater,
  NotNestedLessLess: NotNestedLessLess,
  NotPrecedes: NotPrecedes,
  NotPrecedesEqual: NotPrecedesEqual,
  NotPrecedesSlantEqual: NotPrecedesSlantEqual,
  NotReverseElement: NotReverseElement,
  NotRightTriangle: NotRightTriangle,
  NotRightTriangleBar: NotRightTriangleBar,
  NotRightTriangleEqual: NotRightTriangleEqual,
  NotSquareSubset: NotSquareSubset,
  NotSquareSubsetEqual: NotSquareSubsetEqual,
  NotSquareSuperset: NotSquareSuperset,
  NotSquareSupersetEqual: NotSquareSupersetEqual,
  NotSubset: NotSubset,
  NotSubsetEqual: NotSubsetEqual,
  NotSucceeds: NotSucceeds,
  NotSucceedsEqual: NotSucceedsEqual,
  NotSucceedsSlantEqual: NotSucceedsSlantEqual,
  NotSucceedsTilde: NotSucceedsTilde,
  NotSuperset: NotSuperset,
  NotSupersetEqual: NotSupersetEqual,
  NotTilde: NotTilde,
  NotTildeEqual: NotTildeEqual,
  NotTildeFullEqual: NotTildeFullEqual,
  NotTildeTilde: NotTildeTilde,
  NotVerticalBar: NotVerticalBar,
  Nscr: Nscr,
  Ntild: Ntild,
  Ntilde: Ntilde$1,
  Nu: Nu,
  OElig: OElig,
  Oacut: Oacut,
  Oacute: Oacute$1,
  Ocir: Ocir,
  Ocirc: Ocirc$1,
  Ocy: Ocy,
  Odblac: Odblac,
  Ofr: Ofr,
  Ograv: Ograv,
  Ograve: Ograve$1,
  Omacr: Omacr,
  Omega: Omega,
  Omicron: Omicron,
  Oopf: Oopf,
  OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
  OpenCurlyQuote: OpenCurlyQuote,
  Or: Or,
  Oscr: Oscr,
  Oslas: Oslas,
  Oslash: Oslash$1,
  Otild: Otild,
  Otilde: Otilde$1,
  Otimes: Otimes,
  Oum: Oum,
  Ouml: Ouml$1,
  OverBar: OverBar,
  OverBrace: OverBrace,
  OverBracket: OverBracket,
  OverParenthesis: OverParenthesis,
  PartialD: PartialD,
  Pcy: Pcy,
  Pfr: Pfr,
  Phi: Phi,
  Pi: Pi,
  PlusMinus: PlusMinus,
  Poincareplane: Poincareplane,
  Popf: Popf,
  Pr: Pr,
  Precedes: Precedes,
  PrecedesEqual: PrecedesEqual,
  PrecedesSlantEqual: PrecedesSlantEqual,
  PrecedesTilde: PrecedesTilde,
  Prime: Prime,
  Product: Product,
  Proportion: Proportion,
  Proportional: Proportional,
  Pscr: Pscr,
  Psi: Psi,
  QUO: QUO,
  QUOT: QUOT$1,
  Qfr: Qfr,
  Qopf: Qopf,
  Qscr: Qscr,
  RBarr: RBarr,
  RE: RE,
  REG: REG$1,
  Racute: Racute,
  Rang: Rang,
  Rarr: Rarr,
  Rarrtl: Rarrtl,
  Rcaron: Rcaron,
  Rcedil: Rcedil,
  Rcy: Rcy,
  Re: Re,
  ReverseElement: ReverseElement,
  ReverseEquilibrium: ReverseEquilibrium,
  ReverseUpEquilibrium: ReverseUpEquilibrium,
  Rfr: Rfr,
  Rho: Rho,
  RightAngleBracket: RightAngleBracket,
  RightArrow: RightArrow,
  RightArrowBar: RightArrowBar,
  RightArrowLeftArrow: RightArrowLeftArrow,
  RightCeiling: RightCeiling,
  RightDoubleBracket: RightDoubleBracket,
  RightDownTeeVector: RightDownTeeVector,
  RightDownVector: RightDownVector,
  RightDownVectorBar: RightDownVectorBar,
  RightFloor: RightFloor,
  RightTee: RightTee,
  RightTeeArrow: RightTeeArrow,
  RightTeeVector: RightTeeVector,
  RightTriangle: RightTriangle,
  RightTriangleBar: RightTriangleBar,
  RightTriangleEqual: RightTriangleEqual,
  RightUpDownVector: RightUpDownVector,
  RightUpTeeVector: RightUpTeeVector,
  RightUpVector: RightUpVector,
  RightUpVectorBar: RightUpVectorBar,
  RightVector: RightVector,
  RightVectorBar: RightVectorBar,
  Rightarrow: Rightarrow,
  Ropf: Ropf,
  RoundImplies: RoundImplies,
  Rrightarrow: Rrightarrow,
  Rscr: Rscr,
  Rsh: Rsh,
  RuleDelayed: RuleDelayed,
  SHCHcy: SHCHcy,
  SHcy: SHcy,
  SOFTcy: SOFTcy,
  Sacute: Sacute,
  Sc: Sc,
  Scaron: Scaron,
  Scedil: Scedil,
  Scirc: Scirc,
  Scy: Scy,
  Sfr: Sfr,
  ShortDownArrow: ShortDownArrow,
  ShortLeftArrow: ShortLeftArrow,
  ShortRightArrow: ShortRightArrow,
  ShortUpArrow: ShortUpArrow,
  Sigma: Sigma,
  SmallCircle: SmallCircle,
  Sopf: Sopf,
  Sqrt: Sqrt,
  Square: Square,
  SquareIntersection: SquareIntersection,
  SquareSubset: SquareSubset,
  SquareSubsetEqual: SquareSubsetEqual,
  SquareSuperset: SquareSuperset,
  SquareSupersetEqual: SquareSupersetEqual,
  SquareUnion: SquareUnion,
  Sscr: Sscr,
  Star: Star,
  Sub: Sub,
  Subset: Subset,
  SubsetEqual: SubsetEqual,
  Succeeds: Succeeds,
  SucceedsEqual: SucceedsEqual,
  SucceedsSlantEqual: SucceedsSlantEqual,
  SucceedsTilde: SucceedsTilde,
  SuchThat: SuchThat,
  Sum: Sum$2,
  Sup: Sup,
  Superset: Superset,
  SupersetEqual: SupersetEqual,
  Supset: Supset,
  THOR: THOR,
  THORN: THORN$1,
  TRADE: TRADE,
  TSHcy: TSHcy,
  TScy: TScy,
  Tab: Tab,
  Tau: Tau,
  Tcaron: Tcaron,
  Tcedil: Tcedil,
  Tcy: Tcy,
  Tfr: Tfr,
  Therefore: Therefore,
  Theta: Theta,
  ThickSpace: ThickSpace,
  ThinSpace: ThinSpace,
  Tilde: Tilde,
  TildeEqual: TildeEqual,
  TildeFullEqual: TildeFullEqual,
  TildeTilde: TildeTilde,
  Topf: Topf,
  TripleDot: TripleDot,
  Tscr: Tscr,
  Tstrok: Tstrok,
  Uacut: Uacut,
  Uacute: Uacute$1,
  Uarr: Uarr,
  Uarrocir: Uarrocir,
  Ubrcy: Ubrcy,
  Ubreve: Ubreve,
  Ucir: Ucir,
  Ucirc: Ucirc$1,
  Ucy: Ucy,
  Udblac: Udblac,
  Ufr: Ufr,
  Ugrav: Ugrav,
  Ugrave: Ugrave$1,
  Umacr: Umacr,
  UnderBar: UnderBar,
  UnderBrace: UnderBrace,
  UnderBracket: UnderBracket,
  UnderParenthesis: UnderParenthesis,
  Union: Union,
  UnionPlus: UnionPlus,
  Uogon: Uogon,
  Uopf: Uopf,
  UpArrow: UpArrow,
  UpArrowBar: UpArrowBar,
  UpArrowDownArrow: UpArrowDownArrow,
  UpDownArrow: UpDownArrow,
  UpEquilibrium: UpEquilibrium,
  UpTee: UpTee,
  UpTeeArrow: UpTeeArrow,
  Uparrow: Uparrow,
  Updownarrow: Updownarrow,
  UpperLeftArrow: UpperLeftArrow,
  UpperRightArrow: UpperRightArrow,
  Upsi: Upsi,
  Upsilon: Upsilon,
  Uring: Uring,
  Uscr: Uscr,
  Utilde: Utilde,
  Uum: Uum,
  Uuml: Uuml$1,
  VDash: VDash,
  Vbar: Vbar,
  Vcy: Vcy,
  Vdash: Vdash,
  Vdashl: Vdashl,
  Vee: Vee,
  Verbar: Verbar,
  Vert: Vert,
  VerticalBar: VerticalBar,
  VerticalLine: VerticalLine,
  VerticalSeparator: VerticalSeparator,
  VerticalTilde: VerticalTilde,
  VeryThinSpace: VeryThinSpace,
  Vfr: Vfr,
  Vopf: Vopf,
  Vscr: Vscr,
  Vvdash: Vvdash,
  Wcirc: Wcirc,
  Wedge: Wedge,
  Wfr: Wfr,
  Wopf: Wopf,
  Wscr: Wscr,
  Xfr: Xfr,
  Xi: Xi,
  Xopf: Xopf,
  Xscr: Xscr,
  YAcy: YAcy,
  YIcy: YIcy,
  YUcy: YUcy,
  Yacut: Yacut,
  Yacute: Yacute$1,
  Ycirc: Ycirc,
  Ycy: Ycy,
  Yfr: Yfr,
  Yopf: Yopf,
  Yscr: Yscr,
  Yuml: Yuml,
  ZHcy: ZHcy,
  Zacute: Zacute,
  Zcaron: Zcaron,
  Zcy: Zcy,
  Zdot: Zdot,
  ZeroWidthSpace: ZeroWidthSpace,
  Zeta: Zeta,
  Zfr: Zfr,
  Zopf: Zopf,
  Zscr: Zscr,
  aacut: aacut,
  aacute: aacute$1,
  abreve: abreve,
  ac: ac,
  acE: acE,
  acd: acd,
  acir: acir,
  acirc: acirc$1,
  acut: acut,
  acute: acute$1,
  acy: acy,
  aeli: aeli,
  aelig: aelig$1,
  af: af,
  afr: afr,
  agrav: agrav,
  agrave: agrave$1,
  alefsym: alefsym,
  aleph: aleph,
  alpha: alpha,
  amacr: amacr,
  amalg: amalg,
  am: am,
  amp: amp$1,
  and: and,
  andand: andand,
  andd: andd,
  andslope: andslope,
  andv: andv,
  ang: ang,
  ange: ange,
  angle: angle,
  angmsd: angmsd,
  angmsdaa: angmsdaa,
  angmsdab: angmsdab,
  angmsdac: angmsdac,
  angmsdad: angmsdad,
  angmsdae: angmsdae,
  angmsdaf: angmsdaf,
  angmsdag: angmsdag,
  angmsdah: angmsdah,
  angrt: angrt,
  angrtvb: angrtvb,
  angrtvbd: angrtvbd,
  angsph: angsph,
  angst: angst,
  angzarr: angzarr,
  aogon: aogon,
  aopf: aopf,
  ap: ap,
  apE: apE,
  apacir: apacir,
  ape: ape,
  apid: apid,
  apos: apos,
  approx: approx,
  approxeq: approxeq,
  arin: arin,
  aring: aring$1,
  ascr: ascr,
  ast: ast,
  asymp: asymp,
  asympeq: asympeq,
  atild: atild,
  atilde: atilde$1,
  aum: aum,
  auml: auml$1,
  awconint: awconint,
  awint: awint,
  bNot: bNot,
  backcong: backcong,
  backepsilon: backepsilon,
  backprime: backprime,
  backsim: backsim,
  backsimeq: backsimeq,
  barvee: barvee,
  barwed: barwed,
  barwedge: barwedge,
  bbrk: bbrk,
  bbrktbrk: bbrktbrk,
  bcong: bcong,
  bcy: bcy,
  bdquo: bdquo,
  becaus: becaus,
  because: because,
  bemptyv: bemptyv,
  bepsi: bepsi,
  bernou: bernou,
  beta: beta,
  beth: beth,
  between: between,
  bfr: bfr,
  bigcap: bigcap,
  bigcirc: bigcirc,
  bigcup: bigcup,
  bigodot: bigodot,
  bigoplus: bigoplus,
  bigotimes: bigotimes,
  bigsqcup: bigsqcup,
  bigstar: bigstar,
  bigtriangledown: bigtriangledown,
  bigtriangleup: bigtriangleup,
  biguplus: biguplus,
  bigvee: bigvee,
  bigwedge: bigwedge,
  bkarow: bkarow,
  blacklozenge: blacklozenge,
  blacksquare: blacksquare,
  blacktriangle: blacktriangle,
  blacktriangledown: blacktriangledown,
  blacktriangleleft: blacktriangleleft,
  blacktriangleright: blacktriangleright,
  blank: blank,
  blk12: blk12,
  blk14: blk14,
  blk34: blk34,
  block: block,
  bne: bne,
  bnequiv: bnequiv,
  bnot: bnot,
  bopf: bopf,
  bot: bot,
  bottom: bottom,
  bowtie: bowtie,
  boxDL: boxDL,
  boxDR: boxDR,
  boxDl: boxDl,
  boxDr: boxDr,
  boxH: boxH,
  boxHD: boxHD,
  boxHU: boxHU,
  boxHd: boxHd,
  boxHu: boxHu,
  boxUL: boxUL,
  boxUR: boxUR,
  boxUl: boxUl,
  boxUr: boxUr,
  boxV: boxV,
  boxVH: boxVH,
  boxVL: boxVL,
  boxVR: boxVR,
  boxVh: boxVh,
  boxVl: boxVl,
  boxVr: boxVr,
  boxbox: boxbox,
  boxdL: boxdL,
  boxdR: boxdR,
  boxdl: boxdl,
  boxdr: boxdr,
  boxh: boxh,
  boxhD: boxhD,
  boxhU: boxhU,
  boxhd: boxhd,
  boxhu: boxhu,
  boxminus: boxminus,
  boxplus: boxplus,
  boxtimes: boxtimes,
  boxuL: boxuL,
  boxuR: boxuR,
  boxul: boxul,
  boxur: boxur,
  boxv: boxv,
  boxvH: boxvH,
  boxvL: boxvL,
  boxvR: boxvR,
  boxvh: boxvh,
  boxvl: boxvl,
  boxvr: boxvr,
  bprime: bprime,
  breve: breve,
  brvba: brvba,
  brvbar: brvbar$1,
  bscr: bscr,
  bsemi: bsemi,
  bsim: bsim,
  bsime: bsime,
  bsol: bsol,
  bsolb: bsolb,
  bsolhsub: bsolhsub,
  bull: bull,
  bullet: bullet,
  bump: bump,
  bumpE: bumpE,
  bumpe: bumpe,
  bumpeq: bumpeq,
  cacute: cacute,
  cap: cap,
  capand: capand,
  capbrcup: capbrcup,
  capcap: capcap,
  capcup: capcup,
  capdot: capdot,
  caps: caps,
  caret: caret,
  caron: caron,
  ccaps: ccaps,
  ccaron: ccaron,
  ccedi: ccedi,
  ccedil: ccedil$1,
  ccirc: ccirc,
  ccups: ccups,
  ccupssm: ccupssm,
  cdot: cdot,
  cedi: cedi,
  cedil: cedil$1,
  cemptyv: cemptyv,
  cen: cen,
  cent: cent$1,
  centerdot: centerdot,
  cfr: cfr,
  chcy: chcy,
  check: check$2,
  checkmark: checkmark,
  chi: chi,
  cir: cir,
  cirE: cirE,
  circ: circ,
  circeq: circeq,
  circlearrowleft: circlearrowleft,
  circlearrowright: circlearrowright,
  circledR: circledR,
  circledS: circledS,
  circledast: circledast,
  circledcirc: circledcirc,
  circleddash: circleddash,
  cire: cire,
  cirfnint: cirfnint,
  cirmid: cirmid,
  cirscir: cirscir,
  clubs: clubs,
  clubsuit: clubsuit,
  colon: colon,
  colone: colone,
  coloneq: coloneq,
  comma: comma,
  commat: commat,
  comp: comp,
  compfn: compfn,
  complement: complement,
  complexes: complexes,
  cong: cong,
  congdot: congdot,
  conint: conint,
  copf: copf,
  coprod: coprod,
  cop: cop,
  copy: copy$1,
  copysr: copysr,
  crarr: crarr,
  cross: cross,
  cscr: cscr,
  csub: csub,
  csube: csube,
  csup: csup,
  csupe: csupe,
  ctdot: ctdot,
  cudarrl: cudarrl,
  cudarrr: cudarrr,
  cuepr: cuepr,
  cuesc: cuesc,
  cularr: cularr,
  cularrp: cularrp,
  cup: cup,
  cupbrcap: cupbrcap,
  cupcap: cupcap,
  cupcup: cupcup,
  cupdot: cupdot,
  cupor: cupor,
  cups: cups,
  curarr: curarr,
  curarrm: curarrm,
  curlyeqprec: curlyeqprec,
  curlyeqsucc: curlyeqsucc,
  curlyvee: curlyvee,
  curlywedge: curlywedge,
  curre: curre,
  curren: curren$1,
  curvearrowleft: curvearrowleft,
  curvearrowright: curvearrowright,
  cuvee: cuvee,
  cuwed: cuwed,
  cwconint: cwconint,
  cwint: cwint,
  cylcty: cylcty,
  dArr: dArr,
  dHar: dHar,
  dagger: dagger,
  daleth: daleth,
  darr: darr,
  dash: dash,
  dashv: dashv,
  dbkarow: dbkarow,
  dblac: dblac,
  dcaron: dcaron,
  dcy: dcy,
  dd: dd,
  ddagger: ddagger,
  ddarr: ddarr,
  ddotseq: ddotseq,
  de: de,
  deg: deg$1,
  delta: delta,
  demptyv: demptyv,
  dfisht: dfisht,
  dfr: dfr,
  dharl: dharl,
  dharr: dharr,
  diam: diam,
  diamond: diamond,
  diamondsuit: diamondsuit,
  diams: diams,
  die: die,
  digamma: digamma,
  disin: disin,
  div: div,
  divid: divid,
  divide: divide$2,
  divideontimes: divideontimes,
  divonx: divonx,
  djcy: djcy,
  dlcorn: dlcorn,
  dlcrop: dlcrop,
  dollar: dollar,
  dopf: dopf,
  dot: dot,
  doteq: doteq,
  doteqdot: doteqdot,
  dotminus: dotminus,
  dotplus: dotplus,
  dotsquare: dotsquare,
  doublebarwedge: doublebarwedge,
  downarrow: downarrow,
  downdownarrows: downdownarrows,
  downharpoonleft: downharpoonleft,
  downharpoonright: downharpoonright,
  drbkarow: drbkarow,
  drcorn: drcorn,
  drcrop: drcrop,
  dscr: dscr,
  dscy: dscy,
  dsol: dsol,
  dstrok: dstrok,
  dtdot: dtdot,
  dtri: dtri,
  dtrif: dtrif,
  duarr: duarr,
  duhar: duhar,
  dwangle: dwangle,
  dzcy: dzcy,
  dzigrarr: dzigrarr,
  eDDot: eDDot,
  eDot: eDot,
  eacut: eacut,
  eacute: eacute$1,
  easter: easter,
  ecaron: ecaron,
  ecir: ecir,
  ecirc: ecirc$1,
  ecolon: ecolon,
  ecy: ecy,
  edot: edot,
  ee: ee,
  efDot: efDot,
  efr: efr,
  eg: eg,
  egrav: egrav,
  egrave: egrave$1,
  egs: egs,
  egsdot: egsdot,
  el: el,
  elinters: elinters,
  ell: ell,
  els: els,
  elsdot: elsdot,
  emacr: emacr,
  empty: empty$1,
  emptyset: emptyset,
  emptyv: emptyv,
  emsp13: emsp13,
  emsp14: emsp14,
  emsp: emsp,
  eng: eng,
  ensp: ensp,
  eogon: eogon,
  eopf: eopf,
  epar: epar,
  eparsl: eparsl,
  eplus: eplus,
  epsi: epsi,
  epsilon: epsilon,
  epsiv: epsiv,
  eqcirc: eqcirc,
  eqcolon: eqcolon,
  eqsim: eqsim,
  eqslantgtr: eqslantgtr,
  eqslantless: eqslantless,
  equals: equals,
  equest: equest,
  equiv: equiv,
  equivDD: equivDD,
  eqvparsl: eqvparsl,
  erDot: erDot,
  erarr: erarr,
  escr: escr,
  esdot: esdot,
  esim: esim,
  eta: eta,
  et: et,
  eth: eth$1,
  eum: eum,
  euml: euml$1,
  euro: euro,
  excl: excl,
  exist: exist,
  expectation: expectation,
  exponentiale: exponentiale,
  fallingdotseq: fallingdotseq,
  fcy: fcy,
  female: female,
  ffilig: ffilig,
  fflig: fflig,
  ffllig: ffllig,
  ffr: ffr,
  filig: filig,
  fjlig: fjlig,
  flat: flat,
  fllig: fllig,
  fltns: fltns,
  fnof: fnof,
  fopf: fopf,
  forall: forall,
  fork: fork,
  forkv: forkv,
  fpartint: fpartint,
  frac1: frac1,
  frac12: frac12$1,
  frac13: frac13,
  frac14: frac14$1,
  frac15: frac15,
  frac16: frac16,
  frac18: frac18,
  frac23: frac23,
  frac25: frac25,
  frac3: frac3,
  frac34: frac34$1,
  frac35: frac35,
  frac38: frac38,
  frac45: frac45,
  frac56: frac56,
  frac58: frac58,
  frac78: frac78,
  frasl: frasl,
  frown: frown,
  fscr: fscr,
  gE: gE,
  gEl: gEl,
  gacute: gacute,
  gamma: gamma,
  gammad: gammad,
  gap: gap,
  gbreve: gbreve,
  gcirc: gcirc,
  gcy: gcy,
  gdot: gdot,
  ge: ge,
  gel: gel,
  geq: geq,
  geqq: geqq,
  geqslant: geqslant,
  ges: ges,
  gescc: gescc,
  gesdot: gesdot,
  gesdoto: gesdoto,
  gesdotol: gesdotol,
  gesl: gesl,
  gesles: gesles,
  gfr: gfr,
  gg: gg,
  ggg: ggg,
  gimel: gimel,
  gjcy: gjcy,
  gl: gl,
  glE: glE,
  gla: gla,
  glj: glj,
  gnE: gnE,
  gnap: gnap,
  gnapprox: gnapprox,
  gne: gne,
  gneq: gneq,
  gneqq: gneqq,
  gnsim: gnsim,
  gopf: gopf,
  grave: grave,
  gscr: gscr,
  gsim: gsim,
  gsime: gsime,
  gsiml: gsiml,
  g: g,
  gt: gt$1,
  gtcc: gtcc,
  gtcir: gtcir,
  gtdot: gtdot,
  gtlPar: gtlPar,
  gtquest: gtquest,
  gtrapprox: gtrapprox,
  gtrarr: gtrarr,
  gtrdot: gtrdot,
  gtreqless: gtreqless,
  gtreqqless: gtreqqless,
  gtrless: gtrless,
  gtrsim: gtrsim,
  gvertneqq: gvertneqq,
  gvnE: gvnE,
  hArr: hArr,
  hairsp: hairsp,
  half: half,
  hamilt: hamilt,
  hardcy: hardcy,
  harr: harr,
  harrcir: harrcir,
  harrw: harrw,
  hbar: hbar,
  hcirc: hcirc,
  hearts: hearts,
  heartsuit: heartsuit,
  hellip: hellip,
  hercon: hercon,
  hfr: hfr,
  hksearow: hksearow,
  hkswarow: hkswarow,
  hoarr: hoarr,
  homtht: homtht,
  hookleftarrow: hookleftarrow,
  hookrightarrow: hookrightarrow,
  hopf: hopf,
  horbar: horbar,
  hscr: hscr,
  hslash: hslash,
  hstrok: hstrok,
  hybull: hybull,
  hyphen: hyphen,
  iacut: iacut,
  iacute: iacute$1,
  ic: ic,
  icir: icir,
  icirc: icirc$1,
  icy: icy,
  iecy: iecy,
  iexc: iexc,
  iexcl: iexcl$1,
  iff: iff,
  ifr: ifr,
  igrav: igrav,
  igrave: igrave$1,
  ii: ii,
  iiiint: iiiint,
  iiint: iiint,
  iinfin: iinfin,
  iiota: iiota,
  ijlig: ijlig,
  imacr: imacr,
  image: image,
  imagline: imagline,
  imagpart: imagpart,
  imath: imath,
  imof: imof,
  imped: imped,
  "in": "∈",
  incare: incare,
  infin: infin,
  infintie: infintie,
  inodot: inodot,
  int: int,
  intcal: intcal,
  integers: integers,
  intercal: intercal,
  intlarhk: intlarhk,
  intprod: intprod,
  iocy: iocy,
  iogon: iogon,
  iopf: iopf,
  iota: iota,
  iprod: iprod,
  iques: iques,
  iquest: iquest$1,
  iscr: iscr,
  isin: isin,
  isinE: isinE,
  isindot: isindot,
  isins: isins,
  isinsv: isinsv,
  isinv: isinv,
  it: it,
  itilde: itilde,
  iukcy: iukcy,
  ium: ium,
  iuml: iuml$1,
  jcirc: jcirc,
  jcy: jcy,
  jfr: jfr,
  jmath: jmath,
  jopf: jopf,
  jscr: jscr,
  jsercy: jsercy,
  jukcy: jukcy,
  kappa: kappa,
  kappav: kappav,
  kcedil: kcedil,
  kcy: kcy,
  kfr: kfr,
  kgreen: kgreen,
  khcy: khcy,
  kjcy: kjcy,
  kopf: kopf,
  kscr: kscr,
  lAarr: lAarr,
  lArr: lArr,
  lAtail: lAtail,
  lBarr: lBarr,
  lE: lE,
  lEg: lEg,
  lHar: lHar,
  lacute: lacute,
  laemptyv: laemptyv,
  lagran: lagran,
  lambda: lambda,
  lang: lang,
  langd: langd,
  langle: langle,
  lap: lap,
  laqu: laqu,
  laquo: laquo$1,
  larr: larr,
  larrb: larrb,
  larrbfs: larrbfs,
  larrfs: larrfs,
  larrhk: larrhk,
  larrlp: larrlp,
  larrpl: larrpl,
  larrsim: larrsim,
  larrtl: larrtl,
  lat: lat,
  latail: latail,
  late: late,
  lates: lates,
  lbarr: lbarr,
  lbbrk: lbbrk,
  lbrace: lbrace,
  lbrack: lbrack,
  lbrke: lbrke,
  lbrksld: lbrksld,
  lbrkslu: lbrkslu,
  lcaron: lcaron,
  lcedil: lcedil,
  lceil: lceil,
  lcub: lcub,
  lcy: lcy,
  ldca: ldca,
  ldquo: ldquo,
  ldquor: ldquor,
  ldrdhar: ldrdhar,
  ldrushar: ldrushar,
  ldsh: ldsh,
  le: le,
  leftarrow: leftarrow,
  leftarrowtail: leftarrowtail,
  leftharpoondown: leftharpoondown,
  leftharpoonup: leftharpoonup,
  leftleftarrows: leftleftarrows,
  leftrightarrow: leftrightarrow,
  leftrightarrows: leftrightarrows,
  leftrightharpoons: leftrightharpoons,
  leftrightsquigarrow: leftrightsquigarrow,
  leftthreetimes: leftthreetimes,
  leg: leg,
  leq: leq,
  leqq: leqq,
  leqslant: leqslant,
  les: les,
  lescc: lescc,
  lesdot: lesdot,
  lesdoto: lesdoto,
  lesdotor: lesdotor,
  lesg: lesg,
  lesges: lesges,
  lessapprox: lessapprox,
  lessdot: lessdot,
  lesseqgtr: lesseqgtr,
  lesseqqgtr: lesseqqgtr,
  lessgtr: lessgtr,
  lesssim: lesssim,
  lfisht: lfisht,
  lfloor: lfloor,
  lfr: lfr,
  lg: lg,
  lgE: lgE,
  lhard: lhard,
  lharu: lharu,
  lharul: lharul,
  lhblk: lhblk,
  ljcy: ljcy,
  ll: ll,
  llarr: llarr,
  llcorner: llcorner,
  llhard: llhard,
  lltri: lltri,
  lmidot: lmidot,
  lmoust: lmoust,
  lmoustache: lmoustache,
  lnE: lnE,
  lnap: lnap,
  lnapprox: lnapprox,
  lne: lne,
  lneq: lneq,
  lneqq: lneqq,
  lnsim: lnsim,
  loang: loang,
  loarr: loarr,
  lobrk: lobrk,
  longleftarrow: longleftarrow,
  longleftrightarrow: longleftrightarrow,
  longmapsto: longmapsto,
  longrightarrow: longrightarrow,
  looparrowleft: looparrowleft,
  looparrowright: looparrowright,
  lopar: lopar,
  lopf: lopf,
  loplus: loplus,
  lotimes: lotimes,
  lowast: lowast,
  lowbar: lowbar,
  loz: loz,
  lozenge: lozenge,
  lozf: lozf,
  lpar: lpar,
  lparlt: lparlt,
  lrarr: lrarr,
  lrcorner: lrcorner,
  lrhar: lrhar,
  lrhard: lrhard,
  lrm: lrm,
  lrtri: lrtri,
  lsaquo: lsaquo,
  lscr: lscr,
  lsh: lsh,
  lsim: lsim,
  lsime: lsime,
  lsimg: lsimg,
  lsqb: lsqb,
  lsquo: lsquo,
  lsquor: lsquor,
  lstrok: lstrok,
  l: l$1,
  lt: lt$1,
  ltcc: ltcc,
  ltcir: ltcir,
  ltdot: ltdot,
  lthree: lthree,
  ltimes: ltimes,
  ltlarr: ltlarr,
  ltquest: ltquest,
  ltrPar: ltrPar,
  ltri: ltri,
  ltrie: ltrie,
  ltrif: ltrif,
  lurdshar: lurdshar,
  luruhar: luruhar,
  lvertneqq: lvertneqq,
  lvnE: lvnE,
  mDDot: mDDot,
  mac: mac,
  macr: macr$1,
  male: male,
  malt: malt,
  maltese: maltese,
  map: map,
  mapsto: mapsto,
  mapstodown: mapstodown,
  mapstoleft: mapstoleft,
  mapstoup: mapstoup,
  marker: marker,
  mcomma: mcomma,
  mcy: mcy,
  mdash: mdash,
  measuredangle: measuredangle,
  mfr: mfr,
  mho: mho,
  micr: micr,
  micro: micro$1,
  mid: mid,
  midast: midast,
  midcir: midcir,
  middo: middo,
  middot: middot$1,
  minus: minus,
  minusb: minusb,
  minusd: minusd,
  minusdu: minusdu,
  mlcp: mlcp,
  mldr: mldr,
  mnplus: mnplus,
  models: models,
  mopf: mopf,
  mp: mp,
  mscr: mscr,
  mstpos: mstpos,
  mu: mu,
  multimap: multimap,
  mumap: mumap,
  nGg: nGg,
  nGt: nGt,
  nGtv: nGtv,
  nLeftarrow: nLeftarrow,
  nLeftrightarrow: nLeftrightarrow,
  nLl: nLl,
  nLt: nLt,
  nLtv: nLtv,
  nRightarrow: nRightarrow,
  nVDash: nVDash,
  nVdash: nVdash,
  nabla: nabla,
  nacute: nacute,
  nang: nang,
  nap: nap,
  napE: napE,
  napid: napid,
  napos: napos,
  napprox: napprox,
  natur: natur,
  natural: natural,
  naturals: naturals,
  nbs: nbs,
  nbsp: nbsp$1,
  nbump: nbump,
  nbumpe: nbumpe,
  ncap: ncap,
  ncaron: ncaron,
  ncedil: ncedil,
  ncong: ncong,
  ncongdot: ncongdot,
  ncup: ncup,
  ncy: ncy,
  ndash: ndash,
  ne: ne,
  neArr: neArr,
  nearhk: nearhk,
  nearr: nearr,
  nearrow: nearrow,
  nedot: nedot,
  nequiv: nequiv,
  nesear: nesear,
  nesim: nesim,
  nexist: nexist,
  nexists: nexists,
  nfr: nfr,
  ngE: ngE,
  nge: nge,
  ngeq: ngeq,
  ngeqq: ngeqq,
  ngeqslant: ngeqslant,
  nges: nges,
  ngsim: ngsim,
  ngt: ngt,
  ngtr: ngtr,
  nhArr: nhArr,
  nharr: nharr,
  nhpar: nhpar,
  ni: ni,
  nis: nis,
  nisd: nisd,
  niv: niv,
  njcy: njcy,
  nlArr: nlArr,
  nlE: nlE,
  nlarr: nlarr,
  nldr: nldr,
  nle: nle,
  nleftarrow: nleftarrow,
  nleftrightarrow: nleftrightarrow,
  nleq: nleq,
  nleqq: nleqq,
  nleqslant: nleqslant,
  nles: nles,
  nless: nless,
  nlsim: nlsim,
  nlt: nlt,
  nltri: nltri,
  nltrie: nltrie,
  nmid: nmid,
  nopf: nopf,
  no: no,
  not: not$1,
  notin: notin,
  notinE: notinE,
  notindot: notindot,
  notinva: notinva,
  notinvb: notinvb,
  notinvc: notinvc,
  notni: notni,
  notniva: notniva,
  notnivb: notnivb,
  notnivc: notnivc,
  npar: npar,
  nparallel: nparallel,
  nparsl: nparsl,
  npart: npart,
  npolint: npolint,
  npr: npr,
  nprcue: nprcue,
  npre: npre,
  nprec: nprec,
  npreceq: npreceq,
  nrArr: nrArr,
  nrarr: nrarr,
  nrarrc: nrarrc,
  nrarrw: nrarrw,
  nrightarrow: nrightarrow,
  nrtri: nrtri,
  nrtrie: nrtrie,
  nsc: nsc,
  nsccue: nsccue,
  nsce: nsce,
  nscr: nscr,
  nshortmid: nshortmid,
  nshortparallel: nshortparallel,
  nsim: nsim,
  nsime: nsime,
  nsimeq: nsimeq,
  nsmid: nsmid,
  nspar: nspar,
  nsqsube: nsqsube,
  nsqsupe: nsqsupe,
  nsub: nsub,
  nsubE: nsubE,
  nsube: nsube,
  nsubset: nsubset,
  nsubseteq: nsubseteq,
  nsubseteqq: nsubseteqq,
  nsucc: nsucc,
  nsucceq: nsucceq,
  nsup: nsup,
  nsupE: nsupE,
  nsupe: nsupe,
  nsupset: nsupset,
  nsupseteq: nsupseteq,
  nsupseteqq: nsupseteqq,
  ntgl: ntgl,
  ntild: ntild,
  ntilde: ntilde$1,
  ntlg: ntlg,
  ntriangleleft: ntriangleleft,
  ntrianglelefteq: ntrianglelefteq,
  ntriangleright: ntriangleright,
  ntrianglerighteq: ntrianglerighteq,
  nu: nu,
  num: num,
  numero: numero,
  numsp: numsp,
  nvDash: nvDash,
  nvHarr: nvHarr,
  nvap: nvap,
  nvdash: nvdash,
  nvge: nvge,
  nvgt: nvgt,
  nvinfin: nvinfin,
  nvlArr: nvlArr,
  nvle: nvle,
  nvlt: nvlt,
  nvltrie: nvltrie,
  nvrArr: nvrArr,
  nvrtrie: nvrtrie,
  nvsim: nvsim,
  nwArr: nwArr,
  nwarhk: nwarhk,
  nwarr: nwarr,
  nwarrow: nwarrow,
  nwnear: nwnear,
  oS: oS,
  oacut: oacut,
  oacute: oacute$1,
  oast: oast,
  ocir: ocir,
  ocirc: ocirc$1,
  ocy: ocy,
  odash: odash,
  odblac: odblac,
  odiv: odiv,
  odot: odot,
  odsold: odsold,
  oelig: oelig,
  ofcir: ofcir,
  ofr: ofr,
  ogon: ogon,
  ograv: ograv,
  ograve: ograve$1,
  ogt: ogt,
  ohbar: ohbar,
  ohm: ohm,
  oint: oint,
  olarr: olarr,
  olcir: olcir,
  olcross: olcross,
  oline: oline,
  olt: olt,
  omacr: omacr,
  omega: omega,
  omicron: omicron,
  omid: omid,
  ominus: ominus,
  oopf: oopf,
  opar: opar,
  operp: operp,
  oplus: oplus,
  or: or,
  orarr: orarr,
  ord: ord,
  order: order$1,
  orderof: orderof,
  ordf: ordf$1,
  ordm: ordm$1,
  origof: origof,
  oror: oror,
  orslope: orslope,
  orv: orv,
  oscr: oscr,
  oslas: oslas,
  oslash: oslash$1,
  osol: osol,
  otild: otild,
  otilde: otilde$1,
  otimes: otimes,
  otimesas: otimesas,
  oum: oum,
  ouml: ouml$1,
  ovbar: ovbar,
  par: par,
  para: para$1,
  parallel: parallel,
  parsim: parsim,
  parsl: parsl,
  part: part,
  pcy: pcy,
  percnt: percnt,
  period: period,
  permil: permil,
  perp: perp,
  pertenk: pertenk,
  pfr: pfr,
  phi: phi,
  phiv: phiv,
  phmmat: phmmat,
  phone: phone,
  pi: pi,
  pitchfork: pitchfork,
  piv: piv,
  planck: planck,
  planckh: planckh,
  plankv: plankv,
  plus: plus,
  plusacir: plusacir,
  plusb: plusb,
  pluscir: pluscir,
  plusdo: plusdo,
  plusdu: plusdu,
  pluse: pluse,
  plusm: plusm,
  plusmn: plusmn$1,
  plussim: plussim,
  plustwo: plustwo,
  pm: pm,
  pointint: pointint,
  popf: popf,
  poun: poun,
  pound: pound$1,
  pr: pr,
  prE: prE,
  prap: prap,
  prcue: prcue,
  pre: pre,
  prec: prec,
  precapprox: precapprox,
  preccurlyeq: preccurlyeq,
  preceq: preceq,
  precnapprox: precnapprox,
  precneqq: precneqq,
  precnsim: precnsim,
  precsim: precsim,
  prime: prime,
  primes: primes,
  prnE: prnE,
  prnap: prnap,
  prnsim: prnsim,
  prod: prod,
  profalar: profalar,
  profline: profline,
  profsurf: profsurf,
  prop: prop,
  propto: propto,
  prsim: prsim,
  prurel: prurel,
  pscr: pscr,
  psi: psi,
  puncsp: puncsp,
  qfr: qfr,
  qint: qint,
  qopf: qopf,
  qprime: qprime,
  qscr: qscr,
  quaternions: quaternions,
  quatint: quatint,
  quest: quest,
  questeq: questeq,
  quo: quo,
  quot: quot$2,
  rAarr: rAarr,
  rArr: rArr,
  rAtail: rAtail,
  rBarr: rBarr,
  rHar: rHar,
  race: race,
  racute: racute,
  radic: radic,
  raemptyv: raemptyv,
  rang: rang,
  rangd: rangd,
  range: range$1,
  rangle: rangle,
  raqu: raqu,
  raquo: raquo$1,
  rarr: rarr,
  rarrap: rarrap,
  rarrb: rarrb,
  rarrbfs: rarrbfs,
  rarrc: rarrc,
  rarrfs: rarrfs,
  rarrhk: rarrhk,
  rarrlp: rarrlp,
  rarrpl: rarrpl,
  rarrsim: rarrsim,
  rarrtl: rarrtl,
  rarrw: rarrw,
  ratail: ratail,
  ratio: ratio,
  rationals: rationals,
  rbarr: rbarr,
  rbbrk: rbbrk,
  rbrace: rbrace,
  rbrack: rbrack,
  rbrke: rbrke,
  rbrksld: rbrksld,
  rbrkslu: rbrkslu,
  rcaron: rcaron,
  rcedil: rcedil,
  rceil: rceil,
  rcub: rcub,
  rcy: rcy,
  rdca: rdca,
  rdldhar: rdldhar,
  rdquo: rdquo,
  rdquor: rdquor,
  rdsh: rdsh,
  real: real,
  realine: realine,
  realpart: realpart,
  reals: reals,
  rect: rect,
  re: re,
  reg: reg$1,
  rfisht: rfisht,
  rfloor: rfloor,
  rfr: rfr,
  rhard: rhard,
  rharu: rharu,
  rharul: rharul,
  rho: rho,
  rhov: rhov,
  rightarrow: rightarrow,
  rightarrowtail: rightarrowtail,
  rightharpoondown: rightharpoondown,
  rightharpoonup: rightharpoonup,
  rightleftarrows: rightleftarrows,
  rightleftharpoons: rightleftharpoons,
  rightrightarrows: rightrightarrows,
  rightsquigarrow: rightsquigarrow,
  rightthreetimes: rightthreetimes,
  ring: ring,
  risingdotseq: risingdotseq,
  rlarr: rlarr,
  rlhar: rlhar,
  rlm: rlm,
  rmoust: rmoust,
  rmoustache: rmoustache,
  rnmid: rnmid,
  roang: roang,
  roarr: roarr,
  robrk: robrk,
  ropar: ropar,
  ropf: ropf,
  roplus: roplus,
  rotimes: rotimes,
  rpar: rpar,
  rpargt: rpargt,
  rppolint: rppolint,
  rrarr: rrarr,
  rsaquo: rsaquo,
  rscr: rscr,
  rsh: rsh,
  rsqb: rsqb,
  rsquo: rsquo,
  rsquor: rsquor,
  rthree: rthree,
  rtimes: rtimes,
  rtri: rtri,
  rtrie: rtrie,
  rtrif: rtrif,
  rtriltri: rtriltri,
  ruluhar: ruluhar,
  rx: rx,
  sacute: sacute,
  sbquo: sbquo,
  sc: sc,
  scE: scE,
  scap: scap,
  scaron: scaron,
  sccue: sccue,
  sce: sce,
  scedil: scedil,
  scirc: scirc,
  scnE: scnE,
  scnap: scnap,
  scnsim: scnsim,
  scpolint: scpolint,
  scsim: scsim,
  scy: scy,
  sdot: sdot,
  sdotb: sdotb,
  sdote: sdote,
  seArr: seArr,
  searhk: searhk,
  searr: searr,
  searrow: searrow,
  sec: sec,
  sect: sect$1,
  semi: semi,
  seswar: seswar,
  setminus: setminus,
  setmn: setmn,
  sext: sext,
  sfr: sfr,
  sfrown: sfrown,
  sharp: sharp,
  shchcy: shchcy,
  shcy: shcy,
  shortmid: shortmid,
  shortparallel: shortparallel,
  sh: sh,
  shy: shy$1,
  sigma: sigma,
  sigmaf: sigmaf,
  sigmav: sigmav,
  sim: sim,
  simdot: simdot,
  sime: sime,
  simeq: simeq,
  simg: simg,
  simgE: simgE,
  siml: siml,
  simlE: simlE,
  simne: simne,
  simplus: simplus,
  simrarr: simrarr,
  slarr: slarr,
  smallsetminus: smallsetminus,
  smashp: smashp,
  smeparsl: smeparsl,
  smid: smid,
  smile: smile,
  smt: smt,
  smte: smte,
  smtes: smtes,
  softcy: softcy,
  sol: sol,
  solb: solb,
  solbar: solbar,
  sopf: sopf,
  spades: spades,
  spadesuit: spadesuit,
  spar: spar,
  sqcap: sqcap,
  sqcaps: sqcaps,
  sqcup: sqcup,
  sqcups: sqcups,
  sqsub: sqsub,
  sqsube: sqsube,
  sqsubset: sqsubset,
  sqsubseteq: sqsubseteq,
  sqsup: sqsup,
  sqsupe: sqsupe,
  sqsupset: sqsupset,
  sqsupseteq: sqsupseteq,
  squ: squ,
  square: square,
  squarf: squarf,
  squf: squf,
  srarr: srarr,
  sscr: sscr,
  ssetmn: ssetmn,
  ssmile: ssmile,
  sstarf: sstarf,
  star: star,
  starf: starf,
  straightepsilon: straightepsilon,
  straightphi: straightphi,
  strns: strns,
  sub: sub,
  subE: subE,
  subdot: subdot,
  sube: sube,
  subedot: subedot,
  submult: submult,
  subnE: subnE,
  subne: subne,
  subplus: subplus,
  subrarr: subrarr,
  subset: subset,
  subseteq: subseteq,
  subseteqq: subseteqq,
  subsetneq: subsetneq,
  subsetneqq: subsetneqq,
  subsim: subsim,
  subsub: subsub,
  subsup: subsup,
  succ: succ,
  succapprox: succapprox,
  succcurlyeq: succcurlyeq,
  succeq: succeq,
  succnapprox: succnapprox,
  succneqq: succneqq,
  succnsim: succnsim,
  succsim: succsim,
  sum: sum,
  sung: sung,
  sup: sup,
  sup1: sup1$1,
  sup2: sup2$1,
  sup3: sup3$1,
  supE: supE,
  supdot: supdot,
  supdsub: supdsub,
  supe: supe,
  supedot: supedot,
  suphsol: suphsol,
  suphsub: suphsub,
  suplarr: suplarr,
  supmult: supmult,
  supnE: supnE,
  supne: supne,
  supplus: supplus,
  supset: supset,
  supseteq: supseteq,
  supseteqq: supseteqq,
  supsetneq: supsetneq,
  supsetneqq: supsetneqq,
  supsim: supsim,
  supsub: supsub,
  supsup: supsup,
  swArr: swArr,
  swarhk: swarhk,
  swarr: swarr,
  swarrow: swarrow,
  swnwar: swnwar,
  szli: szli,
  szlig: szlig$1,
  target: target,
  tau: tau,
  tbrk: tbrk,
  tcaron: tcaron,
  tcedil: tcedil,
  tcy: tcy,
  tdot: tdot,
  telrec: telrec,
  tfr: tfr,
  there4: there4,
  therefore: therefore,
  theta: theta,
  thetasym: thetasym,
  thetav: thetav,
  thickapprox: thickapprox,
  thicksim: thicksim,
  thinsp: thinsp,
  thkap: thkap,
  thksim: thksim,
  thor: thor,
  thorn: thorn$1,
  tilde: tilde,
  time: time,
  times: times$1,
  timesb: timesb,
  timesbar: timesbar,
  timesd: timesd,
  tint: tint,
  toea: toea,
  top: top,
  topbot: topbot,
  topcir: topcir,
  topf: topf,
  topfork: topfork,
  tosa: tosa,
  tprime: tprime,
  trade: trade,
  triangle: triangle,
  triangledown: triangledown,
  triangleleft: triangleleft,
  trianglelefteq: trianglelefteq,
  triangleq: triangleq,
  triangleright: triangleright,
  trianglerighteq: trianglerighteq,
  tridot: tridot,
  trie: trie,
  triminus: triminus,
  triplus: triplus,
  trisb: trisb,
  tritime: tritime,
  trpezium: trpezium,
  tscr: tscr,
  tscy: tscy,
  tshcy: tshcy,
  tstrok: tstrok,
  twixt: twixt,
  twoheadleftarrow: twoheadleftarrow,
  twoheadrightarrow: twoheadrightarrow,
  uArr: uArr,
  uHar: uHar,
  uacut: uacut,
  uacute: uacute$1,
  uarr: uarr,
  ubrcy: ubrcy,
  ubreve: ubreve,
  ucir: ucir,
  ucirc: ucirc$1,
  ucy: ucy,
  udarr: udarr,
  udblac: udblac,
  udhar: udhar,
  ufisht: ufisht,
  ufr: ufr,
  ugrav: ugrav,
  ugrave: ugrave$1,
  uharl: uharl,
  uharr: uharr,
  uhblk: uhblk,
  ulcorn: ulcorn,
  ulcorner: ulcorner,
  ulcrop: ulcrop,
  ultri: ultri,
  umacr: umacr,
  um: um,
  uml: uml$1,
  uogon: uogon,
  uopf: uopf,
  uparrow: uparrow,
  updownarrow: updownarrow,
  upharpoonleft: upharpoonleft,
  upharpoonright: upharpoonright,
  uplus: uplus,
  upsi: upsi,
  upsih: upsih,
  upsilon: upsilon,
  upuparrows: upuparrows,
  urcorn: urcorn,
  urcorner: urcorner,
  urcrop: urcrop,
  uring: uring,
  urtri: urtri,
  uscr: uscr,
  utdot: utdot,
  utilde: utilde,
  utri: utri,
  utrif: utrif,
  uuarr: uuarr,
  uum: uum,
  uuml: uuml$1,
  uwangle: uwangle,
  vArr: vArr,
  vBar: vBar,
  vBarv: vBarv,
  vDash: vDash,
  vangrt: vangrt,
  varepsilon: varepsilon,
  varkappa: varkappa,
  varnothing: varnothing,
  varphi: varphi,
  varpi: varpi,
  varpropto: varpropto,
  varr: varr,
  varrho: varrho,
  varsigma: varsigma,
  varsubsetneq: varsubsetneq,
  varsubsetneqq: varsubsetneqq,
  varsupsetneq: varsupsetneq,
  varsupsetneqq: varsupsetneqq,
  vartheta: vartheta,
  vartriangleleft: vartriangleleft,
  vartriangleright: vartriangleright,
  vcy: vcy,
  vdash: vdash,
  vee: vee,
  veebar: veebar,
  veeeq: veeeq,
  vellip: vellip,
  verbar: verbar,
  vert: vert,
  vfr: vfr,
  vltri: vltri,
  vnsub: vnsub,
  vnsup: vnsup,
  vopf: vopf,
  vprop: vprop,
  vrtri: vrtri,
  vscr: vscr,
  vsubnE: vsubnE,
  vsubne: vsubne,
  vsupnE: vsupnE,
  vsupne: vsupne,
  vzigzag: vzigzag,
  wcirc: wcirc,
  wedbar: wedbar,
  wedge: wedge,
  wedgeq: wedgeq,
  weierp: weierp,
  wfr: wfr,
  wopf: wopf,
  wp: wp,
  wr: wr,
  wreath: wreath,
  wscr: wscr,
  xcap: xcap,
  xcirc: xcirc,
  xcup: xcup,
  xdtri: xdtri,
  xfr: xfr,
  xhArr: xhArr,
  xharr: xharr,
  xi: xi,
  xlArr: xlArr,
  xlarr: xlarr,
  xmap: xmap,
  xnis: xnis,
  xodot: xodot,
  xopf: xopf,
  xoplus: xoplus,
  xotime: xotime,
  xrArr: xrArr,
  xrarr: xrarr,
  xscr: xscr,
  xsqcup: xsqcup,
  xuplus: xuplus,
  xutri: xutri,
  xvee: xvee,
  xwedge: xwedge,
  yacut: yacut,
  yacute: yacute$1,
  yacy: yacy,
  ycirc: ycirc,
  ycy: ycy,
  ye: ye,
  yen: yen$1,
  yfr: yfr,
  yicy: yicy,
  yopf: yopf,
  yscr: yscr,
  yucy: yucy,
  yum: yum,
  yuml: yuml$1,
  zacute: zacute,
  zcaron: zcaron,
  zcy: zcy,
  zdot: zdot,
  zeetrf: zeetrf,
  zeta: zeta,
  zfr: zfr,
  zhcy: zhcy,
  zigrarr: zigrarr,
  zopf: zopf,
  zscr: zscr,
  zwj: zwj,
  zwnj: zwnj
};
var characterEntities =
/*#__PURE__*/
Object.freeze({
  AEli: AEli,
  AElig: AElig$1,
  AM: AM,
  AMP: AMP$1,
  Aacut: Aacut,
  Aacute: Aacute$1,
  Abreve: Abreve,
  Acir: Acir,
  Acirc: Acirc$1,
  Acy: Acy,
  Afr: Afr,
  Agrav: Agrav,
  Agrave: Agrave$1,
  Alpha: Alpha,
  Amacr: Amacr,
  And: And,
  Aogon: Aogon,
  Aopf: Aopf,
  ApplyFunction: ApplyFunction,
  Arin: Arin,
  Aring: Aring$1,
  Ascr: Ascr,
  Assign: Assign,
  Atild: Atild,
  Atilde: Atilde$1,
  Aum: Aum,
  Auml: Auml$1,
  Backslash: Backslash,
  Barv: Barv,
  Barwed: Barwed,
  Bcy: Bcy,
  Because: Because,
  Bernoullis: Bernoullis,
  Beta: Beta,
  Bfr: Bfr,
  Bopf: Bopf,
  Breve: Breve,
  Bscr: Bscr,
  Bumpeq: Bumpeq,
  CHcy: CHcy,
  COP: COP,
  COPY: COPY$1,
  Cacute: Cacute,
  Cap: Cap,
  CapitalDifferentialD: CapitalDifferentialD,
  Cayleys: Cayleys,
  Ccaron: Ccaron,
  Ccedi: Ccedi,
  Ccedil: Ccedil$1,
  Ccirc: Ccirc,
  Cconint: Cconint,
  Cdot: Cdot,
  Cedilla: Cedilla,
  CenterDot: CenterDot,
  Cfr: Cfr,
  Chi: Chi,
  CircleDot: CircleDot,
  CircleMinus: CircleMinus,
  CirclePlus: CirclePlus,
  CircleTimes: CircleTimes,
  ClockwiseContourIntegral: ClockwiseContourIntegral,
  CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
  CloseCurlyQuote: CloseCurlyQuote,
  Colon: Colon,
  Colone: Colone,
  Congruent: Congruent,
  Conint: Conint,
  ContourIntegral: ContourIntegral,
  Copf: Copf,
  Coproduct: Coproduct,
  CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
  Cross: Cross,
  Cscr: Cscr,
  Cup: Cup,
  CupCap: CupCap,
  DD: DD,
  DDotrahd: DDotrahd,
  DJcy: DJcy,
  DScy: DScy,
  DZcy: DZcy,
  Dagger: Dagger,
  Darr: Darr,
  Dashv: Dashv,
  Dcaron: Dcaron,
  Dcy: Dcy,
  Del: Del,
  Delta: Delta,
  Dfr: Dfr,
  DiacriticalAcute: DiacriticalAcute,
  DiacriticalDot: DiacriticalDot,
  DiacriticalDoubleAcute: DiacriticalDoubleAcute,
  DiacriticalGrave: DiacriticalGrave,
  DiacriticalTilde: DiacriticalTilde,
  Diamond: Diamond,
  DifferentialD: DifferentialD,
  Dopf: Dopf,
  Dot: Dot,
  DotDot: DotDot,
  DotEqual: DotEqual,
  DoubleContourIntegral: DoubleContourIntegral,
  DoubleDot: DoubleDot,
  DoubleDownArrow: DoubleDownArrow,
  DoubleLeftArrow: DoubleLeftArrow,
  DoubleLeftRightArrow: DoubleLeftRightArrow,
  DoubleLeftTee: DoubleLeftTee,
  DoubleLongLeftArrow: DoubleLongLeftArrow,
  DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
  DoubleLongRightArrow: DoubleLongRightArrow,
  DoubleRightArrow: DoubleRightArrow,
  DoubleRightTee: DoubleRightTee,
  DoubleUpArrow: DoubleUpArrow,
  DoubleUpDownArrow: DoubleUpDownArrow,
  DoubleVerticalBar: DoubleVerticalBar,
  DownArrow: DownArrow,
  DownArrowBar: DownArrowBar,
  DownArrowUpArrow: DownArrowUpArrow,
  DownBreve: DownBreve,
  DownLeftRightVector: DownLeftRightVector,
  DownLeftTeeVector: DownLeftTeeVector,
  DownLeftVector: DownLeftVector,
  DownLeftVectorBar: DownLeftVectorBar,
  DownRightTeeVector: DownRightTeeVector,
  DownRightVector: DownRightVector,
  DownRightVectorBar: DownRightVectorBar,
  DownTee: DownTee,
  DownTeeArrow: DownTeeArrow,
  Downarrow: Downarrow,
  Dscr: Dscr,
  Dstrok: Dstrok,
  ENG: ENG,
  ET: ET,
  ETH: ETH$1,
  Eacut: Eacut,
  Eacute: Eacute$1,
  Ecaron: Ecaron,
  Ecir: Ecir,
  Ecirc: Ecirc$1,
  Ecy: Ecy,
  Edot: Edot,
  Efr: Efr,
  Egrav: Egrav,
  Egrave: Egrave$1,
  Element: Element$1,
  Emacr: Emacr,
  EmptySmallSquare: EmptySmallSquare,
  EmptyVerySmallSquare: EmptyVerySmallSquare,
  Eogon: Eogon,
  Eopf: Eopf,
  Epsilon: Epsilon,
  Equal: Equal,
  EqualTilde: EqualTilde,
  Equilibrium: Equilibrium,
  Escr: Escr,
  Esim: Esim,
  Eta: Eta,
  Eum: Eum,
  Euml: Euml$1,
  Exists: Exists,
  ExponentialE: ExponentialE,
  Fcy: Fcy,
  Ffr: Ffr,
  FilledSmallSquare: FilledSmallSquare,
  FilledVerySmallSquare: FilledVerySmallSquare,
  Fopf: Fopf,
  ForAll: ForAll,
  Fouriertrf: Fouriertrf,
  Fscr: Fscr,
  GJcy: GJcy,
  G: G,
  GT: GT$1,
  Gamma: Gamma,
  Gammad: Gammad,
  Gbreve: Gbreve,
  Gcedil: Gcedil,
  Gcirc: Gcirc,
  Gcy: Gcy,
  Gdot: Gdot,
  Gfr: Gfr,
  Gg: Gg,
  Gopf: Gopf,
  GreaterEqual: GreaterEqual,
  GreaterEqualLess: GreaterEqualLess,
  GreaterFullEqual: GreaterFullEqual,
  GreaterGreater: GreaterGreater,
  GreaterLess: GreaterLess,
  GreaterSlantEqual: GreaterSlantEqual,
  GreaterTilde: GreaterTilde,
  Gscr: Gscr,
  Gt: Gt,
  HARDcy: HARDcy,
  Hacek: Hacek,
  Hat: Hat,
  Hcirc: Hcirc,
  Hfr: Hfr,
  HilbertSpace: HilbertSpace,
  Hopf: Hopf,
  HorizontalLine: HorizontalLine,
  Hscr: Hscr,
  Hstrok: Hstrok,
  HumpDownHump: HumpDownHump,
  HumpEqual: HumpEqual,
  IEcy: IEcy,
  IJlig: IJlig,
  IOcy: IOcy,
  Iacut: Iacut,
  Iacute: Iacute$1,
  Icir: Icir,
  Icirc: Icirc$1,
  Icy: Icy,
  Idot: Idot,
  Ifr: Ifr,
  Igrav: Igrav,
  Igrave: Igrave$1,
  Im: Im,
  Imacr: Imacr,
  ImaginaryI: ImaginaryI,
  Implies: Implies,
  Int: Int,
  Integral: Integral,
  Intersection: Intersection,
  InvisibleComma: InvisibleComma,
  InvisibleTimes: InvisibleTimes,
  Iogon: Iogon,
  Iopf: Iopf,
  Iota: Iota,
  Iscr: Iscr,
  Itilde: Itilde,
  Iukcy: Iukcy,
  Ium: Ium,
  Iuml: Iuml$1,
  Jcirc: Jcirc,
  Jcy: Jcy,
  Jfr: Jfr,
  Jopf: Jopf,
  Jscr: Jscr,
  Jsercy: Jsercy,
  Jukcy: Jukcy,
  KHcy: KHcy,
  KJcy: KJcy,
  Kappa: Kappa,
  Kcedil: Kcedil,
  Kcy: Kcy,
  Kfr: Kfr,
  Kopf: Kopf,
  Kscr: Kscr,
  LJcy: LJcy,
  L: L,
  LT: LT$1,
  Lacute: Lacute,
  Lambda: Lambda,
  Lang: Lang,
  Laplacetrf: Laplacetrf,
  Larr: Larr,
  Lcaron: Lcaron,
  Lcedil: Lcedil,
  Lcy: Lcy,
  LeftAngleBracket: LeftAngleBracket,
  LeftArrow: LeftArrow,
  LeftArrowBar: LeftArrowBar,
  LeftArrowRightArrow: LeftArrowRightArrow,
  LeftCeiling: LeftCeiling,
  LeftDoubleBracket: LeftDoubleBracket,
  LeftDownTeeVector: LeftDownTeeVector,
  LeftDownVector: LeftDownVector,
  LeftDownVectorBar: LeftDownVectorBar,
  LeftFloor: LeftFloor,
  LeftRightArrow: LeftRightArrow,
  LeftRightVector: LeftRightVector,
  LeftTee: LeftTee,
  LeftTeeArrow: LeftTeeArrow,
  LeftTeeVector: LeftTeeVector,
  LeftTriangle: LeftTriangle,
  LeftTriangleBar: LeftTriangleBar,
  LeftTriangleEqual: LeftTriangleEqual,
  LeftUpDownVector: LeftUpDownVector,
  LeftUpTeeVector: LeftUpTeeVector,
  LeftUpVector: LeftUpVector,
  LeftUpVectorBar: LeftUpVectorBar,
  LeftVector: LeftVector,
  LeftVectorBar: LeftVectorBar,
  Leftarrow: Leftarrow,
  Leftrightarrow: Leftrightarrow,
  LessEqualGreater: LessEqualGreater,
  LessFullEqual: LessFullEqual,
  LessGreater: LessGreater,
  LessLess: LessLess,
  LessSlantEqual: LessSlantEqual,
  LessTilde: LessTilde,
  Lfr: Lfr,
  Ll: Ll,
  Lleftarrow: Lleftarrow,
  Lmidot: Lmidot,
  LongLeftArrow: LongLeftArrow,
  LongLeftRightArrow: LongLeftRightArrow,
  LongRightArrow: LongRightArrow,
  Longleftarrow: Longleftarrow,
  Longleftrightarrow: Longleftrightarrow,
  Longrightarrow: Longrightarrow,
  Lopf: Lopf,
  LowerLeftArrow: LowerLeftArrow,
  LowerRightArrow: LowerRightArrow,
  Lscr: Lscr,
  Lsh: Lsh,
  Lstrok: Lstrok,
  Lt: Lt,
  Mcy: Mcy,
  MediumSpace: MediumSpace,
  Mellintrf: Mellintrf,
  Mfr: Mfr,
  MinusPlus: MinusPlus,
  Mopf: Mopf,
  Mscr: Mscr,
  Mu: Mu,
  NJcy: NJcy,
  Nacute: Nacute,
  Ncaron: Ncaron,
  Ncedil: Ncedil,
  Ncy: Ncy,
  NegativeMediumSpace: NegativeMediumSpace,
  NegativeThickSpace: NegativeThickSpace,
  NegativeThinSpace: NegativeThinSpace,
  NegativeVeryThinSpace: NegativeVeryThinSpace,
  NestedGreaterGreater: NestedGreaterGreater,
  NestedLessLess: NestedLessLess,
  NewLine: NewLine,
  Nfr: Nfr,
  NoBreak: NoBreak,
  NonBreakingSpace: NonBreakingSpace,
  Nopf: Nopf,
  Not: Not,
  NotCongruent: NotCongruent,
  NotCupCap: NotCupCap,
  NotDoubleVerticalBar: NotDoubleVerticalBar,
  NotElement: NotElement,
  NotEqual: NotEqual,
  NotEqualTilde: NotEqualTilde,
  NotExists: NotExists,
  NotGreater: NotGreater,
  NotGreaterEqual: NotGreaterEqual,
  NotGreaterFullEqual: NotGreaterFullEqual,
  NotGreaterGreater: NotGreaterGreater,
  NotGreaterLess: NotGreaterLess,
  NotGreaterSlantEqual: NotGreaterSlantEqual,
  NotGreaterTilde: NotGreaterTilde,
  NotHumpDownHump: NotHumpDownHump,
  NotHumpEqual: NotHumpEqual,
  NotLeftTriangle: NotLeftTriangle,
  NotLeftTriangleBar: NotLeftTriangleBar,
  NotLeftTriangleEqual: NotLeftTriangleEqual,
  NotLess: NotLess,
  NotLessEqual: NotLessEqual,
  NotLessGreater: NotLessGreater,
  NotLessLess: NotLessLess,
  NotLessSlantEqual: NotLessSlantEqual,
  NotLessTilde: NotLessTilde,
  NotNestedGreaterGreater: NotNestedGreaterGreater,
  NotNestedLessLess: NotNestedLessLess,
  NotPrecedes: NotPrecedes,
  NotPrecedesEqual: NotPrecedesEqual,
  NotPrecedesSlantEqual: NotPrecedesSlantEqual,
  NotReverseElement: NotReverseElement,
  NotRightTriangle: NotRightTriangle,
  NotRightTriangleBar: NotRightTriangleBar,
  NotRightTriangleEqual: NotRightTriangleEqual,
  NotSquareSubset: NotSquareSubset,
  NotSquareSubsetEqual: NotSquareSubsetEqual,
  NotSquareSuperset: NotSquareSuperset,
  NotSquareSupersetEqual: NotSquareSupersetEqual,
  NotSubset: NotSubset,
  NotSubsetEqual: NotSubsetEqual,
  NotSucceeds: NotSucceeds,
  NotSucceedsEqual: NotSucceedsEqual,
  NotSucceedsSlantEqual: NotSucceedsSlantEqual,
  NotSucceedsTilde: NotSucceedsTilde,
  NotSuperset: NotSuperset,
  NotSupersetEqual: NotSupersetEqual,
  NotTilde: NotTilde,
  NotTildeEqual: NotTildeEqual,
  NotTildeFullEqual: NotTildeFullEqual,
  NotTildeTilde: NotTildeTilde,
  NotVerticalBar: NotVerticalBar,
  Nscr: Nscr,
  Ntild: Ntild,
  Ntilde: Ntilde$1,
  Nu: Nu,
  OElig: OElig,
  Oacut: Oacut,
  Oacute: Oacute$1,
  Ocir: Ocir,
  Ocirc: Ocirc$1,
  Ocy: Ocy,
  Odblac: Odblac,
  Ofr: Ofr,
  Ograv: Ograv,
  Ograve: Ograve$1,
  Omacr: Omacr,
  Omega: Omega,
  Omicron: Omicron,
  Oopf: Oopf,
  OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
  OpenCurlyQuote: OpenCurlyQuote,
  Or: Or,
  Oscr: Oscr,
  Oslas: Oslas,
  Oslash: Oslash$1,
  Otild: Otild,
  Otilde: Otilde$1,
  Otimes: Otimes,
  Oum: Oum,
  Ouml: Ouml$1,
  OverBar: OverBar,
  OverBrace: OverBrace,
  OverBracket: OverBracket,
  OverParenthesis: OverParenthesis,
  PartialD: PartialD,
  Pcy: Pcy,
  Pfr: Pfr,
  Phi: Phi,
  Pi: Pi,
  PlusMinus: PlusMinus,
  Poincareplane: Poincareplane,
  Popf: Popf,
  Pr: Pr,
  Precedes: Precedes,
  PrecedesEqual: PrecedesEqual,
  PrecedesSlantEqual: PrecedesSlantEqual,
  PrecedesTilde: PrecedesTilde,
  Prime: Prime,
  Product: Product,
  Proportion: Proportion,
  Proportional: Proportional,
  Pscr: Pscr,
  Psi: Psi,
  QUO: QUO,
  QUOT: QUOT$1,
  Qfr: Qfr,
  Qopf: Qopf,
  Qscr: Qscr,
  RBarr: RBarr,
  RE: RE,
  REG: REG$1,
  Racute: Racute,
  Rang: Rang,
  Rarr: Rarr,
  Rarrtl: Rarrtl,
  Rcaron: Rcaron,
  Rcedil: Rcedil,
  Rcy: Rcy,
  Re: Re,
  ReverseElement: ReverseElement,
  ReverseEquilibrium: ReverseEquilibrium,
  ReverseUpEquilibrium: ReverseUpEquilibrium,
  Rfr: Rfr,
  Rho: Rho,
  RightAngleBracket: RightAngleBracket,
  RightArrow: RightArrow,
  RightArrowBar: RightArrowBar,
  RightArrowLeftArrow: RightArrowLeftArrow,
  RightCeiling: RightCeiling,
  RightDoubleBracket: RightDoubleBracket,
  RightDownTeeVector: RightDownTeeVector,
  RightDownVector: RightDownVector,
  RightDownVectorBar: RightDownVectorBar,
  RightFloor: RightFloor,
  RightTee: RightTee,
  RightTeeArrow: RightTeeArrow,
  RightTeeVector: RightTeeVector,
  RightTriangle: RightTriangle,
  RightTriangleBar: RightTriangleBar,
  RightTriangleEqual: RightTriangleEqual,
  RightUpDownVector: RightUpDownVector,
  RightUpTeeVector: RightUpTeeVector,
  RightUpVector: RightUpVector,
  RightUpVectorBar: RightUpVectorBar,
  RightVector: RightVector,
  RightVectorBar: RightVectorBar,
  Rightarrow: Rightarrow,
  Ropf: Ropf,
  RoundImplies: RoundImplies,
  Rrightarrow: Rrightarrow,
  Rscr: Rscr,
  Rsh: Rsh,
  RuleDelayed: RuleDelayed,
  SHCHcy: SHCHcy,
  SHcy: SHcy,
  SOFTcy: SOFTcy,
  Sacute: Sacute,
  Sc: Sc,
  Scaron: Scaron,
  Scedil: Scedil,
  Scirc: Scirc,
  Scy: Scy,
  Sfr: Sfr,
  ShortDownArrow: ShortDownArrow,
  ShortLeftArrow: ShortLeftArrow,
  ShortRightArrow: ShortRightArrow,
  ShortUpArrow: ShortUpArrow,
  Sigma: Sigma,
  SmallCircle: SmallCircle,
  Sopf: Sopf,
  Sqrt: Sqrt,
  Square: Square,
  SquareIntersection: SquareIntersection,
  SquareSubset: SquareSubset,
  SquareSubsetEqual: SquareSubsetEqual,
  SquareSuperset: SquareSuperset,
  SquareSupersetEqual: SquareSupersetEqual,
  SquareUnion: SquareUnion,
  Sscr: Sscr,
  Star: Star,
  Sub: Sub,
  Subset: Subset,
  SubsetEqual: SubsetEqual,
  Succeeds: Succeeds,
  SucceedsEqual: SucceedsEqual,
  SucceedsSlantEqual: SucceedsSlantEqual,
  SucceedsTilde: SucceedsTilde,
  SuchThat: SuchThat,
  Sum: Sum$2,
  Sup: Sup,
  Superset: Superset,
  SupersetEqual: SupersetEqual,
  Supset: Supset,
  THOR: THOR,
  THORN: THORN$1,
  TRADE: TRADE,
  TSHcy: TSHcy,
  TScy: TScy,
  Tab: Tab,
  Tau: Tau,
  Tcaron: Tcaron,
  Tcedil: Tcedil,
  Tcy: Tcy,
  Tfr: Tfr,
  Therefore: Therefore,
  Theta: Theta,
  ThickSpace: ThickSpace,
  ThinSpace: ThinSpace,
  Tilde: Tilde,
  TildeEqual: TildeEqual,
  TildeFullEqual: TildeFullEqual,
  TildeTilde: TildeTilde,
  Topf: Topf,
  TripleDot: TripleDot,
  Tscr: Tscr,
  Tstrok: Tstrok,
  Uacut: Uacut,
  Uacute: Uacute$1,
  Uarr: Uarr,
  Uarrocir: Uarrocir,
  Ubrcy: Ubrcy,
  Ubreve: Ubreve,
  Ucir: Ucir,
  Ucirc: Ucirc$1,
  Ucy: Ucy,
  Udblac: Udblac,
  Ufr: Ufr,
  Ugrav: Ugrav,
  Ugrave: Ugrave$1,
  Umacr: Umacr,
  UnderBar: UnderBar,
  UnderBrace: UnderBrace,
  UnderBracket: UnderBracket,
  UnderParenthesis: UnderParenthesis,
  Union: Union,
  UnionPlus: UnionPlus,
  Uogon: Uogon,
  Uopf: Uopf,
  UpArrow: UpArrow,
  UpArrowBar: UpArrowBar,
  UpArrowDownArrow: UpArrowDownArrow,
  UpDownArrow: UpDownArrow,
  UpEquilibrium: UpEquilibrium,
  UpTee: UpTee,
  UpTeeArrow: UpTeeArrow,
  Uparrow: Uparrow,
  Updownarrow: Updownarrow,
  UpperLeftArrow: UpperLeftArrow,
  UpperRightArrow: UpperRightArrow,
  Upsi: Upsi,
  Upsilon: Upsilon,
  Uring: Uring,
  Uscr: Uscr,
  Utilde: Utilde,
  Uum: Uum,
  Uuml: Uuml$1,
  VDash: VDash,
  Vbar: Vbar,
  Vcy: Vcy,
  Vdash: Vdash,
  Vdashl: Vdashl,
  Vee: Vee,
  Verbar: Verbar,
  Vert: Vert,
  VerticalBar: VerticalBar,
  VerticalLine: VerticalLine,
  VerticalSeparator: VerticalSeparator,
  VerticalTilde: VerticalTilde,
  VeryThinSpace: VeryThinSpace,
  Vfr: Vfr,
  Vopf: Vopf,
  Vscr: Vscr,
  Vvdash: Vvdash,
  Wcirc: Wcirc,
  Wedge: Wedge,
  Wfr: Wfr,
  Wopf: Wopf,
  Wscr: Wscr,
  Xfr: Xfr,
  Xi: Xi,
  Xopf: Xopf,
  Xscr: Xscr,
  YAcy: YAcy,
  YIcy: YIcy,
  YUcy: YUcy,
  Yacut: Yacut,
  Yacute: Yacute$1,
  Ycirc: Ycirc,
  Ycy: Ycy,
  Yfr: Yfr,
  Yopf: Yopf,
  Yscr: Yscr,
  Yuml: Yuml,
  ZHcy: ZHcy,
  Zacute: Zacute,
  Zcaron: Zcaron,
  Zcy: Zcy,
  Zdot: Zdot,
  ZeroWidthSpace: ZeroWidthSpace,
  Zeta: Zeta,
  Zfr: Zfr,
  Zopf: Zopf,
  Zscr: Zscr,
  aacut: aacut,
  aacute: aacute$1,
  abreve: abreve,
  ac: ac,
  acE: acE,
  acd: acd,
  acir: acir,
  acirc: acirc$1,
  acut: acut,
  acute: acute$1,
  acy: acy,
  aeli: aeli,
  aelig: aelig$1,
  af: af,
  afr: afr,
  agrav: agrav,
  agrave: agrave$1,
  alefsym: alefsym,
  aleph: aleph,
  alpha: alpha,
  amacr: amacr,
  amalg: amalg,
  am: am,
  amp: amp$1,
  and: and,
  andand: andand,
  andd: andd,
  andslope: andslope,
  andv: andv,
  ang: ang,
  ange: ange,
  angle: angle,
  angmsd: angmsd,
  angmsdaa: angmsdaa,
  angmsdab: angmsdab,
  angmsdac: angmsdac,
  angmsdad: angmsdad,
  angmsdae: angmsdae,
  angmsdaf: angmsdaf,
  angmsdag: angmsdag,
  angmsdah: angmsdah,
  angrt: angrt,
  angrtvb: angrtvb,
  angrtvbd: angrtvbd,
  angsph: angsph,
  angst: angst,
  angzarr: angzarr,
  aogon: aogon,
  aopf: aopf,
  ap: ap,
  apE: apE,
  apacir: apacir,
  ape: ape,
  apid: apid,
  apos: apos,
  approx: approx,
  approxeq: approxeq,
  arin: arin,
  aring: aring$1,
  ascr: ascr,
  ast: ast,
  asymp: asymp,
  asympeq: asympeq,
  atild: atild,
  atilde: atilde$1,
  aum: aum,
  auml: auml$1,
  awconint: awconint,
  awint: awint,
  bNot: bNot,
  backcong: backcong,
  backepsilon: backepsilon,
  backprime: backprime,
  backsim: backsim,
  backsimeq: backsimeq,
  barvee: barvee,
  barwed: barwed,
  barwedge: barwedge,
  bbrk: bbrk,
  bbrktbrk: bbrktbrk,
  bcong: bcong,
  bcy: bcy,
  bdquo: bdquo,
  becaus: becaus,
  because: because,
  bemptyv: bemptyv,
  bepsi: bepsi,
  bernou: bernou,
  beta: beta,
  beth: beth,
  between: between,
  bfr: bfr,
  bigcap: bigcap,
  bigcirc: bigcirc,
  bigcup: bigcup,
  bigodot: bigodot,
  bigoplus: bigoplus,
  bigotimes: bigotimes,
  bigsqcup: bigsqcup,
  bigstar: bigstar,
  bigtriangledown: bigtriangledown,
  bigtriangleup: bigtriangleup,
  biguplus: biguplus,
  bigvee: bigvee,
  bigwedge: bigwedge,
  bkarow: bkarow,
  blacklozenge: blacklozenge,
  blacksquare: blacksquare,
  blacktriangle: blacktriangle,
  blacktriangledown: blacktriangledown,
  blacktriangleleft: blacktriangleleft,
  blacktriangleright: blacktriangleright,
  blank: blank,
  blk12: blk12,
  blk14: blk14,
  blk34: blk34,
  block: block,
  bne: bne,
  bnequiv: bnequiv,
  bnot: bnot,
  bopf: bopf,
  bot: bot,
  bottom: bottom,
  bowtie: bowtie,
  boxDL: boxDL,
  boxDR: boxDR,
  boxDl: boxDl,
  boxDr: boxDr,
  boxH: boxH,
  boxHD: boxHD,
  boxHU: boxHU,
  boxHd: boxHd,
  boxHu: boxHu,
  boxUL: boxUL,
  boxUR: boxUR,
  boxUl: boxUl,
  boxUr: boxUr,
  boxV: boxV,
  boxVH: boxVH,
  boxVL: boxVL,
  boxVR: boxVR,
  boxVh: boxVh,
  boxVl: boxVl,
  boxVr: boxVr,
  boxbox: boxbox,
  boxdL: boxdL,
  boxdR: boxdR,
  boxdl: boxdl,
  boxdr: boxdr,
  boxh: boxh,
  boxhD: boxhD,
  boxhU: boxhU,
  boxhd: boxhd,
  boxhu: boxhu,
  boxminus: boxminus,
  boxplus: boxplus,
  boxtimes: boxtimes,
  boxuL: boxuL,
  boxuR: boxuR,
  boxul: boxul,
  boxur: boxur,
  boxv: boxv,
  boxvH: boxvH,
  boxvL: boxvL,
  boxvR: boxvR,
  boxvh: boxvh,
  boxvl: boxvl,
  boxvr: boxvr,
  bprime: bprime,
  breve: breve,
  brvba: brvba,
  brvbar: brvbar$1,
  bscr: bscr,
  bsemi: bsemi,
  bsim: bsim,
  bsime: bsime,
  bsol: bsol,
  bsolb: bsolb,
  bsolhsub: bsolhsub,
  bull: bull,
  bullet: bullet,
  bump: bump,
  bumpE: bumpE,
  bumpe: bumpe,
  bumpeq: bumpeq,
  cacute: cacute,
  cap: cap,
  capand: capand,
  capbrcup: capbrcup,
  capcap: capcap,
  capcup: capcup,
  capdot: capdot,
  caps: caps,
  caret: caret,
  caron: caron,
  ccaps: ccaps,
  ccaron: ccaron,
  ccedi: ccedi,
  ccedil: ccedil$1,
  ccirc: ccirc,
  ccups: ccups,
  ccupssm: ccupssm,
  cdot: cdot,
  cedi: cedi,
  cedil: cedil$1,
  cemptyv: cemptyv,
  cen: cen,
  cent: cent$1,
  centerdot: centerdot,
  cfr: cfr,
  chcy: chcy,
  check: check$2,
  checkmark: checkmark,
  chi: chi,
  cir: cir,
  cirE: cirE,
  circ: circ,
  circeq: circeq,
  circlearrowleft: circlearrowleft,
  circlearrowright: circlearrowright,
  circledR: circledR,
  circledS: circledS,
  circledast: circledast,
  circledcirc: circledcirc,
  circleddash: circleddash,
  cire: cire,
  cirfnint: cirfnint,
  cirmid: cirmid,
  cirscir: cirscir,
  clubs: clubs,
  clubsuit: clubsuit,
  colon: colon,
  colone: colone,
  coloneq: coloneq,
  comma: comma,
  commat: commat,
  comp: comp,
  compfn: compfn,
  complement: complement,
  complexes: complexes,
  cong: cong,
  congdot: congdot,
  conint: conint,
  copf: copf,
  coprod: coprod,
  cop: cop,
  copy: copy$1,
  copysr: copysr,
  crarr: crarr,
  cross: cross,
  cscr: cscr,
  csub: csub,
  csube: csube,
  csup: csup,
  csupe: csupe,
  ctdot: ctdot,
  cudarrl: cudarrl,
  cudarrr: cudarrr,
  cuepr: cuepr,
  cuesc: cuesc,
  cularr: cularr,
  cularrp: cularrp,
  cup: cup,
  cupbrcap: cupbrcap,
  cupcap: cupcap,
  cupcup: cupcup,
  cupdot: cupdot,
  cupor: cupor,
  cups: cups,
  curarr: curarr,
  curarrm: curarrm,
  curlyeqprec: curlyeqprec,
  curlyeqsucc: curlyeqsucc,
  curlyvee: curlyvee,
  curlywedge: curlywedge,
  curre: curre,
  curren: curren$1,
  curvearrowleft: curvearrowleft,
  curvearrowright: curvearrowright,
  cuvee: cuvee,
  cuwed: cuwed,
  cwconint: cwconint,
  cwint: cwint,
  cylcty: cylcty,
  dArr: dArr,
  dHar: dHar,
  dagger: dagger,
  daleth: daleth,
  darr: darr,
  dash: dash,
  dashv: dashv,
  dbkarow: dbkarow,
  dblac: dblac,
  dcaron: dcaron,
  dcy: dcy,
  dd: dd,
  ddagger: ddagger,
  ddarr: ddarr,
  ddotseq: ddotseq,
  de: de,
  deg: deg$1,
  delta: delta,
  demptyv: demptyv,
  dfisht: dfisht,
  dfr: dfr,
  dharl: dharl,
  dharr: dharr,
  diam: diam,
  diamond: diamond,
  diamondsuit: diamondsuit,
  diams: diams,
  die: die,
  digamma: digamma,
  disin: disin,
  div: div,
  divid: divid,
  divide: divide$2,
  divideontimes: divideontimes,
  divonx: divonx,
  djcy: djcy,
  dlcorn: dlcorn,
  dlcrop: dlcrop,
  dollar: dollar,
  dopf: dopf,
  dot: dot,
  doteq: doteq,
  doteqdot: doteqdot,
  dotminus: dotminus,
  dotplus: dotplus,
  dotsquare: dotsquare,
  doublebarwedge: doublebarwedge,
  downarrow: downarrow,
  downdownarrows: downdownarrows,
  downharpoonleft: downharpoonleft,
  downharpoonright: downharpoonright,
  drbkarow: drbkarow,
  drcorn: drcorn,
  drcrop: drcrop,
  dscr: dscr,
  dscy: dscy,
  dsol: dsol,
  dstrok: dstrok,
  dtdot: dtdot,
  dtri: dtri,
  dtrif: dtrif,
  duarr: duarr,
  duhar: duhar,
  dwangle: dwangle,
  dzcy: dzcy,
  dzigrarr: dzigrarr,
  eDDot: eDDot,
  eDot: eDot,
  eacut: eacut,
  eacute: eacute$1,
  easter: easter,
  ecaron: ecaron,
  ecir: ecir,
  ecirc: ecirc$1,
  ecolon: ecolon,
  ecy: ecy,
  edot: edot,
  ee: ee,
  efDot: efDot,
  efr: efr,
  eg: eg,
  egrav: egrav,
  egrave: egrave$1,
  egs: egs,
  egsdot: egsdot,
  el: el,
  elinters: elinters,
  ell: ell,
  els: els,
  elsdot: elsdot,
  emacr: emacr,
  empty: empty$1,
  emptyset: emptyset,
  emptyv: emptyv,
  emsp13: emsp13,
  emsp14: emsp14,
  emsp: emsp,
  eng: eng,
  ensp: ensp,
  eogon: eogon,
  eopf: eopf,
  epar: epar,
  eparsl: eparsl,
  eplus: eplus,
  epsi: epsi,
  epsilon: epsilon,
  epsiv: epsiv,
  eqcirc: eqcirc,
  eqcolon: eqcolon,
  eqsim: eqsim,
  eqslantgtr: eqslantgtr,
  eqslantless: eqslantless,
  equals: equals,
  equest: equest,
  equiv: equiv,
  equivDD: equivDD,
  eqvparsl: eqvparsl,
  erDot: erDot,
  erarr: erarr,
  escr: escr,
  esdot: esdot,
  esim: esim,
  eta: eta,
  et: et,
  eth: eth$1,
  eum: eum,
  euml: euml$1,
  euro: euro,
  excl: excl,
  exist: exist,
  expectation: expectation,
  exponentiale: exponentiale,
  fallingdotseq: fallingdotseq,
  fcy: fcy,
  female: female,
  ffilig: ffilig,
  fflig: fflig,
  ffllig: ffllig,
  ffr: ffr,
  filig: filig,
  fjlig: fjlig,
  flat: flat,
  fllig: fllig,
  fltns: fltns,
  fnof: fnof,
  fopf: fopf,
  forall: forall,
  fork: fork,
  forkv: forkv,
  fpartint: fpartint,
  frac1: frac1,
  frac12: frac12$1,
  frac13: frac13,
  frac14: frac14$1,
  frac15: frac15,
  frac16: frac16,
  frac18: frac18,
  frac23: frac23,
  frac25: frac25,
  frac3: frac3,
  frac34: frac34$1,
  frac35: frac35,
  frac38: frac38,
  frac45: frac45,
  frac56: frac56,
  frac58: frac58,
  frac78: frac78,
  frasl: frasl,
  frown: frown,
  fscr: fscr,
  gE: gE,
  gEl: gEl,
  gacute: gacute,
  gamma: gamma,
  gammad: gammad,
  gap: gap,
  gbreve: gbreve,
  gcirc: gcirc,
  gcy: gcy,
  gdot: gdot,
  ge: ge,
  gel: gel,
  geq: geq,
  geqq: geqq,
  geqslant: geqslant,
  ges: ges,
  gescc: gescc,
  gesdot: gesdot,
  gesdoto: gesdoto,
  gesdotol: gesdotol,
  gesl: gesl,
  gesles: gesles,
  gfr: gfr,
  gg: gg,
  ggg: ggg,
  gimel: gimel,
  gjcy: gjcy,
  gl: gl,
  glE: glE,
  gla: gla,
  glj: glj,
  gnE: gnE,
  gnap: gnap,
  gnapprox: gnapprox,
  gne: gne,
  gneq: gneq,
  gneqq: gneqq,
  gnsim: gnsim,
  gopf: gopf,
  grave: grave,
  gscr: gscr,
  gsim: gsim,
  gsime: gsime,
  gsiml: gsiml,
  g: g,
  gt: gt$1,
  gtcc: gtcc,
  gtcir: gtcir,
  gtdot: gtdot,
  gtlPar: gtlPar,
  gtquest: gtquest,
  gtrapprox: gtrapprox,
  gtrarr: gtrarr,
  gtrdot: gtrdot,
  gtreqless: gtreqless,
  gtreqqless: gtreqqless,
  gtrless: gtrless,
  gtrsim: gtrsim,
  gvertneqq: gvertneqq,
  gvnE: gvnE,
  hArr: hArr,
  hairsp: hairsp,
  half: half,
  hamilt: hamilt,
  hardcy: hardcy,
  harr: harr,
  harrcir: harrcir,
  harrw: harrw,
  hbar: hbar,
  hcirc: hcirc,
  hearts: hearts,
  heartsuit: heartsuit,
  hellip: hellip,
  hercon: hercon,
  hfr: hfr,
  hksearow: hksearow,
  hkswarow: hkswarow,
  hoarr: hoarr,
  homtht: homtht,
  hookleftarrow: hookleftarrow,
  hookrightarrow: hookrightarrow,
  hopf: hopf,
  horbar: horbar,
  hscr: hscr,
  hslash: hslash,
  hstrok: hstrok,
  hybull: hybull,
  hyphen: hyphen,
  iacut: iacut,
  iacute: iacute$1,
  ic: ic,
  icir: icir,
  icirc: icirc$1,
  icy: icy,
  iecy: iecy,
  iexc: iexc,
  iexcl: iexcl$1,
  iff: iff,
  ifr: ifr,
  igrav: igrav,
  igrave: igrave$1,
  ii: ii,
  iiiint: iiiint,
  iiint: iiint,
  iinfin: iinfin,
  iiota: iiota,
  ijlig: ijlig,
  imacr: imacr,
  image: image,
  imagline: imagline,
  imagpart: imagpart,
  imath: imath,
  imof: imof,
  imped: imped,
  incare: incare,
  infin: infin,
  infintie: infintie,
  inodot: inodot,
  int: int,
  intcal: intcal,
  integers: integers,
  intercal: intercal,
  intlarhk: intlarhk,
  intprod: intprod,
  iocy: iocy,
  iogon: iogon,
  iopf: iopf,
  iota: iota,
  iprod: iprod,
  iques: iques,
  iquest: iquest$1,
  iscr: iscr,
  isin: isin,
  isinE: isinE,
  isindot: isindot,
  isins: isins,
  isinsv: isinsv,
  isinv: isinv,
  it: it,
  itilde: itilde,
  iukcy: iukcy,
  ium: ium,
  iuml: iuml$1,
  jcirc: jcirc,
  jcy: jcy,
  jfr: jfr,
  jmath: jmath,
  jopf: jopf,
  jscr: jscr,
  jsercy: jsercy,
  jukcy: jukcy,
  kappa: kappa,
  kappav: kappav,
  kcedil: kcedil,
  kcy: kcy,
  kfr: kfr,
  kgreen: kgreen,
  khcy: khcy,
  kjcy: kjcy,
  kopf: kopf,
  kscr: kscr,
  lAarr: lAarr,
  lArr: lArr,
  lAtail: lAtail,
  lBarr: lBarr,
  lE: lE,
  lEg: lEg,
  lHar: lHar,
  lacute: lacute,
  laemptyv: laemptyv,
  lagran: lagran,
  lambda: lambda,
  lang: lang,
  langd: langd,
  langle: langle,
  lap: lap,
  laqu: laqu,
  laquo: laquo$1,
  larr: larr,
  larrb: larrb,
  larrbfs: larrbfs,
  larrfs: larrfs,
  larrhk: larrhk,
  larrlp: larrlp,
  larrpl: larrpl,
  larrsim: larrsim,
  larrtl: larrtl,
  lat: lat,
  latail: latail,
  late: late,
  lates: lates,
  lbarr: lbarr,
  lbbrk: lbbrk,
  lbrace: lbrace,
  lbrack: lbrack,
  lbrke: lbrke,
  lbrksld: lbrksld,
  lbrkslu: lbrkslu,
  lcaron: lcaron,
  lcedil: lcedil,
  lceil: lceil,
  lcub: lcub,
  lcy: lcy,
  ldca: ldca,
  ldquo: ldquo,
  ldquor: ldquor,
  ldrdhar: ldrdhar,
  ldrushar: ldrushar,
  ldsh: ldsh,
  le: le,
  leftarrow: leftarrow,
  leftarrowtail: leftarrowtail,
  leftharpoondown: leftharpoondown,
  leftharpoonup: leftharpoonup,
  leftleftarrows: leftleftarrows,
  leftrightarrow: leftrightarrow,
  leftrightarrows: leftrightarrows,
  leftrightharpoons: leftrightharpoons,
  leftrightsquigarrow: leftrightsquigarrow,
  leftthreetimes: leftthreetimes,
  leg: leg,
  leq: leq,
  leqq: leqq,
  leqslant: leqslant,
  les: les,
  lescc: lescc,
  lesdot: lesdot,
  lesdoto: lesdoto,
  lesdotor: lesdotor,
  lesg: lesg,
  lesges: lesges,
  lessapprox: lessapprox,
  lessdot: lessdot,
  lesseqgtr: lesseqgtr,
  lesseqqgtr: lesseqqgtr,
  lessgtr: lessgtr,
  lesssim: lesssim,
  lfisht: lfisht,
  lfloor: lfloor,
  lfr: lfr,
  lg: lg,
  lgE: lgE,
  lhard: lhard,
  lharu: lharu,
  lharul: lharul,
  lhblk: lhblk,
  ljcy: ljcy,
  ll: ll,
  llarr: llarr,
  llcorner: llcorner,
  llhard: llhard,
  lltri: lltri,
  lmidot: lmidot,
  lmoust: lmoust,
  lmoustache: lmoustache,
  lnE: lnE,
  lnap: lnap,
  lnapprox: lnapprox,
  lne: lne,
  lneq: lneq,
  lneqq: lneqq,
  lnsim: lnsim,
  loang: loang,
  loarr: loarr,
  lobrk: lobrk,
  longleftarrow: longleftarrow,
  longleftrightarrow: longleftrightarrow,
  longmapsto: longmapsto,
  longrightarrow: longrightarrow,
  looparrowleft: looparrowleft,
  looparrowright: looparrowright,
  lopar: lopar,
  lopf: lopf,
  loplus: loplus,
  lotimes: lotimes,
  lowast: lowast,
  lowbar: lowbar,
  loz: loz,
  lozenge: lozenge,
  lozf: lozf,
  lpar: lpar,
  lparlt: lparlt,
  lrarr: lrarr,
  lrcorner: lrcorner,
  lrhar: lrhar,
  lrhard: lrhard,
  lrm: lrm,
  lrtri: lrtri,
  lsaquo: lsaquo,
  lscr: lscr,
  lsh: lsh,
  lsim: lsim,
  lsime: lsime,
  lsimg: lsimg,
  lsqb: lsqb,
  lsquo: lsquo,
  lsquor: lsquor,
  lstrok: lstrok,
  l: l$1,
  lt: lt$1,
  ltcc: ltcc,
  ltcir: ltcir,
  ltdot: ltdot,
  lthree: lthree,
  ltimes: ltimes,
  ltlarr: ltlarr,
  ltquest: ltquest,
  ltrPar: ltrPar,
  ltri: ltri,
  ltrie: ltrie,
  ltrif: ltrif,
  lurdshar: lurdshar,
  luruhar: luruhar,
  lvertneqq: lvertneqq,
  lvnE: lvnE,
  mDDot: mDDot,
  mac: mac,
  macr: macr$1,
  male: male,
  malt: malt,
  maltese: maltese,
  map: map,
  mapsto: mapsto,
  mapstodown: mapstodown,
  mapstoleft: mapstoleft,
  mapstoup: mapstoup,
  marker: marker,
  mcomma: mcomma,
  mcy: mcy,
  mdash: mdash,
  measuredangle: measuredangle,
  mfr: mfr,
  mho: mho,
  micr: micr,
  micro: micro$1,
  mid: mid,
  midast: midast,
  midcir: midcir,
  middo: middo,
  middot: middot$1,
  minus: minus,
  minusb: minusb,
  minusd: minusd,
  minusdu: minusdu,
  mlcp: mlcp,
  mldr: mldr,
  mnplus: mnplus,
  models: models,
  mopf: mopf,
  mp: mp,
  mscr: mscr,
  mstpos: mstpos,
  mu: mu,
  multimap: multimap,
  mumap: mumap,
  nGg: nGg,
  nGt: nGt,
  nGtv: nGtv,
  nLeftarrow: nLeftarrow,
  nLeftrightarrow: nLeftrightarrow,
  nLl: nLl,
  nLt: nLt,
  nLtv: nLtv,
  nRightarrow: nRightarrow,
  nVDash: nVDash,
  nVdash: nVdash,
  nabla: nabla,
  nacute: nacute,
  nang: nang,
  nap: nap,
  napE: napE,
  napid: napid,
  napos: napos,
  napprox: napprox,
  natur: natur,
  natural: natural,
  naturals: naturals,
  nbs: nbs,
  nbsp: nbsp$1,
  nbump: nbump,
  nbumpe: nbumpe,
  ncap: ncap,
  ncaron: ncaron,
  ncedil: ncedil,
  ncong: ncong,
  ncongdot: ncongdot,
  ncup: ncup,
  ncy: ncy,
  ndash: ndash,
  ne: ne,
  neArr: neArr,
  nearhk: nearhk,
  nearr: nearr,
  nearrow: nearrow,
  nedot: nedot,
  nequiv: nequiv,
  nesear: nesear,
  nesim: nesim,
  nexist: nexist,
  nexists: nexists,
  nfr: nfr,
  ngE: ngE,
  nge: nge,
  ngeq: ngeq,
  ngeqq: ngeqq,
  ngeqslant: ngeqslant,
  nges: nges,
  ngsim: ngsim,
  ngt: ngt,
  ngtr: ngtr,
  nhArr: nhArr,
  nharr: nharr,
  nhpar: nhpar,
  ni: ni,
  nis: nis,
  nisd: nisd,
  niv: niv,
  njcy: njcy,
  nlArr: nlArr,
  nlE: nlE,
  nlarr: nlarr,
  nldr: nldr,
  nle: nle,
  nleftarrow: nleftarrow,
  nleftrightarrow: nleftrightarrow,
  nleq: nleq,
  nleqq: nleqq,
  nleqslant: nleqslant,
  nles: nles,
  nless: nless,
  nlsim: nlsim,
  nlt: nlt,
  nltri: nltri,
  nltrie: nltrie,
  nmid: nmid,
  nopf: nopf,
  no: no,
  not: not$1,
  notin: notin,
  notinE: notinE,
  notindot: notindot,
  notinva: notinva,
  notinvb: notinvb,
  notinvc: notinvc,
  notni: notni,
  notniva: notniva,
  notnivb: notnivb,
  notnivc: notnivc,
  npar: npar,
  nparallel: nparallel,
  nparsl: nparsl,
  npart: npart,
  npolint: npolint,
  npr: npr,
  nprcue: nprcue,
  npre: npre,
  nprec: nprec,
  npreceq: npreceq,
  nrArr: nrArr,
  nrarr: nrarr,
  nrarrc: nrarrc,
  nrarrw: nrarrw,
  nrightarrow: nrightarrow,
  nrtri: nrtri,
  nrtrie: nrtrie,
  nsc: nsc,
  nsccue: nsccue,
  nsce: nsce,
  nscr: nscr,
  nshortmid: nshortmid,
  nshortparallel: nshortparallel,
  nsim: nsim,
  nsime: nsime,
  nsimeq: nsimeq,
  nsmid: nsmid,
  nspar: nspar,
  nsqsube: nsqsube,
  nsqsupe: nsqsupe,
  nsub: nsub,
  nsubE: nsubE,
  nsube: nsube,
  nsubset: nsubset,
  nsubseteq: nsubseteq,
  nsubseteqq: nsubseteqq,
  nsucc: nsucc,
  nsucceq: nsucceq,
  nsup: nsup,
  nsupE: nsupE,
  nsupe: nsupe,
  nsupset: nsupset,
  nsupseteq: nsupseteq,
  nsupseteqq: nsupseteqq,
  ntgl: ntgl,
  ntild: ntild,
  ntilde: ntilde$1,
  ntlg: ntlg,
  ntriangleleft: ntriangleleft,
  ntrianglelefteq: ntrianglelefteq,
  ntriangleright: ntriangleright,
  ntrianglerighteq: ntrianglerighteq,
  nu: nu,
  num: num,
  numero: numero,
  numsp: numsp,
  nvDash: nvDash,
  nvHarr: nvHarr,
  nvap: nvap,
  nvdash: nvdash,
  nvge: nvge,
  nvgt: nvgt,
  nvinfin: nvinfin,
  nvlArr: nvlArr,
  nvle: nvle,
  nvlt: nvlt,
  nvltrie: nvltrie,
  nvrArr: nvrArr,
  nvrtrie: nvrtrie,
  nvsim: nvsim,
  nwArr: nwArr,
  nwarhk: nwarhk,
  nwarr: nwarr,
  nwarrow: nwarrow,
  nwnear: nwnear,
  oS: oS,
  oacut: oacut,
  oacute: oacute$1,
  oast: oast,
  ocir: ocir,
  ocirc: ocirc$1,
  ocy: ocy,
  odash: odash,
  odblac: odblac,
  odiv: odiv,
  odot: odot,
  odsold: odsold,
  oelig: oelig,
  ofcir: ofcir,
  ofr: ofr,
  ogon: ogon,
  ograv: ograv,
  ograve: ograve$1,
  ogt: ogt,
  ohbar: ohbar,
  ohm: ohm,
  oint: oint,
  olarr: olarr,
  olcir: olcir,
  olcross: olcross,
  oline: oline,
  olt: olt,
  omacr: omacr,
  omega: omega,
  omicron: omicron,
  omid: omid,
  ominus: ominus,
  oopf: oopf,
  opar: opar,
  operp: operp,
  oplus: oplus,
  or: or,
  orarr: orarr,
  ord: ord,
  order: order$1,
  orderof: orderof,
  ordf: ordf$1,
  ordm: ordm$1,
  origof: origof,
  oror: oror,
  orslope: orslope,
  orv: orv,
  oscr: oscr,
  oslas: oslas,
  oslash: oslash$1,
  osol: osol,
  otild: otild,
  otilde: otilde$1,
  otimes: otimes,
  otimesas: otimesas,
  oum: oum,
  ouml: ouml$1,
  ovbar: ovbar,
  par: par,
  para: para$1,
  parallel: parallel,
  parsim: parsim,
  parsl: parsl,
  part: part,
  pcy: pcy,
  percnt: percnt,
  period: period,
  permil: permil,
  perp: perp,
  pertenk: pertenk,
  pfr: pfr,
  phi: phi,
  phiv: phiv,
  phmmat: phmmat,
  phone: phone,
  pi: pi,
  pitchfork: pitchfork,
  piv: piv,
  planck: planck,
  planckh: planckh,
  plankv: plankv,
  plus: plus,
  plusacir: plusacir,
  plusb: plusb,
  pluscir: pluscir,
  plusdo: plusdo,
  plusdu: plusdu,
  pluse: pluse,
  plusm: plusm,
  plusmn: plusmn$1,
  plussim: plussim,
  plustwo: plustwo,
  pm: pm,
  pointint: pointint,
  popf: popf,
  poun: poun,
  pound: pound$1,
  pr: pr,
  prE: prE,
  prap: prap,
  prcue: prcue,
  pre: pre,
  prec: prec,
  precapprox: precapprox,
  preccurlyeq: preccurlyeq,
  preceq: preceq,
  precnapprox: precnapprox,
  precneqq: precneqq,
  precnsim: precnsim,
  precsim: precsim,
  prime: prime,
  primes: primes,
  prnE: prnE,
  prnap: prnap,
  prnsim: prnsim,
  prod: prod,
  profalar: profalar,
  profline: profline,
  profsurf: profsurf,
  prop: prop,
  propto: propto,
  prsim: prsim,
  prurel: prurel,
  pscr: pscr,
  psi: psi,
  puncsp: puncsp,
  qfr: qfr,
  qint: qint,
  qopf: qopf,
  qprime: qprime,
  qscr: qscr,
  quaternions: quaternions,
  quatint: quatint,
  quest: quest,
  questeq: questeq,
  quo: quo,
  quot: quot$2,
  rAarr: rAarr,
  rArr: rArr,
  rAtail: rAtail,
  rBarr: rBarr,
  rHar: rHar,
  race: race,
  racute: racute,
  radic: radic,
  raemptyv: raemptyv,
  rang: rang,
  rangd: rangd,
  range: range$1,
  rangle: rangle,
  raqu: raqu,
  raquo: raquo$1,
  rarr: rarr,
  rarrap: rarrap,
  rarrb: rarrb,
  rarrbfs: rarrbfs,
  rarrc: rarrc,
  rarrfs: rarrfs,
  rarrhk: rarrhk,
  rarrlp: rarrlp,
  rarrpl: rarrpl,
  rarrsim: rarrsim,
  rarrtl: rarrtl,
  rarrw: rarrw,
  ratail: ratail,
  ratio: ratio,
  rationals: rationals,
  rbarr: rbarr,
  rbbrk: rbbrk,
  rbrace: rbrace,
  rbrack: rbrack,
  rbrke: rbrke,
  rbrksld: rbrksld,
  rbrkslu: rbrkslu,
  rcaron: rcaron,
  rcedil: rcedil,
  rceil: rceil,
  rcub: rcub,
  rcy: rcy,
  rdca: rdca,
  rdldhar: rdldhar,
  rdquo: rdquo,
  rdquor: rdquor,
  rdsh: rdsh,
  real: real,
  realine: realine,
  realpart: realpart,
  reals: reals,
  rect: rect,
  re: re,
  reg: reg$1,
  rfisht: rfisht,
  rfloor: rfloor,
  rfr: rfr,
  rhard: rhard,
  rharu: rharu,
  rharul: rharul,
  rho: rho,
  rhov: rhov,
  rightarrow: rightarrow,
  rightarrowtail: rightarrowtail,
  rightharpoondown: rightharpoondown,
  rightharpoonup: rightharpoonup,
  rightleftarrows: rightleftarrows,
  rightleftharpoons: rightleftharpoons,
  rightrightarrows: rightrightarrows,
  rightsquigarrow: rightsquigarrow,
  rightthreetimes: rightthreetimes,
  ring: ring,
  risingdotseq: risingdotseq,
  rlarr: rlarr,
  rlhar: rlhar,
  rlm: rlm,
  rmoust: rmoust,
  rmoustache: rmoustache,
  rnmid: rnmid,
  roang: roang,
  roarr: roarr,
  robrk: robrk,
  ropar: ropar,
  ropf: ropf,
  roplus: roplus,
  rotimes: rotimes,
  rpar: rpar,
  rpargt: rpargt,
  rppolint: rppolint,
  rrarr: rrarr,
  rsaquo: rsaquo,
  rscr: rscr,
  rsh: rsh,
  rsqb: rsqb,
  rsquo: rsquo,
  rsquor: rsquor,
  rthree: rthree,
  rtimes: rtimes,
  rtri: rtri,
  rtrie: rtrie,
  rtrif: rtrif,
  rtriltri: rtriltri,
  ruluhar: ruluhar,
  rx: rx,
  sacute: sacute,
  sbquo: sbquo,
  sc: sc,
  scE: scE,
  scap: scap,
  scaron: scaron,
  sccue: sccue,
  sce: sce,
  scedil: scedil,
  scirc: scirc,
  scnE: scnE,
  scnap: scnap,
  scnsim: scnsim,
  scpolint: scpolint,
  scsim: scsim,
  scy: scy,
  sdot: sdot,
  sdotb: sdotb,
  sdote: sdote,
  seArr: seArr,
  searhk: searhk,
  searr: searr,
  searrow: searrow,
  sec: sec,
  sect: sect$1,
  semi: semi,
  seswar: seswar,
  setminus: setminus,
  setmn: setmn,
  sext: sext,
  sfr: sfr,
  sfrown: sfrown,
  sharp: sharp,
  shchcy: shchcy,
  shcy: shcy,
  shortmid: shortmid,
  shortparallel: shortparallel,
  sh: sh,
  shy: shy$1,
  sigma: sigma,
  sigmaf: sigmaf,
  sigmav: sigmav,
  sim: sim,
  simdot: simdot,
  sime: sime,
  simeq: simeq,
  simg: simg,
  simgE: simgE,
  siml: siml,
  simlE: simlE,
  simne: simne,
  simplus: simplus,
  simrarr: simrarr,
  slarr: slarr,
  smallsetminus: smallsetminus,
  smashp: smashp,
  smeparsl: smeparsl,
  smid: smid,
  smile: smile,
  smt: smt,
  smte: smte,
  smtes: smtes,
  softcy: softcy,
  sol: sol,
  solb: solb,
  solbar: solbar,
  sopf: sopf,
  spades: spades,
  spadesuit: spadesuit,
  spar: spar,
  sqcap: sqcap,
  sqcaps: sqcaps,
  sqcup: sqcup,
  sqcups: sqcups,
  sqsub: sqsub,
  sqsube: sqsube,
  sqsubset: sqsubset,
  sqsubseteq: sqsubseteq,
  sqsup: sqsup,
  sqsupe: sqsupe,
  sqsupset: sqsupset,
  sqsupseteq: sqsupseteq,
  squ: squ,
  square: square,
  squarf: squarf,
  squf: squf,
  srarr: srarr,
  sscr: sscr,
  ssetmn: ssetmn,
  ssmile: ssmile,
  sstarf: sstarf,
  star: star,
  starf: starf,
  straightepsilon: straightepsilon,
  straightphi: straightphi,
  strns: strns,
  sub: sub,
  subE: subE,
  subdot: subdot,
  sube: sube,
  subedot: subedot,
  submult: submult,
  subnE: subnE,
  subne: subne,
  subplus: subplus,
  subrarr: subrarr,
  subset: subset,
  subseteq: subseteq,
  subseteqq: subseteqq,
  subsetneq: subsetneq,
  subsetneqq: subsetneqq,
  subsim: subsim,
  subsub: subsub,
  subsup: subsup,
  succ: succ,
  succapprox: succapprox,
  succcurlyeq: succcurlyeq,
  succeq: succeq,
  succnapprox: succnapprox,
  succneqq: succneqq,
  succnsim: succnsim,
  succsim: succsim,
  sum: sum,
  sung: sung,
  sup: sup,
  sup1: sup1$1,
  sup2: sup2$1,
  sup3: sup3$1,
  supE: supE,
  supdot: supdot,
  supdsub: supdsub,
  supe: supe,
  supedot: supedot,
  suphsol: suphsol,
  suphsub: suphsub,
  suplarr: suplarr,
  supmult: supmult,
  supnE: supnE,
  supne: supne,
  supplus: supplus,
  supset: supset,
  supseteq: supseteq,
  supseteqq: supseteqq,
  supsetneq: supsetneq,
  supsetneqq: supsetneqq,
  supsim: supsim,
  supsub: supsub,
  supsup: supsup,
  swArr: swArr,
  swarhk: swarhk,
  swarr: swarr,
  swarrow: swarrow,
  swnwar: swnwar,
  szli: szli,
  szlig: szlig$1,
  target: target,
  tau: tau,
  tbrk: tbrk,
  tcaron: tcaron,
  tcedil: tcedil,
  tcy: tcy,
  tdot: tdot,
  telrec: telrec,
  tfr: tfr,
  there4: there4,
  therefore: therefore,
  theta: theta,
  thetasym: thetasym,
  thetav: thetav,
  thickapprox: thickapprox,
  thicksim: thicksim,
  thinsp: thinsp,
  thkap: thkap,
  thksim: thksim,
  thor: thor,
  thorn: thorn$1,
  tilde: tilde,
  time: time,
  times: times$1,
  timesb: timesb,
  timesbar: timesbar,
  timesd: timesd,
  tint: tint,
  toea: toea,
  top: top,
  topbot: topbot,
  topcir: topcir,
  topf: topf,
  topfork: topfork,
  tosa: tosa,
  tprime: tprime,
  trade: trade,
  triangle: triangle,
  triangledown: triangledown,
  triangleleft: triangleleft,
  trianglelefteq: trianglelefteq,
  triangleq: triangleq,
  triangleright: triangleright,
  trianglerighteq: trianglerighteq,
  tridot: tridot,
  trie: trie,
  triminus: triminus,
  triplus: triplus,
  trisb: trisb,
  tritime: tritime,
  trpezium: trpezium,
  tscr: tscr,
  tscy: tscy,
  tshcy: tshcy,
  tstrok: tstrok,
  twixt: twixt,
  twoheadleftarrow: twoheadleftarrow,
  twoheadrightarrow: twoheadrightarrow,
  uArr: uArr,
  uHar: uHar,
  uacut: uacut,
  uacute: uacute$1,
  uarr: uarr,
  ubrcy: ubrcy,
  ubreve: ubreve,
  ucir: ucir,
  ucirc: ucirc$1,
  ucy: ucy,
  udarr: udarr,
  udblac: udblac,
  udhar: udhar,
  ufisht: ufisht,
  ufr: ufr,
  ugrav: ugrav,
  ugrave: ugrave$1,
  uharl: uharl,
  uharr: uharr,
  uhblk: uhblk,
  ulcorn: ulcorn,
  ulcorner: ulcorner,
  ulcrop: ulcrop,
  ultri: ultri,
  umacr: umacr,
  um: um,
  uml: uml$1,
  uogon: uogon,
  uopf: uopf,
  uparrow: uparrow,
  updownarrow: updownarrow,
  upharpoonleft: upharpoonleft,
  upharpoonright: upharpoonright,
  uplus: uplus,
  upsi: upsi,
  upsih: upsih,
  upsilon: upsilon,
  upuparrows: upuparrows,
  urcorn: urcorn,
  urcorner: urcorner,
  urcrop: urcrop,
  uring: uring,
  urtri: urtri,
  uscr: uscr,
  utdot: utdot,
  utilde: utilde,
  utri: utri,
  utrif: utrif,
  uuarr: uuarr,
  uum: uum,
  uuml: uuml$1,
  uwangle: uwangle,
  vArr: vArr,
  vBar: vBar,
  vBarv: vBarv,
  vDash: vDash,
  vangrt: vangrt,
  varepsilon: varepsilon,
  varkappa: varkappa,
  varnothing: varnothing,
  varphi: varphi,
  varpi: varpi,
  varpropto: varpropto,
  varr: varr,
  varrho: varrho,
  varsigma: varsigma,
  varsubsetneq: varsubsetneq,
  varsubsetneqq: varsubsetneqq,
  varsupsetneq: varsupsetneq,
  varsupsetneqq: varsupsetneqq,
  vartheta: vartheta,
  vartriangleleft: vartriangleleft,
  vartriangleright: vartriangleright,
  vcy: vcy,
  vdash: vdash,
  vee: vee,
  veebar: veebar,
  veeeq: veeeq,
  vellip: vellip,
  verbar: verbar,
  vert: vert,
  vfr: vfr,
  vltri: vltri,
  vnsub: vnsub,
  vnsup: vnsup,
  vopf: vopf,
  vprop: vprop,
  vrtri: vrtri,
  vscr: vscr,
  vsubnE: vsubnE,
  vsubne: vsubne,
  vsupnE: vsupnE,
  vsupne: vsupne,
  vzigzag: vzigzag,
  wcirc: wcirc,
  wedbar: wedbar,
  wedge: wedge,
  wedgeq: wedgeq,
  weierp: weierp,
  wfr: wfr,
  wopf: wopf,
  wp: wp,
  wr: wr,
  wreath: wreath,
  wscr: wscr,
  xcap: xcap,
  xcirc: xcirc,
  xcup: xcup,
  xdtri: xdtri,
  xfr: xfr,
  xhArr: xhArr,
  xharr: xharr,
  xi: xi,
  xlArr: xlArr,
  xlarr: xlarr,
  xmap: xmap,
  xnis: xnis,
  xodot: xodot,
  xopf: xopf,
  xoplus: xoplus,
  xotime: xotime,
  xrArr: xrArr,
  xrarr: xrarr,
  xscr: xscr,
  xsqcup: xsqcup,
  xuplus: xuplus,
  xutri: xutri,
  xvee: xvee,
  xwedge: xwedge,
  yacut: yacut,
  yacute: yacute$1,
  yacy: yacy,
  ycirc: ycirc,
  ycy: ycy,
  ye: ye,
  yen: yen$1,
  yfr: yfr,
  yicy: yicy,
  yopf: yopf,
  yscr: yscr,
  yucy: yucy,
  yum: yum,
  yuml: yuml$1,
  zacute: zacute,
  zcaron: zcaron,
  zcy: zcy,
  zdot: zdot,
  zeetrf: zeetrf,
  zeta: zeta,
  zfr: zfr,
  zhcy: zhcy,
  zigrarr: zigrarr,
  zopf: zopf,
  zscr: zscr,
  zwj: zwj,
  zwnj: zwnj,
  default: index$e
});
var characterEntities$1 = getCjsExportFromNamespace(characterEntities);
var decodeEntity_1 = decodeEntity;
var own$3 = {}.hasOwnProperty;

function decodeEntity(characters) {
  return own$3.call(characterEntities$1, characters) ? characterEntities$1[characters] : false;
}

var legacy = getCjsExportFromNamespace(characterEntitiesLegacy);
var invalid = getCjsExportFromNamespace(characterReferenceInvalid);
var parseEntities_1 = parseEntities;
var own$4 = {}.hasOwnProperty;
var fromCharCode$1 = String.fromCharCode;
var noop$4 = Function.prototype;
/* Default settings. */

var defaults$1 = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
};
/* Reference types. */

var NAMED = 'named';
var HEXADECIMAL = 'hexadecimal';
var DECIMAL = 'decimal';
/* Map of bases. */

var BASE = {};
BASE[HEXADECIMAL] = 16;
BASE[DECIMAL] = 10;
/* Map of types to tests. Each type of character reference
 * accepts different characters. This test is used to
 * detect whether a reference has ended (as the semicolon
 * is not strictly needed). */

var TESTS = {};
TESTS[NAMED] = isAlphanumerical;
TESTS[DECIMAL] = isDecimal;
TESTS[HEXADECIMAL] = isHexadecimal;
/* Warning messages. */

var NAMED_NOT_TERMINATED = 1;
var NUMERIC_NOT_TERMINATED = 2;
var NAMED_EMPTY = 3;
var NUMERIC_EMPTY = 4;
var NAMED_UNKNOWN = 5;
var NUMERIC_DISALLOWED = 6;
var NUMERIC_PROHIBITED = 7;
var MESSAGES = {};
MESSAGES[NAMED_NOT_TERMINATED] = 'Named character references must be terminated by a semicolon';
MESSAGES[NUMERIC_NOT_TERMINATED] = 'Numeric character references must be terminated by a semicolon';
MESSAGES[NAMED_EMPTY] = 'Named character references cannot be empty';
MESSAGES[NUMERIC_EMPTY] = 'Numeric character references cannot be empty';
MESSAGES[NAMED_UNKNOWN] = 'Named character references must be known';
MESSAGES[NUMERIC_DISALLOWED] = 'Numeric character references cannot be disallowed';
MESSAGES[NUMERIC_PROHIBITED] = 'Numeric character references cannot be outside the permissible Unicode range';
/* Wrap to ensure clean parameters are given to `parse`. */

function parseEntities(value, options) {
  var settings = {};
  var option;
  var key;

  if (!options) {
    options = {};
  }

  for (key in defaults$1) {
    option = options[key];
    settings[key] = option === null || option === undefined ? defaults$1[key] : option;
  }

  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || [];
    settings.position = settings.position.start;
  }

  return parse$1(value, settings);
}
/* Parse entities. */


function parse$1(value, settings) {
  var additional = settings.additional;
  var nonTerminated = settings.nonTerminated;
  var handleText = settings.text;
  var handleReference = settings.reference;
  var handleWarning = settings.warning;
  var textContext = settings.textContext;
  var referenceContext = settings.referenceContext;
  var warningContext = settings.warningContext;
  var pos = settings.position;
  var indent = settings.indent || [];
  var length = value.length;
  var index = 0;
  var lines = -1;
  var column = pos.column || 1;
  var line = pos.line || 1;
  var queue = '';
  var result = [];
  var entityCharacters;
  var namedEntity;
  var terminated;
  var characters;
  var character;
  var reference;
  var following;
  var warning;
  var reason;
  var output;
  var entity;
  var begin;
  var start;
  var type;
  var test;
  var prev;
  var next;
  var diff;
  var end;
  /* Cache the current point. */

  prev = now();
  /* Wrap `handleWarning`. */

  warning = handleWarning ? parseError : noop$4;
  /* Ensure the algorithm walks over the first character
   * and the end (inclusive). */

  index--;
  length++;

  while (++index < length) {
    /* If the previous character was a newline. */
    if (character === '\n') {
      column = indent[lines] || 1;
    }

    character = at(index);
    /* Handle anything other than an ampersand,
     * including newlines and EOF. */

    if (character !== '&') {
      if (character === '\n') {
        line++;
        lines++;
        column = 0;
      }

      if (character) {
        queue += character;
        column++;
      } else {
        flush();
      }
    } else {
      following = at(index + 1);
      /* The behaviour depends on the identity of the next
       * character. */

      if (following === '\t'
      /* Tab */
      || following === '\n'
      /* Newline */
      || following === '\f'
      /* Form feed */
      || following === ' '
      /* Space */
      || following === '<'
      /* Less-than */
      || following === '&'
      /* Ampersand */
      || following === '' || additional && following === additional) {
        /* Not a character reference. No characters
         * are consumed, and nothing is returned.
         * This is not an error, either. */
        queue += character;
        column++;
        continue;
      }

      start = index + 1;
      begin = start;
      end = start;
      /* Numerical entity. */

      if (following !== '#') {
        type = NAMED;
      } else {
        end = ++begin;
        /* The behaviour further depends on the
         * character after the U+0023 NUMBER SIGN. */

        following = at(end);

        if (following === 'x' || following === 'X') {
          /* ASCII hex digits. */
          type = HEXADECIMAL;
          end = ++begin;
        } else {
          /* ASCII digits. */
          type = DECIMAL;
        }
      }

      entityCharacters = '';
      entity = '';
      characters = '';
      test = TESTS[type];
      end--;

      while (++end < length) {
        following = at(end);

        if (!test(following)) {
          break;
        }

        characters += following;
        /* Check if we can match a legacy named
         * reference.  If so, we cache that as the
         * last viable named reference.  This
         * ensures we do not need to walk backwards
         * later. */

        if (type === NAMED && own$4.call(legacy, characters)) {
          entityCharacters = characters;
          entity = legacy[characters];
        }
      }

      terminated = at(end) === ';';

      if (terminated) {
        end++;
        namedEntity = type === NAMED ? decodeEntity_1(characters) : false;

        if (namedEntity) {
          entityCharacters = characters;
          entity = namedEntity;
        }
      }

      diff = 1 + end - start;
      if (!terminated && !nonTerminated) ;else if (!characters) {
        /* An empty (possible) entity is valid, unless
         * its numeric (thus an ampersand followed by
         * an octothorp). */
        if (type !== NAMED) {
          warning(NUMERIC_EMPTY, diff);
        }
      } else if (type === NAMED) {
        /* An ampersand followed by anything
         * unknown, and not terminated, is invalid. */
        if (terminated && !entity) {
          warning(NAMED_UNKNOWN, 1);
        } else {
          /* If theres something after an entity
           * name which is not known, cap the
           * reference. */
          if (entityCharacters !== characters) {
            end = begin + entityCharacters.length;
            diff = 1 + end - begin;
            terminated = false;
          }
          /* If the reference is not terminated,
           * warn. */


          if (!terminated) {
            reason = entityCharacters ? NAMED_NOT_TERMINATED : NAMED_EMPTY;

            if (!settings.attribute) {
              warning(reason, diff);
            } else {
              following = at(end);

              if (following === '=') {
                warning(reason, diff);
                entity = null;
              } else if (isAlphanumerical(following)) {
                entity = null;
              } else {
                warning(reason, diff);
              }
            }
          }
        }

        reference = entity;
      } else {
        if (!terminated) {
          /* All non-terminated numeric entities are
           * not rendered, and trigger a warning. */
          warning(NUMERIC_NOT_TERMINATED, diff);
        }
        /* When terminated and number, parse as
         * either hexadecimal or decimal. */


        reference = parseInt(characters, BASE[type]);
        /* Trigger a warning when the parsed number
         * is prohibited, and replace with
         * replacement character. */

        if (prohibited(reference)) {
          warning(NUMERIC_PROHIBITED, diff);
          reference = "\uFFFD";
        } else if (reference in invalid) {
          /* Trigger a warning when the parsed number
           * is disallowed, and replace by an
           * alternative. */
          warning(NUMERIC_DISALLOWED, diff);
          reference = invalid[reference];
        } else {
          /* Parse the number. */
          output = '';
          /* Trigger a warning when the parsed
           * number should not be used. */

          if (disallowed(reference)) {
            warning(NUMERIC_DISALLOWED, diff);
          }
          /* Stringify the number. */


          if (reference > 0xffff) {
            reference -= 0x10000;
            output += fromCharCode$1(reference >>> (10 & 0x3ff) | 0xd800);
            reference = 0xdc00 | reference & 0x3ff;
          }

          reference = output + fromCharCode$1(reference);
        }
      }
      /* If we could not find a reference, queue the
       * checked characters (as normal characters),
       * and move the pointer to their end. This is
       * possible because we can be certain neither
       * newlines nor ampersands are included. */

      if (!reference) {
        characters = value.slice(start - 1, end);
        queue += characters;
        column += characters.length;
        index = end - 1;
      } else {
        /* Found it! First eat the queued
         * characters as normal text, then eat
         * an entity. */
        flush();
        prev = now();
        index = end - 1;
        column += end - start + 1;
        result.push(reference);
        next = now();
        next.offset++;

        if (handleReference) {
          handleReference.call(referenceContext, reference, {
            start: prev,
            end: next
          }, value.slice(start - 1, end));
        }

        prev = next;
      }
    }
  }
  /* Return the reduced nodes, and any possible warnings. */


  return result.join('');
  /* Get current position. */

  function now() {
    return {
      line: line,
      column: column,
      offset: index + (pos.offset || 0)
    };
  }
  /* “Throw” a parse-error: a warning. */


  function parseError(code, offset) {
    var position = now();
    position.column += offset;
    position.offset += offset;
    handleWarning.call(warningContext, MESSAGES[code], position, code);
  }
  /* Get character at position. */


  function at(position) {
    return value.charAt(position);
  }
  /* Flush `queue` (normal text). Macro invoked before
   * each entity and at the end of `value`.
   * Does nothing when `queue` is empty. */


  function flush() {
    if (queue) {
      result.push(queue);

      if (handleText) {
        handleText.call(textContext, queue, {
          start: prev,
          end: now()
        });
      }

      queue = '';
    }
  }
}
/* Check if `character` is outside the permissible unicode range. */


function prohibited(code) {
  return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
/* Check if `character` is disallowed. */


function disallowed(code) {
  return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}

var decode = factory$3;
/* Factory to create an entity decoder. */

function factory$3(ctx) {
  decoder.raw = decodeRaw;
  return decoder;
  /* Normalize `position` to add an `indent`. */

  function normalize(position) {
    var offsets = ctx.offset;
    var line = position.line;
    var result = [];

    while (++line) {
      if (!(line in offsets)) {
        break;
      }

      result.push((offsets[line] || 0) + 1);
    }

    return {
      start: position,
      indent: result
    };
  }
  /* Handle a warning.
   * See https://github.com/wooorm/parse-entities
   * for the warnings. */


  function handleWarning(reason, position, code) {
    if (code === 3) {
      return;
    }

    ctx.file.message(reason, position);
  }
  /* Decode `value` (at `position`) into text-nodes. */


  function decoder(value, position, handler) {
    parseEntities_1(value, {
      position: normalize(position),
      warning: handleWarning,
      text: handler,
      reference: handler,
      textContext: ctx,
      referenceContext: ctx
    });
  }
  /* Decode `value` (at `position`) into a string. */


  function decodeRaw(value, position, options) {
    return parseEntities_1(value, immutable$1(options, {
      position: normalize(position),
      warning: handleWarning
    }));
  }
}

var tokenizer = factory$4;
var MERGEABLE_NODES = {
  text: mergeText,
  blockquote: mergeBlockquote
};
/* Check whether a node is mergeable with adjacent nodes. */

function mergeable(node) {
  var start;
  var end;

  if (node.type !== 'text' || !node.position) {
    return true;
  }

  start = node.position.start;
  end = node.position.end;
  /* Only merge nodes which occupy the same size as their
   * `value`. */

  return start.line !== end.line || end.column - start.column === node.value.length;
}
/* Merge two text nodes: `node` into `prev`. */


function mergeText(prev, node) {
  prev.value += node.value;
  return prev;
}
/* Merge two blockquotes: `node` into `prev`, unless in
 * CommonMark mode. */


function mergeBlockquote(prev, node) {
  if (this.options.commonmark) {
    return node;
  }

  prev.children = prev.children.concat(node.children);
  return prev;
}
/* Construct a tokenizer.  This creates both
 * `tokenizeInline` and `tokenizeBlock`. */


function factory$4(type) {
  return tokenize;
  /* Tokenizer for a bound `type`. */

  function tokenize(value, location) {
    var self = this;
    var offset = self.offset;
    var tokens = [];
    var methods = self[type + 'Methods'];
    var tokenizers = self[type + 'Tokenizers'];
    var line = location.line;
    var column = location.column;
    var index;
    var length;
    var method;
    var name;
    var matched;
    var valueLength;
    /* Trim white space only lines. */

    if (!value) {
      return tokens;
    }
    /* Expose on `eat`. */


    eat.now = now;
    eat.file = self.file;
    /* Sync initial offset. */

    updatePosition('');
    /* Iterate over `value`, and iterate over all
     * tokenizers.  When one eats something, re-iterate
     * with the remaining value.  If no tokenizer eats,
     * something failed (should not happen) and an
     * exception is thrown. */

    while (value) {
      index = -1;
      length = methods.length;
      matched = false;

      while (++index < length) {
        name = methods[index];
        method = tokenizers[name];

        if (method && (
        /* istanbul ignore next */
        !method.onlyAtStart || self.atStart) && (!method.notInList || !self.inList) && (!method.notInBlock || !self.inBlock) && (!method.notInLink || !self.inLink)) {
          valueLength = value.length;
          method.apply(self, [eat, value]);
          matched = valueLength !== value.length;

          if (matched) {
            break;
          }
        }
      }
      /* istanbul ignore if */


      if (!matched) {
        self.file.fail(new Error('Infinite loop'), eat.now());
      }
    }

    self.eof = now();
    return tokens;
    /* Update line, column, and offset based on
     * `value`. */

    function updatePosition(subvalue) {
      var lastIndex = -1;
      var index = subvalue.indexOf('\n');

      while (index !== -1) {
        line++;
        lastIndex = index;
        index = subvalue.indexOf('\n', index + 1);
      }

      if (lastIndex === -1) {
        column += subvalue.length;
      } else {
        column = subvalue.length - lastIndex;
      }

      if (line in offset) {
        if (lastIndex !== -1) {
          column += offset[line];
        } else if (column <= offset[line]) {
          column = offset[line] + 1;
        }
      }
    }
    /* Get offset.  Called before the first character is
     * eaten to retrieve the range's offsets. */


    function getOffset() {
      var indentation = [];
      var pos = line + 1;
      /* Done.  Called when the last character is
       * eaten to retrieve the range’s offsets. */

      return function () {
        var last = line + 1;

        while (pos < last) {
          indentation.push((offset[pos] || 0) + 1);
          pos++;
        }

        return indentation;
      };
    }
    /* Get the current position. */


    function now() {
      var pos = {
        line: line,
        column: column
      };
      pos.offset = self.toOffset(pos);
      return pos;
    }
    /* Store position information for a node. */


    function Position(start) {
      this.start = start;
      this.end = now();
    }
    /* Throw when a value is incorrectly eaten.
     * This shouldn’t happen but will throw on new,
     * incorrect rules. */


    function validateEat(subvalue) {
      /* istanbul ignore if */
      if (value.substring(0, subvalue.length) !== subvalue) {
        /* Capture stack-trace. */
        self.file.fail(new Error('Incorrectly eaten value: please report this ' + 'warning on http://git.io/vg5Ft'), now());
      }
    }
    /* Mark position and patch `node.position`. */


    function position() {
      var before = now();
      return update;
      /* Add the position to a node. */

      function update(node, indent) {
        var prev = node.position;
        var start = prev ? prev.start : before;
        var combined = [];
        var n = prev && prev.end.line;
        var l = before.line;
        node.position = new Position(start);
        /* If there was already a `position`, this
         * node was merged.  Fixing `start` wasn’t
         * hard, but the indent is different.
         * Especially because some information, the
         * indent between `n` and `l` wasn’t
         * tracked.  Luckily, that space is
         * (should be?) empty, so we can safely
         * check for it now. */

        if (prev && indent && prev.indent) {
          combined = prev.indent;

          if (n < l) {
            while (++n < l) {
              combined.push((offset[n] || 0) + 1);
            }

            combined.push(before.column);
          }

          indent = combined.concat(indent);
        }

        node.position.indent = indent || [];
        return node;
      }
    }
    /* Add `node` to `parent`s children or to `tokens`.
     * Performs merges where possible. */


    function add(node, parent) {
      var children = parent ? parent.children : tokens;
      var prev = children[children.length - 1];

      if (prev && node.type === prev.type && node.type in MERGEABLE_NODES && mergeable(prev) && mergeable(node)) {
        node = MERGEABLE_NODES[node.type].call(self, prev, node);
      }

      if (node !== prev) {
        children.push(node);
      }

      if (self.atStart && tokens.length !== 0) {
        self.exitStart();
      }

      return node;
    }
    /* Remove `subvalue` from `value`.
     * `subvalue` must be at the start of `value`. */


    function eat(subvalue) {
      var indent = getOffset();
      var pos = position();
      var current = now();
      validateEat(subvalue);
      apply.reset = reset;
      reset.test = test;
      apply.test = test;
      value = value.substring(subvalue.length);
      updatePosition(subvalue);
      indent = indent();
      return apply;
      /* Add the given arguments, add `position` to
       * the returned node, and return the node. */

      function apply(node, parent) {
        return pos(add(pos(node), parent), indent);
      }
      /* Functions just like apply, but resets the
       * content:  the line and column are reversed,
       * and the eaten value is re-added.
       * This is useful for nodes with a single
       * type of content, such as lists and tables.
       * See `apply` above for what parameters are
       * expected. */


      function reset() {
        var node = apply.apply(null, arguments);
        line = current.line;
        column = current.column;
        value = subvalue + value;
        return node;
      }
      /* Test the position, after eating, and reverse
       * to a not-eaten state. */


      function test() {
        var result = pos({});
        line = current.line;
        column = current.column;
        value = subvalue + value;
        return result.position;
      }
    }
  }
}

var markdownEscapes = escapes;
var defaults$2 = ['\\', '`', '*', '{', '}', '[', ']', '(', ')', '#', '+', '-', '.', '!', '_', '>'];
var gfm = defaults$2.concat(['~', '|']);
var commonmark = gfm.concat(['\n', '"', '$', '%', '&', "'", ',', '/', ':', ';', '<', '=', '?', '@', '^']);
escapes.default = defaults$2;
escapes.gfm = gfm;
escapes.commonmark = commonmark;
/* Get markdown escapes. */

function escapes(options) {
  var settings = options || {};

  if (settings.commonmark) {
    return commonmark;
  }

  return settings.gfm ? gfm : defaults$2;
}

var blockElements = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "meta", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "pre", "section", "source", "title", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"];
var blockElements$1 =
/*#__PURE__*/
Object.freeze({
  default: blockElements
});
var require$$0$2 = getCjsExportFromNamespace(blockElements$1);
var defaults$3 = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: require$$0$2
};
var setOptions_1 = setOptions;

function setOptions(options) {
  var self = this;
  var current = self.options;
  var key;
  var value;

  if (options == null) {
    options = {};
  } else if (typeof options === 'object') {
    options = immutable$1(options);
  } else {
    throw new Error('Invalid value `' + options + '` ' + 'for setting `options`');
  }

  for (key in defaults$3) {
    value = options[key];

    if (value == null) {
      value = current[key];
    }

    if (key !== 'blocks' && typeof value !== 'boolean' || key === 'blocks' && typeof value !== 'object') {
      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
    }

    options[key] = value;
  }

  self.options = options;
  self.escape = markdownEscapes(options);
  return self;
}
/* eslint-disable max-params */

/* Expose. */


var unistUtilIs = is$3;
/* Assert if `test` passes for `node`.
 * When a `parent` node is known the `index` of node */

function is$3(test, node, index, parent, context) {
  var hasParent = parent !== null && parent !== undefined;
  var hasIndex = index !== null && index !== undefined;
  var check = convert(test);

  if (hasIndex && (typeof index !== 'number' || index < 0 || index === Infinity)) {
    throw new Error('Expected positive finite index or child node');
  }

  if (hasParent && (!is$3(null, parent) || !parent.children)) {
    throw new Error('Expected parent node');
  }

  if (!node || !node.type || typeof node.type !== 'string') {
    return false;
  }

  if (hasParent !== hasIndex) {
    throw new Error('Expected both parent and index');
  }

  return Boolean(check.call(context, node, index, parent));
}

function convert(test) {
  if (typeof test === 'string') {
    return typeFactory(test);
  }

  if (test === null || test === undefined) {
    return ok;
  }

  if (typeof test === 'object') {
    return ('length' in test ? anyFactory : matchesFactory)(test);
  }

  if (typeof test === 'function') {
    return test;
  }

  throw new Error('Expected function, string, or object as test');
}

function convertAll(tests) {
  var results = [];
  var length = tests.length;
  var index = -1;

  while (++index < length) {
    results[index] = convert(tests[index]);
  }

  return results;
}
/* Utility assert each property in `test` is represented
 * in `node`, and each values are strictly equal. */


function matchesFactory(test) {
  return matches;

  function matches(node) {
    var key;

    for (key in test) {
      if (node[key] !== test[key]) {
        return false;
      }
    }

    return true;
  }
}

function anyFactory(tests) {
  var checks = convertAll(tests);
  var length = checks.length;
  return matches;

  function matches() {
    var index = -1;

    while (++index < length) {
      if (checks[index].apply(this, arguments)) {
        return true;
      }
    }

    return false;
  }
}
/* Utility to convert a string into a function which checks
 * a given node’s type for said string. */


function typeFactory(test) {
  return type;

  function type(node) {
    return Boolean(node && node.type === test);
  }
}
/* Utility to return true. */


function ok() {
  return true;
}

var unistUtilVisitParents = visitParents;
var CONTINUE = true;
var SKIP = 'skip';
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;

function visitParents(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor;
    visitor = test;
    test = null;
  }

  one(tree, null, []); // Visit a single node.

  function one(node, index, parents) {
    var result;

    if (!test || unistUtilIs(test, node, index, parents[parents.length - 1] || null)) {
      result = visitor(node, parents);

      if (result === EXIT) {
        return result;
      }
    }

    if (node.children && result !== SKIP) {
      return all(node.children, parents.concat(node)) === EXIT ? EXIT : result;
    }

    return result;
  } // Visit children in `parent`.


  function all(children, parents) {
    var min = -1;
    var step = reverse ? -1 : 1;
    var index = (reverse ? children.length : min) + step;
    var child;
    var result;

    while (index > min && index < children.length) {
      child = children[index];
      result = child && one(child, index, parents);

      if (result === EXIT) {
        return result;
      }

      index = typeof result === 'number' ? result : index + step;
    }
  }
}

var unistUtilVisit = visit;
var CONTINUE$1 = unistUtilVisitParents.CONTINUE;
var SKIP$1 = unistUtilVisitParents.SKIP;
var EXIT$1 = unistUtilVisitParents.EXIT;
visit.CONTINUE = CONTINUE$1;
visit.SKIP = SKIP$1;
visit.EXIT = EXIT$1;

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor;
    visitor = test;
    test = null;
  }

  unistUtilVisitParents(tree, test, overload, reverse);

  function overload(node, parents) {
    var parent = parents[parents.length - 1];
    var index = parent ? parent.children.indexOf(node) : null;
    return visitor(node, index, parent);
  }
}

var unistUtilRemovePosition = removePosition;
/* Remove `position`s from `tree`. */

function removePosition(node, force) {
  unistUtilVisit(node, force ? hard : soft);
  return node;
}

function hard(node) {
  delete node.position;
}

function soft(node) {
  node.position = undefined;
}

var parse_1$1 = parse$2;
var C_NEWLINE = '\n';
var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
/* Parse the bound file. */

function parse$2() {
  var self = this;
  var value = String(self.file);
  var start = {
    line: 1,
    column: 1,
    offset: 0
  };
  var content = immutable$1(start);
  var node;
  /* Clean non-unix newlines: `\r\n` and `\r` are all
   * changed to `\n`.  This should not affect positional
   * information. */

  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);

  if (value.charCodeAt(0) === 0xFEFF) {
    value = value.slice(1);
    content.column++;
    content.offset++;
  }

  node = {
    type: 'root',
    children: self.tokenizeBlock(value, content),
    position: {
      start: start,
      end: self.eof || immutable$1(start)
    }
  };

  if (!self.options.position) {
    unistUtilRemovePosition(node, true);
  }

  return node;
}

var isWhitespaceCharacter = whitespace;
var fromCode = String.fromCharCode;
var re$1 = /\s/;
/* Check if the given character code, or the character
 * code at the first character, is a whitespace character. */

function whitespace(character) {
  return re$1.test(typeof character === 'number' ? fromCode(character) : character.charAt(0));
}

var newline_1 = newline;
/* Tokenise newline. */

function newline(eat, value, silent) {
  var character = value.charAt(0);
  var length;
  var subvalue;
  var queue;
  var index;

  if (character !== '\n') {
    return;
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }

  index = 1;
  length = value.length;
  subvalue = character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!isWhitespaceCharacter(character)) {
      break;
    }

    queue += character;

    if (character === '\n') {
      subvalue += queue;
      queue = '';
    }

    index++;
  }

  eat(subvalue);
}
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

/**
 * Results cache
 */


var res = '';
var cache;
/**
 * Expose `repeat`
 */

var repeatString = repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */

function repeat(str, num) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string');
  } // cover common, quick use cases


  if (num === 1) return str;
  if (num === 2) return str + str;
  var max = str.length * num;

  if (cache !== str || typeof cache === 'undefined') {
    cache = str;
    res = '';
  } else if (res.length >= max) {
    return res.substr(0, max);
  }

  while (max > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }

    num >>= 1;
    str += str;
  }

  res += str;
  res = res.substr(0, max);
  return res;
}

var trimTrailingLines_1 = trimTrailingLines;
var line = '\n';
/* Remove final newline characters from `value`. */

function trimTrailingLines(value) {
  var val = String(value);
  var index = val.length;

  while (val.charAt(--index) === line) {
    /* Empty */
  }

  return val.slice(0, index + 1);
}

var codeIndented = indentedCode;
var C_NEWLINE$1 = '\n';
var C_TAB = '\t';
var C_SPACE = ' ';
var CODE_INDENT_COUNT = 4;
var CODE_INDENT = repeatString(C_SPACE, CODE_INDENT_COUNT);
/* Tokenise indented code. */

function indentedCode(eat, value, silent) {
  var index = -1;
  var length = value.length;
  var subvalue = '';
  var content = '';
  var subvalueQueue = '';
  var contentQueue = '';
  var character;
  var blankQueue;
  var indent;

  while (++index < length) {
    character = value.charAt(index);

    if (indent) {
      indent = false;
      subvalue += subvalueQueue;
      content += contentQueue;
      subvalueQueue = '';
      contentQueue = '';

      if (character === C_NEWLINE$1) {
        subvalueQueue = character;
        contentQueue = character;
      } else {
        subvalue += character;
        content += character;

        while (++index < length) {
          character = value.charAt(index);

          if (!character || character === C_NEWLINE$1) {
            contentQueue = character;
            subvalueQueue = character;
            break;
          }

          subvalue += character;
          content += character;
        }
      }
    } else if (character === C_SPACE && value.charAt(index + 1) === character && value.charAt(index + 2) === character && value.charAt(index + 3) === character) {
      subvalueQueue += CODE_INDENT;
      index += 3;
      indent = true;
    } else if (character === C_TAB) {
      subvalueQueue += character;
      indent = true;
    } else {
      blankQueue = '';

      while (character === C_TAB || character === C_SPACE) {
        blankQueue += character;
        character = value.charAt(++index);
      }

      if (character !== C_NEWLINE$1) {
        break;
      }

      subvalueQueue += blankQueue + character;
      contentQueue += character;
    }
  }

  if (content) {
    if (silent) {
      return true;
    }

    return eat(subvalue)({
      type: 'code',
      lang: null,
      value: trimTrailingLines_1(content)
    });
  }
}

var codeFenced = fencedCode;
var C_NEWLINE$2 = '\n';
var C_TAB$1 = '\t';
var C_SPACE$1 = ' ';
var C_TILDE = '~';
var C_TICK = '`';
var MIN_FENCE_COUNT = 3;
var CODE_INDENT_COUNT$1 = 4;

function fencedCode(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var length = value.length + 1;
  var index = 0;
  var subvalue = '';
  var fenceCount;
  var marker;
  var character;
  var flag;
  var queue;
  var content;
  var exdentedContent;
  var closing;
  var exdentedClosing;
  var indent;
  var now;

  if (!settings.gfm) {
    return;
  }
  /* Eat initial spacing. */


  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE$1 && character !== C_TAB$1) {
      break;
    }

    subvalue += character;
    index++;
  }

  indent = index;
  /* Eat the fence. */

  character = value.charAt(index);

  if (character !== C_TILDE && character !== C_TICK) {
    return;
  }

  index++;
  marker = character;
  fenceCount = 1;
  subvalue += character;

  while (index < length) {
    character = value.charAt(index);

    if (character !== marker) {
      break;
    }

    subvalue += character;
    fenceCount++;
    index++;
  }

  if (fenceCount < MIN_FENCE_COUNT) {
    return;
  }
  /* Eat spacing before flag. */


  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE$1 && character !== C_TAB$1) {
      break;
    }

    subvalue += character;
    index++;
  }
  /* Eat flag. */


  flag = '';
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_NEWLINE$2 || character === C_TILDE || character === C_TICK) {
      break;
    }

    if (character === C_SPACE$1 || character === C_TAB$1) {
      queue += character;
    } else {
      flag += queue + character;
      queue = '';
    }

    index++;
  }

  character = value.charAt(index);

  if (character && character !== C_NEWLINE$2) {
    return;
  }

  if (silent) {
    return true;
  }

  now = eat.now();
  now.column += subvalue.length;
  now.offset += subvalue.length;
  subvalue += flag;
  flag = self.decode.raw(self.unescape(flag), now);

  if (queue) {
    subvalue += queue;
  }

  queue = '';
  closing = '';
  exdentedClosing = '';
  content = '';
  exdentedContent = '';
  /* Eat content. */

  while (index < length) {
    character = value.charAt(index);
    content += closing;
    exdentedContent += exdentedClosing;
    closing = '';
    exdentedClosing = '';

    if (character !== C_NEWLINE$2) {
      content += character;
      exdentedClosing += character;
      index++;
      continue;
    }
    /* Add the newline to `subvalue` if its the first
     * character.  Otherwise, add it to the `closing`
     * queue. */


    if (content) {
      closing += character;
      exdentedClosing += character;
    } else {
      subvalue += character;
    }

    queue = '';
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE$1) {
        break;
      }

      queue += character;
      index++;
    }

    closing += queue;
    exdentedClosing += queue.slice(indent);

    if (queue.length >= CODE_INDENT_COUNT$1) {
      continue;
    }

    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character !== marker) {
        break;
      }

      queue += character;
      index++;
    }

    closing += queue;
    exdentedClosing += queue;

    if (queue.length < fenceCount) {
      continue;
    }

    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE$1 && character !== C_TAB$1) {
        break;
      }

      closing += character;
      exdentedClosing += character;
      index++;
    }

    if (!character || character === C_NEWLINE$2) {
      break;
    }
  }

  subvalue += content + closing;
  return eat(subvalue)({
    type: 'code',
    lang: flag || null,
    value: trimTrailingLines_1(exdentedContent)
  });
}

var trim_1 = createCommonjsModule(function (module, exports) {
  exports = module.exports = trim;

  function trim(str) {
    return str.replace(/^\s*|\s*$/g, '');
  }

  exports.left = function (str) {
    return str.replace(/^\s*/, '');
  };

  exports.right = function (str) {
    return str.replace(/\s*$/, '');
  };
});
var trim_2 = trim_1.left;
var trim_3 = trim_1.right;
var interrupt_1 = interrupt;

function interrupt(interruptors, tokenizers, ctx, params) {
  var bools = ['pedantic', 'commonmark'];
  var count = bools.length;
  var length = interruptors.length;
  var index = -1;
  var interruptor;
  var config;
  var fn;
  var offset;
  var bool;
  var ignore;

  while (++index < length) {
    interruptor = interruptors[index];
    config = interruptor[1] || {};
    fn = interruptor[0];
    offset = -1;
    ignore = false;

    while (++offset < count) {
      bool = bools[offset];

      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
        ignore = true;
        break;
      }
    }

    if (ignore) {
      continue;
    }

    if (tokenizers[fn].apply(ctx, params)) {
      return true;
    }
  }

  return false;
}

var blockquote_1 = blockquote;
var C_NEWLINE$3 = '\n';
var C_TAB$2 = '\t';
var C_SPACE$2 = ' ';
var C_GT = '>';
/* Tokenise a blockquote. */

function blockquote(eat, value, silent) {
  var self = this;
  var offsets = self.offset;
  var tokenizers = self.blockTokenizers;
  var interruptors = self.interruptBlockquote;
  var now = eat.now();
  var currentLine = now.line;
  var length = value.length;
  var values = [];
  var contents = [];
  var indents = [];
  var add;
  var index = 0;
  var character;
  var rest;
  var nextIndex;
  var content;
  var line;
  var startIndex;
  var prefixed;
  var exit;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE$2 && character !== C_TAB$2) {
      break;
    }

    index++;
  }

  if (value.charAt(index) !== C_GT) {
    return;
  }

  if (silent) {
    return true;
  }

  index = 0;

  while (index < length) {
    nextIndex = value.indexOf(C_NEWLINE$3, index);
    startIndex = index;
    prefixed = false;

    if (nextIndex === -1) {
      nextIndex = length;
    }

    while (index < length) {
      character = value.charAt(index);

      if (character !== C_SPACE$2 && character !== C_TAB$2) {
        break;
      }

      index++;
    }

    if (value.charAt(index) === C_GT) {
      index++;
      prefixed = true;

      if (value.charAt(index) === C_SPACE$2) {
        index++;
      }
    } else {
      index = startIndex;
    }

    content = value.slice(index, nextIndex);

    if (!prefixed && !trim_1(content)) {
      index = startIndex;
      break;
    }

    if (!prefixed) {
      rest = value.slice(index);
      /* Check if the following code contains a possible
       * block. */

      if (interrupt_1(interruptors, tokenizers, self, [eat, rest, true])) {
        break;
      }
    }

    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
    indents.push(index - startIndex);
    values.push(line);
    contents.push(content);
    index = nextIndex + 1;
  }

  index = -1;
  length = indents.length;
  add = eat(values.join(C_NEWLINE$3));

  while (++index < length) {
    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
    currentLine++;
  }

  exit = self.enterBlock();
  contents = self.tokenizeBlock(contents.join(C_NEWLINE$3), now);
  exit();
  return add({
    type: 'blockquote',
    children: contents
  });
}

var headingAtx = atxHeading;
var C_NEWLINE$4 = '\n';
var C_TAB$3 = '\t';
var C_SPACE$3 = ' ';
var C_HASH = '#';
var MAX_ATX_COUNT = 6;

function atxHeading(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var length = value.length + 1;
  var index = -1;
  var now = eat.now();
  var subvalue = '';
  var content = '';
  var character;
  var queue;
  var depth;
  /* Eat initial spacing. */

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE$3 && character !== C_TAB$3) {
      index--;
      break;
    }

    subvalue += character;
  }
  /* Eat hashes. */


  depth = 0;

  while (++index <= length) {
    character = value.charAt(index);

    if (character !== C_HASH) {
      index--;
      break;
    }

    subvalue += character;
    depth++;
  }

  if (depth > MAX_ATX_COUNT) {
    return;
  }

  if (!depth || !settings.pedantic && value.charAt(index + 1) === C_HASH) {
    return;
  }

  length = value.length + 1;
  /* Eat intermediate white-space. */

  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE$3 && character !== C_TAB$3) {
      index--;
      break;
    }

    queue += character;
  }
  /* Exit when not in pedantic mode without spacing. */


  if (!settings.pedantic && queue.length === 0 && character && character !== C_NEWLINE$4) {
    return;
  }

  if (silent) {
    return true;
  }
  /* Eat content. */


  subvalue += queue;
  queue = '';
  content = '';

  while (++index < length) {
    character = value.charAt(index);

    if (!character || character === C_NEWLINE$4) {
      break;
    }

    if (character !== C_SPACE$3 && character !== C_TAB$3 && character !== C_HASH) {
      content += queue + character;
      queue = '';
      continue;
    }

    while (character === C_SPACE$3 || character === C_TAB$3) {
      queue += character;
      character = value.charAt(++index);
    }

    while (character === C_HASH) {
      queue += character;
      character = value.charAt(++index);
    }

    while (character === C_SPACE$3 || character === C_TAB$3) {
      queue += character;
      character = value.charAt(++index);
    }

    index--;
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  subvalue += content + queue;
  return eat(subvalue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  });
}

var thematicBreak_1 = thematicBreak;
var C_NEWLINE$5 = '\n';
var C_TAB$4 = '\t';
var C_SPACE$4 = ' ';
var C_ASTERISK = '*';
var C_UNDERSCORE = '_';
var C_DASH = '-';
var THEMATIC_BREAK_MARKER_COUNT = 3;

function thematicBreak(eat, value, silent) {
  var index = -1;
  var length = value.length + 1;
  var subvalue = '';
  var character;
  var marker;
  var markerCount;
  var queue;

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_TAB$4 && character !== C_SPACE$4) {
      break;
    }

    subvalue += character;
  }

  if (character !== C_ASTERISK && character !== C_DASH && character !== C_UNDERSCORE) {
    return;
  }

  marker = character;
  subvalue += character;
  markerCount = 1;
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character === marker) {
      markerCount++;
      subvalue += queue + marker;
      queue = '';
    } else if (character === C_SPACE$4) {
      queue += character;
    } else if (markerCount >= THEMATIC_BREAK_MARKER_COUNT && (!character || character === C_NEWLINE$5)) {
      subvalue += queue;

      if (silent) {
        return true;
      }

      return eat(subvalue)({
        type: 'thematicBreak'
      });
    } else {
      return;
    }
  }
}

var getIndentation = indentation;
/* Map of characters, and their column length,
 * which can be used as indentation. */

var characters = {
  ' ': 1,
  '\t': 4
};
/* Gets indentation information for a line. */

function indentation(value) {
  var index = 0;
  var indent = 0;
  var character = value.charAt(index);
  var stops = {};
  var size;

  while (character in characters) {
    size = characters[character];
    indent += size;

    if (size > 1) {
      indent = Math.floor(indent / size) * size;
    }

    stops[indent] = index;
    character = value.charAt(++index);
  }

  return {
    indent: indent,
    stops: stops
  };
}

var removeIndentation = indentation$1;
var C_SPACE$5 = ' ';
var C_NEWLINE$6 = '\n';
var C_TAB$5 = '\t';
/* Remove the minimum indent from every line in `value`.
 * Supports both tab, spaced, and mixed indentation (as
 * well as possible). */

function indentation$1(value, maximum) {
  var values = value.split(C_NEWLINE$6);
  var position = values.length + 1;
  var minIndent = Infinity;
  var matrix = [];
  var index;
  var indentation;
  var stops;
  var padding;
  values.unshift(repeatString(C_SPACE$5, maximum) + '!');

  while (position--) {
    indentation = getIndentation(values[position]);
    matrix[position] = indentation.stops;

    if (trim_1(values[position]).length === 0) {
      continue;
    }

    if (indentation.indent) {
      if (indentation.indent > 0 && indentation.indent < minIndent) {
        minIndent = indentation.indent;
      }
    } else {
      minIndent = Infinity;
      break;
    }
  }

  if (minIndent !== Infinity) {
    position = values.length;

    while (position--) {
      stops = matrix[position];
      index = minIndent;

      while (index && !(index in stops)) {
        index--;
      }

      if (trim_1(values[position]).length !== 0 && minIndent && index !== minIndent) {
        padding = C_TAB$5;
      } else {
        padding = '';
      }

      values[position] = padding + values[position].slice(index in stops ? stops[index] + 1 : 0);
    }
  }

  values.shift();
  return values.join(C_NEWLINE$6);
}
/* eslint-disable max-params */


var list_1 = list;
var C_ASTERISK$1 = '*';
var C_UNDERSCORE$1 = '_';
var C_PLUS = '+';
var C_DASH$1 = '-';
var C_DOT = '.';
var C_SPACE$6 = ' ';
var C_NEWLINE$7 = '\n';
var C_TAB$6 = '\t';
var C_PAREN_CLOSE = ')';
var C_X_LOWER = 'x';
var TAB_SIZE = 4;
var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
/* Map of characters which can be used to mark
 * list-items. */

var LIST_UNORDERED_MARKERS = {};
LIST_UNORDERED_MARKERS[C_ASTERISK$1] = true;
LIST_UNORDERED_MARKERS[C_PLUS] = true;
LIST_UNORDERED_MARKERS[C_DASH$1] = true;
/* Map of characters which can be used to mark
 * list-items after a digit. */

var LIST_ORDERED_MARKERS = {};
LIST_ORDERED_MARKERS[C_DOT] = true;
/* Map of characters which can be used to mark
 * list-items after a digit. */

var LIST_ORDERED_COMMONMARK_MARKERS = {};
LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;

function list(eat, value, silent) {
  var self = this;
  var commonmark = self.options.commonmark;
  var pedantic = self.options.pedantic;
  var tokenizers = self.blockTokenizers;
  var interuptors = self.interruptList;
  var markers;
  var index = 0;
  var length = value.length;
  var start = null;
  var size = 0;
  var queue;
  var ordered;
  var character;
  var marker;
  var nextIndex;
  var startIndex;
  var prefixed;
  var currentMarker;
  var content;
  var line;
  var prevEmpty;
  var empty;
  var items;
  var allLines;
  var emptyLines;
  var item;
  var enterTop;
  var exitBlockquote;
  var isLoose;
  var node;
  var now;
  var end;
  var indented;

  while (index < length) {
    character = value.charAt(index);

    if (character === C_TAB$6) {
      size += TAB_SIZE - size % TAB_SIZE;
    } else if (character === C_SPACE$6) {
      size++;
    } else {
      break;
    }

    index++;
  }

  if (size >= TAB_SIZE) {
    return;
  }

  character = value.charAt(index);
  markers = commonmark ? LIST_ORDERED_COMMONMARK_MARKERS : LIST_ORDERED_MARKERS;

  if (LIST_UNORDERED_MARKERS[character] === true) {
    marker = character;
    ordered = false;
  } else {
    ordered = true;
    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (!isDecimal(character)) {
        break;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (!queue || markers[character] !== true) {
      return;
    }

    start = parseInt(queue, 10);
    marker = character;
  }

  character = value.charAt(++index);

  if (character !== C_SPACE$6 && character !== C_TAB$6) {
    return;
  }

  if (silent) {
    return true;
  }

  index = 0;
  items = [];
  allLines = [];
  emptyLines = [];

  while (index < length) {
    nextIndex = value.indexOf(C_NEWLINE$7, index);
    startIndex = index;
    prefixed = false;
    indented = false;

    if (nextIndex === -1) {
      nextIndex = length;
    }

    end = index + TAB_SIZE;
    size = 0;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_TAB$6) {
        size += TAB_SIZE - size % TAB_SIZE;
      } else if (character === C_SPACE$6) {
        size++;
      } else {
        break;
      }

      index++;
    }

    if (size >= TAB_SIZE) {
      indented = true;
    }

    if (item && size >= item.indent) {
      indented = true;
    }

    character = value.charAt(index);
    currentMarker = null;

    if (!indented) {
      if (LIST_UNORDERED_MARKERS[character] === true) {
        currentMarker = character;
        index++;
        size++;
      } else {
        queue = '';

        while (index < length) {
          character = value.charAt(index);

          if (!isDecimal(character)) {
            break;
          }

          queue += character;
          index++;
        }

        character = value.charAt(index);
        index++;

        if (queue && markers[character] === true) {
          currentMarker = character;
          size += queue.length + 1;
        }
      }

      if (currentMarker) {
        character = value.charAt(index);

        if (character === C_TAB$6) {
          size += TAB_SIZE - size % TAB_SIZE;
          index++;
        } else if (character === C_SPACE$6) {
          end = index + TAB_SIZE;

          while (index < end) {
            if (value.charAt(index) !== C_SPACE$6) {
              break;
            }

            index++;
            size++;
          }

          if (index === end && value.charAt(index) === C_SPACE$6) {
            index -= TAB_SIZE - 1;
            size -= TAB_SIZE - 1;
          }
        } else if (character !== C_NEWLINE$7 && character !== '') {
          currentMarker = null;
        }
      }
    }

    if (currentMarker) {
      if (!pedantic && marker !== currentMarker) {
        break;
      }

      prefixed = true;
    } else {
      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE$6) {
        indented = true;
      } else if (commonmark && item) {
        indented = size >= item.indent || size > TAB_SIZE;
      }

      prefixed = false;
      index = startIndex;
    }

    line = value.slice(startIndex, nextIndex);
    content = startIndex === index ? line : value.slice(index, nextIndex);

    if (currentMarker === C_ASTERISK$1 || currentMarker === C_UNDERSCORE$1 || currentMarker === C_DASH$1) {
      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
        break;
      }
    }

    prevEmpty = empty;
    empty = !trim_1(content).length;

    if (indented && item) {
      item.value = item.value.concat(emptyLines, line);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    } else if (prefixed) {
      if (emptyLines.length !== 0) {
        item.value.push('');
        item.trail = emptyLines.concat();
      }

      item = {
        value: [line],
        indent: size,
        trail: []
      };
      items.push(item);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    } else if (empty) {
      if (prevEmpty) {
        break;
      }

      emptyLines.push(line);
    } else {
      if (prevEmpty) {
        break;
      }

      if (interrupt_1(interuptors, tokenizers, self, [eat, line, true])) {
        break;
      }

      item.value = item.value.concat(emptyLines, line);
      allLines = allLines.concat(emptyLines, line);
      emptyLines = [];
    }

    index = nextIndex + 1;
  }

  node = eat(allLines.join(C_NEWLINE$7)).reset({
    type: 'list',
    ordered: ordered,
    start: start,
    loose: null,
    children: []
  });
  enterTop = self.enterList();
  exitBlockquote = self.enterBlock();
  isLoose = false;
  index = -1;
  length = items.length;

  while (++index < length) {
    item = items[index].value.join(C_NEWLINE$7);
    now = eat.now();
    item = eat(item)(listItem(self, item, now), node);

    if (item.loose) {
      isLoose = true;
    }

    item = items[index].trail.join(C_NEWLINE$7);

    if (index !== length - 1) {
      item += C_NEWLINE$7;
    }

    eat(item);
  }

  enterTop();
  exitBlockquote();
  node.loose = isLoose;
  return node;
}

function listItem(ctx, value, position) {
  var offsets = ctx.offset;
  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
  var checked = null;
  var task;
  var indent;
  value = fn.apply(null, arguments);

  if (ctx.options.gfm) {
    task = value.match(EXPRESSION_TASK_ITEM);

    if (task) {
      indent = task[0].length;
      checked = task[1].toLowerCase() === C_X_LOWER;
      offsets[position.line] += indent;
      value = value.slice(indent);
    }
  }

  return {
    type: 'listItem',
    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) || value.charAt(value.length - 1) === C_NEWLINE$7,
    checked: checked,
    children: ctx.tokenizeBlock(value, position)
  };
}
/* Create a list-item using overly simple mechanics. */


function pedanticListItem(ctx, value, position) {
  var offsets = ctx.offset;
  var line = position.line;
  /* Remove the list-item’s bullet. */

  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
  /* The initial line was also matched by the below, so
   * we reset the `line`. */

  line = position.line;
  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
  /* A simple replacer which removed all matches,
   * and adds their length to `offset`. */

  function replacer($0) {
    offsets[line] = (offsets[line] || 0) + $0.length;
    line++;
    return '';
  }
}
/* Create a list-item using sane mechanics. */


function normalListItem(ctx, value, position) {
  var offsets = ctx.offset;
  var line = position.line;
  var max;
  var bullet;
  var rest;
  var lines;
  var trimmedLines;
  var index;
  var length;
  /* Remove the list-item’s bullet. */

  value = value.replace(EXPRESSION_BULLET, replacer);
  lines = value.split(C_NEWLINE$7);
  trimmedLines = removeIndentation(value, getIndentation(max).indent).split(C_NEWLINE$7);
  /* We replaced the initial bullet with something
   * else above, which was used to trick
   * `removeIndentation` into removing some more
   * characters when possible.  However, that could
   * result in the initial line to be stripped more
   * than it should be. */

  trimmedLines[0] = rest;
  offsets[line] = (offsets[line] || 0) + bullet.length;
  line++;
  index = 0;
  length = lines.length;

  while (++index < length) {
    offsets[line] = (offsets[line] || 0) + lines[index].length - trimmedLines[index].length;
    line++;
  }

  return trimmedLines.join(C_NEWLINE$7);

  function replacer($0, $1, $2, $3, $4) {
    bullet = $1 + $2 + $3;
    rest = $4;
    /* Make sure that the first nine numbered list items
     * can indent with an extra space.  That is, when
     * the bullet did not receive an extra final space. */

    if (Number($2) < 10 && bullet.length % 2 === 1) {
      $2 = C_SPACE$6 + $2;
    }

    max = $1 + repeatString(C_SPACE$6, $2.length) + $3;
    return max + rest;
  }
}

var headingSetext = setextHeading;
var C_NEWLINE$8 = '\n';
var C_TAB$7 = '\t';
var C_SPACE$7 = ' ';
var C_EQUALS = '=';
var C_DASH$2 = '-';
var MAX_HEADING_INDENT = 3;
/* Map of characters which can be used to mark setext
 * headers, mapping to their corresponding depth. */

var SETEXT_MARKERS = {};
SETEXT_MARKERS[C_EQUALS] = 1;
SETEXT_MARKERS[C_DASH$2] = 2;

function setextHeading(eat, value, silent) {
  var self = this;
  var now = eat.now();
  var length = value.length;
  var index = -1;
  var subvalue = '';
  var content;
  var queue;
  var character;
  var marker;
  var depth;
  /* Eat initial indentation. */

  while (++index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE$7 || index >= MAX_HEADING_INDENT) {
      index--;
      break;
    }

    subvalue += character;
  }
  /* Eat content. */


  content = '';
  queue = '';

  while (++index < length) {
    character = value.charAt(index);

    if (character === C_NEWLINE$8) {
      index--;
      break;
    }

    if (character === C_SPACE$7 || character === C_TAB$7) {
      queue += character;
    } else {
      content += queue + character;
      queue = '';
    }
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  subvalue += content + queue;
  /* Ensure the content is followed by a newline and a
   * valid marker. */

  character = value.charAt(++index);
  marker = value.charAt(++index);

  if (character !== C_NEWLINE$8 || !SETEXT_MARKERS[marker]) {
    return;
  }

  subvalue += character;
  /* Eat Setext-line. */

  queue = marker;
  depth = SETEXT_MARKERS[marker];

  while (++index < length) {
    character = value.charAt(index);

    if (character !== marker) {
      if (character !== C_NEWLINE$8) {
        return;
      }

      index--;
      break;
    }

    queue += character;
  }

  if (silent) {
    return true;
  }

  return eat(subvalue + queue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  });
}

var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var unquoted = "[^\"'=<>`\\u0000-\\u0020]+";
var singleQuoted = '\'[^\']*\'';
var doubleQuoted = '"[^"]*"';
var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing = '<[?].*?[?]>';
var declaration = '<![A-Za-z]+\\s+[^>]*>';
var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
var tag = new RegExp('^(?:' + openTag + '|' + closeTag + '|' + comment + '|' + processing + '|' + declaration + '|' + cdata + ')');
var html = {
  openCloseTag: openCloseTag,
  tag: tag
};
var openCloseTag$1 = html.openCloseTag;
var htmlBlock = blockHTML;
var C_TAB$8 = '\t';
var C_SPACE$8 = ' ';
var C_NEWLINE$9 = '\n';
var C_LT = '<';

function blockHTML(eat, value, silent) {
  var self = this;
  var blocks = self.options.blocks;
  var length = value.length;
  var index = 0;
  var next;
  var line;
  var offset;
  var character;
  var count;
  var sequence;
  var subvalue;
  var sequences = [[/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true], [/^<!--/, /-->/, true], [/^<\?/, /\?>/, true], [/^<![A-Za-z]/, />/, true], [/^<!\[CDATA\[/, /\]\]>/, true], [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true], [new RegExp(openCloseTag$1.source + '\\s*$'), /^$/, false]];
  /* Eat initial spacing. */

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB$8 && character !== C_SPACE$8) {
      break;
    }

    index++;
  }

  if (value.charAt(index) !== C_LT) {
    return;
  }

  next = value.indexOf(C_NEWLINE$9, index + 1);
  next = next === -1 ? length : next;
  line = value.slice(index, next);
  offset = -1;
  count = sequences.length;

  while (++offset < count) {
    if (sequences[offset][0].test(line)) {
      sequence = sequences[offset];
      break;
    }
  }

  if (!sequence) {
    return;
  }

  if (silent) {
    return sequence[2];
  }

  index = next;

  if (!sequence[1].test(line)) {
    while (index < length) {
      next = value.indexOf(C_NEWLINE$9, index + 1);
      next = next === -1 ? length : next;
      line = value.slice(index + 1, next);

      if (sequence[1].test(line)) {
        if (line) {
          index = next;
        }

        break;
      }

      index = next;
    }
  }

  subvalue = value.slice(0, index);
  return eat(subvalue)({
    type: 'html',
    value: subvalue
  });
}

var collapseWhiteSpace = collapse;
/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */

function collapse(value) {
  return String(value).replace(/\s+/g, ' ');
}

var normalize_1 = normalize$1;
/* Normalize an identifier.  Collapses multiple white space
 * characters into a single space, and removes casing. */

function normalize$1(value) {
  return collapseWhiteSpace(value).toLowerCase();
}

var footnoteDefinition_1 = footnoteDefinition;
footnoteDefinition.notInList = true;
footnoteDefinition.notInBlock = true;
var C_BACKSLASH = '\\';
var C_NEWLINE$a = '\n';
var C_TAB$9 = '\t';
var C_SPACE$9 = ' ';
var C_BRACKET_OPEN = '[';
var C_BRACKET_CLOSE = ']';
var C_CARET = '^';
var C_COLON = ':';
var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;

function footnoteDefinition(eat, value, silent) {
  var self = this;
  var offsets = self.offset;
  var index;
  var length;
  var subvalue;
  var now;
  var currentLine;
  var content;
  var queue;
  var subqueue;
  var character;
  var identifier;
  var add;
  var exit;

  if (!self.options.footnotes) {
    return;
  }

  index = 0;
  length = value.length;
  subvalue = '';
  now = eat.now();
  currentLine = now.line;

  while (index < length) {
    character = value.charAt(index);

    if (!isWhitespaceCharacter(character)) {
      break;
    }

    subvalue += character;
    index++;
  }

  if (value.charAt(index) !== C_BRACKET_OPEN || value.charAt(index + 1) !== C_CARET) {
    return;
  }

  subvalue += C_BRACKET_OPEN + C_CARET;
  index = subvalue.length;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE) {
      break;
    } else if (character === C_BACKSLASH) {
      queue += character;
      index++;
      character = value.charAt(index);
    }

    queue += character;
    index++;
  }

  if (!queue || value.charAt(index) !== C_BRACKET_CLOSE || value.charAt(index + 1) !== C_COLON) {
    return;
  }

  if (silent) {
    return true;
  }

  identifier = normalize_1(queue);
  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
  index = subvalue.length;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB$9 && character !== C_SPACE$9) {
      break;
    }

    subvalue += character;
    index++;
  }

  now.column += subvalue.length;
  now.offset += subvalue.length;
  queue = '';
  content = '';
  subqueue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_NEWLINE$a) {
      subqueue = character;
      index++;

      while (index < length) {
        character = value.charAt(index);

        if (character !== C_NEWLINE$a) {
          break;
        }

        subqueue += character;
        index++;
      }

      queue += subqueue;
      subqueue = '';

      while (index < length) {
        character = value.charAt(index);

        if (character !== C_SPACE$9) {
          break;
        }

        subqueue += character;
        index++;
      }

      if (subqueue.length === 0) {
        break;
      }

      queue += subqueue;
    }

    if (queue) {
      content += queue;
      queue = '';
    }

    content += character;
    index++;
  }

  subvalue += content;
  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
    currentLine++;
    return '';
  });
  add = eat(subvalue);
  exit = self.enterBlock();
  content = self.tokenizeBlock(content, now);
  exit();
  return add({
    type: 'footnoteDefinition',
    identifier: identifier,
    children: content
  });
}

var definition_1 = definition;
definition.notInList = true;
definition.notInBlock = true;
var C_DOUBLE_QUOTE = '"';
var C_SINGLE_QUOTE = '\'';
var C_BACKSLASH$1 = '\\';
var C_NEWLINE$b = '\n';
var C_TAB$a = '\t';
var C_SPACE$a = ' ';
var C_BRACKET_OPEN$1 = '[';
var C_BRACKET_CLOSE$1 = ']';
var C_PAREN_OPEN = '(';
var C_PAREN_CLOSE$1 = ')';
var C_COLON$1 = ':';
var C_LT$1 = '<';
var C_GT$1 = '>';

function definition(eat, value, silent) {
  var self = this;
  var commonmark = self.options.commonmark;
  var index = 0;
  var length = value.length;
  var subvalue = '';
  var beforeURL;
  var beforeTitle;
  var queue;
  var character;
  var test;
  var identifier;
  var url;
  var title;

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_SPACE$a && character !== C_TAB$a) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);

  if (character !== C_BRACKET_OPEN$1) {
    return;
  }

  index++;
  subvalue += character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE$1) {
      break;
    } else if (character === C_BACKSLASH$1) {
      queue += character;
      index++;
      character = value.charAt(index);
    }

    queue += character;
    index++;
  }

  if (!queue || value.charAt(index) !== C_BRACKET_CLOSE$1 || value.charAt(index + 1) !== C_COLON$1) {
    return;
  }

  identifier = queue;
  subvalue += queue + C_BRACKET_CLOSE$1 + C_COLON$1;
  index = subvalue.length;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB$a && character !== C_SPACE$a && character !== C_NEWLINE$b) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);
  queue = '';
  beforeURL = subvalue;

  if (character === C_LT$1) {
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (!isEnclosedURLCharacter(character)) {
        break;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (character === isEnclosedURLCharacter.delimiter) {
      subvalue += C_LT$1 + queue + character;
      index++;
    } else {
      if (commonmark) {
        return;
      }

      index -= queue.length + 1;
      queue = '';
    }
  }

  if (!queue) {
    while (index < length) {
      character = value.charAt(index);

      if (!isUnclosedURLCharacter(character)) {
        break;
      }

      queue += character;
      index++;
    }

    subvalue += queue;
  }

  if (!queue) {
    return;
  }

  url = queue;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB$a && character !== C_SPACE$a && character !== C_NEWLINE$b) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);
  test = null;

  if (character === C_DOUBLE_QUOTE) {
    test = C_DOUBLE_QUOTE;
  } else if (character === C_SINGLE_QUOTE) {
    test = C_SINGLE_QUOTE;
  } else if (character === C_PAREN_OPEN) {
    test = C_PAREN_CLOSE$1;
  }

  if (!test) {
    queue = '';
    index = subvalue.length;
  } else if (queue) {
    subvalue += queue + character;
    index = subvalue.length;
    queue = '';

    while (index < length) {
      character = value.charAt(index);

      if (character === test) {
        break;
      }

      if (character === C_NEWLINE$b) {
        index++;
        character = value.charAt(index);

        if (character === C_NEWLINE$b || character === test) {
          return;
        }

        queue += C_NEWLINE$b;
      }

      queue += character;
      index++;
    }

    character = value.charAt(index);

    if (character !== test) {
      return;
    }

    beforeTitle = subvalue;
    subvalue += queue + character;
    index++;
    title = queue;
    queue = '';
  } else {
    return;
  }

  while (index < length) {
    character = value.charAt(index);

    if (character !== C_TAB$a && character !== C_SPACE$a) {
      break;
    }

    subvalue += character;
    index++;
  }

  character = value.charAt(index);

  if (!character || character === C_NEWLINE$b) {
    if (silent) {
      return true;
    }

    beforeURL = eat(beforeURL).test().end;
    url = self.decode.raw(self.unescape(url), beforeURL, {
      nonTerminated: false
    });

    if (title) {
      beforeTitle = eat(beforeTitle).test().end;
      title = self.decode.raw(self.unescape(title), beforeTitle);
    }

    return eat(subvalue)({
      type: 'definition',
      identifier: normalize_1(identifier),
      title: title || null,
      url: url
    });
  }
}
/* Check if `character` can be inside an enclosed URI. */


function isEnclosedURLCharacter(character) {
  return character !== C_GT$1 && character !== C_BRACKET_OPEN$1 && character !== C_BRACKET_CLOSE$1;
}

isEnclosedURLCharacter.delimiter = C_GT$1;
/* Check if `character` can be inside an unclosed URI. */

function isUnclosedURLCharacter(character) {
  return character !== C_BRACKET_OPEN$1 && character !== C_BRACKET_CLOSE$1 && !isWhitespaceCharacter(character);
}

var table_1 = table;
var C_BACKSLASH$2 = '\\';
var C_TICK$1 = '`';
var C_DASH$3 = '-';
var C_PIPE = '|';
var C_COLON$2 = ':';
var C_SPACE$b = ' ';
var C_NEWLINE$c = '\n';
var C_TAB$b = '\t';
var MIN_TABLE_COLUMNS = 1;
var MIN_TABLE_ROWS = 2;
var TABLE_ALIGN_LEFT = 'left';
var TABLE_ALIGN_CENTER = 'center';
var TABLE_ALIGN_RIGHT = 'right';
var TABLE_ALIGN_NONE = null;

function table(eat, value, silent) {
  var self = this;
  var index;
  var alignments;
  var alignment;
  var subvalue;
  var row;
  var length;
  var lines;
  var queue;
  var character;
  var hasDash;
  var align;
  var cell;
  var preamble;
  var count;
  var opening;
  var now;
  var position;
  var lineCount;
  var line;
  var rows;
  var table;
  var lineIndex;
  var pipeIndex;
  var first;
  /* Exit when not in gfm-mode. */

  if (!self.options.gfm) {
    return;
  }
  /* Get the rows.
   * Detecting tables soon is hard, so there are some
   * checks for performance here, such as the minimum
   * number of rows, and allowed characters in the
   * alignment row. */


  index = 0;
  lineCount = 0;
  length = value.length + 1;
  lines = [];

  while (index < length) {
    lineIndex = value.indexOf(C_NEWLINE$c, index);
    pipeIndex = value.indexOf(C_PIPE, index + 1);

    if (lineIndex === -1) {
      lineIndex = value.length;
    }

    if (pipeIndex === -1 || pipeIndex > lineIndex) {
      if (lineCount < MIN_TABLE_ROWS) {
        return;
      }

      break;
    }

    lines.push(value.slice(index, lineIndex));
    lineCount++;
    index = lineIndex + 1;
  }
  /* Parse the alignment row. */


  subvalue = lines.join(C_NEWLINE$c);
  alignments = lines.splice(1, 1)[0] || [];
  index = 0;
  length = alignments.length;
  lineCount--;
  alignment = false;
  align = [];

  while (index < length) {
    character = alignments.charAt(index);

    if (character === C_PIPE) {
      hasDash = null;

      if (alignment === false) {
        if (first === false) {
          return;
        }
      } else {
        align.push(alignment);
        alignment = false;
      }

      first = false;
    } else if (character === C_DASH$3) {
      hasDash = true;
      alignment = alignment || TABLE_ALIGN_NONE;
    } else if (character === C_COLON$2) {
      if (alignment === TABLE_ALIGN_LEFT) {
        alignment = TABLE_ALIGN_CENTER;
      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
        alignment = TABLE_ALIGN_RIGHT;
      } else {
        alignment = TABLE_ALIGN_LEFT;
      }
    } else if (!isWhitespaceCharacter(character)) {
      return;
    }

    index++;
  }

  if (alignment !== false) {
    align.push(alignment);
  }
  /* Exit when without enough columns. */


  if (align.length < MIN_TABLE_COLUMNS) {
    return;
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }
  /* Parse the rows. */


  position = -1;
  rows = [];
  table = eat(subvalue).reset({
    type: 'table',
    align: align,
    children: rows
  });

  while (++position < lineCount) {
    line = lines[position];
    row = {
      type: 'tableRow',
      children: []
    };
    /* Eat a newline character when this is not the
     * first row. */

    if (position) {
      eat(C_NEWLINE$c);
    }
    /* Eat the row. */


    eat(line).reset(row, table);
    length = line.length + 1;
    index = 0;
    queue = '';
    cell = '';
    preamble = true;
    count = null;
    opening = null;

    while (index < length) {
      character = line.charAt(index);

      if (character === C_TAB$b || character === C_SPACE$b) {
        if (cell) {
          queue += character;
        } else {
          eat(character);
        }

        index++;
        continue;
      }

      if (character === '' || character === C_PIPE) {
        if (preamble) {
          eat(character);
        } else {
          if (character && opening) {
            queue += character;
            index++;
            continue;
          }

          if ((cell || character) && !preamble) {
            subvalue = cell;

            if (queue.length > 1) {
              if (character) {
                subvalue += queue.slice(0, queue.length - 1);
                queue = queue.charAt(queue.length - 1);
              } else {
                subvalue += queue;
                queue = '';
              }
            }

            now = eat.now();
            eat(subvalue)({
              type: 'tableCell',
              children: self.tokenizeInline(cell, now)
            }, row);
          }

          eat(queue + character);
          queue = '';
          cell = '';
        }
      } else {
        if (queue) {
          cell += queue;
          queue = '';
        }

        cell += character;

        if (character === C_BACKSLASH$2 && index !== length - 2) {
          cell += line.charAt(index + 1);
          index++;
        }

        if (character === C_TICK$1) {
          count = 1;

          while (line.charAt(index + 1) === character) {
            cell += character;
            index++;
            count++;
          }

          if (!opening) {
            opening = count;
          } else if (count >= opening) {
            opening = 0;
          }
        }
      }

      preamble = false;
      index++;
    }
    /* Eat the alignment row. */


    if (!position) {
      eat(C_NEWLINE$c + alignments);
    }
  }

  return table;
}

var paragraph_1 = paragraph;
var C_NEWLINE$d = '\n';
var C_TAB$c = '\t';
var C_SPACE$c = ' ';
var TAB_SIZE$1 = 4;
/* Tokenise paragraph. */

function paragraph(eat, value, silent) {
  var self = this;
  var settings = self.options;
  var commonmark = settings.commonmark;
  var gfm = settings.gfm;
  var tokenizers = self.blockTokenizers;
  var interruptors = self.interruptParagraph;
  var index = value.indexOf(C_NEWLINE$d);
  var length = value.length;
  var position;
  var subvalue;
  var character;
  var size;
  var now;

  while (index < length) {
    /* Eat everything if there’s no following newline. */
    if (index === -1) {
      index = length;
      break;
    }
    /* Stop if the next character is NEWLINE. */


    if (value.charAt(index + 1) === C_NEWLINE$d) {
      break;
    }
    /* In commonmark-mode, following indented lines
     * are part of the paragraph. */


    if (commonmark) {
      size = 0;
      position = index + 1;

      while (position < length) {
        character = value.charAt(position);

        if (character === C_TAB$c) {
          size = TAB_SIZE$1;
          break;
        } else if (character === C_SPACE$c) {
          size++;
        } else {
          break;
        }

        position++;
      }

      if (size >= TAB_SIZE$1) {
        index = value.indexOf(C_NEWLINE$d, index + 1);
        continue;
      }
    }

    subvalue = value.slice(index + 1);
    /* Check if the following code contains a possible
     * block. */

    if (interrupt_1(interruptors, tokenizers, self, [eat, subvalue, true])) {
      break;
    }
    /* Break if the following line starts a list, when
     * already in a list, or when in commonmark, or when
     * in gfm mode and the bullet is *not* numeric. */


    if (tokenizers.list.call(self, eat, subvalue, true) && (self.inList || commonmark || gfm && !isDecimal(trim_1.left(subvalue).charAt(0)))) {
      break;
    }

    position = index;
    index = value.indexOf(C_NEWLINE$d, index + 1);

    if (index !== -1 && trim_1(value.slice(position, index)) === '') {
      index = position;
      break;
    }
  }

  subvalue = value.slice(0, index);

  if (trim_1(subvalue) === '') {
    eat(subvalue);
    return null;
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }

  now = eat.now();
  subvalue = trimTrailingLines_1(subvalue);
  return eat(subvalue)({
    type: 'paragraph',
    children: self.tokenizeInline(subvalue, now)
  });
}

var _escape = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}

var _escape$1 = escape;
escape.locator = _escape;

function escape(eat, value, silent) {
  var self = this;
  var character;
  var node;

  if (value.charAt(0) === '\\') {
    character = value.charAt(1);

    if (self.escape.indexOf(character) !== -1) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      if (character === '\n') {
        node = {
          type: 'break'
        };
      } else {
        node = {
          type: 'text',
          value: character
        };
      }

      return eat('\\' + character)(node);
    }
  }
}

var tag$1 = locate$1;

function locate$1(value, fromIndex) {
  return value.indexOf('<', fromIndex);
}

var autoLink_1 = autoLink;
autoLink.locator = tag$1;
autoLink.notInLink = true;
var C_LT$2 = '<';
var C_GT$2 = '>';
var C_AT_SIGN = '@';
var C_SLASH = '/';
var MAILTO = 'mailto:';
var MAILTO_LENGTH = MAILTO.length;
/* Tokenise a link. */

function autoLink(eat, value, silent) {
  var self;
  var subvalue;
  var length;
  var index;
  var queue;
  var character;
  var hasAtCharacter;
  var link;
  var now;
  var content;
  var tokenizers;
  var exit;

  if (value.charAt(0) !== C_LT$2) {
    return;
  }

  self = this;
  subvalue = '';
  length = value.length;
  index = 0;
  queue = '';
  hasAtCharacter = false;
  link = '';
  index++;
  subvalue = C_LT$2;

  while (index < length) {
    character = value.charAt(index);

    if (isWhitespaceCharacter(character) || character === C_GT$2 || character === C_AT_SIGN || character === ':' && value.charAt(index + 1) === C_SLASH) {
      break;
    }

    queue += character;
    index++;
  }

  if (!queue) {
    return;
  }

  link += queue;
  queue = '';
  character = value.charAt(index);
  link += character;
  index++;

  if (character === C_AT_SIGN) {
    hasAtCharacter = true;
  } else {
    if (character !== ':' || value.charAt(index + 1) !== C_SLASH) {
      return;
    }

    link += C_SLASH;
    index++;
  }

  while (index < length) {
    character = value.charAt(index);

    if (isWhitespaceCharacter(character) || character === C_GT$2) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);

  if (!queue || character !== C_GT$2) {
    return;
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }

  link += queue;
  content = link;
  subvalue += link + character;
  now = eat.now();
  now.column++;
  now.offset++;

  if (hasAtCharacter) {
    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
      content = content.substr(MAILTO_LENGTH);
      now.column += MAILTO_LENGTH;
      now.offset += MAILTO_LENGTH;
    } else {
      link = MAILTO + link;
    }
  }
  /* Temporarily remove all tokenizers except text in autolinks. */


  tokenizers = self.inlineTokenizers;
  self.inlineTokenizers = {
    text: tokenizers.text
  };
  exit = self.enterLink();
  content = self.tokenizeInline(content, now);
  self.inlineTokenizers = tokenizers;
  exit();
  return eat(subvalue)({
    type: 'link',
    title: null,
    url: parseEntities_1(link, {
      nonTerminated: false
    }),
    children: content
  });
}

var url = locate$2;
var PROTOCOLS = ['https://', 'http://', 'mailto:'];

function locate$2(value, fromIndex) {
  var length = PROTOCOLS.length;
  var index = -1;
  var min = -1;
  var position;

  if (!this.options.gfm) {
    return -1;
  }

  while (++index < length) {
    position = value.indexOf(PROTOCOLS[index], fromIndex);

    if (position !== -1 && (position < min || min === -1)) {
      min = position;
    }
  }

  return min;
}

var url_1 = url$1;
url$1.locator = url;
url$1.notInLink = true;
var C_BRACKET_OPEN$2 = '[';
var C_BRACKET_CLOSE$2 = ']';
var C_PAREN_OPEN$1 = '(';
var C_PAREN_CLOSE$2 = ')';
var C_LT$3 = '<';
var C_AT_SIGN$1 = '@';
var HTTP_PROTOCOL = 'http://';
var HTTPS_PROTOCOL = 'https://';
var MAILTO_PROTOCOL = 'mailto:';
var PROTOCOLS$1 = [HTTP_PROTOCOL, HTTPS_PROTOCOL, MAILTO_PROTOCOL];
var PROTOCOLS_LENGTH = PROTOCOLS$1.length;

function url$1(eat, value, silent) {
  var self = this;
  var subvalue;
  var content;
  var character;
  var index;
  var position;
  var protocol;
  var match;
  var length;
  var queue;
  var parenCount;
  var nextCharacter;
  var exit;

  if (!self.options.gfm) {
    return;
  }

  subvalue = '';
  index = -1;
  length = PROTOCOLS_LENGTH;

  while (++index < length) {
    protocol = PROTOCOLS$1[index];
    match = value.slice(0, protocol.length);

    if (match.toLowerCase() === protocol) {
      subvalue = match;
      break;
    }
  }

  if (!subvalue) {
    return;
  }

  index = subvalue.length;
  length = value.length;
  queue = '';
  parenCount = 0;

  while (index < length) {
    character = value.charAt(index);

    if (isWhitespaceCharacter(character) || character === C_LT$3) {
      break;
    }

    if (character === '.' || character === ',' || character === ':' || character === ';' || character === '"' || character === '\'' || character === ')' || character === ']') {
      nextCharacter = value.charAt(index + 1);

      if (!nextCharacter || isWhitespaceCharacter(nextCharacter)) {
        break;
      }
    }

    if (character === C_PAREN_OPEN$1 || character === C_BRACKET_OPEN$2) {
      parenCount++;
    }

    if (character === C_PAREN_CLOSE$2 || character === C_BRACKET_CLOSE$2) {
      parenCount--;

      if (parenCount < 0) {
        break;
      }
    }

    queue += character;
    index++;
  }

  if (!queue) {
    return;
  }

  subvalue += queue;
  content = subvalue;

  if (protocol === MAILTO_PROTOCOL) {
    position = queue.indexOf(C_AT_SIGN$1);

    if (position === -1 || position === length - 1) {
      return;
    }

    content = content.substr(MAILTO_PROTOCOL.length);
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }

  exit = self.enterLink();
  content = self.tokenizeInline(content, eat.now());
  exit();
  return eat(subvalue)({
    type: 'link',
    title: null,
    url: parseEntities_1(subvalue, {
      nonTerminated: false
    }),
    children: content
  });
}

var tag$2 = html.tag;
var htmlInline = inlineHTML;
inlineHTML.locator = tag$1;
var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;

function inlineHTML(eat, value, silent) {
  var self = this;
  var length = value.length;
  var character;
  var subvalue;

  if (value.charAt(0) !== '<' || length < 3) {
    return;
  }

  character = value.charAt(1);

  if (!isAlphabetical(character) && character !== '?' && character !== '!' && character !== '/') {
    return;
  }

  subvalue = value.match(tag$2);

  if (!subvalue) {
    return;
  }
  /* istanbul ignore if - not used yet. */


  if (silent) {
    return true;
  }

  subvalue = subvalue[0];

  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
    self.inLink = true;
  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
    self.inLink = false;
  }

  return eat(subvalue)({
    type: 'html',
    value: subvalue
  });
}

var link = locate$3;

function locate$3(value, fromIndex) {
  var link = value.indexOf('[', fromIndex);
  var image = value.indexOf('![', fromIndex);

  if (image === -1) {
    return link;
  }
  /* Link can never be `-1` if an image is found, so we don’t need
   * to check for that :) */


  return link < image ? link : image;
}

var link_1 = link$1;
link$1.locator = link;
var own$5 = {}.hasOwnProperty;
var C_BACKSLASH$3 = '\\';
var C_BRACKET_OPEN$3 = '[';
var C_BRACKET_CLOSE$3 = ']';
var C_PAREN_OPEN$2 = '(';
var C_PAREN_CLOSE$3 = ')';
var C_LT$4 = '<';
var C_GT$3 = '>';
var C_TICK$2 = '`';
var C_DOUBLE_QUOTE$1 = '"';
var C_SINGLE_QUOTE$1 = '\'';
/* Map of characters, which can be used to mark link
 * and image titles. */

var LINK_MARKERS = {};
LINK_MARKERS[C_DOUBLE_QUOTE$1] = C_DOUBLE_QUOTE$1;
LINK_MARKERS[C_SINGLE_QUOTE$1] = C_SINGLE_QUOTE$1;
/* Map of characters, which can be used to mark link
 * and image titles in commonmark-mode. */

var COMMONMARK_LINK_MARKERS = {};
COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE$1] = C_DOUBLE_QUOTE$1;
COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE$1] = C_SINGLE_QUOTE$1;
COMMONMARK_LINK_MARKERS[C_PAREN_OPEN$2] = C_PAREN_CLOSE$3;

function link$1(eat, value, silent) {
  var self = this;
  var subvalue = '';
  var index = 0;
  var character = value.charAt(0);
  var pedantic = self.options.pedantic;
  var commonmark = self.options.commonmark;
  var gfm = self.options.gfm;
  var closed;
  var count;
  var opening;
  var beforeURL;
  var beforeTitle;
  var subqueue;
  var hasMarker;
  var markers;
  var isImage;
  var content;
  var marker;
  var length;
  var title;
  var depth;
  var queue;
  var url;
  var now;
  var exit;
  var node;
  /* Detect whether this is an image. */

  if (character === '!') {
    isImage = true;
    subvalue = character;
    character = value.charAt(++index);
  }
  /* Eat the opening. */


  if (character !== C_BRACKET_OPEN$3) {
    return;
  }
  /* Exit when this is a link and we’re already inside
   * a link. */


  if (!isImage && self.inLink) {
    return;
  }

  subvalue += character;
  queue = '';
  index++;
  /* Eat the content. */

  length = value.length;
  now = eat.now();
  depth = 0;
  now.column += index;
  now.offset += index;

  while (index < length) {
    character = value.charAt(index);
    subqueue = character;

    if (character === C_TICK$2) {
      /* Inline-code in link content. */
      count = 1;

      while (value.charAt(index + 1) === C_TICK$2) {
        subqueue += character;
        index++;
        count++;
      }

      if (!opening) {
        opening = count;
      } else if (count >= opening) {
        opening = 0;
      }
    } else if (character === C_BACKSLASH$3) {
      /* Allow brackets to be escaped. */
      index++;
      subqueue += value.charAt(index);
      /* In GFM mode, brackets in code still count.
       * In all other modes, they don’t.  This empty
       * block prevents the next statements are
       * entered. */
    } else if ((!opening || gfm) && character === C_BRACKET_OPEN$3) {
      depth++;
    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE$3) {
      if (depth) {
        depth--;
      } else {
        /* Allow white-space between content and
         * url in GFM mode. */
        if (!pedantic) {
          while (index < length) {
            character = value.charAt(index + 1);

            if (!isWhitespaceCharacter(character)) {
              break;
            }

            subqueue += character;
            index++;
          }
        }

        if (value.charAt(index + 1) !== C_PAREN_OPEN$2) {
          return;
        }

        subqueue += C_PAREN_OPEN$2;
        closed = true;
        index++;
        break;
      }
    }

    queue += subqueue;
    subqueue = '';
    index++;
  }
  /* Eat the content closing. */


  if (!closed) {
    return;
  }

  content = queue;
  subvalue += queue + subqueue;
  index++;
  /* Eat white-space. */

  while (index < length) {
    character = value.charAt(index);

    if (!isWhitespaceCharacter(character)) {
      break;
    }

    subvalue += character;
    index++;
  }
  /* Eat the URL. */


  character = value.charAt(index);
  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
  queue = '';
  beforeURL = subvalue;

  if (character === C_LT$4) {
    index++;
    beforeURL += C_LT$4;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_GT$3) {
        break;
      }

      if (commonmark && character === '\n') {
        return;
      }

      queue += character;
      index++;
    }

    if (value.charAt(index) !== C_GT$3) {
      return;
    }

    subvalue += C_LT$4 + queue + C_GT$3;
    url = queue;
    index++;
  } else {
    character = null;
    subqueue = '';

    while (index < length) {
      character = value.charAt(index);

      if (subqueue && own$5.call(markers, character)) {
        break;
      }

      if (isWhitespaceCharacter(character)) {
        if (!pedantic) {
          break;
        }

        subqueue += character;
      } else {
        if (character === C_PAREN_OPEN$2) {
          depth++;
        } else if (character === C_PAREN_CLOSE$3) {
          if (depth === 0) {
            break;
          }

          depth--;
        }

        queue += subqueue;
        subqueue = '';

        if (character === C_BACKSLASH$3) {
          queue += C_BACKSLASH$3;
          character = value.charAt(++index);
        }

        queue += character;
      }

      index++;
    }

    subvalue += queue;
    url = queue;
    index = subvalue.length;
  }
  /* Eat white-space. */


  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!isWhitespaceCharacter(character)) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);
  subvalue += queue;
  /* Eat the title. */

  if (queue && own$5.call(markers, character)) {
    index++;
    subvalue += character;
    queue = '';
    marker = markers[character];
    beforeTitle = subvalue;
    /* In commonmark-mode, things are pretty easy: the
     * marker cannot occur inside the title.
     *
     * Non-commonmark does, however, support nested
     * delimiters. */

    if (commonmark) {
      while (index < length) {
        character = value.charAt(index);

        if (character === marker) {
          break;
        }

        if (character === C_BACKSLASH$3) {
          queue += C_BACKSLASH$3;
          character = value.charAt(++index);
        }

        index++;
        queue += character;
      }

      character = value.charAt(index);

      if (character !== marker) {
        return;
      }

      title = queue;
      subvalue += queue + character;
      index++;

      while (index < length) {
        character = value.charAt(index);

        if (!isWhitespaceCharacter(character)) {
          break;
        }

        subvalue += character;
        index++;
      }
    } else {
      subqueue = '';

      while (index < length) {
        character = value.charAt(index);

        if (character === marker) {
          if (hasMarker) {
            queue += marker + subqueue;
            subqueue = '';
          }

          hasMarker = true;
        } else if (!hasMarker) {
          queue += character;
        } else if (character === C_PAREN_CLOSE$3) {
          subvalue += queue + marker + subqueue;
          title = queue;
          break;
        } else if (isWhitespaceCharacter(character)) {
          subqueue += character;
        } else {
          queue += marker + subqueue + character;
          subqueue = '';
          hasMarker = false;
        }

        index++;
      }
    }
  }

  if (value.charAt(index) !== C_PAREN_CLOSE$3) {
    return;
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }

  subvalue += C_PAREN_CLOSE$3;
  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {
    nonTerminated: false
  });

  if (title) {
    beforeTitle = eat(beforeTitle).test().end;
    title = self.decode.raw(self.unescape(title), beforeTitle);
  }

  node = {
    type: isImage ? 'image' : 'link',
    title: title || null,
    url: url
  };

  if (isImage) {
    node.alt = self.decode.raw(self.unescape(content), now) || null;
  } else {
    exit = self.enterLink();
    node.children = self.tokenizeInline(content, now);
    exit();
  }

  return eat(subvalue)(node);
}

var reference_1 = reference;
reference.locator = link;
var T_LINK = 'link';
var T_IMAGE = 'image';
var T_FOOTNOTE = 'footnote';
var REFERENCE_TYPE_SHORTCUT = 'shortcut';
var REFERENCE_TYPE_COLLAPSED = 'collapsed';
var REFERENCE_TYPE_FULL = 'full';
var C_CARET$1 = '^';
var C_BACKSLASH$4 = '\\';
var C_BRACKET_OPEN$4 = '[';
var C_BRACKET_CLOSE$4 = ']';

function reference(eat, value, silent) {
  var self = this;
  var character = value.charAt(0);
  var index = 0;
  var length = value.length;
  var subvalue = '';
  var intro = '';
  var type = T_LINK;
  var referenceType = REFERENCE_TYPE_SHORTCUT;
  var content;
  var identifier;
  var now;
  var node;
  var exit;
  var queue;
  var bracketed;
  var depth;
  /* Check whether we’re eating an image. */

  if (character === '!') {
    type = T_IMAGE;
    intro = character;
    character = value.charAt(++index);
  }

  if (character !== C_BRACKET_OPEN$4) {
    return;
  }

  index++;
  intro += character;
  queue = '';
  /* Check whether we’re eating a footnote. */

  if (self.options.footnotes && value.charAt(index) === C_CARET$1) {
    /* Exit if `![^` is found, so the `!` will be seen as text after this,
     * and we’ll enter this function again when `[^` is found. */
    if (type === T_IMAGE) {
      return;
    }

    intro += C_CARET$1;
    index++;
    type = T_FOOTNOTE;
  }
  /* Eat the text. */


  depth = 0;

  while (index < length) {
    character = value.charAt(index);

    if (character === C_BRACKET_OPEN$4) {
      bracketed = true;
      depth++;
    } else if (character === C_BRACKET_CLOSE$4) {
      if (!depth) {
        break;
      }

      depth--;
    }

    if (character === C_BACKSLASH$4) {
      queue += C_BACKSLASH$4;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }

  subvalue = queue;
  content = queue;
  character = value.charAt(index);

  if (character !== C_BRACKET_CLOSE$4) {
    return;
  }

  index++;
  subvalue += character;
  queue = '';

  while (index < length) {
    character = value.charAt(index);

    if (!isWhitespaceCharacter(character)) {
      break;
    }

    queue += character;
    index++;
  }

  character = value.charAt(index);
  /* Inline footnotes cannot have an identifier. */

  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN$4) {
    identifier = '';
    queue += character;
    index++;

    while (index < length) {
      character = value.charAt(index);

      if (character === C_BRACKET_OPEN$4 || character === C_BRACKET_CLOSE$4) {
        break;
      }

      if (character === C_BACKSLASH$4) {
        identifier += C_BACKSLASH$4;
        character = value.charAt(++index);
      }

      identifier += character;
      index++;
    }

    character = value.charAt(index);

    if (character === C_BRACKET_CLOSE$4) {
      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
      queue += identifier + character;
      index++;
    } else {
      identifier = '';
    }

    subvalue += queue;
    queue = '';
  } else {
    if (!content) {
      return;
    }

    identifier = content;
  }
  /* Brackets cannot be inside the identifier. */


  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
    return;
  }

  subvalue = intro + subvalue;

  if (type === T_LINK && self.inLink) {
    return null;
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }

  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
    return eat(subvalue)({
      type: 'footnote',
      children: this.tokenizeInline(content, eat.now())
    });
  }

  now = eat.now();
  now.column += intro.length;
  now.offset += intro.length;
  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
  node = {
    type: type + 'Reference',
    identifier: normalize_1(identifier)
  };

  if (type === T_LINK || type === T_IMAGE) {
    node.referenceType = referenceType;
  }

  if (type === T_LINK) {
    exit = self.enterLink();
    node.children = self.tokenizeInline(content, now);
    exit();
  } else if (type === T_IMAGE) {
    node.alt = self.decode.raw(self.unescape(content), now) || null;
  }

  return eat(subvalue)(node);
}

var strong = locate$4;

function locate$4(value, fromIndex) {
  var asterisk = value.indexOf('**', fromIndex);
  var underscore = value.indexOf('__', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}

var strong_1 = strong$1;
strong$1.locator = strong;
var C_ASTERISK$2 = '*';
var C_UNDERSCORE$2 = '_';

function strong$1(eat, value, silent) {
  var self = this;
  var index = 0;
  var character = value.charAt(index);
  var now;
  var pedantic;
  var marker;
  var queue;
  var subvalue;
  var length;
  var prev;

  if (character !== C_ASTERISK$2 && character !== C_UNDERSCORE$2 || value.charAt(++index) !== character) {
    return;
  }

  pedantic = self.options.pedantic;
  marker = character;
  subvalue = marker + marker;
  length = value.length;
  index++;
  queue = '';
  character = '';

  if (pedantic && isWhitespaceCharacter(value.charAt(index))) {
    return;
  }

  while (index < length) {
    prev = character;
    character = value.charAt(index);

    if (character === marker && value.charAt(index + 1) === marker && (!pedantic || !isWhitespaceCharacter(prev))) {
      character = value.charAt(index + 2);

      if (character !== marker) {
        if (!trim_1(queue)) {
          return;
        }
        /* istanbul ignore if - never used (yet) */


        if (silent) {
          return true;
        }

        now = eat.now();
        now.column += 2;
        now.offset += 2;
        return eat(subvalue + queue + subvalue)({
          type: 'strong',
          children: self.tokenizeInline(queue, now)
        });
      }
    }

    if (!pedantic && character === '\\') {
      queue += character;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }
}

var isWordCharacter = wordCharacter;
var fromCode$1 = String.fromCharCode;
var re$2 = /\w/;
/* Check if the given character code, or the character
 * code at the first character, is a word character. */

function wordCharacter(character) {
  return re$2.test(typeof character === 'number' ? fromCode$1(character) : character.charAt(0));
}

var emphasis = locate$5;

function locate$5(value, fromIndex) {
  var asterisk = value.indexOf('*', fromIndex);
  var underscore = value.indexOf('_', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}

var emphasis_1 = emphasis$1;
emphasis$1.locator = emphasis;
var C_ASTERISK$3 = '*';
var C_UNDERSCORE$3 = '_';

function emphasis$1(eat, value, silent) {
  var self = this;
  var index = 0;
  var character = value.charAt(index);
  var now;
  var pedantic;
  var marker;
  var queue;
  var subvalue;
  var length;
  var prev;

  if (character !== C_ASTERISK$3 && character !== C_UNDERSCORE$3) {
    return;
  }

  pedantic = self.options.pedantic;
  subvalue = character;
  marker = character;
  length = value.length;
  index++;
  queue = '';
  character = '';

  if (pedantic && isWhitespaceCharacter(value.charAt(index))) {
    return;
  }

  while (index < length) {
    prev = character;
    character = value.charAt(index);

    if (character === marker && (!pedantic || !isWhitespaceCharacter(prev))) {
      character = value.charAt(++index);

      if (character !== marker) {
        if (!trim_1(queue) || prev === marker) {
          return;
        }

        if (!pedantic && marker === C_UNDERSCORE$3 && isWordCharacter(character)) {
          queue += marker;
          continue;
        }
        /* istanbul ignore if - never used (yet) */


        if (silent) {
          return true;
        }

        now = eat.now();
        now.column++;
        now.offset++;
        return eat(subvalue + queue + marker)({
          type: 'emphasis',
          children: self.tokenizeInline(queue, now)
        });
      }

      queue += marker;
    }

    if (!pedantic && character === '\\') {
      queue += character;
      character = value.charAt(++index);
    }

    queue += character;
    index++;
  }
}

var _delete = locate$6;

function locate$6(value, fromIndex) {
  return value.indexOf('~~', fromIndex);
}

var _delete$1 = strikethrough;
strikethrough.locator = _delete;
var C_TILDE$1 = '~';
var DOUBLE = '~~';

function strikethrough(eat, value, silent) {
  var self = this;
  var character = '';
  var previous = '';
  var preceding = '';
  var subvalue = '';
  var index;
  var length;
  var now;

  if (!self.options.gfm || value.charAt(0) !== C_TILDE$1 || value.charAt(1) !== C_TILDE$1 || isWhitespaceCharacter(value.charAt(2))) {
    return;
  }

  index = 1;
  length = value.length;
  now = eat.now();
  now.column += 2;
  now.offset += 2;

  while (++index < length) {
    character = value.charAt(index);

    if (character === C_TILDE$1 && previous === C_TILDE$1 && (!preceding || !isWhitespaceCharacter(preceding))) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true;
      }

      return eat(DOUBLE + subvalue + DOUBLE)({
        type: 'delete',
        children: self.tokenizeInline(subvalue, now)
      });
    }

    subvalue += previous;
    preceding = previous;
    previous = character;
  }
}

var codeInline = locate$7;

function locate$7(value, fromIndex) {
  return value.indexOf('`', fromIndex);
}

var codeInline$1 = inlineCode;
inlineCode.locator = codeInline;
var C_TICK$3 = '`';
/* Tokenise inline code. */

function inlineCode(eat, value, silent) {
  var length = value.length;
  var index = 0;
  var queue = '';
  var tickQueue = '';
  var contentQueue;
  var subqueue;
  var count;
  var openingCount;
  var subvalue;
  var character;
  var found;
  var next;

  while (index < length) {
    if (value.charAt(index) !== C_TICK$3) {
      break;
    }

    queue += C_TICK$3;
    index++;
  }

  if (!queue) {
    return;
  }

  subvalue = queue;
  openingCount = index;
  queue = '';
  next = value.charAt(index);
  count = 0;

  while (index < length) {
    character = next;
    next = value.charAt(index + 1);

    if (character === C_TICK$3) {
      count++;
      tickQueue += character;
    } else {
      count = 0;
      queue += character;
    }

    if (count && next !== C_TICK$3) {
      if (count === openingCount) {
        subvalue += queue + tickQueue;
        found = true;
        break;
      }

      queue += tickQueue;
      tickQueue = '';
    }

    index++;
  }

  if (!found) {
    if (openingCount % 2 !== 0) {
      return;
    }

    queue = '';
  }
  /* istanbul ignore if - never used (yet) */


  if (silent) {
    return true;
  }

  contentQueue = '';
  subqueue = '';
  length = queue.length;
  index = -1;

  while (++index < length) {
    character = queue.charAt(index);

    if (isWhitespaceCharacter(character)) {
      subqueue += character;
      continue;
    }

    if (subqueue) {
      if (contentQueue) {
        contentQueue += subqueue;
      }

      subqueue = '';
    }

    contentQueue += character;
  }

  return eat(subvalue)({
    type: 'inlineCode',
    value: contentQueue
  });
}

var _break = locate$8;

function locate$8(value, fromIndex) {
  var index = value.indexOf('\n', fromIndex);

  while (index > fromIndex) {
    if (value.charAt(index - 1) !== ' ') {
      break;
    }

    index--;
  }

  return index;
}

var _break$1 = hardBreak;
hardBreak.locator = _break;
var MIN_BREAK_LENGTH = 2;

function hardBreak(eat, value, silent) {
  var length = value.length;
  var index = -1;
  var queue = '';
  var character;

  while (++index < length) {
    character = value.charAt(index);

    if (character === '\n') {
      if (index < MIN_BREAK_LENGTH) {
        return;
      }
      /* istanbul ignore if - never used (yet) */


      if (silent) {
        return true;
      }

      queue += character;
      return eat(queue)({
        type: 'break'
      });
    }

    if (character !== ' ') {
      return;
    }

    queue += character;
  }
}

var text_1 = text;

function text(eat, value, silent) {
  var self = this;
  var methods;
  var tokenizers;
  var index;
  var length;
  var subvalue;
  var position;
  var tokenizer;
  var name;
  var min;
  var now;
  /* istanbul ignore if - never used (yet) */

  if (silent) {
    return true;
  }

  methods = self.inlineMethods;
  length = methods.length;
  tokenizers = self.inlineTokenizers;
  index = -1;
  min = value.length;

  while (++index < length) {
    name = methods[index];

    if (name === 'text' || !tokenizers[name]) {
      continue;
    }

    tokenizer = tokenizers[name].locator;

    if (!tokenizer) {
      eat.file.fail('Missing locator: `' + name + '`');
    }

    position = tokenizer.call(self, value, 1);

    if (position !== -1 && position < min) {
      min = position;
    }
  }

  subvalue = value.slice(0, min);
  now = eat.now();
  self.decode(subvalue, now, function (content, position, source) {
    eat(source || content)({
      type: 'text',
      value: content
    });
  });
}

var parser$1 = Parser;

function Parser(doc, file) {
  this.file = file;
  this.offset = {};
  this.options = immutable$1(this.options);
  this.setOptions({});
  this.inList = false;
  this.inBlock = false;
  this.inLink = false;
  this.atStart = true;
  this.toOffset = vfileLocation(file).toOffset;
  this.unescape = _unescape(this, 'escape');
  this.decode = decode(this);
}

var proto$8 = Parser.prototype;
/* Expose core. */

proto$8.setOptions = setOptions_1;
proto$8.parse = parse_1$1;
/* Expose `defaults`. */

proto$8.options = defaults$3;
/* Enter and exit helpers. */

proto$8.exitStart = stateToggle('atStart', true);
proto$8.enterList = stateToggle('inList', false);
proto$8.enterLink = stateToggle('inLink', false);
proto$8.enterBlock = stateToggle('inBlock', false);
/* Nodes that can interupt a paragraph:
 *
 * ```markdown
 * A paragraph, followed by a thematic break.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the paragraph. */

proto$8.interruptParagraph = [['thematicBreak'], ['atxHeading'], ['fencedCode'], ['blockquote'], ['html'], ['setextHeading', {
  commonmark: false
}], ['definition', {
  commonmark: false
}], ['footnote', {
  commonmark: false
}]];
/* Nodes that can interupt a list:
 *
 * ```markdown
 * - One
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the list. */

proto$8.interruptList = [['atxHeading', {
  pedantic: false
}], ['fencedCode', {
  pedantic: false
}], ['thematicBreak', {
  pedantic: false
}], ['definition', {
  commonmark: false
}], ['footnote', {
  commonmark: false
}]];
/* Nodes that can interupt a blockquote:
 *
 * ```markdown
 * > A paragraph.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the blockquote. */

proto$8.interruptBlockquote = [['indentedCode', {
  commonmark: true
}], ['fencedCode', {
  commonmark: true
}], ['atxHeading', {
  commonmark: true
}], ['setextHeading', {
  commonmark: true
}], ['thematicBreak', {
  commonmark: true
}], ['html', {
  commonmark: true
}], ['list', {
  commonmark: true
}], ['definition', {
  commonmark: false
}], ['footnote', {
  commonmark: false
}]];
/* Handlers. */

proto$8.blockTokenizers = {
  newline: newline_1,
  indentedCode: codeIndented,
  fencedCode: codeFenced,
  blockquote: blockquote_1,
  atxHeading: headingAtx,
  thematicBreak: thematicBreak_1,
  list: list_1,
  setextHeading: headingSetext,
  html: htmlBlock,
  footnote: footnoteDefinition_1,
  definition: definition_1,
  table: table_1,
  paragraph: paragraph_1
};
proto$8.inlineTokenizers = {
  escape: _escape$1,
  autoLink: autoLink_1,
  url: url_1,
  html: htmlInline,
  link: link_1,
  reference: reference_1,
  strong: strong_1,
  emphasis: emphasis_1,
  deletion: _delete$1,
  code: codeInline$1,
  break: _break$1,
  text: text_1
};
/* Expose precedence. */

proto$8.blockMethods = keys$7(proto$8.blockTokenizers);
proto$8.inlineMethods = keys$7(proto$8.inlineTokenizers);
/* Tokenizers. */

proto$8.tokenizeBlock = tokenizer('block');
proto$8.tokenizeInline = tokenizer('inline');
proto$8.tokenizeFactory = tokenizer;
/* Get all keys in `value`. */

function keys$7(value) {
  var result = [];
  var key;

  for (key in value) {
    result.push(key);
  }

  return result;
}

var remarkParse = parse$3;
parse$3.Parser = parser$1;

function parse$3(options) {
  var Local = unherit_1(parser$1);
  Local.prototype.options = immutable$1(Local.prototype.options, this.data('settings'), options);
  this.Parser = Local;
}
/* Expose. */


var unistUtilVisitParents$1 = visitParents$1;
/* Visit. */

function visitParents$1(tree, type, visitor) {
  var stack = [];

  if (typeof type === 'function') {
    visitor = type;
    type = null;
  }

  one(tree);
  /* Visit a single node. */

  function one(node) {
    var result;

    if (!type || node.type === type) {
      result = visitor(node, stack.concat());
    }

    if (node.children && result !== false) {
      return all(node.children, node);
    }

    return result;
  }
  /* Visit children in `parent`. */


  function all(children, parent) {
    var length = children.length;
    var index = -1;
    var child;
    stack.push(parent);

    while (++index < length) {
      child = children[index];

      if (child && one(child) === false) {
        return false;
      }
    }

    stack.pop();
    return true;
  }
}

function addListMetadata() {
  return function (ast) {
    unistUtilVisitParents$1(ast, 'list', function (listNode, parents) {
      var depth = 0,
          i,
          n;

      for (i = 0, n = parents.length; i < n; i++) {
        if (parents[i].type === 'list') depth += 1;
      }

      for (i = 0, n = listNode.children.length; i < n; i++) {
        var child = listNode.children[i];
        child.index = i;
        child.ordered = listNode.ordered;
      }

      listNode.depth = depth;
    });
    return ast;
  };
}

var mdastAddListMetadata = addListMetadata;
/**
 * Naive, simple plugin to match inline nodes without attributes
 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
 * For proper HTML support, you'll want a different plugin
 **/

var type = 'virtualHtml';
var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;

var naiveHtml = function naiveHtml(tree) {
  var open;
  var currentParent;
  unistUtilVisit(tree, 'html', function (node, index, parent) {
    if (currentParent !== parent) {
      open = [];
      currentParent = parent;
    }

    var selfClosing = getSelfClosing(node);

    if (selfClosing) {
      parent.children.splice(index, 1, {
        type: type,
        tag: selfClosing,
        position: node.position
      });
      return true;
    }

    var current = getSimpleTag(node, parent);

    if (!current) {
      return true;
    }

    var matching = findAndPull(open, current.tag);

    if (matching) {
      parent.children.splice(index, 0, virtual(current, matching, parent));
    } else if (!current.opening) {
      open.push(current);
    }

    return true;
  }, true // Iterate in reverse
  );
  return tree;
};

function findAndPull(open, matchingTag) {
  var i = open.length;

  while (i--) {
    if (open[i].tag === matchingTag) {
      return open.splice(i, 1)[0];
    }
  }

  return false;
}

function getSimpleTag(node, parent) {
  var match = node.value.match(simpleTagRe);
  return match ? {
    tag: match[2],
    opening: !match[1],
    node: node
  } : false;
}

function getSelfClosing(node) {
  var match = node.value.match(selfClosingRe);
  return match ? match[1] : false;
}

function virtual(fromNode, toNode, parent) {
  var fromIndex = parent.children.indexOf(fromNode.node);
  var toIndex = parent.children.indexOf(toNode.node);
  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
  var children = extracted.slice(1, -1);
  return {
    type: type,
    children: children,
    tag: fromNode.tag,
    position: {
      start: fromNode.node.position.start,
      end: toNode.node.position.end,
      indent: []
    }
  };
}

var ofType = function ofType(types, mode) {
  return function (node) {
    types.forEach(function (type) {
      return unistUtilVisit(node, type, disallow, true);
    });
    return node;
  };

  function disallow(node, index, parent) {
    if (parent) {
      untangle(node, index, parent, mode);
    }
  }
};

var ifNotMatch = function ifNotMatch(allowNode, mode) {
  return function (node) {
    unistUtilVisit(node, disallow, true);
    return node;
  };

  function disallow(node, index, parent) {
    if (parent && !allowNode(node, index, parent)) {
      untangle(node, index, parent, mode);
    }
  }
};

function untangle(node, index, parent, mode) {
  if (mode === 'remove') {
    parent.children.splice(index, 1);
  } else if (mode === 'unwrap') {
    var args = [index, 1];

    if (node.children) {
      args = args.concat(node.children);
    }

    Array.prototype.splice.apply(parent.children, args);
  }
}

var disallowNode = {
  ofType: ofType,
  ifNotMatch: ifNotMatch
};

function astToReact(node, options) {
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var renderer = options.renderers[node.type];
  var pos = node.position.start;
  var key = [node.type, pos.line, pos.column].join('-');

  if (typeof renderer !== 'function' && typeof renderer !== 'string' && !isReactFragment(renderer)) {
    throw new Error("Renderer for type `".concat(node.type, "` not defined or is not renderable"));
  }

  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);

  function resolveChildren() {
    return node.children && node.children.map(function (childNode, i) {
      return astToReact(childNode, options, {
        node: node,
        props: nodeProps
      }, i);
    });
  }
}

function isReactFragment(renderer) {
  return React.Fragment && React.Fragment === renderer;
} // eslint-disable-next-line max-params, complexity


function getNodeProps(node, key, opts, renderer, parent, index) {
  var props = {
    key: key
  };
  var isTagRenderer = typeof renderer === 'string'; // `sourcePos` is true if the user wants source information (line/column info from markdown source)

  if (opts.sourcePos && node.position) {
    props['data-sourcepos'] = flattenPosition(node.position);
  }

  if (opts.rawSourcePos && !isTagRenderer) {
    props.sourcePosition = node.position;
  } // If `includeNodeIndex` is true, pass node index info to all non-tag renderers


  if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
    props.index = parent.node.children.indexOf(node);
    props.parentChildCount = parent.node.children.length;
  }

  var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;

  switch (node.type) {
    case 'root':
      assignDefined(props, {
        className: opts.className
      });
      break;

    case 'text':
      props.nodeKey = key;
      props.children = node.value;
      break;

    case 'heading':
      props.level = node.depth;
      break;

    case 'list':
      props.start = node.start;
      props.ordered = node.ordered;
      props.tight = !node.loose;
      props.depth = node.depth;
      break;

    case 'listItem':
      props.checked = node.checked;
      props.tight = !node.loose;
      props.ordered = node.ordered;
      props.index = node.index;
      props.children = getListItemChildren(node, parent).map(function (childNode, i) {
        return astToReact(childNode, opts, {
          node: node,
          props: props
        }, i);
      });
      break;

    case 'definition':
      assignDefined(props, {
        identifier: node.identifier,
        title: node.title,
        url: node.url
      });
      break;

    case 'code':
      assignDefined(props, {
        language: node.lang && node.lang.split(/\s/, 1)[0]
      });
      break;

    case 'inlineCode':
      props.children = node.value;
      props.inline = true;
      break;

    case 'link':
      assignDefined(props, {
        title: node.title || undefined,
        target: typeof opts.linkTarget === 'function' ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
      });
      break;

    case 'image':
      assignDefined(props, {
        alt: node.alt || undefined,
        title: node.title || undefined,
        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
      });
      break;

    case 'linkReference':
      assignDefined(props, immutable$1(ref, {
        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
      }));
      break;

    case 'imageReference':
      assignDefined(props, {
        src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
        title: ref.title || undefined,
        alt: node.alt || undefined
      });
      break;

    case 'table':
    case 'tableHead':
    case 'tableBody':
      props.columnAlignment = node.align;
      break;

    case 'tableRow':
      props.isHeader = parent.node.type === 'tableHead';
      props.columnAlignment = parent.props.columnAlignment;
      break;

    case 'tableCell':
      assignDefined(props, {
        isHeader: parent.props.isHeader,
        align: parent.props.columnAlignment[index]
      });
      break;

    case 'virtualHtml':
      props.tag = node.tag;
      break;

    case 'html':
      // @todo find a better way than this
      props.isBlock = node.position.start.line !== node.position.end.line;
      props.escapeHtml = opts.escapeHtml;
      props.skipHtml = opts.skipHtml;
      break;

    case 'parsedHtml':
      props.escapeHtml = opts.escapeHtml;
      props.skipHtml = opts.skipHtml;
      props.element = mergeNodeChildren(node, (node.children || []).map(function (child, i) {
        return astToReact(child, opts, {
          node: node,
          props: props
        }, i);
      }));
      break;

    default:
      assignDefined(props, immutable$1(node, {
        type: undefined,
        position: undefined,
        children: undefined
      }));
  }

  if (!isTagRenderer && node.value) {
    props.value = node.value;
  }

  return props;
}

function assignDefined(target, attrs) {
  for (var key in attrs) {
    if (typeof attrs[key] !== 'undefined') {
      target[key] = attrs[key];
    }
  }
}

function mergeNodeChildren(node, parsedChildren) {
  var el = node.element;

  if (Array.isArray(el)) {
    var Fragment = React.Fragment || 'div';
    return React.createElement(Fragment, null, el);
  }

  var children = (el.props.children || []).concat(parsedChildren);
  return React.cloneElement(el, null, children);
}

function flattenPosition(pos) {
  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
}

function getListItemChildren(node, parent) {
  if (node.loose) {
    return node.children;
  }

  if (parent.node && node.index > 0 && parent.node.children[node.index - 1].loose) {
    return node.children;
  }

  return unwrapParagraphs(node);
}

function unwrapParagraphs(node) {
  return node.children.reduce(function (array, child) {
    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
  }, []);
}

var astToReact_1 = astToReact;

var wrapTableRows = function wrapTableRows(node) {
  unistUtilVisit(node, 'table', wrap$4);
  return node;
};

function wrap$4(table) {
  var children = table.children;
  table.children = [{
    type: 'tableHead',
    align: table.align,
    children: [children[0]],
    position: children[0].position
  }];

  if (children.length > 1) {
    table.children.push({
      type: 'tableBody',
      align: table.align,
      children: children.slice(1),
      position: {
        start: children[1].position.start,
        end: children[children.length - 1].position.end
      }
    });
  }
}

var getDefinitions = function getDefinitions(node) {
  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (node.children || []).reduce(function (definitions, child) {
    if (child.type === 'definition') {
      definitions[child.identifier] = {
        href: child.url,
        title: child.title
      };
    }

    return getDefinitions(child, definitions);
  }, defs);
};

var protocols = ['http', 'https', 'mailto', 'tel'];

var uriTransformer = function uriTransformer(uri) {
  var url = (uri || '').trim();
  var first = url.charAt(0);

  if (first === '#' || first === '/') {
    return url;
  }

  var colon = url.indexOf(':');

  if (colon === -1) {
    return url;
  }

  var length = protocols.length;
  var index = -1;

  while (++index < length) {
    var protocol = protocols[index];

    if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) {
      return url;
    }
  }

  index = url.indexOf('?');

  if (index !== -1 && colon > index) {
    return url;
  }

  index = url.indexOf('#');

  if (index !== -1 && colon > index) {
    return url;
  } // eslint-disable-next-line no-script-url


  return 'javascript:void(0)';
};

var supportsStringRender = parseInt((React.version || '16').slice(0, 2), 10) >= 16;
var createElement$1 = React.createElement;
var renderers = {
  break: 'br',
  paragraph: 'p',
  emphasis: 'em',
  strong: 'strong',
  thematicBreak: 'hr',
  blockquote: 'blockquote',
  delete: 'del',
  link: 'a',
  image: 'img',
  linkReference: 'a',
  imageReference: 'img',
  table: SimpleRenderer.bind(null, 'table'),
  tableHead: SimpleRenderer.bind(null, 'thead'),
  tableBody: SimpleRenderer.bind(null, 'tbody'),
  tableRow: SimpleRenderer.bind(null, 'tr'),
  tableCell: TableCell,
  root: Root,
  text: TextRenderer,
  list: List$f,
  listItem: ListItem,
  definition: NullRenderer,
  heading: Heading,
  inlineCode: InlineCode,
  code: CodeBlock,
  html: Html,
  virtualHtml: VirtualHtml,
  parsedHtml: ParsedHtml
};

function TextRenderer(props) {
  return supportsStringRender ? props.children : createElement$1('span', null, props.children);
}

function Root(props) {
  var useFragment = !props.className;
  var root = useFragment ? React.Fragment || 'div' : 'div';
  return createElement$1(root, useFragment ? null : props, props.children);
}

function SimpleRenderer(tag, props) {
  return createElement$1(tag, getCoreProps(props), props.children);
}

function TableCell(props) {
  var style = props.align ? {
    textAlign: props.align
  } : undefined;
  var coreProps = getCoreProps(props);
  return createElement$1(props.isHeader ? 'th' : 'td', style ? immutable$1({
    style: style
  }, coreProps) : coreProps, props.children);
}

function Heading(props) {
  return createElement$1("h".concat(props.level), getCoreProps(props), props.children);
}

function List$f(props) {
  var attrs = getCoreProps(props);

  if (props.start !== null && props.start !== 1) {
    attrs.start = props.start.toString();
  }

  return createElement$1(props.ordered ? 'ol' : 'ul', attrs, props.children);
}

function ListItem(props) {
  var checkbox = null;

  if (props.checked !== null) {
    var checked = props.checked;
    checkbox = createElement$1('input', {
      type: 'checkbox',
      checked: checked,
      readOnly: true
    });
  }

  return createElement$1('li', getCoreProps(props), checkbox, props.children);
}

function CodeBlock(props) {
  var className = props.language && "language-".concat(props.language);
  var code = createElement$1('code', className ? {
    className: className
  } : null, props.value);
  return createElement$1('pre', getCoreProps(props), code);
}

function InlineCode(props) {
  return createElement$1('code', getCoreProps(props), props.children);
}

function Html(props) {
  if (props.skipHtml) {
    return null;
  }

  var tag = props.isBlock ? 'div' : 'span';

  if (props.escapeHtml) {
    var comp = React.Fragment || tag;
    return createElement$1(comp, null, props.value);
  }

  var nodeProps = {
    dangerouslySetInnerHTML: {
      __html: props.value
    }
  };
  return createElement$1(tag, nodeProps);
}

function ParsedHtml(props) {
  return props['data-sourcepos'] ? React.cloneElement(props.element, {
    'data-sourcepos': props['data-sourcepos']
  }) : props.element;
}

function VirtualHtml(props) {
  return createElement$1(props.tag, getCoreProps(props), props.children);
}

function NullRenderer() {
  return null;
}

function getCoreProps(props) {
  return props['data-sourcepos'] ? {
    'data-sourcepos': props['data-sourcepos']
  } : {};
}

var HtmlParser = '__RMD_HTML_PARSER__';
var HtmlParser_1 = typeof Symbol === 'undefined' ? HtmlParser : Symbol(HtmlParser);
var symbols = {
  HtmlParser: HtmlParser_1
};

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var allTypes = Object.keys(renderers);

var ReactMarkdown = function ReactMarkdown(props) {
  var src = props.source || props.children || '';

  if (props.allowedTypes && props.disallowedTypes) {
    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
  }

  var renderers$$1 = immutable$1(renderers, props.renderers);
  var plugins = [remarkParse].concat(props.plugins || []);
  var parser = plugins.reduce(applyParserPlugin, unified_1());
  var rawAst = parser.parse(src);
  var renderProps = immutable$1(props, {
    renderers: renderers$$1,
    definitions: getDefinitions(rawAst)
  });
  var astPlugins = determineAstPlugins(props);
  var ast = astPlugins.reduce(function (node, plugin) {
    return plugin(node, renderProps);
  }, rawAst);
  return astToReact_1(ast, renderProps);
};

function applyParserPlugin(parser, plugin) {
  return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
}

function determineAstPlugins(props) {
  var plugins = [wrapTableRows, mdastAddListMetadata()];
  var disallowedTypes = props.disallowedTypes;

  if (props.allowedTypes) {
    disallowedTypes = allTypes.filter(function (type) {
      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
    });
  }

  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';

  if (disallowedTypes && disallowedTypes.length > 0) {
    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
  }

  if (props.allowNode) {
    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
  }

  var renderHtml = !props.escapeHtml && !props.skipHtml;
  var hasHtmlParser = (props.astPlugins || []).some(function (item) {
    var plugin = Array.isArray(item) ? item[0] : item;
    return plugin.identity === symbols.HtmlParser;
  });

  if (renderHtml && !hasHtmlParser) {
    plugins.push(naiveHtml);
  }

  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
}

ReactMarkdown.defaultProps = {
  renderers: {},
  escapeHtml: true,
  skipHtml: false,
  sourcePos: false,
  rawSourcePos: false,
  transformLinkUri: uriTransformer,
  astPlugins: [],
  plugins: []
};
ReactMarkdown.propTypes = {
  className: PropTypes.string,
  source: PropTypes.string,
  children: PropTypes.string,
  sourcePos: PropTypes.bool,
  rawSourcePos: PropTypes.bool,
  escapeHtml: PropTypes.bool,
  skipHtml: PropTypes.bool,
  allowNode: PropTypes.func,
  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transformImageUri: PropTypes.func,
  astPlugins: PropTypes.arrayOf(PropTypes.func),
  unwrapDisallowed: PropTypes.bool,
  renderers: PropTypes.object,
  plugins: PropTypes.array
};
ReactMarkdown.types = allTypes;
ReactMarkdown.renderers = renderers;
ReactMarkdown.uriTransformer = uriTransformer;
var reactMarkdown = ReactMarkdown;

var _templateObject$17 = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\t> h1 {\n\t\tfont-weight: 600;\n\t\tdisplay: inline;\n\t\tmargin: 0 1em 0 0;\n\t}\n\t> svg {\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tmargin-right: 1em;\n\t\tflex-shrink: 0;\n\t\tfill: ", ";\n\t}\n\t> span {\n\t\tflex-grow: 1;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\t> h1 {\n\t\tfont-weight: 600;\n\t\tdisplay: inline;\n\t\tmargin: 0 1em 0 0;\n\t}\n\t> svg {\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tmargin-right: 1em;\n\t\tflex-shrink: 0;\n\t\tfill: ", ";\n\t}\n\t> span {\n\t\tflex-grow: 1;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"]);

var StyledWrapper$3 = styled.div(_templateObject$17, function (props) {
  return props.theme.neutralDark["4"];
});

var Info = function Info(_ref) {
  var sequence = _ref.sequence,
      type = _ref.type,
      content = _ref.content;
  var config = questionConfigs[type];
  var Icon = config ? config.icon : function () {
    return null;
  };
  return React.createElement(StyledWrapper$3, null, React.createElement("h1", null, "Q", sequence), React.createElement(Icon, null), React.createElement(reactMarkdown, {
    source: content
  }));
};

var _templateObject$18 = taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\toverflow-x: auto;\n\tmargin-left: 2.2em;\n\tmargin-bottom: 1.5em;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\toverflow-x: auto;\n\tmargin-left: 2.2em;\n\tmargin-bottom: 1.5em;\n"]),
    _templateObject2$t = taggedTemplateLiteral(["\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\talign-items: ", ";\n\t", ";\n"], ["\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\talign-items: ", ";\n\t", ";\n"]),
    _templateObject3$e = taggedTemplateLiteral(["\n\theight: 1.5em;\n\tmargin: 0.5em 0;\n\twhite-space: nowrap;\n"], ["\n\theight: 1.5em;\n\tmargin: 0.5em 0;\n\twhite-space: nowrap;\n"]);

var Wrapper$i = styled.div(_templateObject$18);
var Column = styled.div(_templateObject2$t, function (props) {
  return props.header ? "start" : "center";
}, function (props) {
  return props.header ? "" : "margin: 0 1em;";
});
var Cell = styled.div(_templateObject3$e);

var CheckboxCell = function (_React$Component) {
  inherits(CheckboxCell, _React$Component);

  function CheckboxCell(props) {
    classCallCheck(this, CheckboxCell);

    var _this = possibleConstructorReturn(this, (CheckboxCell.__proto__ || Object.getPrototypeOf(CheckboxCell)).call(this, props));

    _this.state = {
      checked: false
    };
    return _this;
  }

  createClass(CheckboxCell, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Cell, null, React.createElement(Checkbox, {
        checked: this.state.checked,
        onChange: function onChange() {
          return _this2.setState({
            checked: !_this2.state.checked
          });
        }
      }));
    }
  }]);
  return CheckboxCell;
}(React.Component);

var SingleSelectGridOutline = function (_React$Component2) {
  inherits(SingleSelectGridOutline, _React$Component2);

  function SingleSelectGridOutline(props) {
    classCallCheck(this, SingleSelectGridOutline);

    var _this3 = possibleConstructorReturn(this, (SingleSelectGridOutline.__proto__ || Object.getPrototypeOf(SingleSelectGridOutline)).call(this, props));

    _this3.renderCell = _this3.renderCell.bind(_this3);
    _this3.renderColumn = _this3.renderColumn.bind(_this3);
    _this3.onChange = _this3.onChange.bind(_this3);
    _this3.state = {};
    return _this3;
  }

  createClass(SingleSelectGridOutline, [{
    key: "onChange",
    // In a Single Select Grid, each row maps to a Radio Button name.
    // In the state, we track selected values with row names as keys and column ids as values.
    value: function onChange(e) {
      this.setState(defineProperty$3({}, e.target.name, e.target.value));
    }
  }, {
    key: "renderCell",
    value: function renderCell(row, col) {
      var name = "outline" + this.props.id + "_row" + row;
      var checked = this.state[name] === col.toString();
      return React.createElement(Cell, {
        key: row.toString()
      }, React.createElement(Radio, {
        checked: checked,
        onChange: this.onChange,
        value: col.toString(),
        name: name
      }));
    }
  }, {
    key: "renderColumn",
    value: function renderColumn(_ref) {
      var _this4 = this;

      var id = _ref.id,
          content = _ref.content;
      var rows = this.props.rows;
      return React.createElement(Column, {
        key: id.toString()
      }, React.createElement(Cell, null, content), rows.map(function (r) {
        return _this4.renderCell(r.id, id);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          rows = _props.rows,
          columns = _props.columns;
      return React.createElement(Wrapper$i, null, React.createElement(Column, {
        header: true
      }, React.createElement(Cell, null), rows.map(function (r) {
        return React.createElement(Cell, {
          key: r.id.toString()
        }, r.content);
      })), columns.map(this.renderColumn));
    }
  }]);
  return SingleSelectGridOutline;
}(React.Component);

var MultipleSelectGridOutline = function (_React$Component3) {
  inherits(MultipleSelectGridOutline, _React$Component3);

  function MultipleSelectGridOutline(props) {
    classCallCheck(this, MultipleSelectGridOutline);

    var _this5 = possibleConstructorReturn(this, (MultipleSelectGridOutline.__proto__ || Object.getPrototypeOf(MultipleSelectGridOutline)).call(this, props));

    _this5.renderCell = _this5.renderCell.bind(_this5);
    _this5.renderColumn = _this5.renderColumn.bind(_this5);
    return _this5;
  }

  createClass(MultipleSelectGridOutline, [{
    key: "renderCell",
    value: function renderCell(row) {
      return React.createElement(CheckboxCell, {
        key: row.toString()
      });
    }
  }, {
    key: "renderColumn",
    value: function renderColumn(_ref2) {
      var _this6 = this;

      var id = _ref2.id,
          content = _ref2.content;
      var rows = this.props.rows;
      return React.createElement(Column, {
        key: id.toString()
      }, React.createElement(Cell, null, content), rows.map(function (r) {
        return _this6.renderCell(r.id);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          rows = _props2.rows,
          columns = _props2.columns;
      return React.createElement(Wrapper$i, null, React.createElement(Column, {
        header: true
      }, React.createElement(Cell, null), rows.map(function (r) {
        return React.createElement(Cell, {
          key: r.id.toString()
        }, r.content);
      })), columns.map(this.renderColumn));
    }
  }]);
  return MultipleSelectGridOutline;
}(React.Component); // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$9 = function makeMapStateToProps() {
  var getGrid = makeGridContentSelector();
  return function (state, ownProps) {
    var _getGrid = getGrid(state, ownProps.id),
        rows = _getGrid.rows,
        columns = _getGrid.columns;

    return {
      rows: rows,
      columns: columns
    };
  };
};

var SingleSelectGridContainer = connect(makeMapStateToProps$9)(SingleSelectGridOutline);
var MultipleSelectGridContainer = connect(makeMapStateToProps$9)(MultipleSelectGridOutline);

var _templateObject$19 = taggedTemplateLiteral(["\n\tmargin-left: 2.3em;\n\tmargin-bottom: 1.5em;\n"], ["\n\tmargin-left: 2.3em;\n\tmargin-bottom: 1.5em;\n"]),
    _templateObject2$u = taggedTemplateLiteral(["\n\tmargin-bottom: 0.5em;\n"], ["\n\tmargin-bottom: 0.5em;\n"]);

var Wrapper$j = styled.div(_templateObject$19);
var RowWrapper = styled.div(_templateObject2$u);

var _templateObject$1a = taggedTemplateLiteral(["\n\tmax-width: 300px;\n"], ["\n\tmax-width: 300px;\n"]);

var StyledSelect$9 = styled(Select)(_templateObject$1a);

var Dropdown$1 = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.state = {
      value: undefined
    };
    return _this;
  }

  createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var options = this.props.rows.map(function (r) {
        return {
          value: r.id,
          label: r.content
        };
      });
      return React.createElement(Wrapper$j, null, React.createElement(StyledSelect$9, {
        searchable: false,
        clearable: false,
        options: options,
        onChange: function onChange(value) {
          return _this2.setState({
            value: value
          });
        },
        value: options.find(function (o) {
          return o.value === _this2.state.value;
        })
      }));
    }
  }]);
  return Dropdown;
}(React.Component);

var _templateObject$1b = taggedTemplateLiteral(["\n\tvertical-align: middle;\n"], ["\n\tvertical-align: middle;\n"]);

var AlignedSpan = styled.span(_templateObject$1b);

var AnswerRow$1 = function (_React$Component) {
  inherits(AnswerRow, _React$Component);

  function AnswerRow(props) {
    classCallCheck(this, AnswerRow);

    var _this = possibleConstructorReturn(this, (AnswerRow.__proto__ || Object.getPrototypeOf(AnswerRow)).call(this, props));

    _this.state = {
      checked: false
    };
    return _this;
  }

  createClass(AnswerRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var content = this.props.content;
      return React.createElement("div", null, React.createElement(Checkbox, {
        onChange: function onChange() {
          return _this2.setState({
            checked: !_this2.state.checked
          });
        },
        checked: this.state.checked
      }, React.createElement(AlignedSpan, null, content)));
    }
  }]);
  return AnswerRow;
}(React.Component);

var MultipleSelectOutline = function MultipleSelectOutline(_ref) {
  var rows = _ref.rows;
  return React.createElement(Wrapper$j, null, rows.map(function (r) {
    return React.createElement(AnswerRow$1, {
      key: r.id,
      content: r.content
    });
  }));
};

var _templateObject$1c = taggedTemplateLiteral(["\n\tvertical-align: middle;\n"], ["\n\tvertical-align: middle;\n"]),
    _templateObject2$v = taggedTemplateLiteral(["\n\tmargin-left: 2.1em;\n\tmargin-bottom: 1.5em;\n\t", " {\n\t\tfont-size: 1em;\n\t\tmargin-right: 0.5em;\n\t}\n"], ["\n\tmargin-left: 2.1em;\n\tmargin-bottom: 1.5em;\n\t", " {\n\t\tfont-size: 1em;\n\t\tmargin-right: 0.5em;\n\t}\n"]);

var AlignedSpan$1 = styled.span(_templateObject$1c);
var Wrapper$k = styled.div(_templateObject2$v, Radio);

var AnswerRow$2 = function AnswerRow(_ref) {
  var value = _ref.value,
      name = _ref.name,
      content = _ref.content,
      onChange = _ref.onChange,
      checked = _ref.checked;
  return React.createElement("div", null, React.createElement(Radio, {
    checked: checked,
    value: value,
    onChange: onChange,
    name: name
  }, React.createElement(AlignedSpan$1, null, content)));
};

var SingleSelectOutline = function (_React$Component) {
  inherits(SingleSelectOutline, _React$Component);

  function SingleSelectOutline(props) {
    classCallCheck(this, SingleSelectOutline);

    var _this = possibleConstructorReturn(this, (SingleSelectOutline.__proto__ || Object.getPrototypeOf(SingleSelectOutline)).call(this, props));

    _this.state = {};
    _this.selectValue = _this.selectValue.bind(_this);
    _this.renderAnswerRow = _this.renderAnswerRow.bind(_this);
    return _this;
  }

  createClass(SingleSelectOutline, [{
    key: "selectValue",
    value: function selectValue(e) {
      var id = parseInt(e.currentTarget.value, 10);
      this.setState({
        checked: id
      });
    }
  }, {
    key: "renderAnswerRow",
    value: function renderAnswerRow(r) {
      var name = "outline" + this.props.id;
      var rowIdString = r.id.toString();
      return React.createElement(AnswerRow$2, {
        key: rowIdString,
        value: rowIdString,
        name: name,
        content: r.content,
        checked: this.state.checked === r.id,
        onChange: this.selectValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Wrapper$k, null, this.props.rows.map(this.renderAnswerRow));
    }
  }]);
  return SingleSelectOutline;
}(React.Component);

var _templateObject$1d = taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 1em;\n"], ["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 1em;\n"]);

var StyledSelect$a = styled(Select)(_templateObject$1d);

var RankingRow = function (_React$Component) {
  inherits(RankingRow, _React$Component);

  function RankingRow(props) {
    classCallCheck(this, RankingRow);

    var _this = possibleConstructorReturn(this, (RankingRow.__proto__ || Object.getPrototypeOf(RankingRow)).call(this, props));

    _this.state = {
      ranking: 1
    };
    _this.getOptions = _this.getOptions.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  createClass(RankingRow, [{
    key: "getOptions",
    value: function getOptions() {
      var values = range_1(1, this.props.rowCount + 1);
      return values.map(function (v) {
        return {
          label: v,
          value: v
        };
      });
    }
  }, {
    key: "onChange",
    value: function onChange(_ref) {
      var value = _ref.value;
      this.setState({
        ranking: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var options = this.getOptions();
      return React.createElement(RowWrapper, null, React.createElement(StyledSelect$a, {
        searchable: false,
        clearable: false,
        options: options,
        value: options.find(function (o) {
          return o.value === _this2.state.ranking;
        }),
        onChange: this.onChange
      }), this.props.content);
    }
  }]);
  return RankingRow;
}(React.Component);

var Ranking$2 = function (_React$Component2) {
  inherits(Ranking, _React$Component2);

  function Ranking(props) {
    classCallCheck(this, Ranking);

    var _this3 = possibleConstructorReturn(this, (Ranking.__proto__ || Object.getPrototypeOf(Ranking)).call(this, props));

    _this3.renderRow = _this3.renderRow.bind(_this3);
    return _this3;
  }

  createClass(Ranking, [{
    key: "renderRow",
    value: function renderRow(r) {
      var rowCount = this.props.rows.length;
      return React.createElement(RankingRow, {
        key: r.id,
        content: r.content,
        rowCount: rowCount
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Wrapper$j, null, this.props.rows.map(this.renderRow));
    }
  }]);
  return Ranking;
}(React.Component);

var _templateObject$1e = taggedTemplateLiteral(["\n\tmax-width: 55px;\n\tmargin-right: 1em;\n"], ["\n\tmax-width: 55px;\n\tmargin-right: 1em;\n"]);

var StyledInput$3 = styled(TextInput)(_templateObject$1e);

var SumRow = function (_React$Component) {
  inherits(SumRow, _React$Component);

  function SumRow(props) {
    classCallCheck(this, SumRow);

    var _this = possibleConstructorReturn(this, (SumRow.__proto__ || Object.getPrototypeOf(SumRow)).call(this, props));

    _this.state = {
      value: 0
    };
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  createClass(SumRow, [{
    key: "onChange",
    value: function onChange(e) {
      var value = parseInt(e.currentTarget.value, 10);
      this.setState({
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var content = this.props.content;
      return React.createElement(RowWrapper, null, React.createElement(StyledInput$3, {
        type: "number",
        value: this.state.value,
        onChange: this.onChange
      }), React.createElement("span", null, content));
    }
  }]);
  return SumRow;
}(React.Component);

var SumOutline = function SumOutline(props) {
  var rows = props.rows;
  return React.createElement(Wrapper$j, null, rows.map(function (r) {
    return React.createElement(SumRow, {
      key: r.id.toString(),
      content: r.content
    });
  }));
};

var _templateObject$1f = taggedTemplateLiteral(["\n\tdisplay: block;\n\ttext-align: center;\n\twidth: 20px;\n"], ["\n\tdisplay: block;\n\ttext-align: center;\n\twidth: 20px;\n"]),
    _templateObject2$w = taggedTemplateLiteral(["\n\tdisplay: inline-block;\n"], ["\n\tdisplay: inline-block;\n"]),
    _templateObject3$f = taggedTemplateLiteral(["\n\tmargin-left: 2.1em;\n\tmargin-bottom: 1.5em;\n\t", " {\n\t\tfont-size: 1em;\n\t\tmargin-right: 0.5em;\n\t}\n"], ["\n\tmargin-left: 2.1em;\n\tmargin-bottom: 1.5em;\n\t", " {\n\t\tfont-size: 1em;\n\t\tmargin-right: 0.5em;\n\t}\n"]),
    _templateObject4$5 = taggedTemplateLiteral(["\n\tdisplay: block;\n\ttext-indent: 5px;\n\tpadding-bottom: 5px;\n"], ["\n\tdisplay: block;\n\ttext-indent: 5px;\n\tpadding-bottom: 5px;\n"]);

var AlignedSpan$2 = styled.span(_templateObject$1f);
var RatingDiv = styled.div(_templateObject2$w);
var Wrapper$l = styled.div(_templateObject3$f, Radio);
var AlignedContentSpan = styled.span(_templateObject4$5);

var RatingStep = function RatingStep(_ref) {
  var value = _ref.value,
      name = _ref.name,
      checked = _ref.checked,
      onChange = _ref.onChange;
  return React.createElement(RatingDiv, null, React.createElement(Radio, {
    checked: checked,
    value: value,
    onChange: onChange,
    name: name
  }, React.createElement(AlignedSpan$2, null, value)));
};

var RatingOutline = function (_React$Component) {
  inherits(RatingOutline, _React$Component);

  function RatingOutline(props) {
    classCallCheck(this, RatingOutline);

    var _this = possibleConstructorReturn(this, (RatingOutline.__proto__ || Object.getPrototypeOf(RatingOutline)).call(this, props));

    _this.state = {};
    _this.selectValue = _this.selectValue.bind(_this);
    _this.renderRatingStep = _this.renderRatingStep.bind(_this);
    return _this;
  }

  createClass(RatingOutline, [{
    key: "selectValue",
    value: function selectValue(e) {
      var id = parseInt(e.currentTarget.value, 10);
      this.setState({
        checked: id
      });
    }
  }, {
    key: "renderRatingStep",
    value: function renderRatingStep(step) {
      var name = "outline" + this.props.id;
      return React.createElement(RatingStep, {
        key: step,
        value: step,
        name: name,
        checked: this.state.checked === step,
        onChange: this.selectValue
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var content = this.props.content;

      if (content) {
        return React.createElement(AlignedContentSpan, null, content);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Wrapper$l, null, this.renderContent(), [].concat(toConsumableArray(Array(Number(this.props.steps)).keys())).map(function (i) {
        return _this2.renderRatingStep(i + 1);
      }));
    }
  }]);
  return RatingOutline;
}(React.Component);

var _templateObject$1g = taggedTemplateLiteral(["\n\tmargin-left: 0;\n\tmargin-bottom: 1.5em;\n"], ["\n\tmargin-left: 0;\n\tmargin-bottom: 1.5em;\n"]);

var Wrapper$m = styled.div(_templateObject$1g);

var MultipleRatingOutline = function MultipleRatingOutline(_ref) {
  var rows = _ref.rows,
      steps = _ref.steps;
  return React.createElement(Wrapper$m, null, rows.map(function (r) {
    return React.createElement(RatingOutline, {
      key: r.id.toString(),
      id: r.id,
      content: r.content,
      steps: steps
    });
  }));
};

var _templateObject$1h = taggedTemplateLiteral(["\n\tmargin: 10px 0 0 10px;\n\twidth: 350px;\n\tdisplay: inline-block;\n"], ["\n\tmargin: 10px 0 0 10px;\n\twidth: 350px;\n\tdisplay: inline-block;\n"]),
    _templateObject2$x = taggedTemplateLiteral(["\n\tmargin-top: -16px;\n\ttext-align: center;\n\tfont-size: 0.8em;\n"], ["\n\tmargin-top: -16px;\n\ttext-align: center;\n\tfont-size: 0.8em;\n"]),
    _templateObject3$g = taggedTemplateLiteral(["\n\tdisplay: block;\n\ttext-indent: 5px;\n\tpadding-bottom: 10px;\n"], ["\n\tdisplay: block;\n\ttext-indent: 5px;\n\tpadding-bottom: 10px;\n"]),
    _templateObject4$6 = taggedTemplateLiteral([""], [""]),
    _templateObject5$4 = taggedTemplateLiteral(["\n\tmargin-left: 10px;\n"], ["\n\tmargin-left: 10px;\n"]);

var StyledSlider = styled(Slider)(_templateObject$1h);
var StepHandle = styled.div(_templateObject2$x);
var AlignedContentSpan$1 = styled.span(_templateObject3$g);
var MinSpan = styled.span(_templateObject4$6);
var MaxSpan = styled.span(_templateObject5$4);

var SliderOutline = function (_React$Component) {
  inherits(SliderOutline, _React$Component);

  function SliderOutline(props) {
    classCallCheck(this, SliderOutline);

    var _this = possibleConstructorReturn(this, (SliderOutline.__proto__ || Object.getPrototypeOf(SliderOutline)).call(this, props));

    _this.state = {
      value: props.min
    };
    return _this;
  }

  createClass(SliderOutline, [{
    key: "renderContent",
    value: function renderContent() {
      var content = this.props.content;

      if (content) {
        return React.createElement(AlignedContentSpan$1, null, content);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          min = _props.min,
          max = _props.max,
          increment = _props.increment;
      var value = this.state.value;
      return React.createElement(Wrapper$j, null, this.renderContent(), React.createElement(MinSpan, null, min), React.createElement(StyledSlider, {
        min: min,
        max: max,
        step: increment,
        value: value,
        onChange: function onChange(value) {
          return _this2.setState({
            value: value
          });
        }
      }, React.createElement(StepHandle, null, value)), React.createElement(MaxSpan, null, max));
    }
  }]);
  return SliderOutline;
}(React.Component);

var _templateObject$1i = taggedTemplateLiteral(["\n\tmargin-left: 0;\n"], ["\n\tmargin-left: 0;\n"]);

var SliderWrapper = styled.div(_templateObject$1i);

var MultipleSliderOutline = function MultipleSliderOutline(_ref) {
  var rows = _ref.rows,
      min = _ref.min,
      max = _ref.max,
      increment = _ref.increment;
  return React.createElement(SliderWrapper, null, rows.map(function (r) {
    return React.createElement(SliderOutline, {
      key: r.id,
      id: r.id,
      content: r.content,
      min: min,
      max: max,
      increment: increment
    });
  }));
}; // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$a = function makeMapStateToProps() {
  var getRows = makeContentRowsSelector();
  return function (state, ownProps) {
    return {
      rows: getRows(state, ownProps.id)
    };
  };
};

var DropdownContainer = connect(makeMapStateToProps$a)(Dropdown$1);
var MultipleSelectContainer = connect(makeMapStateToProps$a)(MultipleSelectOutline);
var SingleSelectContainer = connect(makeMapStateToProps$a)(SingleSelectOutline);
var RankingContainer = connect(makeMapStateToProps$a)(Ranking$2);
var RatingContainer$1 = connect(makeMapStateToProps$a)(RatingOutline);
var MultipleRatingContainer = connect(makeMapStateToProps$a)(MultipleRatingOutline);
var MultipleSliderContainer = connect(makeMapStateToProps$a)(MultipleSliderOutline);
var SumContainer$1 = connect(makeMapStateToProps$a)(SumOutline);

var Text$2 = function (_React$Component) {
  inherits(Text, _React$Component);

  function Text(props) {
    classCallCheck(this, Text);

    var _this = possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props));

    _this.state = {
      text: ""
    };
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  createClass(Text, [{
    key: "onChange",
    value: function onChange(e) {
      var text = e.target.value;
      this.setState({
        text: text
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Wrapper$j, null, React.createElement(TextInput, {
        value: this.state.text,
        onChange: this.onChange
      }));
    }
  }]);
  return Text;
}(React.Component); // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$b = function makeMapStateToProps() {
  var getSlider = makeSliderSelector();
  return function (state, ownProps) {
    var _getSlider = getSlider(state, ownProps.id),
        min = _getSlider.min,
        max = _getSlider.max,
        increment = _getSlider.increment;

    return {
      min: min,
      max: max,
      increment: increment
    };
  };
};

var SliderContainer$1 = connect(makeMapStateToProps$b)(SliderOutline); // $FlowFixMe (react-redux factory signature)

var makeMapStateToProps$c = function makeMapStateToProps() {
  var getSlider = makeSliderSelector();
  var getRows = makeContentRowsSelector();
  return function (state, ownProps) {
    var _getSlider = getSlider(state, ownProps.id),
        min = _getSlider.min,
        max = _getSlider.max,
        increment = _getSlider.increment;

    return {
      rows: getRows(state, ownProps.id),
      min: min,
      max: max,
      increment: increment
    };
  };
};

var MultipleSliderContainer$1 = connect(makeMapStateToProps$c)(MultipleSliderOutline); // $FlowFixMe (react-redux factory signature)

var makeMapStateToProps$d = function makeMapStateToProps() {
  var getRating = makeRatingSelector();
  return function (state, ownProps) {
    var _getRating = getRating(state, ownProps.id),
        steps = _getRating.steps;

    return {
      steps: steps
    };
  };
};

var RatingContainer$2 = connect(makeMapStateToProps$d)(RatingOutline); // $FlowFixMe (react-redux factory signature)

var makeMapStateToProps$e = function makeMapStateToProps() {
  var getRating = makeRatingSelector();
  var getRows = makeContentRowsSelector();
  return function (state, ownProps) {
    var _getRating = getRating(state, ownProps.id),
        steps = _getRating.steps;

    return {
      rows: getRows(state, ownProps.id),
      steps: steps
    };
  };
};

var MultipleRatingContainer$1 = connect(makeMapStateToProps$e)(MultipleRatingOutline);

var Empty$2 = function Empty() {
  return null;
};

var types$6 = {
  single_select: SingleSelectContainer,
  multiple_select: MultipleSelectContainer,
  single_select_matrix: SingleSelectGridContainer,
  multiple_select_matrix: MultipleSelectGridContainer,
  short_text_input: Text$2,
  long_text_input: Text$2,
  dropdown: DropdownContainer,
  rank_order: RankingContainer,
  rating: RatingContainer$2,
  slider: SliderContainer$1,
  sum: SumContainer$1,
  descriptive: Empty$2,
  multiple_rating: MultipleRatingContainer$1,
  multiple_slider: MultipleSliderContainer$1,
  numeric: Text$2
};

var _templateObject$1j = taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 60px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 60px;\n"]);

var Flex = styled.div(_templateObject$1j);

var QuestionOutline = function (_React$Component) {
  inherits(QuestionOutline, _React$Component);

  function QuestionOutline(props) {
    classCallCheck(this, QuestionOutline);

    var _this = possibleConstructorReturn(this, (QuestionOutline.__proto__ || Object.getPrototypeOf(QuestionOutline)).call(this, props));

    _this.rootClickHandler = _this.rootClickHandler.bind(_this);
    _this.renderTypedOutline = _this.renderTypedOutline.bind(_this);
    return _this;
  }

  createClass(QuestionOutline, [{
    key: "rootClickHandler",
    value: function rootClickHandler(e) {
      var _props = this.props,
          id = _props.id,
          active = _props.active,
          surveyHashRoute = _props.surveyHashRoute;
      e.stopPropagation();
      if (!active) window.__SURVEYTOOL_HISTORY__.push("/" + surveyHashRoute + "/question/" + id);
    }
  }, {
    key: "renderTypedOutline",
    value: function renderTypedOutline(type) {
      var _props2 = this.props,
          id = _props2.id,
          active = _props2.active,
          expandQuestions = _props2.expandQuestions;
      var TypedOutline = types$6[type];
      if (TypedOutline === undefined) return null;
      if (expandQuestions || active) return React.createElement(TypedOutline, {
        id: id
      });
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          id = _props3.id,
          connectDragSource = _props3.connectDragSource,
          type = _props3.type,
          active = _props3.active,
          className = _props3.className,
          sequence = _props3.sequence,
          content = _props3.content,
          readOnly = _props3.readOnly;
      var controls = readOnly ? null : React.createElement(ControlWrapper$1, null, React.createElement(ControlsContainer$3, {
        id: id
      }));
      return connectDragSource(React.createElement("div", null, React.createElement(Card$3, {
        tabIndex: "0",
        onClick: this.rootClickHandler,
        className: (className || "") + " " + (active ? "active" : ""),
        onMouseOver: function onMouseOver() {
          return _this2.props.onMouseOver(id);
        },
        onMouseOut: function onMouseOut() {
          return _this2.props.onMouseOut(id);
        }
      }, React.createElement(Flex, null, React.createElement(Info, {
        sequence: sequence,
        type: type,
        content: content
      }), controls), this.renderTypedOutline(type))));
    }
  }]);
  return QuestionOutline;
}(React.Component);

var dragSource$5 = {
  canDrag: function canDrag(props) {
    return !props.readOnly;
  },
  beginDrag: function beginDrag(props, monitor, component) {
    return {
      id: props.id,
      pageQuestionCount: props.pageQuestionCount
    };
  }
};

var collect$8 = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var QuestionOutlineDraggable = lib_4$4(DragTypes.QUESTION, dragSource$5, collect$8)(QuestionOutline);

var makeMapStateToProps$f = function makeMapStateToProps() {
  var getOutline = makeQuestionOutlineSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var id = ownProps.id,
        locationPath = ownProps.locationPath;
    var active = locationPath.endsWith("/question/" + id);

    var _uiSelector = uiSelector(state),
        expandQuestions = _uiSelector.expandQuestions,
        readOnly = _uiSelector.readOnly;

    var _getOutline = getOutline(state, id),
        type = _getOutline.type,
        sequence = _getOutline.sequence,
        content = _getOutline.content;

    return {
      active: active,
      expandQuestions: expandQuestions,
      readOnly: readOnly,
      type: type,
      sequence: sequence,
      content: content
    };
  };

  return mapStateToProps;
};

var QuestionOutlineContainer = connect(makeMapStateToProps$f, {
  deleteQuestion: deleteQuestion,
  duplicateQuestion: duplicateQuestion,
  showModal: showModal$1
})(QuestionOutlineDraggable);

var _templateObject$1k = taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  min-height: 24px;\n  > h1 {\n    flex-grow: 1;\n    margin-bottom: ", ";\n  }\n  > svg {\n    height: 1.2em;\n    width: auto;\n    margin-right: 0.3em;\n    fill: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  min-height: 24px;\n  > h1 {\n    flex-grow: 1;\n    margin-bottom: ", ";\n  }\n  > svg {\n    height: 1.2em;\n    width: auto;\n    margin-right: 0.3em;\n    fill: ", ";\n  }\n"]);

var DisplayLogic$1 = icons.DisplayLogic,
    SkipLogic$1 = icons.SkipLogic;

var PageTitle = function PageTitle(_ref) {
  var sequence = _ref.sequence,
      content = _ref.content;
  var title = content ? "P" + sequence + ": " + content : "P" + sequence;
  return React.createElement("h1", null, title);
};

var FlexHeader = styled.div(_templateObject$1k, function (props) {
  return props.demo ? "1.5em" : "0";
}, function (props) {
  return props.theme.primary["2"];
});

var PageOutlineDemo = function PageOutlineDemo(_ref2) {
  var children = _ref2.children;
  return React.createElement(Card$2, {
    demo: true
  }, React.createElement(FlexHeader, {
    demo: true
  }, React.createElement("h1", null, "P1")), children);
};

var PageOutline = function (_React$Component) {
  inherits(PageOutline, _React$Component);

  function PageOutline(props) {
    classCallCheck(this, PageOutline);

    var _this = possibleConstructorReturn(this, (PageOutline.__proto__ || Object.getPrototypeOf(PageOutline)).call(this, props));

    _this.state = {
      QuestionHovered: null
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.renderPageHeader = _this.renderPageHeader.bind(_this);
    _this.renderQuestion = _this.renderQuestion.bind(_this);
    _this.setQuestionHovered = _this.setQuestionHovered.bind(_this);
    _this.clearQuestionHovered = _this.clearQuestionHovered.bind(_this);
    return _this;
  }

  createClass(PageOutline, [{
    key: "handleClick",
    value: function handleClick() {
      var _props = this.props,
          id = _props.id,
          surveyHashRoute = _props.surveyHashRoute;

      window.__SURVEYTOOL_HISTORY__.push("/" + surveyHashRoute + "/page/" + id);
    }
  }, {
    key: "renderPageHeader",
    value: function renderPageHeader() {
      var _props2 = this.props,
          id = _props2.id,
          sequence = _props2.sequence,
          content = _props2.content,
          questions = _props2.questions,
          hasDisplayLogic = _props2.hasDisplayLogic,
          hasSkipLogic = _props2.hasSkipLogic,
          readOnly = _props2.readOnly;
      var questionHovered = this.state.QuestionHovered !== null;
      var displayLogicIcon = hasDisplayLogic ? React.createElement(DisplayLogic$1, null) : null;
      var skipLogicIcon = hasSkipLogic ? React.createElement(SkipLogic$1, null) : null;
      var controls = readOnly || questionHovered ? null : React.createElement(ControlWrapper, null, React.createElement(ControlsContainer$2, {
        id: id,
        questionCount: questions.length
      }));
      return React.createElement(FlexHeader, null, displayLogicIcon, skipLogicIcon, React.createElement(PageTitle, {
        sequence: sequence,
        content: content
      }), controls);
    }
  }, {
    key: "setQuestionHovered",
    value: function setQuestionHovered(QuestionHovered) {
      this.setState({
        QuestionHovered: QuestionHovered
      });
    }
  }, {
    key: "clearQuestionHovered",
    value: function clearQuestionHovered(QuestionHovered) {
      this.setState({
        QuestionHovered: null
      });
    }
  }, {
    key: "renderQuestion",
    value: function renderQuestion(q) {
      var _props3 = this.props,
          id = _props3.id,
          locationPath = _props3.locationPath,
          surveyHashRoute = _props3.surveyHashRoute;
      return React.createElement("div", {
        key: q
      }, React.createElement(QuestionOutlineContainer, {
        id: q,
        locationPath: locationPath,
        surveyHashRoute: surveyHashRoute,
        onMouseOver: this.setQuestionHovered,
        onMouseOut: this.clearQuestionHovered
      }), React.createElement(AddQuestionContainer, {
        id: id,
        after: q,
        surveyHashRoute: surveyHashRoute
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          id = _props4.id,
          active = _props4.active,
          questions = _props4.questions,
          connectDragSource = _props4.connectDragSource,
          surveyHashRoute = _props4.surveyHashRoute;
      return connectDragSource(React.createElement("div", null, React.createElement(Card$2, {
        tabIndex: "0",
        onClick: this.handleClick,
        className: active ? "active" : ""
      }, this.renderPageHeader(), React.createElement(AddQuestionContainer, {
        id: id,
        surveyHashRoute: surveyHashRoute
      }), questions.map(this.renderQuestion))));
    }
  }]);
  return PageOutline;
}(React.Component);

var dragSource$6 = {
  canDrag: function canDrag(props) {
    return !props.readOnly;
  },
  beginDrag: function beginDrag(props, monitor, component) {
    return {
      id: props.id
    };
  }
};

var collect$9 = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource()
  };
};

var PageOutlineDraggable = lib_4$4(DragTypes.PAGE, dragSource$6, collect$9)(PageOutline);

var makeMapStateToProps$g = function makeMapStateToProps() {
  var getPageById = makePageByIdSelector();
  var getPageQuestions = makePageQuestionIdsSelector();
  var getSkipLogic = makeSkipLogicSelector();
  var getDisplayLogic = makeDisplayLogicSelector();
  return function (state, ownProps) {
    var id = ownProps.id,
        locationPath = ownProps.locationPath;
    var questions = getPageQuestions(state, id);

    var _getPageById = getPageById(state, id),
        sequence = _getPageById.sequence,
        content = _getPageById.content;

    var active = locationPath.endsWith("/page/" + id);
    var hasSkipLogic = getSkipLogic(state, id).length > 0;
    var hasDisplayLogic = getDisplayLogic(state, id) !== undefined;

    var _uiSelector = uiSelector(state),
        readOnly = _uiSelector.readOnly;

    return {
      active: active,
      sequence: sequence,
      questions: questions,
      content: content,
      hasDisplayLogic: hasDisplayLogic,
      hasSkipLogic: hasSkipLogic,
      readOnly: readOnly
    };
  };
}; // $FlowFixMe (flow seems to dislike connecting React DnD components?)


var PageOutlineContainer = connect(makeMapStateToProps$g)(PageOutlineDraggable);

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INSTANCE_MAP = new Map();
var OBSERVER_MAP = new Map();
/**
 * Monitor element, and trigger callback when element becomes visible
 * @param element {HTMLElement}
 * @param callback {Function} Called with inView
 * @param options {Object} InterSection observer options
 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be visible before triggering
 * @param options.root {HTMLElement} It should have a unique id or data-intersection-id in order for the Observer to reused.
 * @param options.rootMargin {String} The CSS margin to apply to the root element.
 * @param rootId {String} Unique identifier for the root element, to enable reusing the IntersectionObserver
 */

function observe(element, callback, options, rootId) {
  if (options === void 0) {
    options = {};
  } // Validate that the element is not being used in another <Observer />


  invariant_1(!INSTANCE_MAP.has(element), "react-intersection-observer: Trying to observe %s, but it's already being observed by another instance.\nMake sure the `ref` is only used by a single <Observer /> instance.\n\n%s", element); // IntersectionObserver needs a threshold to trigger, so set it to 0 if it's not defined.
  // Modify the options object, since it's used in the onChange handler.

  if (!options.threshold) options.threshold = 0;
  var _options = options,
      root = _options.root,
      rootMargin = _options.rootMargin,
      threshold = _options.threshold;
  if (!element || !callback) return;
  var observerId = rootMargin ? threshold.toString() + "_" + rootMargin : threshold.toString();

  if (root) {
    observerId = rootId ? rootId + "_" + observerId : null;
  }

  var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : null;

  if (!observerInstance) {
    observerInstance = new IntersectionObserver(onChange, options);
    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
  }

  var instance = {
    callback: callback,
    visible: false,
    options: options,
    observerId: observerId,
    observer: !observerId ? observerInstance : undefined
  };
  INSTANCE_MAP.set(element, instance);
  observerInstance.observe(element);
  return instance;
}
/**
 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
 * make sure to call this method.
 * @param element {HTMLElement}
 */


function unobserve(element) {
  if (!element) return;
  var instance = INSTANCE_MAP.get(element);

  if (instance) {
    var observerId = instance.observerId,
        observer = instance.observer;
    var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : observer;

    if (observerInstance) {
      observerInstance.unobserve(element);
    } // Check if we are still observing any elements with the same threshold.


    var itemsLeft = false;

    if (observerId) {
      INSTANCE_MAP.forEach(function (item, key) {
        if (item && item.observerId === observerId && key !== element) {
          itemsLeft = true;
        }
      });
    }

    if (observerInstance && !itemsLeft) {
      // No more elements to observe for threshold, disconnect observer
      observerInstance.disconnect();
      OBSERVER_MAP.delete(observerId);
    } // Remove reference to element


    INSTANCE_MAP.delete(element);
  }
}

function onChange(changes) {
  changes.forEach(function (intersection) {
    var isIntersecting = intersection.isIntersecting,
        intersectionRatio = intersection.intersectionRatio,
        target = intersection.target;
    var instance = INSTANCE_MAP.get(target); // Firefox can report a negative intersectionRatio when scrolling.

    if (instance && intersectionRatio >= 0) {
      var options = instance.options;
      var _inView = false;

      if (Array.isArray(options.threshold)) {
        // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
        _inView = options.threshold.some(function (threshold) {
          return instance.visible ? intersectionRatio > threshold : intersectionRatio >= threshold;
        });
      } else if (options.threshold !== undefined) {
        // Trigger on 0 ratio only when not visible. This is fallback for browsers without isIntersecting support
        _inView = instance.visible ? intersectionRatio > options.threshold : intersectionRatio >= options.threshold;
      }

      if (isIntersecting !== undefined) {
        // If isIntersecting is defined, ensure that the element is actually intersecting.
        // Otherwise it reports a threshold of 0
        _inView = _inView && isIntersecting;
      }

      instance.visible = _inView;
      instance.callback(_inView, intersectionRatio);
    }
  });
}
/**
 * Monitors scroll, and triggers the children function with updated props
 *
 <InView>
 {({inView, ref}) => (
   <h1 ref={ref}>{`${inView}`}</h1>
 )}
 </InView>
 */


var InView =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty$3(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      inView: false,
      intersectionRatio: 0
    });

    _defineProperty$3(_assertThisInitialized(_assertThisInitialized(_this)), "node", null);

    _defineProperty$3(_assertThisInitialized(_assertThisInitialized(_this)), "handleNode", function (node) {
      if (_this.node) unobserve(_this.node);
      _this.node = node;

      _this.observeNode();
    });

    _defineProperty$3(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (inView, intersectionRatio) {
      _this.setState({
        inView: inView,
        intersectionRatio: intersectionRatio
      });

      if (_this.props.onChange) {
        _this.props.onChange(inView, intersectionRatio);
      }
    });

    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (process.env.NODE_ENV !== 'production') {
      if (this.props.hasOwnProperty('render')) {
        console.warn("react-intersection-observer: \"render\" is deprecated, and should be replaced with \"children\"", this.node);
      }

      invariant_1(this.node, "react-intersection-observer: No DOM node found. Make sure you forward \"ref\" to the root DOM element you want to observe.");
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
      unobserve(this.node);
      this.observeNode();
    }

    if (prevState.inView !== this.state.inView) {
      if (this.state.inView && this.props.triggerOnce) {
        unobserve(this.node);
        this.node = null;
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.node) {
      unobserve(this.node);
      this.node = null;
    }
  };

  _proto.observeNode = function observeNode() {
    if (!this.node) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        rootId = _this$props.rootId;
    observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin
    }, rootId);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        render = _this$props2.render,
        tag = _this$props2.tag,
        triggerOnce = _this$props2.triggerOnce,
        threshold = _this$props2.threshold,
        root = _this$props2.root,
        rootId = _this$props2.rootId,
        rootMargin = _this$props2.rootMargin,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "render", "tag", "triggerOnce", "threshold", "root", "rootId", "rootMargin"]);

    var _this$state = this.state,
        inView = _this$state.inView,
        intersectionRatio = _this$state.intersectionRatio;
    var renderMethod = children || render;

    if (typeof renderMethod === 'function') {
      return renderMethod({
        inView: inView,
        intersectionRatio: intersectionRatio,
        ref: this.handleNode
      });
    }

    return createElement(tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(Component);

_defineProperty$3(InView, "defaultProps", {
  threshold: 0,
  triggerOnce: false
});

var HeaderWithObserver = function (_React$Component) {
  inherits(HeaderWithObserver, _React$Component);

  function HeaderWithObserver(props) {
    classCallCheck(this, HeaderWithObserver);

    var _this = possibleConstructorReturn(this, (HeaderWithObserver.__proto__ || Object.getPrototypeOf(HeaderWithObserver)).call(this, props));

    _this.state = {
      contentInView: false,
      headerInView: false
    };
    return _this;
  }

  createClass(HeaderWithObserver, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          header = _props.header,
          body = _props.body;
      var stuck = this.state.contentInView && !this.state.headerInView;
      return React.createElement(InView, {
        onChange: function onChange(contentInView) {
          requestAnimationFrame(function () {
            return _this2.setState({
              contentInView: contentInView
            });
          });
        }
      }, React.createElement("div", null, React.createElement(InView, {
        onChange: function onChange(headerInView) {
          requestAnimationFrame(function () {
            return _this2.setState({
              headerInView: headerInView
            });
          });
        }
      }, header(stuck)), body(stuck)));
    }
  }]);
  return HeaderWithObserver;
}(React.Component);

var _templateObject$1l = taggedTemplateLiteral(["\n\tmargin: 0 -20px;\n\tbackground-color: ", ";\n\tz-index: 5;\n\theight: 35px;\n\tbox-sizing: border-box;\n\t", " {\n\t\tpadding: 15px 20px 0 20px;\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\t\tborder-bottom-width: 0;\n\t\t> h1 {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n"], ["\n\tmargin: 0 -20px;\n\tbackground-color: ", ";\n\tz-index: 5;\n\theight: 35px;\n\tbox-sizing: border-box;\n\t", " {\n\t\tpadding: 15px 20px 0 20px;\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\t\tborder-bottom-width: 0;\n\t\t> h1 {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n"]);

var Cap$1 = styled.div(_templateObject$1l, function (props) {
  return props.theme.neutralLight["5"];
}, Card$1);

var Header$4 = function (_React$Component) {
  inherits(Header, _React$Component);

  function Header() {
    classCallCheck(this, Header);
    return possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  createClass(Header, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          id = _props.id,
          stuck = _props.stuck,
          setOutlineHeader = _props.setOutlineHeader;

      if (nextProps.stuck && !stuck) {
        return setOutlineHeader({
          section: id
        });
      }

      if (!nextProps.stuck && stuck) {
        return setOutlineHeader({
          section: null
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Cap$1, null, React.createElement(Card$1, null, React.createElement("h1", null, this.props.content)));
    }
  }]);
  return Header;
}(React.Component);

var _templateObject$1m = taggedTemplateLiteral(["\n\tfont-size: inherit;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tborder-radius: 0.5em;\n\theight: 60px;\n\tbox-sizing: border-box;\n\ttext-align: center;\n\tposition: relative;\n\ttransition: background-color 0.125s;\n\tsvg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\toverflow: visible;\n\t\tborder-radius: inherit;\n\t}\n\trect {\n\t\tfill: none;\n\t\tborder-radius: inherit;\n\t\tstroke: ", ";\n\t\tstroke-width: 1.5;\n\t\tstroke-linecap: round;\n\t\tstroke-dasharray: 5;\n\t}\n\tspan {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t}\n"], ["\n\tfont-size: inherit;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tborder-radius: 0.5em;\n\theight: 60px;\n\tbox-sizing: border-box;\n\ttext-align: center;\n\tposition: relative;\n\ttransition: background-color 0.125s;\n\tsvg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\toverflow: visible;\n\t\tborder-radius: inherit;\n\t}\n\trect {\n\t\tfill: none;\n\t\tborder-radius: inherit;\n\t\tstroke: ", ";\n\t\tstroke-width: 1.5;\n\t\tstroke-linecap: round;\n\t\tstroke-dasharray: 5;\n\t}\n\tspan {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t}\n"]);

var Dropzone$2 = function Dropzone(_ref) {
  var className = _ref.className,
      children = _ref.children,
      style = _ref.style;
  return React.createElement("div", {
    className: className,
    style: style
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    height: "100%",
    width: "100%",
    rx: "7",
    ry: "7"
  })), children);
};

var Dropzone$3 = styled(Dropzone$2)(_templateObject$1m, function (props) {
  return props.hovered ? props.theme.primary["4"] : props.theme.primary["5"];
}, function (props) {
  return props.theme.primary["2"];
}, function (props) {
  return props.theme.primary["2"];
});

var _templateObject$1n = taggedTemplateLiteral(["\n\tposition: relative;\n\tmin-height: 20px;\n\tpadding: ", ";\n"], ["\n\tposition: relative;\n\tmin-height: 20px;\n\tpadding: ", ";\n"]);

var AddPage = function AddPage(_ref) {
  var connectDropTarget = _ref.connectDropTarget,
      hovered = _ref.hovered,
      collapse = _ref.collapse,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style;
  var dropzone = collapse && !hovered ? null : React.createElement(Dropzone$3, {
    hovered: hovered,
    collapse: collapse
  }, React.createElement("span", null, children));
  return connectDropTarget(React.createElement("div", {
    className: className,
    style: style
  }, dropzone));
};

var StyledAddPage = styled(AddPage)(_templateObject$1n, function (props) {
  return props.hovered || !props.collapse ? "20px 0" : "0";
});

var questionTypeDrop$1 = function questionTypeDrop(props, monitor, component) {
  var createPageWithNewQuestion = props.createPageWithNewQuestion,
      surveyHashRoute = props.surveyHashRoute;

  var _monitor$getItem = monitor.getItem(),
      type = _monitor$getItem.type;

  var graph = props.graph,
      after = props.after;
  createPageWithNewQuestion({
    graph: graph,
    after: after
  }, type, surveyHashRoute);
};

var questionDrop$2 = function questionDrop(props, monitor, component) {
  var createPageWithExistingQuestion = props.createPageWithExistingQuestion,
      graph = props.graph,
      after = props.after,
      index = props.index;

  var _monitor$getItem2 = monitor.getItem(),
      question = _monitor$getItem2.id;

  createPageWithExistingQuestion({
    graph: graph,
    after: after,
    sequence: index + 1
  }, question);
};

var pageDrop$1 = function pageDrop(props, monitor, component) {
  var movePage = props.movePage,
      graph = props.graph,
      after = props.after;

  var _monitor$getItem3 = monitor.getItem(),
      id = _monitor$getItem3.id;

  movePage(id, graph, after);
};

var dropTarget$2 = {
  drop: function drop(props, monitor, component) {
    switch (monitor.getItemType()) {
      case DragTypes.QUESTION_TYPE:
        return questionTypeDrop$1(props, monitor, component);

      case DragTypes.QUESTION:
        return questionDrop$2(props, monitor, component);

      case DragTypes.PAGE:
        return pageDrop$1(props, monitor, component);

      default:
        throw new Error("Unhandled drop type " + monitor.getItemType());
    }
  }
};

var collect$a = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    hovered: monitor.isOver(),
    questionType: monitor.getItem()
  };
};

var types$7 = [DragTypes.QUESTION_TYPE, DragTypes.QUESTION, DragTypes.PAGE];
var AddPageDroppable = lib_5$2(types$7, dropTarget$2, collect$a)(StyledAddPage);
var AddPageContainer = withRouter(connect(null, {
  createPageWithNewQuestion: createPageWithNewQuestion$1,
  createPageWithExistingQuestion: createPageWithExistingQuestion$1,
  movePage: movePage
})(AddPageDroppable));

var _templateObject$1o = taggedTemplateLiteral(["\n  margin: 0 -20px;\n  padding: 0 20px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-top-width: 0;\n"], ["\n  margin: 0 -20px;\n  padding: 0 20px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-top-width: 0;\n"]);

var StyledCard$2 = styled(Card$1)(_templateObject$1o);

var SectionBody = function (_React$Component) {
  inherits(SectionBody, _React$Component);

  function SectionBody(props) {
    classCallCheck(this, SectionBody);

    var _this = possibleConstructorReturn(this, (SectionBody.__proto__ || Object.getPrototypeOf(SectionBody)).call(this, props));

    _this.renderPage = _this.renderPage.bind(_this);
    _this.renderAddPage = _this.renderAddPage.bind(_this);
    return _this;
  }

  createClass(SectionBody, [{
    key: "renderAddPage",
    value: function renderAddPage(after) {
      var _props = this.props,
          graph = _props.childGraph,
          surveyHashRoute = _props.surveyHashRoute;
      return React.createElement(AddPageContainer, {
        surveyHashRoute: surveyHashRoute,
        collapse: true,
        after: after,
        graph: graph
      }, "+ Add Page");
    }
  }, {
    key: "renderPage",
    value: function renderPage(page, after) {
      var _props2 = this.props,
          locationPath = _props2.locationPath,
          surveyHashRoute = _props2.surveyHashRoute;
      var id = page.id,
          node = page.node;
      return React.createElement("div", {
        key: id
      }, React.createElement(PageOutlineContainer, {
        surveyHashRoute: surveyHashRoute,
        id: id,
        locationPath: locationPath
      }), this.renderAddPage(node));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var pages = this.props.pages;
      return React.createElement(StyledCard$2, null, this.renderAddPage(), pages.map(function (p) {
        return _this2.renderPage(p);
      }));
    }
  }]);
  return SectionBody;
}(React.Component);

var SectionOutline = function (_React$Component) {
  inherits(SectionOutline, _React$Component);

  function SectionOutline() {
    classCallCheck(this, SectionOutline);
    return possibleConstructorReturn(this, (SectionOutline.__proto__ || Object.getPrototypeOf(SectionOutline)).apply(this, arguments));
  }

  createClass(SectionOutline, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          content = _props.content,
          pages = _props.pages,
          setOutlineHeader = _props.setOutlineHeader,
          childGraph = _props.childGraph,
          locationPath = _props.locationPath,
          surveyHashRoute = _props.surveyHashRoute;

      var renderHeader = function renderHeader(stuck) {
        return React.createElement(Header$4, {
          id: id,
          content: content,
          stuck: stuck,
          setOutlineHeader: setOutlineHeader
        });
      };

      var renderBody = function renderBody(stuck) {
        return React.createElement(SectionBody, {
          surveyHashRoute: surveyHashRoute,
          pages: pages,
          childGraph: childGraph,
          locationPath: locationPath
        });
      };

      return React.createElement(HeaderWithObserver, {
        header: renderHeader,
        body: renderBody
      });
    }
  }]);
  return SectionOutline;
}(React.Component); // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$h = function makeMapStateToProps() {
  var getSection = makeSectionSelector();
  var getGraph = makeChildGraphSelector();
  var getPages = makeSectionPagesSelector();

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var id = ownProps.id;

    var _getSection = getSection(state, id),
        content = _getSection.content,
        node = _getSection.node;

    var _getGraph = getGraph(state, node),
        childGraph = _getGraph.id;

    var pages = getPages(state, childGraph);
    return {
      content: content,
      pages: pages,
      childGraph: childGraph
    };
  };

  return mapStateToProps;
};

var SectionOutlineContainer = connect(makeMapStateToProps$h, {
  setOutlineHeader: setOutlineHeader
})(SectionOutline);

var _templateObject$1p = taggedTemplateLiteral(["\n  padding: 20px 40px;\n  margin: 0 -20px;\n  border-radius: 0.5em;\n"], ["\n  padding: 20px 40px;\n  margin: 0 -20px;\n  border-radius: 0.5em;\n"]),
    _templateObject2$y = taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 25px;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 25px;\n  transform: translateY(-50%);\n"]);

var Wrapper$n = styled(DottedOutline)(_templateObject$1p);
var StyledLabel = styled(GroupLabel)(_templateObject2$y);

var Header$5 = function (_React$Component) {
  inherits(Header, _React$Component);

  function Header() {
    classCallCheck(this, Header);
    return possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  createClass(Header, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          id = _props.id,
          stuck = _props.stuck,
          setOutlineHeader = _props.setOutlineHeader;

      if (nextProps.stuck && !stuck) {
        return setOutlineHeader({
          group: id
        });
      }

      if (!nextProps.stuck && stuck) {
        return setOutlineHeader({
          group: null
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          color = _props2.color,
          content = _props2.content;
      return React.createElement(StyledLabel, {
        color: color
      }, content);
    }
  }]);
  return Header;
}(React.Component);

var Body$1 = function Body(_ref) {
  var sections = _ref.sections,
      locationPath = _ref.locationPath,
      surveyHashRoute = _ref.surveyHashRoute;
  return React.createElement("div", null, sections.map(function (id) {
    return React.createElement(SectionOutlineContainer, {
      surveyHashRoute: surveyHashRoute,
      key: id,
      id: id,
      locationPath: locationPath
    });
  }));
};

var GroupOutline = function GroupOutline(_ref2) {
  var id = _ref2.id,
      sections = _ref2.sections,
      color = _ref2.color,
      content = _ref2.content,
      locationPath = _ref2.locationPath,
      setOutlineHeader = _ref2.setOutlineHeader,
      surveyHashRoute = _ref2.surveyHashRoute;
  return React.createElement(Wrapper$n, {
    borderColor: color
  }, React.createElement(HeaderWithObserver, {
    header: function header(stuck) {
      return React.createElement(Header$5, {
        id: id,
        stuck: stuck,
        color: color,
        content: content,
        setOutlineHeader: setOutlineHeader
      });
    },
    body: function body(stuck) {
      return React.createElement(Body$1, {
        surveyHashRoute: surveyHashRoute,
        sections: sections,
        locationPath: locationPath
      });
    }
  }));
}; // $FlowFixMe (react-redux factory signature)


var makeMapStateToProps$i = function makeMapStateToProps() {
  var getGroup = makeGroupSelector();
  var getGroupGraph = makeGroupGraphSelector();
  var getSections = makeGroupSectionIdSelector();
  return function (state, ownProps) {
    var _getGroup = getGroup(state, ownProps.id),
        content = _getGroup.content,
        sortType = _getGroup.sortType,
        color = _getGroup.color;

    var _getGroupGraph = getGroupGraph(state, ownProps.id),
        childGraph = _getGroupGraph.id;

    var sections = getSections(state, ownProps.id);
    return {
      content: content,
      sortType: sortType,
      color: color,
      childGraph: childGraph,
      sections: sections
    };
  };
};

var GroupOutlineContainer = connect(makeMapStateToProps$i, {
  setOutlineHeader: setOutlineHeader
})(GroupOutline);
var componentMap = {
  Page: PageOutlineContainer,
  Section: SectionOutlineContainer,
  Group: GroupOutlineContainer
};

var ContentMap = function ContentMap(_ref) {
  var addPage = _ref.addPage,
      locationPath = _ref.locationPath,
      surveyHashRoute = _ref.surveyHashRoute,
      contentType = _ref.contentType,
      id = _ref.id;
  var ContentComponent = componentMap[contentType];
  return React.createElement("div", null, React.createElement(ContentComponent, {
    surveyHashRoute: surveyHashRoute,
    locationPath: locationPath,
    id: id
  }), addPage);
};

var SurveyOutlineList = function (_React$Component) {
  inherits(SurveyOutlineList, _React$Component);

  function SurveyOutlineList(props) {
    classCallCheck(this, SurveyOutlineList);

    var _this = possibleConstructorReturn(this, (SurveyOutlineList.__proto__ || Object.getPrototypeOf(SurveyOutlineList)).call(this, props));

    _this.renderAddPage = _this.renderAddPage.bind(_this);
    _this.renderAddPageDemo = _this.renderAddPageDemo.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);
    _this.renderEmpty = _this.renderEmpty.bind(_this);
    _this.renderList = _this.renderList.bind(_this);
    return _this;
  }

  createClass(SurveyOutlineList, [{
    key: "renderAddPage",
    value: function renderAddPage(after) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _props = this.props,
          contents = _props.contents,
          graph = _props.graph,
          surveyHashRoute = _props.surveyHashRoute;
      if (contents.length === 0) return null;
      return React.createElement(AddPageContainer, {
        surveyHashRoute: surveyHashRoute,
        index: index,
        after: after,
        collapse: true,
        graph: graph
      }, "+ Add Page");
    }
  }, {
    key: "renderAddPageDemo",
    value: function renderAddPageDemo(after) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _props2 = this.props,
          graph = _props2.graph,
          surveyHashRoute = _props2.surveyHashRoute;
      return React.createElement(AddPageContainer, {
        surveyHashRoute: surveyHashRoute,
        index: index,
        after: after,
        graph: graph
      }, "Drag & drop a question here to add a new page");
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var _props3 = this.props,
          graph = _props3.graph,
          surveyHashRoute = _props3.surveyHashRoute;
      return React.createElement(PageOutlineDemo, null, React.createElement(AddPageContainer, {
        surveyHashRoute: surveyHashRoute,
        index: 0,
        style: {
          padding: 0
        },
        graph: graph
      }, "Drag & drop your first question here"));
    }
  }, {
    key: "renderContent",
    value: function renderContent(content, index) {
      var contentType = content.contentType,
          id = content.id,
          node = content.node;
      var _props4 = this.props,
          contents = _props4.contents,
          locationPath = _props4.locationPath,
          surveyHashRoute = _props4.surveyHashRoute;
      var addPage = contents.length === 1 ? this.renderAddPageDemo(node, index + 1) : this.renderAddPage(node, index + 1);
      var key = "" + contentType + id;
      return React.createElement(ContentMap, {
        id: id,
        key: key,
        surveyHashRoute: surveyHashRoute,
        locationPath: locationPath,
        addPage: addPage,
        contentType: contentType
      });
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var contents = this.props.contents;
      return React.createElement("div", null, this.renderAddPage(), contents.map(this.renderContent));
    }
  }, {
    key: "render",
    value: function render() {
      var contents = this.props.contents;
      if (!contents.length) return this.renderEmpty();
      return this.renderList();
    }
  }]);
  return SurveyOutlineList;
}(React.Component);

SurveyOutlineList.defaultProps = {
  contents: []
};

function mapStateToProps$J(state) {
  var graph = rootGraphSelector(state);
  var contents = graphContentSelector(state, graph);
  return {
    graph: graph,
    contents: contents
  };
}

var SurveyOutlineListContainer = connect(mapStateToProps$J)(SurveyOutlineList);

var _templateObject$1q = taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 10px 60px;\n  overflow: auto;\n  height: 100%;\n  > div {\n    max-width: 990px;\n  }\n"], ["\n  background-color: ", ";\n  padding: 10px 60px;\n  overflow: auto;\n  height: 100%;\n  > div {\n    max-width: 990px;\n  }\n"]),
    _templateObject2$z = taggedTemplateLiteral(["\n  flex-grow: 2;\n  flex-basis: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  flex-grow: 2;\n  flex-basis: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
    _templateObject3$h = taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n"], ["\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n"]);

var List$g = styled.div(_templateObject$1q, function (props) {
  return props.theme.neutralLight["5"];
});
var Container$1 = styled.div(_templateObject2$z);
var OutlineOverlay = styled.div(_templateObject3$h);

var SurveyOutline = function SurveyOutline(props) {
  var conditionalOverlay = props.overlayVisible ? React.createElement(OutlineOverlay, null) : null;
  return React.createElement(Container$1, null, conditionalOverlay, React.createElement(FixedHeader, props.outlineHeader), React.createElement(List$g, null, React.createElement("div", null, React.createElement(SurveyOutlineListContainer, {
    locationPath: props.location.pathname,
    surveyHashRoute: props.surveyHashRoute
  }))));
};

var mapStateToProps$K = function mapStateToProps(state) {
  var _outlineHeaderSelecto = outlineHeaderSelector(state),
      section = _outlineHeaderSelecto.section,
      group = _outlineHeaderSelecto.group;

  var _uiSelector = uiSelector(state),
      outlineOverlay = _uiSelector.outlineOverlay;

  return {
    outlineHeader: {
      section: section,
      group: group
    },
    overlayVisible: outlineOverlay
  };
};

var SurveyOutlineContainer = withRouter(connect(mapStateToProps$K)(SurveyOutline));

var _templateObject$1r = taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  font-family: ", ";\n  color: ", ";\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
    _templateObject2$A = taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  min-width: 720px;\n  max-width: 1440px;\n  margin: 0 auto;\n  background: ", ";\n  width: 100%;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-grow: 1;\n  min-width: 720px;\n  max-width: 1440px;\n  margin: 0 auto;\n  background: ", ";\n  width: 100%;\n  overflow: hidden;\n"]);

var StyledApp = styled.div(_templateObject$1r, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.neutralDark["4"];
});
var StyledWrapper$4 = styled.div(_templateObject2$A, function (props) {
  return props.theme.neutralLight["5"];
});

var AppLayout = function AppLayout(props) {
  return React.createElement(StyledApp, props, React.createElement(TopbarContainer, {
    exitLink: props.exitLink
  }), React.createElement(AppErrorBoundaryContainer, null, React.createElement(StyledWrapper$4, null, React.createElement(Sidebar$1, null), React.createElement(SurveyOutlineContainer, {
    surveyHashRoute: props.surveyHashRoute
  }))), React.createElement(ModalContainer, null));
};

var mousetrap = createCommonjsModule(function (module) {
  /*global define:false */

  /**
   * Copyright 2012-2017 Craig Campbell
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   * http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *
   * Mousetrap is a simple keyboard shortcut library for Javascript with
   * no external dependencies
   *
   * @version 1.6.2
   * @url craig.is/killing/mice
   */
  (function (window, document, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window) {
      return;
    }
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */


    var _MAP = {
      8: 'backspace',
      9: 'tab',
      13: 'enter',
      16: 'shift',
      17: 'ctrl',
      18: 'alt',
      20: 'capslock',
      27: 'esc',
      32: 'space',
      33: 'pageup',
      34: 'pagedown',
      35: 'end',
      36: 'home',
      37: 'left',
      38: 'up',
      39: 'right',
      40: 'down',
      45: 'ins',
      46: 'del',
      91: 'meta',
      93: 'meta',
      224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */

    var _KEYCODE_MAP = {
      106: '*',
      107: '+',
      109: '-',
      110: '.',
      111: '/',
      186: ';',
      187: '=',
      188: ',',
      189: '-',
      190: '.',
      191: '/',
      192: '`',
      219: '[',
      220: '\\',
      221: ']',
      222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */

    var _SHIFT_MAP = {
      '~': '`',
      '!': '1',
      '@': '2',
      '#': '3',
      '$': '4',
      '%': '5',
      '^': '6',
      '&': '7',
      '*': '8',
      '(': '9',
      ')': '0',
      '_': '-',
      '+': '=',
      ':': ';',
      '\"': '\'',
      '<': ',',
      '>': '.',
      '?': '/',
      '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */

    var _SPECIAL_ALIASES = {
      'option': 'alt',
      'command': 'meta',
      'return': 'enter',
      'escape': 'esc',
      'plus': '+',
      'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */

    var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */


    for (var i = 1; i < 20; ++i) {
      _MAP[111 + i] = 'f' + i;
    }
    /**
     * loop through to map numbers on the numeric keypad
     */


    for (i = 0; i <= 9; ++i) {
      // This needs to use a string cause otherwise since 0 is falsey
      // mousetrap will never fire for numpad 0 pressed as part of a keydown
      // event.
      //
      // @see https://github.com/ccampbell/mousetrap/pull/258
      _MAP[i + 96] = i.toString();
    }
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */


    function _addEvent(object, type, callback) {
      if (object.addEventListener) {
        object.addEventListener(type, callback, false);
        return;
      }

      object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */


    function _characterFromEvent(e) {
      // for keypress events we should return the character as is
      if (e.type == 'keypress') {
        var character = String.fromCharCode(e.which); // if the shift key is not pressed then it is safe to assume
        // that we want the character to be lowercase.  this means if
        // you accidentally have caps lock on then your key bindings
        // will continue to work
        //
        // the only side effect that might not be desired is if you
        // bind something like 'A' cause you want to trigger an
        // event when capital A is pressed caps lock will no longer
        // trigger the event.  shift+a will though.

        if (!e.shiftKey) {
          character = character.toLowerCase();
        }

        return character;
      } // for non keypress events the special maps are needed


      if (_MAP[e.which]) {
        return _MAP[e.which];
      }

      if (_KEYCODE_MAP[e.which]) {
        return _KEYCODE_MAP[e.which];
      } // if it is not in the special map
      // with keydown and keyup events the character seems to always
      // come in as an uppercase character whether you are pressing shift
      // or not.  we should make sure it is always lowercase for comparisons


      return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */


    function _modifiersMatch(modifiers1, modifiers2) {
      return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */


    function _eventModifiers(e) {
      var modifiers = [];

      if (e.shiftKey) {
        modifiers.push('shift');
      }

      if (e.altKey) {
        modifiers.push('alt');
      }

      if (e.ctrlKey) {
        modifiers.push('ctrl');
      }

      if (e.metaKey) {
        modifiers.push('meta');
      }

      return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */


    function _preventDefault(e) {
      if (e.preventDefault) {
        e.preventDefault();
        return;
      }

      e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */


    function _stopPropagation(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
        return;
      }

      e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */


    function _isModifier(key) {
      return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */


    function _getReverseMap() {
      if (!_REVERSE_MAP) {
        _REVERSE_MAP = {};

        for (var key in _MAP) {
          // pull out the numeric keypad from here cause keypress should
          // be able to detect the keys from the character
          if (key > 95 && key < 112) {
            continue;
          }

          if (_MAP.hasOwnProperty(key)) {
            _REVERSE_MAP[_MAP[key]] = key;
          }
        }
      }

      return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */


    function _pickBestAction(key, modifiers, action) {
      // if no action was picked in we should try to pick the one
      // that we think would work best for this key
      if (!action) {
        action = _getReverseMap()[key] ? 'keydown' : 'keypress';
      } // modifier keys don't work as expected with keypress,
      // switch to keydown


      if (action == 'keypress' && modifiers.length) {
        action = 'keydown';
      }

      return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */


    function _keysFromString(combination) {
      if (combination === '+') {
        return ['+'];
      }

      combination = combination.replace(/\+{2}/g, '+plus');
      return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */


    function _getKeyInfo(combination, action) {
      var keys;
      var key;
      var i;
      var modifiers = []; // take the keys from this pattern and figure out what the actual
      // pattern is all about

      keys = _keysFromString(combination);

      for (i = 0; i < keys.length; ++i) {
        key = keys[i]; // normalize key names

        if (_SPECIAL_ALIASES[key]) {
          key = _SPECIAL_ALIASES[key];
        } // if this is not a keypress event then we should
        // be smart about using shift keys
        // this will only work for US keyboards however


        if (action && action != 'keypress' && _SHIFT_MAP[key]) {
          key = _SHIFT_MAP[key];
          modifiers.push('shift');
        } // if this key is a modifier then add it to the list of modifiers


        if (_isModifier(key)) {
          modifiers.push(key);
        }
      } // depending on what the key combination is
      // we will try to pick the best event for it


      action = _pickBestAction(key, modifiers, action);
      return {
        key: key,
        modifiers: modifiers,
        action: action
      };
    }

    function _belongsTo(element, ancestor) {
      if (element === null || element === document) {
        return false;
      }

      if (element === ancestor) {
        return true;
      }

      return _belongsTo(element.parentNode, ancestor);
    }

    function Mousetrap(targetElement) {
      var self = this;
      targetElement = targetElement || document;

      if (!(self instanceof Mousetrap)) {
        return new Mousetrap(targetElement);
      }
      /**
       * element to attach key events to
       *
       * @type {Element}
       */


      self.target = targetElement;
      /**
       * a list of all the callbacks setup via Mousetrap.bind()
       *
       * @type {Object}
       */

      self._callbacks = {};
      /**
       * direct map of string combinations to callbacks used for trigger()
       *
       * @type {Object}
       */

      self._directMap = {};
      /**
       * keeps track of what level each sequence is at since multiple
       * sequences can start out with the same sequence
       *
       * @type {Object}
       */

      var _sequenceLevels = {};
      /**
       * variable to store the setTimeout call
       *
       * @type {null|number}
       */

      var _resetTimer;
      /**
       * temporary state where we will ignore the next keyup
       *
       * @type {boolean|string}
       */


      var _ignoreNextKeyup = false;
      /**
       * temporary state where we will ignore the next keypress
       *
       * @type {boolean}
       */

      var _ignoreNextKeypress = false;
      /**
       * are we currently inside of a sequence?
       * type of action ("keyup" or "keydown" or "keypress") or false
       *
       * @type {boolean|string}
       */

      var _nextExpectedAction = false;
      /**
       * resets all sequence counters except for the ones passed in
       *
       * @param {Object} doNotReset
       * @returns void
       */

      function _resetSequences(doNotReset) {
        doNotReset = doNotReset || {};
        var activeSequences = false,
            key;

        for (key in _sequenceLevels) {
          if (doNotReset[key]) {
            activeSequences = true;
            continue;
          }

          _sequenceLevels[key] = 0;
        }

        if (!activeSequences) {
          _nextExpectedAction = false;
        }
      }
      /**
       * finds all callbacks that match based on the keycode, modifiers,
       * and action
       *
       * @param {string} character
       * @param {Array} modifiers
       * @param {Event|Object} e
       * @param {string=} sequenceName - name of the sequence we are looking for
       * @param {string=} combination
       * @param {number=} level
       * @returns {Array}
       */


      function _getMatches(character, modifiers, e, sequenceName, combination, level) {
        var i;
        var callback;
        var matches = [];
        var action = e.type; // if there are no events related to this keycode

        if (!self._callbacks[character]) {
          return [];
        } // if a modifier key is coming up on its own we should allow it


        if (action == 'keyup' && _isModifier(character)) {
          modifiers = [character];
        } // loop through all callbacks for the key that was pressed
        // and see if any of them match


        for (i = 0; i < self._callbacks[character].length; ++i) {
          callback = self._callbacks[character][i]; // if a sequence name is not specified, but this is a sequence at
          // the wrong level then move onto the next match

          if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
            continue;
          } // if the action we are looking for doesn't match the action we got
          // then we should keep going


          if (action != callback.action) {
            continue;
          } // if this is a keypress event and the meta key and control key
          // are not pressed that means that we need to only look at the
          // character, otherwise check the modifiers as well
          //
          // chrome will not fire a keypress if meta or control is down
          // safari will fire a keypress if meta or meta+shift is down
          // firefox will fire a keypress if meta or control is down


          if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
            // when you bind a combination or sequence a second time it
            // should overwrite the first one.  if a sequenceName or
            // combination is specified in this call it does just that
            //
            // @todo make deleting its own method?
            var deleteCombo = !sequenceName && callback.combo == combination;
            var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;

            if (deleteCombo || deleteSequence) {
              self._callbacks[character].splice(i, 1);
            }

            matches.push(callback);
          }
        }

        return matches;
      }
      /**
       * actually calls the callback function
       *
       * if your callback function returns false this will use the jquery
       * convention - prevent default and stop propogation on the event
       *
       * @param {Function} callback
       * @param {Event} e
       * @returns void
       */


      function _fireCallback(callback, e, combo, sequence) {
        // if this event should not happen stop here
        if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
          return;
        }

        if (callback(e, combo) === false) {
          _preventDefault(e);

          _stopPropagation(e);
        }
      }
      /**
       * handles a character key event
       *
       * @param {string} character
       * @param {Array} modifiers
       * @param {Event} e
       * @returns void
       */


      self._handleKey = function (character, modifiers, e) {
        var callbacks = _getMatches(character, modifiers, e);

        var i;
        var doNotReset = {};
        var maxLevel = 0;
        var processedSequenceCallback = false; // Calculate the maxLevel for sequences so we can only execute the longest callback sequence

        for (i = 0; i < callbacks.length; ++i) {
          if (callbacks[i].seq) {
            maxLevel = Math.max(maxLevel, callbacks[i].level);
          }
        } // loop through matching callbacks for this key event


        for (i = 0; i < callbacks.length; ++i) {
          // fire for all sequence callbacks
          // this is because if for example you have multiple sequences
          // bound such as "g i" and "g t" they both need to fire the
          // callback for matching g cause otherwise you can only ever
          // match the first one
          if (callbacks[i].seq) {
            // only fire callbacks for the maxLevel to prevent
            // subsequences from also firing
            //
            // for example 'a option b' should not cause 'option b' to fire
            // even though 'option b' is part of the other sequence
            //
            // any sequences that do not match here will be discarded
            // below by the _resetSequences call
            if (callbacks[i].level != maxLevel) {
              continue;
            }

            processedSequenceCallback = true; // keep a list of which sequences were matches for later

            doNotReset[callbacks[i].seq] = 1;

            _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);

            continue;
          } // if there were no sequence matches but we are still here
          // that means this is a regular match so we should fire that


          if (!processedSequenceCallback) {
            _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
          }
        } // if the key you pressed matches the type of sequence without
        // being a modifier (ie "keyup" or "keypress") then we should
        // reset all sequences that were not matched by this event
        //
        // this is so, for example, if you have the sequence "h a t" and you
        // type "h e a r t" it does not match.  in this case the "e" will
        // cause the sequence to reset
        //
        // modifier keys are ignored because you can have a sequence
        // that contains modifiers such as "enter ctrl+space" and in most
        // cases the modifier key will be pressed before the next key
        //
        // also if you have a sequence such as "ctrl+b a" then pressing the
        // "b" key will trigger a "keypress" and a "keydown"
        //
        // the "keydown" is expected when there is a modifier, but the
        // "keypress" ends up matching the _nextExpectedAction since it occurs
        // after and that causes the sequence to reset
        //
        // we ignore keypresses in a sequence that directly follow a keydown
        // for the same character


        var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;

        if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
          _resetSequences(doNotReset);
        }

        _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
      };
      /**
       * handles a keydown event
       *
       * @param {Event} e
       * @returns void
       */


      function _handleKeyEvent(e) {
        // normalize e.which for key events
        // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
        if (typeof e.which !== 'number') {
          e.which = e.keyCode;
        }

        var character = _characterFromEvent(e); // no character found then stop


        if (!character) {
          return;
        } // need to use === for the character check because the character can be 0


        if (e.type == 'keyup' && _ignoreNextKeyup === character) {
          _ignoreNextKeyup = false;
          return;
        }

        self.handleKey(character, _eventModifiers(e), e);
      }
      /**
       * called to set a 1 second timeout on the specified sequence
       *
       * this is so after each key press in the sequence you have 1 second
       * to press the next key before you have to start over
       *
       * @returns void
       */


      function _resetSequenceTimer() {
        clearTimeout(_resetTimer);
        _resetTimer = setTimeout(_resetSequences, 1000);
      }
      /**
       * binds a key sequence to an event
       *
       * @param {string} combo - combo specified in bind call
       * @param {Array} keys
       * @param {Function} callback
       * @param {string=} action
       * @returns void
       */


      function _bindSequence(combo, keys, callback, action) {
        // start off by adding a sequence level record for this combination
        // and setting the level to 0
        _sequenceLevels[combo] = 0;
        /**
         * callback to increase the sequence level for this sequence and reset
         * all other sequences that were active
         *
         * @param {string} nextAction
         * @returns {Function}
         */

        function _increaseSequence(nextAction) {
          return function () {
            _nextExpectedAction = nextAction;
            ++_sequenceLevels[combo];

            _resetSequenceTimer();
          };
        }
        /**
         * wraps the specified callback inside of another function in order
         * to reset all sequence counters as soon as this sequence is done
         *
         * @param {Event} e
         * @returns void
         */


        function _callbackAndReset(e) {
          _fireCallback(callback, e, combo); // we should ignore the next key up if the action is key down
          // or keypress.  this is so if you finish a sequence and
          // release the key the final key will not trigger a keyup


          if (action !== 'keyup') {
            _ignoreNextKeyup = _characterFromEvent(e);
          } // weird race condition if a sequence ends with the key
          // another sequence begins with


          setTimeout(_resetSequences, 10);
        } // loop through keys one at a time and bind the appropriate callback
        // function.  for any key leading up to the final one it should
        // increase the sequence. after the final, it should reset all sequences
        //
        // if an action is specified in the original bind call then that will
        // be used throughout.  otherwise we will pass the action that the
        // next key in the sequence should match.  this allows a sequence
        // to mix and match keypress and keydown events depending on which
        // ones are better suited to the key provided


        for (var i = 0; i < keys.length; ++i) {
          var isFinal = i + 1 === keys.length;
          var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);

          _bindSingle(keys[i], wrappedCallback, action, combo, i);
        }
      }
      /**
       * binds a single keyboard combination
       *
       * @param {string} combination
       * @param {Function} callback
       * @param {string=} action
       * @param {string=} sequenceName - name of sequence if part of sequence
       * @param {number=} level - what part of the sequence the command is
       * @returns void
       */


      function _bindSingle(combination, callback, action, sequenceName, level) {
        // store a direct mapped reference for use with Mousetrap.trigger
        self._directMap[combination + ':' + action] = callback; // make sure multiple spaces in a row become a single space

        combination = combination.replace(/\s+/g, ' ');
        var sequence = combination.split(' ');
        var info; // if this pattern is a sequence of keys then run through this method
        // to reprocess each pattern one key at a time

        if (sequence.length > 1) {
          _bindSequence(combination, sequence, callback, action);

          return;
        }

        info = _getKeyInfo(combination, action); // make sure to initialize array if this is the first time
        // a callback is added for this key

        self._callbacks[info.key] = self._callbacks[info.key] || []; // remove an existing match if there is one

        _getMatches(info.key, info.modifiers, {
          type: info.action
        }, sequenceName, combination, level); // add this call back to the array
        // if it is a sequence put it at the beginning
        // if not put it at the end
        //
        // this is important because the way these are processed expects
        // the sequence ones to come first


        self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
          callback: callback,
          modifiers: info.modifiers,
          action: info.action,
          seq: sequenceName,
          level: level,
          combo: combination
        });
      }
      /**
       * binds multiple combinations to the same callback
       *
       * @param {Array} combinations
       * @param {Function} callback
       * @param {string|undefined} action
       * @returns void
       */


      self._bindMultiple = function (combinations, callback, action) {
        for (var i = 0; i < combinations.length; ++i) {
          _bindSingle(combinations[i], callback, action);
        }
      }; // start!


      _addEvent(targetElement, 'keypress', _handleKeyEvent);

      _addEvent(targetElement, 'keydown', _handleKeyEvent);

      _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */


    Mousetrap.prototype.bind = function (keys, callback, action) {
      var self = this;
      keys = keys instanceof Array ? keys : [keys];

      self._bindMultiple.call(self, keys, callback, action);

      return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */


    Mousetrap.prototype.unbind = function (keys, action) {
      var self = this;
      return self.bind.call(self, keys, function () {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */


    Mousetrap.prototype.trigger = function (keys, action) {
      var self = this;

      if (self._directMap[keys + ':' + action]) {
        self._directMap[keys + ':' + action]({}, keys);
      }

      return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */


    Mousetrap.prototype.reset = function () {
      var self = this;
      self._callbacks = {};
      self._directMap = {};
      return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */


    Mousetrap.prototype.stopCallback = function (e, element) {
      var self = this; // if the element has the class "mousetrap" then no need to stop

      if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
        return false;
      }

      if (_belongsTo(element, self.target)) {
        return false;
      } // stop for input, select, and textarea


      return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */


    Mousetrap.prototype.handleKey = function () {
      var self = this;
      return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */


    Mousetrap.addKeycodes = function (object) {
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          _MAP[key] = object[key];
        }
      }

      _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */


    Mousetrap.init = function () {
      var documentMousetrap = Mousetrap(document);

      for (var method in documentMousetrap) {
        if (method.charAt(0) !== '_') {
          Mousetrap[method] = function (method) {
            return function () {
              return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
          }(method);
        }
      }
    };

    Mousetrap.init(); // expose mousetrap to the global object

    window.Mousetrap = Mousetrap; // expose as a common js module

    if (module.exports) {
      module.exports = Mousetrap;
    } // expose mousetrap as an AMD module


    if (typeof undefined === 'function' && undefined.amd) {
      undefined(function () {
        return Mousetrap;
      });
    }
  })(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);
});

var ActionHistory$2 = function (_React$Component) {
  inherits(ActionHistory, _React$Component);

  function ActionHistory(props) {
    classCallCheck(this, ActionHistory);

    var _this = possibleConstructorReturn(this, (ActionHistory.__proto__ || Object.getPrototypeOf(ActionHistory)).call(this, props));

    _this.undo = _this.undo.bind(_this);
    _this.redo = _this.redo.bind(_this);
    return _this;
  }

  createClass(ActionHistory, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      mousetrap.bind(["command+z", "ctrl+z"], this.undo);
      mousetrap.bind(["command+y", "ctrl+y", "command+shift+z", "ctrl+shift+z"], this.redo);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      mousetrap.unbind(["command+z", "ctrl+z"]);
      mousetrap.unbind(["command+y", "ctrl+y", "command+shift+z", "ctrl+shift+z"]);
    }
  }, {
    key: "undo",
    value: function undo(event) {
      event.preventDefault();
      this.props.undo();
    }
  }, {
    key: "redo",
    value: function redo(event) {
      event.preventDefault();
      this.props.redo();
    }
  }, {
    key: "render",
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return ActionHistory;
}(React.Component);

var ActionHistoryContainer = connect(null, {
  undo: lib_8$1.undo,
  redo: lib_8$1.redo
})(ActionHistory$2);

var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH$2 =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');

var undef = function undef(v) {
  return v === null || v === undefined;
};

var notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};

var func = function func(f) {
  return typeof f === 'function';
};

var string = function string(s) {
  return typeof s === 'string';
};

var array = Array.isArray;

var object = function object(obj) {
  return obj && !array(obj) && typeof obj === 'object';
};

var promise = function promise(p) {
  return p && func(p.then);
};

var iterator$3 = function iterator(it) {
  return it && func(it.next) && func(it.throw);
};

var task$1 = function task(t) {
  return t && t[TASK];
};

var buffer = function buffer(buf) {
  return buf && func(buf.isEmpty) && func(buf.take) && func(buf.put);
};

var pattern = function pattern(pat) {
  return pat && (string(pat) || symbol$3(pat) || func(pat) || array(pat) && pat.every(pattern));
};

var channel$1 = function channel(ch) {
  return ch && func(ch.take) && func(ch.close);
};

var stringableFunc = function stringableFunc(f) {
  return func(f) && f.hasOwnProperty('toString');
};

var symbol$3 = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};

var multicast = function multicast(ch) {
  return channel$1(ch) && ch[MULTICAST];
};

function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, ms, val);
  });

  promise[CANCEL] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

var konst = function konst(v) {
  return function () {
    return v;
  };
};

var kTrue =
/*#__PURE__*/
konst(true);

var noop$5 = function noop() {};

var identity$1 = function identity(v) {
  return v;
};

var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';

function check$3(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}

var assignWithSymbols = function assignWithSymbols(target, source) {
  _extends(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};

var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};

function remove(array$$1, item) {
  var index = array$$1.indexOf(item);

  if (index >= 0) {
    array$$1.splice(index, 1);
  }
}

function once$1(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}

function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;
  /*eslint-disable no-console*/

  console.error(error);
  console.error(sagaStack);
}

var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};

var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (process.env.NODE_ENV !== 'production') {
      check$3(action, function (ac) {
        return !Object.isFrozen(ac);
      }, FROZEN_ACTION_ERROR);
    }

    return dispatch(Object.defineProperty(action, SAGA_ACTION, {
      value: true
    }));
  };
};

var shouldTerminate = function shouldTerminate(res) {
  return res === TERMINATE;
};

var shouldCancel = function shouldCancel(res) {
  return res === TASK_CANCEL;
};

var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};

function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (process.env.NODE_ENV !== 'production') {
    check$3(totalCount, function (c) {
      return c > 0;
    }, 'createAllStyleChildCallbacks: get an empty array or object');
  }

  var completedCount = 0;
  var completed;
  var results = array(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = noop$5;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}

function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}

function getLocation(instrumented) {
  return instrumented[SAGA_LOCATION];
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: kTrue,
  put: noop$5,
  take: noop$5
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var none = function none() {
  return zeroBuffer;
};

var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};

var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};

var sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};

var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var buffers =
/*#__PURE__*/
Object.freeze({
  none: none,
  fixed: fixed,
  dropping: dropping,
  sliding: sliding,
  expanding: expanding
});
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL$1 = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';
var effectTypes =
/*#__PURE__*/
Object.freeze({
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: CANCEL$1,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});
var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};

function take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (process.env.NODE_ENV !== 'production' && arguments.length) {
    check$3(arguments[0], notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }

  if (pattern(patternOrChannel)) {
    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if (multicast(patternOrChannel) && notUndef(multicastPattern) && pattern(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if (channel$1(patternOrChannel)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  throw new Error("take(patternOrChannel): argument " + patternOrChannel + " is not valid channel or a valid pattern");
}

function put(channel$$1, action) {
  if (process.env.NODE_ENV !== 'production') {
    if (arguments.length > 1) {
      check$3(channel$$1, notUndef, 'put(channel, action): argument channel is undefined');
      check$3(channel$$1, channel$1, "put(channel, action): argument " + channel$$1 + " is not a valid channel");
      check$3(action, notUndef, 'put(channel, action): argument action is undefined');
    } else {
      check$3(channel$$1, notUndef, 'put(action): argument action is undefined');
    }
  }

  if (undef(action)) {
    action = channel$$1; // `undefined` instead of `null` to make default parameter work

    channel$$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$$1,
    action: action
  });
}

function all(effects) {
  var eff = makeEffect(ALL, effects);
  eff.combinator = true;
  return eff;
}

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  check$3(fnDescriptor, notUndef, effectName + ": argument fn is undefined or null");

  if (func(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (array(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    check$3(fn, notUndef, effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (object(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    check$3(fn, notUndef, effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    check$3(fnDescriptor, func, effectName + ": argument fn is not function");
    return;
  }

  if (context && string(fn)) {
    check$3(context[fn], func, effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  check$3(fn, func, effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if (func(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if (array(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && string(fn) && func(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== delay;
};

function call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (process.env.NODE_ENV !== 'production') {
    check$3(fnDescriptor, isNotDelayEffect, "instead of writing `yield call(delay, " + args[0] + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + args[0] + ")`");
    validateFnDescriptor('call', fnDescriptor);
  }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}

function fork$1(fnDescriptor) {
  if (process.env.NODE_ENV !== 'production') {
    validateFnDescriptor('fork', fnDescriptor);
  }

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}

function cancel(taskOrTasks) {
  if (taskOrTasks === void 0) {
    taskOrTasks = SELF_CANCELLATION;
  }

  if (process.env.NODE_ENV !== 'production') {
    if (arguments.length > 1) {
      throw new Error('cancel(...tasks) is not supported any more. Please use cancel([...tasks]) to cancel multiple tasks.');
    }

    if (array(taskOrTasks)) {
      taskOrTasks.forEach(function (t) {
        check$3(t, task$1, "cancel([...tasks]): argument " + t + " is not a valid Task object " + TEST_HINT);
      });
    } else if (taskOrTasks !== SELF_CANCELLATION && notUndef(taskOrTasks)) {
      check$3(taskOrTasks, task$1, "cancel(task): argument " + taskOrTasks + " is not a valid Task object " + TEST_HINT);
    }
  }

  return makeEffect(CANCEL$1, taskOrTasks);
}

function select(selector) {
  if (selector === void 0) {
    selector = identity$1;
  }

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (process.env.NODE_ENV !== 'production' && arguments.length) {
    check$3(arguments[0], notUndef, 'select(selector, [...]): argument selector is undefined');
    check$3(selector, func, "select(selector, [...]): argument " + selector + " is not a function");
  }

  return makeEffect(SELECT, {
    selector: selector,
    args: args
  });
}

var delay =
/*#__PURE__*/
call.bind(null, delayP);

function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}

var queue$3 = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release$1();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap$1(task) {
  queue$3.push(task);

  if (!semaphore) {
    suspend();
    flush$2();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */


function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    flush$2();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/


function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release$1() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function flush$2() {
  release$1();
  var task;

  while (!semaphore && (task = queue$3.shift()) !== undefined) {
    exec(task);
  }
}

var array$1 = function array$$1(patterns) {
  return function (input) {
    return patterns.some(function (p$$1) {
      return matcher(p$$1)(input);
    });
  };
};

var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};

var string$1 = function string$$1(pattern$$1) {
  return function (input) {
    return input.type === String(pattern$$1);
  };
};

var symbol$1$1 = function symbol$$1(pattern$$1) {
  return function (input) {
    return input.type === pattern$$1;
  };
};

var wildcard = function wildcard() {
  return kTrue;
};

function matcher(pattern$$1) {
  // prettier-ignore
  var matcherCreator = pattern$$1 === '*' ? wildcard : string(pattern$$1) ? string$1 : array(pattern$$1) ? array$1 : stringableFunc(pattern$$1) ? string$1 : func(pattern$$1) ? predicate : symbol$3(pattern$$1) ? symbol$1$1 : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern$$1);
  }

  return matcherCreator(pattern$$1);
}

var END = {
  type: CHANNEL_END_TYPE
};

var isEnd = function isEnd(a$$1) {
  return a$$1 && a$$1.type === CHANNEL_END_TYPE;
};

var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";

function channel$1$1(buffer$$1) {
  if (buffer$$1 === void 0) {
    buffer$$1 = expanding();
  }

  var closed = false;
  var takers = [];

  if (process.env.NODE_ENV !== 'production') {
    check$3(buffer$$1, buffer, INVALID_BUFFER);
  }

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$$1.isEmpty()) {
      throw internalErr('Cannot have pending takers with non empty buffer');
    }
  }

  function put$$1(input) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check$3(input, notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take$$1(cb) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check$3(cb, func, "channel.take's callback must be a function");
    }

    if (closed && buffer$$1.isEmpty()) {
      cb(END);
    } else if (!buffer$$1.isEmpty()) {
      cb(buffer$$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        remove(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check$3(cb, func, "channel.flush' callback must be a function");
    }

    if (closed && buffer$$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$$1.flush());
  }

  function close() {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
    }

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i$$1 = 0, len = arr.length; i$$1 < len; i$$1++) {
      var taker = arr[i$$1];
      taker(END);
    }
  }

  return {
    take: take$$1,
    put: put$$1,
    flush: flush,
    close: close
  };
}

function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
    }

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[MULTICAST] = true, _ref.put = function put$$1(input) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check$3(input, notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i$$1 = 0, len = takers.length; i$$1 < len; i$$1++) {
      var taker = takers[i$$1];

      if (taker[MATCH$2](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take$$1(cb, matcher$$1) {
    if (matcher$$1 === void 0) {
      matcher$$1 = wildcard;
    }

    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
    }

    if (closed) {
      cb(END);
      return;
    }

    cb[MATCH$2] = matcher$$1;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = once$1(function () {
      ensureCanMutateNextTakers();
      remove(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}

function stdChannel() {
  var chan = multicastChannel();
  var put$$1 = chan.put;

  chan.put = function (input) {
    if (input[SAGA_ACTION]) {
      put$$1(input);
      return;
    }

    asap$1(function () {
      put$$1(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var CANCELLED$1 = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise$$1, cb) {
  var cancelPromise = promise$$1[CANCEL];

  if (func(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise$$1.then(cb, function (error) {
    cb(error, true);
  });
}

var current = 0;

var nextEffectId = function nextEffectId() {
  return ++current;
};

var _effectRunnerMap;

function getIteratorMetaInfo(iterator$$1, fn) {
  if (iterator$$1.isSagaIterator) {
    return {
      name: iterator$$1.meta.name
    };
  }

  return getMetaInfo(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args; // catch synchronous failures; see #152 and #441

  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if (iterator$3(result)) {
      return result;
    }

    var next = function next(value) {
      if (value === void 0) {
        value = result;
      }

      return {
        value: value,
        done: !promise(value)
      };
    };

    return makeIterator(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return makeIterator(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel$$1 = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;
  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/

  asap$1(function () {
    var result;

    try {
      result = (channel$$1 ? channel$$1.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && promise(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel$$1 = _ref3$channel === void 0 ? env.channel : _ref3$channel,
      pattern$$1 = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(TERMINATE);
      return;
    }

    cb(input);
  };

  try {
    channel$$1.take(takeCb, notUndef(pattern$$1) ? matcher(pattern$$1) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task; // catch synchronous failures; see #152

  try {
    var result = fn.apply(context, args);

    if (promise(result)) {
      resolvePromise(result, cb);
      return;
    }

    if (iterator$3(result)) {
      // resolve iterator
      proc(env, result, task.context, current, getMetaInfo(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args; // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152

  try {
    var cpsCb = function cpsCb(err, res) {
      if (undef(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, current, meta, detached, noop$5);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        remove(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if (array(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = createAllStyleChildCallbacks(taskOrTasks, cb);
    taskOrTasks.forEach(function (t$$1, i$$1) {
      joinSingleTask(t$$1, childCallbacks[i$$1]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === SELF_CANCELLATION) {
    cancelSingleTask(task);
  } else if (array(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb(array(effects) ? [] : {});
    return;
  }

  var childCallbacks = createAllStyleChildCallbacks(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);
  var response = array(effects) ? createEmptyArray(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = noop$5;
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern$$1 = _ref14.pattern,
      buffer$$1 = _ref14.buffer;
  var chan = channel$1$1(buffer$$1);
  var match = matcher(pattern$$1);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel$$1, cb) {
  channel$$1.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  assignWithSymbols(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[TAKE] = runTakeEffect, _effectRunnerMap[PUT] = runPutEffect, _effectRunnerMap[ALL] = runAllEffect, _effectRunnerMap[RACE] = runRaceEffect, _effectRunnerMap[CALL] = runCallEffect, _effectRunnerMap[CPS] = runCPSEffect, _effectRunnerMap[FORK] = runForkEffect, _effectRunnerMap[JOIN] = runJoinEffect, _effectRunnerMap[CANCEL$1] = runCancelEffect, _effectRunnerMap[SELECT] = runSelectEffect, _effectRunnerMap[ACTION_CHANNEL] = runChannelEffect, _effectRunnerMap[CANCELLED] = runCancelledEffect, _effectRunnerMap[FLUSH] = runFlushEffect, _effectRunnerMap[GET_CONTEXT] = runGetContextEffect, _effectRunnerMap[SET_CONTEXT] = runSetContextEffect, _effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      remove(tasks, task);
      task.cont = noop$5;

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t$$1) {
      t$$1.cont = noop$5;
      t$$1.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
} // there can be only a single saga error created at any given moment


function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect$$1) {
  var location = getLocation(effect$$1);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = flatMap(function (i$$1) {
    return i$$1.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];

var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};

var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now


var setCrashedEffect = function setCrashedEffect(effect$$1) {
  crashedEffect = effect$$1;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/


var toString$8 = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s$$1) {
    return "    created by " + sagaLocationAsString(s$$1.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t$$1) {
      return t$$1.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel$$1() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = CANCELLED$1;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(TASK_CANCEL, false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === TASK_CANCEL) {
        status = CANCELLED$1;
      } else if (status !== CANCELLED$1) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = toString$8(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext$$1(props) {
    if (process.env.NODE_ENV !== 'production') {
      check$3(props, object, createSetContextWarning('task', props));
    }

    assignWithSymbols(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = deferred();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel$$1, _task.cont = cont, _task.end = end, _task.setContext = setContext$$1, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === CANCELLED$1 || status === RUNNING && mainTask.status === CANCELLED$1;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (process.env.NODE_ENV !== 'production' && iterator$$1[asyncIteratorSymbol]) {
    throw new Error("redux-saga doesn't support async generators, please use only regular ones");
  }

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = noop$5;
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
    /**
     Creates a new task descriptor for this generator.
     A task is the aggregation of it's mainTask and all it's forked tasks.
     **/

  };
  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
    /**
      cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
    **/

  };

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = CANCELLED$1;
      next(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  cont.cancel = task.cancel; // kicks up the generator

  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if (shouldCancel(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = CANCELLED$1;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = func(iterator$$1.return) ? iterator$$1.return(TASK_CANCEL) : {
          done: true,
          value: TASK_CANCEL
        };
      } else if (shouldTerminate(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = func(iterator$$1.return) ? iterator$$1.return() : {
          done: true
        };
      } else {
        result = iterator$$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== CANCELLED$1) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === CANCELLED$1) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect$$1, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if (promise(effect$$1)) {
      resolvePromise(effect$$1, currCb);
    } else if (iterator$3(effect$$1)) {
      // resolve iterator
      proc(env, effect$$1, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect$$1 && effect$$1[IO]) {
      var effectRunner = effectRunnerMap[effect$$1.type];
      effectRunner(env, effect$$1.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect$$1);
    }
  }

  function digestEffect(effect$$1, parentEffectId, cb, label) {
    if (label === void 0) {
      label = '';
    }

    var effectId = nextEffectId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect$$1
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = noop$5; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect$$1);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = noop$5; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = noop$5; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect$$1, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";

function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel$$1 = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? logError : _ref$onError;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (process.env.NODE_ENV !== 'production') {
    check$3(saga, func, NON_GENERATOR_ERR);
  }

  var iterator$$1 = saga.apply(void 0, args);

  if (process.env.NODE_ENV !== 'production') {
    check$3(iterator$$1, iterator$3, NON_GENERATOR_ERR);
  }

  var effectId = nextEffectId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || noop$5;
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || noop$5;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || noop$5;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || noop$5;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || noop$5;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || noop$5;
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    if (notUndef(dispatch)) {
      check$3(dispatch, func, 'dispatch must be a function');
    }

    if (notUndef(getState)) {
      check$3(getState, func, 'getState must be a function');
    }

    if (notUndef(effectMiddlewares)) {
      var MIDDLEWARE_TYPE_ERROR = 'effectMiddlewares must be an array of functions';
      check$3(effectMiddlewares, array, MIDDLEWARE_TYPE_ERROR);
      effectMiddlewares.forEach(function (effectMiddleware) {
        return check$3(effectMiddleware, func, MIDDLEWARE_TYPE_ERROR);
      });
    }

    check$3(onError, func, 'onError passed to the redux-saga is not a function!');
  }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = compose.apply(void 0, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect$$1, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect$$1);
      };
    };
  } else {
    finalizeRunEffect = identity$1;
  }

  var env = {
    channel: channel$$1,
    dispatch: wrapSagaDispatch(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$$1, context, effectId, getMetaInfo(saga),
    /* isRoot */
    true, noop$5);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? {} : _ref2$context,
      _ref2$channel = _ref2.channel,
      channel$$1 = _ref2$channel === void 0 ? stdChannel() : _ref2$channel,
      sagaMonitor = _ref2.sagaMonitor,
      options = _objectWithoutPropertiesLoose(_ref2, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (process.env.NODE_ENV !== 'production') {
    check$3(channel$$1, channel$1, 'options.channel passed to the Saga middleware is not a channel');
  }

  function sagaMiddleware(_ref3) {
    var getState = _ref3.getState,
        dispatch = _ref3.dispatch;
    boundRunSaga = runSaga.bind(null, _extends({}, options, {
      context: context,
      channel: channel$$1,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel$$1.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (process.env.NODE_ENV !== 'production' && !boundRunSaga) {
      throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    }

    return boundRunSaga.apply(void 0, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (process.env.NODE_ENV !== 'production') {
      check$3(props, object, createSetContextWarning('sagaMiddleware', props));
    }

    assignWithSymbols(context, props);
  };

  return sagaMiddleware;
}

function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

function middlewareFactory(errorHandler) {
  return function (store) {
    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          errorHandler(err, store.getState, action, store.dispatch);
          return err;
        }
      };
    };
  };
}

var reduxCatch = middlewareFactory;

var errorHandler = function errorHandler(error, getState, lastAction, dispatch) {
  if (process.env.NODE_ENV !== "production") throw error;
  var errorObject = {
    type: "action",
    error: error,
    state: getState(),
    lastAction: lastAction
  };
  var action = setError(errorObject);
  dispatch(action);
}; // The actual reducer logic for the ORM state lives in the Models' code.


var reducer = lib_2$2(orm); // TODO: Set an action history length limit

var orm$1 = undoable(reducer, {
  groupBy: function groupBy(a) {
    return groupedTypes.includes(a);
  },
  filter: lib_6$1(excludedTypes)
});
var initialState = {
  expandQuestions: false,
  templateActive: false,
  error: false,
  outlineHeader: {
    section: null,
    group: null
  },
  savePending: false,
  saveError: false,
  lastSave: undefined,
  modal: {
    modalType: null,
    modalProps: null
  },
  outlineOverlay: false,
  readOnly: false
};

var ui = function ui() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case interfaceTypes.INTERFACE_TOGGLE_TEMPLATE:
      return _extends$c({}, state, {
        templateActive: !state.templateActive
      });

    case interfaceTypes.INTERFACE_TOGGLE_EXPAND_QUESTIONS:
      return _extends$c({}, state, {
        expandQuestions: !state.expandQuestions
      });

    case interfaceTypes.INTERFACE_TOGGLE_OUTLINE_OVERLAY:
      return _extends$c({}, state, {
        outlineOverlay: !state.outlineOverlay
      });

    case interfaceTypes.INTERFACE_SET_OUTLINE_HEADER:
      return _extends$c({}, state, {
        outlineHeader: _extends$c({}, state.outlineHeader, action.payload)
      });

    case interfaceTypes.INTERFACE_SET_ERROR:
      return _extends$c({}, state, {
        error: action.payload
      });

    case interfaceTypes.INTERFACE_TOGGLE_READ_ONLY:
      return _extends$c({}, state, {
        readOnly: !state.readOnly
      });

    case autosaveTypes.AUTOSAVE_REQUEST:
      return _extends$c({}, state, {
        savePending: true
      });

    case autosaveTypes.AUTOSAVE_SUCCESS:
      return _extends$c({}, state, {
        savePending: false,
        saveError: false,
        lastSave: action.payload
      });

    case autosaveTypes.AUTOSAVE_ERROR:
      return _extends$c({}, state, {
        savePending: false,
        saveError: true
      });

    case modalTypes.MODAL_SHOW:
      return _extends$c({}, state, {
        modal: {
          modalType: action.payload.modalType,
          modalProps: action.payload.modalProps
        }
      });

    case modalTypes.MODAL_CLOSE:
      return _extends$c({}, state, {
        modal: {
          modalType: null,
          modalProps: null
        }
      });

    default:
      return state;
  }
};

var rootReducer = combineReducers({
  orm: orm$1,
  ui: ui
});

var normalizePipe = function normalizePipe(data, endQuestionId, session) {
  var placeholder = data.placeholder,
      selected = data.selected,
      question = data.question;
  var questionId = parseInt(question, 10);
  var args = {
    endQuestion: session.Question.withId(endQuestionId),
    sourceQuestion: session.Question.withId(questionId),
    placeholder: placeholder,
    selected: selected
  };
  return session.Pipe.create(args);
};

var normalizeImage = function normalizeImage(data, model) {
  if (data.image) {
    model.set("imageFilename", data.image.filename);
    model.set("imageUrl", data.image.url);
  }
};

var normalizeAnswerContent = function normalizeAnswerContent(data, session) {
  var key = data.key,
      rest = objectWithoutProperties(data, ["key"]);
  var id = parseInt(key, 10);
  var model = session.AnswerContent.create(_extends$c({
    id: id
  }, rest));
  normalizeImage(data, model);
  model.set("defaultContent", false);
  model.set("lastNonEmptyContent", data.content);
  return model;
};

var normalizeSpecialOption = function normalizeSpecialOption(data) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var session = arguments[2];

  var attrs = function () {
    var type = data.type,
        text = data.text;

    var base = _extends$c({
      type: type,
      text: text
    }, props);

    if (data.open_answer) {
      var _data$open_answer = data.open_answer,
          require = _data$open_answer.require,
          _text = _data$open_answer.text;
      return _extends$c({}, base, {
        openAnswerRequired: require,
        openAnswerText: _text
      });
    }

    return base;
  }();

  return session.SpecialOption.create(attrs);
};

var normalizeDiscrete = function normalizeDiscrete(attrs) {
  return {
    sortType: attrs.sort_type,
    require: attrs.require
  };
};

var normalizeAnswerContents = function normalizeAnswerContents(denormalizedContents) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var session = arguments[2];
  denormalizedContents.forEach(function (content) {
    return normalizeAnswerContent(_extends$c({}, content, props), session);
  });
};

var normalizeSpecialOptions = function normalizeSpecialOptions(denormalizedSpecialOptions) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var session = arguments[2];
  denormalizedSpecialOptions.forEach(function (option) {
    return normalizeSpecialOption(option, props, session);
  });
};

var normalizeSingleSelect = function normalizeSingleSelect(data, session) {
  var model = session.SingleSelect.create(normalizeDiscrete(data));
  normalizeAnswerContents(data.answer.rows, {
    singleSelect: model
  }, session);
  if (data.special_options) normalizeSpecialOptions(data.special_options, {
    singleSelect: model
  }, session);
  return model;
};

var normalizeLongText = function normalizeLongText(data, session) {
  var min = data.min,
      max = data.max,
      require = data.require;
  var model = session.LongText.create({
    min: min,
    max: max,
    require: require
  });
  return model;
};

var normalizeShortText = function normalizeShortText(data, session) {
  var min = data.min,
      max = data.max,
      require = data.require;
  var model = session.ShortText.create({
    min: min,
    max: max,
    require: require
  });
  return model;
};

var normalizeSum = function normalizeSum(data, session) {
  var sumAttrs = data.equals === undefined ? {
    validatesSum: false
  } : {
    validatesSum: true,
    targetSum: data.equals
  };

  var attrs = _extends$c({}, normalizeDiscrete(data), sumAttrs);

  var model = session.Sum.create(attrs);
  normalizeAnswerContents(data.answer.rows, {
    sum: model
  }, session);
  return model;
};

var normalizeMultipleRating = function normalizeMultipleRating(data, session) {
  var attrs = _extends$c({}, normalizeDiscrete(data), {
    steps: data.num_columns
  });

  var model = session.MultipleRating.create(attrs);
  normalizeAnswerContents(data.answer.rows, {
    multipleRating: model
  }, session);
  return model;
};

var normalizeSlider = function normalizeSlider(data, session) {
  var require = data.require,
      min = data.min,
      max = data.max,
      increment = data.increment;
  return session.Slider.create({
    require: require,
    min: min,
    max: max,
    increment: increment
  });
};

var normalizeMessage = function normalizeMessage(data, session) {
  return session.Message.create();
};

var normalizeMultipleSlider = function normalizeMultipleSlider(data, session) {
  var attrs = _extends$c({}, normalizeDiscrete(data), {
    min: data.min,
    max: data.max,
    increment: data.increment
  });

  var model = session.MultipleSlider.create(attrs);
  normalizeAnswerContents(data.answer.rows, {
    multipleSlider: model
  }, session);
  return model;
};

var normalizeRanking = function normalizeRanking(data, session) {
  var attrs = normalizeDiscrete(data);
  var model = session.Ranking.create(attrs);
  normalizeAnswerContents(data.answer.rows, {
    rankOrder: model
  }, session);
  return model;
};

var normalizeNumeric = function normalizeNumeric(data, session) {
  var require = data.require,
      min = data.min,
      max = data.max;
  return session.Numeric.create({
    require: require,
    min: min,
    max: max
  });
};

var normalizeRating = function normalizeRating(data, session) {
  var model = session.Rating.create({
    steps: data.num_columns,
    require: data.require
  });
  return model;
};

var normalizeMultipleSelect = function normalizeMultipleSelect(data, session) {
  var attrs = _extends$c({}, normalizeDiscrete(data), {
    min: data.min,
    max: data.max
  });

  var model = session.MultipleSelect.create(attrs);
  normalizeAnswerContents(data.answer.rows, {
    multipleSelect: model
  }, session);
  if (data.special_options) normalizeSpecialOptions(data.special_options, {
    multipleSelect: model
  }, session);
  return model;
};

var normalizeDropdown = function normalizeDropdown(data, session) {
  var model = session.Dropdown.create(normalizeDiscrete(data));
  normalizeAnswerContents(data.answer.rows, {
    dropdown: model
  }, session);
  if (data.special_options) normalizeSpecialOptions(data.special_options, {
    dropdown: model
  }, session);
  return model;
};

var normalizeMultipleSelectGrid = function normalizeMultipleSelectGrid(data, session) {
  var attrs = normalizeDiscrete(data);
  var model = session.MultipleSelectGrid.create(attrs);
  normalizeAnswerContents(data.answer.rows, {
    multipleSelectGridRow: model
  }, session);
  normalizeAnswerContents(data.answer.columns, {
    multipleSelectGridColumn: model
  }, session);
  return model;
};

var normalizeSingleSelectGrid = function normalizeSingleSelectGrid(data, session) {
  var attrs = normalizeDiscrete(data);
  var model = session.SingleSelectGrid.create(attrs);
  normalizeAnswerContents(data.answer.rows, {
    singleSelectGridRow: model
  }, session);
  normalizeAnswerContents(data.answer.columns, {
    singleSelectGridColumn: model
  }, session);
  return model;
};

var normalizeQuestionBase = function normalizeQuestionBase(question, session) {
  var content = question.content,
      sequence = question.sequence,
      anchor = question.anchor,
      key = question.key;
  var type = question.type || undefined;
  var description = question.description ? {
    description: question.description,
    hasDescription: true
  } : {
    hasDescription: false
  };
  var draftContent = Draft_3.createFromText(content);
  var draftRawContent = Draft_2(draftContent);
  var draftSelectionState = Draft_5.createEmpty(draftContent.getFirstBlock().getKey());
  var id = parseInt(key, 10);
  var model = session.Question.create(_extends$c({}, description, {
    id: id,
    content: content,
    sequence: sequence,
    anchor: anchor,
    draftRawContent: draftRawContent,
    draftSelectionState: draftSelectionState
  }));
  model.set("type", type);

  if (question.pipe) {
    normalizePipe(question.pipe, id, session);
  }

  return model;
};

var questionTypeMap = {
  dropdown: normalizeDropdown,
  long_text_input: normalizeLongText,
  descriptive: normalizeMessage,
  multiple_rating: normalizeMultipleRating,
  multiple_select_matrix: normalizeMultipleSelectGrid,
  multiple_select: normalizeMultipleSelect,
  multiple_slider: normalizeMultipleSlider,
  numeric: normalizeNumeric,
  rank_order: normalizeRanking,
  rating: normalizeRating,
  short_text_input: normalizeShortText,
  single_select_matrix: normalizeSingleSelectGrid,
  single_select: normalizeSingleSelect,
  slider: normalizeSlider,
  sum: normalizeSum
};

var normalizeMedia = function normalizeMedia(data, model) {
  if (data.media) {
    model.set("hasMedia", true);

    if (data.media.image) {
      model.set("mediaType", "image");
      model.set("imageFilename", data.media.image.filename);
      model.set("imageUrl", data.media.image.url);
    }

    if (data.media.video) {
      model.set("mediaType", "video");
      model.set("videoUrl", data.media.video);
    }
  }
};

var normalizeQuestion = function normalizeQuestion(data, session) {
  var normalizeType = questionTypeMap[data.type];
  var model = normalizeQuestionBase(data, session);
  var typeModel = normalizeType(data, session);
  typeModel.set("question", model);
  normalizeMedia(data, model);
  return model;
};

var normalizeGridPair = function normalizeGridPair(string) {
  return string.split(":").map(function (id) {
    return parseInt(id, 10);
  });
};

var normalizeLogicCondition = function normalizeLogicCondition(data, session) {
  var page = data.page,
      question = data.question,
      answer = data.answer,
      rest = objectWithoutProperties(data, ["page", "question", "answer"]);
  var questionId = parseInt(question, 10);
  if (!session.Question.hasId(questionId)) return null;
  var model = session.LogicCondition.create(_extends$c({
    question: questionId
  }, rest));
  var questionModel = session.Question.withId(questionId);

  if (questionModel.singleSelect || questionModel.multipleSelect || questionModel.dropdown) {
    var value = data.value;

    if (value === "other" || value === "none") {
      var typeModel = questionModel.typeModel;
      var specials = typeModel.specialOptions.toModelArray();
      var specialId = specials.find(function (s) {
        return s.type === value;
      });
      model.set("specialOptionValue", specialId);
      model.set("value", undefined);
    } else {
      var discreteValue = parseInt(value, 10);
      model.set("value", discreteValue);
    }
  }

  if (questionModel.singleSelectGrid || questionModel.multipleSelectGrid) {
    var _value = data.value;

    var dict = _value.reduce(function (acc, pair) {
      var _normalizeGridPair = normalizeGridPair(pair),
          _normalizeGridPair2 = slicedToArray(_normalizeGridPair, 2),
          row = _normalizeGridPair2[0],
          column = _normalizeGridPair2[1];

      return {
        rows: acc.rows.set(row, true),
        columns: acc.columns.set(column, true)
      };
    }, {
      rows: new Map(),
      columns: new Map()
    });

    var rows = Array.from(dict.rows.keys());
    var columns = Array.from(dict.columns.keys());
    model.set("value", {
      rows: rows,
      columns: columns
    });
  }

  if (questionModel.numeric || questionModel.rating || questionModel.slider) {
    if (data.operator === "range") {
      var _value2 = data.value;

      var _value2$split$map = _value2.split(":").map(function (v) {
        return parseInt(v, 10);
      }),
          _value2$split$map2 = slicedToArray(_value2$split$map, 2),
          min = _value2$split$map2[0],
          max = _value2$split$map2[1];

      model.set("value", {
        min: min,
        max: max
      });
    }
  }

  if (questionModel.multipleRating || questionModel.multipleSlider || questionModel.rankOrder || questionModel.sum) {
    var answerId = parseInt(data.answer, 10);
    model.answer.add(answerId);

    if (data.operator === "range") {
      var _value3 = data.value;

      var _value3$split$map = _value3.split(":").map(function (v) {
        return parseInt(v, 10);
      }),
          _value3$split$map2 = slicedToArray(_value3$split$map, 2),
          _min = _value3$split$map2[0],
          _max = _value3$split$map2[1];

      model.set("value", {
        min: _min,
        max: _max
      });
    } else {
      model.set("value", data.value);
    }
  }

  return model;
};

var normalizeLogicBranch = function normalizeLogicBranch(data, session) {
  var model = session.LogicBranch.create();
  var conditions = data.conditions;
  conditions.forEach(function (condition) {
    var conditionModel = normalizeLogicCondition(condition, session);
    if (conditionModel !== null) model.conditions.add(conditionModel);
  });
  return model;
};

var normalizePage = function normalizePage(data, session, graph, after) {
  var sequence = data.sequence,
      sort_type = data.sort_type,
      content = data.content,
      anchor = data.anchor,
      key = data.key;
  var id = parseInt(key, 10);
  var model = createPage({
    id: id,
    graph: graph,
    sequence: sequence,
    sortType: sort_type,
    content: content,
    anchor: anchor,
    after: after
  }, session.Page, session);
  data.questions.forEach(function (questionData) {
    var questionModel = normalizeQuestion(questionData, session);
    questionModel.set("page", model);
  });

  if (data.logic && data.logic.display) {
    data.logic.display.forEach(function (b) {
      model.set("displayLogicBranch", normalizeLogicBranch(b, session));
    });
  }

  return model;
};

var normalizeSection = function normalizeSection(data, session, pages) {
  var title = data.title,
      sort_type = data.sort_type,
      key = data.key;
  var id = parseInt(key, 10);
  var model = createSection({
    id: id,
    content: title,
    sortType: sort_type,
    pages: pages
  }, session.Section, session);
  return model;
};

var normalizeGroup = function normalizeGroup(data, session, sections) {
  var title = data.title,
      sort_type = data.sort_type,
      color = data.color,
      key = data.key;
  var id = parseInt(key, 10);
  var model = createGroup({
    id: id,
    sections: sections,
    content: title,
    sortType: sort_type,
    color: color
  }, session.Group, session);
  return model;
};

var normalizeSkipLogicBranch = function normalizeSkipLogicBranch(data, session, pageId) {
  var model = normalizeLogicBranch(data, session);
  model.set("skipLogicPage", pageId);

  if (data.target !== "complete" && data.target !== "disqualify") {
    setTarget(session, model, parseInt(data.target, 10));
  } else {
    setTarget(session, model, data.target);
  }

  return model;
};

var getChildSlice = function getChildSlice(list, start, end) {
  var startIndex = list.findIndex(function (item) {
    return item.id === start;
  });
  var endIndex = list.findIndex(function (item) {
    return item.id === end;
  });
  return list.slice(startIndex, endIndex + 1);
};

var normalizeSurvey = function normalizeSurvey(data, session) {
  var graph = session.DagGraph.create({});
  var model = session.Survey.create({
    graph: graph
  });
  var pages = data.pages,
      sections = data.sections,
      groups = data.groups,
      display = data.display,
      preview_link = data.preview_link,
      rest = objectWithoutProperties(data, ["pages", "sections", "groups", "display", "preview_link"]);
  var pageModels = [];
  var skipBranches = pages.reduce(function (acc, p) {
    return p.logic && p.logic.skip ? _extends$c({}, acc, defineProperty$3({}, p.key, p.logic.skip)) : acc;
  }, {});
  pages.forEach(function (p, i) {
    var after = i === 0 ? undefined : pageModels[i - 1].node.id;
    var model = normalizePage(p, session, graph.id, after);
    pageModels.push(model);
  });
  var sectionModels = sections.map(function (s) {
    var pages = getChildSlice(pageModels, parseInt(s.start, 10), parseInt(s.end, 10));
    var pageIds = pages.map(function (p) {
      return p.id;
    });
    return normalizeSection(s, session, pageIds);
  });
  groups.forEach(function (g) {
    var sectionIds = getChildSlice(sectionModels, parseInt(g.start, 10), parseInt(g.end, 10)).map(function (s) {
      return s.id;
    });
    normalizeGroup(g, session, sectionIds);
  });
  Object.keys(skipBranches).forEach(function (pKey) {
    var pageBranches = skipBranches[pKey];
    pageBranches.forEach(function (pageBranch) {
      normalizeSkipLogicBranch(pageBranch, session, parseInt(pKey, 10));
    });
  });
  model.set("title", display);
  model.set("previewLink", preview_link);
  Object.keys(rest).forEach(function (k) {
    return model.set(k, rest[k]);
  });
  return model;
};

var getInitialState = function getInitialState(orm, surveyData) {
  var state = orm.getEmptyState();
  var session = orm.mutableSession(state);
  var Survey = session.Survey,
      DagGraph = session.DagGraph; // We need to initialize a survey in case none exists.

  if (surveyData) {
    normalizeSurvey(surveyData, session);
  } else {
    var survey = Survey.create({});
    var graph = DagGraph.create({
      survey: survey.id
    });
    survey.set("graph", graph.id);
  }

  return session.state;
};

var initialState$1 = function bootstrap(orm, surveyData) {
  var ormState = getInitialState(orm, surveyData);
  return {
    orm: {
      past: [],
      present: ormState,
      future: []
    },
    ui: initialState
  };
};

var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};

function safeName(patternOrChannel) {
  if (channel$1(patternOrChannel)) {
    return 'channel';
  }

  if (stringableFunc(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if (func(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}

function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect$$1,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect$$1 = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect$$1;
    }
  }

  return makeIterator(next, function (error) {
    return next(null, error);
  }, name);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork$1.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yFork(action)
      };
    }
  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork$1.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: cancel(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  check$3(patternOrChannel, notUndef, fn.name + " requires a pattern or channel");
  check$3(worker, notUndef, fn.name + " requires a saga parameter");
};

function takeEvery$1(patternOrChannel, worker) {
  if (process.env.NODE_ENV !== 'production') {
    validateTakeEffect(takeEvery$1, patternOrChannel, worker);
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return fork$1.apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
}

function takeLatest$1(patternOrChannel, worker) {
  if (process.env.NODE_ENV !== 'production') {
    validateTakeEffect(takeLatest$1, patternOrChannel, worker);
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return fork$1.apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
}

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(onAnswerImageUpload),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(onQuestionImageUpload),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(onQuestionCreated),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(questionCreatedSaga),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(onErrorSet),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(onSurveyChanged),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(autosaveSaga),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(onSave),
    _marked9 =
/*#__PURE__*/
_regeneratorRuntime.mark(onHashSet),
    _marked10 =
/*#__PURE__*/
_regeneratorRuntime.mark(hashSetSaga);

var presentSelector = function presentSelector(state) {
  return state.orm.present;
};

var surveySelector$1 = function surveySelector(state) {
  return state.orm.present.Survey.itemsById[0];
};

var uiSelector$1 = function uiSelector(state) {
  return state.ui;
}; // Answer image upload saga


function onAnswerImageUpload(action, uploadImage) {
  var _action$payload, id, file, _survey, hash, res, _ref, location;

  return _regeneratorRuntime.wrap(function onAnswerImageUpload$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, id = _action$payload.id, file = _action$payload.file;
          _context.prev = 1;
          _context.next = 4;
          return select(surveySelector$1);

        case 4:
          _survey = _context.sent;
          hash = _survey.hash;
          _context.next = 8;
          return uploadImage(file, hash);

        case 8:
          res = _context.sent;
          _context.next = 11;
          return res.json();

        case 11:
          _ref = _context.sent;
          location = _ref.location;
          _context.next = 15;
          return put(answerContentImageSuccess(id, file.name, location));

        case 15:
          _context.next = 21;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](1);
          _context.next = 21;
          return put(answerContentImageError(id, _context.t0));

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[1, 17]]);
}

function makeAnswerImageSaga(uploadImage) {
  return (
    /*#__PURE__*/
    _regeneratorRuntime.mark(function answerImageSaga() {
      return _regeneratorRuntime.wrap(function answerImageSaga$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return takeEvery$1(answerContentTypes.ANSWER_CONTENT_IMAGE_REQUEST, function (act) {
                return onAnswerImageUpload(act, uploadImage);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, answerImageSaga, this);
    })
  );
} // Question image upload saga


function onQuestionImageUpload(action, uploadImage) {
  var _action$payload2, id, file, presentState, hash, res, _ref2, location;

  return _regeneratorRuntime.wrap(function onQuestionImageUpload$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload2 = action.payload, id = _action$payload2.id, file = _action$payload2.file;
          _context3.prev = 1;
          _context3.next = 4;
          return select(presentSelector);

        case 4:
          presentState = _context3.sent;
          hash = presentState.Survey.itemsById[0].hash;
          _context3.next = 8;
          return uploadImage(file, hash);

        case 8:
          res = _context3.sent;
          _context3.next = 11;
          return res.json();

        case 11:
          _ref2 = _context3.sent;
          location = _ref2.location;
          _context3.next = 15;
          return put(questionImageSuccess(id, file.name, location));

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 21;
          return put(questionImageError(id, _context3.t0));

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2, this, [[1, 17]]);
}

function makeQuestionImageSaga(uploadImage) {
  return (
    /*#__PURE__*/
    _regeneratorRuntime.mark(function questionImageSaga() {
      return _regeneratorRuntime.wrap(function questionImageSaga$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return takeEvery$1(questionTypes.QUESTION_IMAGE_REQUEST, function (act) {
                return onQuestionImageUpload(act, uploadImage);
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, questionImageSaga, this);
    })
  );
} // Question creation saga


function onQuestionCreated(action) {
  var surveyHashRoute, presentState, questions, newQuestionId, nextPath;
  return _regeneratorRuntime.wrap(function onQuestionCreated$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          surveyHashRoute = action.payload.surveyHashRoute;
          _context5.next = 3;
          return select(presentSelector);

        case 3:
          presentState = _context5.sent;
          questions = presentState.Question.items;
          newQuestionId = questions[questions.length - 1];
          nextPath = window.__SURVEYTOOL_HISTORY__.location.pathname.replace("/build", "/question/" + newQuestionId);

          window.__SURVEYTOOL_HISTORY__.push(nextPath);

        case 8:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked3, this);
}

function questionCreatedSaga() {
  return _regeneratorRuntime.wrap(function questionCreatedSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeEvery$1([questionTypes.QUESTION_CREATE, pageTypes.PAGE_CREATE_WITH_NEW_QUESTION], onQuestionCreated);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked4, this);
} // Error logging saga


function onErrorSet(action, logError) {
  var doLog;
  return _regeneratorRuntime.wrap(function onErrorSet$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          doLog = logError || console.error;
          _context7.prev = 1;
          _context7.next = 4;
          return doLog(action.payload);

        case 4:
          _context7.next = 9;
          break;

        case 6:
          _context7.prev = 6;
          _context7.t0 = _context7["catch"](1);
          console.warn("Failed to log error: ", action.payload);

        case 9:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked5, this, [[1, 6]]);
}

function makeErrorSetSaga(logError) {
  return (
    /*#__PURE__*/
    _regeneratorRuntime.mark(function errorSetSaga() {
      return _regeneratorRuntime.wrap(function errorSetSaga$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return takeEvery$1(interfaceTypes.INTERFACE_SET_ERROR, function (action) {
                return onErrorSet(action, logError);
              });

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, errorSetSaga, this);
    })
  );
} // The autosave saga takes most actions and then
// dispatches an AUTOSAVE_REQUEST action afterward.


function onSurveyChanged() {
  var _ref3, readOnly;

  return _regeneratorRuntime.wrap(function onSurveyChanged$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return select(uiSelector$1);

        case 2:
          _ref3 = _context9.sent;
          readOnly = _ref3.readOnly;

          if (!readOnly) {
            _context9.next = 6;
            break;
          }

          return _context9.abrupt("return");

        case 6:
          _context9.next = 8;
          return delay(500);

        case 8:
          _context9.next = 10;
          return put(requestSave());

        case 10:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked6, this);
} // The autosave Saga should take every action that modifies the survey state,
// so we should exclude some actions that aren't related to modifying the survey.


var takePattern = function takePattern(_ref4) {
  var type = _ref4.type;
  return !excludedTypes.includes(type);
};

function autosaveSaga() {
  return _regeneratorRuntime.wrap(function autosaveSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return takeLatest$1(takePattern, onSurveyChanged);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked7, this);
}

var importDenormalizer = new Promise(function (resolve) {
  return Promise.resolve().then(function () {
    return denormalizeState$2;
  }).then(function (module) {
    return resolve(module);
  });
});

var awaitDenormalizer = function awaitDenormalizer() {
  return Promise.resolve(importDenormalizer);
}; // The save saga takes only AUTOSAVE_REQUEST actions,
// and executes the actual side-effect, the API request itself.


function onSave(doSave) {
  var presentState, survey, denormalizeState, denormalizedSurvey, hash, previewLink;
  return _regeneratorRuntime.wrap(function onSave$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return select(presentSelector);

        case 2:
          presentState = _context11.sent;
          _context11.next = 5;
          return select(surveySelector$1);

        case 5:
          survey = _context11.sent;
          _context11.next = 8;
          return call(awaitDenormalizer);

        case 8:
          denormalizeState = _context11.sent;
          denormalizedSurvey = denormalizeState.default(presentState);
          hash = survey.hash || "";
          previewLink = survey.previewLink || "";
          _context11.prev = 12;
          _context11.next = 15;
          return doSave(denormalizedSurvey).then(function (response) {
            return response.json();
          }).then(function (json) {
            hash = json.hash;
            previewLink = json.preview_link;
          });

        case 15:
          if (!hash) {
            _context11.next = 18;
            break;
          }

          _context11.next = 18;
          return put(setSurveyHash(hash));

        case 18:
          if (!previewLink) {
            _context11.next = 21;
            break;
          }

          _context11.next = 21;
          return put(setSurveyPreviewLink(previewLink));

        case 21:
          _context11.next = 23;
          return put(autosaveSuccess());

        case 23:
          _context11.next = 30;
          break;

        case 25:
          _context11.prev = 25;
          _context11.t0 = _context11["catch"](12);
          console.error(_context11.t0);
          _context11.next = 30;
          return put(autosaveError(_context11.t0));

        case 30:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked8, this, [[12, 25]]);
}

function makeSaveSaga(doSave) {
  return (
    /*#__PURE__*/
    _regeneratorRuntime.mark(function saveSaga() {
      return _regeneratorRuntime.wrap(function saveSaga$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return takeEvery$1(autosaveTypes.AUTOSAVE_REQUEST, function () {
                return onSave(doSave);
              });

            case 2:
            case "end":
              return _context12.stop();
          }
        }
      }, saveSaga, this);
    })
  );
}

function onHashSet(action) {
  var hash, nextPath;
  return _regeneratorRuntime.wrap(function onHashSet$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          hash = action.payload;
          nextPath = window.__SURVEYTOOL_HISTORY__.location.pathname.replace("/new/", "/" + hash + "/");

          window.__SURVEYTOOL_HISTORY__.push(nextPath);

        case 3:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked9, this);
}

function hashSetSaga() {
  return _regeneratorRuntime.wrap(function hashSetSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return takeEvery$1(surveyTypes.SURVEY_SET_HASH, onHashSet);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked10, this);
}

function makeRootSaga(params) {
  var uploadImage = params.uploadImage,
      onSave = params.onSave,
      logError = params.logError;
  var answerImageSaga = makeAnswerImageSaga(uploadImage);
  var questionImageSaga = makeQuestionImageSaga(uploadImage);
  var saveSaga = makeSaveSaga(onSave);
  var errorLoggingSaga = makeErrorSetSaga(logError);
  return (
    /*#__PURE__*/
    _regeneratorRuntime.mark(function rootSaga() {
      return _regeneratorRuntime.wrap(function rootSaga$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return all([// Factory-made sagas
              answerImageSaga(), questionImageSaga(), saveSaga(), errorLoggingSaga(), // Homegrown sagas
              questionCreatedSaga(), autosaveSaga(), hashSetSaga()]);

            case 2:
            case "end":
              return _context15.stop();
          }
        }
      }, rootSaga, this);
    })
  );
}

var sagaMiddleware = sagaMiddlewareFactory();
var errorMiddleware = reduxCatch(errorHandler);
var middleware = [sagaMiddleware, errorMiddleware, thunk];
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

var makeStore = function makeStore(surveyData, rootSagaParams) {
  var initialState = initialState$1(orm, surveyData);
  var store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware.apply(undefined, middleware)));
  var rootSaga = makeRootSaga(rootSagaParams);
  sagaMiddleware.run(rootSaga);
  return store;
};

var App = function (_React$Component) {
  inherits(App, _React$Component);

  function App(props) {
    classCallCheck(this, App);

    var _this = possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.makeSagaParams = function () {
      return {
        uploadImage: _this.props.uploadImage,
        onSave: _this.props.onSave
      };
    };

    _this.state = {
      store: null
    };
    return _this;
  }

  createClass(App, [{
    key: "componentDidMount",
    value: function () {
      var _ref = asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var surveyData, rootSagaParams, store;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                surveyData = this.props.initialSurvey || null;
                rootSagaParams = this.makeSagaParams();
                store = makeStore(surveyData, rootSagaParams);
                return _context.abrupt("return", this.setState({
                  store: store
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var store = this.state.store;
      var _props = this.props,
          baseRoute = _props.baseRoute,
          exitLink = _props.exitLink;
      if (store == null) return null;
      return React.createElement(BrowserRouter, {
        basename: baseRoute || "/surveytool/"
      }, React.createElement(Route, {
        path: "/:surveyHash"
      }, function (_ref2) {
        var match = _ref2.match,
            history = _ref2.history;
        var surveyHashRoute = match === null ? "new" : match.params.surveyHash;
        window.__SURVEYTOOL_HISTORY__ = history;
        return React.createElement(Provider, {
          store: store
        }, React.createElement(ActionHistoryContainer, null, React.createElement(ThemeProvider, {
          theme: defaultTheme
        }, React.createElement(AppLayout, {
          surveyHashRoute: surveyHashRoute,
          exitLink: exitLink
        }))));
      }));
    }
  }]);
  return App;
}(React.Component); // In production, we register a service worker to serve assets from local cache.


function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "body {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nhtml,\nbody,\ndiv#index_root__4PyOE {\n\theight: 100%;\n}\n";
styleInject(css);

var _global$2 = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core$2 = createCommonjsModule(function (module) {
  var core = module.exports = {
    version: '2.6.2'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});

var _core_1$2 = _core$2.version;

var _isObject$2 = function _isObject$2(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject$2 = function _anObject$2(it) {
  if (!_isObject$2(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails$2 = function _fails$2(exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
}; // Thank's IE8 for his funny defineProperty


var _descriptors$2 = !_fails$2(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

var document$5 = _global$2.document; // typeof document.createElement is 'object' in old IE

var is$4 = _isObject$2(document$5) && _isObject$2(document$5.createElement);

var _domCreate$2 = function _domCreate$2(it) {
  return is$4 ? document$5.createElement(it) : {};
};

var _ie8DomDefine$2 = !_descriptors$2 && !_fails$2(function () {
  return Object.defineProperty(_domCreate$2('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // 7.1.1 ToPrimitive(input [, PreferredType])
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string


var _toPrimitive$2 = function _toPrimitive$2(it, S) {
  if (!_isObject$2(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject$2(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject$2(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject$2(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP$8 = Object.defineProperty;
var f$f = _descriptors$2 ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject$2(O);

  P = _toPrimitive$2(P, true);

  _anObject$2(Attributes);

  if (_ie8DomDefine$2) try {
    return dP$8(O, P, Attributes);
  } catch (e) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var _objectDp$2 = {
  f: f$f
};

var _propertyDesc$2 = function _propertyDesc$2(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide$2 = _descriptors$2 ? function (object, key, value) {
  return _objectDp$2.f(object, key, _propertyDesc$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$i = {}.hasOwnProperty;

var _has$2 = function _has$2(it, key) {
  return hasOwnProperty$i.call(it, key);
};

var id$3 = 0;
var px$2 = Math.random();

var _uid$2 = function _uid$2(key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$3 + px$2).toString(36));
};

var _redefine$2 = createCommonjsModule(function (module) {
  var SRC = _uid$2('src');

  var TO_STRING = 'toString';
  var $toString = Function[TO_STRING];
  var TPL = ('' + $toString).split(TO_STRING);

  _core$2.inspectSource = function (it) {
    return $toString.call(it);
  };

  (module.exports = function (O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) _has$2(val, 'name') || _hide$2(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) _has$2(val, SRC) || _hide$2(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

    if (O === _global$2) {
      O[key] = val;
    } else if (!safe) {
      delete O[key];

      _hide$2(O, key, val);
    } else if (O[key]) {
      O[key] = val;
    } else {
      _hide$2(O, key, val);
    } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

  })(Function.prototype, TO_STRING, function toString() {
    return typeof this == 'function' && this[SRC] || $toString.call(this);
  });
});

var _aFunction$2 = function _aFunction$2(it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
}; // optional / simple context binding


var _ctx$2 = function _ctx$2(fn, that, length) {
  _aFunction$2(fn);

  if (that === undefined) return fn;

  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE$6 = 'prototype';

var $export$2 = function $export$2(type, name, source) {
  var IS_FORCED = type & $export$2.F;
  var IS_GLOBAL = type & $export$2.G;
  var IS_STATIC = type & $export$2.S;
  var IS_PROTO = type & $export$2.P;
  var IS_BIND = type & $export$2.B;
  var target = IS_GLOBAL ? _global$2 : IS_STATIC ? _global$2[name] || (_global$2[name] = {}) : (_global$2[name] || {})[PROTOTYPE$6];
  var exports = IS_GLOBAL ? _core$2 : _core$2[name] || (_core$2[name] = {});
  var expProto = exports[PROTOTYPE$6] || (exports[PROTOTYPE$6] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;

  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

    out = (own ? target : source)[key]; // bind timers to global for call from export context

    exp = IS_BIND && own ? _ctx$2(out, _global$2) : IS_PROTO && typeof out == 'function' ? _ctx$2(Function.call, out) : out; // extend global

    if (target) _redefine$2(target, key, out, type & $export$2.U); // export

    if (exports[key] != out) _hide$2(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};

_global$2.core = _core$2; // type bitmap

$export$2.F = 1; // forced

$export$2.G = 2; // global

$export$2.S = 4; // static

$export$2.P = 8; // proto

$export$2.B = 16; // bind

$export$2.W = 32; // wrap

$export$2.U = 64; // safe

$export$2.R = 128; // real proto method for `library`

var _export$2 = $export$2;
var toString$9 = {}.toString;

var _cof$2 = function _cof$2(it) {
  return toString$9.call(it).slice(8, -1);
}; // fallback for non-array-like ES3 and non-enumerable old V8 strings
// eslint-disable-next-line no-prototype-builtins


var _iobject$2 = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof$2(it) == 'String' ? it.split('') : Object(it);
}; // 7.2.1 RequireObjectCoercible(argument)


var _defined$2 = function _defined$2(it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
}; // to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject$2 = function _toIobject$2(it) {
  return _iobject$2(_defined$2(it));
}; // 7.1.4 ToInteger


var ceil$2 = Math.ceil;
var floor$5 = Math.floor;

var _toInteger$2 = function _toInteger$2(it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor$5 : ceil$2)(it);
}; // 7.1.15 ToLength


var min$5 = Math.min;

var _toLength$2 = function _toLength$2(it) {
  return it > 0 ? min$5(_toInteger$2(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max$3 = Math.max;
var min$6 = Math.min;

var _toAbsoluteIndex$2 = function _toAbsoluteIndex$2(index, length) {
  index = _toInteger$2(index);
  return index < 0 ? max$3(index + length, 0) : min$6(index, length);
}; // false -> Array#indexOf
// true  -> Array#includes


var _arrayIncludes$3 = function _arrayIncludes$3(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject$2($this);

    var length = _toLength$2(O.length);

    var index = _toAbsoluteIndex$2(fromIndex, length);

    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }
    return !IS_INCLUDES && -1;
  };
};

var _library$2 = false;

var _shared$2 = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global$2[SHARED] || (_global$2[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core$2.version,
    mode: _library$2 ? 'pure' : 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var _wks$2 = createCommonjsModule(function (module) {
  var store = _shared$2('wks');

  var Symbol = _global$2.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid$2)('Symbol.' + name));
  };

  $exports.store = store;
}); // 22.1.3.31 Array.prototype[@@unscopables]


var UNSCOPABLES$1 = _wks$2('unscopables');

var ArrayProto$3 = Array.prototype;
if (ArrayProto$3[UNSCOPABLES$1] == undefined) _hide$2(ArrayProto$3, UNSCOPABLES$1, {});

var _addToUnscopables$2 = function _addToUnscopables$2(key) {
  ArrayProto$3[UNSCOPABLES$1][key] = true;
}; // https://github.com/tc39/Array.prototype.includes


var $includes$1 = _arrayIncludes$3(true);

_export$2(_export$2.P, 'Array', {
  includes: function includes(el
  /* , fromIndex = 0 */
  ) {
    return $includes$1(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables$2('includes');

var includes$2 = _core$2.Array.includes; // 7.1.13 ToObject(argument)

var _toObject$2 = function _toObject$2(it) {
  return Object(_defined$2(it));
}; // 7.2.2 IsArray(argument)


var _isArray$2 = Array.isArray || function isArray(arg) {
  return _cof$2(arg) == 'Array';
};

var SPECIES$4 = _wks$2('species');

var _arraySpeciesConstructor$1 = function _arraySpeciesConstructor$1(original) {
  var C;

  if (_isArray$2(original)) {
    C = original.constructor; // cross-realm fallback

    if (typeof C == 'function' && (C === Array || _isArray$2(C.prototype))) C = undefined;

    if (_isObject$2(C)) {
      C = C[SPECIES$4];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? Array : C;
}; // 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate$1 = function _arraySpeciesCreate$1(original, length) {
  return new (_arraySpeciesConstructor$1(original))(length);
}; // 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex


var _arrayMethods$1 = function _arrayMethods$1(TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate$1;
  return function ($this, callbackfn, that) {
    var O = _toObject$2($this);

    var self = _iobject$2(O);

    var f = _ctx$2(callbackfn, that, 3);

    var length = _toLength$2(self.length);

    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;

    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);

        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true;
              // some

              case 5:
                return val;
              // find

              case 6:
                return index;
              // findIndex

              case 2:
                result.push(val);
              // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
}; // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)


var $find$2 = _arrayMethods$1(5);

var KEY$2 = 'find';
var forced$2 = true; // Shouldn't skip holes

if (KEY$2 in []) Array(1)[KEY$2](function () {
  forced$2 = false;
});

_export$2(_export$2.P + _export$2.F * forced$2, 'Array', {
  find: function find(callbackfn
  /* , that = undefined */
  ) {
    return $find$2(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables$2(KEY$2);

var find$1 = _core$2.Array.find;

if (!("IntersectionObserver" in window) || !("IntersectionObserverEntry" in window) || !("intersectionRatio" in window.IntersectionObserverEntry.prototype)) {
  Promise.resolve().then(function () {
    return intersectionObserver;
  });
}
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */


var union = _baseRest(function (arrays) {
  return _baseUniq(_baseFlatten(arrays, 1, isArrayLikeObject_1, true));
});

var union_1 = union;
var EnterLeaveCounter_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var EnterLeaveCounter =
  /** @class */
  function () {
    function EnterLeaveCounter(isNodeInDocument) {
      this.entered = [];
      this.isNodeInDocument = isNodeInDocument;
    }

    EnterLeaveCounter.prototype.enter = function (enteringNode) {
      var _this = this;

      var previousLength = this.entered.length;

      var isNodeEntered = function isNodeEntered(node) {
        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
      };

      this.entered = union_1(this.entered.filter(isNodeEntered), [enteringNode]);
      return previousLength === 0 && this.entered.length > 0;
    };

    EnterLeaveCounter.prototype.leave = function (leavingNode) {
      var previousLength = this.entered.length;
      this.entered = without_1(this.entered.filter(this.isNodeInDocument), leavingNode);
      return previousLength > 0 && this.entered.length === 0;
    };

    EnterLeaveCounter.prototype.reset = function () {
      this.entered = [];
    };

    return EnterLeaveCounter;
  }();

  exports.default = EnterLeaveCounter;
});
unwrapExports(EnterLeaveCounter_1);
var BrowserDetector = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isFirefox = memoize_1(function () {
    return /firefox/i.test(navigator.userAgent);
  });
  exports.isSafari = memoize_1(function () {
    return Boolean(window.safari);
  });
});
unwrapExports(BrowserDetector);
var BrowserDetector_1 = BrowserDetector.isFirefox;
var BrowserDetector_2 = BrowserDetector.isSafari;
var MonotonicInterpolant_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var MonotonicInterpolant =
  /** @class */
  function () {
    function MonotonicInterpolant(xs, ys) {
      var length = xs.length; // Rearrange xs and ys so that xs is sorted

      var indexes = [];

      for (var i = 0; i < length; i++) {
        indexes.push(i);
      }

      indexes.sort(function (a, b) {
        return xs[a] < xs[b] ? -1 : 1;
      });
      var dxs = [];
      var ms = [];
      var dx;
      var dy;

      for (var i = 0; i < length - 1; i++) {
        dx = xs[i + 1] - xs[i];
        dy = ys[i + 1] - ys[i];
        dxs.push(dx);
        ms.push(dy / dx);
      } // Get degree-1 coefficients


      var c1s = [ms[0]];

      for (var i = 0; i < dxs.length - 1; i++) {
        var m2 = ms[i];
        var mNext = ms[i + 1];

        if (m2 * mNext <= 0) {
          c1s.push(0);
        } else {
          dx = dxs[i];
          var dxNext = dxs[i + 1];
          var common = dx + dxNext;
          c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
        }
      }

      c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients

      var c2s = [];
      var c3s = [];
      var m;

      for (var i = 0; i < c1s.length - 1; i++) {
        m = ms[i];
        var c1 = c1s[i];
        var invDx = 1 / dxs[i];
        var common = c1 + c1s[i + 1] - m - m;
        c2s.push((m - c1 - common) * invDx);
        c3s.push(common * invDx * invDx);
      }

      this.xs = xs;
      this.ys = ys;
      this.c1s = c1s;
      this.c2s = c2s;
      this.c3s = c3s;
    }

    MonotonicInterpolant.prototype.interpolate = function (x) {
      var _a = this,
          xs = _a.xs,
          ys = _a.ys,
          c1s = _a.c1s,
          c2s = _a.c2s,
          c3s = _a.c3s; // The rightmost point in the dataset should give an exact result


      var i = xs.length - 1;

      if (x === xs[i]) {
        return ys[i];
      } // Search for the interval x is in, returning the corresponding y if x is one of the original xs


      var low = 0;
      var high = c3s.length - 1;
      var mid;

      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        var xHere = xs[mid];

        if (xHere < x) {
          low = mid + 1;
        } else if (xHere > x) {
          high = mid - 1;
        } else {
          return ys[mid];
        }
      }

      i = Math.max(0, high); // Interpolate

      var diff = x - xs[i];
      var diffSq = diff * diff;
      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    };

    return MonotonicInterpolant;
  }();

  exports.default = MonotonicInterpolant;
});
unwrapExports(MonotonicInterpolant_1);
var OffsetUtils = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ELEMENT_NODE = 1;

  function getNodeClientOffset(node) {
    var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

    if (!el) {
      return null;
    }

    var _a = el.getBoundingClientRect(),
        top = _a.top,
        left = _a.left;

    return {
      x: left,
      y: top
    };
  }

  exports.getNodeClientOffset = getNodeClientOffset;

  function getEventClientOffset(e) {
    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  exports.getEventClientOffset = getEventClientOffset;

  function isImageNode(node) {
    return node.nodeName === 'IMG' && (BrowserDetector.isFirefox() || !document.documentElement.contains(node));
  }

  function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers

    if (BrowserDetector.isSafari() && isImage) {
      dragPreviewHeight /= window.devicePixelRatio;
      dragPreviewWidth /= window.devicePixelRatio;
    }

    return {
      dragPreviewWidth: dragPreviewWidth,
      dragPreviewHeight: dragPreviewHeight
    };
  }

  function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    var offsetFromDragPreview = {
      x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
      y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    var sourceWidth = sourceNode.offsetWidth,
        sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX,
        anchorY = anchorPoint.anchorY;

    var _a = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
        dragPreviewWidth = _a.dragPreviewWidth,
        dragPreviewHeight = _a.dragPreviewHeight;

    var calculateYOffset = function calculateYOffset() {
      var interpolantY = new MonotonicInterpolant_1.default([0, 0.5, 1], [// Dock to the top
      offsetFromDragPreview.y, // Align at the center
      offsetFromDragPreview.y / sourceHeight * dragPreviewHeight, // Dock to the bottom
      offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
      var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug

      if (BrowserDetector.isSafari() && isImage) {
        // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
      }

      return y;
    };

    var calculateXOffset = function calculateXOffset() {
      // Interpolate coordinates depending on anchor point
      // If you know a simpler way to do this, let me know
      var interpolantX = new MonotonicInterpolant_1.default([0, 0.5, 1], [// Dock to the left
      offsetFromDragPreview.x, // Align at the center
      offsetFromDragPreview.x / sourceWidth * dragPreviewWidth, // Dock to the right
      offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
      return interpolantX.interpolate(anchorX);
    }; // Force offsets if specified in the options.


    var offsetX = offsetPoint.offsetX,
        offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
      x: isManualOffsetX ? offsetX : calculateXOffset(),
      y: isManualOffsetY ? offsetY : calculateYOffset()
    };
  }

  exports.getDragPreviewOffset = getDragPreviewOffset;
});
unwrapExports(OffsetUtils);
var OffsetUtils_1 = OffsetUtils.getNodeClientOffset;
var OffsetUtils_2 = OffsetUtils.getEventClientOffset;
var OffsetUtils_3 = OffsetUtils.getDragPreviewOffset;
var NativeTypes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FILE = '__NATIVE_FILE__';
  exports.URL = '__NATIVE_URL__';
  exports.TEXT = '__NATIVE_TEXT__';
});
unwrapExports(NativeTypes);
var NativeTypes_1 = NativeTypes.FILE;
var NativeTypes_2 = NativeTypes.URL;
var NativeTypes_3 = NativeTypes.TEXT;
var NativeDragSources = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _a;

  function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
      return resultSoFar || dataTransfer.getData(typeToTry);
    }, null);
    return result != null ? result : defaultValue;
  }

  var nativeTypesConfig = (_a = {}, _a[NativeTypes.FILE] = {
    exposeProperty: 'files',
    matchesTypes: ['Files'],
    getData: function getData(dataTransfer) {
      return Array.prototype.slice.call(dataTransfer.files);
    }
  }, _a[NativeTypes.URL] = {
    exposeProperty: 'urls',
    matchesTypes: ['Url', 'text/uri-list'],
    getData: function getData(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
    }
  }, _a[NativeTypes.TEXT] = {
    exposeProperty: 'text',
    matchesTypes: ['Text', 'text/plain'],
    getData: function getData(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    }
  }, _a);

  function createNativeDragSource(type) {
    var _a = nativeTypesConfig[type],
        exposeProperty = _a.exposeProperty,
        matchesTypes = _a.matchesTypes,
        getData = _a.getData;
    return (
      /** @class */
      function () {
        function NativeDragSource() {
          var _a;

          this.item = (_a = {}, Object.defineProperty(_a, exposeProperty, {
            get: function get() {
              // tslint:disable-next-line no-console
              console.warn("Browser doesn't allow reading \"" + exposeProperty + "\" until the drop event.");
              return null;
            },
            enumerable: true,
            configurable: true
          }), _a);
        }

        NativeDragSource.prototype.mutateItemByReadingDataTransfer = function (dataTransfer) {
          delete this.item[exposeProperty];
          this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
        };

        NativeDragSource.prototype.canDrag = function () {
          return true;
        };

        NativeDragSource.prototype.beginDrag = function () {
          return this.item;
        };

        NativeDragSource.prototype.isDragging = function (monitor, handle) {
          return handle === monitor.getSourceId();
        };

        NativeDragSource.prototype.endDrag = function () {// empty
        };

        return NativeDragSource;
      }()
    );
  }

  exports.createNativeDragSource = createNativeDragSource;

  function matchNativeItemType(dataTransfer) {
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
      var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
      return matchesTypes.some(function (t) {
        return dataTransferTypes.indexOf(t) > -1;
      });
    })[0] || null;
  }

  exports.matchNativeItemType = matchNativeItemType;
});
unwrapExports(NativeDragSources);
var NativeDragSources_1 = NativeDragSources.createNativeDragSource;
var NativeDragSources_2 = NativeDragSources.matchNativeItemType;
/** Used for built-in method references. */

var objectProto$f = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$j = objectProto$f.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */

var defaults$4 = _baseRest(function (object, sources) {
  object = Object(object);
  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn_1(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined || eq_1(value, objectProto$f[key]) && !hasOwnProperty$j.call(object, key)) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

var defaults_1$1 = defaults$4;
var HTML5Backend_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var HTML5Backend =
  /** @class */
  function () {
    function HTML5Backend(manager) {
      var _this = this;

      this.sourcePreviewNodes = new Map();
      this.sourcePreviewNodeOptions = new Map();
      this.sourceNodes = new Map();
      this.sourceNodeOptions = new Map();
      this.dragStartSourceIds = null;
      this.dropTargetIds = [];
      this.dragEnterTargetIds = [];
      this.currentNativeSource = null;
      this.currentNativeHandle = null;
      this.currentDragSourceNode = null;
      this.altKeyPressed = false;
      this.mouseMoveTimeoutTimer = null;
      this.asyncEndDragFrameId = null;
      this.dragOverTargetIds = null;

      this.getSourceClientOffset = function (sourceId) {
        return OffsetUtils.getNodeClientOffset(_this.sourceNodes.get(sourceId));
      };

      this.endDragNativeItem = function () {
        if (!_this.isDraggingNativeItem()) {
          return;
        }

        _this.actions.endDrag();

        _this.registry.removeSource(_this.currentNativeHandle);

        _this.currentNativeHandle = null;
        _this.currentNativeSource = null;
      };

      this.isNodeInDocument = function (node) {
        // Check the node either in the main document or in the current context
        return !!document && document.body.contains(node) || !!_this.window && _this.window.document.body.contains(node);
      };

      this.endDragIfSourceWasRemovedFromDOM = function () {
        var node = _this.currentDragSourceNode;

        if (_this.isNodeInDocument(node)) {
          return;
        }

        if (_this.clearCurrentDragSourceNode()) {
          _this.actions.endDrag();
        }
      };

      this.handleTopDragStartCapture = function () {
        _this.clearCurrentDragSourceNode();

        _this.dragStartSourceIds = [];
      };

      this.handleTopDragStart = function (e) {
        var dragStartSourceIds = _this.dragStartSourceIds;
        _this.dragStartSourceIds = null;
        var clientOffset = OffsetUtils.getEventClientOffset(e); // Avoid crashing if we missed a drop event or our previous drag died

        if (_this.monitor.isDragging()) {
          _this.actions.endDrag();
        } // Don't publish the source just yet (see why below)


        _this.actions.beginDrag(dragStartSourceIds || [], {
          publishSource: false,
          getSourceClientOffset: _this.getSourceClientOffset,
          clientOffset: clientOffset
        });

        var dataTransfer = e.dataTransfer;
        var nativeType = NativeDragSources.matchNativeItemType(dataTransfer);

        if (_this.monitor.isDragging()) {
          if (typeof dataTransfer.setDragImage === 'function') {
            // Use custom drag image if user specifies it.
            // If child drag source refuses drag but parent agrees,
            // use parent's node as drag image. Neither works in IE though.
            var sourceId = _this.monitor.getSourceId();

            var sourceNode = _this.sourceNodes.get(sourceId);

            var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;

            var _a = _this.getCurrentSourcePreviewNodeOptions(),
                anchorX = _a.anchorX,
                anchorY = _a.anchorY,
                offsetX = _a.offsetX,
                offsetY = _a.offsetY;

            var anchorPoint = {
              anchorX: anchorX,
              anchorY: anchorY
            };
            var offsetPoint = {
              offsetX: offsetX,
              offsetY: offsetY
            };
            var dragPreviewOffset = OffsetUtils.getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
            dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
          }

          try {
            // Firefox won't drag without setting data
            dataTransfer.setData('application/json', {});
          } catch (err) {} // IE doesn't support MIME types in setData
          // Store drag source node so we can check whether
          // it is removed from DOM and trigger endDrag manually.


          _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?


          var captureDraggingState = _this.getCurrentSourcePreviewNodeOptions().captureDraggingState;

          if (!captureDraggingState) {
            // Usually we want to publish it in the next tick so that browser
            // is able to screenshot the current (not yet dragging) state.
            //
            // It also neatly avoids a situation where render() returns null
            // in the same tick for the source element, and browser freaks out.
            setTimeout(function () {
              return _this.actions.publishDragSource();
            }, 0);
          } else {
            // In some cases the user may want to override this behavior, e.g.
            // to work around IE not supporting custom drag previews.
            //
            // When using a custom drag layer, the only way to prevent
            // the default drag preview from drawing in IE is to screenshot
            // the dragging state in which the node itself has zero opacity
            // and height. In this case, though, returning null from render()
            // will abruptly end the dragging, which is not obvious.
            //
            // This is the reason such behavior is strictly opt-in.
            _this.actions.publishDragSource();
          }
        } else if (nativeType) {
          // A native item (such as URL) dragged from inside the document
          _this.beginDragNativeItem(nativeType);
        } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
          // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
          // Just let it drag. It's a native type (URL or text) and will be picked up in
          // dragenter handler.
          return;
        } else {
          // If by this time no drag source reacted, tell browser not to drag.
          e.preventDefault();
        }
      };

      this.handleTopDragEndCapture = function () {
        if (_this.clearCurrentDragSourceNode()) {
          // Firefox can dispatch this event in an infinite loop
          // if dragend handler does something like showing an alert.
          // Only proceed if we have not handled it already.
          _this.actions.endDrag();
        }
      };

      this.handleTopDragEnterCapture = function (e) {
        _this.dragEnterTargetIds = [];

        var isFirstEnter = _this.enterLeaveCounter.enter(e.target);

        if (!isFirstEnter || _this.monitor.isDragging()) {
          return;
        }

        var dataTransfer = e.dataTransfer;
        var nativeType = NativeDragSources.matchNativeItemType(dataTransfer);

        if (nativeType) {
          // A native item (such as file or URL) dragged from outside the document
          _this.beginDragNativeItem(nativeType);
        }
      };

      this.handleTopDragEnter = function (e) {
        var dragEnterTargetIds = _this.dragEnterTargetIds;
        _this.dragEnterTargetIds = [];

        if (!_this.monitor.isDragging()) {
          // This is probably a native item type we don't understand.
          return;
        }

        _this.altKeyPressed = e.altKey;

        if (!BrowserDetector.isFirefox()) {
          // Don't emit hover in `dragenter` on Firefox due to an edge case.
          // If the target changes position as the result of `dragenter`, Firefox
          // will still happily dispatch `dragover` despite target being no longer
          // there. The easy solution is to only fire `hover` in `dragover` on FF.
          _this.actions.hover(dragEnterTargetIds, {
            clientOffset: OffsetUtils.getEventClientOffset(e)
          });
        }

        var canDrop = dragEnterTargetIds.some(function (targetId) {
          return _this.monitor.canDropOnTarget(targetId);
        });

        if (canDrop) {
          // IE requires this to fire dragover events
          e.preventDefault();
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      };

      this.handleTopDragOverCapture = function () {
        _this.dragOverTargetIds = [];
      };

      this.handleTopDragOver = function (e) {
        var dragOverTargetIds = _this.dragOverTargetIds;
        _this.dragOverTargetIds = [];

        if (!_this.monitor.isDragging()) {
          // This is probably a native item type we don't understand.
          // Prevent default "drop and blow away the whole document" action.
          e.preventDefault();
          e.dataTransfer.dropEffect = 'none';
          return;
        }

        _this.altKeyPressed = e.altKey;

        _this.actions.hover(dragOverTargetIds || [], {
          clientOffset: OffsetUtils.getEventClientOffset(e)
        });

        var canDrop = (dragOverTargetIds || []).some(function (targetId) {
          return _this.monitor.canDropOnTarget(targetId);
        });

        if (canDrop) {
          // Show user-specified drop effect.
          e.preventDefault();
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        } else if (_this.isDraggingNativeItem()) {
          // Don't show a nice cursor but still prevent default
          // "drop and blow away the whole document" action.
          e.preventDefault();
          e.dataTransfer.dropEffect = 'none';
        } else {
          e.preventDefault();
          e.dataTransfer.dropEffect = 'none';
        }
      };

      this.handleTopDragLeaveCapture = function (e) {
        if (_this.isDraggingNativeItem()) {
          e.preventDefault();
        }

        var isLastLeave = _this.enterLeaveCounter.leave(e.target);

        if (!isLastLeave) {
          return;
        }

        if (_this.isDraggingNativeItem()) {
          _this.endDragNativeItem();
        }
      };

      this.handleTopDropCapture = function (e) {
        _this.dropTargetIds = [];
        e.preventDefault();

        if (_this.isDraggingNativeItem()) {
          _this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
        }

        _this.enterLeaveCounter.reset();
      };

      this.handleTopDrop = function (e) {
        var dropTargetIds = _this.dropTargetIds;
        _this.dropTargetIds = [];

        _this.actions.hover(dropTargetIds, {
          clientOffset: OffsetUtils.getEventClientOffset(e)
        });

        _this.actions.drop({
          dropEffect: _this.getCurrentDropEffect()
        });

        if (_this.isDraggingNativeItem()) {
          _this.endDragNativeItem();
        } else {
          _this.endDragIfSourceWasRemovedFromDOM();
        }
      };

      this.handleSelectStart = function (e) {
        var target = e.target; // Only IE requires us to explicitly say
        // we want drag drop operation to start

        if (typeof target.dragDrop !== 'function') {
          return;
        } // Inputs and textareas should be selectable


        if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
          return;
        } // For other targets, ask IE
        // to enable drag and drop


        e.preventDefault();
        target.dragDrop();
      };

      this.actions = manager.getActions();
      this.monitor = manager.getMonitor();
      this.registry = manager.getRegistry();
      this.context = manager.getContext();
      this.enterLeaveCounter = new EnterLeaveCounter_1.default(this.isNodeInDocument);
    }

    Object.defineProperty(HTML5Backend.prototype, "window", {
      // public for test
      get: function get() {
        if (this.context && this.context.window) {
          return this.context.window;
        } else if (typeof window !== 'undefined') {
          return window;
        }

        return undefined;
      },
      enumerable: true,
      configurable: true
    });

    HTML5Backend.prototype.setup = function () {
      if (this.window === undefined) {
        return;
      }

      if (this.window.__isReactDndBackendSetUp) {
        throw new Error('Cannot have two HTML5 backends at the same time.');
      }

      this.window.__isReactDndBackendSetUp = true;
      this.addEventListeners(this.window);
    };

    HTML5Backend.prototype.teardown = function () {
      if (this.window === undefined) {
        return;
      }

      this.window.__isReactDndBackendSetUp = false;
      this.removeEventListeners(this.window);
      this.clearCurrentDragSourceNode();

      if (this.asyncEndDragFrameId) {
        this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    };

    HTML5Backend.prototype.connectDragPreview = function (sourceId, node, options) {
      var _this = this;

      this.sourcePreviewNodeOptions.set(sourceId, options);
      this.sourcePreviewNodes.set(sourceId, node);
      return function () {
        _this.sourcePreviewNodes.delete(sourceId);

        _this.sourcePreviewNodeOptions.delete(sourceId);
      };
    };

    HTML5Backend.prototype.connectDragSource = function (sourceId, node, options) {
      var _this = this;

      this.sourceNodes.set(sourceId, node);
      this.sourceNodeOptions.set(sourceId, options);

      var handleDragStart = function handleDragStart(e) {
        return _this.handleDragStart(e, sourceId);
      };

      var handleSelectStart = function handleSelectStart(e) {
        return _this.handleSelectStart(e);
      };

      node.setAttribute('draggable', true);
      node.addEventListener('dragstart', handleDragStart);
      node.addEventListener('selectstart', handleSelectStart);
      return function () {
        _this.sourceNodes.delete(sourceId);

        _this.sourceNodeOptions.delete(sourceId);

        node.removeEventListener('dragstart', handleDragStart);
        node.removeEventListener('selectstart', handleSelectStart);
        node.setAttribute('draggable', false);
      };
    };

    HTML5Backend.prototype.connectDropTarget = function (targetId, node) {
      var _this = this;

      var handleDragEnter = function handleDragEnter(e) {
        return _this.handleDragEnter(e, targetId);
      };

      var handleDragOver = function handleDragOver(e) {
        return _this.handleDragOver(e, targetId);
      };

      var handleDrop = function handleDrop(e) {
        return _this.handleDrop(e, targetId);
      };

      node.addEventListener('dragenter', handleDragEnter);
      node.addEventListener('dragover', handleDragOver);
      node.addEventListener('drop', handleDrop);
      return function () {
        node.removeEventListener('dragenter', handleDragEnter);
        node.removeEventListener('dragover', handleDragOver);
        node.removeEventListener('drop', handleDrop);
      };
    };

    HTML5Backend.prototype.addEventListeners = function (target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.addEventListener) {
        return;
      }

      target.addEventListener('dragstart', this.handleTopDragStart);
      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
      target.addEventListener('dragenter', this.handleTopDragEnter);
      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.addEventListener('dragover', this.handleTopDragOver);
      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
      target.addEventListener('drop', this.handleTopDrop);
      target.addEventListener('drop', this.handleTopDropCapture, true);
    };

    HTML5Backend.prototype.removeEventListeners = function (target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.removeEventListener) {
        return;
      }

      target.removeEventListener('dragstart', this.handleTopDragStart);
      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
      target.removeEventListener('dragenter', this.handleTopDragEnter);
      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.removeEventListener('dragover', this.handleTopDragOver);
      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
      target.removeEventListener('drop', this.handleTopDrop);
      target.removeEventListener('drop', this.handleTopDropCapture, true);
    };

    HTML5Backend.prototype.getCurrentSourceNodeOptions = function () {
      var sourceId = this.monitor.getSourceId();
      var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
      return defaults_1$1(sourceNodeOptions || {}, {
        dropEffect: this.altKeyPressed ? 'copy' : 'move'
      });
    };

    HTML5Backend.prototype.getCurrentDropEffect = function () {
      if (this.isDraggingNativeItem()) {
        // It makes more sense to default to 'copy' for native resources
        return 'copy';
      }

      return this.getCurrentSourceNodeOptions().dropEffect;
    };

    HTML5Backend.prototype.getCurrentSourcePreviewNodeOptions = function () {
      var sourceId = this.monitor.getSourceId();
      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
      return defaults_1$1(sourcePreviewNodeOptions || {}, {
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: false
      });
    };

    HTML5Backend.prototype.isDraggingNativeItem = function () {
      var itemType = this.monitor.getItemType();
      return Object.keys(NativeTypes).some(function (key) {
        return NativeTypes[key] === itemType;
      });
    };

    HTML5Backend.prototype.beginDragNativeItem = function (type) {
      this.clearCurrentDragSourceNode();
      var SourceType = NativeDragSources.createNativeDragSource(type);
      this.currentNativeSource = new SourceType();
      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
      this.actions.beginDrag([this.currentNativeHandle]);
    };

    HTML5Backend.prototype.setCurrentDragSourceNode = function (node) {
      var _this = this;

      this.clearCurrentDragSourceNode();
      this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869

      var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
      // means it has ended and the drag source node disappeared from DOM,
      // so the browser didn't dispatch the dragend event.
      //
      // We need to wait before we start listening for mousemove events.
      // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
      // immediately in some browsers.
      //
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869
      //

      this.mouseMoveTimeoutTimer = setTimeout(function () {
        return _this.window && _this.window.addEventListener('mousemove', _this.endDragIfSourceWasRemovedFromDOM, true);
      }, MOUSE_MOVE_TIMEOUT);
    };

    HTML5Backend.prototype.clearCurrentDragSourceNode = function () {
      if (this.currentDragSourceNode) {
        this.currentDragSourceNode = null;

        if (this.window) {
          this.window.clearTimeout(this.mouseMoveTimeoutTimer);
          this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }

        this.mouseMoveTimeoutTimer = null;
        return true;
      }

      return false;
    };

    HTML5Backend.prototype.handleDragStart = function (e, sourceId) {
      if (!this.dragStartSourceIds) {
        this.dragStartSourceIds = [];
      }

      this.dragStartSourceIds.unshift(sourceId);
    };

    HTML5Backend.prototype.handleDragEnter = function (e, targetId) {
      this.dragEnterTargetIds.unshift(targetId);
    };

    HTML5Backend.prototype.handleDragOver = function (e, targetId) {
      if (this.dragOverTargetIds === null) {
        this.dragOverTargetIds = [];
      }

      this.dragOverTargetIds.unshift(targetId);
    };

    HTML5Backend.prototype.handleDrop = function (e, targetId) {
      this.dropTargetIds.unshift(targetId);
    };

    return HTML5Backend;
  }();

  exports.default = HTML5Backend;
});
unwrapExports(HTML5Backend_1);
var getEmptyImage_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var emptyImage;

  function getEmptyImage() {
    if (!emptyImage) {
      emptyImage = new Image();
      emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }

    return emptyImage;
  }

  exports.default = getEmptyImage;
});
unwrapExports(getEmptyImage_1);
var lib$8 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getEmptyImage = getEmptyImage_1.default;
  exports.NativeTypes = NativeTypes;

  function createHTML5Backend(manager) {
    return new HTML5Backend_1.default(manager);
  }

  exports.default = createHTML5Backend;
});
var HTML5Backend$1 = unwrapExports(lib$8);
var lib_1$6 = lib$8.getEmptyImage;
var lib_2$5 = lib$8.NativeTypes;
var withDragDropContext = lib_1$5(HTML5Backend$1);
unregister();
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */

function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

var flatten_1 = flatten;

var denormalizeImage = function denormalizeImage(answer) {
  return {
    filename: answer.ref.imageFilename,
    url: answer.ref.imageUrl
  };
};

var denormalizeAnswerContent = function denormalizeAnswerContent(answer) {
  var _answer$ref = answer.ref,
      id = _answer$ref.id,
      content = _answer$ref.content,
      lastNonEmptyContent = _answer$ref.lastNonEmptyContent,
      sequence = _answer$ref.sequence,
      anchor = _answer$ref.anchor;
  var image = answer.ref.imageUrl ? denormalizeImage(answer) : undefined;
  var nonEmptyContent = content.trim() === "" ? lastNonEmptyContent : content;
  return {
    key: id.toString(),
    content: nonEmptyContent,
    sequence: sequence,
    anchor: anchor,
    image: image
  };
};

var denormalizeSpecialOption = function denormalizeSpecialOption(specialOption) {
  var _specialOption$ref = specialOption.ref,
      type = _specialOption$ref.type,
      text = _specialOption$ref.text,
      openAnswerRequired = _specialOption$ref.openAnswerRequired,
      openAnswerText = _specialOption$ref.openAnswerText;
  var base = {
    type: type,
    text: text
  };

  if (openAnswerRequired !== undefined && openAnswerText !== undefined) {
    return _extends$c({}, base, {
      open_answer: {
        require: openAnswerRequired,
        text: openAnswerText
      }
    });
  }

  return base;
};

var denormalizePipe = function denormalizePipe(pipe) {
  return {
    page: pipe.sourceQuestion.page.id.toString(),
    question: pipe.sourceQuestion.id.toString(),
    selected: pipe.ref.selected,
    placeholder: pipe.ref.placeholder
  };
}; // Abstract functions for attributes shared by various types


var denormalizeGrid = function denormalizeGrid(model, type) {
  return {
    type: type,
    sort_type: model.ref.sortType,
    require: model.ref.require,
    answer: {
      rows: model.rows.orderBy("sequence").toModelArray().map(function (r) {
        return denormalizeAnswerContent(r);
      }),
      columns: model.columns.orderBy("sequence").toModelArray().map(function (c) {
        return denormalizeAnswerContent(c);
      })
    }
  };
};

var denormalizeText = function denormalizeText(model, type) {
  return {
    type: type,
    require: model.ref.require,
    min: model.ref.min,
    max: model.ref.max
  };
};

var denormalizeDiscrete = function denormalizeDiscrete(model, type) {
  var result = {
    type: type,
    sort_type: model.ref.sortType,
    require: model.ref.require,
    answer: {
      rows: model.rows.orderBy("sequence").toModelArray().map(function (r) {
        return denormalizeAnswerContent(r);
      })
    }
  };

  if (model.specialOptions && model.specialOptions.toModelArray && typeof model.specialOptions.toModelArray === "function") {
    result.special_options = model.specialOptions.toModelArray().map(denormalizeSpecialOption);
  }

  return result;
}; // Denormalizers for types


var denormalizeSingleSelectGrid = function denormalizeSingleSelectGrid(typeModel) {
  return denormalizeGrid(typeModel, "single_select_matrix");
};

var denormalizeMultipleSelectGrid = function denormalizeMultipleSelectGrid(typeModel) {
  return denormalizeGrid(typeModel, "multiple_select_matrix");
};

var denormalizeSingleSelect = function denormalizeSingleSelect(typeModel) {
  return denormalizeDiscrete(typeModel, "single_select");
};

var denormalizeMultipleSelect = function denormalizeMultipleSelect(typeModel) {
  var _typeModel$ref = typeModel.ref,
      min = _typeModel$ref.min,
      max = _typeModel$ref.max;
  return _extends$c({}, denormalizeDiscrete(typeModel, "multiple_select"), {
    min: min,
    max: max
  });
};

var denormalizeDropdown = function denormalizeDropdown(typeModel) {
  return denormalizeDiscrete(typeModel, "dropdown");
};

var denormalizeShortText = function denormalizeShortText(typeModel) {
  return denormalizeText(typeModel, "short_text_input");
};

var denormalizeLongText = function denormalizeLongText(typeModel) {
  return denormalizeText(typeModel, "long_text_input");
};

var denormalizeMessage = function denormalizeMessage() {
  return {
    type: "descriptive"
  };
};

var denormalizeRating = function denormalizeRating(typeModel) {
  return {
    type: "rating",
    num_columns: parseInt(typeModel.ref.steps, 10),
    require: typeModel.ref.require
  };
};

var denormalizeMultipleRating = function denormalizeMultipleRating(typeModel) {
  return _extends$c({}, denormalizeDiscrete(typeModel, "multiple_rating"), {
    num_columns: parseInt(typeModel.ref.steps, 10)
  });
};

var denormalizeRanking = function denormalizeRanking(typeModel) {
  return denormalizeDiscrete(typeModel, "rank_order");
};

var denormalizeSlider = function denormalizeSlider(typeModel) {
  var _typeModel$ref2 = typeModel.ref,
      min = _typeModel$ref2.min,
      max = _typeModel$ref2.max,
      increment = _typeModel$ref2.increment,
      require = _typeModel$ref2.require;
  return {
    type: "slider",
    min: min,
    max: max,
    increment: increment,
    require: require
  };
};

var denormalizeMultipleSlider = function denormalizeMultipleSlider(typeModel) {
  var _typeModel$ref3 = typeModel.ref,
      min = _typeModel$ref3.min,
      max = _typeModel$ref3.max,
      increment = _typeModel$ref3.increment,
      require = _typeModel$ref3.require;
  var rows = denormalizeDiscrete(typeModel, "multiple_slider");
  return _extends$c({
    min: min,
    max: max,
    increment: increment,
    require: require
  }, rows);
};

var denormalizeNumeric = function denormalizeNumeric(typeModel) {
  var _typeModel$ref4 = typeModel.ref,
      min = _typeModel$ref4.min,
      max = _typeModel$ref4.max,
      require = _typeModel$ref4.require;
  return {
    type: "numeric",
    min: min,
    max: max,
    require: require
  };
};

var denormalizeSum = function denormalizeSum(typeModel) {
  var _typeModel$ref5 = typeModel.ref,
      validatesSum = _typeModel$ref5.validatesSum,
      targetSum = _typeModel$ref5.targetSum;
  var equals = validatesSum ? {
    equals: targetSum
  } : undefined;
  var rows = denormalizeDiscrete(typeModel, "sum");
  return _extends$c({}, equals, rows);
};

var denormalizeTypeModel = function denormalizeTypeModel(question) {
  if (question.singleSelectGrid) return denormalizeSingleSelectGrid(question.singleSelectGrid);
  if (question.multipleSelectGrid) return denormalizeMultipleSelectGrid(question.multipleSelectGrid);
  if (question.singleSelect) return denormalizeSingleSelect(question.singleSelect);
  if (question.multipleSelect) return denormalizeMultipleSelect(question.multipleSelect);
  if (question.dropdown) return denormalizeDropdown(question.dropdown);
  if (question.shortText) return denormalizeShortText(question.shortText);
  if (question.longText) return denormalizeLongText(question.longText);
  if (question.message) return denormalizeMessage();
  if (question.rating) return denormalizeRating(question.rating);
  if (question.multipleRating) return denormalizeMultipleRating(question.multipleRating);
  if (question.rankOrder) return denormalizeRanking(question.rankOrder);
  if (question.slider) return denormalizeSlider(question.slider);
  if (question.multipleSlider) return denormalizeMultipleSlider(question.multipleSlider);
  if (question.numeric) return denormalizeNumeric(question.numeric);
  if (question.sum) return denormalizeSum(question.sum);
  throw new Error("Missing type model in denormalizing question with id " + question.id);
};

var denormalizeQuestionMedia = function denormalizeQuestionMedia(question) {
  if (question.ref.mediaType === "image") {
    return {
      image: {
        filename: question.ref.imageFilename,
        url: question.ref.imageUrl
      }
    };
  }

  return {
    video: question.ref.videoUrl
  };
};

var denormalizeQuestion = function denormalizeQuestion(question) {
  var _question$ref = question.ref,
      id = _question$ref.id,
      content = _question$ref.content,
      lastNonEmptyContent = _question$ref.lastNonEmptyContent,
      sequence = _question$ref.sequence,
      hasDescription = _question$ref.hasDescription,
      hasMedia = _question$ref.hasMedia,
      anchor = _question$ref.anchor;
  var description = hasDescription ? {
    description: question.ref.description
  } : undefined;
  var media = hasMedia ? denormalizeQuestionMedia(question) : undefined;
  var pipe = question.providerPipe ? {
    pipe: denormalizePipe(question.providerPipe)
  } : undefined;
  var nonEmptyContent = content.trim() === "" ? lastNonEmptyContent : content;
  return _extends$c({
    key: id.toString(),
    content: nonEmptyContent,
    sequence: sequence
  }, description, pipe, {
    anchor: anchor,
    visibility: "visible",
    show_subsequent: true,
    media: media
  });
};

var denormalizeQuestionWithType = function denormalizeQuestionWithType(question) {
  var base = denormalizeQuestion(question);
  var typeData = denormalizeTypeModel(question);
  return _extends$c({}, base, typeData);
};

var denormalizeLogic = function denormalizeLogic(condition) {
  var question = condition.question,
      specialOptionValue = condition.specialOptionValue;
  var _condition$ref = condition.ref,
      operator = _condition$ref.operator,
      value = _condition$ref.value,
      sequence = _condition$ref.sequence,
      gate = _condition$ref.gate;
  var page = question.page;
  var base = {
    question: question.id.toString(),
    page: page.id.toString(),
    sequence: sequence,
    operator: operator,
    gate: gate
  };

  if (question.singleSelect || question.multipleSelect || question.dropdown) {
    if (specialOptionValue !== undefined) {
      var specialType = specialOptionValue.type;
      return _extends$c({}, base, {
        value: specialType
      });
    }

    return _extends$c({}, base, {
      value: value.toString()
    });
  }

  if (question.singleSelectGrid || question.multipleSelectGrid) {
    var gridValue = value;
    var rows = gridValue.rows,
        columns = gridValue.columns;
    var denormalizedValue = rows.reduce(function (pairings, row) {
      return [].concat(toConsumableArray(pairings), toConsumableArray(columns.map(function (c) {
        return row + ":" + c;
      })));
    }, []);
    return _extends$c({}, base, {
      value: denormalizedValue
    });
  }

  if (question.numeric || question.rating || question.slider) {
    if (operator === "range") {
      var rangeValue = value;
      return _extends$c({}, base, {
        value: rangeValue.min + ":" + rangeValue.max
      });
    }

    var numericValue = value;
    return _extends$c({}, base, {
      value: numericValue
    });
  }

  if (question.multipleRating || question.multipleSlider || question.rankOrder || question.sum) {
    var answer = condition.answer.toModelArray().map(function (a) {
      return a.id.toString();
    })[0];

    if (operator === "range") {
      var _rangeValue = value;
      return _extends$c({}, base, {
        answer: answer,
        value: _rangeValue.min + ":" + _rangeValue.max
      });
    }

    var _numericValue = value;
    return _extends$c({}, base, {
      answer: answer,
      value: _numericValue
    });
  }

  throw new Error("Missing type model in denormalizing logic condition with id " + condition.id);
};

var denormalizeLogicBranch = function denormalizeLogicBranch(b) {
  var conditions = b.conditions.orderBy("sequence").toModelArray();
  return {
    conditions: conditions.map(denormalizeLogic)
  };
};

var denormalizeSkipLogicBranch = function denormalizeSkipLogicBranch(b) {
  var target = b.specialTarget || b.target.id.toString();
  return _extends$c({}, denormalizeLogicBranch(b), {
    target: target
  });
};

var denormalizePage = function denormalizePage(page) {
  var displayLogic = [];

  if (page.displayLogicBranch) {
    displayLogic.push(denormalizeLogicBranch(page.displayLogicBranch));
  }

  var skipLogic = page.skipLogicBranches.orderBy("sequence").toModelArray().map(denormalizeSkipLogicBranch);
  return {
    key: page.id.toString(),
    logic: {
      skip: skipLogic,
      display: displayLogic
    },
    questions: page.questions.orderBy("sequence").toModelArray().map(function (q) {
      return denormalizeQuestionWithType(q);
    }),
    sequence: page.ref.sequence,
    sort_type: page.ref.sortType,
    content: page.ref.content,
    anchor: page.ref.anchor
  };
};

var getAnchorPages = function getAnchorPages(pages) {
  return pages.reduce(function (result, page) {
    if (!page.anchor) return result;
    return [].concat(toConsumableArray(result), [page.key]);
  }, []);
};

var denormalizeSection = function denormalizeSection(section, pages) {
  return {
    title: section.ref.content,
    key: section.id.toString(),
    start: pages[0].key,
    end: pages[pages.length - 1].key,
    sort_type: section.ref.sortType,
    anchor: getAnchorPages(pages)
  };
};

var denormalizeGroup = function denormalizeGroup(group, sections) {
  return {
    key: group.id.toString(),
    title: group.ref.content,
    sort_type: group.ref.sortType,
    color: group.ref.color,
    start: sections[0].key,
    end: sections[sections.length - 1].key
  };
};

var sortNodes = function sortNodes(nodes) {
  var models = nodes.toModelArray();
  var sortedNodes = [];
  var rootNode = models.find(function (n) {
    return n.incomingEdges.count() === 0;
  });
  var node = rootNode;

  while (node) {
    sortedNodes.push(node);
    var edge = node.defaultEdge;
    node = edge ? edge.headNode : null;
  }

  return sortedNodes;
};

var getGroupSections = function getGroupSections(group) {
  var graph = group.node.childGraph;
  var groupSections = graph.nodes.toModelArray().map(function (n) {
    return n.section;
  });
  return groupSections;
};

var getSectionPages = function getSectionPages(section) {
  var sectionGraph = section.node.childGraph;
  var nodes = sectionGraph.nodes.toModelArray();
  var pages = nodes.map(function (n) {
    return n.page;
  });
  var denormalizedPages = pages.map(denormalizePage);
  return denormalizedPages;
};

var denormalizeSurvey = function denormalizeSurvey(survey) {
  var nodes = sortNodes(survey.graph.nodes);
  var hash = survey.hash;
  var display = survey.title;
  var pages = [];
  var sections = [];
  var groups = [];
  nodes.forEach(function (node) {
    if (node.group) {
      var groupSections = getGroupSections(node.group);
      var denormalizedPages = groupSections.map(getSectionPages);
      var denormalizedSections = groupSections.map(function (section, index) {
        return denormalizeSection(section, denormalizedPages[index]);
      });
      pages = [].concat(toConsumableArray(pages), toConsumableArray(flatten_1(denormalizedPages)));
      sections = [].concat(toConsumableArray(sections), toConsumableArray(denormalizedSections));
      groups = [].concat(toConsumableArray(groups), [// $FlowFixMe
      denormalizeGroup(node.group, denormalizedSections)]);
      return;
    }

    if (node.section) {
      var _denormalizedPages = getSectionPages(node.section);

      pages = [].concat(toConsumableArray(pages), toConsumableArray(_denormalizedPages));
      sections = [].concat(toConsumableArray(sections), [// $FlowFixMe
      denormalizeSection(node.section, _denormalizedPages)]);
      return;
    }

    if (node.page) {
      pages = [].concat(toConsumableArray(pages), [denormalizePage(node.page)]);
      return;
    }
  });
  return {
    pages: pages,
    sections: sections,
    groups: groups,
    hash: hash,
    display: display
  };
};

var denormalizeState$1 = function denormalizeState(state) {
  var session = orm.session(state);
  var survey = session.Survey.first();
  return denormalizeSurvey(survey);
};

var denormalizeState$2 =
/*#__PURE__*/
Object.freeze({
  default: denormalizeState$1
});
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function (window, document) {
  // Exits early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }

    return;
  }
  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */


  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect; // Calculates the intersection ratio.

    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height; // Sets intersection ratio.

    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }
  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */


  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    } // Binds and throttles `this._checkForIntersections`.


    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT); // Private properties.

    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin); // Public properties.

    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
  }
  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */


  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */

  IntersectionObserver.prototype.POLL_INTERVAL = null;
  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */

  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */

  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();

    this._observationTargets.push({
      element: target,
      entry: null
    });

    this._monitorIntersections();

    this._checkForIntersections();
  };
  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });

    if (!this._observationTargets.length) {
      this._unmonitorIntersections();

      this._unregisterInstance();
    }
  };
  /**
   * Stops observing all target elements for intersection changes.
   */


  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];

    this._unmonitorIntersections();

    this._unregisterInstance();
  };
  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */


  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();

    this._queuedEntries = [];
    return records;
  };
  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */


  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }

      return t !== a[i - 1];
    });
  };
  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */


  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);

      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }

      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    }); // Handles shorthand.

    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };
  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @private
   */


  IntersectionObserver.prototype._monitorIntersections = function () {
    if (!this._monitoringIntersections) {
      this._monitoringIntersections = true; // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.

      if (this.POLL_INTERVAL) {
        this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
      } else {
        addEvent(window, 'resize', this._checkForIntersections, true);
        addEvent(document, 'scroll', this._checkForIntersections, true);

        if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
          this._domObserver = new MutationObserver(this._checkForIntersections);

          this._domObserver.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @private
   */


  IntersectionObserver.prototype._unmonitorIntersections = function () {
    if (this._monitoringIntersections) {
      this._monitoringIntersections = false;
      clearInterval(this._monitoringInterval);
      this._monitoringInterval = null;
      removeEvent(window, 'resize', this._checkForIntersections, true);
      removeEvent(document, 'scroll', this._checkForIntersections, true);

      if (this._domObserver) {
        this._domObserver.disconnect();

        this._domObserver = null;
      }
    }
  };
  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */


  IntersectionObserver.prototype._checkForIntersections = function () {
    var rootIsInDom = this._rootIsInDom();

    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);

      var rootContainsTarget = this._rootContainsTarget(target);

      var oldEntry = item.entry;

      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };
  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */


  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var targetRect = getBoundingClientRect(target);
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {}; // If the parent isn't displayed, an intersection can't happen.

      if (parentComputedStyle.display == 'none') return;

      if (parent == this.root || parent == document) {
        atRoot = true;
        parentRect = rootRect;
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      } // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.


      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
        if (!intersectionRect) break;
      }

      parent = getParentNode(parent);
    }

    return intersectionRect;
  };
  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {Object} The expanded root rect.
   * @private
   */


  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;

    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }

    return this._expandRectByRootMargin(rootRect);
  };
  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {Object} rect The rect object to expand.
   * @return {Object} The expanded rect.
   * @private
   */


  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });

    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };
  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */


  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1; // Ignore unchanged ratios

    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i]; // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.

      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };
  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */


  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };
  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */


  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target);
  };
  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */


  IntersectionObserver.prototype._registerInstance = function () {};
  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */


  IntersectionObserver.prototype._unregisterInstance = function () {};
  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */


  function now() {
    return window.performance && performance.now && performance.now();
  }
  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */


  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }
  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */


  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }
  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */


  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }
  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object} The intersection rect or undefined if no intersection
   *     is found.
   */


  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    };
  }
  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {Object} The (possibly shimmed) rect of the element.
   */


  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {// Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect(); // Older IE

    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }

    return rect;
  }
  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {Object} The empty rect.
   */


  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */


  function containsDeep(parent, child) {
    var node = child;

    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }

    return false;
  }
  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */


  function getParentNode(node) {
    var parent = node.parentNode;

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    return parent;
  } // Exposes the constructors globally.


  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})(window, document);

var intersectionObserver =
/*#__PURE__*/
Object.freeze({});
export default App;
export { withDragDropContext };